var _slicedToArray = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _defineProperty = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");
var _regeneratorRuntime = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/regenerator/index.js");
var _toConsumableArray = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _classCallCheck = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/circleci/project/packages/yi-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e72) { throw _e72; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e73) { didErr = true; err = _e73; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.promise.finally.js");
require("core-js/modules/es.regexp.flags.js");
require("core-js/modules/esnext.string.replace-all.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/esnext.global-this.js");
/*! For license information please see NpawPlugin.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.NpawPlugin = e() : t.NpawPlugin = e();
}(self, function () {
  return function () {
    var t = {
        525: function _(t, e) {
          "use strict";

          function i(t, e) {
            return void 0 === e && (e = Object), e && "function" == typeof e.freeze ? e.freeze(t) : t;
          }
          var s = i({
              HTML: "text/html",
              isHTML: function isHTML(t) {
                return t === s.HTML;
              },
              XML_APPLICATION: "application/xml",
              XML_TEXT: "text/xml",
              XML_XHTML_APPLICATION: "application/xhtml+xml",
              XML_SVG_IMAGE: "image/svg+xml"
            }),
            n = i({
              HTML: "http://www.w3.org/1999/xhtml",
              isHTML: function isHTML(t) {
                return t === n.HTML;
              },
              SVG: "http://www.w3.org/2000/svg",
              XML: "http://www.w3.org/XML/1998/namespace",
              XMLNS: "http://www.w3.org/2000/xmlns/"
            });
          e.find = function (t, e, i) {
            if (void 0 === i && (i = Array.prototype), t && "function" == typeof i.find) return i.find.call(t, e);
            for (var s = 0; s < t.length; s++) if (Object.prototype.hasOwnProperty.call(t, s)) {
              var n = t[s];
              if (e.call(void 0, n, s, t)) return n;
            }
          }, e.freeze = i, e.MIME_TYPE = s, e.NAMESPACE = n;
        },
        8633: function _(t, e, i) {
          var s = i(525),
            n = i(1129),
            r = i(6598),
            a = i(2133),
            o = n.DOMImplementation,
            d = s.NAMESPACE,
            c = a.ParseError,
            u = a.XMLReader;
          function l(t) {
            this.options = t || {
              locator: {}
            };
          }
          function h() {
            this.cdata = !1;
          }
          function p(t, e) {
            e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber;
          }
          function f(t) {
            if (t) return "\n@" + (t.systemId || "") + "#[line:" + t.lineNumber + ",col:" + t.columnNumber + "]";
          }
          function g(t, e, i) {
            return "string" == typeof t ? t.substr(e, i) : t.length >= e + i || e ? new java.lang.String(t, e, i) + "" : t;
          }
          function m(t, e) {
            t.currentElement ? t.currentElement.appendChild(e) : t.doc.appendChild(e);
          }
          l.prototype.parseFromString = function (t, e) {
            var i = this.options,
              s = new u(),
              n = i.domBuilder || new h(),
              a = i.errorHandler,
              o = i.locator,
              c = i.xmlns || {},
              l = /\/x?html?$/.test(e),
              p = l ? r.HTML_ENTITIES : r.XML_ENTITIES;
            return o && n.setDocumentLocator(o), s.errorHandler = function (t, e, i) {
              if (!t) {
                if (e instanceof h) return e;
                t = e;
              }
              var s = {},
                n = t instanceof Function;
              function r(e) {
                var r = t[e];
                !r && n && (r = 2 == t.length ? function (i) {
                  t(e, i);
                } : t), s[e] = r && function (t) {
                  r("[xmldom " + e + "]\t" + t + f(i));
                } || function () {};
              }
              return i = i || {}, r("warning"), r("error"), r("fatalError"), s;
            }(a, n, o), s.domBuilder = i.domBuilder || n, l && (c[""] = d.HTML), c.xml = c.xml || d.XML, t && "string" == typeof t ? s.parse(t, c, p) : s.errorHandler.error("invalid doc source"), n.doc;
          }, h.prototype = {
            startDocument: function startDocument() {
              this.doc = new o().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
            },
            startElement: function startElement(t, e, i, s) {
              var n = this.doc,
                r = n.createElementNS(t, i || e),
                a = s.length;
              m(this, r), this.currentElement = r, this.locator && p(this.locator, r);
              for (var o = 0; o < a; o++) {
                t = s.getURI(o);
                var d = s.getValue(o),
                  c = (i = s.getQName(o), n.createAttributeNS(t, i));
                this.locator && p(s.getLocator(o), c), c.value = c.nodeValue = d, r.setAttributeNode(c);
              }
            },
            endElement: function endElement(t, e, i) {
              var s = this.currentElement;
              s.tagName, this.currentElement = s.parentNode;
            },
            startPrefixMapping: function startPrefixMapping(t, e) {},
            endPrefixMapping: function endPrefixMapping(t) {},
            processingInstruction: function processingInstruction(t, e) {
              var i = this.doc.createProcessingInstruction(t, e);
              this.locator && p(this.locator, i), m(this, i);
            },
            ignorableWhitespace: function ignorableWhitespace(t, e, i) {},
            characters: function characters(t, e, i) {
              if (t = g.apply(this, arguments)) {
                if (this.cdata) var s = this.doc.createCDATASection(t);else s = this.doc.createTextNode(t);
                this.currentElement ? this.currentElement.appendChild(s) : /^\s*$/.test(t) && this.doc.appendChild(s), this.locator && p(this.locator, s);
              }
            },
            skippedEntity: function skippedEntity(t) {},
            endDocument: function endDocument() {
              this.doc.normalize();
            },
            setDocumentLocator: function setDocumentLocator(t) {
              (this.locator = t) && (t.lineNumber = 0);
            },
            comment: function comment(t, e, i) {
              t = g.apply(this, arguments);
              var s = this.doc.createComment(t);
              this.locator && p(this.locator, s), m(this, s);
            },
            startCDATA: function startCDATA() {
              this.cdata = !0;
            },
            endCDATA: function endCDATA() {
              this.cdata = !1;
            },
            startDTD: function startDTD(t, e, i) {
              var s = this.doc.implementation;
              if (s && s.createDocumentType) {
                var n = s.createDocumentType(t, e, i);
                this.locator && p(this.locator, n), m(this, n), this.doc.doctype = n;
              }
            },
            warning: function warning(t) {
              console.warn("[xmldom warning]\t" + t, f(this.locator));
            },
            error: function error(t) {
              console.error("[xmldom error]\t" + t, f(this.locator));
            },
            fatalError: function fatalError(t) {
              throw new c(t, this.locator);
            }
          }, "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (t) {
            h.prototype[t] = function () {
              return null;
            };
          }), e.DOMParser = l, n.DOMImplementation, n.XMLSerializer;
        },
        1129: function _(t, e, i) {
          var s = i(525),
            n = s.find,
            r = s.NAMESPACE;
          function a(t) {
            return "" !== t;
          }
          function o(t, e) {
            return t.hasOwnProperty(e) || (t[e] = !0), t;
          }
          function d(t) {
            if (!t) return [];
            var e = function (t) {
              return t ? t.split(/[\t\n\f\r ]+/).filter(a) : [];
            }(t);
            return Object.keys(e.reduce(o, {}));
          }
          function c(t, e) {
            for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
          function u(t, e) {
            var i = t.prototype;
            if (!(i instanceof e)) {
              var _s = function _s() {};
              _s.prototype = e.prototype, c(i, _s = new _s()), t.prototype = i = _s;
            }
            i.constructor != t && ("function" != typeof t && console.error("unknown Class:" + t), i.constructor = t);
          }
          var l = {},
            h = l.ELEMENT_NODE = 1,
            p = l.ATTRIBUTE_NODE = 2,
            f = l.TEXT_NODE = 3,
            g = l.CDATA_SECTION_NODE = 4,
            m = l.ENTITY_REFERENCE_NODE = 5,
            v = l.ENTITY_NODE = 6,
            y = l.PROCESSING_INSTRUCTION_NODE = 7,
            T = l.COMMENT_NODE = 8,
            S = l.DOCUMENT_NODE = 9,
            E = l.DOCUMENT_TYPE_NODE = 10,
            b = l.DOCUMENT_FRAGMENT_NODE = 11,
            A = l.NOTATION_NODE = 12,
            w = {},
            _ = {},
            I = (w.INDEX_SIZE_ERR = (_[1] = "Index size error", 1), w.DOMSTRING_SIZE_ERR = (_[2] = "DOMString size error", 2), w.HIERARCHY_REQUEST_ERR = (_[3] = "Hierarchy request error", 3)),
            N = (w.WRONG_DOCUMENT_ERR = (_[4] = "Wrong document", 4), w.INVALID_CHARACTER_ERR = (_[5] = "Invalid character", 5), w.NO_DATA_ALLOWED_ERR = (_[6] = "No data allowed", 6), w.NO_MODIFICATION_ALLOWED_ERR = (_[7] = "No modification allowed", 7), w.NOT_FOUND_ERR = (_[8] = "Not found", 8)),
            P = (w.NOT_SUPPORTED_ERR = (_[9] = "Not supported", 9), w.INUSE_ATTRIBUTE_ERR = (_[10] = "Attribute in use", 10));
          function D(t, e) {
            if (e instanceof Error) var i = e;else i = this, Error.call(this, _[t]), this.message = _[t], Error.captureStackTrace && Error.captureStackTrace(this, D);
            return i.code = t, e && (this.message = this.message + ": " + e), i;
          }
          function R() {}
          function L(t, e) {
            this._node = t, this._refresh = e, C(this);
          }
          function C(t) {
            var e = t._node._inc || t._node.ownerDocument._inc;
            if (t._inc !== e) {
              var i = t._refresh(t._node);
              if (yt(t, "length", i.length), !t.$$length || i.length < t.$$length) for (var s = i.length; (s in t); s++) Object.prototype.hasOwnProperty.call(t, s) && delete t[s];
              c(i, t), t._inc = e;
            }
          }
          function O() {}
          function B(t, e) {
            for (var i = t.length; i--;) if (t[i] === e) return i;
          }
          function x(t, e, i, s) {
            if (s ? e[B(e, s)] = i : e[e.length++] = i, t) {
              i.ownerElement = t;
              var n = t.ownerDocument;
              n && (s && X(n, t, s), function (t, e, i) {
                t && t._inc++, i.namespaceURI === r.XMLNS && (e._nsMap[i.prefix ? i.localName : ""] = i.value);
              }(n, t, i));
            }
          }
          function M(t, e, i) {
            var s = B(e, i);
            if (!(s >= 0)) throw new D(N, new Error(t.tagName + "@" + i));
            for (var n = e.length - 1; s < n;) e[s] = e[++s];
            if (e.length = n, t) {
              var r = t.ownerDocument;
              r && (X(r, t, i), i.ownerElement = null);
            }
          }
          function k() {}
          function U() {}
          function V(t) {
            return ("<" == t ? "&lt;" : ">" == t && "&gt;") || "&" == t && "&amp;" || '"' == t && "&quot;" || "&#" + t.charCodeAt() + ";";
          }
          function q(t, e) {
            if (e(t)) return !0;
            if (t = t.firstChild) do {
              if (q(t, e)) return !0;
            } while (t = t.nextSibling);
          }
          function F() {
            this.ownerDocument = this;
          }
          function X(t, e, i, s) {
            t && t._inc++, i.namespaceURI === r.XMLNS && delete e._nsMap[i.prefix ? i.localName : ""];
          }
          function H(t, e, i) {
            if (t && t._inc) {
              t._inc++;
              var s = e.childNodes;
              if (i) s[s.length++] = i;else {
                for (var n = e.firstChild, r = 0; n;) s[r++] = n, n = n.nextSibling;
                s.length = r, delete s[s.length];
              }
            }
          }
          function G(t, e) {
            var i = e.previousSibling,
              s = e.nextSibling;
            return i ? i.nextSibling = s : t.firstChild = s, s ? s.previousSibling = i : t.lastChild = i, e.parentNode = null, e.previousSibling = null, e.nextSibling = null, H(t.ownerDocument, t), e;
          }
          function j(t) {
            return t && t.nodeType === U.DOCUMENT_TYPE_NODE;
          }
          function W(t) {
            return t && t.nodeType === U.ELEMENT_NODE;
          }
          function Y(t) {
            return t && t.nodeType === U.TEXT_NODE;
          }
          function z(t, e) {
            var i = t.childNodes || [];
            if (n(i, W) || j(e)) return !1;
            var s = n(i, j);
            return !(e && s && i.indexOf(s) > i.indexOf(e));
          }
          function K(t, e) {
            var i = t.childNodes || [];
            if (n(i, function (t) {
              return W(t) && t !== e;
            })) return !1;
            var s = n(i, j);
            return !(e && s && i.indexOf(s) > i.indexOf(e));
          }
          function Q(t, e, i) {
            var s = t.childNodes || [],
              r = e.childNodes || [];
            if (e.nodeType === U.DOCUMENT_FRAGMENT_NODE) {
              var a = r.filter(W);
              if (a.length > 1 || n(r, Y)) throw new D(I, "More than one element or text in fragment");
              if (1 === a.length && !z(t, i)) throw new D(I, "Element in fragment can not be inserted before doctype");
            }
            if (W(e) && !z(t, i)) throw new D(I, "Only one element can be added and only after doctype");
            if (j(e)) {
              if (n(s, j)) throw new D(I, "Only one doctype is allowed");
              var o = n(s, W);
              if (i && s.indexOf(o) < s.indexOf(i)) throw new D(I, "Doctype can only be inserted before an element");
              if (!i && o) throw new D(I, "Doctype can not be appended since element is present");
            }
          }
          function J(t, e, i) {
            var s = t.childNodes || [],
              r = e.childNodes || [];
            if (e.nodeType === U.DOCUMENT_FRAGMENT_NODE) {
              var a = r.filter(W);
              if (a.length > 1 || n(r, Y)) throw new D(I, "More than one element or text in fragment");
              if (1 === a.length && !K(t, i)) throw new D(I, "Element in fragment can not be inserted before doctype");
            }
            if (W(e) && !K(t, i)) throw new D(I, "Only one element can be added and only after doctype");
            if (j(e)) {
              if (n(s, function (t) {
                return j(t) && t !== i;
              })) throw new D(I, "Only one doctype is allowed");
              var o = n(s, W);
              if (i && s.indexOf(o) < s.indexOf(i)) throw new D(I, "Doctype can only be inserted before an element");
            }
          }
          function $(t, e, i, s) {
            (function (t, e, i) {
              if (!function (t) {
                return t && (t.nodeType === U.DOCUMENT_NODE || t.nodeType === U.DOCUMENT_FRAGMENT_NODE || t.nodeType === U.ELEMENT_NODE);
              }(t)) throw new D(I, "Unexpected parent node type " + t.nodeType);
              if (i && i.parentNode !== t) throw new D(N, "child not in parent");
              if (!function (t) {
                return t && (W(t) || Y(t) || j(t) || t.nodeType === U.DOCUMENT_FRAGMENT_NODE || t.nodeType === U.COMMENT_NODE || t.nodeType === U.PROCESSING_INSTRUCTION_NODE);
              }(e) || j(e) && t.nodeType !== U.DOCUMENT_NODE) throw new D(I, "Unexpected node type " + e.nodeType + " for parent node type " + t.nodeType);
            })(t, e, i), t.nodeType === U.DOCUMENT_NODE && (s || Q)(t, e, i);
            var n = e.parentNode;
            if (n && n.removeChild(e), e.nodeType === b) {
              var r = e.firstChild;
              if (null == r) return e;
              var a = e.lastChild;
            } else r = a = e;
            var o = i ? i.previousSibling : t.lastChild;
            r.previousSibling = o, a.nextSibling = i, o ? o.nextSibling = r : t.firstChild = r, null == i ? t.lastChild = a : i.previousSibling = a;
            do {
              r.parentNode = t;
            } while (r !== a && (r = r.nextSibling));
            return H(t.ownerDocument || t, t), e.nodeType == b && (e.firstChild = e.lastChild = null), e;
          }
          function Z() {
            this._nsMap = {};
          }
          function tt() {}
          function et() {}
          function it() {}
          function st() {}
          function nt() {}
          function rt() {}
          function at() {}
          function ot() {}
          function dt() {}
          function ct() {}
          function ut() {}
          function lt() {}
          function ht(t, e) {
            var i = [],
              s = 9 == this.nodeType && this.documentElement || this,
              n = s.prefix,
              r = s.namespaceURI;
            if (r && null == n && null == (n = s.lookupPrefix(r))) var a = [{
              namespace: r,
              prefix: null
            }];
            return gt(this, i, t, e, a), i.join("");
          }
          function pt(t, e, i) {
            var s = t.prefix || "",
              n = t.namespaceURI;
            if (!n) return !1;
            if ("xml" === s && n === r.XML || n === r.XMLNS) return !1;
            for (var a = i.length; a--;) {
              var o = i[a];
              if (o.prefix === s) return o.namespace !== n;
            }
            return !0;
          }
          function ft(t, e, i) {
            t.push(" ", e, '="', i.replace(/[<&"]/g, V), '"');
          }
          function gt(t, e, i, s, n) {
            if (n || (n = []), s) {
              if (!(t = s(t))) return;
              if ("string" == typeof t) return void e.push(t);
            }
            switch (t.nodeType) {
              case h:
                var a = t.attributes,
                  o = a.length,
                  d = t.firstChild,
                  c = t.tagName,
                  u = c;
                if (!(i = r.isHTML(t.namespaceURI) || i) && !t.prefix && t.namespaceURI) {
                  for (var l, v = 0; v < a.length; v++) if ("xmlns" === a.item(v).name) {
                    l = a.item(v).value;
                    break;
                  }
                  if (!l) for (var A = n.length - 1; A >= 0; A--) if ("" === (w = n[A]).prefix && w.namespace === t.namespaceURI) {
                    l = w.namespace;
                    break;
                  }
                  if (l !== t.namespaceURI) for (A = n.length - 1; A >= 0; A--) {
                    var w;
                    if ((w = n[A]).namespace === t.namespaceURI) {
                      w.prefix && (u = w.prefix + ":" + c);
                      break;
                    }
                  }
                }
                e.push("<", u);
                for (var _ = 0; _ < o; _++) "xmlns" == (I = a.item(_)).prefix ? n.push({
                  prefix: I.localName,
                  namespace: I.value
                }) : "xmlns" == I.nodeName && n.push({
                  prefix: "",
                  namespace: I.value
                });
                for (_ = 0; _ < o; _++) {
                  var I, N, P;
                  pt(I = a.item(_), 0, n) && (ft(e, (N = I.prefix || "") ? "xmlns:" + N : "xmlns", P = I.namespaceURI), n.push({
                    prefix: N,
                    namespace: P
                  })), gt(I, e, i, s, n);
                }
                if (c === u && pt(t, 0, n) && (ft(e, (N = t.prefix || "") ? "xmlns:" + N : "xmlns", P = t.namespaceURI), n.push({
                  prefix: N,
                  namespace: P
                })), d || i && !/^(?:meta|link|img|br|hr|input)$/i.test(c)) {
                  if (e.push(">"), i && /^script$/i.test(c)) for (; d;) d.data ? e.push(d.data) : gt(d, e, i, s, n.slice()), d = d.nextSibling;else for (; d;) gt(d, e, i, s, n.slice()), d = d.nextSibling;
                  e.push("</", u, ">");
                } else e.push("/>");
                return;
              case S:
              case b:
                for (d = t.firstChild; d;) gt(d, e, i, s, n.slice()), d = d.nextSibling;
                return;
              case p:
                return ft(e, t.name, t.value);
              case f:
                return e.push(t.data.replace(/[<&]/g, V).replace(/]]>/g, "]]&gt;"));
              case g:
                return e.push("<![CDATA[", t.data, "]]>");
              case T:
                return e.push("\x3c!--", t.data, "--\x3e");
              case E:
                var D = t.publicId,
                  R = t.systemId;
                if (e.push("<!DOCTYPE ", t.name), D) e.push(" PUBLIC ", D), R && "." != R && e.push(" ", R), e.push(">");else if (R && "." != R) e.push(" SYSTEM ", R, ">");else {
                  var L = t.internalSubset;
                  L && e.push(" [", L, "]"), e.push(">");
                }
                return;
              case y:
                return e.push("<?", t.target, " ", t.data, "?>");
              case m:
                return e.push("&", t.nodeName, ";");
              default:
                e.push("??", t.nodeName);
            }
          }
          function mt(t, e, i) {
            var s;
            switch (e.nodeType) {
              case h:
                (s = e.cloneNode(!1)).ownerDocument = t;
              case b:
                break;
              case p:
                i = !0;
            }
            if (s || (s = e.cloneNode(!1)), s.ownerDocument = t, s.parentNode = null, i) for (var n = e.firstChild; n;) s.appendChild(mt(t, n, i)), n = n.nextSibling;
            return s;
          }
          function vt(t, e, i) {
            var s = new e.constructor();
            for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
              var r = e[n];
              "object" != typeof r && r != s[n] && (s[n] = r);
            }
            switch (e.childNodes && (s.childNodes = new R()), s.ownerDocument = t, s.nodeType) {
              case h:
                var a = e.attributes,
                  o = s.attributes = new O(),
                  d = a.length;
                o._ownerElement = s;
                for (var c = 0; c < d; c++) s.setAttributeNode(vt(t, a.item(c), !0));
                break;
              case p:
                i = !0;
            }
            if (i) for (var u = e.firstChild; u;) s.appendChild(vt(t, u, i)), u = u.nextSibling;
            return s;
          }
          function yt(t, e, i) {
            t[e] = i;
          }
          w.INVALID_STATE_ERR = (_[11] = "Invalid state", 11), w.SYNTAX_ERR = (_[12] = "Syntax error", 12), w.INVALID_MODIFICATION_ERR = (_[13] = "Invalid modification", 13), w.NAMESPACE_ERR = (_[14] = "Invalid namespace", 14), w.INVALID_ACCESS_ERR = (_[15] = "Invalid access", 15), D.prototype = Error.prototype, c(w, D), R.prototype = {
            length: 0,
            item: function item(t) {
              return t >= 0 && t < this.length ? this[t] : null;
            },
            toString: function toString(t, e) {
              for (var i = [], s = 0; s < this.length; s++) gt(this[s], i, t, e);
              return i.join("");
            },
            filter: function filter(t) {
              return Array.prototype.filter.call(this, t);
            },
            indexOf: function indexOf(t) {
              return Array.prototype.indexOf.call(this, t);
            }
          }, L.prototype.item = function (t) {
            return C(this), this[t] || null;
          }, u(L, R), O.prototype = {
            length: 0,
            item: R.prototype.item,
            getNamedItem: function getNamedItem(t) {
              for (var e = this.length; e--;) {
                var i = this[e];
                if (i.nodeName == t) return i;
              }
            },
            setNamedItem: function setNamedItem(t) {
              var e = t.ownerElement;
              if (e && e != this._ownerElement) throw new D(P);
              var i = this.getNamedItem(t.nodeName);
              return x(this._ownerElement, this, t, i), i;
            },
            setNamedItemNS: function setNamedItemNS(t) {
              var e,
                i = t.ownerElement;
              if (i && i != this._ownerElement) throw new D(P);
              return e = this.getNamedItemNS(t.namespaceURI, t.localName), x(this._ownerElement, this, t, e), e;
            },
            removeNamedItem: function removeNamedItem(t) {
              var e = this.getNamedItem(t);
              return M(this._ownerElement, this, e), e;
            },
            removeNamedItemNS: function removeNamedItemNS(t, e) {
              var i = this.getNamedItemNS(t, e);
              return M(this._ownerElement, this, i), i;
            },
            getNamedItemNS: function getNamedItemNS(t, e) {
              for (var i = this.length; i--;) {
                var s = this[i];
                if (s.localName == e && s.namespaceURI == t) return s;
              }
              return null;
            }
          }, k.prototype = {
            hasFeature: function hasFeature(t, e) {
              return !0;
            },
            createDocument: function createDocument(t, e, i) {
              var s = new F();
              if (s.implementation = this, s.childNodes = new R(), s.doctype = i || null, i && s.appendChild(i), e) {
                var n = s.createElementNS(t, e);
                s.appendChild(n);
              }
              return s;
            },
            createDocumentType: function createDocumentType(t, e, i) {
              var s = new rt();
              return s.name = t, s.nodeName = t, s.publicId = e || "", s.systemId = i || "", s;
            }
          }, U.prototype = {
            firstChild: null,
            lastChild: null,
            previousSibling: null,
            nextSibling: null,
            attributes: null,
            parentNode: null,
            childNodes: null,
            ownerDocument: null,
            nodeValue: null,
            namespaceURI: null,
            prefix: null,
            localName: null,
            insertBefore: function insertBefore(t, e) {
              return $(this, t, e);
            },
            replaceChild: function replaceChild(t, e) {
              $(this, t, e, J), e && this.removeChild(e);
            },
            removeChild: function removeChild(t) {
              return G(this, t);
            },
            appendChild: function appendChild(t) {
              return this.insertBefore(t, null);
            },
            hasChildNodes: function hasChildNodes() {
              return null != this.firstChild;
            },
            cloneNode: function cloneNode(t) {
              return vt(this.ownerDocument || this, this, t);
            },
            normalize: function normalize() {
              for (var t = this.firstChild; t;) {
                var e = t.nextSibling;
                e && e.nodeType == f && t.nodeType == f ? (this.removeChild(e), t.appendData(e.data)) : (t.normalize(), t = e);
              }
            },
            isSupported: function isSupported(t, e) {
              return this.ownerDocument.implementation.hasFeature(t, e);
            },
            hasAttributes: function hasAttributes() {
              return this.attributes.length > 0;
            },
            lookupPrefix: function lookupPrefix(t) {
              for (var e = this; e;) {
                var i = e._nsMap;
                if (i) for (var s in i) if (Object.prototype.hasOwnProperty.call(i, s) && i[s] === t) return s;
                e = e.nodeType == p ? e.ownerDocument : e.parentNode;
              }
              return null;
            },
            lookupNamespaceURI: function lookupNamespaceURI(t) {
              for (var e = this; e;) {
                var i = e._nsMap;
                if (i && t in i && Object.prototype.hasOwnProperty.call(i, t)) return i[t];
                e = e.nodeType == p ? e.ownerDocument : e.parentNode;
              }
              return null;
            },
            isDefaultNamespace: function isDefaultNamespace(t) {
              return null == this.lookupPrefix(t);
            }
          }, c(l, U), c(l, U.prototype), F.prototype = {
            nodeName: "#document",
            nodeType: S,
            doctype: null,
            documentElement: null,
            _inc: 1,
            insertBefore: function insertBefore(t, e) {
              if (t.nodeType == b) {
                for (var i = t.firstChild; i;) {
                  var s = i.nextSibling;
                  this.insertBefore(i, e), i = s;
                }
                return t;
              }
              return $(this, t, e), t.ownerDocument = this, null === this.documentElement && t.nodeType === h && (this.documentElement = t), t;
            },
            removeChild: function removeChild(t) {
              return this.documentElement == t && (this.documentElement = null), G(this, t);
            },
            replaceChild: function replaceChild(t, e) {
              $(this, t, e, J), t.ownerDocument = this, e && this.removeChild(e), W(t) && (this.documentElement = t);
            },
            importNode: function importNode(t, e) {
              return mt(this, t, e);
            },
            getElementById: function getElementById(t) {
              var e = null;
              return q(this.documentElement, function (i) {
                if (i.nodeType == h && i.getAttribute("id") == t) return e = i, !0;
              }), e;
            },
            getElementsByClassName: function getElementsByClassName(t) {
              var e = d(t);
              return new L(this, function (i) {
                var s = [];
                return e.length > 0 && q(i.documentElement, function (n) {
                  if (n !== i && n.nodeType === h) {
                    var r = n.getAttribute("class");
                    if (r) {
                      var a = t === r;
                      if (!a) {
                        var o = d(r);
                        a = e.every((c = o, function (t) {
                          return c && -1 !== c.indexOf(t);
                        }));
                      }
                      a && s.push(n);
                    }
                  }
                  var c;
                }), s;
              });
            },
            createElement: function createElement(t) {
              var e = new Z();
              return e.ownerDocument = this, e.nodeName = t, e.tagName = t, e.localName = t, e.childNodes = new R(), (e.attributes = new O())._ownerElement = e, e;
            },
            createDocumentFragment: function createDocumentFragment() {
              var t = new ct();
              return t.ownerDocument = this, t.childNodes = new R(), t;
            },
            createTextNode: function createTextNode(t) {
              var e = new it();
              return e.ownerDocument = this, e.appendData(t), e;
            },
            createComment: function createComment(t) {
              var e = new st();
              return e.ownerDocument = this, e.appendData(t), e;
            },
            createCDATASection: function createCDATASection(t) {
              var e = new nt();
              return e.ownerDocument = this, e.appendData(t), e;
            },
            createProcessingInstruction: function createProcessingInstruction(t, e) {
              var i = new ut();
              return i.ownerDocument = this, i.tagName = i.nodeName = i.target = t, i.nodeValue = i.data = e, i;
            },
            createAttribute: function createAttribute(t) {
              var e = new tt();
              return e.ownerDocument = this, e.name = t, e.nodeName = t, e.localName = t, e.specified = !0, e;
            },
            createEntityReference: function createEntityReference(t) {
              var e = new dt();
              return e.ownerDocument = this, e.nodeName = t, e;
            },
            createElementNS: function createElementNS(t, e) {
              var i = new Z(),
                s = e.split(":"),
                n = i.attributes = new O();
              return i.childNodes = new R(), i.ownerDocument = this, i.nodeName = e, i.tagName = e, i.namespaceURI = t, 2 == s.length ? (i.prefix = s[0], i.localName = s[1]) : i.localName = e, n._ownerElement = i, i;
            },
            createAttributeNS: function createAttributeNS(t, e) {
              var i = new tt(),
                s = e.split(":");
              return i.ownerDocument = this, i.nodeName = e, i.name = e, i.namespaceURI = t, i.specified = !0, 2 == s.length ? (i.prefix = s[0], i.localName = s[1]) : i.localName = e, i;
            }
          }, u(F, U), Z.prototype = {
            nodeType: h,
            hasAttribute: function hasAttribute(t) {
              return null != this.getAttributeNode(t);
            },
            getAttribute: function getAttribute(t) {
              var e = this.getAttributeNode(t);
              return e && e.value || "";
            },
            getAttributeNode: function getAttributeNode(t) {
              return this.attributes.getNamedItem(t);
            },
            setAttribute: function setAttribute(t, e) {
              var i = this.ownerDocument.createAttribute(t);
              i.value = i.nodeValue = "" + e, this.setAttributeNode(i);
            },
            removeAttribute: function removeAttribute(t) {
              var e = this.getAttributeNode(t);
              e && this.removeAttributeNode(e);
            },
            appendChild: function appendChild(t) {
              return t.nodeType === b ? this.insertBefore(t, null) : function (t, e) {
                return e.parentNode && e.parentNode.removeChild(e), e.parentNode = t, e.previousSibling = t.lastChild, e.nextSibling = null, e.previousSibling ? e.previousSibling.nextSibling = e : t.firstChild = e, t.lastChild = e, H(t.ownerDocument, t, e), e;
              }(this, t);
            },
            setAttributeNode: function setAttributeNode(t) {
              return this.attributes.setNamedItem(t);
            },
            setAttributeNodeNS: function setAttributeNodeNS(t) {
              return this.attributes.setNamedItemNS(t);
            },
            removeAttributeNode: function removeAttributeNode(t) {
              return this.attributes.removeNamedItem(t.nodeName);
            },
            removeAttributeNS: function removeAttributeNS(t, e) {
              var i = this.getAttributeNodeNS(t, e);
              i && this.removeAttributeNode(i);
            },
            hasAttributeNS: function hasAttributeNS(t, e) {
              return null != this.getAttributeNodeNS(t, e);
            },
            getAttributeNS: function getAttributeNS(t, e) {
              var i = this.getAttributeNodeNS(t, e);
              return i && i.value || "";
            },
            setAttributeNS: function setAttributeNS(t, e, i) {
              var s = this.ownerDocument.createAttributeNS(t, e);
              s.value = s.nodeValue = "" + i, this.setAttributeNode(s);
            },
            getAttributeNodeNS: function getAttributeNodeNS(t, e) {
              return this.attributes.getNamedItemNS(t, e);
            },
            getElementsByTagName: function getElementsByTagName(t) {
              return new L(this, function (e) {
                var i = [];
                return q(e, function (s) {
                  s === e || s.nodeType != h || "*" !== t && s.tagName != t || i.push(s);
                }), i;
              });
            },
            getElementsByTagNameNS: function getElementsByTagNameNS(t, e) {
              return new L(this, function (i) {
                var s = [];
                return q(i, function (n) {
                  n === i || n.nodeType !== h || "*" !== t && n.namespaceURI !== t || "*" !== e && n.localName != e || s.push(n);
                }), s;
              });
            }
          }, F.prototype.getElementsByTagName = Z.prototype.getElementsByTagName, F.prototype.getElementsByTagNameNS = Z.prototype.getElementsByTagNameNS, u(Z, U), tt.prototype.nodeType = p, u(tt, U), et.prototype = {
            data: "",
            substringData: function substringData(t, e) {
              return this.data.substring(t, t + e);
            },
            appendData: function appendData(t) {
              t = this.data + t, this.nodeValue = this.data = t, this.length = t.length;
            },
            insertData: function insertData(t, e) {
              this.replaceData(t, 0, e);
            },
            appendChild: function appendChild(t) {
              throw new Error(_[I]);
            },
            deleteData: function deleteData(t, e) {
              this.replaceData(t, e, "");
            },
            replaceData: function replaceData(t, e, i) {
              i = this.data.substring(0, t) + i + this.data.substring(t + e), this.nodeValue = this.data = i, this.length = i.length;
            }
          }, u(et, U), it.prototype = {
            nodeName: "#text",
            nodeType: f,
            splitText: function splitText(t) {
              var e = this.data,
                i = e.substring(t);
              e = e.substring(0, t), this.data = this.nodeValue = e, this.length = e.length;
              var s = this.ownerDocument.createTextNode(i);
              return this.parentNode && this.parentNode.insertBefore(s, this.nextSibling), s;
            }
          }, u(it, et), st.prototype = {
            nodeName: "#comment",
            nodeType: T
          }, u(st, et), nt.prototype = {
            nodeName: "#cdata-section",
            nodeType: g
          }, u(nt, et), rt.prototype.nodeType = E, u(rt, U), at.prototype.nodeType = A, u(at, U), ot.prototype.nodeType = v, u(ot, U), dt.prototype.nodeType = m, u(dt, U), ct.prototype.nodeName = "#document-fragment", ct.prototype.nodeType = b, u(ct, U), ut.prototype.nodeType = y, u(ut, U), lt.prototype.serializeToString = function (t, e, i) {
            return ht.call(t, e, i);
          }, U.prototype.toString = ht;
          try {
            if (Object.defineProperty) {
              var Tt = function Tt(t) {
                switch (t.nodeType) {
                  case h:
                  case b:
                    var e = [];
                    for (t = t.firstChild; t;) 7 !== t.nodeType && 8 !== t.nodeType && e.push(Tt(t)), t = t.nextSibling;
                    return e.join("");
                  default:
                    return t.nodeValue;
                }
              };
              Object.defineProperty(L.prototype, "length", {
                get: function get() {
                  return C(this), this.$$length;
                }
              }), Object.defineProperty(U.prototype, "textContent", {
                get: function get() {
                  return Tt(this);
                },
                set: function set(t) {
                  switch (this.nodeType) {
                    case h:
                    case b:
                      for (; this.firstChild;) this.removeChild(this.firstChild);
                      (t || String(t)) && this.appendChild(this.ownerDocument.createTextNode(t));
                      break;
                    default:
                      this.data = t, this.value = t, this.nodeValue = t;
                  }
                }
              }), yt = function yt(t, e, i) {
                t["$$" + e] = i;
              };
            }
          } catch (St) {}
          e.DocumentType = rt, e.DOMException = D, e.DOMImplementation = k, e.Element = Z, e.Node = U, e.NodeList = R, e.XMLSerializer = lt;
        },
        6598: function _(t, e, i) {
          "use strict";

          var s = i(525).freeze;
          e.XML_ENTITIES = s({
            amp: "&",
            apos: "'",
            gt: ">",
            lt: "<",
            quot: '"'
          }), e.HTML_ENTITIES = s({
            Aacute: "Á",
            aacute: "á",
            Abreve: "Ă",
            abreve: "ă",
            ac: "∾",
            acd: "∿",
            acE: "∾̳",
            Acirc: "Â",
            acirc: "â",
            acute: "´",
            Acy: "А",
            acy: "а",
            AElig: "Æ",
            aelig: "æ",
            af: "⁡",
            Afr: "𝔄",
            afr: "𝔞",
            Agrave: "À",
            agrave: "à",
            alefsym: "ℵ",
            aleph: "ℵ",
            Alpha: "Α",
            alpha: "α",
            Amacr: "Ā",
            amacr: "ā",
            amalg: "⨿",
            AMP: "&",
            amp: "&",
            And: "⩓",
            and: "∧",
            andand: "⩕",
            andd: "⩜",
            andslope: "⩘",
            andv: "⩚",
            ang: "∠",
            ange: "⦤",
            angle: "∠",
            angmsd: "∡",
            angmsdaa: "⦨",
            angmsdab: "⦩",
            angmsdac: "⦪",
            angmsdad: "⦫",
            angmsdae: "⦬",
            angmsdaf: "⦭",
            angmsdag: "⦮",
            angmsdah: "⦯",
            angrt: "∟",
            angrtvb: "⊾",
            angrtvbd: "⦝",
            angsph: "∢",
            angst: "Å",
            angzarr: "⍼",
            Aogon: "Ą",
            aogon: "ą",
            Aopf: "𝔸",
            aopf: "𝕒",
            ap: "≈",
            apacir: "⩯",
            apE: "⩰",
            ape: "≊",
            apid: "≋",
            apos: "'",
            ApplyFunction: "⁡",
            approx: "≈",
            approxeq: "≊",
            Aring: "Å",
            aring: "å",
            Ascr: "𝒜",
            ascr: "𝒶",
            Assign: "≔",
            ast: "*",
            asymp: "≈",
            asympeq: "≍",
            Atilde: "Ã",
            atilde: "ã",
            Auml: "Ä",
            auml: "ä",
            awconint: "∳",
            awint: "⨑",
            backcong: "≌",
            backepsilon: "϶",
            backprime: "‵",
            backsim: "∽",
            backsimeq: "⋍",
            Backslash: "∖",
            Barv: "⫧",
            barvee: "⊽",
            Barwed: "⌆",
            barwed: "⌅",
            barwedge: "⌅",
            bbrk: "⎵",
            bbrktbrk: "⎶",
            bcong: "≌",
            Bcy: "Б",
            bcy: "б",
            bdquo: "„",
            becaus: "∵",
            Because: "∵",
            because: "∵",
            bemptyv: "⦰",
            bepsi: "϶",
            bernou: "ℬ",
            Bernoullis: "ℬ",
            Beta: "Β",
            beta: "β",
            beth: "ℶ",
            between: "≬",
            Bfr: "𝔅",
            bfr: "𝔟",
            bigcap: "⋂",
            bigcirc: "◯",
            bigcup: "⋃",
            bigodot: "⨀",
            bigoplus: "⨁",
            bigotimes: "⨂",
            bigsqcup: "⨆",
            bigstar: "★",
            bigtriangledown: "▽",
            bigtriangleup: "△",
            biguplus: "⨄",
            bigvee: "⋁",
            bigwedge: "⋀",
            bkarow: "⤍",
            blacklozenge: "⧫",
            blacksquare: "▪",
            blacktriangle: "▴",
            blacktriangledown: "▾",
            blacktriangleleft: "◂",
            blacktriangleright: "▸",
            blank: "␣",
            blk12: "▒",
            blk14: "░",
            blk34: "▓",
            block: "█",
            bne: "=⃥",
            bnequiv: "≡⃥",
            bNot: "⫭",
            bnot: "⌐",
            Bopf: "𝔹",
            bopf: "𝕓",
            bot: "⊥",
            bottom: "⊥",
            bowtie: "⋈",
            boxbox: "⧉",
            boxDL: "╗",
            boxDl: "╖",
            boxdL: "╕",
            boxdl: "┐",
            boxDR: "╔",
            boxDr: "╓",
            boxdR: "╒",
            boxdr: "┌",
            boxH: "═",
            boxh: "─",
            boxHD: "╦",
            boxHd: "╤",
            boxhD: "╥",
            boxhd: "┬",
            boxHU: "╩",
            boxHu: "╧",
            boxhU: "╨",
            boxhu: "┴",
            boxminus: "⊟",
            boxplus: "⊞",
            boxtimes: "⊠",
            boxUL: "╝",
            boxUl: "╜",
            boxuL: "╛",
            boxul: "┘",
            boxUR: "╚",
            boxUr: "╙",
            boxuR: "╘",
            boxur: "└",
            boxV: "║",
            boxv: "│",
            boxVH: "╬",
            boxVh: "╫",
            boxvH: "╪",
            boxvh: "┼",
            boxVL: "╣",
            boxVl: "╢",
            boxvL: "╡",
            boxvl: "┤",
            boxVR: "╠",
            boxVr: "╟",
            boxvR: "╞",
            boxvr: "├",
            bprime: "‵",
            Breve: "˘",
            breve: "˘",
            brvbar: "¦",
            Bscr: "ℬ",
            bscr: "𝒷",
            bsemi: "⁏",
            bsim: "∽",
            bsime: "⋍",
            bsol: "\\",
            bsolb: "⧅",
            bsolhsub: "⟈",
            bull: "•",
            bullet: "•",
            bump: "≎",
            bumpE: "⪮",
            bumpe: "≏",
            Bumpeq: "≎",
            bumpeq: "≏",
            Cacute: "Ć",
            cacute: "ć",
            Cap: "⋒",
            cap: "∩",
            capand: "⩄",
            capbrcup: "⩉",
            capcap: "⩋",
            capcup: "⩇",
            capdot: "⩀",
            CapitalDifferentialD: "ⅅ",
            caps: "∩︀",
            caret: "⁁",
            caron: "ˇ",
            Cayleys: "ℭ",
            ccaps: "⩍",
            Ccaron: "Č",
            ccaron: "č",
            Ccedil: "Ç",
            ccedil: "ç",
            Ccirc: "Ĉ",
            ccirc: "ĉ",
            Cconint: "∰",
            ccups: "⩌",
            ccupssm: "⩐",
            Cdot: "Ċ",
            cdot: "ċ",
            cedil: "¸",
            Cedilla: "¸",
            cemptyv: "⦲",
            cent: "¢",
            CenterDot: "·",
            centerdot: "·",
            Cfr: "ℭ",
            cfr: "𝔠",
            CHcy: "Ч",
            chcy: "ч",
            check: "✓",
            checkmark: "✓",
            Chi: "Χ",
            chi: "χ",
            cir: "○",
            circ: "ˆ",
            circeq: "≗",
            circlearrowleft: "↺",
            circlearrowright: "↻",
            circledast: "⊛",
            circledcirc: "⊚",
            circleddash: "⊝",
            CircleDot: "⊙",
            circledR: "®",
            circledS: "Ⓢ",
            CircleMinus: "⊖",
            CirclePlus: "⊕",
            CircleTimes: "⊗",
            cirE: "⧃",
            cire: "≗",
            cirfnint: "⨐",
            cirmid: "⫯",
            cirscir: "⧂",
            ClockwiseContourIntegral: "∲",
            CloseCurlyDoubleQuote: "”",
            CloseCurlyQuote: "’",
            clubs: "♣",
            clubsuit: "♣",
            Colon: "∷",
            colon: ":",
            Colone: "⩴",
            colone: "≔",
            coloneq: "≔",
            comma: ",",
            commat: "@",
            comp: "∁",
            compfn: "∘",
            complement: "∁",
            complexes: "ℂ",
            cong: "≅",
            congdot: "⩭",
            Congruent: "≡",
            Conint: "∯",
            conint: "∮",
            ContourIntegral: "∮",
            Copf: "ℂ",
            copf: "𝕔",
            coprod: "∐",
            Coproduct: "∐",
            COPY: "©",
            copy: "©",
            copysr: "℗",
            CounterClockwiseContourIntegral: "∳",
            crarr: "↵",
            Cross: "⨯",
            cross: "✗",
            Cscr: "𝒞",
            cscr: "𝒸",
            csub: "⫏",
            csube: "⫑",
            csup: "⫐",
            csupe: "⫒",
            ctdot: "⋯",
            cudarrl: "⤸",
            cudarrr: "⤵",
            cuepr: "⋞",
            cuesc: "⋟",
            cularr: "↶",
            cularrp: "⤽",
            Cup: "⋓",
            cup: "∪",
            cupbrcap: "⩈",
            CupCap: "≍",
            cupcap: "⩆",
            cupcup: "⩊",
            cupdot: "⊍",
            cupor: "⩅",
            cups: "∪︀",
            curarr: "↷",
            curarrm: "⤼",
            curlyeqprec: "⋞",
            curlyeqsucc: "⋟",
            curlyvee: "⋎",
            curlywedge: "⋏",
            curren: "¤",
            curvearrowleft: "↶",
            curvearrowright: "↷",
            cuvee: "⋎",
            cuwed: "⋏",
            cwconint: "∲",
            cwint: "∱",
            cylcty: "⌭",
            Dagger: "‡",
            dagger: "†",
            daleth: "ℸ",
            Darr: "↡",
            dArr: "⇓",
            darr: "↓",
            dash: "‐",
            Dashv: "⫤",
            dashv: "⊣",
            dbkarow: "⤏",
            dblac: "˝",
            Dcaron: "Ď",
            dcaron: "ď",
            Dcy: "Д",
            dcy: "д",
            DD: "ⅅ",
            dd: "ⅆ",
            ddagger: "‡",
            ddarr: "⇊",
            DDotrahd: "⤑",
            ddotseq: "⩷",
            deg: "°",
            Del: "∇",
            Delta: "Δ",
            delta: "δ",
            demptyv: "⦱",
            dfisht: "⥿",
            Dfr: "𝔇",
            dfr: "𝔡",
            dHar: "⥥",
            dharl: "⇃",
            dharr: "⇂",
            DiacriticalAcute: "´",
            DiacriticalDot: "˙",
            DiacriticalDoubleAcute: "˝",
            DiacriticalGrave: "`",
            DiacriticalTilde: "˜",
            diam: "⋄",
            Diamond: "⋄",
            diamond: "⋄",
            diamondsuit: "♦",
            diams: "♦",
            die: "¨",
            DifferentialD: "ⅆ",
            digamma: "ϝ",
            disin: "⋲",
            div: "÷",
            divide: "÷",
            divideontimes: "⋇",
            divonx: "⋇",
            DJcy: "Ђ",
            djcy: "ђ",
            dlcorn: "⌞",
            dlcrop: "⌍",
            dollar: "$",
            Dopf: "𝔻",
            dopf: "𝕕",
            Dot: "¨",
            dot: "˙",
            DotDot: "⃜",
            doteq: "≐",
            doteqdot: "≑",
            DotEqual: "≐",
            dotminus: "∸",
            dotplus: "∔",
            dotsquare: "⊡",
            doublebarwedge: "⌆",
            DoubleContourIntegral: "∯",
            DoubleDot: "¨",
            DoubleDownArrow: "⇓",
            DoubleLeftArrow: "⇐",
            DoubleLeftRightArrow: "⇔",
            DoubleLeftTee: "⫤",
            DoubleLongLeftArrow: "⟸",
            DoubleLongLeftRightArrow: "⟺",
            DoubleLongRightArrow: "⟹",
            DoubleRightArrow: "⇒",
            DoubleRightTee: "⊨",
            DoubleUpArrow: "⇑",
            DoubleUpDownArrow: "⇕",
            DoubleVerticalBar: "∥",
            DownArrow: "↓",
            Downarrow: "⇓",
            downarrow: "↓",
            DownArrowBar: "⤓",
            DownArrowUpArrow: "⇵",
            DownBreve: "̑",
            downdownarrows: "⇊",
            downharpoonleft: "⇃",
            downharpoonright: "⇂",
            DownLeftRightVector: "⥐",
            DownLeftTeeVector: "⥞",
            DownLeftVector: "↽",
            DownLeftVectorBar: "⥖",
            DownRightTeeVector: "⥟",
            DownRightVector: "⇁",
            DownRightVectorBar: "⥗",
            DownTee: "⊤",
            DownTeeArrow: "↧",
            drbkarow: "⤐",
            drcorn: "⌟",
            drcrop: "⌌",
            Dscr: "𝒟",
            dscr: "𝒹",
            DScy: "Ѕ",
            dscy: "ѕ",
            dsol: "⧶",
            Dstrok: "Đ",
            dstrok: "đ",
            dtdot: "⋱",
            dtri: "▿",
            dtrif: "▾",
            duarr: "⇵",
            duhar: "⥯",
            dwangle: "⦦",
            DZcy: "Џ",
            dzcy: "џ",
            dzigrarr: "⟿",
            Eacute: "É",
            eacute: "é",
            easter: "⩮",
            Ecaron: "Ě",
            ecaron: "ě",
            ecir: "≖",
            Ecirc: "Ê",
            ecirc: "ê",
            ecolon: "≕",
            Ecy: "Э",
            ecy: "э",
            eDDot: "⩷",
            Edot: "Ė",
            eDot: "≑",
            edot: "ė",
            ee: "ⅇ",
            efDot: "≒",
            Efr: "𝔈",
            efr: "𝔢",
            eg: "⪚",
            Egrave: "È",
            egrave: "è",
            egs: "⪖",
            egsdot: "⪘",
            el: "⪙",
            Element: "∈",
            elinters: "⏧",
            ell: "ℓ",
            els: "⪕",
            elsdot: "⪗",
            Emacr: "Ē",
            emacr: "ē",
            empty: "∅",
            emptyset: "∅",
            EmptySmallSquare: "◻",
            emptyv: "∅",
            EmptyVerySmallSquare: "▫",
            emsp: " ",
            emsp13: " ",
            emsp14: " ",
            ENG: "Ŋ",
            eng: "ŋ",
            ensp: " ",
            Eogon: "Ę",
            eogon: "ę",
            Eopf: "𝔼",
            eopf: "𝕖",
            epar: "⋕",
            eparsl: "⧣",
            eplus: "⩱",
            epsi: "ε",
            Epsilon: "Ε",
            epsilon: "ε",
            epsiv: "ϵ",
            eqcirc: "≖",
            eqcolon: "≕",
            eqsim: "≂",
            eqslantgtr: "⪖",
            eqslantless: "⪕",
            Equal: "⩵",
            equals: "=",
            EqualTilde: "≂",
            equest: "≟",
            Equilibrium: "⇌",
            equiv: "≡",
            equivDD: "⩸",
            eqvparsl: "⧥",
            erarr: "⥱",
            erDot: "≓",
            Escr: "ℰ",
            escr: "ℯ",
            esdot: "≐",
            Esim: "⩳",
            esim: "≂",
            Eta: "Η",
            eta: "η",
            ETH: "Ð",
            eth: "ð",
            Euml: "Ë",
            euml: "ë",
            euro: "€",
            excl: "!",
            exist: "∃",
            Exists: "∃",
            expectation: "ℰ",
            ExponentialE: "ⅇ",
            exponentiale: "ⅇ",
            fallingdotseq: "≒",
            Fcy: "Ф",
            fcy: "ф",
            female: "♀",
            ffilig: "ﬃ",
            fflig: "ﬀ",
            ffllig: "ﬄ",
            Ffr: "𝔉",
            ffr: "𝔣",
            filig: "ﬁ",
            FilledSmallSquare: "◼",
            FilledVerySmallSquare: "▪",
            fjlig: "fj",
            flat: "♭",
            fllig: "ﬂ",
            fltns: "▱",
            fnof: "ƒ",
            Fopf: "𝔽",
            fopf: "𝕗",
            ForAll: "∀",
            forall: "∀",
            fork: "⋔",
            forkv: "⫙",
            Fouriertrf: "ℱ",
            fpartint: "⨍",
            frac12: "½",
            frac13: "⅓",
            frac14: "¼",
            frac15: "⅕",
            frac16: "⅙",
            frac18: "⅛",
            frac23: "⅔",
            frac25: "⅖",
            frac34: "¾",
            frac35: "⅗",
            frac38: "⅜",
            frac45: "⅘",
            frac56: "⅚",
            frac58: "⅝",
            frac78: "⅞",
            frasl: "⁄",
            frown: "⌢",
            Fscr: "ℱ",
            fscr: "𝒻",
            gacute: "ǵ",
            Gamma: "Γ",
            gamma: "γ",
            Gammad: "Ϝ",
            gammad: "ϝ",
            gap: "⪆",
            Gbreve: "Ğ",
            gbreve: "ğ",
            Gcedil: "Ģ",
            Gcirc: "Ĝ",
            gcirc: "ĝ",
            Gcy: "Г",
            gcy: "г",
            Gdot: "Ġ",
            gdot: "ġ",
            gE: "≧",
            ge: "≥",
            gEl: "⪌",
            gel: "⋛",
            geq: "≥",
            geqq: "≧",
            geqslant: "⩾",
            ges: "⩾",
            gescc: "⪩",
            gesdot: "⪀",
            gesdoto: "⪂",
            gesdotol: "⪄",
            gesl: "⋛︀",
            gesles: "⪔",
            Gfr: "𝔊",
            gfr: "𝔤",
            Gg: "⋙",
            gg: "≫",
            ggg: "⋙",
            gimel: "ℷ",
            GJcy: "Ѓ",
            gjcy: "ѓ",
            gl: "≷",
            gla: "⪥",
            glE: "⪒",
            glj: "⪤",
            gnap: "⪊",
            gnapprox: "⪊",
            gnE: "≩",
            gne: "⪈",
            gneq: "⪈",
            gneqq: "≩",
            gnsim: "⋧",
            Gopf: "𝔾",
            gopf: "𝕘",
            grave: "`",
            GreaterEqual: "≥",
            GreaterEqualLess: "⋛",
            GreaterFullEqual: "≧",
            GreaterGreater: "⪢",
            GreaterLess: "≷",
            GreaterSlantEqual: "⩾",
            GreaterTilde: "≳",
            Gscr: "𝒢",
            gscr: "ℊ",
            gsim: "≳",
            gsime: "⪎",
            gsiml: "⪐",
            Gt: "≫",
            GT: ">",
            gt: ">",
            gtcc: "⪧",
            gtcir: "⩺",
            gtdot: "⋗",
            gtlPar: "⦕",
            gtquest: "⩼",
            gtrapprox: "⪆",
            gtrarr: "⥸",
            gtrdot: "⋗",
            gtreqless: "⋛",
            gtreqqless: "⪌",
            gtrless: "≷",
            gtrsim: "≳",
            gvertneqq: "≩︀",
            gvnE: "≩︀",
            Hacek: "ˇ",
            hairsp: " ",
            half: "½",
            hamilt: "ℋ",
            HARDcy: "Ъ",
            hardcy: "ъ",
            hArr: "⇔",
            harr: "↔",
            harrcir: "⥈",
            harrw: "↭",
            Hat: "^",
            hbar: "ℏ",
            Hcirc: "Ĥ",
            hcirc: "ĥ",
            hearts: "♥",
            heartsuit: "♥",
            hellip: "…",
            hercon: "⊹",
            Hfr: "ℌ",
            hfr: "𝔥",
            HilbertSpace: "ℋ",
            hksearow: "⤥",
            hkswarow: "⤦",
            hoarr: "⇿",
            homtht: "∻",
            hookleftarrow: "↩",
            hookrightarrow: "↪",
            Hopf: "ℍ",
            hopf: "𝕙",
            horbar: "―",
            HorizontalLine: "─",
            Hscr: "ℋ",
            hscr: "𝒽",
            hslash: "ℏ",
            Hstrok: "Ħ",
            hstrok: "ħ",
            HumpDownHump: "≎",
            HumpEqual: "≏",
            hybull: "⁃",
            hyphen: "‐",
            Iacute: "Í",
            iacute: "í",
            ic: "⁣",
            Icirc: "Î",
            icirc: "î",
            Icy: "И",
            icy: "и",
            Idot: "İ",
            IEcy: "Е",
            iecy: "е",
            iexcl: "¡",
            iff: "⇔",
            Ifr: "ℑ",
            ifr: "𝔦",
            Igrave: "Ì",
            igrave: "ì",
            ii: "ⅈ",
            iiiint: "⨌",
            iiint: "∭",
            iinfin: "⧜",
            iiota: "℩",
            IJlig: "Ĳ",
            ijlig: "ĳ",
            Im: "ℑ",
            Imacr: "Ī",
            imacr: "ī",
            image: "ℑ",
            ImaginaryI: "ⅈ",
            imagline: "ℐ",
            imagpart: "ℑ",
            imath: "ı",
            imof: "⊷",
            imped: "Ƶ",
            Implies: "⇒",
            in: "∈",
            incare: "℅",
            infin: "∞",
            infintie: "⧝",
            inodot: "ı",
            Int: "∬",
            int: "∫",
            intcal: "⊺",
            integers: "ℤ",
            Integral: "∫",
            intercal: "⊺",
            Intersection: "⋂",
            intlarhk: "⨗",
            intprod: "⨼",
            InvisibleComma: "⁣",
            InvisibleTimes: "⁢",
            IOcy: "Ё",
            iocy: "ё",
            Iogon: "Į",
            iogon: "į",
            Iopf: "𝕀",
            iopf: "𝕚",
            Iota: "Ι",
            iota: "ι",
            iprod: "⨼",
            iquest: "¿",
            Iscr: "ℐ",
            iscr: "𝒾",
            isin: "∈",
            isindot: "⋵",
            isinE: "⋹",
            isins: "⋴",
            isinsv: "⋳",
            isinv: "∈",
            it: "⁢",
            Itilde: "Ĩ",
            itilde: "ĩ",
            Iukcy: "І",
            iukcy: "і",
            Iuml: "Ï",
            iuml: "ï",
            Jcirc: "Ĵ",
            jcirc: "ĵ",
            Jcy: "Й",
            jcy: "й",
            Jfr: "𝔍",
            jfr: "𝔧",
            jmath: "ȷ",
            Jopf: "𝕁",
            jopf: "𝕛",
            Jscr: "𝒥",
            jscr: "𝒿",
            Jsercy: "Ј",
            jsercy: "ј",
            Jukcy: "Є",
            jukcy: "є",
            Kappa: "Κ",
            kappa: "κ",
            kappav: "ϰ",
            Kcedil: "Ķ",
            kcedil: "ķ",
            Kcy: "К",
            kcy: "к",
            Kfr: "𝔎",
            kfr: "𝔨",
            kgreen: "ĸ",
            KHcy: "Х",
            khcy: "х",
            KJcy: "Ќ",
            kjcy: "ќ",
            Kopf: "𝕂",
            kopf: "𝕜",
            Kscr: "𝒦",
            kscr: "𝓀",
            lAarr: "⇚",
            Lacute: "Ĺ",
            lacute: "ĺ",
            laemptyv: "⦴",
            lagran: "ℒ",
            Lambda: "Λ",
            lambda: "λ",
            Lang: "⟪",
            lang: "⟨",
            langd: "⦑",
            langle: "⟨",
            lap: "⪅",
            Laplacetrf: "ℒ",
            laquo: "«",
            Larr: "↞",
            lArr: "⇐",
            larr: "←",
            larrb: "⇤",
            larrbfs: "⤟",
            larrfs: "⤝",
            larrhk: "↩",
            larrlp: "↫",
            larrpl: "⤹",
            larrsim: "⥳",
            larrtl: "↢",
            lat: "⪫",
            lAtail: "⤛",
            latail: "⤙",
            late: "⪭",
            lates: "⪭︀",
            lBarr: "⤎",
            lbarr: "⤌",
            lbbrk: "❲",
            lbrace: "{",
            lbrack: "[",
            lbrke: "⦋",
            lbrksld: "⦏",
            lbrkslu: "⦍",
            Lcaron: "Ľ",
            lcaron: "ľ",
            Lcedil: "Ļ",
            lcedil: "ļ",
            lceil: "⌈",
            lcub: "{",
            Lcy: "Л",
            lcy: "л",
            ldca: "⤶",
            ldquo: "“",
            ldquor: "„",
            ldrdhar: "⥧",
            ldrushar: "⥋",
            ldsh: "↲",
            lE: "≦",
            le: "≤",
            LeftAngleBracket: "⟨",
            LeftArrow: "←",
            Leftarrow: "⇐",
            leftarrow: "←",
            LeftArrowBar: "⇤",
            LeftArrowRightArrow: "⇆",
            leftarrowtail: "↢",
            LeftCeiling: "⌈",
            LeftDoubleBracket: "⟦",
            LeftDownTeeVector: "⥡",
            LeftDownVector: "⇃",
            LeftDownVectorBar: "⥙",
            LeftFloor: "⌊",
            leftharpoondown: "↽",
            leftharpoonup: "↼",
            leftleftarrows: "⇇",
            LeftRightArrow: "↔",
            Leftrightarrow: "⇔",
            leftrightarrow: "↔",
            leftrightarrows: "⇆",
            leftrightharpoons: "⇋",
            leftrightsquigarrow: "↭",
            LeftRightVector: "⥎",
            LeftTee: "⊣",
            LeftTeeArrow: "↤",
            LeftTeeVector: "⥚",
            leftthreetimes: "⋋",
            LeftTriangle: "⊲",
            LeftTriangleBar: "⧏",
            LeftTriangleEqual: "⊴",
            LeftUpDownVector: "⥑",
            LeftUpTeeVector: "⥠",
            LeftUpVector: "↿",
            LeftUpVectorBar: "⥘",
            LeftVector: "↼",
            LeftVectorBar: "⥒",
            lEg: "⪋",
            leg: "⋚",
            leq: "≤",
            leqq: "≦",
            leqslant: "⩽",
            les: "⩽",
            lescc: "⪨",
            lesdot: "⩿",
            lesdoto: "⪁",
            lesdotor: "⪃",
            lesg: "⋚︀",
            lesges: "⪓",
            lessapprox: "⪅",
            lessdot: "⋖",
            lesseqgtr: "⋚",
            lesseqqgtr: "⪋",
            LessEqualGreater: "⋚",
            LessFullEqual: "≦",
            LessGreater: "≶",
            lessgtr: "≶",
            LessLess: "⪡",
            lesssim: "≲",
            LessSlantEqual: "⩽",
            LessTilde: "≲",
            lfisht: "⥼",
            lfloor: "⌊",
            Lfr: "𝔏",
            lfr: "𝔩",
            lg: "≶",
            lgE: "⪑",
            lHar: "⥢",
            lhard: "↽",
            lharu: "↼",
            lharul: "⥪",
            lhblk: "▄",
            LJcy: "Љ",
            ljcy: "љ",
            Ll: "⋘",
            ll: "≪",
            llarr: "⇇",
            llcorner: "⌞",
            Lleftarrow: "⇚",
            llhard: "⥫",
            lltri: "◺",
            Lmidot: "Ŀ",
            lmidot: "ŀ",
            lmoust: "⎰",
            lmoustache: "⎰",
            lnap: "⪉",
            lnapprox: "⪉",
            lnE: "≨",
            lne: "⪇",
            lneq: "⪇",
            lneqq: "≨",
            lnsim: "⋦",
            loang: "⟬",
            loarr: "⇽",
            lobrk: "⟦",
            LongLeftArrow: "⟵",
            Longleftarrow: "⟸",
            longleftarrow: "⟵",
            LongLeftRightArrow: "⟷",
            Longleftrightarrow: "⟺",
            longleftrightarrow: "⟷",
            longmapsto: "⟼",
            LongRightArrow: "⟶",
            Longrightarrow: "⟹",
            longrightarrow: "⟶",
            looparrowleft: "↫",
            looparrowright: "↬",
            lopar: "⦅",
            Lopf: "𝕃",
            lopf: "𝕝",
            loplus: "⨭",
            lotimes: "⨴",
            lowast: "∗",
            lowbar: "_",
            LowerLeftArrow: "↙",
            LowerRightArrow: "↘",
            loz: "◊",
            lozenge: "◊",
            lozf: "⧫",
            lpar: "(",
            lparlt: "⦓",
            lrarr: "⇆",
            lrcorner: "⌟",
            lrhar: "⇋",
            lrhard: "⥭",
            lrm: "‎",
            lrtri: "⊿",
            lsaquo: "‹",
            Lscr: "ℒ",
            lscr: "𝓁",
            Lsh: "↰",
            lsh: "↰",
            lsim: "≲",
            lsime: "⪍",
            lsimg: "⪏",
            lsqb: "[",
            lsquo: "‘",
            lsquor: "‚",
            Lstrok: "Ł",
            lstrok: "ł",
            Lt: "≪",
            LT: "<",
            lt: "<",
            ltcc: "⪦",
            ltcir: "⩹",
            ltdot: "⋖",
            lthree: "⋋",
            ltimes: "⋉",
            ltlarr: "⥶",
            ltquest: "⩻",
            ltri: "◃",
            ltrie: "⊴",
            ltrif: "◂",
            ltrPar: "⦖",
            lurdshar: "⥊",
            luruhar: "⥦",
            lvertneqq: "≨︀",
            lvnE: "≨︀",
            macr: "¯",
            male: "♂",
            malt: "✠",
            maltese: "✠",
            Map: "⤅",
            map: "↦",
            mapsto: "↦",
            mapstodown: "↧",
            mapstoleft: "↤",
            mapstoup: "↥",
            marker: "▮",
            mcomma: "⨩",
            Mcy: "М",
            mcy: "м",
            mdash: "—",
            mDDot: "∺",
            measuredangle: "∡",
            MediumSpace: " ",
            Mellintrf: "ℳ",
            Mfr: "𝔐",
            mfr: "𝔪",
            mho: "℧",
            micro: "µ",
            mid: "∣",
            midast: "*",
            midcir: "⫰",
            middot: "·",
            minus: "−",
            minusb: "⊟",
            minusd: "∸",
            minusdu: "⨪",
            MinusPlus: "∓",
            mlcp: "⫛",
            mldr: "…",
            mnplus: "∓",
            models: "⊧",
            Mopf: "𝕄",
            mopf: "𝕞",
            mp: "∓",
            Mscr: "ℳ",
            mscr: "𝓂",
            mstpos: "∾",
            Mu: "Μ",
            mu: "μ",
            multimap: "⊸",
            mumap: "⊸",
            nabla: "∇",
            Nacute: "Ń",
            nacute: "ń",
            nang: "∠⃒",
            nap: "≉",
            napE: "⩰̸",
            napid: "≋̸",
            napos: "ŉ",
            napprox: "≉",
            natur: "♮",
            natural: "♮",
            naturals: "ℕ",
            nbsp: " ",
            nbump: "≎̸",
            nbumpe: "≏̸",
            ncap: "⩃",
            Ncaron: "Ň",
            ncaron: "ň",
            Ncedil: "Ņ",
            ncedil: "ņ",
            ncong: "≇",
            ncongdot: "⩭̸",
            ncup: "⩂",
            Ncy: "Н",
            ncy: "н",
            ndash: "–",
            ne: "≠",
            nearhk: "⤤",
            neArr: "⇗",
            nearr: "↗",
            nearrow: "↗",
            nedot: "≐̸",
            NegativeMediumSpace: "​",
            NegativeThickSpace: "​",
            NegativeThinSpace: "​",
            NegativeVeryThinSpace: "​",
            nequiv: "≢",
            nesear: "⤨",
            nesim: "≂̸",
            NestedGreaterGreater: "≫",
            NestedLessLess: "≪",
            NewLine: "\n",
            nexist: "∄",
            nexists: "∄",
            Nfr: "𝔑",
            nfr: "𝔫",
            ngE: "≧̸",
            nge: "≱",
            ngeq: "≱",
            ngeqq: "≧̸",
            ngeqslant: "⩾̸",
            nges: "⩾̸",
            nGg: "⋙̸",
            ngsim: "≵",
            nGt: "≫⃒",
            ngt: "≯",
            ngtr: "≯",
            nGtv: "≫̸",
            nhArr: "⇎",
            nharr: "↮",
            nhpar: "⫲",
            ni: "∋",
            nis: "⋼",
            nisd: "⋺",
            niv: "∋",
            NJcy: "Њ",
            njcy: "њ",
            nlArr: "⇍",
            nlarr: "↚",
            nldr: "‥",
            nlE: "≦̸",
            nle: "≰",
            nLeftarrow: "⇍",
            nleftarrow: "↚",
            nLeftrightarrow: "⇎",
            nleftrightarrow: "↮",
            nleq: "≰",
            nleqq: "≦̸",
            nleqslant: "⩽̸",
            nles: "⩽̸",
            nless: "≮",
            nLl: "⋘̸",
            nlsim: "≴",
            nLt: "≪⃒",
            nlt: "≮",
            nltri: "⋪",
            nltrie: "⋬",
            nLtv: "≪̸",
            nmid: "∤",
            NoBreak: "⁠",
            NonBreakingSpace: " ",
            Nopf: "ℕ",
            nopf: "𝕟",
            Not: "⫬",
            not: "¬",
            NotCongruent: "≢",
            NotCupCap: "≭",
            NotDoubleVerticalBar: "∦",
            NotElement: "∉",
            NotEqual: "≠",
            NotEqualTilde: "≂̸",
            NotExists: "∄",
            NotGreater: "≯",
            NotGreaterEqual: "≱",
            NotGreaterFullEqual: "≧̸",
            NotGreaterGreater: "≫̸",
            NotGreaterLess: "≹",
            NotGreaterSlantEqual: "⩾̸",
            NotGreaterTilde: "≵",
            NotHumpDownHump: "≎̸",
            NotHumpEqual: "≏̸",
            notin: "∉",
            notindot: "⋵̸",
            notinE: "⋹̸",
            notinva: "∉",
            notinvb: "⋷",
            notinvc: "⋶",
            NotLeftTriangle: "⋪",
            NotLeftTriangleBar: "⧏̸",
            NotLeftTriangleEqual: "⋬",
            NotLess: "≮",
            NotLessEqual: "≰",
            NotLessGreater: "≸",
            NotLessLess: "≪̸",
            NotLessSlantEqual: "⩽̸",
            NotLessTilde: "≴",
            NotNestedGreaterGreater: "⪢̸",
            NotNestedLessLess: "⪡̸",
            notni: "∌",
            notniva: "∌",
            notnivb: "⋾",
            notnivc: "⋽",
            NotPrecedes: "⊀",
            NotPrecedesEqual: "⪯̸",
            NotPrecedesSlantEqual: "⋠",
            NotReverseElement: "∌",
            NotRightTriangle: "⋫",
            NotRightTriangleBar: "⧐̸",
            NotRightTriangleEqual: "⋭",
            NotSquareSubset: "⊏̸",
            NotSquareSubsetEqual: "⋢",
            NotSquareSuperset: "⊐̸",
            NotSquareSupersetEqual: "⋣",
            NotSubset: "⊂⃒",
            NotSubsetEqual: "⊈",
            NotSucceeds: "⊁",
            NotSucceedsEqual: "⪰̸",
            NotSucceedsSlantEqual: "⋡",
            NotSucceedsTilde: "≿̸",
            NotSuperset: "⊃⃒",
            NotSupersetEqual: "⊉",
            NotTilde: "≁",
            NotTildeEqual: "≄",
            NotTildeFullEqual: "≇",
            NotTildeTilde: "≉",
            NotVerticalBar: "∤",
            npar: "∦",
            nparallel: "∦",
            nparsl: "⫽⃥",
            npart: "∂̸",
            npolint: "⨔",
            npr: "⊀",
            nprcue: "⋠",
            npre: "⪯̸",
            nprec: "⊀",
            npreceq: "⪯̸",
            nrArr: "⇏",
            nrarr: "↛",
            nrarrc: "⤳̸",
            nrarrw: "↝̸",
            nRightarrow: "⇏",
            nrightarrow: "↛",
            nrtri: "⋫",
            nrtrie: "⋭",
            nsc: "⊁",
            nsccue: "⋡",
            nsce: "⪰̸",
            Nscr: "𝒩",
            nscr: "𝓃",
            nshortmid: "∤",
            nshortparallel: "∦",
            nsim: "≁",
            nsime: "≄",
            nsimeq: "≄",
            nsmid: "∤",
            nspar: "∦",
            nsqsube: "⋢",
            nsqsupe: "⋣",
            nsub: "⊄",
            nsubE: "⫅̸",
            nsube: "⊈",
            nsubset: "⊂⃒",
            nsubseteq: "⊈",
            nsubseteqq: "⫅̸",
            nsucc: "⊁",
            nsucceq: "⪰̸",
            nsup: "⊅",
            nsupE: "⫆̸",
            nsupe: "⊉",
            nsupset: "⊃⃒",
            nsupseteq: "⊉",
            nsupseteqq: "⫆̸",
            ntgl: "≹",
            Ntilde: "Ñ",
            ntilde: "ñ",
            ntlg: "≸",
            ntriangleleft: "⋪",
            ntrianglelefteq: "⋬",
            ntriangleright: "⋫",
            ntrianglerighteq: "⋭",
            Nu: "Ν",
            nu: "ν",
            num: "#",
            numero: "№",
            numsp: " ",
            nvap: "≍⃒",
            nVDash: "⊯",
            nVdash: "⊮",
            nvDash: "⊭",
            nvdash: "⊬",
            nvge: "≥⃒",
            nvgt: ">⃒",
            nvHarr: "⤄",
            nvinfin: "⧞",
            nvlArr: "⤂",
            nvle: "≤⃒",
            nvlt: "<⃒",
            nvltrie: "⊴⃒",
            nvrArr: "⤃",
            nvrtrie: "⊵⃒",
            nvsim: "∼⃒",
            nwarhk: "⤣",
            nwArr: "⇖",
            nwarr: "↖",
            nwarrow: "↖",
            nwnear: "⤧",
            Oacute: "Ó",
            oacute: "ó",
            oast: "⊛",
            ocir: "⊚",
            Ocirc: "Ô",
            ocirc: "ô",
            Ocy: "О",
            ocy: "о",
            odash: "⊝",
            Odblac: "Ő",
            odblac: "ő",
            odiv: "⨸",
            odot: "⊙",
            odsold: "⦼",
            OElig: "Œ",
            oelig: "œ",
            ofcir: "⦿",
            Ofr: "𝔒",
            ofr: "𝔬",
            ogon: "˛",
            Ograve: "Ò",
            ograve: "ò",
            ogt: "⧁",
            ohbar: "⦵",
            ohm: "Ω",
            oint: "∮",
            olarr: "↺",
            olcir: "⦾",
            olcross: "⦻",
            oline: "‾",
            olt: "⧀",
            Omacr: "Ō",
            omacr: "ō",
            Omega: "Ω",
            omega: "ω",
            Omicron: "Ο",
            omicron: "ο",
            omid: "⦶",
            ominus: "⊖",
            Oopf: "𝕆",
            oopf: "𝕠",
            opar: "⦷",
            OpenCurlyDoubleQuote: "“",
            OpenCurlyQuote: "‘",
            operp: "⦹",
            oplus: "⊕",
            Or: "⩔",
            or: "∨",
            orarr: "↻",
            ord: "⩝",
            order: "ℴ",
            orderof: "ℴ",
            ordf: "ª",
            ordm: "º",
            origof: "⊶",
            oror: "⩖",
            orslope: "⩗",
            orv: "⩛",
            oS: "Ⓢ",
            Oscr: "𝒪",
            oscr: "ℴ",
            Oslash: "Ø",
            oslash: "ø",
            osol: "⊘",
            Otilde: "Õ",
            otilde: "õ",
            Otimes: "⨷",
            otimes: "⊗",
            otimesas: "⨶",
            Ouml: "Ö",
            ouml: "ö",
            ovbar: "⌽",
            OverBar: "‾",
            OverBrace: "⏞",
            OverBracket: "⎴",
            OverParenthesis: "⏜",
            par: "∥",
            para: "¶",
            parallel: "∥",
            parsim: "⫳",
            parsl: "⫽",
            part: "∂",
            PartialD: "∂",
            Pcy: "П",
            pcy: "п",
            percnt: "%",
            period: ".",
            permil: "‰",
            perp: "⊥",
            pertenk: "‱",
            Pfr: "𝔓",
            pfr: "𝔭",
            Phi: "Φ",
            phi: "φ",
            phiv: "ϕ",
            phmmat: "ℳ",
            phone: "☎",
            Pi: "Π",
            pi: "π",
            pitchfork: "⋔",
            piv: "ϖ",
            planck: "ℏ",
            planckh: "ℎ",
            plankv: "ℏ",
            plus: "+",
            plusacir: "⨣",
            plusb: "⊞",
            pluscir: "⨢",
            plusdo: "∔",
            plusdu: "⨥",
            pluse: "⩲",
            PlusMinus: "±",
            plusmn: "±",
            plussim: "⨦",
            plustwo: "⨧",
            pm: "±",
            Poincareplane: "ℌ",
            pointint: "⨕",
            Popf: "ℙ",
            popf: "𝕡",
            pound: "£",
            Pr: "⪻",
            pr: "≺",
            prap: "⪷",
            prcue: "≼",
            prE: "⪳",
            pre: "⪯",
            prec: "≺",
            precapprox: "⪷",
            preccurlyeq: "≼",
            Precedes: "≺",
            PrecedesEqual: "⪯",
            PrecedesSlantEqual: "≼",
            PrecedesTilde: "≾",
            preceq: "⪯",
            precnapprox: "⪹",
            precneqq: "⪵",
            precnsim: "⋨",
            precsim: "≾",
            Prime: "″",
            prime: "′",
            primes: "ℙ",
            prnap: "⪹",
            prnE: "⪵",
            prnsim: "⋨",
            prod: "∏",
            Product: "∏",
            profalar: "⌮",
            profline: "⌒",
            profsurf: "⌓",
            prop: "∝",
            Proportion: "∷",
            Proportional: "∝",
            propto: "∝",
            prsim: "≾",
            prurel: "⊰",
            Pscr: "𝒫",
            pscr: "𝓅",
            Psi: "Ψ",
            psi: "ψ",
            puncsp: " ",
            Qfr: "𝔔",
            qfr: "𝔮",
            qint: "⨌",
            Qopf: "ℚ",
            qopf: "𝕢",
            qprime: "⁗",
            Qscr: "𝒬",
            qscr: "𝓆",
            quaternions: "ℍ",
            quatint: "⨖",
            quest: "?",
            questeq: "≟",
            QUOT: '"',
            quot: '"',
            rAarr: "⇛",
            race: "∽̱",
            Racute: "Ŕ",
            racute: "ŕ",
            radic: "√",
            raemptyv: "⦳",
            Rang: "⟫",
            rang: "⟩",
            rangd: "⦒",
            range: "⦥",
            rangle: "⟩",
            raquo: "»",
            Rarr: "↠",
            rArr: "⇒",
            rarr: "→",
            rarrap: "⥵",
            rarrb: "⇥",
            rarrbfs: "⤠",
            rarrc: "⤳",
            rarrfs: "⤞",
            rarrhk: "↪",
            rarrlp: "↬",
            rarrpl: "⥅",
            rarrsim: "⥴",
            Rarrtl: "⤖",
            rarrtl: "↣",
            rarrw: "↝",
            rAtail: "⤜",
            ratail: "⤚",
            ratio: "∶",
            rationals: "ℚ",
            RBarr: "⤐",
            rBarr: "⤏",
            rbarr: "⤍",
            rbbrk: "❳",
            rbrace: "}",
            rbrack: "]",
            rbrke: "⦌",
            rbrksld: "⦎",
            rbrkslu: "⦐",
            Rcaron: "Ř",
            rcaron: "ř",
            Rcedil: "Ŗ",
            rcedil: "ŗ",
            rceil: "⌉",
            rcub: "}",
            Rcy: "Р",
            rcy: "р",
            rdca: "⤷",
            rdldhar: "⥩",
            rdquo: "”",
            rdquor: "”",
            rdsh: "↳",
            Re: "ℜ",
            real: "ℜ",
            realine: "ℛ",
            realpart: "ℜ",
            reals: "ℝ",
            rect: "▭",
            REG: "®",
            reg: "®",
            ReverseElement: "∋",
            ReverseEquilibrium: "⇋",
            ReverseUpEquilibrium: "⥯",
            rfisht: "⥽",
            rfloor: "⌋",
            Rfr: "ℜ",
            rfr: "𝔯",
            rHar: "⥤",
            rhard: "⇁",
            rharu: "⇀",
            rharul: "⥬",
            Rho: "Ρ",
            rho: "ρ",
            rhov: "ϱ",
            RightAngleBracket: "⟩",
            RightArrow: "→",
            Rightarrow: "⇒",
            rightarrow: "→",
            RightArrowBar: "⇥",
            RightArrowLeftArrow: "⇄",
            rightarrowtail: "↣",
            RightCeiling: "⌉",
            RightDoubleBracket: "⟧",
            RightDownTeeVector: "⥝",
            RightDownVector: "⇂",
            RightDownVectorBar: "⥕",
            RightFloor: "⌋",
            rightharpoondown: "⇁",
            rightharpoonup: "⇀",
            rightleftarrows: "⇄",
            rightleftharpoons: "⇌",
            rightrightarrows: "⇉",
            rightsquigarrow: "↝",
            RightTee: "⊢",
            RightTeeArrow: "↦",
            RightTeeVector: "⥛",
            rightthreetimes: "⋌",
            RightTriangle: "⊳",
            RightTriangleBar: "⧐",
            RightTriangleEqual: "⊵",
            RightUpDownVector: "⥏",
            RightUpTeeVector: "⥜",
            RightUpVector: "↾",
            RightUpVectorBar: "⥔",
            RightVector: "⇀",
            RightVectorBar: "⥓",
            ring: "˚",
            risingdotseq: "≓",
            rlarr: "⇄",
            rlhar: "⇌",
            rlm: "‏",
            rmoust: "⎱",
            rmoustache: "⎱",
            rnmid: "⫮",
            roang: "⟭",
            roarr: "⇾",
            robrk: "⟧",
            ropar: "⦆",
            Ropf: "ℝ",
            ropf: "𝕣",
            roplus: "⨮",
            rotimes: "⨵",
            RoundImplies: "⥰",
            rpar: ")",
            rpargt: "⦔",
            rppolint: "⨒",
            rrarr: "⇉",
            Rrightarrow: "⇛",
            rsaquo: "›",
            Rscr: "ℛ",
            rscr: "𝓇",
            Rsh: "↱",
            rsh: "↱",
            rsqb: "]",
            rsquo: "’",
            rsquor: "’",
            rthree: "⋌",
            rtimes: "⋊",
            rtri: "▹",
            rtrie: "⊵",
            rtrif: "▸",
            rtriltri: "⧎",
            RuleDelayed: "⧴",
            ruluhar: "⥨",
            rx: "℞",
            Sacute: "Ś",
            sacute: "ś",
            sbquo: "‚",
            Sc: "⪼",
            sc: "≻",
            scap: "⪸",
            Scaron: "Š",
            scaron: "š",
            sccue: "≽",
            scE: "⪴",
            sce: "⪰",
            Scedil: "Ş",
            scedil: "ş",
            Scirc: "Ŝ",
            scirc: "ŝ",
            scnap: "⪺",
            scnE: "⪶",
            scnsim: "⋩",
            scpolint: "⨓",
            scsim: "≿",
            Scy: "С",
            scy: "с",
            sdot: "⋅",
            sdotb: "⊡",
            sdote: "⩦",
            searhk: "⤥",
            seArr: "⇘",
            searr: "↘",
            searrow: "↘",
            sect: "§",
            semi: ";",
            seswar: "⤩",
            setminus: "∖",
            setmn: "∖",
            sext: "✶",
            Sfr: "𝔖",
            sfr: "𝔰",
            sfrown: "⌢",
            sharp: "♯",
            SHCHcy: "Щ",
            shchcy: "щ",
            SHcy: "Ш",
            shcy: "ш",
            ShortDownArrow: "↓",
            ShortLeftArrow: "←",
            shortmid: "∣",
            shortparallel: "∥",
            ShortRightArrow: "→",
            ShortUpArrow: "↑",
            shy: "­",
            Sigma: "Σ",
            sigma: "σ",
            sigmaf: "ς",
            sigmav: "ς",
            sim: "∼",
            simdot: "⩪",
            sime: "≃",
            simeq: "≃",
            simg: "⪞",
            simgE: "⪠",
            siml: "⪝",
            simlE: "⪟",
            simne: "≆",
            simplus: "⨤",
            simrarr: "⥲",
            slarr: "←",
            SmallCircle: "∘",
            smallsetminus: "∖",
            smashp: "⨳",
            smeparsl: "⧤",
            smid: "∣",
            smile: "⌣",
            smt: "⪪",
            smte: "⪬",
            smtes: "⪬︀",
            SOFTcy: "Ь",
            softcy: "ь",
            sol: "/",
            solb: "⧄",
            solbar: "⌿",
            Sopf: "𝕊",
            sopf: "𝕤",
            spades: "♠",
            spadesuit: "♠",
            spar: "∥",
            sqcap: "⊓",
            sqcaps: "⊓︀",
            sqcup: "⊔",
            sqcups: "⊔︀",
            Sqrt: "√",
            sqsub: "⊏",
            sqsube: "⊑",
            sqsubset: "⊏",
            sqsubseteq: "⊑",
            sqsup: "⊐",
            sqsupe: "⊒",
            sqsupset: "⊐",
            sqsupseteq: "⊒",
            squ: "□",
            Square: "□",
            square: "□",
            SquareIntersection: "⊓",
            SquareSubset: "⊏",
            SquareSubsetEqual: "⊑",
            SquareSuperset: "⊐",
            SquareSupersetEqual: "⊒",
            SquareUnion: "⊔",
            squarf: "▪",
            squf: "▪",
            srarr: "→",
            Sscr: "𝒮",
            sscr: "𝓈",
            ssetmn: "∖",
            ssmile: "⌣",
            sstarf: "⋆",
            Star: "⋆",
            star: "☆",
            starf: "★",
            straightepsilon: "ϵ",
            straightphi: "ϕ",
            strns: "¯",
            Sub: "⋐",
            sub: "⊂",
            subdot: "⪽",
            subE: "⫅",
            sube: "⊆",
            subedot: "⫃",
            submult: "⫁",
            subnE: "⫋",
            subne: "⊊",
            subplus: "⪿",
            subrarr: "⥹",
            Subset: "⋐",
            subset: "⊂",
            subseteq: "⊆",
            subseteqq: "⫅",
            SubsetEqual: "⊆",
            subsetneq: "⊊",
            subsetneqq: "⫋",
            subsim: "⫇",
            subsub: "⫕",
            subsup: "⫓",
            succ: "≻",
            succapprox: "⪸",
            succcurlyeq: "≽",
            Succeeds: "≻",
            SucceedsEqual: "⪰",
            SucceedsSlantEqual: "≽",
            SucceedsTilde: "≿",
            succeq: "⪰",
            succnapprox: "⪺",
            succneqq: "⪶",
            succnsim: "⋩",
            succsim: "≿",
            SuchThat: "∋",
            Sum: "∑",
            sum: "∑",
            sung: "♪",
            Sup: "⋑",
            sup: "⊃",
            sup1: "¹",
            sup2: "²",
            sup3: "³",
            supdot: "⪾",
            supdsub: "⫘",
            supE: "⫆",
            supe: "⊇",
            supedot: "⫄",
            Superset: "⊃",
            SupersetEqual: "⊇",
            suphsol: "⟉",
            suphsub: "⫗",
            suplarr: "⥻",
            supmult: "⫂",
            supnE: "⫌",
            supne: "⊋",
            supplus: "⫀",
            Supset: "⋑",
            supset: "⊃",
            supseteq: "⊇",
            supseteqq: "⫆",
            supsetneq: "⊋",
            supsetneqq: "⫌",
            supsim: "⫈",
            supsub: "⫔",
            supsup: "⫖",
            swarhk: "⤦",
            swArr: "⇙",
            swarr: "↙",
            swarrow: "↙",
            swnwar: "⤪",
            szlig: "ß",
            Tab: "\t",
            target: "⌖",
            Tau: "Τ",
            tau: "τ",
            tbrk: "⎴",
            Tcaron: "Ť",
            tcaron: "ť",
            Tcedil: "Ţ",
            tcedil: "ţ",
            Tcy: "Т",
            tcy: "т",
            tdot: "⃛",
            telrec: "⌕",
            Tfr: "𝔗",
            tfr: "𝔱",
            there4: "∴",
            Therefore: "∴",
            therefore: "∴",
            Theta: "Θ",
            theta: "θ",
            thetasym: "ϑ",
            thetav: "ϑ",
            thickapprox: "≈",
            thicksim: "∼",
            ThickSpace: "  ",
            thinsp: " ",
            ThinSpace: " ",
            thkap: "≈",
            thksim: "∼",
            THORN: "Þ",
            thorn: "þ",
            Tilde: "∼",
            tilde: "˜",
            TildeEqual: "≃",
            TildeFullEqual: "≅",
            TildeTilde: "≈",
            times: "×",
            timesb: "⊠",
            timesbar: "⨱",
            timesd: "⨰",
            tint: "∭",
            toea: "⤨",
            top: "⊤",
            topbot: "⌶",
            topcir: "⫱",
            Topf: "𝕋",
            topf: "𝕥",
            topfork: "⫚",
            tosa: "⤩",
            tprime: "‴",
            TRADE: "™",
            trade: "™",
            triangle: "▵",
            triangledown: "▿",
            triangleleft: "◃",
            trianglelefteq: "⊴",
            triangleq: "≜",
            triangleright: "▹",
            trianglerighteq: "⊵",
            tridot: "◬",
            trie: "≜",
            triminus: "⨺",
            TripleDot: "⃛",
            triplus: "⨹",
            trisb: "⧍",
            tritime: "⨻",
            trpezium: "⏢",
            Tscr: "𝒯",
            tscr: "𝓉",
            TScy: "Ц",
            tscy: "ц",
            TSHcy: "Ћ",
            tshcy: "ћ",
            Tstrok: "Ŧ",
            tstrok: "ŧ",
            twixt: "≬",
            twoheadleftarrow: "↞",
            twoheadrightarrow: "↠",
            Uacute: "Ú",
            uacute: "ú",
            Uarr: "↟",
            uArr: "⇑",
            uarr: "↑",
            Uarrocir: "⥉",
            Ubrcy: "Ў",
            ubrcy: "ў",
            Ubreve: "Ŭ",
            ubreve: "ŭ",
            Ucirc: "Û",
            ucirc: "û",
            Ucy: "У",
            ucy: "у",
            udarr: "⇅",
            Udblac: "Ű",
            udblac: "ű",
            udhar: "⥮",
            ufisht: "⥾",
            Ufr: "𝔘",
            ufr: "𝔲",
            Ugrave: "Ù",
            ugrave: "ù",
            uHar: "⥣",
            uharl: "↿",
            uharr: "↾",
            uhblk: "▀",
            ulcorn: "⌜",
            ulcorner: "⌜",
            ulcrop: "⌏",
            ultri: "◸",
            Umacr: "Ū",
            umacr: "ū",
            uml: "¨",
            UnderBar: "_",
            UnderBrace: "⏟",
            UnderBracket: "⎵",
            UnderParenthesis: "⏝",
            Union: "⋃",
            UnionPlus: "⊎",
            Uogon: "Ų",
            uogon: "ų",
            Uopf: "𝕌",
            uopf: "𝕦",
            UpArrow: "↑",
            Uparrow: "⇑",
            uparrow: "↑",
            UpArrowBar: "⤒",
            UpArrowDownArrow: "⇅",
            UpDownArrow: "↕",
            Updownarrow: "⇕",
            updownarrow: "↕",
            UpEquilibrium: "⥮",
            upharpoonleft: "↿",
            upharpoonright: "↾",
            uplus: "⊎",
            UpperLeftArrow: "↖",
            UpperRightArrow: "↗",
            Upsi: "ϒ",
            upsi: "υ",
            upsih: "ϒ",
            Upsilon: "Υ",
            upsilon: "υ",
            UpTee: "⊥",
            UpTeeArrow: "↥",
            upuparrows: "⇈",
            urcorn: "⌝",
            urcorner: "⌝",
            urcrop: "⌎",
            Uring: "Ů",
            uring: "ů",
            urtri: "◹",
            Uscr: "𝒰",
            uscr: "𝓊",
            utdot: "⋰",
            Utilde: "Ũ",
            utilde: "ũ",
            utri: "▵",
            utrif: "▴",
            uuarr: "⇈",
            Uuml: "Ü",
            uuml: "ü",
            uwangle: "⦧",
            vangrt: "⦜",
            varepsilon: "ϵ",
            varkappa: "ϰ",
            varnothing: "∅",
            varphi: "ϕ",
            varpi: "ϖ",
            varpropto: "∝",
            vArr: "⇕",
            varr: "↕",
            varrho: "ϱ",
            varsigma: "ς",
            varsubsetneq: "⊊︀",
            varsubsetneqq: "⫋︀",
            varsupsetneq: "⊋︀",
            varsupsetneqq: "⫌︀",
            vartheta: "ϑ",
            vartriangleleft: "⊲",
            vartriangleright: "⊳",
            Vbar: "⫫",
            vBar: "⫨",
            vBarv: "⫩",
            Vcy: "В",
            vcy: "в",
            VDash: "⊫",
            Vdash: "⊩",
            vDash: "⊨",
            vdash: "⊢",
            Vdashl: "⫦",
            Vee: "⋁",
            vee: "∨",
            veebar: "⊻",
            veeeq: "≚",
            vellip: "⋮",
            Verbar: "‖",
            verbar: "|",
            Vert: "‖",
            vert: "|",
            VerticalBar: "∣",
            VerticalLine: "|",
            VerticalSeparator: "❘",
            VerticalTilde: "≀",
            VeryThinSpace: " ",
            Vfr: "𝔙",
            vfr: "𝔳",
            vltri: "⊲",
            vnsub: "⊂⃒",
            vnsup: "⊃⃒",
            Vopf: "𝕍",
            vopf: "𝕧",
            vprop: "∝",
            vrtri: "⊳",
            Vscr: "𝒱",
            vscr: "𝓋",
            vsubnE: "⫋︀",
            vsubne: "⊊︀",
            vsupnE: "⫌︀",
            vsupne: "⊋︀",
            Vvdash: "⊪",
            vzigzag: "⦚",
            Wcirc: "Ŵ",
            wcirc: "ŵ",
            wedbar: "⩟",
            Wedge: "⋀",
            wedge: "∧",
            wedgeq: "≙",
            weierp: "℘",
            Wfr: "𝔚",
            wfr: "𝔴",
            Wopf: "𝕎",
            wopf: "𝕨",
            wp: "℘",
            wr: "≀",
            wreath: "≀",
            Wscr: "𝒲",
            wscr: "𝓌",
            xcap: "⋂",
            xcirc: "◯",
            xcup: "⋃",
            xdtri: "▽",
            Xfr: "𝔛",
            xfr: "𝔵",
            xhArr: "⟺",
            xharr: "⟷",
            Xi: "Ξ",
            xi: "ξ",
            xlArr: "⟸",
            xlarr: "⟵",
            xmap: "⟼",
            xnis: "⋻",
            xodot: "⨀",
            Xopf: "𝕏",
            xopf: "𝕩",
            xoplus: "⨁",
            xotime: "⨂",
            xrArr: "⟹",
            xrarr: "⟶",
            Xscr: "𝒳",
            xscr: "𝓍",
            xsqcup: "⨆",
            xuplus: "⨄",
            xutri: "△",
            xvee: "⋁",
            xwedge: "⋀",
            Yacute: "Ý",
            yacute: "ý",
            YAcy: "Я",
            yacy: "я",
            Ycirc: "Ŷ",
            ycirc: "ŷ",
            Ycy: "Ы",
            ycy: "ы",
            yen: "¥",
            Yfr: "𝔜",
            yfr: "𝔶",
            YIcy: "Ї",
            yicy: "ї",
            Yopf: "𝕐",
            yopf: "𝕪",
            Yscr: "𝒴",
            yscr: "𝓎",
            YUcy: "Ю",
            yucy: "ю",
            Yuml: "Ÿ",
            yuml: "ÿ",
            Zacute: "Ź",
            zacute: "ź",
            Zcaron: "Ž",
            zcaron: "ž",
            Zcy: "З",
            zcy: "з",
            Zdot: "Ż",
            zdot: "ż",
            zeetrf: "ℨ",
            ZeroWidthSpace: "​",
            Zeta: "Ζ",
            zeta: "ζ",
            Zfr: "ℨ",
            zfr: "𝔷",
            ZHcy: "Ж",
            zhcy: "ж",
            zigrarr: "⇝",
            Zopf: "ℤ",
            zopf: "𝕫",
            Zscr: "𝒵",
            zscr: "𝓏",
            zwj: "‍",
            zwnj: "‌"
          }), e.entityMap = e.HTML_ENTITIES;
        },
        7937: function _(t, e, i) {
          var s = i(1129);
          s.DOMImplementation, s.XMLSerializer, e.DOMParser = i(8633).DOMParser;
        },
        2133: function _(t, e, i) {
          var s = i(525).NAMESPACE,
            n = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
            r = new RegExp("[\\-\\.0-9" + n.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"),
            a = new RegExp("^" + n.source + r.source + "*(?::" + n.source + r.source + "*)?$");
          function o(t, e) {
            this.message = t, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, o);
          }
          function d() {}
          function c(t, e) {
            return e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber, e;
          }
          function u(t, e, i, n, r, a) {
            function o(t, e, s) {
              i.attributeNames.hasOwnProperty(t) && a.fatalError("Attribute " + t + " redefined"), i.addValue(t, e, s);
            }
            for (var d, c = ++e, u = 0;;) {
              var l = t.charAt(c);
              switch (l) {
                case "=":
                  if (1 === u) d = t.slice(e, c), u = 3;else {
                    if (2 !== u) throw new Error("attribute equal must after attrName");
                    u = 3;
                  }
                  break;
                case "'":
                case '"':
                  if (3 === u || 1 === u) {
                    if (1 === u && (a.warning('attribute value must after "="'), d = t.slice(e, c)), e = c + 1, !((c = t.indexOf(l, e)) > 0)) throw new Error("attribute value no end '" + l + "' match");
                    o(d, h = t.slice(e, c).replace(/&#?\w+;/g, r), e - 1), u = 5;
                  } else {
                    if (4 != u) throw new Error('attribute value must after "="');
                    o(d, h = t.slice(e, c).replace(/&#?\w+;/g, r), e), a.warning('attribute "' + d + '" missed start quot(' + l + ")!!"), e = c + 1, u = 5;
                  }
                  break;
                case "/":
                  switch (u) {
                    case 0:
                      i.setTagName(t.slice(e, c));
                    case 5:
                    case 6:
                    case 7:
                      u = 7, i.closed = !0;
                    case 4:
                    case 1:
                      break;
                    case 2:
                      i.closed = !0;
                      break;
                    default:
                      throw new Error("attribute invalid close char('/')");
                  }
                  break;
                case "":
                  return a.error("unexpected end of input"), 0 == u && i.setTagName(t.slice(e, c)), c;
                case ">":
                  switch (u) {
                    case 0:
                      i.setTagName(t.slice(e, c));
                    case 5:
                    case 6:
                    case 7:
                      break;
                    case 4:
                    case 1:
                      "/" === (h = t.slice(e, c)).slice(-1) && (i.closed = !0, h = h.slice(0, -1));
                    case 2:
                      2 === u && (h = d), 4 == u ? (a.warning('attribute "' + h + '" missed quot(")!'), o(d, h.replace(/&#?\w+;/g, r), e)) : (s.isHTML(n[""]) && h.match(/^(?:disabled|checked|selected)$/i) || a.warning('attribute "' + h + '" missed value!! "' + h + '" instead!!'), o(h, h, e));
                      break;
                    case 3:
                      throw new Error("attribute value missed!!");
                  }
                  return c;
                case "":
                  l = " ";
                default:
                  if (l <= " ") switch (u) {
                    case 0:
                      i.setTagName(t.slice(e, c)), u = 6;
                      break;
                    case 1:
                      d = t.slice(e, c), u = 2;
                      break;
                    case 4:
                      var h = t.slice(e, c).replace(/&#?\w+;/g, r);
                      a.warning('attribute "' + h + '" missed quot(")!!'), o(d, h, e);
                    case 5:
                      u = 6;
                  } else switch (u) {
                    case 2:
                      i.tagName, s.isHTML(n[""]) && d.match(/^(?:disabled|checked|selected)$/i) || a.warning('attribute "' + d + '" missed value!! "' + d + '" instead2!!'), o(d, d, e), e = c, u = 1;
                      break;
                    case 5:
                      a.warning('attribute space is required"' + d + '"!!');
                    case 6:
                      u = 1, e = c;
                      break;
                    case 3:
                      u = 4, e = c;
                      break;
                    case 7:
                      throw new Error("elements closed character '/' and '>' must be connected to");
                  }
              }
              c++;
            }
          }
          function l(t, e, i) {
            for (var n = t.tagName, r = null, a = t.length; a--;) {
              var o = t[a],
                d = o.qName,
                c = o.value;
              if ((p = d.indexOf(":")) > 0) var u = o.prefix = d.slice(0, p),
                l = d.slice(p + 1),
                h = "xmlns" === u && l;else l = d, u = null, h = "xmlns" === d && "";
              o.localName = l, !1 !== h && (null == r && (r = {}, f(i, i = {})), i[h] = r[h] = c, o.uri = s.XMLNS, e.startPrefixMapping(h, c));
            }
            for (a = t.length; a--;) (u = (o = t[a]).prefix) && ("xml" === u && (o.uri = s.XML), "xmlns" !== u && (o.uri = i[u || ""]));
            var p;
            (p = n.indexOf(":")) > 0 ? (u = t.prefix = n.slice(0, p), l = t.localName = n.slice(p + 1)) : (u = null, l = t.localName = n);
            var g = t.uri = i[u || ""];
            if (e.startElement(g, l, n, t), !t.closed) return t.currentNSMap = i, t.localNSMap = r, !0;
            if (e.endElement(g, l, n), r) for (u in r) Object.prototype.hasOwnProperty.call(r, u) && e.endPrefixMapping(u);
          }
          function h(t, e, i, s, n) {
            if (/^(?:script|textarea)$/i.test(i)) {
              var r = t.indexOf("</" + i + ">", e),
                a = t.substring(e + 1, r);
              if (/[&<]/.test(a)) return /^script$/i.test(i) ? (n.characters(a, 0, a.length), r) : (a = a.replace(/&#?\w+;/g, s), n.characters(a, 0, a.length), r);
            }
            return e + 1;
          }
          function p(t, e, i, s) {
            var n = s[i];
            return null == n && ((n = t.lastIndexOf("</" + i + ">")) < e && (n = t.lastIndexOf("</" + i)), s[i] = n), n < e;
          }
          function f(t, e) {
            for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
          function g(t, e, i, s) {
            if ("-" === t.charAt(e + 2)) return "-" === t.charAt(e + 3) ? (n = t.indexOf("--\x3e", e + 4)) > e ? (i.comment(t, e + 4, n - e - 4), n + 3) : (s.error("Unclosed comment"), -1) : -1;
            if ("CDATA[" == t.substr(e + 3, 6)) {
              var n = t.indexOf("]]>", e + 9);
              return i.startCDATA(), i.characters(t, e + 9, n - e - 9), i.endCDATA(), n + 3;
            }
            var r = function (t, e) {
                var i,
                  s = [],
                  n = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
                for (n.lastIndex = e, n.exec(t); i = n.exec(t);) if (s.push(i), i[1]) return s;
              }(t, e),
              a = r.length;
            if (a > 1 && /!doctype/i.test(r[0][0])) {
              var o = r[1][0],
                d = !1,
                c = !1;
              a > 3 && (/^public$/i.test(r[2][0]) ? (d = r[3][0], c = a > 4 && r[4][0]) : /^system$/i.test(r[2][0]) && (c = r[3][0]));
              var u = r[a - 1];
              return i.startDTD(o, d, c), i.endDTD(), u.index + u[0].length;
            }
            return -1;
          }
          function m(t, e, i) {
            var s = t.indexOf("?>", e);
            if (s) {
              var n = t.substring(e, s).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
              return n ? (n[0].length, i.processingInstruction(n[1], n[2]), s + 2) : -1;
            }
            return -1;
          }
          function v() {
            this.attributeNames = {};
          }
          o.prototype = new Error(), o.prototype.name = o.name, d.prototype = {
            parse: function parse(t, e, i) {
              var n = this.domBuilder;
              n.startDocument(), f(e, e = {}), function (t, e, i, n, r) {
                function a(t) {
                  var e = t.slice(1, -1);
                  return e in i ? i[e] : "#" === e.charAt(0) ? function (t) {
                    if (t > 65535) {
                      var e = 55296 + ((t -= 65536) >> 10),
                        i = 56320 + (1023 & t);
                      return String.fromCharCode(e, i);
                    }
                    return String.fromCharCode(t);
                  }(parseInt(e.substr(1).replace("x", "0x"))) : (r.error("entity not found:" + t), t);
                }
                function d(e) {
                  if (e > w) {
                    var i = t.substring(w, e).replace(/&#?\w+;/g, a);
                    E && f(w), n.characters(i, 0, e - w), w = e;
                  }
                }
                function f(e, i) {
                  for (; e >= T && (i = S.exec(t));) y = i.index, T = y + i[0].length, E.lineNumber++;
                  E.columnNumber = e - y + 1;
                }
                for (var y = 0, T = 0, S = /.*(?:\r\n?|\n)|.*$/g, E = n.locator, b = [{
                    currentNSMap: e
                  }], A = {}, w = 0;;) {
                  try {
                    var _ = t.indexOf("<", w);
                    if (_ < 0) {
                      if (!t.substr(w).match(/^\s*$/)) {
                        var I = n.doc,
                          N = I.createTextNode(t.substr(w));
                        I.appendChild(N), n.currentElement = N;
                      }
                      return;
                    }
                    switch (_ > w && d(_), t.charAt(_ + 1)) {
                      case "/":
                        var P = t.indexOf(">", _ + 3),
                          D = t.substring(_ + 2, P).replace(/[ \t\n\r]+$/g, ""),
                          R = b.pop();
                        P < 0 ? (D = t.substring(_ + 2).replace(/[\s<].*/, ""), r.error("end tag name: " + D + " is not complete:" + R.tagName), P = _ + 1 + D.length) : D.match(/\s</) && (D = D.replace(/[\s<].*/, ""), r.error("end tag name: " + D + " maybe not complete"), P = _ + 1 + D.length);
                        var L = R.localNSMap,
                          C = R.tagName == D;
                        if (C || R.tagName && R.tagName.toLowerCase() == D.toLowerCase()) {
                          if (n.endElement(R.uri, R.localName, D), L) for (var O in L) Object.prototype.hasOwnProperty.call(L, O) && n.endPrefixMapping(O);
                          C || r.fatalError("end tag name: " + D + " is not match the current start tagName:" + R.tagName);
                        } else b.push(R);
                        P++;
                        break;
                      case "?":
                        E && f(_), P = m(t, _, n);
                        break;
                      case "!":
                        E && f(_), P = g(t, _, n, r);
                        break;
                      default:
                        E && f(_);
                        var B = new v(),
                          x = b[b.length - 1].currentNSMap,
                          M = (P = u(t, _, B, x, a, r), B.length);
                        if (!B.closed && p(t, P, B.tagName, A) && (B.closed = !0, i.nbsp || r.warning("unclosed xml attribute")), E && M) {
                          for (var k = c(E, {}), U = 0; U < M; U++) {
                            var V = B[U];
                            f(V.offset), V.locator = c(E, {});
                          }
                          n.locator = k, l(B, n, x) && b.push(B), n.locator = E;
                        } else l(B, n, x) && b.push(B);
                        s.isHTML(B.uri) && !B.closed ? P = h(t, P, B.tagName, a, n) : P++;
                    }
                  } catch (t) {
                    if (t instanceof o) throw t;
                    r.error("element parse error: " + t), P = -1;
                  }
                  P > w ? w = P : d(Math.max(_, w) + 1);
                }
              }(t, e, i, n, this.errorHandler), n.endDocument();
            }
          }, v.prototype = {
            setTagName: function setTagName(t) {
              if (!a.test(t)) throw new Error("invalid tagName:" + t);
              this.tagName = t;
            },
            addValue: function addValue(t, e, i) {
              if (!a.test(t)) throw new Error("invalid attribute:" + t);
              this.attributeNames[t] = this.length, this[this.length++] = {
                qName: t,
                value: e,
                offset: i
              };
            },
            length: 0,
            getLocalName: function getLocalName(t) {
              return this[t].localName;
            },
            getLocator: function getLocator(t) {
              return this[t].locator;
            },
            getQName: function getQName(t) {
              return this[t].qName;
            },
            getURI: function getURI(t) {
              return this[t].uri;
            },
            getValue: function getValue(t) {
              return this[t].value;
            }
          }, e.XMLReader = d, e.ParseError = o;
        },
        7991: function _(t, e) {
          "use strict";

          e.byteLength = function (t) {
            var e = o(t),
              i = e[0],
              s = e[1];
            return 3 * (i + s) / 4 - s;
          }, e.toByteArray = function (t) {
            var e,
              i,
              r = o(t),
              a = r[0],
              d = r[1],
              c = new n(function (t, e, i) {
                return 3 * (e + i) / 4 - i;
              }(0, a, d)),
              u = 0,
              l = d > 0 ? a - 4 : a;
            for (i = 0; i < l; i += 4) e = s[t.charCodeAt(i)] << 18 | s[t.charCodeAt(i + 1)] << 12 | s[t.charCodeAt(i + 2)] << 6 | s[t.charCodeAt(i + 3)], c[u++] = e >> 16 & 255, c[u++] = e >> 8 & 255, c[u++] = 255 & e;
            return 2 === d && (e = s[t.charCodeAt(i)] << 2 | s[t.charCodeAt(i + 1)] >> 4, c[u++] = 255 & e), 1 === d && (e = s[t.charCodeAt(i)] << 10 | s[t.charCodeAt(i + 1)] << 4 | s[t.charCodeAt(i + 2)] >> 2, c[u++] = e >> 8 & 255, c[u++] = 255 & e), c;
          }, e.fromByteArray = function (t) {
            for (var e, s = t.length, n = s % 3, r = [], a = 16383, o = 0, c = s - n; o < c; o += a) r.push(d(t, o, o + a > c ? c : o + a));
            return 1 === n ? (e = t[s - 1], r.push(i[e >> 2] + i[e << 4 & 63] + "==")) : 2 === n && (e = (t[s - 2] << 8) + t[s - 1], r.push(i[e >> 10] + i[e >> 4 & 63] + i[e << 2 & 63] + "=")), r.join("");
          };
          for (var i = [], s = [], n = "undefined" != typeof Uint8Array ? Uint8Array : Array, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0; a < 64; ++a) i[a] = r[a], s[r.charCodeAt(a)] = a;
          function o(t) {
            var e = t.length;
            if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var i = t.indexOf("=");
            return -1 === i && (i = e), [i, i === e ? 0 : 4 - i % 4];
          }
          function d(t, e, s) {
            for (var n, r, a = [], o = e; o < s; o += 3) n = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (255 & t[o + 2]), a.push(i[(r = n) >> 18 & 63] + i[r >> 12 & 63] + i[r >> 6 & 63] + i[63 & r]);
            return a.join("");
          }
          s["-".charCodeAt(0)] = 62, s["_".charCodeAt(0)] = 63;
        },
        1048: function _(t, e, i) {
          "use strict";

          var s = i(7991),
            n = i(9318),
            r = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
          e.hp = d, e.IS = 50;
          var a = 2147483647;
          function o(t) {
            if (t > a) throw new RangeError('The value "' + t + '" is invalid for option "size"');
            var e = new Uint8Array(t);
            return Object.setPrototypeOf(e, d.prototype), e;
          }
          function d(t, e, i) {
            if ("number" == typeof t) {
              if ("string" == typeof e) throw new TypeError('The "string" argument must be of type string. Received type number');
              return l(t);
            }
            return c(t, e, i);
          }
          function c(t, e, i) {
            if ("string" == typeof t) return function (t, e) {
              if ("string" == typeof e && "" !== e || (e = "utf8"), !d.isEncoding(e)) throw new TypeError("Unknown encoding: " + e);
              var i = 0 | g(t, e);
              var s = o(i);
              var n = s.write(t, e);
              return n !== i && (s = s.slice(0, n)), s;
            }(t, e);
            if (ArrayBuffer.isView(t)) return function (t) {
              if (K(t, Uint8Array)) {
                var _e2 = new Uint8Array(t);
                return p(_e2.buffer, _e2.byteOffset, _e2.byteLength);
              }
              return h(t);
            }(t);
            if (null == t) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t);
            if (K(t, ArrayBuffer) || t && K(t.buffer, ArrayBuffer)) return p(t, e, i);
            if ("undefined" != typeof SharedArrayBuffer && (K(t, SharedArrayBuffer) || t && K(t.buffer, SharedArrayBuffer))) return p(t, e, i);
            if ("number" == typeof t) throw new TypeError('The "value" argument must not be of type number. Received type number');
            var s = t.valueOf && t.valueOf();
            if (null != s && s !== t) return d.from(s, e, i);
            var n = function (t) {
              if (d.isBuffer(t)) {
                var _e3 = 0 | f(t.length),
                  _i2 = o(_e3);
                return 0 === _i2.length || t.copy(_i2, 0, 0, _e3), _i2;
              }
              return void 0 !== t.length ? "number" != typeof t.length || Q(t.length) ? o(0) : h(t) : "Buffer" === t.type && Array.isArray(t.data) ? h(t.data) : void 0;
            }(t);
            if (n) return n;
            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t[Symbol.toPrimitive]) return d.from(t[Symbol.toPrimitive]("string"), e, i);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t);
          }
          function u(t) {
            if ("number" != typeof t) throw new TypeError('"size" argument must be of type number');
            if (t < 0) throw new RangeError('The value "' + t + '" is invalid for option "size"');
          }
          function l(t) {
            return u(t), o(t < 0 ? 0 : 0 | f(t));
          }
          function h(t) {
            var e = t.length < 0 ? 0 : 0 | f(t.length),
              i = o(e);
            for (var _s2 = 0; _s2 < e; _s2 += 1) i[_s2] = 255 & t[_s2];
            return i;
          }
          function p(t, e, i) {
            if (e < 0 || t.byteLength < e) throw new RangeError('"offset" is outside of buffer bounds');
            if (t.byteLength < e + (i || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var s;
            return s = void 0 === e && void 0 === i ? new Uint8Array(t) : void 0 === i ? new Uint8Array(t, e) : new Uint8Array(t, e, i), Object.setPrototypeOf(s, d.prototype), s;
          }
          function f(t) {
            if (t >= a) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
            return 0 | t;
          }
          function g(t, e) {
            if (d.isBuffer(t)) return t.length;
            if (ArrayBuffer.isView(t) || K(t, ArrayBuffer)) return t.byteLength;
            if ("string" != typeof t) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof t);
            var i = t.length,
              s = arguments.length > 2 && !0 === arguments[2];
            if (!s && 0 === i) return 0;
            var n = !1;
            for (;;) switch (e) {
              case "ascii":
              case "latin1":
              case "binary":
                return i;
              case "utf8":
              case "utf-8":
                return W(t).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * i;
              case "hex":
                return i >>> 1;
              case "base64":
                return Y(t).length;
              default:
                if (n) return s ? -1 : W(t).length;
                e = ("" + e).toLowerCase(), n = !0;
            }
          }
          function m(t, e, i) {
            var s = !1;
            if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
            if ((void 0 === i || i > this.length) && (i = this.length), i <= 0) return "";
            if ((i >>>= 0) <= (e >>>= 0)) return "";
            for (t || (t = "utf8");;) switch (t) {
              case "hex":
                return R(this, e, i);
              case "utf8":
              case "utf-8":
                return I(this, e, i);
              case "ascii":
                return P(this, e, i);
              case "latin1":
              case "binary":
                return D(this, e, i);
              case "base64":
                return _(this, e, i);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return L(this, e, i);
              default:
                if (s) throw new TypeError("Unknown encoding: " + t);
                t = (t + "").toLowerCase(), s = !0;
            }
          }
          function v(t, e, i) {
            var s = t[e];
            t[e] = t[i], t[i] = s;
          }
          function y(t, e, i, s, n) {
            if (0 === t.length) return -1;
            if ("string" == typeof i ? (s = i, i = 0) : i > 2147483647 ? i = 2147483647 : i < -2147483648 && (i = -2147483648), Q(i = +i) && (i = n ? 0 : t.length - 1), i < 0 && (i = t.length + i), i >= t.length) {
              if (n) return -1;
              i = t.length - 1;
            } else if (i < 0) {
              if (!n) return -1;
              i = 0;
            }
            if ("string" == typeof e && (e = d.from(e, s)), d.isBuffer(e)) return 0 === e.length ? -1 : T(t, e, i, s, n);
            if ("number" == typeof e) return e &= 255, "function" == typeof Uint8Array.prototype.indexOf ? n ? Uint8Array.prototype.indexOf.call(t, e, i) : Uint8Array.prototype.lastIndexOf.call(t, e, i) : T(t, [e], i, s, n);
            throw new TypeError("val must be string, number or Buffer");
          }
          function T(t, e, i, s, n) {
            var r,
              a = 1,
              o = t.length,
              d = e.length;
            if (void 0 !== s && ("ucs2" === (s = String(s).toLowerCase()) || "ucs-2" === s || "utf16le" === s || "utf-16le" === s)) {
              if (t.length < 2 || e.length < 2) return -1;
              a = 2, o /= 2, d /= 2, i /= 2;
            }
            function c(t, e) {
              return 1 === a ? t[e] : t.readUInt16BE(e * a);
            }
            if (n) {
              var _s3 = -1;
              for (r = i; r < o; r++) if (c(t, r) === c(e, -1 === _s3 ? 0 : r - _s3)) {
                if (-1 === _s3 && (_s3 = r), r - _s3 + 1 === d) return _s3 * a;
              } else -1 !== _s3 && (r -= r - _s3), _s3 = -1;
            } else for (i + d > o && (i = o - d), r = i; r >= 0; r--) {
              var _i3 = !0;
              for (var _s4 = 0; _s4 < d; _s4++) if (c(t, r + _s4) !== c(e, _s4)) {
                _i3 = !1;
                break;
              }
              if (_i3) return r;
            }
            return -1;
          }
          function S(t, e, i, s) {
            i = Number(i) || 0;
            var n = t.length - i;
            s ? (s = Number(s)) > n && (s = n) : s = n;
            var r = e.length;
            var a;
            for (s > r / 2 && (s = r / 2), a = 0; a < s; ++a) {
              var _s5 = parseInt(e.substr(2 * a, 2), 16);
              if (Q(_s5)) return a;
              t[i + a] = _s5;
            }
            return a;
          }
          function E(t, e, i, s) {
            return z(W(e, t.length - i), t, i, s);
          }
          function b(t, e, i, s) {
            return z(function (t) {
              var e = [];
              for (var _i4 = 0; _i4 < t.length; ++_i4) e.push(255 & t.charCodeAt(_i4));
              return e;
            }(e), t, i, s);
          }
          function A(t, e, i, s) {
            return z(Y(e), t, i, s);
          }
          function w(t, e, i, s) {
            return z(function (t, e) {
              var i, s, n;
              var r = [];
              for (var _a = 0; _a < t.length && !((e -= 2) < 0); ++_a) i = t.charCodeAt(_a), s = i >> 8, n = i % 256, r.push(n), r.push(s);
              return r;
            }(e, t.length - i), t, i, s);
          }
          function _(t, e, i) {
            return 0 === e && i === t.length ? s.fromByteArray(t) : s.fromByteArray(t.slice(e, i));
          }
          function I(t, e, i) {
            i = Math.min(t.length, i);
            var s = [];
            var n = e;
            for (; n < i;) {
              var _e4 = t[n];
              var _r = null,
                _a2 = _e4 > 239 ? 4 : _e4 > 223 ? 3 : _e4 > 191 ? 2 : 1;
              if (n + _a2 <= i) {
                var _i5 = void 0,
                  _s6 = void 0,
                  _o = void 0,
                  _d = void 0;
                switch (_a2) {
                  case 1:
                    _e4 < 128 && (_r = _e4);
                    break;
                  case 2:
                    _i5 = t[n + 1], 128 == (192 & _i5) && (_d = (31 & _e4) << 6 | 63 & _i5, _d > 127 && (_r = _d));
                    break;
                  case 3:
                    _i5 = t[n + 1], _s6 = t[n + 2], 128 == (192 & _i5) && 128 == (192 & _s6) && (_d = (15 & _e4) << 12 | (63 & _i5) << 6 | 63 & _s6, _d > 2047 && (_d < 55296 || _d > 57343) && (_r = _d));
                    break;
                  case 4:
                    _i5 = t[n + 1], _s6 = t[n + 2], _o = t[n + 3], 128 == (192 & _i5) && 128 == (192 & _s6) && 128 == (192 & _o) && (_d = (15 & _e4) << 18 | (63 & _i5) << 12 | (63 & _s6) << 6 | 63 & _o, _d > 65535 && _d < 1114112 && (_r = _d));
                }
              }
              null === _r ? (_r = 65533, _a2 = 1) : _r > 65535 && (_r -= 65536, s.push(_r >>> 10 & 1023 | 55296), _r = 56320 | 1023 & _r), s.push(_r), n += _a2;
            }
            return function (t) {
              var e = t.length;
              if (e <= N) return String.fromCharCode.apply(String, t);
              var i = "",
                s = 0;
              for (; s < e;) i += String.fromCharCode.apply(String, t.slice(s, s += N));
              return i;
            }(s);
          }
          d.TYPED_ARRAY_SUPPORT = function () {
            try {
              var _t2 = new Uint8Array(1),
                _e5 = {
                  foo: function foo() {
                    return 42;
                  }
                };
              return Object.setPrototypeOf(_e5, Uint8Array.prototype), Object.setPrototypeOf(_t2, _e5), 42 === _t2.foo();
            } catch (t) {
              return !1;
            }
          }(), d.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(d.prototype, "parent", {
            enumerable: !0,
            get: function get() {
              if (d.isBuffer(this)) return this.buffer;
            }
          }), Object.defineProperty(d.prototype, "offset", {
            enumerable: !0,
            get: function get() {
              if (d.isBuffer(this)) return this.byteOffset;
            }
          }), d.poolSize = 8192, d.from = function (t, e, i) {
            return c(t, e, i);
          }, Object.setPrototypeOf(d.prototype, Uint8Array.prototype), Object.setPrototypeOf(d, Uint8Array), d.alloc = function (t, e, i) {
            return function (t, e, i) {
              return u(t), t <= 0 ? o(t) : void 0 !== e ? "string" == typeof i ? o(t).fill(e, i) : o(t).fill(e) : o(t);
            }(t, e, i);
          }, d.allocUnsafe = function (t) {
            return l(t);
          }, d.allocUnsafeSlow = function (t) {
            return l(t);
          }, d.isBuffer = function (t) {
            return null != t && !0 === t._isBuffer && t !== d.prototype;
          }, d.compare = function (t, e) {
            if (K(t, Uint8Array) && (t = d.from(t, t.offset, t.byteLength)), K(e, Uint8Array) && (e = d.from(e, e.offset, e.byteLength)), !d.isBuffer(t) || !d.isBuffer(e)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (t === e) return 0;
            var i = t.length,
              s = e.length;
            for (var _n = 0, _r2 = Math.min(i, s); _n < _r2; ++_n) if (t[_n] !== e[_n]) {
              i = t[_n], s = e[_n];
              break;
            }
            return i < s ? -1 : s < i ? 1 : 0;
          }, d.isEncoding = function (t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, d.concat = function (t, e) {
            if (!Array.isArray(t)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === t.length) return d.alloc(0);
            var i;
            if (void 0 === e) for (e = 0, i = 0; i < t.length; ++i) e += t[i].length;
            var s = d.allocUnsafe(e);
            var n = 0;
            for (i = 0; i < t.length; ++i) {
              var _e6 = t[i];
              if (K(_e6, Uint8Array)) n + _e6.length > s.length ? (d.isBuffer(_e6) || (_e6 = d.from(_e6)), _e6.copy(s, n)) : Uint8Array.prototype.set.call(s, _e6, n);else {
                if (!d.isBuffer(_e6)) throw new TypeError('"list" argument must be an Array of Buffers');
                _e6.copy(s, n);
              }
              n += _e6.length;
            }
            return s;
          }, d.byteLength = g, d.prototype._isBuffer = !0, d.prototype.swap16 = function () {
            var t = this.length;
            if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var _e7 = 0; _e7 < t; _e7 += 2) v(this, _e7, _e7 + 1);
            return this;
          }, d.prototype.swap32 = function () {
            var t = this.length;
            if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var _e8 = 0; _e8 < t; _e8 += 4) v(this, _e8, _e8 + 3), v(this, _e8 + 1, _e8 + 2);
            return this;
          }, d.prototype.swap64 = function () {
            var t = this.length;
            if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var _e9 = 0; _e9 < t; _e9 += 8) v(this, _e9, _e9 + 7), v(this, _e9 + 1, _e9 + 6), v(this, _e9 + 2, _e9 + 5), v(this, _e9 + 3, _e9 + 4);
            return this;
          }, d.prototype.toString = function () {
            var t = this.length;
            return 0 === t ? "" : 0 === arguments.length ? I(this, 0, t) : m.apply(this, arguments);
          }, d.prototype.toLocaleString = d.prototype.toString, d.prototype.equals = function (t) {
            if (!d.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            return this === t || 0 === d.compare(this, t);
          }, d.prototype.inspect = function () {
            var t = "";
            var i = e.IS;
            return t = this.toString("hex", 0, i).replace(/(.{2})/g, "$1 ").trim(), this.length > i && (t += " ... "), "<Buffer " + t + ">";
          }, r && (d.prototype[r] = d.prototype.inspect), d.prototype.compare = function (t, e, i, s, n) {
            if (K(t, Uint8Array) && (t = d.from(t, t.offset, t.byteLength)), !d.isBuffer(t)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof t);
            if (void 0 === e && (e = 0), void 0 === i && (i = t ? t.length : 0), void 0 === s && (s = 0), void 0 === n && (n = this.length), e < 0 || i > t.length || s < 0 || n > this.length) throw new RangeError("out of range index");
            if (s >= n && e >= i) return 0;
            if (s >= n) return -1;
            if (e >= i) return 1;
            if (this === t) return 0;
            var r = (n >>>= 0) - (s >>>= 0),
              a = (i >>>= 0) - (e >>>= 0);
            var o = Math.min(r, a),
              c = this.slice(s, n),
              u = t.slice(e, i);
            for (var _t3 = 0; _t3 < o; ++_t3) if (c[_t3] !== u[_t3]) {
              r = c[_t3], a = u[_t3];
              break;
            }
            return r < a ? -1 : a < r ? 1 : 0;
          }, d.prototype.includes = function (t, e, i) {
            return -1 !== this.indexOf(t, e, i);
          }, d.prototype.indexOf = function (t, e, i) {
            return y(this, t, e, i, !0);
          }, d.prototype.lastIndexOf = function (t, e, i) {
            return y(this, t, e, i, !1);
          }, d.prototype.write = function (t, e, i, s) {
            if (void 0 === e) s = "utf8", i = this.length, e = 0;else if (void 0 === i && "string" == typeof e) s = e, i = this.length, e = 0;else {
              if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              e >>>= 0, isFinite(i) ? (i >>>= 0, void 0 === s && (s = "utf8")) : (s = i, i = void 0);
            }
            var n = this.length - e;
            if ((void 0 === i || i > n) && (i = n), t.length > 0 && (i < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            s || (s = "utf8");
            var r = !1;
            for (;;) switch (s) {
              case "hex":
                return S(this, t, e, i);
              case "utf8":
              case "utf-8":
                return E(this, t, e, i);
              case "ascii":
              case "latin1":
              case "binary":
                return b(this, t, e, i);
              case "base64":
                return A(this, t, e, i);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return w(this, t, e, i);
              default:
                if (r) throw new TypeError("Unknown encoding: " + s);
                s = ("" + s).toLowerCase(), r = !0;
            }
          }, d.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          var N = 4096;
          function P(t, e, i) {
            var s = "";
            i = Math.min(t.length, i);
            for (var _n2 = e; _n2 < i; ++_n2) s += String.fromCharCode(127 & t[_n2]);
            return s;
          }
          function D(t, e, i) {
            var s = "";
            i = Math.min(t.length, i);
            for (var _n3 = e; _n3 < i; ++_n3) s += String.fromCharCode(t[_n3]);
            return s;
          }
          function R(t, e, i) {
            var s = t.length;
            (!e || e < 0) && (e = 0), (!i || i < 0 || i > s) && (i = s);
            var n = "";
            for (var _s7 = e; _s7 < i; ++_s7) n += J[t[_s7]];
            return n;
          }
          function L(t, e, i) {
            var s = t.slice(e, i);
            var n = "";
            for (var _t4 = 0; _t4 < s.length - 1; _t4 += 2) n += String.fromCharCode(s[_t4] + 256 * s[_t4 + 1]);
            return n;
          }
          function C(t, e, i) {
            if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
            if (t + e > i) throw new RangeError("Trying to access beyond buffer length");
          }
          function O(t, e, i, s, n, r) {
            if (!d.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e > n || e < r) throw new RangeError('"value" argument is out of bounds');
            if (i + s > t.length) throw new RangeError("Index out of range");
          }
          function B(t, e, i, s, n) {
            X(e, s, n, t, i, 7);
            var r = Number(e & BigInt(4294967295));
            t[i++] = r, r >>= 8, t[i++] = r, r >>= 8, t[i++] = r, r >>= 8, t[i++] = r;
            var a = Number(e >> BigInt(32) & BigInt(4294967295));
            return t[i++] = a, a >>= 8, t[i++] = a, a >>= 8, t[i++] = a, a >>= 8, t[i++] = a, i;
          }
          function x(t, e, i, s, n) {
            X(e, s, n, t, i, 7);
            var r = Number(e & BigInt(4294967295));
            t[i + 7] = r, r >>= 8, t[i + 6] = r, r >>= 8, t[i + 5] = r, r >>= 8, t[i + 4] = r;
            var a = Number(e >> BigInt(32) & BigInt(4294967295));
            return t[i + 3] = a, a >>= 8, t[i + 2] = a, a >>= 8, t[i + 1] = a, a >>= 8, t[i] = a, i + 8;
          }
          function M(t, e, i, s, n, r) {
            if (i + s > t.length) throw new RangeError("Index out of range");
            if (i < 0) throw new RangeError("Index out of range");
          }
          function k(t, e, i, s, r) {
            return e = +e, i >>>= 0, r || M(t, 0, i, 4), n.write(t, e, i, s, 23, 4), i + 4;
          }
          function U(t, e, i, s, r) {
            return e = +e, i >>>= 0, r || M(t, 0, i, 8), n.write(t, e, i, s, 52, 8), i + 8;
          }
          d.prototype.slice = function (t, e) {
            var i = this.length;
            (t = ~~t) < 0 ? (t += i) < 0 && (t = 0) : t > i && (t = i), (e = void 0 === e ? i : ~~e) < 0 ? (e += i) < 0 && (e = 0) : e > i && (e = i), e < t && (e = t);
            var s = this.subarray(t, e);
            return Object.setPrototypeOf(s, d.prototype), s;
          }, d.prototype.readUintLE = d.prototype.readUIntLE = function (t, e, i) {
            t >>>= 0, e >>>= 0, i || C(t, e, this.length);
            var s = this[t],
              n = 1,
              r = 0;
            for (; ++r < e && (n *= 256);) s += this[t + r] * n;
            return s;
          }, d.prototype.readUintBE = d.prototype.readUIntBE = function (t, e, i) {
            t >>>= 0, e >>>= 0, i || C(t, e, this.length);
            var s = this[t + --e],
              n = 1;
            for (; e > 0 && (n *= 256);) s += this[t + --e] * n;
            return s;
          }, d.prototype.readUint8 = d.prototype.readUInt8 = function (t, e) {
            return t >>>= 0, e || C(t, 1, this.length), this[t];
          }, d.prototype.readUint16LE = d.prototype.readUInt16LE = function (t, e) {
            return t >>>= 0, e || C(t, 2, this.length), this[t] | this[t + 1] << 8;
          }, d.prototype.readUint16BE = d.prototype.readUInt16BE = function (t, e) {
            return t >>>= 0, e || C(t, 2, this.length), this[t] << 8 | this[t + 1];
          }, d.prototype.readUint32LE = d.prototype.readUInt32LE = function (t, e) {
            return t >>>= 0, e || C(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
          }, d.prototype.readUint32BE = d.prototype.readUInt32BE = function (t, e) {
            return t >>>= 0, e || C(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
          }, d.prototype.readBigUInt64LE = $(function (t) {
            H(t >>>= 0, "offset");
            var e = this[t],
              i = this[t + 7];
            void 0 !== e && void 0 !== i || G(t, this.length - 8);
            var s = e + 256 * this[++t] + 65536 * this[++t] + this[++t] * Math.pow(2, 24),
              n = this[++t] + 256 * this[++t] + 65536 * this[++t] + i * Math.pow(2, 24);
            return BigInt(s) + (BigInt(n) << BigInt(32));
          }), d.prototype.readBigUInt64BE = $(function (t) {
            H(t >>>= 0, "offset");
            var e = this[t],
              i = this[t + 7];
            void 0 !== e && void 0 !== i || G(t, this.length - 8);
            var s = e * Math.pow(2, 24) + 65536 * this[++t] + 256 * this[++t] + this[++t],
              n = this[++t] * Math.pow(2, 24) + 65536 * this[++t] + 256 * this[++t] + i;
            return (BigInt(s) << BigInt(32)) + BigInt(n);
          }), d.prototype.readIntLE = function (t, e, i) {
            t >>>= 0, e >>>= 0, i || C(t, e, this.length);
            var s = this[t],
              n = 1,
              r = 0;
            for (; ++r < e && (n *= 256);) s += this[t + r] * n;
            return n *= 128, s >= n && (s -= Math.pow(2, 8 * e)), s;
          }, d.prototype.readIntBE = function (t, e, i) {
            t >>>= 0, e >>>= 0, i || C(t, e, this.length);
            var s = e,
              n = 1,
              r = this[t + --s];
            for (; s > 0 && (n *= 256);) r += this[t + --s] * n;
            return n *= 128, r >= n && (r -= Math.pow(2, 8 * e)), r;
          }, d.prototype.readInt8 = function (t, e) {
            return t >>>= 0, e || C(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, d.prototype.readInt16LE = function (t, e) {
            t >>>= 0, e || C(t, 2, this.length);
            var i = this[t] | this[t + 1] << 8;
            return 32768 & i ? 4294901760 | i : i;
          }, d.prototype.readInt16BE = function (t, e) {
            t >>>= 0, e || C(t, 2, this.length);
            var i = this[t + 1] | this[t] << 8;
            return 32768 & i ? 4294901760 | i : i;
          }, d.prototype.readInt32LE = function (t, e) {
            return t >>>= 0, e || C(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
          }, d.prototype.readInt32BE = function (t, e) {
            return t >>>= 0, e || C(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
          }, d.prototype.readBigInt64LE = $(function (t) {
            H(t >>>= 0, "offset");
            var e = this[t],
              i = this[t + 7];
            void 0 !== e && void 0 !== i || G(t, this.length - 8);
            var s = this[t + 4] + 256 * this[t + 5] + 65536 * this[t + 6] + (i << 24);
            return (BigInt(s) << BigInt(32)) + BigInt(e + 256 * this[++t] + 65536 * this[++t] + this[++t] * Math.pow(2, 24));
          }), d.prototype.readBigInt64BE = $(function (t) {
            H(t >>>= 0, "offset");
            var e = this[t],
              i = this[t + 7];
            void 0 !== e && void 0 !== i || G(t, this.length - 8);
            var s = (e << 24) + 65536 * this[++t] + 256 * this[++t] + this[++t];
            return (BigInt(s) << BigInt(32)) + BigInt(this[++t] * Math.pow(2, 24) + 65536 * this[++t] + 256 * this[++t] + i);
          }), d.prototype.readFloatLE = function (t, e) {
            return t >>>= 0, e || C(t, 4, this.length), n.read(this, t, !0, 23, 4);
          }, d.prototype.readFloatBE = function (t, e) {
            return t >>>= 0, e || C(t, 4, this.length), n.read(this, t, !1, 23, 4);
          }, d.prototype.readDoubleLE = function (t, e) {
            return t >>>= 0, e || C(t, 8, this.length), n.read(this, t, !0, 52, 8);
          }, d.prototype.readDoubleBE = function (t, e) {
            return t >>>= 0, e || C(t, 8, this.length), n.read(this, t, !1, 52, 8);
          }, d.prototype.writeUintLE = d.prototype.writeUIntLE = function (t, e, i, s) {
            t = +t, e >>>= 0, i >>>= 0, s || O(this, t, e, i, Math.pow(2, 8 * i) - 1, 0);
            var n = 1,
              r = 0;
            for (this[e] = 255 & t; ++r < i && (n *= 256);) this[e + r] = t / n & 255;
            return e + i;
          }, d.prototype.writeUintBE = d.prototype.writeUIntBE = function (t, e, i, s) {
            t = +t, e >>>= 0, i >>>= 0, s || O(this, t, e, i, Math.pow(2, 8 * i) - 1, 0);
            var n = i - 1,
              r = 1;
            for (this[e + n] = 255 & t; --n >= 0 && (r *= 256);) this[e + n] = t / r & 255;
            return e + i;
          }, d.prototype.writeUint8 = d.prototype.writeUInt8 = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 1, 255, 0), this[e] = 255 & t, e + 1;
          }, d.prototype.writeUint16LE = d.prototype.writeUInt16LE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 2, 65535, 0), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
          }, d.prototype.writeUint16BE = d.prototype.writeUInt16BE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 2, 65535, 0), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
          }, d.prototype.writeUint32LE = d.prototype.writeUInt32LE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 4, 4294967295, 0), this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t, e + 4;
          }, d.prototype.writeUint32BE = d.prototype.writeUInt32BE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 4, 4294967295, 0), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
          }, d.prototype.writeBigUInt64LE = $(function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return B(this, t, e, BigInt(0), BigInt("0xffffffffffffffff"));
          }), d.prototype.writeBigUInt64BE = $(function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return x(this, t, e, BigInt(0), BigInt("0xffffffffffffffff"));
          }), d.prototype.writeIntLE = function (t, e, i, s) {
            if (t = +t, e >>>= 0, !s) {
              var _s8 = Math.pow(2, 8 * i - 1);
              O(this, t, e, i, _s8 - 1, -_s8);
            }
            var n = 0,
              r = 1,
              a = 0;
            for (this[e] = 255 & t; ++n < i && (r *= 256);) t < 0 && 0 === a && 0 !== this[e + n - 1] && (a = 1), this[e + n] = (t / r | 0) - a & 255;
            return e + i;
          }, d.prototype.writeIntBE = function (t, e, i, s) {
            if (t = +t, e >>>= 0, !s) {
              var _s9 = Math.pow(2, 8 * i - 1);
              O(this, t, e, i, _s9 - 1, -_s9);
            }
            var n = i - 1,
              r = 1,
              a = 0;
            for (this[e + n] = 255 & t; --n >= 0 && (r *= 256);) t < 0 && 0 === a && 0 !== this[e + n + 1] && (a = 1), this[e + n] = (t / r | 0) - a & 255;
            return e + i;
          }, d.prototype.writeInt8 = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 1, 127, -128), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
          }, d.prototype.writeInt16LE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 2, 32767, -32768), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
          }, d.prototype.writeInt16BE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 2, 32767, -32768), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
          }, d.prototype.writeInt32LE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 4, 2147483647, -2147483648), this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24, e + 4;
          }, d.prototype.writeInt32BE = function (t, e, i) {
            return t = +t, e >>>= 0, i || O(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
          }, d.prototype.writeBigInt64LE = $(function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return B(this, t, e, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
          }), d.prototype.writeBigInt64BE = $(function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return x(this, t, e, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
          }), d.prototype.writeFloatLE = function (t, e, i) {
            return k(this, t, e, !0, i);
          }, d.prototype.writeFloatBE = function (t, e, i) {
            return k(this, t, e, !1, i);
          }, d.prototype.writeDoubleLE = function (t, e, i) {
            return U(this, t, e, !0, i);
          }, d.prototype.writeDoubleBE = function (t, e, i) {
            return U(this, t, e, !1, i);
          }, d.prototype.copy = function (t, e, i, s) {
            if (!d.isBuffer(t)) throw new TypeError("argument should be a Buffer");
            if (i || (i = 0), s || 0 === s || (s = this.length), e >= t.length && (e = t.length), e || (e = 0), s > 0 && s < i && (s = i), s === i) return 0;
            if (0 === t.length || 0 === this.length) return 0;
            if (e < 0) throw new RangeError("targetStart out of bounds");
            if (i < 0 || i >= this.length) throw new RangeError("Index out of range");
            if (s < 0) throw new RangeError("sourceEnd out of bounds");
            s > this.length && (s = this.length), t.length - e < s - i && (s = t.length - e + i);
            var n = s - i;
            return this === t && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(e, i, s) : Uint8Array.prototype.set.call(t, this.subarray(i, s), e), n;
          }, d.prototype.fill = function (t, e, i, s) {
            if ("string" == typeof t) {
              if ("string" == typeof e ? (s = e, e = 0, i = this.length) : "string" == typeof i && (s = i, i = this.length), void 0 !== s && "string" != typeof s) throw new TypeError("encoding must be a string");
              if ("string" == typeof s && !d.isEncoding(s)) throw new TypeError("Unknown encoding: " + s);
              if (1 === t.length) {
                var _e10 = t.charCodeAt(0);
                ("utf8" === s && _e10 < 128 || "latin1" === s) && (t = _e10);
              }
            } else "number" == typeof t ? t &= 255 : "boolean" == typeof t && (t = Number(t));
            if (e < 0 || this.length < e || this.length < i) throw new RangeError("Out of range index");
            if (i <= e) return this;
            var n;
            if (e >>>= 0, i = void 0 === i ? this.length : i >>> 0, t || (t = 0), "number" == typeof t) for (n = e; n < i; ++n) this[n] = t;else {
              var _r3 = d.isBuffer(t) ? t : d.from(t, s),
                _a3 = _r3.length;
              if (0 === _a3) throw new TypeError('The value "' + t + '" is invalid for argument "value"');
              for (n = 0; n < i - e; ++n) this[n + e] = _r3[n % _a3];
            }
            return this;
          };
          var V = {};
          function q(t, e, i) {
            V[t] = /*#__PURE__*/function (_i6) {
              _inherits(_class, _i6);
              var _super = _createSuper(_class);
              function _class() {
                var _this;
                _classCallCheck(this, _class);
                _this = _super.call(this), Object.defineProperty(_assertThisInitialized(_this), "message", {
                  value: e.apply(_assertThisInitialized(_this), arguments),
                  writable: !0,
                  configurable: !0
                }), _this.name = "".concat(_this.name, " [").concat(t, "]"), _this.stack, delete _this.name;
                return _this;
              }
              _createClass(_class, [{
                key: "code",
                get: function get() {
                  return t;
                },
                set: function set(t) {
                  Object.defineProperty(this, "code", {
                    configurable: !0,
                    enumerable: !0,
                    value: t,
                    writable: !0
                  });
                }
              }, {
                key: "toString",
                value: function toString() {
                  return "".concat(this.name, " [").concat(t, "]: ").concat(this.message);
                }
              }]);
              return _class;
            }(i);
          }
          function F(t) {
            var e = "",
              i = t.length;
            var s = "-" === t[0] ? 1 : 0;
            for (; i >= s + 4; i -= 3) e = "_".concat(t.slice(i - 3, i)).concat(e);
            return "".concat(t.slice(0, i)).concat(e);
          }
          function X(t, e, i, s, n, r) {
            if (t > i || t < e) {
              var _s10 = "bigint" == typeof e ? "n" : "";
              var _n4;
              throw _n4 = r > 3 ? 0 === e || e === BigInt(0) ? ">= 0".concat(_s10, " and < 2").concat(_s10, " ** ").concat(8 * (r + 1)).concat(_s10) : ">= -(2".concat(_s10, " ** ").concat(8 * (r + 1) - 1).concat(_s10, ") and < 2 ** ").concat(8 * (r + 1) - 1).concat(_s10) : ">= ".concat(e).concat(_s10, " and <= ").concat(i).concat(_s10), new V.ERR_OUT_OF_RANGE("value", _n4, t);
            }
            !function (t, e, i) {
              H(e, "offset"), void 0 !== t[e] && void 0 !== t[e + i] || G(e, t.length - (i + 1));
            }(s, n, r);
          }
          function H(t, e) {
            if ("number" != typeof t) throw new V.ERR_INVALID_ARG_TYPE(e, "number", t);
          }
          function G(t, e, i) {
            if (Math.floor(t) !== t) throw H(t, i), new V.ERR_OUT_OF_RANGE(i || "offset", "an integer", t);
            if (e < 0) throw new V.ERR_BUFFER_OUT_OF_BOUNDS();
            throw new V.ERR_OUT_OF_RANGE(i || "offset", ">= ".concat(i ? 1 : 0, " and <= ").concat(e), t);
          }
          q("ERR_BUFFER_OUT_OF_BOUNDS", function (t) {
            return t ? "".concat(t, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
          }, RangeError), q("ERR_INVALID_ARG_TYPE", function (t, e) {
            return "The \"".concat(t, "\" argument must be of type number. Received type ").concat(typeof e);
          }, TypeError), q("ERR_OUT_OF_RANGE", function (t, e, i) {
            var s = "The value of \"".concat(t, "\" is out of range."),
              n = i;
            return Number.isInteger(i) && Math.abs(i) > Math.pow(2, 32) ? n = F(String(i)) : "bigint" == typeof i && (n = String(i), (i > Math.pow(BigInt(2), BigInt(32)) || i < -Math.pow(BigInt(2), BigInt(32))) && (n = F(n)), n += "n"), s += " It must be ".concat(e, ". Received ").concat(n), s;
          }, RangeError);
          var j = /[^+/0-9A-Za-z-_]/g;
          function W(t, e) {
            var i;
            e = e || 1 / 0;
            var s = t.length;
            var n = null;
            var r = [];
            for (var _a4 = 0; _a4 < s; ++_a4) {
              if (i = t.charCodeAt(_a4), i > 55295 && i < 57344) {
                if (!n) {
                  if (i > 56319) {
                    (e -= 3) > -1 && r.push(239, 191, 189);
                    continue;
                  }
                  if (_a4 + 1 === s) {
                    (e -= 3) > -1 && r.push(239, 191, 189);
                    continue;
                  }
                  n = i;
                  continue;
                }
                if (i < 56320) {
                  (e -= 3) > -1 && r.push(239, 191, 189), n = i;
                  continue;
                }
                i = 65536 + (n - 55296 << 10 | i - 56320);
              } else n && (e -= 3) > -1 && r.push(239, 191, 189);
              if (n = null, i < 128) {
                if ((e -= 1) < 0) break;
                r.push(i);
              } else if (i < 2048) {
                if ((e -= 2) < 0) break;
                r.push(i >> 6 | 192, 63 & i | 128);
              } else if (i < 65536) {
                if ((e -= 3) < 0) break;
                r.push(i >> 12 | 224, i >> 6 & 63 | 128, 63 & i | 128);
              } else {
                if (!(i < 1114112)) throw new Error("Invalid code point");
                if ((e -= 4) < 0) break;
                r.push(i >> 18 | 240, i >> 12 & 63 | 128, i >> 6 & 63 | 128, 63 & i | 128);
              }
            }
            return r;
          }
          function Y(t) {
            return s.toByteArray(function (t) {
              if ((t = (t = t.split("=")[0]).trim().replace(j, "")).length < 2) return "";
              for (; t.length % 4 != 0;) t += "=";
              return t;
            }(t));
          }
          function z(t, e, i, s) {
            var n;
            for (n = 0; n < s && !(n + i >= e.length || n >= t.length); ++n) e[n + i] = t[n];
            return n;
          }
          function K(t, e) {
            return t instanceof e || null != t && null != t.constructor && null != t.constructor.name && t.constructor.name === e.name;
          }
          function Q(t) {
            return t != t;
          }
          var J = function () {
            var t = "0123456789abcdef",
              e = new Array(256);
            for (var _i7 = 0; _i7 < 16; ++_i7) {
              var _s11 = 16 * _i7;
              for (var _n5 = 0; _n5 < 16; ++_n5) e[_s11 + _n5] = t[_i7] + t[_n5];
            }
            return e;
          }();
          function $(t) {
            return "undefined" == typeof BigInt ? Z : t;
          }
          function Z() {
            throw new Error("BigInt not supported");
          }
        },
        2553: function _(t, e, i) {
          var s;
          s = "undefined" != typeof window ? window : void 0 !== i.g ? i.g : "undefined" != typeof self ? self : {}, t.exports = s;
        },
        8641: function _(t, e, i) {
          var s,
            n = i(1048).hp;
          self, s = function s() {
            return t = {
              851: function _(t, e, i) {
                var s = i(771),
                  n = s.getOptions,
                  r = s.setOptions,
                  a = i(463),
                  o = i(367),
                  d = i(890);
                t.exports = {
                  parse: a,
                  stringify: o,
                  types: d,
                  getOptions: n,
                  setOptions: r
                };
              },
              463: function _(t, e, i) {
                function s(t, e) {
                  return function (t) {
                    if (Array.isArray(t)) return t;
                  }(t) || function (t, e) {
                    var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != i) {
                      var s,
                        n,
                        r,
                        a,
                        o = [],
                        d = !0,
                        c = !1;
                      try {
                        if (r = (i = i.call(t)).next, 0 === e) {
                          if (Object(i) !== i) return;
                          d = !1;
                        } else for (; !(d = (s = r.call(i)).done) && (o.push(s.value), o.length !== e); d = !0);
                      } catch (t) {
                        c = !0, n = t;
                      } finally {
                        try {
                          if (!d && null != i.return && (a = i.return(), Object(a) !== a)) return;
                        } finally {
                          if (c) throw n;
                        }
                      }
                      return o;
                    }
                  }(t, e) || a(t, e) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }();
                }
                function r(t, e) {
                  var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                  if (!i) {
                    if (Array.isArray(t) || (i = a(t)) || e && t && "number" == typeof t.length) {
                      i && (t = i);
                      var s = 0,
                        n = function n() {};
                      return {
                        s: n,
                        n: function n() {
                          return s >= t.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: t[s++]
                          };
                        },
                        e: function e(t) {
                          throw t;
                        },
                        f: n
                      };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }
                  var r,
                    o = !0,
                    d = !1;
                  return {
                    s: function s() {
                      i = i.call(t);
                    },
                    n: function n() {
                      var t = i.next();
                      return o = t.done, t;
                    },
                    e: function e(t) {
                      d = !0, r = t;
                    },
                    f: function f() {
                      try {
                        o || null == i.return || i.return();
                      } finally {
                        if (d) throw r;
                      }
                    }
                  };
                }
                function a(t, e) {
                  if (t) {
                    if ("string" == typeof t) return o(t, e);
                    var i = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? o(t, e) : void 0;
                  }
                }
                function o(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];
                  return s;
                }
                var d = i(771),
                  c = i(890),
                  u = c.Rendition,
                  l = c.Variant,
                  h = c.SessionData,
                  p = c.Key,
                  f = c.MediaInitializationSection,
                  g = c.DateRange,
                  m = c.SpliceInfo,
                  v = c.MasterPlaylist,
                  y = c.MediaPlaylist,
                  T = c.Segment,
                  S = c.PartialSegment,
                  E = c.PrefetchSegment,
                  b = c.RenditionReport;
                function A(t) {
                  return d.trim(t, '"');
                }
                function w(t) {
                  var e = d.splitAt(t, ",");
                  return {
                    duration: d.toNumber(e[0]),
                    title: decodeURIComponent(escape(e[1]))
                  };
                }
                function _(t) {
                  var e = d.splitAt(t, "@");
                  return {
                    length: d.toNumber(e[0]),
                    offset: e[1] ? d.toNumber(e[1]) : -1
                  };
                }
                function I(t) {
                  var e = d.splitAt(t, "x");
                  return {
                    width: d.toNumber(e[0]),
                    height: d.toNumber(e[1])
                  };
                }
                function N(t) {
                  var e = "ALLOWED-CPC: Each entry must consit of KEYFORMAT and Content Protection Configuration",
                    i = t.split(",");
                  0 === i.length && d.INVALIDPLAYLIST(e);
                  var n,
                    a = [],
                    o = r(i);
                  try {
                    for (o.s(); !(n = o.n()).done;) {
                      var c = n.value,
                        u = s(d.splitAt(c, ":"), 2),
                        l = u[0],
                        h = u[1];
                      l && h ? a.push({
                        format: l,
                        cpcList: h.split("/")
                      }) : d.INVALIDPLAYLIST(e);
                    }
                  } catch (t) {
                    o.e(t);
                  } finally {
                    o.f();
                  }
                  return a;
                }
                function P(t) {
                  return t.startsWith('"') ? A(t) : t.startsWith("0x") || t.startsWith("0X") ? d.hexToByteSequence(t) : d.toNumber(t);
                }
                function D(t, e) {
                  e.IV && t.compatibleVersion < 2 && (t.compatibleVersion = 2), (e.KEYFORMAT || e.KEYFORMATVERSIONS) && t.compatibleVersion < 5 && (t.compatibleVersion = 5);
                }
                function R(t) {
                  var e,
                    i,
                    n,
                    a = {},
                    o = r(d.splitByCommaWithPreservingQuotes(t));
                  try {
                    for (o.s(); !(e = o.n()).done;) {
                      var c = e.value,
                        u = s(d.splitAt(c, "="), 2),
                        l = u[0],
                        h = u[1],
                        p = A(h);
                      switch (l) {
                        case "URI":
                          a[l] = p;
                          break;
                        case "START-DATE":
                        case "END-DATE":
                          a[l] = new Date(p);
                          break;
                        case "IV":
                          a[l] = (i = p, 16 !== (n = d.hexToByteSequence(i)).length && d.INVALIDPLAYLIST("IV must be a 128-bit unsigned integer"), n);
                          break;
                        case "BYTERANGE":
                          a[l] = _(p);
                          break;
                        case "RESOLUTION":
                          a[l] = I(p);
                          break;
                        case "ALLOWED-CPC":
                          a[l] = N(p);
                          break;
                        case "END-ON-NEXT":
                        case "DEFAULT":
                        case "AUTOSELECT":
                        case "FORCED":
                        case "PRECISE":
                        case "CAN-BLOCK-RELOAD":
                        case "INDEPENDENT":
                        case "GAP":
                          a[l] = "YES" === p;
                          break;
                        case "DURATION":
                        case "PLANNED-DURATION":
                        case "BANDWIDTH":
                        case "AVERAGE-BANDWIDTH":
                        case "FRAME-RATE":
                        case "TIME-OFFSET":
                        case "CAN-SKIP-UNTIL":
                        case "HOLD-BACK":
                        case "PART-HOLD-BACK":
                        case "PART-TARGET":
                        case "BYTERANGE-START":
                        case "BYTERANGE-LENGTH":
                        case "LAST-MSN":
                        case "LAST-PART":
                        case "SKIPPED-SEGMENTS":
                        case "SCORE":
                          a[l] = d.toNumber(p);
                          break;
                        default:
                          l.startsWith("SCTE35-") ? a[l] = d.hexToByteSequence(p) : l.startsWith("X-") ? a[l] = P(h) : ("VIDEO-RANGE" === l && "SDR" !== p && "HLG" !== p && "PQ" !== p && d.INVALIDPLAYLIST('VIDEO-RANGE: unknown value "'.concat(p, '"')), a[l] = p);
                      }
                    }
                  } catch (t) {
                    o.e(t);
                  } finally {
                    o.f();
                  }
                  return a;
                }
                function L() {
                  d.INVALIDPLAYLIST("The file contains both media and master playlist tags.");
                }
                function C(t, e, i) {
                  var s,
                    n = (s = e.attributes, new u({
                      type: s.TYPE,
                      uri: s.URI,
                      groupId: s["GROUP-ID"],
                      language: s.LANGUAGE,
                      assocLanguage: s["ASSOC-LANGUAGE"],
                      name: s.NAME,
                      isDefault: s.DEFAULT,
                      autoselect: s.AUTOSELECT,
                      forced: s.FORCED,
                      instreamId: s["INSTREAM-ID"],
                      characteristics: s.CHARACTERISTICS,
                      channels: s.CHANNELS
                    })),
                    a = t[d.camelify(i)],
                    o = function (t, e) {
                      var i,
                        s = !1,
                        n = r(t);
                      try {
                        for (n.s(); !(i = n.n()).done;) {
                          var a = i.value;
                          if (a.name === e.name) return "All EXT-X-MEDIA tags in the same Group MUST have different NAME attributes.";
                          a.isDefault && (s = !0);
                        }
                      } catch (t) {
                        n.e(t);
                      } finally {
                        n.f();
                      }
                      return s && e.isDefault ? "EXT-X-MEDIA A Group MUST NOT have more than one member with a DEFAULT attribute of YES." : "";
                    }(a, n);
                  o && d.INVALIDPLAYLIST(o), a.push(n), n.isDefault && (t.currentRenditions[d.camelify(i)] = a.length - 1);
                }
                function O(t, e, i, s, n) {
                  var a,
                    o = new l({
                      uri: i,
                      bandwidth: e.BANDWIDTH,
                      averageBandwidth: e["AVERAGE-BANDWIDTH"],
                      score: e.SCORE,
                      codecs: e.CODECS,
                      resolution: e.RESOLUTION,
                      frameRate: e["FRAME-RATE"],
                      hdcpLevel: e["HDCP-LEVEL"],
                      allowedCpc: e["ALLOWED-CPC"],
                      videoRange: e["VIDEO-RANGE"],
                      stableVariantId: e["STABLE-VARIANT-ID"]
                    }),
                    c = r(t);
                  try {
                    for (c.s(); !(a = c.n()).done;) {
                      var u = a.value;
                      if ("EXT-X-MEDIA" === u.name) {
                        var h = u.attributes,
                          p = h.TYPE;
                        if (p && h["GROUP-ID"] || d.INVALIDPLAYLIST("EXT-X-MEDIA TYPE attribute is REQUIRED."), e[p] === h["GROUP-ID"] && (C(o, u, p), "CLOSED-CAPTIONS" === p)) {
                          var f,
                            g = r(o.closedCaptions);
                          try {
                            for (g.s(); !(f = g.n()).done;) {
                              var m = f.value.instreamId;
                              if (m && m.startsWith("SERVICE") && n.compatibleVersion < 7) {
                                n.compatibleVersion = 7;
                                break;
                              }
                            }
                          } catch (t) {
                            g.e(t);
                          } finally {
                            g.f();
                          }
                        }
                      }
                    }
                  } catch (t) {
                    c.e(t);
                  } finally {
                    c.f();
                  }
                  return function (t, e, i) {
                    for (var s = function s() {
                        var s = r[n];
                        "CLOSED-CAPTIONS" === s && "NONE" === t[s] ? (i.isClosedCaptionsNone = !0, e.closedCaptions = []) : t[s] && !e[d.camelify(s)].some(function (e) {
                          return e.groupId === t[s];
                        }) && d.INVALIDPLAYLIST("".concat(s, " attribute MUST match the value of the GROUP-ID attribute of an EXT-X-MEDIA tag whose TYPE attribute is ").concat(s, "."));
                      }, n = 0, r = ["AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS"]; n < r.length; n++) s();
                  }(e, o, n), o.isIFrameOnly = s, o;
                }
                function B(t, e) {
                  if (t.method !== e.method) return !1;
                  if (t.uri !== e.uri) return !1;
                  if (t.iv) {
                    if (!e.iv) return !1;
                    if (t.iv.length !== e.iv.length) return !1;
                    for (var i = 0; i < t.iv.length; i++) if (t.iv[i] !== e.iv[i]) return !1;
                  } else if (e.iv) return !1;
                  return t.format === e.format && t.formatVersion === e.formatVersion;
                }
                function x(t, e, i, s, n, r, a) {
                  for (var o = new T({
                      uri: e,
                      mediaSequenceNumber: n,
                      discontinuitySequence: r
                    }), c = !1, u = !1, l = i; l <= s; l++) {
                    var h = t[l],
                      v = h.name,
                      y = h.value,
                      E = h.attributes;
                    if ("EXTINF" === v) !Number.isInteger(y.duration) && a.compatibleVersion < 3 && (a.compatibleVersion = 3), Math.round(y.duration) > a.targetDuration && d.INVALIDPLAYLIST("EXTINF duration, when rounded to the nearest integer, MUST be less than or equal to the target duration"), o.duration = y.duration, o.title = y.title;else if ("EXT-X-BYTERANGE" === v) a.compatibleVersion < 4 && (a.compatibleVersion = 4), o.byterange = y;else if ("EXT-X-DISCONTINUITY" === v) o.parts.length > 0 && d.INVALIDPLAYLIST("EXT-X-DISCONTINUITY must appear before the first EXT-X-PART tag of the Parent Segment."), o.discontinuity = !0;else if ("EXT-X-KEY" === v) o.parts.length > 0 && d.INVALIDPLAYLIST("EXT-X-KEY must appear before the first EXT-X-PART tag of the Parent Segment."), D(a, E), o.key = new p({
                      method: E.METHOD,
                      uri: E.URI,
                      iv: E.IV,
                      format: E.KEYFORMAT,
                      formatVersion: E.KEYFORMATVERSIONS
                    });else if ("EXT-X-MAP" === v) o.parts.length > 0 && d.INVALIDPLAYLIST("EXT-X-MAP must appear before the first EXT-X-PART tag of the Parent Segment."), a.compatibleVersion < 5 && (a.compatibleVersion = 5), a.hasMap = !0, o.map = new f({
                      uri: E.URI,
                      byterange: E.BYTERANGE
                    });else if ("EXT-X-PROGRAM-DATE-TIME" === v) o.programDateTime = y;else if ("EXT-X-DATERANGE" === v) {
                      for (var b = {}, A = 0, w = Object.keys(E); A < w.length; A++) {
                        var _ = w[A];
                        (_.startsWith("SCTE35-") || _.startsWith("X-")) && (b[_] = E[_]);
                      }
                      o.dateRange = new g({
                        id: E.ID,
                        classId: E.CLASS,
                        start: E["START-DATE"],
                        end: E["END-DATE"],
                        duration: E.DURATION,
                        plannedDuration: E["PLANNED-DURATION"],
                        endOnNext: E["END-ON-NEXT"],
                        attributes: b
                      });
                    } else if ("EXT-X-CUE-OUT" === v) o.markers.push(new m({
                      type: "OUT",
                      duration: E && E.DURATION || y
                    }));else if ("EXT-X-CUE-IN" === v) o.markers.push(new m({
                      type: "IN"
                    }));else if ("EXT-X-CUE-OUT-CONT" === v || "EXT-X-CUE" === v || "EXT-OATCLS-SCTE35" === v || "EXT-X-ASSET" === v || "EXT-X-SCTE35" === v) o.markers.push(new m({
                      type: "RAW",
                      tagName: v,
                      value: y
                    }));else if ("EXT-X-PRELOAD-HINT" !== v || E.TYPE) {
                      if ("EXT-X-PRELOAD-HINT" === v && "PART" === E.TYPE && u) d.INVALIDPLAYLIST("Servers should not add more than one EXT-X-PRELOAD-HINT tag with the same TYPE attribute to a Playlist.");else if ("EXT-X-PART" !== v && "EXT-X-PRELOAD-HINT" !== v || E.URI) {
                        if ("EXT-X-PRELOAD-HINT" === v && "MAP" === E.TYPE) c && d.INVALIDPLAYLIST("Servers should not add more than one EXT-X-PRELOAD-HINT tag with the same TYPE attribute to a Playlist."), c = !0, a.hasMap = !0, o.map = new f({
                          hint: !0,
                          uri: E.URI,
                          byterange: {
                            length: E["BYTERANGE-LENGTH"],
                            offset: E["BYTERANGE-START"] || 0
                          }
                        });else if ("EXT-X-PART" === v || "EXT-X-PRELOAD-HINT" === v && "PART" === E.TYPE) {
                          "EXT-X-PART" !== v || E.DURATION || d.INVALIDPLAYLIST("EXT-X-PART: DURATION attribute is mandatory"), "EXT-X-PRELOAD-HINT" === v && (u = !0);
                          var I = new S({
                            hint: "EXT-X-PRELOAD-HINT" === v,
                            uri: E.URI,
                            byterange: "EXT-X-PART" === v ? E.BYTERANGE : {
                              length: E["BYTERANGE-LENGTH"],
                              offset: E["BYTERANGE-START"] || 0
                            },
                            duration: E.DURATION,
                            independent: E.INDEPENDENT,
                            gap: E.GAP
                          });
                          o.parts.push(I);
                        }
                      } else d.INVALIDPLAYLIST("EXT-X-PART / EXT-X-PRELOAD-HINT: URI attribute is mandatory");
                    } else d.INVALIDPLAYLIST("EXT-X-PRELOAD-HINT: TYPE attribute is mandatory");
                  }
                  return o;
                }
                function M(t, e, i, s, n, r, a) {
                  for (var o = new E({
                      uri: e,
                      mediaSequenceNumber: n,
                      discontinuitySequence: r
                    }), c = i; c <= s; c++) {
                    var u = t[c],
                      l = u.name,
                      h = u.attributes;
                    "EXTINF" === l ? d.INVALIDPLAYLIST("A prefetch segment must not be advertised with an EXTINF tag.") : "EXT-X-DISCONTINUITY" === l ? d.INVALIDPLAYLIST("A prefetch segment must not be advertised with an EXT-X-DISCONTINUITY tag.") : "EXT-X-PREFETCH-DISCONTINUITY" === l ? o.discontinuity = !0 : "EXT-X-KEY" === l ? (D(a, h), o.key = new p({
                      method: h.METHOD,
                      uri: h.URI,
                      iv: h.IV,
                      format: h.KEYFORMAT,
                      formatVersion: h.KEYFORMATVERSIONS
                    })) : "EXT-X-MAP" === l && d.INVALIDPLAYLIST("Prefetch segments must not be advertised with an EXT-X-MAP tag.");
                  }
                  return o;
                }
                function k(t, e, i, s, n) {
                  var r = e.discontinuity,
                    a = e.key,
                    o = e.map,
                    c = e.byterange,
                    u = e.uri;
                  if (r && (e.discontinuitySequence = i + 1), a || (e.key = s), o || (e.map = n), c && -1 === c.offset) {
                    var l = t.segments;
                    if (l.length > 0) {
                      var h = l[l.length - 1];
                      h.byterange && h.uri === u ? c.offset = h.byterange.offset + h.byterange.length : d.INVALIDPLAYLIST("If offset of EXT-X-BYTERANGE is not present, a previous Media Segment MUST be a sub-range of the same media resource");
                    } else d.INVALIDPLAYLIST("If offset of EXT-X-BYTERANGE is not present, a previous Media Segment MUST appear in the Playlist file");
                  }
                  return t.segments.push(e), [e.discontinuitySequence, e.key, e.map];
                }
                function U(t, e) {
                  var i = function (t) {
                      var e = t.indexOf(":");
                      return -1 === e ? [t.slice(1).trim(), null] : [t.slice(1, e).trim(), t.slice(e + 1).trim()];
                    }(t),
                    n = s(i, 2),
                    r = n[0],
                    a = n[1],
                    o = function (t) {
                      switch (t) {
                        case "EXTM3U":
                        case "EXT-X-VERSION":
                          return "Basic";
                        case "EXTINF":
                        case "EXT-X-BYTERANGE":
                        case "EXT-X-DISCONTINUITY":
                        case "EXT-X-PREFETCH-DISCONTINUITY":
                        case "EXT-X-KEY":
                        case "EXT-X-MAP":
                        case "EXT-X-PROGRAM-DATE-TIME":
                        case "EXT-X-DATERANGE":
                        case "EXT-X-CUE-OUT":
                        case "EXT-X-CUE-IN":
                        case "EXT-X-CUE-OUT-CONT":
                        case "EXT-X-CUE":
                        case "EXT-OATCLS-SCTE35":
                        case "EXT-X-ASSET":
                        case "EXT-X-SCTE35":
                        case "EXT-X-PART":
                        case "EXT-X-PRELOAD-HINT":
                          return "Segment";
                        case "EXT-X-TARGETDURATION":
                        case "EXT-X-MEDIA-SEQUENCE":
                        case "EXT-X-DISCONTINUITY-SEQUENCE":
                        case "EXT-X-ENDLIST":
                        case "EXT-X-PLAYLIST-TYPE":
                        case "EXT-X-I-FRAMES-ONLY":
                        case "EXT-X-SERVER-CONTROL":
                        case "EXT-X-PART-INF":
                        case "EXT-X-PREFETCH":
                        case "EXT-X-RENDITION-REPORT":
                        case "EXT-X-SKIP":
                          return "MediaPlaylist";
                        case "EXT-X-MEDIA":
                        case "EXT-X-STREAM-INF":
                        case "EXT-X-I-FRAME-STREAM-INF":
                        case "EXT-X-SESSION-DATA":
                        case "EXT-X-SESSION-KEY":
                          return "MasterPlaylist";
                        case "EXT-X-INDEPENDENT-SEGMENTS":
                        case "EXT-X-START":
                          return "MediaorMasterPlaylist";
                        default:
                          return "Unknown";
                      }
                    }(r);
                  if (function (t, e) {
                    if ("Segment" === t || "MediaPlaylist" === t) return void 0 === e.isMasterPlaylist ? void (e.isMasterPlaylist = !1) : void (e.isMasterPlaylist && L());
                    if ("MasterPlaylist" === t) {
                      if (void 0 === e.isMasterPlaylist) return void (e.isMasterPlaylist = !0);
                      !1 === e.isMasterPlaylist && L();
                    }
                  }(o, e), "Unknown" === o) return null;
                  "MediaPlaylist" === o && "EXT-X-RENDITION-REPORT" !== r && "EXT-X-PREFETCH" !== r && (e.hash[r] && d.INVALIDPLAYLIST("There MUST NOT be more than one Media Playlist tag of each type in any Media Playlist"), e.hash[r] = !0);
                  var c = function (t, e) {
                      switch (t) {
                        case "EXTM3U":
                        case "EXT-X-DISCONTINUITY":
                        case "EXT-X-ENDLIST":
                        case "EXT-X-I-FRAMES-ONLY":
                        case "EXT-X-INDEPENDENT-SEGMENTS":
                        case "EXT-X-CUE-IN":
                          return [null, null];
                        case "EXT-X-VERSION":
                        case "EXT-X-TARGETDURATION":
                        case "EXT-X-MEDIA-SEQUENCE":
                        case "EXT-X-DISCONTINUITY-SEQUENCE":
                          return [d.toNumber(e), null];
                        case "EXT-X-CUE-OUT":
                          return Number.isNaN(Number(e)) ? [null, R(e)] : [d.toNumber(e), null];
                        case "EXT-X-KEY":
                        case "EXT-X-MAP":
                        case "EXT-X-DATERANGE":
                        case "EXT-X-MEDIA":
                        case "EXT-X-STREAM-INF":
                        case "EXT-X-I-FRAME-STREAM-INF":
                        case "EXT-X-SESSION-DATA":
                        case "EXT-X-SESSION-KEY":
                        case "EXT-X-START":
                        case "EXT-X-SERVER-CONTROL":
                        case "EXT-X-PART-INF":
                        case "EXT-X-PART":
                        case "EXT-X-PRELOAD-HINT":
                        case "EXT-X-RENDITION-REPORT":
                        case "EXT-X-SKIP":
                          return [null, R(e)];
                        case "EXTINF":
                          return [w(e), null];
                        case "EXT-X-BYTERANGE":
                          return [_(e), null];
                        case "EXT-X-PROGRAM-DATE-TIME":
                          return [new Date(e), null];
                        default:
                          return [e, null];
                      }
                    }(r, a),
                    u = s(c, 2);
                  return {
                    name: r,
                    category: o,
                    value: u[0],
                    attributes: u[1]
                  };
                }
                function V(t, e) {
                  var i;
                  return e.isMasterPlaylist ? i = function (t, e) {
                    var i,
                      n = new v(),
                      a = !1,
                      o = r(t.entries());
                    try {
                      for (o.s(); !(i = o.n()).done;) {
                        var c = s(i.value, 2),
                          u = c[0],
                          l = c[1],
                          f = l.name,
                          g = l.value,
                          m = l.attributes;
                        if ("EXT-X-VERSION" === f) n.version = g;else if ("EXT-X-STREAM-INF" === f) {
                          var y = t[u + 1];
                          ("string" != typeof y || y.startsWith("#EXT")) && d.INVALIDPLAYLIST("EXT-X-STREAM-INF must be followed by a URI line");
                          var T = O(t, m, y, !1, e);
                          T && ("number" == typeof T.score && (a = !0, T.score < 0 && d.INVALIDPLAYLIST("SCORE attribute on EXT-X-STREAM-INF must be positive decimal-floating-point number.")), n.variants.push(T));
                        } else if ("EXT-X-I-FRAME-STREAM-INF" === f) {
                          var S = O(t, m, m.URI, !0, e);
                          S && n.variants.push(S);
                        } else "EXT-X-SESSION-DATA" === f ? function () {
                          var t = new h({
                            id: m["DATA-ID"],
                            value: m.VALUE,
                            uri: m.URI,
                            language: m.LANGUAGE
                          });
                          n.sessionDataList.some(function (e) {
                            return e.id === t.id && e.language === t.language;
                          }) && d.INVALIDPLAYLIST("A Playlist MUST NOT contain more than one EXT-X-SESSION-DATA tag with the same DATA-ID attribute and the same LANGUAGE attribute."), n.sessionDataList.push(t);
                        }() : "EXT-X-SESSION-KEY" === f ? function () {
                          "NONE" === m.METHOD && d.INVALIDPLAYLIST("EXT-X-SESSION-KEY: The value of the METHOD attribute MUST NOT be NONE");
                          var t = new p({
                            method: m.METHOD,
                            uri: m.URI,
                            iv: m.IV,
                            format: m.KEYFORMAT,
                            formatVersion: m.KEYFORMATVERSIONS
                          });
                          n.sessionKeyList.some(function (e) {
                            return B(e, t);
                          }) && d.INVALIDPLAYLIST("A Master Playlist MUST NOT contain more than one EXT-X-SESSION-KEY tag with the same METHOD, URI, IV, KEYFORMAT, and KEYFORMATVERSIONS attribute values."), D(e, m), n.sessionKeyList.push(t);
                        }() : "EXT-X-INDEPENDENT-SEGMENTS" === f ? (n.independentSegments && d.INVALIDPLAYLIST("EXT-X-INDEPENDENT-SEGMENTS tag MUST NOT appear more than once in a Playlist"), n.independentSegments = !0) : "EXT-X-START" === f && (n.start && d.INVALIDPLAYLIST("EXT-X-START tag MUST NOT appear more than once in a Playlist"), "number" != typeof m["TIME-OFFSET"] && d.INVALIDPLAYLIST("EXT-X-START: TIME-OFFSET attribute is REQUIRED"), n.start = {
                          offset: m["TIME-OFFSET"],
                          precise: m.PRECISE || !1
                        });
                      }
                    } catch (t) {
                      o.e(t);
                    } finally {
                      o.f();
                    }
                    if (a) {
                      var E,
                        b = r(n.variants);
                      try {
                        for (b.s(); !(E = b.n()).done;) "number" != typeof E.value.score && d.INVALIDPLAYLIST("If any Variant Stream contains the SCORE attribute, then all Variant Streams in the Master Playlist SHOULD have a SCORE attribute");
                      } catch (t) {
                        b.e(t);
                      } finally {
                        b.f();
                      }
                    }
                    if (e.isClosedCaptionsNone) {
                      var A,
                        w = r(n.variants);
                      try {
                        for (w.s(); !(A = w.n()).done;) A.value.closedCaptions.length > 0 && d.INVALIDPLAYLIST("If there is a variant with CLOSED-CAPTIONS attribute of NONE, all EXT-X-STREAM-INF tags MUST have this attribute with a value of NONE");
                      } catch (t) {
                        w.e(t);
                      } finally {
                        w.f();
                      }
                    }
                    return n;
                  }(t, e) : !(i = function (t, e) {
                    var i,
                      n = new y(),
                      a = -1,
                      o = 0,
                      c = !1,
                      u = !1,
                      l = 0,
                      h = null,
                      p = null,
                      f = !1,
                      g = r(t.entries());
                    try {
                      for (g.s(); !(i = g.n()).done;) {
                        var m = s(i.value, 2),
                          v = m[0],
                          T = m[1],
                          S = T.name,
                          E = T.value,
                          A = T.attributes;
                        if ("Segment" !== T.category) {
                          if ("EXT-X-VERSION" === S) void 0 === n.version ? n.version = E : d.INVALIDPLAYLIST("A Playlist file MUST NOT contain more than one EXT-X-VERSION tag.");else if ("EXT-X-TARGETDURATION" === S) n.targetDuration = e.targetDuration = E;else if ("EXT-X-MEDIA-SEQUENCE" === S) n.segments.length > 0 && d.INVALIDPLAYLIST("The EXT-X-MEDIA-SEQUENCE tag MUST appear before the first Media Segment in the Playlist."), n.mediaSequenceBase = o = E;else if ("EXT-X-DISCONTINUITY-SEQUENCE" === S) n.segments.length > 0 && d.INVALIDPLAYLIST("The EXT-X-DISCONTINUITY-SEQUENCE tag MUST appear before the first Media Segment in the Playlist."), c && d.INVALIDPLAYLIST("The EXT-X-DISCONTINUITY-SEQUENCE tag MUST appear before any EXT-X-DISCONTINUITY tag."), n.discontinuitySequenceBase = l = E;else if ("EXT-X-ENDLIST" === S) n.endlist = !0;else if ("EXT-X-PLAYLIST-TYPE" === S) n.playlistType = E;else if ("EXT-X-I-FRAMES-ONLY" === S) e.compatibleVersion < 4 && (e.compatibleVersion = 4), n.isIFrame = !0;else if ("EXT-X-INDEPENDENT-SEGMENTS" === S) n.independentSegments && d.INVALIDPLAYLIST("EXT-X-INDEPENDENT-SEGMENTS tag MUST NOT appear more than once in a Playlist"), n.independentSegments = !0;else if ("EXT-X-START" === S) n.start && d.INVALIDPLAYLIST("EXT-X-START tag MUST NOT appear more than once in a Playlist"), "number" != typeof A["TIME-OFFSET"] && d.INVALIDPLAYLIST("EXT-X-START: TIME-OFFSET attribute is REQUIRED"), n.start = {
                            offset: A["TIME-OFFSET"],
                            precise: A.PRECISE || !1
                          };else if ("EXT-X-SERVER-CONTROL" === S) A["CAN-BLOCK-RELOAD"] || d.INVALIDPLAYLIST("EXT-X-SERVER-CONTROL: CAN-BLOCK-RELOAD=YES is mandatory for Low-Latency HLS"), n.lowLatencyCompatibility = {
                            canBlockReload: A["CAN-BLOCK-RELOAD"],
                            canSkipUntil: A["CAN-SKIP-UNTIL"],
                            holdBack: A["HOLD-BACK"],
                            partHoldBack: A["PART-HOLD-BACK"]
                          };else if ("EXT-X-PART-INF" === S) A["PART-TARGET"] || d.INVALIDPLAYLIST("EXT-X-PART-INF: PART-TARGET attribute is mandatory"), n.partTargetDuration = A["PART-TARGET"];else if ("EXT-X-RENDITION-REPORT" === S) A.URI || d.INVALIDPLAYLIST("EXT-X-RENDITION-REPORT: URI attribute is mandatory"), 0 === A.URI.search(/^[a-z]+:/) && d.INVALIDPLAYLIST("EXT-X-RENDITION-REPORT: URI must be relative to the playlist uri"), n.renditionReports.push(new b({
                            uri: A.URI,
                            lastMSN: A["LAST-MSN"],
                            lastPart: A["LAST-PART"]
                          }));else if ("EXT-X-SKIP" === S) A["SKIPPED-SEGMENTS"] || d.INVALIDPLAYLIST("EXT-X-SKIP: SKIPPED-SEGMENTS attribute is mandatory"), e.compatibleVersion < 9 && (e.compatibleVersion = 9), n.skip = A["SKIPPED-SEGMENTS"], o += n.skip;else if ("EXT-X-PREFETCH" === S) {
                            var w = M(t, E, -1 === a ? v : a, v - 1, o++, l, e);
                            w && (w.discontinuity && (w.discontinuitySequence++, l = w.discontinuitySequence), w.key ? h = w.key : w.key = h, n.prefetchSegments.push(w)), u = !0, a = -1;
                          } else if ("string" == typeof T) {
                            -1 === a && d.INVALIDPLAYLIST("A URI line is not preceded by any segment tags"), n.targetDuration || d.INVALIDPLAYLIST("The EXT-X-TARGETDURATION tag is REQUIRED"), u && d.INVALIDPLAYLIST("These segments must appear after all complete segments.");
                            var _ = x(t, T, a, v - 1, o++, l, e);
                            if (_) {
                              var I = s(k(n, _, l, h, p), 3);
                              l = I[0], h = I[1], p = I[2], !f && _.parts.length > 0 && (f = !0);
                            }
                            a = -1;
                          }
                        } else -1 === a && (a = v), "EXT-X-DISCONTINUITY" === S && (c = !0);
                      }
                    } catch (t) {
                      g.e(t);
                    } finally {
                      g.f();
                    }
                    if (-1 !== a) {
                      var N = x(t, "", a, t.length - 1, o++, l, e);
                      if (N) {
                        var P = N.parts;
                        P.length > 0 && !n.endlist && !P[P.length - 1].hint && d.INVALIDPLAYLIST("If the Playlist contains EXT-X-PART tags and does not contain an EXT-X-ENDLIST tag, the Playlist must contain an EXT-X-PRELOAD-HINT tag with a TYPE=PART attribute"), k(n, N, h, p), !f && N.parts.length > 0 && (f = !0);
                      }
                    }
                    return function (t) {
                      for (var e = new Map(), i = new Map(), s = !1, n = !1, a = t.length - 1; a >= 0; a--) {
                        var o = t[a],
                          c = o.programDateTime,
                          u = o.dateRange;
                        if (c && (n = !0), u && u.start) {
                          s = !0, u.endOnNext && (u.end || u.duration) && d.INVALIDPLAYLIST("An EXT-X-DATERANGE tag with an END-ON-NEXT=YES attribute MUST NOT contain DURATION or END-DATE attributes.");
                          var l = u.start.getTime(),
                            h = u.duration || 0;
                          u.end && u.duration && l + 1e3 * h !== u.end.getTime() && d.INVALIDPLAYLIST("END-DATE MUST be equal to the value of the START-DATE attribute plus the value of the DURATION"), u.endOnNext && (u.end = e.get(u.classId)), e.set(u.classId, u.start);
                          var p = u.end ? u.end.getTime() : u.start.getTime() + 1e3 * (u.duration || 0),
                            f = i.get(u.classId);
                          if (f) {
                            var g,
                              m = r(f);
                            try {
                              for (m.s(); !(g = m.n()).done;) {
                                var v = g.value;
                                (v.start <= l && v.end > l || v.start >= l && v.start < p) && d.INVALIDPLAYLIST("DATERANGE tags with the same CLASS should not overlap");
                              }
                            } catch (t) {
                              m.e(t);
                            } finally {
                              m.f();
                            }
                            f.push({
                              start: l,
                              end: p
                            });
                          } else i.set(u.classId, [{
                            start: l,
                            end: p
                          }]);
                        }
                      }
                      s && !n && d.INVALIDPLAYLIST("If a Playlist contains an EXT-X-DATERANGE tag, it MUST also contain at least one EXT-X-PROGRAM-DATE-TIME tag.");
                    }(n.segments), n.lowLatencyCompatibility && function (t, e) {
                      var i = t.lowLatencyCompatibility,
                        n = t.targetDuration,
                        a = t.partTargetDuration,
                        o = t.segments,
                        c = t.renditionReports,
                        u = i.canSkipUntil,
                        l = i.holdBack,
                        h = i.partHoldBack;
                      if (u < 6 * n && d.INVALIDPLAYLIST("The Skip Boundary must be at least six times the EXT-X-TARGETDURATION."), l < 3 * n && d.INVALIDPLAYLIST("HOLD-BACK must be at least three times the EXT-X-TARGETDURATION."), e) {
                        void 0 === a && d.INVALIDPLAYLIST("EXT-X-PART-INF is required if a Playlist contains one or more EXT-X-PART tags"), void 0 === h && d.INVALIDPLAYLIST("EXT-X-PART: PART-HOLD-BACK attribute is mandatory"), h < a && d.INVALIDPLAYLIST("PART-HOLD-BACK must be at least PART-TARGET");
                        var p,
                          f = r(o.entries());
                        try {
                          for (f.s(); !(p = f.n()).done;) {
                            var g = s(p.value, 2),
                              m = g[0],
                              v = g[1].parts;
                            v.length > 0 && m < o.length - 3 && d.INVALIDPLAYLIST("Remove EXT-X-PART tags from the Playlist after they are greater than three target durations from the end of the Playlist.");
                            var y,
                              T = r(v.entries());
                            try {
                              for (T.s(); !(y = T.n()).done;) {
                                var S = s(y.value, 2),
                                  E = S[0],
                                  b = S[1].duration;
                                void 0 !== b && (b > a && d.INVALIDPLAYLIST("PART-TARGET is the maximum duration of any Partial Segment"), E < v.length - 1 && b < .85 * a && d.INVALIDPLAYLIST("All Partial Segments except the last part of a segment must have a duration of at least 85% of PART-TARGET"));
                              }
                            } catch (t) {
                              T.e(t);
                            } finally {
                              T.f();
                            }
                          }
                        } catch (t) {
                          f.e(t);
                        } finally {
                          f.f();
                        }
                      }
                      var A,
                        w = r(c);
                      try {
                        for (w.s(); !(A = w.n()).done;) {
                          var _ = A.value,
                            I = o[o.length - 1];
                          _.lastMSN || (_.lastMSN = I.mediaSequenceNumber), !_.lastPart && I.parts.length > 0 && (_.lastPart = I.parts.length - 1);
                        }
                      } catch (t) {
                        w.e(t);
                      } finally {
                        w.f();
                      }
                    }(n, f), n;
                  }(t, e)).isIFrame && e.hasMap && e.compatibleVersion < 6 && (e.compatibleVersion = 6), e.compatibleVersion > 1 && (!i.version || i.version < e.compatibleVersion) && d.INVALIDPLAYLIST("EXT-X-VERSION needs to be ".concat(e.compatibleVersion, " or higher.")), i;
                }
                t.exports = function (t) {
                  var e = {
                      version: void 0,
                      isMasterPlaylist: void 0,
                      hasMap: !1,
                      targetDuration: 0,
                      compatibleVersion: 1,
                      isClosedCaptionsNone: !1,
                      hash: {}
                    },
                    i = function (t, e) {
                      var i,
                        s = [],
                        a = r(t.split("\n"));
                      try {
                        for (a.s(); !(i = a.n()).done;) {
                          var o = i.value,
                            c = n.from(o.trim()).toString();
                          if (c) if (c.startsWith("#")) {
                            if (c.startsWith("#EXT")) {
                              var u = U(c, e);
                              u && s.push(u);
                            }
                          } else s.push(c);
                        }
                      } catch (t) {
                        a.e(t);
                      } finally {
                        a.f();
                      }
                      return 0 !== s.length && "EXTM3U" === s[0].name || d.INVALIDPLAYLIST("The EXTM3U tag MUST be the first line."), s;
                    }(t, e),
                    s = V(i, e);
                  return s.source = t, s;
                };
              },
              367: function _(t, e, i) {
                function s(t) {
                  return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t;
                  } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                  }, s(t);
                }
                function n(t, e) {
                  return function (t) {
                    if (Array.isArray(t)) return t;
                  }(t) || function (t, e) {
                    var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != i) {
                      var s,
                        n,
                        r,
                        a,
                        o = [],
                        d = !0,
                        c = !1;
                      try {
                        if (r = (i = i.call(t)).next, 0 === e) {
                          if (Object(i) !== i) return;
                          d = !1;
                        } else for (; !(d = (s = r.call(i)).done) && (o.push(s.value), o.length !== e); d = !0);
                      } catch (t) {
                        c = !0, n = t;
                      } finally {
                        try {
                          if (!d && null != i.return && (a = i.return(), Object(a) !== a)) return;
                        } finally {
                          if (c) throw n;
                        }
                      }
                      return o;
                    }
                  }(t, e) || a(t, e) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }();
                }
                function r(t, e) {
                  var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                  if (!i) {
                    if (Array.isArray(t) || (i = a(t)) || e && t && "number" == typeof t.length) {
                      i && (t = i);
                      var s = 0,
                        n = function n() {};
                      return {
                        s: n,
                        n: function n() {
                          return s >= t.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: t[s++]
                          };
                        },
                        e: function e(t) {
                          throw t;
                        },
                        f: n
                      };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }
                  var r,
                    o = !0,
                    d = !1;
                  return {
                    s: function s() {
                      i = i.call(t);
                    },
                    n: function n() {
                      var t = i.next();
                      return o = t.done, t;
                    },
                    e: function e(t) {
                      d = !0, r = t;
                    },
                    f: function f() {
                      try {
                        o || null == i.return || i.return();
                      } finally {
                        if (d) throw r;
                      }
                    }
                  };
                }
                function a(t, e) {
                  if (t) {
                    if ("string" == typeof t) return o(t, e);
                    var i = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? o(t, e) : void 0;
                  }
                }
                function o(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];
                  return s;
                }
                function d(t, e) {
                  for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, (r = function (t, e) {
                      if ("object" !== s(t) || null === t) return t;
                      var i = t[Symbol.toPrimitive];
                      if (void 0 !== i) {
                        var n = i.call(t, "string");
                        if ("object" !== s(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                      }
                      return String(t);
                    }(n.key), "symbol" === s(r) ? r : String(r)), n);
                  }
                  var r;
                }
                function c() {
                  return c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (t, e, i) {
                    var s = function (t, e) {
                      for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = g(t)););
                      return t;
                    }(t, e);
                    if (s) {
                      var n = Object.getOwnPropertyDescriptor(s, e);
                      return n.get ? n.get.call(arguments.length < 3 ? t : i) : n.value;
                    }
                  }, c.apply(this, arguments);
                }
                function u(t, e) {
                  if (e && ("object" === s(e) || "function" == typeof e)) return e;
                  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                  return function (t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                  }(t);
                }
                function l(t) {
                  var e = "function" == typeof Map ? new Map() : void 0;
                  return l = function l(t) {
                    if (null === t || (i = t, -1 === Function.toString.call(i).indexOf("[native code]"))) return t;
                    var i;
                    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== e) {
                      if (e.has(t)) return e.get(t);
                      e.set(t, s);
                    }
                    function s() {
                      return h(t, arguments, g(this).constructor);
                    }
                    return s.prototype = Object.create(t.prototype, {
                      constructor: {
                        value: s,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                      }
                    }), f(s, t);
                  }, l(t);
                }
                function h(t, e, i) {
                  return h = p() ? Reflect.construct.bind() : function (t, e, i) {
                    var s = [null];
                    s.push.apply(s, e);
                    var n = new (Function.bind.apply(t, s))();
                    return i && f(n, i.prototype), n;
                  }, h.apply(null, arguments);
                }
                function p() {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (t) {
                    return !1;
                  }
                }
                function f(t, e) {
                  return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
                    return t.__proto__ = e, t;
                  }, f(t, e);
                }
                function g(t) {
                  return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                  }, g(t);
                }
                var m = i(771),
                  v = ["#EXTINF", "#EXT-X-BYTERANGE", "#EXT-X-DISCONTINUITY", "#EXT-X-STREAM-INF", "#EXT-X-CUE-OUT", "#EXT-X-CUE-IN", "#EXT-X-KEY", "#EXT-X-MAP"],
                  y = ["#EXT-X-MEDIA"],
                  T = function (t) {
                    !function (t, e) {
                      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                      t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                          value: t,
                          writable: !0,
                          configurable: !0
                        }
                      }), Object.defineProperty(t, "prototype", {
                        writable: !1
                      }), e && f(t, e);
                    }(a, t);
                    var e,
                      i,
                      s,
                      n,
                      r = (e = a, i = p(), function () {
                        var t,
                          s = g(e);
                        if (i) {
                          var n = g(this).constructor;
                          t = Reflect.construct(s, arguments, n);
                        } else t = s.apply(this, arguments);
                        return u(this, t);
                      });
                    function a(t) {
                      var e;
                      return function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                      }(this, a), (e = r.call(this)).baseUri = t, e;
                    }
                    return s = a, n = [{
                      key: "push",
                      value: function value() {
                        for (var t = this, e = arguments.length, i = new Array(e), s = 0; s < e; s++) i[s] = arguments[s];
                        for (var n = function n() {
                            var e = o[r];
                            if (!e.startsWith("#")) return c(g(a.prototype), "push", t).call(t, e), "continue";
                            if (v.some(function (t) {
                              return e.startsWith(t);
                            })) return c(g(a.prototype), "push", t).call(t, e), "continue";
                            if (t.includes(e)) {
                              if (y.some(function (t) {
                                return e.startsWith(t);
                              })) return "continue";
                              m.INVALIDPLAYLIST("Redundant item (".concat(e, ")"));
                            }
                            c(g(a.prototype), "push", t).call(t, e);
                          }, r = 0, o = i; r < o.length; r++) n();
                      }
                    }], n && d(s.prototype, n), Object.defineProperty(s, "prototype", {
                      writable: !1
                    }), a;
                  }(l(Array));
                function S(t, e) {
                  var i = 1e3;
                  e && (i = Math.pow(10, e));
                  var s = Math.round(t * i) / i;
                  return e ? s.toFixed(e) : s;
                }
                function E(t) {
                  var e = ['DATA-ID="'.concat(t.id, '"')];
                  return t.language && e.push('LANGUAGE="'.concat(t.language, '"')), t.value ? e.push('VALUE="'.concat(t.value, '"')) : t.uri && e.push('URI="'.concat(t.uri, '"')), "#EXT-X-SESSION-DATA:".concat(e.join(","));
                }
                function b(t, e) {
                  var i = e ? "#EXT-X-SESSION-KEY" : "#EXT-X-KEY",
                    s = ["METHOD=".concat(t.method)];
                  return t.uri && s.push('URI="'.concat(t.uri, '"')), t.iv && (16 !== t.iv.length && m.INVALIDPLAYLIST("IV must be a 128-bit unsigned integer"), s.push("IV=".concat(m.byteSequenceToHex(t.iv)))), t.format && s.push('KEYFORMAT="'.concat(t.format, '"')), t.formatVersion && s.push('KEYFORMATVERSIONS="'.concat(t.formatVersion, '"')), "".concat(i, ":").concat(s.join(","));
                }
                function A(t, e) {
                  var i = e.isIFrameOnly ? "#EXT-X-I-FRAME-STREAM-INF" : "#EXT-X-STREAM-INF",
                    s = ["BANDWIDTH=".concat(e.bandwidth)];
                  if (e.averageBandwidth && s.push("AVERAGE-BANDWIDTH=".concat(e.averageBandwidth)), e.isIFrameOnly && s.push('URI="'.concat(e.uri, '"')), e.codecs && s.push('CODECS="'.concat(e.codecs, '"')), e.resolution && s.push("RESOLUTION=".concat(e.resolution.width, "x").concat(e.resolution.height)), e.frameRate && s.push("FRAME-RATE=".concat(S(e.frameRate, 3))), e.hdcpLevel && s.push("HDCP-LEVEL=".concat(e.hdcpLevel)), e.audio.length > 0) {
                    s.push('AUDIO="'.concat(e.audio[0].groupId, '"'));
                    var n,
                      a = r(e.audio);
                    try {
                      for (a.s(); !(n = a.n()).done;) {
                        var o = n.value;
                        t.push(w(o));
                      }
                    } catch (t) {
                      a.e(t);
                    } finally {
                      a.f();
                    }
                  }
                  if (e.video.length > 0) {
                    s.push('VIDEO="'.concat(e.video[0].groupId, '"'));
                    var d,
                      c = r(e.video);
                    try {
                      for (c.s(); !(d = c.n()).done;) {
                        var u = d.value;
                        t.push(w(u));
                      }
                    } catch (t) {
                      c.e(t);
                    } finally {
                      c.f();
                    }
                  }
                  if (e.subtitles.length > 0) {
                    s.push('SUBTITLES="'.concat(e.subtitles[0].groupId, '"'));
                    var l,
                      h = r(e.subtitles);
                    try {
                      for (h.s(); !(l = h.n()).done;) {
                        var p = l.value;
                        t.push(w(p));
                      }
                    } catch (t) {
                      h.e(t);
                    } finally {
                      h.f();
                    }
                  }
                  if (m.getOptions().allowClosedCaptionsNone && 0 === e.closedCaptions.length) s.push("CLOSED-CAPTIONS=NONE");else if (e.closedCaptions.length > 0) {
                    s.push('CLOSED-CAPTIONS="'.concat(e.closedCaptions[0].groupId, '"'));
                    var f,
                      g = r(e.closedCaptions);
                    try {
                      for (g.s(); !(f = g.n()).done;) {
                        var v = f.value;
                        t.push(w(v));
                      }
                    } catch (t) {
                      g.e(t);
                    } finally {
                      g.f();
                    }
                  }
                  if (e.score && s.push("SCORE=".concat(e.score)), e.allowedCpc) {
                    var y,
                      T = [],
                      E = r(e.allowedCpc);
                    try {
                      for (E.s(); !(y = E.n()).done;) {
                        var b = y.value,
                          A = b.format,
                          _ = b.cpcList;
                        T.push("".concat(A, ":").concat(_.join("/")));
                      }
                    } catch (t) {
                      E.e(t);
                    } finally {
                      E.f();
                    }
                    s.push('ALLOWED-CPC="'.concat(T.join(","), '"'));
                  }
                  e.videoRange && s.push("VIDEO-RANGE=".concat(e.videoRange)), e.stableVariantId && s.push('STABLE-VARIANT-ID="'.concat(e.stableVariantId, '"')), t.push("".concat(i, ":").concat(s.join(","))), e.isIFrameOnly || t.push("".concat(e.uri));
                }
                function w(t) {
                  var e = ["TYPE=".concat(t.type), 'GROUP-ID="'.concat(t.groupId, '"'), 'NAME="'.concat(t.name, '"')];
                  return void 0 !== t.isDefault && e.push("DEFAULT=".concat(t.isDefault ? "YES" : "NO")), void 0 !== t.autoselect && e.push("AUTOSELECT=".concat(t.autoselect ? "YES" : "NO")), void 0 !== t.forced && e.push("FORCED=".concat(t.forced ? "YES" : "NO")), t.language && e.push('LANGUAGE="'.concat(t.language, '"')), t.assocLanguage && e.push('ASSOC-LANGUAGE="'.concat(t.assocLanguage, '"')), t.instreamId && e.push('INSTREAM-ID="'.concat(t.instreamId, '"')), t.characteristics && e.push('CHARACTERISTICS="'.concat(t.characteristics, '"')), t.channels && e.push('CHANNELS="'.concat(t.channels, '"')), t.uri && e.push('URI="'.concat(t.uri, '"')), "#EXT-X-MEDIA:".concat(e.join(","));
                }
                function _(t, e, i, s) {
                  var n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
                    r = !1,
                    a = "";
                  if (e.discontinuity && t.push("#EXT-X-DISCONTINUITY"), e.key) {
                    var o = b(e.key);
                    o !== i && (t.push(o), i = o);
                  }
                  if (e.map) {
                    var d = function (t) {
                      var e = ['URI="'.concat(t.uri, '"')];
                      return t.byterange && e.push('BYTERANGE="'.concat(I(t.byterange), '"')), "#EXT-X-MAP:".concat(e.join(","));
                    }(e.map);
                    d !== s && (t.push(d), s = d);
                  }
                  if (e.programDateTime && t.push("#EXT-X-PROGRAM-DATE-TIME:".concat(m.formatDate(e.programDateTime))), e.dateRange && t.push(function (t) {
                    var e = ['ID="'.concat(t.id, '"')];
                    t.start && e.push('START-DATE="'.concat(m.formatDate(t.start), '"')), t.end && e.push('END-DATE="'.concat(t.end, '"')), t.duration && e.push("DURATION=".concat(t.duration)), t.plannedDuration && e.push("PLANNED-DURATION=".concat(t.plannedDuration)), t.classId && e.push('CLASS="'.concat(t.classId, '"')), t.endOnNext && e.push("END-ON-NEXT=YES");
                    for (var i = 0, s = Object.keys(t.attributes); i < s.length; i++) {
                      var n = s[i];
                      n.startsWith("X-") ? "number" == typeof t.attributes[n] ? e.push("".concat(n, "=").concat(t.attributes[n])) : e.push("".concat(n, '="').concat(t.attributes[n], '"')) : n.startsWith("SCTE35-") && e.push("".concat(n, "=").concat(m.byteSequenceToHex(t.attributes[n])));
                    }
                    return "#EXT-X-DATERANGE:".concat(e.join(","));
                  }(e.dateRange)), e.markers.length > 0 && (a = N(t, e.markers)), e.parts.length > 0 && (r = P(t, e.parts)), r) return [i, s];
                  var c = n < 3 ? Math.round(e.duration) : S(e.duration, function (t) {
                    var e = t.toString(10),
                      i = e.indexOf(".");
                    return -1 === i ? 0 : e.length - i - 1;
                  }(e.duration));
                  return t.push("#EXTINF:".concat(c, ",").concat(unescape(encodeURIComponent(e.title || "")))), e.byterange && t.push("#EXT-X-BYTERANGE:".concat(I(e.byterange))), Array.prototype.push.call(t, "".concat(e.uri)), [i, s, a];
                }
                function I(t) {
                  var e = t.offset,
                    i = t.length;
                  return "".concat(i, "@").concat(e);
                }
                function N(t, e) {
                  var i,
                    s = "",
                    n = r(e);
                  try {
                    for (n.s(); !(i = n.n()).done;) {
                      var a = i.value;
                      if ("OUT" === a.type) s = "OUT", t.push("#EXT-X-CUE-OUT:DURATION=".concat(a.duration));else if ("IN" === a.type) s = "IN", t.push("#EXT-X-CUE-IN");else if ("RAW" === a.type) {
                        var o = a.value ? ":".concat(a.value) : "";
                        t.push("#".concat(a.tagName).concat(o));
                      }
                    }
                  } catch (t) {
                    n.e(t);
                  } finally {
                    n.f();
                  }
                  return s;
                }
                function P(t, e) {
                  var i,
                    s = !1,
                    n = r(e);
                  try {
                    for (n.s(); !(i = n.n()).done;) {
                      var a = i.value;
                      if (a.hint) {
                        var o = [];
                        if (o.push("TYPE=PART", 'URI="'.concat(a.uri, '"')), a.byterange) {
                          var d = a.byterange,
                            c = d.offset,
                            u = d.length;
                          o.push("BYTERANGE-START=".concat(c)), u && o.push("BYTERANGE-LENGTH=".concat(u));
                        }
                        t.push("#EXT-X-PRELOAD-HINT:".concat(o.join(","))), s = !0;
                      } else {
                        var l = [];
                        l.push("DURATION=".concat(a.duration), 'URI="'.concat(a.uri, '"')), a.byterange && l.push("BYTERANGE=".concat(I(a.byterange))), a.independent && l.push("INDEPENDENT=YES"), a.gap && l.push("GAP=YES"), t.push("#EXT-X-PART:".concat(l.join(",")));
                      }
                    }
                  } catch (t) {
                    n.e(t);
                  } finally {
                    n.f();
                  }
                  return s;
                }
                t.exports = function (t) {
                  m.PARAMCHECK(t), m.ASSERT("Not a playlist", "playlist" === t.type);
                  var e = new T(t.uri);
                  return e.push("#EXTM3U"), t.version && e.push("#EXT-X-VERSION:".concat(t.version)), t.independentSegments && e.push("#EXT-X-INDEPENDENT-SEGMENTS"), t.start && e.push("#EXT-X-START:TIME-OFFSET=".concat(S(t.start.offset)).concat(t.start.precise ? ",PRECISE=YES" : "")), t.isMasterPlaylist ? function (t, e) {
                    var i,
                      s = r(e.sessionDataList);
                    try {
                      for (s.s(); !(i = s.n()).done;) {
                        var n = i.value;
                        t.push(E(n));
                      }
                    } catch (t) {
                      s.e(t);
                    } finally {
                      s.f();
                    }
                    var a,
                      o = r(e.sessionKeyList);
                    try {
                      for (o.s(); !(a = o.n()).done;) {
                        var d = a.value;
                        t.push(b(d, !0));
                      }
                    } catch (t) {
                      o.e(t);
                    } finally {
                      o.f();
                    }
                    var c,
                      u = r(e.variants);
                    try {
                      for (u.s(); !(c = u.n()).done;) A(t, c.value);
                    } catch (t) {
                      u.e(t);
                    } finally {
                      u.f();
                    }
                  }(e, t) : function (t, e) {
                    var i = "",
                      s = "",
                      a = !1;
                    if (e.targetDuration && t.push("#EXT-X-TARGETDURATION:".concat(e.targetDuration)), e.lowLatencyCompatibility) {
                      var o = e.lowLatencyCompatibility,
                        d = o.canBlockReload,
                        c = o.canSkipUntil,
                        u = o.holdBack,
                        l = o.partHoldBack,
                        h = [];
                      h.push("CAN-BLOCK-RELOAD=".concat(d ? "YES" : "NO")), void 0 !== c && h.push("CAN-SKIP-UNTIL=".concat(c)), void 0 !== u && h.push("HOLD-BACK=".concat(u)), void 0 !== l && h.push("PART-HOLD-BACK=".concat(l)), t.push("#EXT-X-SERVER-CONTROL:".concat(h.join(",")));
                    }
                    e.partTargetDuration && t.push("#EXT-X-PART-INF:PART-TARGET=".concat(e.partTargetDuration)), e.mediaSequenceBase && t.push("#EXT-X-MEDIA-SEQUENCE:".concat(e.mediaSequenceBase)), e.discontinuitySequenceBase && t.push("#EXT-X-DISCONTINUITY-SEQUENCE:".concat(e.discontinuitySequenceBase)), e.playlistType && t.push("#EXT-X-PLAYLIST-TYPE:".concat(e.playlistType)), e.isIFrame && t.push("#EXT-X-I-FRAMES-ONLY"), e.skip > 0 && t.push("#EXT-X-SKIP:SKIPPED-SEGMENTS=".concat(e.skip));
                    var p,
                      f = r(e.segments);
                    try {
                      for (f.s(); !(p = f.n()).done;) {
                        var g,
                          v = n(_(t, p.value, i, s, e.version), 3);
                        i = v[0], s = v[1], "OUT" === (g = v[2]) ? a = !0 : "IN" === g && a && (a = !1);
                      }
                    } catch (t) {
                      f.e(t);
                    } finally {
                      f.f();
                    }
                    "VOD" === e.playlistType && a && t.push("#EXT-X-CUE-IN"), e.prefetchSegments.length > 2 && m.INVALIDPLAYLIST("The server must deliver no more than two prefetch segments");
                    var y,
                      T = r(e.prefetchSegments);
                    try {
                      for (T.s(); !(y = T.n()).done;) {
                        var S = y.value;
                        S.discontinuity && t.push("#EXT-X-PREFETCH-DISCONTINUITY"), t.push("#EXT-X-PREFETCH:".concat(S.uri));
                      }
                    } catch (t) {
                      T.e(t);
                    } finally {
                      T.f();
                    }
                    e.endlist && t.push("#EXT-X-ENDLIST");
                    var E,
                      b = r(e.renditionReports);
                    try {
                      for (b.s(); !(E = b.n()).done;) {
                        var A = E.value,
                          w = [];
                        w.push('URI="'.concat(A.uri, '"'), "LAST-MSN=".concat(A.lastMSN)), void 0 !== A.lastPart && w.push("LAST-PART=".concat(A.lastPart)), t.push("#EXT-X-RENDITION-REPORT:".concat(w.join(",")));
                      }
                    } catch (t) {
                      b.e(t);
                    } finally {
                      b.f();
                    }
                  }(e, t), e.join("\n");
                };
              },
              890: function _(t, e, i) {
                function s(t) {
                  return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t;
                  } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                  }, s(t);
                }
                function n(t, e) {
                  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                  t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                      value: t,
                      writable: !0,
                      configurable: !0
                    }
                  }), Object.defineProperty(t, "prototype", {
                    writable: !1
                  }), e && r(t, e);
                }
                function r(t, e) {
                  return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
                    return t.__proto__ = e, t;
                  }, r(t, e);
                }
                function a(t) {
                  var e = function () {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                    } catch (t) {
                      return !1;
                    }
                  }();
                  return function () {
                    var i,
                      s = d(t);
                    if (e) {
                      var n = d(this).constructor;
                      i = Reflect.construct(s, arguments, n);
                    } else i = s.apply(this, arguments);
                    return o(this, i);
                  };
                }
                function o(t, e) {
                  if (e && ("object" === s(e) || "function" == typeof e)) return e;
                  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                  return function (t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                  }(t);
                }
                function d(t) {
                  return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                  }, d(t);
                }
                function c(t, e) {
                  for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, (r = function (t, e) {
                      if ("object" !== s(t) || null === t) return t;
                      var i = t[Symbol.toPrimitive];
                      if (void 0 !== i) {
                        var n = i.call(t, "string");
                        if ("object" !== s(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                      }
                      return String(t);
                    }(n.key), "symbol" === s(r) ? r : String(r)), n);
                  }
                  var r;
                }
                function u(t, e, i) {
                  return e && c(t.prototype, e), i && c(t, i), Object.defineProperty(t, "prototype", {
                    writable: !1
                  }), t;
                }
                function l(t, e) {
                  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }
                var h = i(771),
                  p = u(function t(e) {
                    var i = e.type,
                      s = e.uri,
                      n = e.groupId,
                      r = e.language,
                      a = e.assocLanguage,
                      o = e.name,
                      d = e.isDefault,
                      c = e.autoselect,
                      u = e.forced,
                      p = e.instreamId,
                      f = e.characteristics,
                      g = e.channels;
                    l(this, t), h.PARAMCHECK(i, n, o), h.CONDITIONALASSERT(["SUBTITLES" === i, s], ["CLOSED-CAPTIONS" === i, p], ["CLOSED-CAPTIONS" === i, !s], [u, "SUBTITLES" === i]), this.type = i, this.uri = s, this.groupId = n, this.language = r, this.assocLanguage = a, this.name = o, this.isDefault = d, this.autoselect = c, this.forced = u, this.instreamId = p, this.characteristics = f, this.channels = g;
                  }),
                  f = u(function t(e) {
                    var i = e.uri,
                      s = e.isIFrameOnly,
                      n = void 0 !== s && s,
                      r = e.bandwidth,
                      a = e.averageBandwidth,
                      o = e.score,
                      d = e.codecs,
                      c = e.resolution,
                      u = e.frameRate,
                      p = e.hdcpLevel,
                      f = e.allowedCpc,
                      g = e.videoRange,
                      m = e.stableVariantId,
                      v = e.audio,
                      y = void 0 === v ? [] : v,
                      T = e.video,
                      S = void 0 === T ? [] : T,
                      E = e.subtitles,
                      b = void 0 === E ? [] : E,
                      A = e.closedCaptions,
                      w = void 0 === A ? [] : A,
                      _ = e.currentRenditions,
                      I = void 0 === _ ? {
                        audio: 0,
                        video: 0,
                        subtitles: 0,
                        closedCaptions: 0
                      } : _;
                    l(this, t), h.PARAMCHECK(i, r), this.uri = i, this.isIFrameOnly = n, this.bandwidth = r, this.averageBandwidth = a, this.score = o, this.codecs = d, this.resolution = c, this.frameRate = u, this.hdcpLevel = p, this.allowedCpc = f, this.videoRange = g, this.stableVariantId = m, this.audio = y, this.video = S, this.subtitles = b, this.closedCaptions = w, this.currentRenditions = I;
                  }),
                  g = u(function t(e) {
                    var i = e.id,
                      s = e.value,
                      n = e.uri,
                      r = e.language;
                    l(this, t), h.PARAMCHECK(i, s || n), h.ASSERT("SessionData cannot have both value and uri, shoud be either.", !(s && n)), this.id = i, this.value = s, this.uri = n, this.language = r;
                  }),
                  m = u(function t(e) {
                    var i = e.method,
                      s = e.uri,
                      n = e.iv,
                      r = e.format,
                      a = e.formatVersion;
                    l(this, t), h.PARAMCHECK(i), h.CONDITIONALPARAMCHECK(["NONE" !== i, s]), h.CONDITIONALASSERT(["NONE" === i, !(s || n || r || a)]), this.method = i, this.uri = s, this.iv = n, this.format = r, this.formatVersion = a;
                  }),
                  v = u(function t(e) {
                    var i = e.hint,
                      s = void 0 !== i && i,
                      n = e.uri,
                      r = e.mimeType,
                      a = e.byterange;
                    l(this, t), h.PARAMCHECK(n), this.hint = s, this.uri = n, this.mimeType = r, this.byterange = a;
                  }),
                  y = u(function t(e) {
                    var i = e.id,
                      s = e.classId,
                      n = e.start,
                      r = e.end,
                      a = e.duration,
                      o = e.plannedDuration,
                      d = e.endOnNext,
                      c = e.attributes,
                      u = void 0 === c ? {} : c;
                    l(this, t), h.PARAMCHECK(i), h.CONDITIONALPARAMCHECK([!0 === d, s]), h.CONDITIONALASSERT([r, n], [r, n <= r], [a, a >= 0], [o, o >= 0]), this.id = i, this.classId = s, this.start = n, this.end = r, this.duration = a, this.plannedDuration = o, this.endOnNext = d, this.attributes = u;
                  }),
                  T = u(function t(e) {
                    var i = e.type,
                      s = e.duration,
                      n = e.tagName,
                      r = e.value;
                    l(this, t), h.PARAMCHECK(i), h.CONDITIONALPARAMCHECK(["OUT" === i, s]), h.CONDITIONALPARAMCHECK(["RAW" === i, n]), this.type = i, this.duration = s, this.tagName = n, this.value = r;
                  }),
                  S = u(function t(e) {
                    l(this, t), h.PARAMCHECK(e), this.type = e;
                  }),
                  E = function (t) {
                    n(i, t);
                    var e = a(i);
                    function i(t) {
                      var s,
                        n = t.isMasterPlaylist,
                        r = t.uri,
                        a = t.version,
                        o = t.independentSegments,
                        d = void 0 !== o && o,
                        c = t.start,
                        u = t.source;
                      return l(this, i), s = e.call(this, "playlist"), h.PARAMCHECK(n), s.isMasterPlaylist = n, s.uri = r, s.version = a, s.independentSegments = d, s.start = c, s.source = u, s;
                    }
                    return u(i);
                  }(S),
                  b = function (t) {
                    n(i, t);
                    var e = a(i);
                    function i() {
                      var t,
                        s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                      l(this, i), s.isMasterPlaylist = !0, t = e.call(this, s);
                      var n = s.variants,
                        r = void 0 === n ? [] : n,
                        a = s.currentVariant,
                        o = s.sessionDataList,
                        d = void 0 === o ? [] : o,
                        c = s.sessionKeyList,
                        u = void 0 === c ? [] : c;
                      return t.variants = r, t.currentVariant = a, t.sessionDataList = d, t.sessionKeyList = u, t;
                    }
                    return u(i);
                  }(E),
                  A = function (t) {
                    n(i, t);
                    var e = a(i);
                    function i() {
                      var t,
                        s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                      l(this, i), s.isMasterPlaylist = !1, t = e.call(this, s);
                      var n = s.targetDuration,
                        r = s.mediaSequenceBase,
                        a = void 0 === r ? 0 : r,
                        o = s.discontinuitySequenceBase,
                        d = void 0 === o ? 0 : o,
                        c = s.endlist,
                        u = void 0 !== c && c,
                        h = s.playlistType,
                        p = s.isIFrame,
                        f = s.segments,
                        g = void 0 === f ? [] : f,
                        m = s.prefetchSegments,
                        v = void 0 === m ? [] : m,
                        y = s.lowLatencyCompatibility,
                        T = s.partTargetDuration,
                        S = s.renditionReports,
                        E = void 0 === S ? [] : S,
                        b = s.skip,
                        A = void 0 === b ? 0 : b,
                        w = s.hash;
                      return t.targetDuration = n, t.mediaSequenceBase = a, t.discontinuitySequenceBase = d, t.endlist = u, t.playlistType = h, t.isIFrame = p, t.segments = g, t.prefetchSegments = v, t.lowLatencyCompatibility = y, t.partTargetDuration = T, t.renditionReports = E, t.skip = A, t.hash = w, t;
                    }
                    return u(i);
                  }(E),
                  w = function (t) {
                    n(i, t);
                    var e = a(i);
                    function i(t) {
                      var s,
                        n = t.uri,
                        r = t.mimeType,
                        a = t.data,
                        o = t.duration,
                        d = t.title,
                        c = t.byterange,
                        u = t.discontinuity,
                        h = t.mediaSequenceNumber,
                        p = void 0 === h ? 0 : h,
                        f = t.discontinuitySequence,
                        g = void 0 === f ? 0 : f,
                        m = t.key,
                        v = t.map,
                        y = t.programDateTime,
                        T = t.dateRange,
                        S = t.markers,
                        E = void 0 === S ? [] : S,
                        b = t.parts,
                        A = void 0 === b ? [] : b;
                      return l(this, i), (s = e.call(this, "segment")).uri = n, s.mimeType = r, s.data = a, s.duration = o, s.title = d, s.byterange = c, s.discontinuity = u, s.mediaSequenceNumber = p, s.discontinuitySequence = g, s.key = m, s.map = v, s.programDateTime = y, s.dateRange = T, s.markers = E, s.parts = A, s;
                    }
                    return u(i);
                  }(S),
                  _ = function (t) {
                    n(i, t);
                    var e = a(i);
                    function i(t) {
                      var s,
                        n = t.hint,
                        r = void 0 !== n && n,
                        a = t.uri,
                        o = t.duration,
                        d = t.independent,
                        c = t.byterange,
                        u = t.gap;
                      return l(this, i), s = e.call(this, "part"), h.PARAMCHECK(a), s.hint = r, s.uri = a, s.duration = o, s.independent = d, s.duration = o, s.byterange = c, s.gap = u, s;
                    }
                    return u(i);
                  }(S),
                  I = function (t) {
                    n(i, t);
                    var e = a(i);
                    function i(t) {
                      var s,
                        n = t.uri,
                        r = t.discontinuity,
                        a = t.mediaSequenceNumber,
                        o = void 0 === a ? 0 : a,
                        d = t.discontinuitySequence,
                        c = void 0 === d ? 0 : d,
                        u = t.key;
                      return l(this, i), s = e.call(this, "prefetch"), h.PARAMCHECK(n), s.uri = n, s.discontinuity = r, s.mediaSequenceNumber = o, s.discontinuitySequence = c, s.key = u, s;
                    }
                    return u(i);
                  }(S),
                  N = u(function t(e) {
                    var i = e.uri,
                      s = e.lastMSN,
                      n = e.lastPart;
                    l(this, t), h.PARAMCHECK(i), this.uri = i, this.lastMSN = s, this.lastPart = n;
                  });
                t.exports = {
                  Rendition: p,
                  Variant: f,
                  SessionData: g,
                  Key: m,
                  MediaInitializationSection: v,
                  DateRange: y,
                  SpliceInfo: T,
                  Playlist: E,
                  MasterPlaylist: b,
                  MediaPlaylist: A,
                  Segment: w,
                  PartialSegment: _,
                  PrefetchSegment: I,
                  RenditionReport: N
                };
              },
              771: function _(t) {
                function e(t, e) {
                  return function (t) {
                    if (Array.isArray(t)) return t;
                  }(t) || function (t, e) {
                    var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                    if (null != i) {
                      var s,
                        n,
                        r,
                        a,
                        o = [],
                        d = !0,
                        c = !1;
                      try {
                        if (r = (i = i.call(t)).next, 0 === e) {
                          if (Object(i) !== i) return;
                          d = !1;
                        } else for (; !(d = (s = r.call(i)).done) && (o.push(s.value), o.length !== e); d = !0);
                      } catch (t) {
                        c = !0, n = t;
                      } finally {
                        try {
                          if (!d && null != i.return && (a = i.return(), Object(a) !== a)) return;
                        } finally {
                          if (c) throw n;
                        }
                      }
                      return o;
                    }
                  }(t, e) || s(t, e) || function () {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }();
                }
                function i(t, e) {
                  var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                  if (!i) {
                    if (Array.isArray(t) || (i = s(t)) || e && t && "number" == typeof t.length) {
                      i && (t = i);
                      var _n6 = 0,
                        r = function r() {};
                      return {
                        s: r,
                        n: function n() {
                          return _n6 >= t.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: t[_n6++]
                          };
                        },
                        e: function e(t) {
                          throw t;
                        },
                        f: r
                      };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }
                  var a,
                    o = !0,
                    d = !1;
                  return {
                    s: function s() {
                      i = i.call(t);
                    },
                    n: function n() {
                      var t = i.next();
                      return o = t.done, t;
                    },
                    e: function e(t) {
                      d = !0, a = t;
                    },
                    f: function f() {
                      try {
                        o || null == i.return || i.return();
                      } finally {
                        if (d) throw a;
                      }
                    }
                  };
                }
                function s(t, e) {
                  if (t) {
                    if ("string" == typeof t) return r(t, e);
                    var i = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? r(t, e) : void 0;
                  }
                }
                function r(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];
                  return s;
                }
                var a = {};
                function o(t) {
                  if (a.strictMode) throw t;
                  a.silent || console.error(t.message);
                }
                function d(t) {
                  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10;
                  if ("number" == typeof t) return t;
                  var i = 10 === e ? Number.parseFloat(t, e) : Number.parseInt(t, e);
                  return Number.isNaN(i) ? 0 : i;
                }
                t.exports = {
                  THROW: o,
                  ASSERT: function ASSERT(t) {
                    for (var s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), r = 1; r < s; r++) n[r - 1] = arguments[r];
                    var a,
                      d = i(n.entries());
                    try {
                      for (d.s(); !(a = d.n()).done;) {
                        var c = e(a.value, 2),
                          u = c[0];
                        c[1] || o(new Error("".concat(t, " : Failed at [").concat(u, "]")));
                      }
                    } catch (t) {
                      d.e(t);
                    } finally {
                      d.f();
                    }
                  },
                  CONDITIONALASSERT: function CONDITIONALASSERT() {
                    for (var t = arguments.length, s = new Array(t), n = 0; n < t; n++) s[n] = arguments[n];
                    var r,
                      a = i(s.entries());
                    try {
                      for (a.s(); !(r = a.n()).done;) {
                        var d = e(r.value, 2),
                          c = d[0],
                          u = e(d[1], 2),
                          l = u[0],
                          h = u[1];
                        l && (h || o(new Error("Conditional Assert : Failed at [".concat(c, "]"))));
                      }
                    } catch (t) {
                      a.e(t);
                    } finally {
                      a.f();
                    }
                  },
                  PARAMCHECK: function PARAMCHECK() {
                    for (var t = arguments.length, s = new Array(t), n = 0; n < t; n++) s[n] = arguments[n];
                    var r,
                      a = i(s.entries());
                    try {
                      for (a.s(); !(r = a.n()).done;) {
                        var d = e(r.value, 2),
                          c = d[0];
                        void 0 === d[1] && o(new Error("Param Check : Failed at [".concat(c, "]")));
                      }
                    } catch (t) {
                      a.e(t);
                    } finally {
                      a.f();
                    }
                  },
                  CONDITIONALPARAMCHECK: function CONDITIONALPARAMCHECK() {
                    for (var t = arguments.length, s = new Array(t), n = 0; n < t; n++) s[n] = arguments[n];
                    var r,
                      a = i(s.entries());
                    try {
                      for (a.s(); !(r = a.n()).done;) {
                        var d = e(r.value, 2),
                          c = d[0],
                          u = e(d[1], 2),
                          l = u[0],
                          h = u[1];
                        l && void 0 === h && o(new Error("Conditional Param Check : Failed at [".concat(c, "]")));
                      }
                    } catch (t) {
                      a.e(t);
                    } finally {
                      a.f();
                    }
                  },
                  INVALIDPLAYLIST: function INVALIDPLAYLIST(t) {
                    o(new Error("Invalid Playlist : ".concat(t)));
                  },
                  toNumber: d,
                  hexToByteSequence: function hexToByteSequence(t) {
                    (t.startsWith("0x") || t.startsWith("0X")) && (t = t.slice(2));
                    for (var e = [], i = 0; i < t.length; i += 2) e.push(d(t.slice(i, i + 2), 16));
                    return n.from(e);
                  },
                  byteSequenceToHex: function byteSequenceToHex(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length;
                    i <= e && o(new Error("end must be larger than start : start=".concat(e, ", end=").concat(i)));
                    for (var s = [], n = e; n < i; n++) s.push("0".concat((255 & t[n]).toString(16).toUpperCase()).slice(-2));
                    return "0x".concat(s.join(""));
                  },
                  tryCatch: function tryCatch(t, e) {
                    try {
                      return t();
                    } catch (t) {
                      return e(t);
                    }
                  },
                  splitAt: function splitAt(t, e) {
                    for (var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, s = -1, n = 0, r = 0; n < t.length; n++) if (t[n] === e) {
                      if (r++ === i) return [t.slice(0, n), t.slice(n + 1)];
                      s = n;
                    }
                    return -1 !== s ? [t.slice(0, s), t.slice(s + 1)] : [t];
                  },
                  trim: function trim(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
                    return t ? (t = t.trim(), " " === e || (t.startsWith(e) && (t = t.slice(1)), t.endsWith(e) && (t = t.slice(0, -1))), t) : t;
                  },
                  splitByCommaWithPreservingQuotes: function splitByCommaWithPreservingQuotes(t) {
                    for (var e = [], i = !0, s = 0, n = [], r = 0; r < t.length; r++) {
                      var a = t[r];
                      i && "," === a ? (e.push(t.slice(s, r).trim()), s = r + 1) : '"' !== a && "'" !== a || (i ? (n.push(a), i = !1) : a === n[n.length - 1] ? (n.pop(), i = !0) : n.push(a));
                    }
                    return e.push(t.slice(s).trim()), e;
                  },
                  camelify: function camelify(t) {
                    var e,
                      s = [],
                      n = !1,
                      r = i(t);
                    try {
                      for (r.s(); !(e = r.n()).done;) {
                        var a = e.value;
                        "-" !== a && "_" !== a ? n ? (s.push(a.toUpperCase()), n = !1) : s.push(a.toLowerCase()) : n = !0;
                      }
                    } catch (t) {
                      r.e(t);
                    } finally {
                      r.f();
                    }
                    return s.join("");
                  },
                  formatDate: function formatDate(t) {
                    var e = t.getUTCFullYear(),
                      i = ("0" + (t.getUTCMonth() + 1)).slice(-2),
                      s = ("0" + t.getUTCDate()).slice(-2),
                      n = ("0" + t.getUTCHours()).slice(-2),
                      r = ("0" + t.getUTCMinutes()).slice(-2),
                      a = ("0" + t.getUTCSeconds()).slice(-2),
                      o = ("00" + t.getUTCMilliseconds()).slice(-3);
                    return "".concat(e, "-").concat(i, "-").concat(s, "T").concat(n, ":").concat(r, ":").concat(a, ".").concat(o, "Z");
                  },
                  hasOwnProp: function hasOwnProp(t, e) {
                    return Object.hasOwnProperty.call(t, e);
                  },
                  setOptions: function setOptions() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    a = Object.assign(a, t);
                  },
                  getOptions: function getOptions() {
                    return Object.assign({}, a);
                  }
                };
              }
            }, e = {}, function i(s) {
              var n = e[s];
              if (void 0 !== n) return n.exports;
              var r = e[s] = {
                exports: {}
              };
              return t[s](r, r.exports, i), r.exports;
            }(851);
            var t, e;
          }, t.exports = s();
        },
        9318: function _(t, e) {
          e.read = function (t, e, i, s, n) {
            var r,
              a,
              o = 8 * n - s - 1,
              d = (1 << o) - 1,
              c = d >> 1,
              u = -7,
              l = i ? n - 1 : 0,
              h = i ? -1 : 1,
              p = t[e + l];
            for (l += h, r = p & (1 << -u) - 1, p >>= -u, u += o; u > 0; r = 256 * r + t[e + l], l += h, u -= 8);
            for (a = r & (1 << -u) - 1, r >>= -u, u += s; u > 0; a = 256 * a + t[e + l], l += h, u -= 8);
            if (0 === r) r = 1 - c;else {
              if (r === d) return a ? NaN : 1 / 0 * (p ? -1 : 1);
              a += Math.pow(2, s), r -= c;
            }
            return (p ? -1 : 1) * a * Math.pow(2, r - s);
          }, e.write = function (t, e, i, s, n, r) {
            var a,
              o,
              d,
              c = 8 * r - n - 1,
              u = (1 << c) - 1,
              l = u >> 1,
              h = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              p = s ? 0 : r - 1,
              f = s ? 1 : -1,
              g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = u) : (a = Math.floor(Math.log(e) / Math.LN2), e * (d = Math.pow(2, -a)) < 1 && (a--, d *= 2), (e += a + l >= 1 ? h / d : h * Math.pow(2, 1 - l)) * d >= 2 && (a++, d /= 2), a + l >= u ? (o = 0, a = u) : a + l >= 1 ? (o = (e * d - 1) * Math.pow(2, n), a += l) : (o = e * Math.pow(2, l - 1) * Math.pow(2, n), a = 0)); n >= 8; t[i + p] = 255 & o, p += f, o /= 256, n -= 8);
            for (a = a << n | o, c += n; c > 0; t[i + p] = 255 & a, p += f, a /= 256, c -= 8);
            t[i + p - f] |= 128 * g;
          };
        },
        9907: function _(t) {
          var e,
            i,
            s = t.exports = {};
          function n() {
            throw new Error("setTimeout has not been defined");
          }
          function r() {
            throw new Error("clearTimeout has not been defined");
          }
          function a(t) {
            if (e === setTimeout) return setTimeout(t, 0);
            if ((e === n || !e) && setTimeout) return e = setTimeout, setTimeout(t, 0);
            try {
              return e(t, 0);
            } catch (i) {
              try {
                return e.call(null, t, 0);
              } catch (i) {
                return e.call(this, t, 0);
              }
            }
          }
          !function () {
            try {
              e = "function" == typeof setTimeout ? setTimeout : n;
            } catch (t) {
              e = n;
            }
            try {
              i = "function" == typeof clearTimeout ? clearTimeout : r;
            } catch (t) {
              i = r;
            }
          }();
          var o,
            d = [],
            c = !1,
            u = -1;
          function l() {
            c && o && (c = !1, o.length ? d = o.concat(d) : u = -1, d.length && h());
          }
          function h() {
            if (!c) {
              var t = a(l);
              c = !0;
              for (var e = d.length; e;) {
                for (o = d, d = []; ++u < e;) o && o[u].run();
                u = -1, e = d.length;
              }
              o = null, c = !1, function (t) {
                if (i === clearTimeout) return clearTimeout(t);
                if ((i === r || !i) && clearTimeout) return i = clearTimeout, clearTimeout(t);
                try {
                  return i(t);
                } catch (e) {
                  try {
                    return i.call(null, t);
                  } catch (e) {
                    return i.call(this, t);
                  }
                }
              }(t);
            }
          }
          function p(t, e) {
            this.fun = t, this.array = e;
          }
          function f() {}
          s.nextTick = function (t) {
            var e = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var i = 1; i < arguments.length; i++) e[i - 1] = arguments[i];
            d.push(new p(t, e)), 1 !== d.length || c || a(h);
          }, p.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = f, s.addListener = f, s.once = f, s.off = f, s.removeListener = f, s.removeAllListeners = f, s.emit = f, s.prependListener = f, s.prependOnceListener = f, s.listeners = function (t) {
            return [];
          }, s.binding = function (t) {
            throw new Error("process.binding is not supported");
          }, s.cwd = function () {
            return "/";
          }, s.chdir = function (t) {
            throw new Error("process.chdir is not supported");
          }, s.umask = function () {
            return 0;
          };
        },
        3555: function _(t, e, i) {
          "use strict";

          i.r(e), i.d(e, {
            default: function _default() {
              return n;
            }
          });
          var s = i(2784);
          var n = /*#__PURE__*/function () {
            function n(t, e, i, _n7, r, a, o) {
              _classCallCheck(this, n);
              this.method = s.Method.GET, this.videoKey = i, this.service = t, this.method = _n7, this.params = e || {}, this.body = r, this.onSuccessCallback = a, this.onFailCallback = o;
            }
            _createClass(n, [{
              key: "getService",
              value: function getService() {
                return this.service;
              }
            }, {
              key: "getMethod",
              value: function getMethod() {
                var t;
                return null !== (t = this.method) && void 0 !== t ? t : s.Method.GET;
              }
            }, {
              key: "setMethod",
              value: function setMethod(t) {
                this.method = t;
              }
            }, {
              key: "getParams",
              value: function getParams() {
                return this.params;
              }
            }, {
              key: "getOnSuccess",
              value: function getOnSuccess() {
                return this.onSuccessCallback;
              }
            }, {
              key: "getOnFail",
              value: function getOnFail() {
                return this.onFailCallback;
              }
            }, {
              key: "getVideoKey",
              value: function getVideoKey() {
                return this.videoKey;
              }
            }, {
              key: "getParam",
              value: function getParam(t) {
                return this.params[t];
              }
            }, {
              key: "setParam",
              value: function setParam(t, e) {
                return this.params[t] = e, this;
              }
            }, {
              key: "setParams",
              value: function setParams(t) {
                this.params = t;
              }
            }, {
              key: "getBody",
              value: function getBody() {
                return this.body;
              }
            }, {
              key: "setBody",
              value: function setBody(t) {
                this.body = t;
              }
            }, {
              key: "isPost",
              value: function isPost() {
                return this.method === s.Method.POST;
              }
            }]);
            return n;
          }();
        },
        6075: function _(t, e, i) {
          "use strict";

          i.r(e), i.d(e, {
            default: function _default() {
              return d;
            }
          });
          var s = i(108),
            n = i(9065),
            r = i(3555),
            a = i(2784),
            o = i(61);
          var d = /*#__PURE__*/function () {
            function d(t) {
              _classCallCheck(this, d);
              this.readyToSend = !1, this.servicesToWait = [s.A.Service.INIT, s.A.Service.START], this.onWillSendVideoRequestListeners = [], this.pluginRef = t, this._requests = [], this._waitingForToken = [], this._waitingForMetadata = [];
            }
            _createClass(d, [{
              key: "shouldSendStats",
              value: function shouldSendStats() {
                return this.readyToSend;
              }
            }, {
              key: "sendRequest",
              value: function sendRequest(t) {
                var _this2 = this,
                  _this$_requests;
                if ("" === n.default.getInstance().getFastDataSessionToken()) return void this._waitingForToken.push(t);
                this._waitingForToken.forEach(function (t) {
                  return _this2.prepareParams(t);
                }), (_this$_requests = this._requests).push.apply(_this$_requests, _toConsumableArray(this._waitingForToken)), this._waitingForToken = [];
                var e = t.getVideoKey(),
                  i = t.getParams(),
                  s = t.getService();
                var _iterator = _createForOfIteratorHelper(this.onWillSendVideoRequestListeners),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var _t5 = _step.value;
                    _t5(s, e, i);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this.prepareParams(t), this._requests.push(t), this._processRequests();
              }
            }, {
              key: "prepareParams",
              value: function prepareParams(t) {
                var e = t.getService();
                e != s.A.Service.START && e != s.A.Service.PING || (t.setParam("pingTime", t.getParam("pingTime") || n.default.getInstance().getFastDataService().getPingTime()), n.default.getInstance().getCommonVariable("appAnalytics", "isEnabled") && t.setParam("sessionParent", t.getParam("sessionParent") || n.default.getInstance().getFastDataSessionToken()));
                var i = t.getVideoKey();
                this.pluginRef.videos.existsVideo(i) && t.setParam("code", t.getParam("code") || this.pluginRef.videos.getVideo(i).getViewCode()), e !== s.A.Service.INIT && e !== s.A.Service.START && e !== s.A.Service.ERROR || n.default.getInstance().getCommonVariable("appAnalytics", "isEnabled") && (t.setParam("parentId", t.getParam("sessionRoot")), t.setParam("navContext", t.getParam("navContext") || n.default.getInstance().getCommonVariable("appAnalytics", "context")));
              }
            }, {
              key: "buildRequest",
              value: function buildRequest(t, e, i, s, n, o) {
                i = null != i ? i : a.Method.GET;
                var _d2 = new r.default(t, e, "", i, s, n, o);
                return _d2.setMethod(i), _d2;
              }
            }, {
              key: "_processRequests",
              value: function _processRequests() {
                var _this3 = this;
                var t = this._requests;
                this._requests = [], t.forEach(function (t) {
                  if (-1 !== _this3.servicesToWait.indexOf(t.getService()) && (_this3.readyToSend = !0), _this3.readyToSend) {
                    for (; _this3._waitingForMetadata.length;) {
                      var _t6 = _this3._waitingForMetadata.shift();
                      n.default.getInstance().pushData(n.default.getInstance().getOptions().offline ? o.default.Consumer.PERSISTENT : o.default.Consumer.NQS, _t6.getService(), _t6.getMethod(), _t6.getParams(), _t6.getOnSuccess(), _t6.getOnFail());
                    }
                    n.default.getInstance().pushData(n.default.getInstance().getOptions().offline ? o.default.Consumer.PERSISTENT : o.default.Consumer.NQS, t.getService(), t.getMethod(), t.getParams(), t.getOnSuccess(), t.getOnFail());
                  } else _this3._waitingForMetadata.push(t);
                });
              }
            }]);
            return d;
          }();
        },
        2784: function _(t, e, i) {
          "use strict";

          var s;
          i.r(e), i.d(e, {
            AnalyticsTag: function AnalyticsTag() {
              return n;
            },
            AppAnalyticsTag: function AppAnalyticsTag() {
              return r;
            },
            BalancerTag: function BalancerTag() {
              return a;
            },
            CoreTag: function CoreTag() {
              return o;
            },
            Method: function Method() {
              return s;
            }
          }), function (t) {
            t.GET = "GET", t.POST = "POST";
          }(s || (s = {}));
          var n = "Analytics",
            r = "AppAnalytics",
            a = "Balancer",
            o = "Core";
        },
        7276: function _(t, e, i) {
          "use strict";

          var s;
          i.r(e), i.d(e, {
            LogLevel: function LogLevel() {
              return s;
            },
            default: function _default() {
              return n;
            }
          }), function (t) {
            t[t.SILENT = 6] = "SILENT", t[t.ERROR = 5] = "ERROR", t[t.WARNING = 4] = "WARNING", t[t.NOTICE = 3] = "NOTICE", t[t.DEBUG = 2] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE";
          }(s || (s = {}));
          var n = /*#__PURE__*/function () {
            function n() {
              _classCallCheck(this, n);
            }
            _createClass(n, null, [{
              key: "report",
              value: function report(t, e, i, r) {
                if ("undefined" != typeof console && console.log) {
                  r = r || "darkcyan";
                  var o = {
                    5: "e",
                    4: "w",
                    3: "n",
                    2: "d",
                    1: "v"
                  }[i = i || s.NOTICE];
                  var d = "[NPAW - ".concat(t, "]") + this._getCurrentTime() + " " + o + ":";
                  if (n.logLevel <= i) if (n.plainLogs || "undefined" != typeof document && document.documentMode) this._plainReport(e, d);else {
                    var _t7;
                    _t7 = i === s.ERROR && console.error ? console.error : i === s.WARNING && console.warn ? console.warn : i === s.DEBUG && console.debug ? console.debug : console.log, d = "%c" + d, a = e, "[object Array]" === Object.prototype.toString.call(a) ? (e.splice(0, 0, d, "color: " + r), _t7.apply(console, e)) : _t7.call(console, d, "color: " + r, e);
                  }
                }
                var a;
              }
            }, {
              key: "_getCurrentTime",
              value: function _getCurrentTime() {
                var t = new Date();
                return "[" + ("0" + t.getDate()).slice(-2) + ":" + ("0" + t.getMinutes()).slice(-2) + ":" + ("0" + t.getSeconds()).slice(-2) + "." + ("00" + t.getMilliseconds()).slice(-3) + "]";
              }
            }, {
              key: "_plainReport",
              value: function _plainReport(t, e) {
                if (t instanceof Array) for (var _i8 in t) this._plainReport(t[_i8], e);else "string" == typeof t ? console.log(e + " " + t) : (console.log(e + " <next line>"), console.log(t));
              }
            }, {
              key: "setLogLevel",
              value: function setLogLevel(t) {
                this.logLevel = t;
              }
            }, {
              key: "getLogLevel",
              value: function getLogLevel() {
                return this.logLevel;
              }
            }, {
              key: "error",
              value: function error(t) {
                for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  e[_key - 1] = arguments[_key];
                }
                this.report(t, [].slice.call(arguments, 1), s.ERROR, "darkred");
              }
            }, {
              key: "warn",
              value: function warn(t) {
                for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  e[_key2 - 1] = arguments[_key2];
                }
                this.report(t, [].slice.call(arguments, 1), s.WARNING, "darkorange");
              }
            }, {
              key: "notice",
              value: function notice(t) {
                for (var _len3 = arguments.length, e = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  e[_key3 - 1] = arguments[_key3];
                }
                this.report(t, [].slice.call(arguments, 1), s.NOTICE, "darkgreen");
              }
            }, {
              key: "debug",
              value: function debug(t) {
                for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                  e[_key4 - 1] = arguments[_key4];
                }
                this.report(t, [].slice.call(arguments, 1), s.DEBUG, "indigo");
              }
            }, {
              key: "verbose",
              value: function verbose(t) {
                for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                  e[_key5 - 1] = arguments[_key5];
                }
                this.report(t, [].slice.call(arguments, 1), s.VERBOSE, "navy");
              }
            }, {
              key: "loadLevelFromUrl",
              value: function loadLevelFromUrl() {
                "undefined" != typeof window && window.location && this._parseLevelFromUrl(window.location.search);
              }
            }, {
              key: "_parseLevelFromUrl",
              value: function _parseLevelFromUrl(t) {
                if (t) {
                  var _e11 = /\?.*&*npaw-debug=(.+)/i.exec(t);
                  null !== _e11 && (this.logLevel = Number(_e11[1])), null !== /\?.*&*npaw-debug=plain/i.exec(t) && (this.plainLogs = !0);
                }
              }
            }]);
            return n;
          }();
          n.logLevel = s.ERROR, n.plainLogs = !1;
        },
        9065: function _(t, e, i) {
          "use strict";

          i.r(e), i.d(e, {
            default: function _default() {
              return T;
            }
          });
          var s = i(108),
            n = i(1577),
            r = i(2784),
            a = i(7276),
            o = i(9907);
          var d = /*#__PURE__*/function () {
            function d(t, e, i, s, n) {
              _classCallCheck(this, d);
              var r, a, _d3;
              this.response = {}, this._session = "", this.sessionExpire = 120, this.retries = 0, this.isUsingLegacy = !1, this.options = t, this.npawPluginOptions = n, this.accountCode = e, this.coreStorage = i, this.browserStorage = s, this._fastDataHost = this.options.getFastDataHost();
              var c = null !== (r = "true" === o.env.IS_STANDALONE) && void 0 !== r && r;
              this.isUsingLegacy = c && null !== (_d3 = void 0 !== (null === (a = null == n ? void 0 : n.legacyPlugin) || void 0 === a ? void 0 : a.viewTransform)) && void 0 !== _d3 && _d3, this._createConfigurationInterval();
            }
            _createClass(d, [{
              key: "init",
              value: function init() {
                var t, e;
                if (this.options && this.options.offline) return this.response.host = "OFFLINE", this.response.code = "OFFLINE", this.response.pingTime = 60, this.response.beatTime = 60, void (this._session = n.default.generateRandomString(15));
                if (this.isUsingLegacy) return;
                if (this.browserStorage && this.browserStorage.isEnabled() && new Date().getTime() < 1e3 * (null !== (t = Number(this.browserStorage.getLocal("sessionExpire"))) && void 0 !== t ? t : this.sessionExpire) + (Number(this.coreStorage.getDataTime()) || 0) && this.coreStorage.getStoredData()) return void this.setData(null !== (e = this.coreStorage.getStoredData()) && void 0 !== e ? e : "");
                var i = s.A.Service.DATA,
                  o = {
                    system: this.accountCode,
                    pluginVersion: T.getPluginVersion(),
                    requestNumber: this.getRequestNumber()
                  };
                this.loadConfiguration();
                try {
                  a.default.notice(r.CoreTag, i + " " + o.system), "nicetest" === o.system && a.default.error(r.CoreTag, "No accountCode has been set. Please set your accountCode inside plugin's options."), this.performRequestToFastData(i, o, this._receiveData.bind(this), this._failedData.bind(this));
                } catch (t) {
                  a.default.error(r.CoreTag, "Error doing get data request to FastData service.");
                }
              }
            }, {
              key: "updateOptions",
              value: function updateOptions(t) {
                this.options.updateOptions(t), this.options.offline && (this.reset(), this.init());
              }
            }, {
              key: "getSessionExpireTime",
              value: function getSessionExpireTime() {
                return this.sessionExpire;
              }
            }, {
              key: "refreshSessionToken",
              value: function refreshSessionToken() {
                this._session = "", this.browserStorage.removeStorages("data"), this.init();
              }
            }, {
              key: "loadConfiguration",
              value: function loadConfiguration() {
                var t = s.A.Service.CONFIGURATION,
                  e = {
                    system: this.accountCode,
                    pluginVersion: T.getPluginVersion(),
                    requestNumber: this.getRequestNumber()
                  };
                this.performRequestToFastData(t, e, this._receiveConfiguration.bind(this), this._failedConfiguration.bind(this));
              }
            }, {
              key: "getSession",
              value: function getSession() {
                var t, e;
                return this.isUsingLegacy ? null === (e = null === (t = this.npawPluginOptions) || void 0 === t ? void 0 : t.legacyPlugin) || void 0 === e ? void 0 : e.viewTransform._session : this._session;
              }
            }, {
              key: "setSession",
              value: function setSession(t) {
                this._session = t;
              }
            }, {
              key: "setHost",
              value: function setHost(t) {
                this.response.host = t;
              }
            }, {
              key: "getPingTime",
              value: function getPingTime() {
                var t;
                return null !== (t = this.pingTime) && void 0 !== t ? t : 5;
              }
            }, {
              key: "getBeatTime",
              value: function getBeatTime() {
                var t;
                return null !== (t = this.beatTime) && void 0 !== t ? t : 30;
              }
            }, {
              key: "setData",
              value: function setData(t) {
                try {
                  var _e12 = JSON.parse(t);
                  this.options["parse.fdsResponseHost"] && (t = t.replace(_e12.q.h, this.options["parse.fdsResponseHost"](_e12.q.h)), _e12 = JSON.parse(t)), this.response = {
                    msg: t,
                    host: _e12.q.h,
                    code: _e12.q.c,
                    pingTime: _e12.q.pt || 5,
                    beatTime: _e12.q.i && _e12.q.i.bt || 30,
                    sessionExpire: _e12.q.st && _e12.q.st || 120
                  }, this._session = this.response.code, this.browserStorage.setLocal("sessionExpire", this.response.sessionExpire), this.browserStorage.setStorages("accCode", this.accountCode), this.browserStorage.setStorages("session", this.response.code), this.coreStorage.setStoredData(this.response.msg), this.coreStorage.setDataTime(new Date().getTime().toString()), this.pingTime = this.response.pingTime, this.beatTime = this.response.beatTime, this.sessionExpire = this.response.sessionExpire;
                } catch (t) {
                  a.default.error(r.CoreTag, "Fastdata response is invalid.");
                }
              }
            }, {
              key: "setConfiguration",
              value: function setConfiguration(t) {
                try {
                  this.response.configurationOptions = JSON.parse(t);
                } catch (t) {
                  a.default.error(r.CoreTag, "Configuration response is invalid.");
                }
              }
            }, {
              key: "getFastDataResponse",
              value: function getFastDataResponse() {
                return this.response;
              }
            }, {
              key: "getAccountCode",
              value: function getAccountCode() {
                return this.accountCode;
              }
            }, {
              key: "getRequestNumber",
              value: function getRequestNumber() {
                return Math.random();
              }
            }, {
              key: "reset",
              value: function reset() {
                this.coreStorage.removeStoredData(), this.coreStorage.removeSession(), this.browserStorage.removeLocal("sessionExpire"), this.browserStorage.removeStorages("accCode"), this.browserStorage.removeStorages("session");
              }
            }, {
              key: "performRequestToFastData",
              value: function performRequestToFastData(t, e, i, s) {
                if (this.options.offline) return;
                e.timemark = new Date().getTime(), e.outputFormat = "json";
                var r = this,
                  a = new XMLHttpRequest();
                a.open("GET", "https://".concat(this._fastDataHost).concat(t).concat(n.default.toQueryString(e))), a.onload = function (t) {
                  r.options.offline || (a.status >= 200 && a.status < 400 ? i(this, t) : s(this, t));
                }, a.onerror = function (t) {
                  s(this, t);
                }, a.send();
              }
            }, {
              key: "_createConfigurationInterval",
              value: function _createConfigurationInterval() {
                this.isUsingLegacy || !this.options.isRefreshLMAConfigurationEnabled() || this._refreshInterval || (this._refreshInterval = setInterval(this.loadConfiguration.bind(this), 1e3 * this.options.refreshLMAConfigurationSeconds()));
              }
            }, {
              key: "_receiveData",
              value: function _receiveData(t, e) {
                this.setData(t.response);
              }
            }, {
              key: "_receiveConfiguration",
              value: function _receiveConfiguration(t, e) {
                this.setConfiguration(t.response);
              }
            }, {
              key: "_failedData",
              value: function _failedData(t, e) {
                a.default.error(r.CoreTag, "Fastdata request has failed."), ++this.retries < 5 && setTimeout(this.init.bind(this), 5e3);
              }
            }, {
              key: "_failedConfiguration",
              value: function _failedConfiguration(t, e) {
                a.default.error(r.CoreTag, "Fastdata configuration request has failed."), ++this.retries < 5 && setTimeout(this.init.bind(this), 5e3);
              }
            }]);
            return d;
          }();
          var c = i(2602);
          var u = /*#__PURE__*/function () {
            function u() {
              _classCallCheck(this, u);
              this.offline = !1, this.host = "lma.npaw.com", this.disableCookies = !0, this.forceCookies = !1, this.disableStorage = !1, this.authToken = void 0, this.authType = "Bearer", this["app.https"] = !0, this["lma.refresh.configuration.enabled"] = !1, this["lma.refresh.configuration.seconds"] = 300, this["parse.fdsResponseHost"] = null;
            }
            _createClass(u, [{
              key: "updateOptions",
              value: function updateOptions(t) {
                var _this4 = this;
                var e = new c.A();
                Object.keys(this).forEach(function (i) {
                  null == t[i] || Object.keys(e).includes(i) || (_this4[i] = t[i]);
                });
              }
            }, {
              key: "setNpawPluginOptions",
              value: function setNpawPluginOptions(t) {
                var _this5 = this;
                Object.keys(this).forEach(function (e) {
                  null != t[e] && (_this5[e] = t[e]);
                });
              }
            }, {
              key: "isRefreshLMAConfigurationEnabled",
              value: function isRefreshLMAConfigurationEnabled() {
                return this["lma.refresh.configuration.enabled"];
              }
            }, {
              key: "refreshLMAConfigurationSeconds",
              value: function refreshLMAConfigurationSeconds() {
                return this["lma.refresh.configuration.seconds"];
              }
            }, {
              key: "getHost",
              value: function getHost() {
                return this.host;
              }
            }, {
              key: "getFastDataHost",
              value: function getFastDataHost() {
                return this.host;
              }
            }]);
            return u;
          }();
          var l = /*#__PURE__*/function () {
            function l(t, e, i, s, n, a, o) {
              _classCallCheck(this, l);
              this.method = r.Method.GET, this.headers = {}, this.xhr = new XMLHttpRequest(), this.retries = 0, this.hadBody = !1, this.isHttps = t, this.host = e, this.service = i, this.method = s, this.params = n, this.onSuccessCallback = a, this.onFailCallback = o;
            }
            _createClass(l, [{
              key: "performHttps",
              value: function performHttps() {
                return this.isHttps;
              }
            }, {
              key: "getHost",
              value: function getHost() {
                return this.host;
              }
            }, {
              key: "getService",
              value: function getService() {
                return this.service;
              }
            }, {
              key: "getMethod",
              value: function getMethod() {
                return this.method;
              }
            }, {
              key: "getParams",
              value: function getParams() {
                return this.params;
              }
            }, {
              key: "getBody",
              value: function getBody() {
                return this.body;
              }
            }, {
              key: "setBody",
              value: function setBody(t) {
                this.body = t;
              }
            }, {
              key: "addHeader",
              value: function addHeader(t, e) {
                this.headers[t] = e;
              }
            }, {
              key: "getRetries",
              value: function getRetries() {
                return this.retries;
              }
            }, {
              key: "send",
              value: function send(t, e) {
                var _this6 = this;
                if (this.params.timemark = Date.now(), this.params.sessionRoot = T.getInstance().getFastDataSessionToken(), this.params.system = T.getInstance().getFastDataService().getAccountCode(), this.body && (this.hadBody = !0), this.method === r.Method.POST && !this.body) {
                  var _t8 = {};
                  _t8.timemark = this.params.timemark, this.params.code && (_t8.code = this.params.code), _t8.sessionRoot = this.params.sessionRoot, _t8.system = this.params.system, _t8.sessionId = this.params.sessionId && "" != this.params.sessionId ? this.params.sessionId : T.getInstance().getFastDataSessionToken(), this.body = JSON.stringify(this.params), this.params = _t8;
                }
                try {
                  this.getUrl();
                } catch (t) {
                  console.log(t);
                }
                this.xhr.open(this.method, this.getUrl()), this.xhr.onreadystatechange = function () {
                  4 === _this6.xhr.readyState && _this6.xhr.status >= 200 && _this6.xhr.status < 400 ? (e && e(), _this6.onSuccessCallback && _this6.onSuccessCallback()) : 4 === _this6.xhr.readyState && (_this6.retries++, !_this6.hadBody && _this6.method === r.Method.POST && _this6.body && (_this6.params = JSON.parse(_this6.body), _this6.body = void 0), t(), _this6.onFailCallback && _this6.onFailCallback());
                };
                for (var _t9 in this.headers) this.xhr.setRequestHeader(_t9, this.headers[_t9]);
                this.xhr.send(this.body);
              }
            }, {
              key: "asyncSend",
              value: function asyncSend() {
                return t = this, e = void 0, s = /*#__PURE__*/_regeneratorRuntime.mark(function s() {
                  var _this7 = this;
                  return _regeneratorRuntime.wrap(function s$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", new Promise(function (t, e) {
                          _this7.send(e, t);
                        }));
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, s);
                }), new ((i = void 0) || (i = Promise))(function (n, r) {
                  function a(t) {
                    try {
                      d(s.next(t));
                    } catch (t) {
                      r(t);
                    }
                  }
                  function o(t) {
                    try {
                      d(s.throw(t));
                    } catch (t) {
                      r(t);
                    }
                  }
                  function d(t) {
                    var e;
                    t.done ? n(t.value) : (e = t.value, e instanceof i ? e : new i(function (t) {
                      t(e);
                    })).then(a, o);
                  }
                  d((s = s.apply(t, e || [])).next());
                });
                var t, e, i, s;
              }
            }, {
              key: "toLocalStorageString",
              value: function toLocalStorageString() {
                var t = {},
                  e = this.service.split("/");
                t.request = e[e.length - 1], t.unixtime = this.params.timemark;
                for (var _e13 in this.params) void 0 !== this.params[_e13] && ("sessionId" === _e13 || "sessionRoot" === _e13 ? t[_e13] = "" : "code" === _e13 ? t[_e13] = "CODE_PLACEHOLDER" : "object" == typeof this.params[_e13] ? t[_e13] = JSON.stringify(this.params[_e13]) : t[_e13] = this.params[_e13]);
                return JSON.stringify(t);
              }
            }, {
              key: "getUrl",
              value: function getUrl() {
                return "".concat(this.isHttps ? "https" : "http", "://").concat(this.host).concat(this.service).concat(n.default.toQueryString(this.params));
              }
            }]);
            return l;
          }();
          var h = i(5438);
          var p = [s.A.Service.ERROR, s.A.Service.AD_ERROR];
          var f = /*#__PURE__*/function () {
            function f(t, e, i) {
              _classCallCheck(this, f);
              this.freshRequests = [], this.retryRequests = [], this.databaseSendingInterval = 12e4, this.isDestroyed = !1, this.servicesToWait = [s.A.Service.INIT, s.A.Service.START], this.sentStart = !1, this.options = t, this.coreStorage = e, this.fastDataService = i;
            }
            _createClass(f, [{
              key: "destroy",
              value: function destroy() {
                this.freshRequests = [], this.retryRequests = [], this.isDestroyed = !0, this.timeWhenLastSentFromDatabase = new Date().getTime();
              }
            }, {
              key: "send",
              value: function send(t, e, i, s, n) {
                var o;
                if (this.isDestroyed) return;
                var d = new l(null === (o = this.options["app.https"]) || void 0 === o || o, this.coreStorage.getHost(), t, e, null != i ? i : {}, s, n);
                void 0 !== this.options.authToken && void 0 !== this.options.authType && t !== h.xC.CDN && (a.default.verbose(r.AnalyticsTag, "Adding Authorization header with type " + this.options.authType), d.addHeader("Authorization", this.options.authType + " " + this.options.authToken)), this.freshRequests.push(d), this._processRequests();
              }
            }, {
              key: "getTimeOfLastSentRequest",
              value: function getTimeOfLastSentRequest() {
                return this.timeOfLastSentRequest;
              }
            }, {
              key: "wasStartSent",
              value: function wasStartSent() {
                return this.sentStart;
              }
            }, {
              key: "_processRequests",
              value: function _processRequests() {
                return t = this, e = void 0, s = /*#__PURE__*/_regeneratorRuntime.mark(function s() {
                  var _a$default, _this$retryRequests;
                  var t, e, i, s, _iterator2, _step2, _e14, _iterator3, _step3, _t10;
                  return _regeneratorRuntime.wrap(function s$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          _context2.next = 2;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 2:
                        t = this.retryRequests.splice(0, this.retryRequests.length), e = this.freshRequests.splice(0, this.freshRequests.length);
                        t.length > 0 && (_a$default = a.default).verbose.apply(_a$default, [r.CoreTag, "Retrying to send these requests:"].concat(_toConsumableArray(t.map(function (t) {
                          return t.getService();
                        }))));
                        i = [];
                        s = !1;
                        _iterator2 = _createForOfIteratorHelper(t);
                        _context2.prev = 7;
                        _iterator2.s();
                      case 9:
                        if ((_step2 = _iterator2.n()).done) {
                          _context2.next = 26;
                          break;
                        }
                        _e14 = _step2.value;
                        if (!s) {
                          _context2.next = 15;
                          break;
                        }
                        i.push(_e14);
                        _context2.next = 24;
                        break;
                      case 15:
                        _context2.prev = 15;
                        _context2.next = 18;
                        return _e14.asyncSend();
                      case 18:
                        this.timeOfLastSentRequest = new Date().getTime();
                        _context2.next = 24;
                        break;
                      case 21:
                        _context2.prev = 21;
                        _context2.t0 = _context2["catch"](15);
                        s = !0, i.push(_e14);
                      case 24:
                        _context2.next = 9;
                        break;
                      case 26:
                        _context2.next = 31;
                        break;
                      case 28:
                        _context2.prev = 28;
                        _context2.t1 = _context2["catch"](7);
                        _iterator2.e(_context2.t1);
                      case 31:
                        _context2.prev = 31;
                        _iterator2.f();
                        return _context2.finish(31);
                      case 34:
                        _iterator3 = _createForOfIteratorHelper(e);
                        _context2.prev = 35;
                        _iterator3.s();
                      case 37:
                        if ((_step3 = _iterator3.n()).done) {
                          _context2.next = 51;
                          break;
                        }
                        _t10 = _step3.value;
                        _context2.prev = 39;
                        _context2.next = 42;
                        return _t10.asyncSend();
                      case 42:
                        this.servicesToWait.includes(_t10.getService()) && (this.sentStart = !0);
                        this.timeOfLastSentRequest = new Date().getTime();
                        _context2.next = 49;
                        break;
                      case 46:
                        _context2.prev = 46;
                        _context2.t2 = _context2["catch"](39);
                        p.includes(_t10.getService()) && i.push(_t10);
                      case 49:
                        _context2.next = 37;
                        break;
                      case 51:
                        _context2.next = 56;
                        break;
                      case 53:
                        _context2.prev = 53;
                        _context2.t3 = _context2["catch"](35);
                        _iterator3.e(_context2.t3);
                      case 56:
                        _context2.prev = 56;
                        _iterator3.f();
                        return _context2.finish(56);
                      case 59:
                        (_this$retryRequests = this.retryRequests).push.apply(_this$retryRequests, _toConsumableArray(i.slice(-25)));
                      case 60:
                      case "end":
                        return _context2.stop();
                    }
                  }, s, this, [[7, 28, 31, 34], [15, 21], [35, 53, 56, 59], [39, 46]]);
                }), new ((i = void 0) || (i = Promise))(function (n, r) {
                  function a(t) {
                    try {
                      d(s.next(t));
                    } catch (t) {
                      r(t);
                    }
                  }
                  function o(t) {
                    try {
                      d(s.throw(t));
                    } catch (t) {
                      r(t);
                    }
                  }
                  function d(t) {
                    var e;
                    t.done ? n(t.value) : (e = t.value, e instanceof i ? e : new i(function (t) {
                      t(e);
                    })).then(a, o);
                  }
                  d((s = s.apply(t, e || [])).next());
                });
                var t, e, i, s;
              }
            }]);
            return f;
          }();
          var g = /*#__PURE__*/function () {
            function g(t, e, i) {
              _classCallCheck(this, g);
              this.prefix = "npaw", this.disableCookies = t, this.forceCookies = e, this.disabled = i;
            }
            _createClass(g, [{
              key: "updateStorageOptions",
              value: function updateStorageOptions(t, e, i) {
                this.disableCookies = t, this.forceCookies = e, this.disabled = i;
              }
            }, {
              key: "isEnabled",
              value: function isEnabled() {
                if (this.disabled) return !1;
                var t = !0;
                if (!this.forceCookies) try {
                  localStorage.setItem(this.prefix + ".test", "true"), localStorage.removeItem(this.prefix + ".test");
                } catch (e) {
                  t = !1;
                }
                return t;
              }
            }, {
              key: "setLocal",
              value: function setLocal(t, e) {
                if (!this.disabled) try {
                  !this.forceCookies && ("undefined" != typeof localStorage && localStorage || this.disableCookies) ? "undefined" != typeof localStorage && localStorage && localStorage.setItem(this.prefix + "." + t, e) : this._setCookie(this.prefix + ".local." + t, e);
                } catch (t) {
                  a.default.debug(r.CoreTag, "App Analytics needs localStorage or cookies, not supported by your browser.");
                }
              }
            }, {
              key: "getLocal",
              value: function getLocal(t) {
                if (!this.disabled) return this._localGetRemove("getItem", "_getCookie", t);
              }
            }, {
              key: "removeLocal",
              value: function removeLocal(t) {
                if (!this.disabled) return this._localGetRemove("removeItem", "_removeCookie", t);
              }
            }, {
              key: "_localGetRemove",
              value: function _localGetRemove(t, e, i) {
                try {
                  if (this.forceCookies || !("undefined" != typeof localStorage && localStorage || this.disableCookies)) return this[e](this.prefix + ".local." + i);
                  if ("undefined" != typeof localStorage && localStorage) return localStorage[t](this.prefix + "." + i);
                } catch (t) {
                  a.default.debug(r.CoreTag, "App Analytics needs localStorage or cookies, not supported by your browser.");
                }
              }
            }, {
              key: "setSession",
              value: function setSession(t, e) {
                if (!this.disabled) try {
                  !this.forceCookies && ("undefined" != typeof sessionStorage && sessionStorage || this.disableCookies) ? "undefined" != typeof sessionStorage && sessionStorage && sessionStorage.setItem(this.prefix + "." + t, e) : this._setCookie(this.prefix + ".session." + t, e);
                } catch (t) {
                  a.default.debug(r.CoreTag, "App Analytics needs sessionStorage or cookies, not supported by your browser.");
                }
              }
            }, {
              key: "getSession",
              value: function getSession(t) {
                if (!this.disabled) return this._sessionGetRemove("getItem", "_getCookie", t);
              }
            }, {
              key: "removeSession",
              value: function removeSession(t) {
                if (!this.disabled) return this._sessionGetRemove("removeItem", "_removeCookie", t);
              }
            }, {
              key: "_sessionGetRemove",
              value: function _sessionGetRemove(t, e, i) {
                try {
                  if (this.forceCookies || !("undefined" != typeof sessionStorage && sessionStorage || this.disableCookies)) return this[e](this.prefix + ".session." + i);
                  if ("undefined" != typeof sessionStorage && sessionStorage) return sessionStorage[t](this.prefix + "." + i);
                } catch (t) {
                  a.default.debug(r.CoreTag, "App Analytics needs sessionStorage or cookies, not supported by your browser.");
                }
              }
            }, {
              key: "getStorages",
              value: function getStorages(t) {
                if (!this.disabled) return this.getSession(t) || this.getLocal(t);
              }
            }, {
              key: "setStorages",
              value: function setStorages(t, e) {
                this.disabled || (this.setSession(t, e), this.setLocal(t, e));
              }
            }, {
              key: "removeStorages",
              value: function removeStorages(t) {
                this.disabled || (this.removeSession(t), this.removeLocal(t));
              }
            }, {
              key: "_setCookie",
              value: function _setCookie(t, e) {
                if ("undefined" != typeof document) {
                  var _i9 = ";";
                  "undefined" != typeof location && (_i9 += "domain=" + location.host.split(".").reverse().splice(0, 2).reverse().join(".") + ";path=/;"), document.cookie = t + "=" + e + _i9;
                }
              }
            }, {
              key: "_getCookie",
              value: function _getCookie(t) {
                if ("undefined" != typeof document) {
                  var _e15 = t + "=",
                    _i10 = decodeURIComponent(document.cookie).split(";");
                  for (var _t11 = 0; _t11 < _i10.length; _t11++) {
                    var _s12 = _i10[_t11];
                    for (; " " === _s12.charAt(0);) _s12 = _s12.substring(1);
                    if (0 === _s12.indexOf(_e15)) return _s12.substring(_e15.length, _s12.length);
                  }
                }
                return null;
              }
            }, {
              key: "_removeCookie",
              value: function _removeCookie(t) {
                this._setCookie(t, "");
              }
            }]);
            return g;
          }();
          var m = /*#__PURE__*/function () {
            function m(t, e) {
              _classCallCheck(this, m);
              this.options = t, this.browserStorage = e;
            }
            _createClass(m, [{
              key: "isEnabled",
              value: function isEnabled() {
                return this.browserStorage.isEnabled();
              }
            }, {
              key: "setLocal",
              value: function setLocal(t, e) {
                this.browserStorage.setLocal(t, e);
              }
            }, {
              key: "getLocal",
              value: function getLocal(t) {
                return this.browserStorage.getLocal(t);
              }
            }, {
              key: "removeLocal",
              value: function removeLocal(t) {
                this.browserStorage.removeLocal(t);
              }
            }, {
              key: "getHost",
              value: function getHost() {
                var t = this.options.getHost();
                var e = T.getInstance().getFastDataService();
                return !T.getInstance().isUsingLegacy() && e && e.getFastDataResponse() && e.getFastDataResponse().host ? t = e.getFastDataResponse().host : T.getInstance().isUsingLegacy() && T.getInstance().getLegacyFastDataHost() && (t = T.getInstance().getLegacyFastDataHost()), t;
              }
            }, {
              key: "getSession",
              value: function getSession() {
                var t = this.browserStorage.getStorages("session");
                if ("undefined" === t && (t = void 0), !t) {
                  var _e16 = this.getStoredData();
                  if (_e16) try {
                    t = JSON.parse(_e16).q.c;
                  } catch (t) {}
                }
                return t;
              }
            }, {
              key: "getStorageHost",
              value: function getStorageHost() {
                var t = null;
                var e = this.getStoredData();
                if (e) try {
                  t = JSON.parse(e).q.h;
                } catch (t) {}
                return t;
              }
            }, {
              key: "getLocalAccountCode",
              value: function getLocalAccountCode() {
                return this.browserStorage.getLocal("accCode");
              }
            }, {
              key: "getSessionAccountCode",
              value: function getSessionAccountCode() {
                return this.browserStorage.getSession("accCode");
              }
            }, {
              key: "getAppAnalyticsRegisteredProperties",
              value: function getAppAnalyticsRegisteredProperties() {
                return this.browserStorage.getLocal("appAnalyticsRegisteredProperties");
              }
            }, {
              key: "setAppAnalyticsRegisteredProperties",
              value: function setAppAnalyticsRegisteredProperties(t) {
                this.browserStorage.setLocal("appAnalyticsRegisteredProperties", t);
              }
            }, {
              key: "removeAppAnalyticsRegisteredProperties",
              value: function removeAppAnalyticsRegisteredProperties() {
                this.browserStorage.removeLocal("appAnalyticsRegisteredProperties");
              }
            }, {
              key: "getAppAnalyticsStarted",
              value: function getAppAnalyticsStarted() {
                return "true" === this.browserStorage.getLocal("appAnalyticsStarted");
              }
            }, {
              key: "setAppAnalyticsStarted",
              value: function setAppAnalyticsStarted(t) {
                this.browserStorage.setLocal("appAnalyticsStarted", String(t));
              }
            }, {
              key: "removeAppAnalyticsStarted",
              value: function removeAppAnalyticsStarted() {
                this.browserStorage.removeStorages("appAnalyticsStarted");
              }
            }, {
              key: "getDataTime",
              value: function getDataTime() {
                return this.browserStorage.getStorages("dataTime");
              }
            }, {
              key: "setDataTime",
              value: function setDataTime(t) {
                this.browserStorage.setStorages("dataTime", t);
              }
            }, {
              key: "getLastActive",
              value: function getLastActive() {
                return Number(this.browserStorage.getStorages("lastactive"));
              }
            }, {
              key: "setLastActive",
              value: function setLastActive(t) {
                this.browserStorage.setStorages("lastactive", t);
              }
            }, {
              key: "removeLastActive",
              value: function removeLastActive() {
                this.browserStorage.removeStorages("lastactive");
              }
            }, {
              key: "setSession",
              value: function setSession(t) {
                this.browserStorage.setStorages("session", t);
              }
            }, {
              key: "removeSession",
              value: function removeSession() {
                this.browserStorage.removeStorages("session");
              }
            }, {
              key: "getSessionExpire",
              value: function getSessionExpire() {
                return 1e3 * Number(this.browserStorage.getLocal("sessionExpire"));
              }
            }, {
              key: "getStoredData",
              value: function getStoredData() {
                return this.browserStorage.getStorages("data");
              }
            }, {
              key: "setStoredData",
              value: function setStoredData(t) {
                this.browserStorage.setStorages("data", t);
              }
            }, {
              key: "removeStoredData",
              value: function removeStoredData() {
                this.browserStorage.removeStorages("data");
              }
            }, {
              key: "getStorages",
              value: function getStorages(t) {
                return e = this, i = void 0, n = /*#__PURE__*/_regeneratorRuntime.mark(function n() {
                  return _regeneratorRuntime.wrap(function n$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", this.browserStorage.getStorages(t));
                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }, n, this);
                }), new ((s = void 0) || (s = Promise))(function (t, r) {
                  function a(t) {
                    try {
                      d(n.next(t));
                    } catch (t) {
                      r(t);
                    }
                  }
                  function o(t) {
                    try {
                      d(n.throw(t));
                    } catch (t) {
                      r(t);
                    }
                  }
                  function d(e) {
                    var i;
                    e.done ? t(e.value) : (i = e.value, i instanceof s ? i : new s(function (t) {
                      t(i);
                    })).then(a, o);
                  }
                  d((n = n.apply(e, i || [])).next());
                });
                var e, i, s, n;
              }
            }]);
            return m;
          }();
          var v = i(61),
            y = i(9907);
          var T = /*#__PURE__*/function () {
            function T(t, e) {
              _classCallCheck(this, T);
              var i, s, n, r;
              if (this.options = new u(), this.sendingOffline = !1, this.isDestroyed = !1, this.usingLegacy = !1, this.commonVariables = new Map(), this.registeredPeriodicPushes = new Map(), this.pluginOptions = e, this.pluginOptions) {
                this.pluginOptions.host && this.options.setNpawPluginOptions({
                  host: this.pluginOptions.host
                });
                var _t12 = null !== (i = "true" === y.env.IS_STANDALONE) && void 0 !== i && i;
                this.usingLegacy = _t12 && null !== (r = void 0 !== (null === (n = null === (s = this.pluginOptions) || void 0 === s ? void 0 : s.legacyPlugin) || void 0 === n ? void 0 : n.viewTransform)) && void 0 !== r && r;
              }
              this.browserStorage = new g(this.options.disableCookies, this.options.forceCookies, this.options.disableStorage), this.coreStorage = new m(this.options, this.browserStorage), this.fastDataService = new d(this.options, t, this.coreStorage, this.browserStorage, this.pluginOptions), this.fastDataService.init(), this.nqsService = new f(this.options, this.coreStorage, this.fastDataService), this.deleteOldOfflineEntries();
            }
            _createClass(T, [{
              key: "destroy",
              value: function destroy() {
                this.unregisterAllPeriodicPushes(), this.commonVariables.clear(), this.nqsService.destroy();
              }
            }, {
              key: "isUsingLegacy",
              value: function isUsingLegacy() {
                return this.usingLegacy;
              }
            }, {
              key: "wasStartSent",
              value: function wasStartSent() {
                var t, e, i, s, n, r, a;
                return this.isUsingLegacy() ? (null === (e = null === (t = this.pluginOptions) || void 0 === t ? void 0 : t.legacyPlugin) || void 0 === e ? void 0 : e._comm) && (null === (s = null === (i = this.pluginOptions) || void 0 === i ? void 0 : i.legacyPlugin) || void 0 === s ? void 0 : s._comm.transforms) ? null === (a = !(null === (r = null === (n = this.pluginOptions) || void 0 === n ? void 0 : n.legacyPlugin) || void 0 === r ? void 0 : r._comm.transforms[0]._isBusy)) || void 0 === a || a : void 0 : this.nqsService.wasStartSent();
              }
            }, {
              key: "setLegacyPlugin",
              value: function setLegacyPlugin(t) {
                var e, i, s, n;
                if (this.pluginOptions) {
                  this.pluginOptions.legacyPlugin = t;
                  var _r4 = null !== (e = "true" === y.env.IS_STANDALONE) && void 0 !== e && e;
                  this.usingLegacy = _r4 && null !== (n = void 0 !== (null === (s = null === (i = this.pluginOptions) || void 0 === i ? void 0 : i.legacyPlugin) || void 0 === s ? void 0 : s.viewTransform)) && void 0 !== n && n;
                }
              }
            }, {
              key: "setActiveSwitchingOnLegacy",
              value: function setActiveSwitchingOnLegacy(t) {
                t && this.pluginOptions && this.pluginOptions.legacyPlugin && this.pluginOptions.legacyPlugin.options && (this.pluginOptions.legacyPlugin.options["content.cdn"] = "ACTVSWIT");
              }
            }, {
              key: "getViewCode",
              value: function getViewCode() {
                var t;
                return null === (t = this.pluginOptions) || void 0 === t ? void 0 : t.legacyPlugin.viewTransform.getViewCode();
              }
            }, {
              key: "getLegacyFastDataHost",
              value: function getLegacyFastDataHost() {
                var t;
                return null === (t = this.pluginOptions) || void 0 === t ? void 0 : t.legacyPlugin.viewTransform.response.host;
              }
            }, {
              key: "setOptions",
              value: function setOptions(t) {
                this.options.updateOptions(t), this.browserStorage.updateStorageOptions(this.options.disableCookies, this.options.forceCookies, this.options.disableStorage), this.fastDataService.updateOptions(t);
              }
            }, {
              key: "getOptions",
              value: function getOptions() {
                return this.options;
              }
            }, {
              key: "getCoreStorage",
              value: function getCoreStorage() {
                return this.coreStorage;
              }
            }, {
              key: "registerCommonVariable",
              value: function registerCommonVariable(t, e, i) {
                var s, n;
                this.commonVariables.has(t) ? null === (s = this.commonVariables.get(t)) || void 0 === s || s.set(e, i) : (this.commonVariables.set(t, new Map()), null === (n = this.commonVariables.get(t)) || void 0 === n || n.set(e, i));
              }
            }, {
              key: "unregisterCommonVariable",
              value: function unregisterCommonVariable(t, e) {
                var i;
                null === (i = this.commonVariables.get(t)) || void 0 === i || i.delete(e);
              }
            }, {
              key: "getCommonVariable",
              value: function getCommonVariable(t, e) {
                var i;
                return null === (i = this.commonVariables.get(t)) || void 0 === i ? void 0 : i.get(e);
              }
            }, {
              key: "getFastDataService",
              value: function getFastDataService() {
                return this.fastDataService;
              }
            }, {
              key: "getFastDataSessionToken",
              value: function getFastDataSessionToken() {
                return this.fastDataService.getSession();
              }
            }, {
              key: "refreshSessionToken",
              value: function refreshSessionToken() {
                return this.usingLegacy ? void 0 : this.fastDataService.refreshSessionToken();
              }
            }, {
              key: "isSessionTokenExpired",
              value: function isSessionTokenExpired() {
                var t;
                var e = new Date().getTime();
                return !this.usingLegacy && e - (null !== (t = this.nqsService.getTimeOfLastSentRequest()) && void 0 !== t ? t : e) > 1e3 * this.fastDataService.getSessionExpireTime();
              }
            }, {
              key: "pushData",
              value: function pushData(t, e, i, s, n, r) {
                this.handleDataToSend(t, e, i, s, n, r);
              }
            }, {
              key: "pushPeriodicDataFromCallback",
              value: function pushPeriodicDataFromCallback(t, e, i, s, n, r, a, o) {
                var _this8 = this;
                var d = setInterval(function () {
                  var e = r();
                  e && _this8.handleDataToSend(t, i, n, e, a, o);
                }, s < 1e3 ? 1e3 : s);
                this.registeredPeriodicPushes.has(e) ? (clearInterval(this.registeredPeriodicPushes.get(e)), this.registeredPeriodicPushes.set(e, d)) : this.registeredPeriodicPushes.set(e, d);
              }
            }, {
              key: "unregisterPeriodicPush",
              value: function unregisterPeriodicPush(t) {
                clearInterval(this.registeredPeriodicPushes.get(t)), this.registeredPeriodicPushes.delete(t);
              }
            }, {
              key: "unregisterAllPeriodicPushes",
              value: function unregisterAllPeriodicPushes() {
                if (0 === this.registeredPeriodicPushes.size) return;
                a.default.debug(r.CoreTag, "Unregistering ".concat(this.registeredPeriodicPushes.size, " periodic pushes"));
                var t = Array.from(this.registeredPeriodicPushes.keys());
                for (var _i11 = 0, _t13 = t; _i11 < _t13.length; _i11++) {
                  var _e17 = _t13[_i11];
                  clearInterval(this.registeredPeriodicPushes.get(_e17)), this.registeredPeriodicPushes.delete(_e17);
                }
                a.default.debug(r.CoreTag, "Finished unregistering all pushes");
              }
            }, {
              key: "deleteOldOfflineEntries",
              value: function deleteOldOfflineEntries() {
                var t, e, i, s;
                var n = null !== (e = null === (t = this.coreStorage.getLocal("offlineViews")) || void 0 === t ? void 0 : t.split(",")) && void 0 !== e ? e : [];
                var _iterator4 = _createForOfIteratorHelper(n),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _t14 = _step4.value;
                    var _e18 = null !== (s = null === (i = this.coreStorage.getLocal("offlineViews." + _t14)) || void 0 === i ? void 0 : i.split(",")) && void 0 !== s ? s : [],
                      _n8 = 2592e6;
                    _e18.length > 0 && Date.now() - JSON.parse("[" + _e18 + "]")[0].timemark > _n8 && this.deleteViewDataFromLocalStorage(_t14);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
            }, {
              key: "sendOfflineEvents",
              value: function sendOfflineEvents() {
                var t, e, i, n, o, d;
                return i = this, n = void 0, d = /*#__PURE__*/_regeneratorRuntime.mark(function d() {
                  var _this9 = this;
                  var i, n, o;
                  return _regeneratorRuntime.wrap(function d$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!this.options.offline) {
                          _context4.next = 2;
                          break;
                        }
                        return _context4.abrupt("return", void a.default.notice(r.AnalyticsTag, "Unable to send offline events because offline option is enabled"));
                      case 2:
                        if (!this.sendingOffline) {
                          _context4.next = 4;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 4:
                        this.sendingOffline = !0;
                        i = 15, n = !1;
                      case 6:
                        if (!(!n && i-- > 0)) {
                          _context4.next = 15;
                          break;
                        }
                        if (!("" === this.getFastDataSessionToken())) {
                          _context4.next = 12;
                          break;
                        }
                        _context4.next = 10;
                        return new Promise(function (t) {
                          return setTimeout(t, 100);
                        });
                      case 10:
                        _context4.next = 13;
                        break;
                      case 12:
                        n = !0;
                      case 13:
                        _context4.next = 6;
                        break;
                      case 15:
                        if (!(i < 1)) {
                          _context4.next = 17;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 17:
                        o = (null !== (e = null === (t = this.coreStorage.getLocal("offlineViews")) || void 0 === t ? void 0 : t.split(",")) && void 0 !== e ? e : []).map(function (t) {
                          return new Promise(function (e, i) {
                            var n;
                            var a = null !== (n = _this9.coreStorage.getLocal("offlineViews." + t)) && void 0 !== n ? n : "";
                            if (a = a.replace(/CODE_PLACEHOLDER/g, T.getInstance().getFastDataSessionToken() + "_" + t.split("_")[1]), a.length > 0) {
                              var _i12 = new l(!0, _this9.coreStorage.getHost(), s.A.Service.OFFLINE_EVENTS, r.Method.POST, {
                                code: T.getInstance().getFastDataSessionToken() + "_" + t.split("_")[1]
                              }, function () {
                                _this9.deleteViewDataFromLocalStorage(t), e();
                              }, function () {
                                return e();
                              });
                              _i12.setBody("[" + a + "]"), _i12.send(function () {});
                            }
                          });
                        });
                        _context4.next = 20;
                        return Promise.all(o).finally(function () {
                          _this9.sendingOffline = !1;
                        });
                      case 20:
                      case "end":
                        return _context4.stop();
                    }
                  }, d, this);
                }), new ((o = void 0) || (o = Promise))(function (t, e) {
                  function s(t) {
                    try {
                      a(d.next(t));
                    } catch (t) {
                      e(t);
                    }
                  }
                  function r(t) {
                    try {
                      a(d.throw(t));
                    } catch (t) {
                      e(t);
                    }
                  }
                  function a(e) {
                    var i;
                    e.done ? t(e.value) : (i = e.value, i instanceof o ? i : new o(function (t) {
                      t(i);
                    })).then(s, r);
                  }
                  a((d = d.apply(i, n || [])).next());
                });
              }
            }, {
              key: "deleteViewDataFromLocalStorage",
              value: function deleteViewDataFromLocalStorage(t) {
                var e, i;
                this.coreStorage.removeLocal("offlineViews." + t);
                var s = null !== (i = null === (e = this.coreStorage.getLocal("offlineViews")) || void 0 === e ? void 0 : e.split(",")) && void 0 !== i ? i : [],
                  n = s.indexOf(t);
                -1 != n && s.splice(n, 1), this.coreStorage.setLocal("offlineViews", s.toString());
              }
            }, {
              key: "handleDataToSend",
              value: function handleDataToSend(t, e, i, n, r, a) {
                if (!this.isDestroyed) switch (t) {
                  case v.default.Consumer.NQS:
                    this.nqsService.send(e, i, n, r, a);
                    break;
                  case v.default.Consumer.PERSISTENT:
                    if (void 0 !== r && r(), e === s.A.Service.VIDEO_PLUGIN_LOGS) break;
                    if (e === s.A.Service.INIT) break;
                    n.timemark = Date.now();
                    var _t15 = new l(this.options["app.https"], "", e, i, n, r, a),
                      _o2 = this.coreStorage.getLocal("offlineViews");
                    if (_o2) {
                      var _t16 = _o2.split(",");
                      _t16.includes(n.code) || (_t16.push(n.code), this.coreStorage.setLocal("offlineViews", _t16.toString()));
                    } else this.coreStorage.setLocal("offlineViews", n.code);
                    var _d4 = this.coreStorage.getLocal("offlineViews." + n.code);
                    if (_d4) {
                      var _e19 = _d4.split(",");
                      _e19.push(_t15.toLocalStorageString()), this.coreStorage.setLocal("offlineViews." + n.code, _e19.toString());
                    } else this.coreStorage.setLocal("offlineViews." + n.code, _t15.toLocalStorageString());
                    break;
                  case v.default.Consumer.BLACK_HOLE:
                    void 0 !== r && r();
                }
              }
            }], [{
              key: "getInstance",
              value: function getInstance(t, e, i) {
                return this._instance && !i || (this._instance = new T(t || "", e)), this._instance;
              }
            }, {
              key: "getPluginVersion",
              value: function getPluginVersion() {
                var t = y.env.NWF || "";
                return "7.2.26".concat("true" === y.env.IS_STANDALONE ? "-balancer" : "").concat(t, "-js-sdk");
              }
            }]);
            return T;
          }();
        },
        2602: function _(t, e, i) {
          "use strict";

          i.d(e, {
            A: function A() {
              return s;
            }
          });
          var s = /*#__PURE__*/_createClass(function s() {
            _classCallCheck(this, s);
            this.host = "lma.npaw.com", this.components = {}, this.host = "lma.npaw.com", this.components = {};
          });
        },
        108: function _(t, e, i) {
          "use strict";

          var s;
          i.d(e, {
            A: function A() {
              return r;
            }
          });
          var n = /*#__PURE__*/_createClass(function n() {
            _classCallCheck(this, n);
          });
          s = n, n.VideoService = {
            INIT: "/init",
            START: "/start",
            JOIN: "/joinTime",
            PAUSE: "/pause",
            RESUME: "/resume",
            SEEK: "/seek",
            BUFFER: "/bufferUnderrun",
            ERROR: "/error",
            STOP: "/stop",
            PING: "/ping"
          }, n.Service = Object.assign(Object.assign({
            DATA: "/data",
            ADAPTERS: "/adapters",
            CONFIGURATION: "/configuration",
            APP_ANALYTICS_PLUGIN_LOGS: "/infinity/session/pluginLogs",
            VIDEO_PLUGIN_LOGS: "/infinity/video/pluginLogs"
          }, s.VideoService), {
            CDN: "/cdn",
            VIDEO_EVENT: "/infinity/video/event",
            AD_INIT: "/adInit",
            AD_START: "/adStart",
            AD_JOIN: "/adJoin",
            AD_PAUSE: "/adPause",
            AD_RESUME: "/adResume",
            AD_BUFFER: "/adBufferUnderrun",
            AD_STOP: "/adStop",
            AD_CLICK: "/adClick",
            AD_ERROR: "/adError",
            AD_MANIFEST: "/adManifest",
            AD_POD_START: "/adBreakStart",
            AD_POD_STOP: "/adBreakStop",
            AD_QUARTILE: "/adQuartile",
            EVENT: "/infinity/session/event",
            SESSION_START: "/infinity/session/start",
            SESSION_STOP: "/infinity/session/stop",
            NAV: "/infinity/session/nav",
            BEAT: "/infinity/session/beat",
            OFFLINE_EVENTS: "/offlineEvents"
          });
          var r = n;
        },
        61: function _(t, e, i) {
          "use strict";

          i.r(e), i.d(e, {
            default: function _default() {
              return s;
            }
          });
          var s = /*#__PURE__*/_createClass(function s() {
            _classCallCheck(this, s);
          });
          s.Products = {
            VIDEO_ANALYTICS: "videoAnalytics",
            BALANCER: "balancer"
          }, s.AnalyticsVariables = {
            VIEW_CODE: "viewCode",
            METHOD_OPTION: "methodOption"
          }, s.BalancerVariables = {
            AS_ENABLED: "activeSwitchingEnabled",
            PROFILE_NAME: "profileName",
            BUCKET: "bucket",
            DECISION_FINISHED: "decisionFinished",
            LAST_USED_CDN: "lastUsedCdn",
            BALANCER_TRAFFIC: "balancerTraffic",
            BALANCER_BITRATE: "balancerBitrate"
          }, s.Consumer = {
            NQS: "NQS",
            PERSISTENT: "PERSISTENT",
            BLACK_HOLE: "BLACK_HOLE"
          };
        },
        1577: function _(t, e, i) {
          "use strict";

          i.r(e), i.d(e, {
            default: function _default() {
              return r;
            }
          });
          var s = i(7276),
            n = i(2784);
          var r = /*#__PURE__*/function () {
            function r() {
              _classCallCheck(this, r);
            }
            _createClass(r, null, [{
              key: "toQueryString",
              value: function toQueryString(t) {
                return "?" + Object.keys(t).map(function (e) {
                  if (null !== t[e] && "object" == typeof t[e]) {
                    var _i13 = JSON.stringify(t[e]);
                    if ("{}" !== _i13) return encodeURIComponent(e) + "=" + encodeURIComponent(_i13);
                  } else if (null !== t[e] && void 0 !== t[e] && "" !== t[e]) return encodeURIComponent(e) + "=" + encodeURIComponent(t[e]);
                  return "";
                }).filter(function (t) {
                  return "" != t;
                }).join("&");
              }
            }, {
              key: "addProtocol",
              value: function addProtocol(t, e) {
                var i = "http://localhost/";
                try {
                  i = "http://" + t, e || "undefined" != typeof window && 0 === window.location.protocol.indexOf("https") ? i = "https://" + t : "undefined" != typeof window && 0 === window.location.protocol.indexOf("http") && (i = "//" + t);
                } catch (t) {
                  s.default.warn(n.CoreTag, t);
                }
                return i;
              }
            }, {
              key: "parseBoolean",
              value: function parseBoolean(t) {
                return "string" == typeof t ? "true" === t.toLowerCase() : !!t;
              }
            }, {
              key: "methodFromString",
              value: function methodFromString(t) {
                var e;
                var i = null !== (e = null == t ? void 0 : t.toUpperCase()) && void 0 !== e ? e : "";
                return i in n.Method ? n.Method[i] : n.Method.GET;
              }
            }, {
              key: "generateRandomString",
              value: function generateRandomString(t) {
                var e = "";
                for (var _i14 = 0; _i14 < t; _i14++) e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62 * Math.random()));
                return e;
              }
            }]);
            return r;
          }();
        },
        6933: function _(t, e, i) {
          "use strict";

          i.r(e), i.d(e, {
            default: function _default() {
              return p;
            }
          });
          var s,
            n = i(2477),
            r = i.n(n),
            a = i(7276);
          !function (t) {
            t.BLACK = "[30m", t.RED = "[31m", t.GREEN = "[32m", t.YELLOW = "[33m", t.BLUE = "[34m", t.MAGENTA = "[35m", t.CYAN = "[36m", t.WHITE = "[37m";
          }(s || (s = {}));
          var o = /*#__PURE__*/function () {
            function o() {
              _classCallCheck(this, o);
            }
            _createClass(o, null, [{
              key: "colorizeText",
              value: function colorizeText(t, e) {
                return "".concat(e).concat(t).concat(this.RESET);
              }
            }, {
              key: "header",
              value: function header(t) {
                a.default.getLogLevel() < a.LogLevel.SILENT && console.log(this.BOLD + t + this.RESET);
              }
            }, {
              key: "log",
              value: function log(t, e) {
                a.default.getLogLevel() < a.LogLevel.SILENT && console.log(t, e || "");
              }
            }, {
              key: "logWithPrefix",
              value: function logWithPrefix(t, e) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                if (a.default.getLogLevel() < a.LogLevel.SILENT) {
                  var _s13 = e.repeat(i) + t;
                  console.log(_s13);
                }
              }
            }]);
            return o;
          }();
          o.logIdent = "  ", o.BOLD = "[1m", o.RESET = "[0m";
          var d = /*#__PURE__*/function () {
            function d(t, e) {
              _classCallCheck(this, d);
              this.eventType = t, this.params = e, this.columns = ["Event", "Params"];
            }
            _createClass(d, [{
              key: "generateRow",
              value: function generateRow() {
                return this.eventType.padEnd(15) + this.getParamsString().padEnd(15);
              }
            }, {
              key: "getParamsString",
              value: function getParamsString() {
                if (!this.params) return o.colorizeText("Data not defined", s.YELLOW);
                var t = [];
                switch (this.eventType) {
                  case r().INIT:
                  case r().START:
                    this.params.player && t.push("Player: ".concat(this.params.player)), this.params.pluginVersion && t.push("Plugin Version: ".concat(this.params.pluginVersion)), this.params.playerStartupTime && t.push("Player Startup Time: ".concat(this.params.playerStartupTime, " ms")), this.params.playhead && t.push("Playhead: ".concat(this.params.playhead)), this.params.position && t.push("Position: ".concat(this.params.position)), this.params.breakNumber && t.push("Break Number: ".concat(this.params.breakNumber)), this.params.adAdapterVersion && t.push("Ad Adapter Version: ".concat(this.params.adAdapterVersion)), this.params.adDuration && t.push("Ad Duration: ".concat(this.params.adDuration));
                    break;
                  case r().JOIN:
                    this.params.rendition && t.push("Rendition: ".concat(this.params.rendition)), this.params.pingTime && t.push("Ping Time: ".concat(this.params.pingTime, " s")), this.params.playhead && t.push("Playhead: ".concat(this.params.playhead)), this.params.position && t.push("Position: ".concat(this.params.position)), this.params.breakNumber && t.push("Break Number: ".concat(this.params.breakNumber)), this.params.adJoinDuration && t.push("Ad Join Duration: ".concat(this.params.adJoinDuration)), this.params.adPlayhead && t.push("Ad Playhead: ".concat(this.params.adPlayhead));
                    break;
                  case r().JOIN_TIME:
                    this.params.joinDuration && t.push("Join Time: ".concat(this.params.joinDuration, " ms")), this.params.bitrate && t.push("Bitrate: ".concat((this.params.bitrate / 1e6).toFixed(2), " MB/s"));
                    break;
                  case r().PAUSE:
                    this.params.playhead && t.push("Playhead: ".concat(this.params.playhead));
                    break;
                  case r().RESUME:
                    this.params.playhead && t.push("Playhead: ".concat(this.params.playhead)), this.params.pauseDuration && t.push("Pause Duration: ".concat(this.params.pauseDuration, " ms"));
                    break;
                  case r().SEEK_BEGIN:
                    break;
                  case r().SEEK_END:
                    this.params.seekDuration && t.push("Seek Duration: ".concat(this.params.seekDuration, " ms"));
                    break;
                  case r().BUFFER_BEGIN:
                    break;
                  case r().BUFFER_END:
                    this.params.bufferDuration && t.push("Buffer Duration: ".concat(this.params.bufferDuration, " ms"));
                    break;
                  case r().ERROR:
                    break;
                  case r().STOP:
                    this.params.playhead && t.push("Playhead: ".concat(this.params.playhead)), this.params.bitrate && -1 !== this.params.bitrate ? t.push("Bitrate: ".concat((this.params.bitrate / 1e6).toFixed(2), " MB/s")) : this.params.bitrate && t.push("Bitrate: ".concat(this.params.bitrate)), this.params.position && t.push("Position: ".concat(this.params.position)), this.params.breakNumber && t.push("Break Number: ".concat(this.params.breakNumber)), this.params.adPlayhead && t.push("Ad Playhead: ".concat(this.params.adPlayhead)), this.params.adJoinDuration && t.push("Ad Join Duration: ".concat(this.params.adJoinDuration)), this.params.adViewedDuration && t.push("Ad Viewed Duration: ".concat(this.params.adViewedDuration)), this.params.adTotalDuration && t.push("Ad Total Duration: ".concat(this.params.adTotalDuration)), this.params.adBitrate && t.push("Ad Bitrate: ".concat(this.params.adBitrate));
                    break;
                  case r().VIDEO_EVENT:
                    break;
                  case r().QUARTILE:
                    this.params.position && t.push("Position: ".concat(this.params.position)), this.params.breakNumber && t.push("Break Number: ".concat(this.params.breakNumber)), this.params.quartile && t.push("Quartile: ".concat(this.params.quartile)), this.params.adViewedDuration && t.push("Ad Viewed Duration: ".concat(this.params.adViewedDuration));
                    break;
                  case r().PODSTART:
                    this.params.position && t.push("Position: ".concat(this.params.position)), this.params.breakNumber && t.push("Break Number: ".concat(this.params.breakNumber)), this.params.adInsertionType && t.push("Ad Insertion Type: ".concat(this.params.adInsertionType));
                    break;
                  case r().PODSTOP:
                    this.params.position && t.push("Position: ".concat(this.params.position)), this.params.breakNumber && t.push("Break Number: ".concat(this.params.breakNumber));
                  case r().CLICK:
                  case r().MANIFEST:
                }
                return 0 === t.length ? o.colorizeText("Data not defined", s.YELLOW) : t.join(" | ");
              }
            }]);
            return d;
          }();
          var c = i(3782),
            u = i.n(c),
            l = i(1577),
            h = i(9065);
          var p = /*#__PURE__*/function () {
            function p() {
              _classCallCheck(this, p);
              this.integrationMessageColors = {
                RED: "#FF1515",
                GREEN: "#0f0",
                YELLOW: "#F6D500"
              }, this.balancerEnabled = !0, this.videoAnalyticsEnabled = !0, this.adsAnalyticsEnabled = !0, this.reportTimeoutDuration = p.defaultReportTimeout, this.reportTimeoutStarted = !1, this.runningOffline = !1, this.balancerInterceptedRequests = !1, this.successfulResponseFromSelector = !1, this.usedSelectorAPI = !1, this.activeSwitchingEnabled = !1, this.asDecisionPerformed = !1, this.switchedCdns = !1, this.cdnList = new Map(), this.triedSendingBalancerStats = !1, this.mandatoryBalancerRequests = ["cdn"], this.capturedEvents = [], this.successfulNQSRequests = new Set(), this.hasPlayerRegistered = !1, this.triedSendingNQSStats = !1, this.mandatoryNQSRequests = [r().START, r().JOIN_TIME, "ping", r().STOP], this.shouldIgnoreAds = !1, this.capturedAdsEvents = [], this.successfulNQSAdsRequests = new Set(), this.hasAdsPlayerRegistered = !1, this.triedSendingNQSAdStats = !1, this.mandatoryNQSAdsRequests = [u().Service.AD_START, u().Service.AD_MANIFEST, u().Service.AD_JOIN, u().Service.AD_STOP, u().Service.AD_POD_START, u().Service.AD_QUARTILE, u().Service.AD_POD_STOP].map(function (t) {
                return t.slice(1);
              });
            }
            _createClass(p, [{
              key: "destroy",
              value: function destroy() {
                this.clearReportTimeout(), this.cleanCdnList(), this.capturedEvents = [], this.successfulNQSRequests.clear(), this.reportTimeoutStarted = !1;
              }
            }, {
              key: "start",
              value: function start(t) {
                var _this10 = this;
                t && (this.npawPluginInstance = t), this.reportTimeoutStarted || (this.reportTimeout = setTimeout(function () {
                  _this10.report(), _this10.videoAnalyticsEnabled = !1, _this10.balancerEnabled = !1, _this10.adsAnalyticsEnabled = !1;
                }, this.reportTimeoutDuration), this.reportTimeoutStarted = !0);
              }
            }, {
              key: "clearReportTimeout",
              value: function clearReportTimeout() {
                clearTimeout(this.reportTimeout), this.reportTimeoutStarted = !1, this.reportTimeout = void 0;
              }
            }, {
              key: "setOptions",
              value: function setOptions(t) {
                t && (t["ad.ignore"] && (this.shouldIgnoreAds = l.default.parseBoolean(t["ad.ignore"])), t.offline && (this.runningOffline = l.default.parseBoolean(t.offline)));
              }
            }, {
              key: "setBalancerEnabled",
              value: function setBalancerEnabled(t) {
                this.balancerEnabled = null != t ? t : this.balancerEnabled;
              }
            }, {
              key: "setVideoAnalyticsEnabled",
              value: function setVideoAnalyticsEnabled(t) {
                this.videoAnalyticsEnabled = null != t ? t : this.videoAnalyticsEnabled;
              }
            }, {
              key: "setAdsAnalyticsEnabled",
              value: function setAdsAnalyticsEnabled(t) {
                this.adsAnalyticsEnabled = null != t ? t : this.adsAnalyticsEnabled;
              }
            }, {
              key: "getReportTimeout",
              value: function getReportTimeout() {
                return this.reportTimeoutDuration;
              }
            }, {
              key: "setReportTimeout",
              value: function setReportTimeout(t) {
                t && t > 0 && (this.reportTimeoutDuration = null != t ? t : this.reportTimeoutDuration, this.clearReportTimeout(), this.start());
              }
            }, {
              key: "cleanCdnList",
              value: function cleanCdnList() {
                this.cdnList.clear();
              }
            }, {
              key: "addCdn",
              value: function addCdn(t, e) {
                this.cdnList.set(t, e);
              }
            }, {
              key: "updateCdnInfo",
              value: function updateCdnInfo(t, e, i, s) {
                if (this.balancerEnabled) {
                  var _n9 = this.cdnList.get(t);
                  _n9 && (_n9.setRequestsPerformed(e), _n9.setTrafficServerInBytes(i), _n9.setFailedRequests(s));
                }
              }
            }, {
              key: "wasSelectorCommunicationSuccessful",
              value: function wasSelectorCommunicationSuccessful(t, e) {
                this.successfulResponseFromSelector = t, e && (this.apiErrorMessage = e);
              }
            }, {
              key: "setInterceptedRequests",
              value: function setInterceptedRequests(t) {
                this.balancerInterceptedRequests = t;
              }
            }, {
              key: "setActiveSwitchingEnabled",
              value: function setActiveSwitchingEnabled(t) {
                this.activeSwitchingEnabled = t;
              }
            }, {
              key: "wasActiveSwitchingDecisionPerformed",
              value: function wasActiveSwitchingDecisionPerformed(t) {
                this.asDecisionPerformed = t;
              }
            }, {
              key: "setSwitchedCdns",
              value: function setSwitchedCdns(t) {
                this.switchedCdns = t;
              }
            }, {
              key: "usedSelectorAPIResponse",
              value: function usedSelectorAPIResponse(t) {
                this.usedSelectorAPI = t;
              }
            }, {
              key: "setTriedSendingBalancerStats",
              value: function setTriedSendingBalancerStats(t) {
                this.triedSendingBalancerStats = t;
              }
            }, {
              key: "addNQSRequest",
              value: function addNQSRequest(t) {
                (this.videoAnalyticsEnabled || this.balancerEnabled) && this.successfulNQSRequests.add(t);
              }
            }, {
              key: "addNQSEvent",
              value: function addNQSEvent(t, e) {
                var _this11 = this;
                this.videoAnalyticsEnabled && this.capturedEvents.push(new d(t, e)), "stop" === t && setTimeout(function () {
                  _this11.report(), _this11.clearReportTimeout();
                }, 500);
              }
            }, {
              key: "registeredPlayer",
              value: function registeredPlayer(t) {
                this.hasPlayerRegistered = t;
              }
            }, {
              key: "setTriedSendingNQSStats",
              value: function setTriedSendingNQSStats(t) {
                this.triedSendingNQSStats = t;
              }
            }, {
              key: "addNQSAdRequest",
              value: function addNQSAdRequest(t) {
                this.adsAnalyticsEnabled && this.successfulNQSAdsRequests.add(t);
              }
            }, {
              key: "addNQSAdEvent",
              value: function addNQSAdEvent(t, e) {
                this.adsAnalyticsEnabled && this.capturedAdsEvents.push(new d(t, e));
              }
            }, {
              key: "registeredAdsPlayer",
              value: function registeredAdsPlayer(t) {
                this.hasAdsPlayerRegistered = t;
              }
            }, {
              key: "setTriedSendingNQSAdStats",
              value: function setTriedSendingNQSAdStats(t) {
                this.triedSendingNQSAdStats = t;
              }
            }, {
              key: "report",
              value: function report() {
                if (this.balancerEnabled || this.videoAnalyticsEnabled || this.adsAnalyticsEnabled) {
                  var _t17 = "------- Certification Tool -------";
                  o.header(_t17), "ERROR_INVALID_ACCOUNT" === this.apiErrorMessage ? o.log("%cAccount code is invalid!", "color: #FF1515; font-size: 12px; font-weight: bold;") : (this.logBalancerDiagnostic(), h.default.getInstance().isUsingLegacy() || (this.logVideoAnalyticsDiagnostic(), this.logAdsAnalyticsDiagnostic())), this.videoAnalyticsEnabled = !1, this.balancerEnabled = !1, this.adsAnalyticsEnabled = !1, this.clearReportTimeout(), o.header("".padEnd(_t17.length, "-"));
                }
              }
            }, {
              key: "logBalancerDiagnostic",
              value: function logBalancerDiagnostic() {
                var t, e;
                if (!this.balancerEnabled || null !== (e = null === (t = this.npawPluginInstance) || void 0 === t ? void 0 : t.isBalancerEnabled()) && void 0 !== e && !e) return;
                var i = Array.from(this.successfulNQSRequests).map(function (t) {
                    return t.slice(1);
                  }),
                  n = this.mandatoryBalancerRequests.some(function (t) {
                    return i.includes(t);
                  }),
                  r = this.mandatoryBalancerRequests.filter(function (t) {
                    return !i.includes(t);
                  });
                if (o.header("Balancer Diagnostic"), o.logWithPrefix("Intercepted requests: " + (this.balancerInterceptedRequests ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), this.runningOffline ? o.logWithPrefix("Ignoring Balancer stats since running in offline mode", o.logIdent) : this.triedSendingBalancerStats ? o.logWithPrefix("Any event sent to server: " + (n ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent) : o.logWithPrefix("Reached stats server: Unknown", o.logIdent), !this.runningOffline && r.length > 0 && this.triedSendingBalancerStats && o.logWithPrefix(o.colorizeText("Missing requests: " + r.join(", "), s.YELLOW), o.logIdent), o.logWithPrefix("Request to the Selector API: " + (this.successfulResponseFromSelector ? o.colorizeText("Successful", s.GREEN) : o.colorizeText("Unsuccessful", s.RED)), o.logIdent), this.apiErrorMessage && !this.successfulResponseFromSelector && o.logWithPrefix(this.getApiErrorMessage(), o.logIdent, 2), o.logWithPrefix("Took decision based on Selector API: " + (this.usedSelectorAPI ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), this.activeSwitchingEnabled ? o.logWithPrefix("Active switching decision: " + (this.asDecisionPerformed ? o.colorizeText("Performed", s.GREEN) : o.colorizeText("Not performed", s.RED)), o.logIdent) : o.logWithPrefix("Active switching decision: " + o.colorizeText("Active Switching Disabled!", s.YELLOW), o.logIdent), o.logWithPrefix("CDN List: ", o.logIdent), this.cdnList.size > 0) {
                  var _t18 = this.cdnList.values().next().value.columns.map(function (t) {
                    return t.padEnd(18);
                  }).join("");
                  o.logWithPrefix(_t18, o.logIdent, 2);
                } else o.logWithPrefix(o.colorizeText("The list is empty!", s.RED), o.logIdent, 2);
                var _iterator5 = _createForOfIteratorHelper(this.cdnList.values()),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var _t19 = _step5.value;
                    var _e20 = _t19.generateRow();
                    o.log(o.logIdent.repeat(2) + _e20.row, "color: " + _e20.color);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                var a = Array.from(this.cdnList.values()).filter(function (t) {
                    return t.getFailedRequestsPercentage() > 30;
                  }).length,
                  d = this.successfulResponseFromSelector && this.balancerInterceptedRequests && this.usedSelectorAPI && this.cdnList.size > 0 && (!this.triedSendingBalancerStats || n);
                var c = this.integrationMessageColors.YELLOW,
                  u = "%cCDN Balancer might not be integrated!";
                d ? this.triedSendingBalancerStats && 0 === r.length && a < this.cdnList.size && (u = "%cCDN Balancer is integrated!", c = this.integrationMessageColors.GREEN) : (u = "%cCDN Balancer is NOT integrated!", c = this.integrationMessageColors.RED), o.log(u, "color: ".concat(c, "; font-size: 12px; font-weight: bold;"));
              }
            }, {
              key: "logVideoAnalyticsDiagnostic",
              value: function logVideoAnalyticsDiagnostic() {
                if (!this.videoAnalyticsEnabled) return;
                var t = Array.from(this.successfulNQSRequests).map(function (t) {
                    return t.slice(1);
                  }),
                  e = this.mandatoryNQSRequests.filter(function (e) {
                    return !t.includes(e);
                  });
                if (o.header("Video Analytics Diagnostic"), o.logWithPrefix("Events sent to server/storage: " + (0 !== t.length ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), o.logWithPrefix("All mandatory events sent to server/storage: " + (0 === e.length ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), e.length > 0 && this.triedSendingNQSStats && o.logWithPrefix("Missing stats requests: " + o.colorizeText(e.join(", "), s.RED), o.logIdent), o.logWithPrefix("Was able to capture events: " + (this.capturedEvents.length > 0 ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), o.logWithPrefix("Captured events:", o.logIdent), this.capturedEvents.length > 0) {
                  var _t20 = this.capturedEvents[0].columns.map(function (t) {
                    return t.padEnd(15);
                  }).join("");
                  o.logWithPrefix(_t20, o.logIdent, 2);
                } else o.logWithPrefix(o.colorizeText("No events captured!", s.RED), o.logIdent, 2);
                var _iterator6 = _createForOfIteratorHelper(this.capturedEvents),
                  _step6;
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    var _t21 = _step6.value;
                    o.logWithPrefix(_t21.generateRow(), o.logIdent, 2);
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
                var i = this.hasPlayerRegistered && 0 !== t.length && this.capturedEvents.length > 0;
                var n = this.integrationMessageColors.YELLOW,
                  r = "%cVideo Analytics might not be integrated!";
                i ? this.triedSendingNQSStats && 0 === e.length && (r = "%cVideo Analytics is integrated!", n = this.integrationMessageColors.GREEN) : (r = "%cVideo Analytics is NOT integrated!", n = this.integrationMessageColors.RED), o.log(r, "color: ".concat(n, "; font-size: 12px; font-weight: bold;"));
              }
            }, {
              key: "logAdsAnalyticsDiagnostic",
              value: function logAdsAnalyticsDiagnostic() {
                if (!this.adsAnalyticsEnabled) return;
                var t = Array.from(this.successfulNQSAdsRequests).map(function (t) {
                    return t.slice(1);
                  }),
                  e = this.mandatoryNQSAdsRequests.filter(function (e) {
                    return !t.includes(e);
                  });
                if (o.header("Ads Analytics Diagnostic"), this.shouldIgnoreAds && o.log("%cIgnoring Ads Analytics because ad.ignore option is set to true", "color: ".concat(this.integrationMessageColors.YELLOW, "; font-size: 12px; font-weight: bold;")), this.hasAdsPlayerRegistered || 0 !== t.length) {
                  if (o.logWithPrefix("Events sent to server/storage: " + (0 !== t.length ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), o.logWithPrefix("All mandatory events sent to server/storage: " + (0 === e.length ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), e.length > 0 && this.triedSendingNQSAdStats && o.logWithPrefix("Missing ad stats requests: " + o.colorizeText(e.join(", "), s.RED), o.logIdent), o.logWithPrefix("Was able to capture ads events: " + (this.capturedAdsEvents.length > 0 ? o.colorizeText("Yes", s.GREEN) : o.colorizeText("No", s.RED)), o.logIdent), o.logWithPrefix("Captured events:", o.logIdent), this.capturedAdsEvents.length > 0) {
                    var _t22 = this.capturedAdsEvents[0].columns.map(function (t) {
                      return t.padEnd(15);
                    }).join("");
                    o.logWithPrefix(_t22, o.logIdent, 2);
                  } else o.logWithPrefix(o.colorizeText("No events captured!", s.RED), o.logIdent, 2);
                  var _iterator7 = _createForOfIteratorHelper(this.capturedAdsEvents),
                    _step7;
                  try {
                    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                      var _t23 = _step7.value;
                      o.logWithPrefix(_t23.generateRow(), o.logIdent, 2);
                    }
                  } catch (err) {
                    _iterator7.e(err);
                  } finally {
                    _iterator7.f();
                  }
                  var _i15 = (this.hasAdsPlayerRegistered || 0 != t.length) && this.capturedAdsEvents.length > 0;
                  var _n10 = this.integrationMessageColors.YELLOW,
                    _r5 = "%cAds Analytics might not be integrated!";
                  _i15 ? 0 === e.length && (_r5 = "%cAds Analytics is integrated!", _n10 = this.integrationMessageColors.GREEN) : (_r5 = "%cAds Analytics is NOT integrated!", _n10 = this.integrationMessageColors.RED), o.log(_r5, "color: ".concat(_n10, "; font-size: 12px; font-weight: bold;"));
                } else o.log("%cIgnoring Ads Analytics because no ads adapter was registered", "color: ".concat(this.integrationMessageColors.YELLOW, "; font-size: 12px; font-weight: bold;"));
              }
            }, {
              key: "getApiErrorMessage",
              value: function getApiErrorMessage() {
                return "ERROR_CONFIGURATION_NOT_FOUND" === this.apiErrorMessage ? o.colorizeText("".concat(this.apiErrorMessage, " - Default profile not set or profile doesn't exist"), s.YELLOW) : this.apiErrorMessage;
              }
            }], [{
              key: "getInstance",
              value: function getInstance() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                return this._instance && !t || (this._instance = new p()), this._instance;
              }
            }]);
            return p;
          }();
          p.defaultReportTimeout = 3e5;
        },
        9731: function _(t) {
          var e, i, s, n, r;
          e = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, i = /^(?=([^\/?#]*))\1([^]*)$/, s = /(?:\/|^)\.(?=\/)/g, n = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, r = {
            buildAbsoluteURL: function buildAbsoluteURL(t, e, s) {
              if (s = s || {}, t = t.trim(), !(e = e.trim())) {
                if (!s.alwaysNormalize) return t;
                var n = r.parseURL(t);
                if (!n) throw new Error("Error trying to parse base URL.");
                return n.path = r.normalizePath(n.path), r.buildURLFromParts(n);
              }
              var a = r.parseURL(e);
              if (!a) throw new Error("Error trying to parse relative URL.");
              if (a.scheme) return s.alwaysNormalize ? (a.path = r.normalizePath(a.path), r.buildURLFromParts(a)) : e;
              var o = r.parseURL(t);
              if (!o) throw new Error("Error trying to parse base URL.");
              if (!o.netLoc && o.path && "/" !== o.path[0]) {
                var d = i.exec(o.path);
                o.netLoc = d[1], o.path = d[2];
              }
              o.netLoc && !o.path && (o.path = "/");
              var c = {
                scheme: o.scheme,
                netLoc: a.netLoc,
                path: null,
                params: a.params,
                query: a.query,
                fragment: a.fragment
              };
              if (!a.netLoc && (c.netLoc = o.netLoc, "/" !== a.path[0])) if (a.path) {
                var u = o.path,
                  l = u.substring(0, u.lastIndexOf("/") + 1) + a.path;
                c.path = r.normalizePath(l);
              } else c.path = o.path, a.params || (c.params = o.params, a.query || (c.query = o.query));
              return null === c.path && (c.path = s.alwaysNormalize ? r.normalizePath(a.path) : a.path), r.buildURLFromParts(c);
            },
            parseURL: function parseURL(t) {
              var i = e.exec(t);
              return i ? {
                scheme: i[1] || "",
                netLoc: i[2] || "",
                path: i[3] || "",
                params: i[4] || "",
                query: i[5] || "",
                fragment: i[6] || ""
              } : null;
            },
            normalizePath: function normalizePath(t) {
              for (t = t.split("").reverse().join("").replace(s, ""); t.length !== (t = t.replace(n, "")).length;);
              return t.split("").reverse().join("");
            },
            buildURLFromParts: function buildURLFromParts(t) {
              return t.scheme + t.netLoc + t.path + t.params + t.query + t.fragment;
            }
          }, t.exports = r;
        },
        5438: function _(t, e, i) {
          "use strict";

          i.d(e, {
            CE: function CE() {
              return m;
            },
            Ji: function Ji() {
              return b;
            },
            LI: function LI() {
              return y;
            },
            Lg: function Lg() {
              return l;
            },
            Ow: function Ow() {
              return p;
            },
            Y4: function Y4() {
              return d;
            },
            Zq: function Zq() {
              return w;
            },
            _C: function _C() {
              return E;
            },
            b3: function b3() {
              return v;
            },
            dR: function dR() {
              return S;
            },
            df: function df() {
              return o;
            },
            jQ: function jQ() {
              return T;
            },
            m: function m() {
              return h;
            },
            mH: function mH() {
              return g;
            },
            w2: function w2() {
              return u;
            },
            wc: function wc() {
              return A;
            },
            xC: function xC() {
              return n;
            },
            yL: function yL() {
              return r;
            },
            yl: function yl() {
              return a;
            }
          });
          var s = c;
          !function (t, e) {
            var i = c,
              s = t();
            for (;;) try {
              if (681399 == -parseInt(i(502)) / 1 * (parseInt(i(471)) / 2) + -parseInt(i(495)) / 3 + parseInt(i(489)) / 4 * (-parseInt(i(468)) / 5) + parseInt(i(487)) / 6 * (-parseInt(i(474)) / 7) + parseInt(i(493)) / 8 * (-parseInt(i(472)) / 9) + -parseInt(i(476)) / 10 + parseInt(i(496)) / 11 * (parseInt(i(508)) / 12)) break;
              s.push(s.shift());
            } catch (t) {
              s.push(s.shift());
            }
          }(f);
          var n = {
              CDN: s(499)
            },
            r = {
              Success: "ok",
              Fail: "nok",
              Progress: "pr"
            },
            a = {
              Updated: s(506),
              Success: "ok",
              Fail: s(505)
            },
            o = {
              host: s(475),
              devHost: s(501),
              devDomains: [s(480), s(463)],
              service: s(486),
              decisionCallWaitTime: 3e4,
              decisionReloadIntervalPerManifestMilliseconds: 3e4
            },
            d = [s(467), ".m4s", ".ts", s(470), s(483), s(478)];
          function c(t, e) {
            var i = f();
            return (c = function c(t, e) {
              return i[t -= 461];
            })(t, e);
          }
          var u = [s(465), s(464)],
            l = {
              connect: s(473),
              close: s(479),
              error: s(482),
              data: s(490),
              ping: s(466),
              pong: s(485)
            },
            h = {
              optimizedScore: s(504),
              optimizedFeedback: s(481),
              bestScore: "bestScore",
              qualityPriority: s(500),
              cdnPriority: s(461)
            },
            p = {
              max: 25e6,
              min: 2e5,
              default: 2e5
            };
          function f() {
            var t = [".m4f", "close", "stage.npaw.com", "optimizedFeedback", "error", ".dash", "size", "pong", "/decision", "17070NmkqLY", "SEGMENTS_MAP", "4YmZvIC", "data", "PONG", "keys", "8CAnmOw", "command", "656409CCRdDA", "451pgLvVC", "data_spec_key", "NEW_SEGMENT_AVAILABLE", "/cdn", "qualityPriority", "stage-smartswitchv2.youbora.com", "170485YJJDuI", "splits", "optimizedScore", "nok", "updated", "identifier", "1346556EFpYpg", "cdnPriority", "SEGMENT_ABSENT", "qa.npaw.com", ".mpd", ".m3u8", "ping", ".mp4", "4425275zlbQNO", "SEGMENT_DATA", ".cmf", "14WsIhzS", "2363292BYBeBd", "connect", "1358LzuCwp", "gnsnpaw.com", "8075630KKagil", "CANCEL_SEGMENT_REQUEST"];
            return (f = function f() {
              return t;
            })();
          }
          var g = {
              data: s(469),
              absent: s(462),
              map: s(488),
              newSegmentAvailable: s(498),
              request: "SEGMENT_REQUEST",
              cancel: s(477),
              ping: "PING",
              pong: s(491)
            },
            m = {
              command: s(494),
              id: s(497),
              size: s(484),
              storageSize: "ss",
              map: s(492),
              identifier: s(507),
              splits: s(503),
              time: 0,
              simpleMapKeys: "k",
              simpleMapSize: "s",
              dateTime: "dt",
              createdAt: "ca"
            },
            v = {
              bandwidth_test: 2,
              message: 1,
              data: 0
            },
            y = {
              maxMessageSize: 65532,
              probability: 1,
              timeout: 2500,
              maxConcurrency: 6,
              maxConnectedPeers: 40,
              tracker: "wss://p2p-tracker.youbora.com/webrtc",
              upload: !1
            },
            T = {
              version: 2
            },
            S = {
              expiration: 3e5,
              count: 60,
              safeMaxCount: 300
            },
            E = {
              retries: 5,
              retryDelay: 100,
              defaultBwThreshold: 2e5,
              connectTimeoutMilliseconds: 1e4,
              readTimeoutMilliseconds: 3e3,
              minRequestSizeForBwEstimateKB: 100
            },
            b = {
              totalDataInterval: 6e4
            },
            A = {
              callTimeoutMilliseconds: 500,
              timeBetweenCallsMilliseconds: 1e3,
              timeBetweenBurstsMilliseconds: 5e3
            },
            w = {
              lastMeasurementWeight: .5,
              maximumRelativeDeltaForTrial: .2,
              minimumDurationSinceLastUsedForTrialMilliseconds: 3e4
            };
        },
        9393: function _(t, e, i) {
          var s = i(7086),
            n = i(7680),
            r = {
              getPosition: function getPosition() {
                return null;
              },
              getGivenBreaks: function getGivenBreaks() {
                return null;
              },
              getExpectedBreaks: function getExpectedBreaks() {
                return null;
              },
              getExpectedPattern: function getExpectedPattern() {
                return null;
              },
              getBreaksTime: function getBreaksTime() {
                return null;
              },
              getGivenAds: function getGivenAds() {
                return null;
              },
              getExpectedAds: function getExpectedAds() {
                return null;
              },
              getIsVisible: function getIsVisible() {
                return !0;
              },
              getAudioEnabled: function getAudioEnabled() {
                return null;
              },
              getIsSkippable: function getIsSkippable() {
                return null;
              },
              getIsFullscreen: function getIsFullscreen() {
                return null;
              },
              getCampaign: function getCampaign() {
                return null;
              },
              getCreativeId: function getCreativeId() {
                return null;
              },
              getProvider: function getProvider() {
                return null;
              },
              getAdInsertionType: function getAdInsertionType() {
                return null;
              },
              fireClick: function fireClick(t) {
                "string" == typeof t && (t = {
                  url: t
                }), this.emit(s.Event.CLICK, {
                  params: t
                });
              },
              fireQuartile: function fireQuartile(t) {
                this.flags.isStarted && "number" == typeof t && t > this.flags.lastQuartileSent && t < 4 && (this.flags.lastQuartileSent++, this.emit(s.Event.QUARTILE, {
                  params: {
                    quartile: t
                  }
                }));
              },
              startChronoView: function startChronoView() {
                if (this.getIsVisible() && this.plugin.backgroundDetector && !this.plugin.backgroundDetector.isInBackground) {
                  var t = this.chronos.viewedMax;
                  0 !== t.length && 0 === t[t.length - 1].stopTime || (t.push(new n()), t[t.length - 1].start());
                }
              },
              stopChronoView: function stopChronoView() {
                var t = this.chronos.viewedMax;
                t[0] && t.length > 0 && 0 === t[t.length - 1].stopTime && t[t.length - 1].stop();
              },
              fireManifest: function fireManifest(t, e) {
                var i = {
                  params: t
                };
                "string" == typeof t && (i = {
                  params: {
                    errorType: t,
                    errorMessage: e
                  }
                }), this.emit(s.Event.MANIFEST, i);
              },
              fireSkip: function fireSkip(t) {
                void 0 === t && (t = {}), t.skipped = !0, this.fireStop(t);
              },
              fireBreakStart: function fireBreakStart(t) {
                this.fireAdBreakStart(t);
              },
              fireBreakStop: function fireBreakStop(t) {
                this.fireAdBreakStop(t);
              },
              fireAdBreakStart: function fireAdBreakStart(t) {
                this.emit(s.Event.PODSTART, {
                  params: t
                });
              },
              fireAdBreakStop: function fireAdBreakStop(t) {
                this.emit(s.Event.PODSTOP, {
                  params: t
                });
              }
            };
          t.exports = r;
        },
        594: function _(t, e, i) {
          var s = i(7086);
          var _i16 = i(7276),
            n = _i16.default,
            _i17 = i(2784),
            r = _i17.AnalyticsTag;
          var a = {
            getPlayrate: function getPlayrate() {
              return this.flags.isPaused ? 0 : 1;
            },
            getFramesPerSecond: function getFramesPerSecond() {},
            getDroppedFrames: function getDroppedFrames() {},
            getThroughput: function getThroughput() {},
            getRendition: function getRendition() {},
            getTitle2: function getTitle2() {},
            getIsLive: function getIsLive() {},
            getCdnTraffic: function getCdnTraffic() {},
            getP2PTraffic: function getP2PTraffic() {},
            getUploadTraffic: function getUploadTraffic() {},
            getIsP2PEnabled: function getIsP2PEnabled() {},
            getSegmentDuration: function getSegmentDuration() {},
            getHouseholdId: function getHouseholdId() {},
            getLatency: function getLatency() {},
            getPacketLoss: function getPacketLoss() {},
            getPacketSent: function getPacketSent() {},
            getMetrics: function getMetrics() {},
            getAudioCodec: function getAudioCodec() {},
            getVideoCodec: function getVideoCodec() {},
            getURLToParse: function getURLToParse() {},
            fireSeekBegin: function fireSeekBegin(t, e, i) {
              if (this._discardFalseBuffers(), !(this.getVideo() && this.getVideo().getIsLive() && this.plugin.options["content.isLive.noSeek"]) && this.flags.isJoined && !this.flags.isSeeking) {
                if (this.flags.isBuffering) {
                  if (!1 === e) return;
                  n.notice(r, "Converting current buffer to seek"), this.chronos.seek = this.chronos.buffer.clone(), this.chronos.buffer.reset(), this.flags.isBuffering = !1;
                } else this.chronos.seek.start();
                try {
                  this.fireEventsStruct.seek = [], i ? this.fireEventsStruct.seek.push(i) : this.fireEventsStruct.seek.push("undefinedEvent");
                } catch (t) {}
                this.flags.isSeeking = !0, this.emit(s.Event.SEEK_BEGIN, {
                  params: t
                });
              }
            },
            fireSeekEnd: function fireSeekEnd(t, e) {
              if (!(this.getVideo() && this.getVideo().getIsLive() && this.plugin.options["content.isLive.noSeek"]) && this.flags.isJoined && this.flags.isSeeking) {
                try {
                  e ? this.fireEventsStruct.seek.push(e) : this.fireEventsStruct.seek.push("undefinedEvent");
                } catch (t) {}
                (t = t || {}).triggeredEvents = this.fireEventsStruct.seek, this.cancelSeek(), this.emit(s.Event.SEEK_END, {
                  params: t
                });
                try {
                  this.chronos.pause.getDeltaTime(!1) > 0 && this.chronos.pause.resume();
                } catch (t) {}
              }
            },
            cancelSeek: function cancelSeek(t) {
              this.flags.isJoined && this.flags.isSeeking && (this.flags.isSeeking = !1, this.chronos.seek.stop(), this.monitor && this.monitor.skipNextTick());
            },
            fireEvent: function fireEvent(t, e, i, n) {
              var r = n || {};
              r.name = t || "", r.dimensions = e || {}, r.values = i || {}, this.emit(s.Event.VIDEO_EVENT, {
                params: r
              });
            },
            storeNewRendition: function storeNewRendition(t) {
              this.getVideo().triggerUpdateRendition(t);
            }
          };
          t.exports = a;
        },
        5292: function _(t, e, i) {
          var s = i(1593);
          var _i18 = i(7276),
            n = _i18.default;
          var r = i(2507),
            a = i(9835),
            o = i(5200),
            d = i(7255),
            c = i(3381),
            u = i(8490),
            l = i(7086),
            h = i(6777);
          var _i19 = i(2784),
            p = _i19.AnalyticsTag,
            _i20 = i(9065),
            f = _i20.default,
            _i21 = i(61),
            g = _i21.default;
          var m = s.extend({
            constructor: function constructor(t, e, s, r, c, u) {
              this._key = t, this._setAdapter = !1, this._npawVideo = e, this._loadedAdapterImplementation = !1, this.flags = new d(), this.chronos = new o(), this.fireEventsStruct = {}, this.fireEventsStruct.buffer = [], this.fireEventsStruct.seek = [], this.monitor = null, this.plugin = s, this.player && this.unregisterListeners(), this.player = null, this._isAdsAdapter = null, this.log = n, this.log.loadLevelFromUrl(), this.npaw = i(6014), this.setPlayer(c);
              var l = "object" != typeof u;
              var h;
              var f = l ? JSON.parse(u) : void 0;
              if (this._adapterName = l ? this.getAdapterName(f) : this.getAdapterNameFromClass(u), l && this.plugin && this.plugin.canOverwriteAdapters() && (h = this._getAdapterFromTemplates(this._adapterName), h && n.notice(p, "Overwrite Adapter: " + this._adapterName)), l && !h) if (u) try {
                h = f;
              } catch (t) {
                n.warn(p, "Problem parsing adapter json code (to object conversion)");
              } else h = this._getAdapterFromTemplates(this._adapterName);
              this.tag = this.player, l && h ? (this.evalAdapterJson(h, !1), this.registerListeners()) : !l && u && (this.loadAdapterClasses(u, !1), this.registerListeners()), this.plugin.options.enableExtraMetricCollection && this._npawVideo.fetchLocation(), n.notice(p, "Adapter " + this.getVersion() + " with Lib " + a + " is ready.");
            },
            _updatePlayer: function _updatePlayer(t) {
              this.player && this.unregisterListeners(), this.player = null, this.setPlayer(t), this.tag = this.player, this.registerListeners();
            },
            isSetAdapter: function isSetAdapter() {
              return this._setAdapter;
            },
            getVideo: function getVideo() {
              return this._npawVideo;
            },
            getPlugin: function getPlugin() {
              return this.plugin;
            },
            getNpawUtils: function getNpawUtils() {
              return this.plugin.utils;
            },
            getNpawReference: function getNpawReference() {
              return this.npaw;
            },
            getLog: function getLog() {
              return this.log;
            },
            isStarted: function isStarted() {
              return !!this.flags && this.flags.isStarted;
            },
            getAdapterClass: function getAdapterClass(t) {
              if (this._npawVideo) {
                var e = this._npawVideo.getAdapterClasses() || {};
                if (e[t]) return e[t];
              }
              return null;
            },
            getAdapterName: function getAdapterName(t) {
              if (t && t["adapter,getVersion"]) try {
                return window.Function(t["adapter,getVersion"])();
              } catch (t) {}
              return "undefined";
            },
            getAdapterNameFromClass: function getAdapterNameFromClass(t) {
              if (t && t.getVersion) try {
                return t.getVersion();
              } catch (t) {}
              return "undefined";
            },
            getAdapterClasses: function getAdapterClasses() {
              return this._npawVideo ? this._npawVideo.getAdapterClasses() || {} : null;
            },
            updateAdapterTemplates: function updateAdapterTemplates(t) {
              if (this.plugin.canOverwriteAdapters()) {
                var e = this._getAdapterFromTemplates(this._adapterName, t);
                e && (this.evalAdapterJson(e, !0), this.registerListeners());
              }
            },
            _getAdapterFromTemplates: function _getAdapterFromTemplates(t, e) {
              var i = null;
              e || (e = this.plugin.adapterTemplates);
              try {
                t && e && e[t.toLowerCase()] && (i = JSON.parse(e[t.toLowerCase()]));
              } catch (e) {
                n.warn(p, "Adapter " + t + " not found on repository");
              }
              return i;
            },
            evalAdapterJson: function evalAdapterJson(t, e) {
              e = e || !1;
              var i = 0,
                s = 0,
                r = "";
              try {
                for (var a in t) {
                  var o = a.split(","),
                    d = o.shift(),
                    c = o.shift();
                  r = c;
                  var u = null;
                  if (o && o.length >= 1) {
                    var l = o;
                    u = window.Function(l, t[a]);
                  } else u = window.Function(t[a]);
                  u && ("adapter" === d.toLowerCase() ? (this[c] = u, i++) : d.indexOf(".adapter") > 0 ? (d = d.replace(".adapter", ""), this.getAdapterClasses()[d] || (this.getAdapterClasses()[d] = new m(this._key, this._npawVideo, this.getPlugin(), null, this.player, null, null, {})), this.getAdapterClasses()[d][c] = u, s++) : (this.getAdapterClasses()[d] || (this.getAdapterClasses()[d] = {}, this.getAdapterClasses()[d].constructor = function () {}, this.getAdapterClasses()[d].plugin = this.plugin, this.getAdapterClasses()[d].getNpawUtils = function () {
                    return this.plugin.utils;
                  }), this.getAdapterClasses()[d][c] = u, s++));
                }
                this._loadedAdapterImplementation = !0, this._adapterEvaluatedCode = t;
                try {
                  this.adapterHash = h("string" == typeof t ? t.trim() : JSON.stringify(t).trim());
                } catch (t) {
                  this.adapterHash = "Undefined";
                }
                n.notice(p, "[" + this.getAdapterKey() + "] Loaded adapter (" + this.getVersion() + ") (Hash " + this.adapterHash + ") implementation from JSON; From templates: " + e + "; Integrated adapter methods: " + i + ", external methods: " + s);
              } catch (t) {
                n.error(p, "Can't be evaluated adapter json correctly; From templates: " + e + ", Last method evaluated: " + r);
              }
            },
            loadAdapterClasses: function loadAdapterClasses(t, e) {
              var _this12 = this;
              e = e || !1;
              var i = 0,
                s = 0,
                r = "",
                a = Object.getPrototypeOf(t);
              try {
                var _o3 = "";
                var _d5 = new Map();
                for (; a !== Object.prototype;) Object.getOwnPropertyNames(a).forEach(function (t) {
                  "function" != typeof a[t] || "constructor" === t || _d5.has(t) || _d5.set(t, a[t]);
                }), a = Object.getPrototypeOf(a);
                if (_d5.forEach(function (t, e) {
                  _this12[e] = t, _o3 += t.toString(), i++;
                }), r = "Adapter Class", void 0 !== t.adsAdapters) for (var _i22 = 0, _Object$keys = Object.keys(t.adsAdapters); _i22 < _Object$keys.length; _i22++) {
                  var _e21 = _Object$keys[_i22];
                  this.getAdapterClasses()[_e21] = new m(this._key, this._npawVideo, this.getPlugin(), null, this.player, new t.adsAdapters[_e21]()), r = "Ads Adapter -> " + _e21;
                }
                if (void 0 !== t.additionalContexts) {
                  var _loop = function _loop() {
                    var e = _Object$keys2[_i23];
                    _this12.getAdapterClasses()[e] || (_this12.getAdapterClasses()[e] = {}, _this12.getAdapterClasses()[e].constructor = function () {}, _this12.getAdapterClasses()[e].plugin = _this12.plugin, _this12.getAdapterClasses()[e].getNpawUtils = function () {
                      return this.plugin.utils;
                    });
                    var i = new t.additionalContexts[e](),
                      n = Object.getPrototypeOf(i),
                      r = Object.getOwnPropertyNames(n).filter(function (t) {
                        return "function" == typeof i[t] && "constructor" !== t;
                      });
                    var _iterator8 = _createForOfIteratorHelper(r),
                      _step8;
                    try {
                      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                        var _t24 = _step8.value;
                        _this12.getAdapterClasses()[e][_t24] = i[_t24], s++;
                      }
                    } catch (err) {
                      _iterator8.e(err);
                    } finally {
                      _iterator8.f();
                    }
                  };
                  for (var _i23 = 0, _Object$keys2 = Object.keys(t.additionalContexts); _i23 < _Object$keys2.length; _i23++) {
                    _loop();
                  }
                  r = "Additional Contexts";
                }
                this._loadedAdapterImplementation = !0;
                try {
                  this.adapterHash = h(_o3.trim());
                } catch (t) {
                  this.adapterHash = "Undefined";
                }
                n.notice(p, "[" + this.getAdapterKey() + "] Loaded adapter (" + this.getVersion() + ") (Hash " + this.adapterHash + ") implementation from class; From templates: " + e + "; Integrated adapter methods: " + i + ", external methods: " + s);
              } catch (t) {
                n.error(p, "Can't be evaluated adapter class correctly; From templates: " + e + ", Last method evaluated: " + r);
              }
            },
            getAdapterKey: function getAdapterKey() {
              return this._key;
            },
            setPlayer: function setPlayer(t) {
              "string" == typeof t && "undefined" != typeof document ? this.player = document.getElementById(t) : this.player = t;
            },
            registerListeners: function registerListeners() {},
            unregisterListeners: function unregisterListeners() {},
            dispose: function dispose() {
              try {
                this.stopMonitor(), this.stopReadyStateMonitor(), this.unregisterListeners(), this.player = null, this.tag = null;
              } catch (t) {
                n.error(p, "Can't process dispose for video " + this._key);
              }
            },
            monitorPlayhead: function monitorPlayhead(t, e, i) {
              this.stopMonitor();
              var s = 0;
              t && (s |= c.Type.BUFFER), e && (s |= c.Type.SEEK), this.monitor && this.monitor._timer.isRunning ? this.monitor.skipNextTick() : this.monitor = new c(this, s, i);
            },
            stopMonitor: function stopMonitor() {
              this.monitor && this.monitor.stop();
            },
            monitorReadyState: function monitorReadyState(t) {
              this.stopReadyStateMonitor(), this.stateMonitor = new u(this, t);
            },
            startReadyStateMonitor: function startReadyStateMonitor() {
              this.stateMonitor && this.stateMonitor.start();
            },
            stopReadyStateMonitor: function stopReadyStateMonitor() {
              this.stateMonitor && this.stateMonitor.stop();
            },
            checkReadyState: function checkReadyState(t, e) {
              try {
                this.plugin && this.plugin.getReadyStateMonitorEnabled() && t && (t > 3 && !this.flags.isSeeking ? this.flags.isBuffering ? this.fireBufferEnd({}, e + "-readyState") : this.flags.isJoined || this.fireJoin({}, e + "-readyState") : t < 4 && !this.flags.isBuffering && !this.flags.isPaused && this.fireBufferBegin({}, !1, e + "-readyState", !0));
              } catch (t) {
                n.error(p, "Can't check readyState property correctly");
              }
            },
            getPlayhead: function getPlayhead() {
              return null;
            },
            getDuration: function getDuration() {
              return null;
            },
            getBitrate: function getBitrate() {
              return null;
            },
            getTotalBytes: function getTotalBytes() {
              return null;
            },
            getTitle: function getTitle() {
              return null;
            },
            getResource: function getResource() {
              return null;
            },
            getPlayerVersion: function getPlayerVersion() {
              return null;
            },
            getPlayerName: function getPlayerName() {
              return null;
            },
            getVersion: function getVersion() {
              return a + "-generic-js";
            },
            getVideoObject: function getVideoObject() {
              return null;
            },
            getLastUsedCdn: function getLastUsedCdn() {
              return f.getInstance().getCommonVariable(g.Products.BALANCER, g.BalancerVariables.LAST_USED_CDN) || void 0;
            },
            checkExistsPlayer: function checkExistsPlayer() {
              return !0;
            },
            checkExistsObjectOnPage: function checkExistsObjectOnPage(t) {
              return r.elementIsInPage(t);
            },
            fireInit: function fireInit(t, e) {
              if (this._npawVideo && this._npawVideo.controlPlayerExists() && !this.checkExistsPlayer()) return n.warn(p, "Cannot fire init event because player not exists on the document"), null;
              this.adapterHash && ((t = t || {}).pluginHash = this.adapterHash), this._npawVideo && this._npawVideo.fireInit(t, e);
            },
            fireStart: function fireStart(t, e) {
              return this._npawVideo && this._npawVideo.controlPlayerExists() && !this.checkExistsPlayer() ? (n.warn(p, "Cannot fire start event because player not exists on the document"), null) : this.plugin && this.plugin.backgroundDetector && this.plugin.backgroundDetector.canBlockStartCalls() ? null : void (this.flags.isStarted || (this.flags.isStarted = !0, this.chronos.total.start(), this.chronos.join.start(), e && ((t = t || {}).triggeredEvents = [e]), this.adapterHash && ((t = t || {}).pluginHash = this.adapterHash), this.startReadyStateMonitor(), this.emit(l.Event.START, {
                params: t
              }), this.plugin._logSetAdapterEvent(this._adapterEvaluatedCode)));
            },
            fireJoin: function fireJoin(t, e) {
              this.flags.isJoined || this.flags.isStarted || this._isAds() || !this._npawVideo || !this._npawVideo.isInitiated || this.fireStart(), this.flags.isStarted && !this.flags.isJoined && (this.flags.isStarted = !0, this.monitor && this.monitor.start(), this.flags.isJoined = !0, this.chronos.join.stop(), e && ((t = t || {}).triggeredEvents = [e]), this.emit(l.Event.JOIN, {
                params: t
              }));
            },
            firePause: function firePause(t, e) {
              this._discardFalseBuffers(), this.flags.isBuffering && this.fireBufferEnd(null, "firePauseCall"), this.flags.isJoined && !this.flags.isPaused && (this.flags.isPaused = !0, this.chronos.pause.start(), e && ((t = t || {}).triggeredEvents = [e]), this.emit(l.Event.PAUSE, {
                params: t
              }));
            },
            fireResume: function fireResume(t, e) {
              if (this._discardFalseBuffers(), this.flags.isJoined && this.flags.isPaused) {
                this.flags.isPaused = !1;
                try {
                  this._npawVideo.ignorePauseSmallEvents() && this.chronos.pause.getDeltaTime(!1) <= 50 ? this.chronos.pause.reset() : this.chronos.pause.stop();
                } catch (t) {
                  this.chronos.pause.stop();
                }
                this.monitor && this.monitor.skipNextTick(), e && ((t = t || {}).triggeredEvents = [e]), this.emit(l.Event.RESUME, {
                  params: t
                });
              }
            },
            fireBufferBegin: function fireBufferBegin(t, e, i, s) {
              if (s = s || !1, this.flags.isJoined && !this.flags.isBuffering) {
                if (this.flags.isSeeking) {
                  if (!e) return;
                  n.notice(p, "Converting current buffer to seek"), this.chronos.buffer = this.chronos.seek.clone(), this.chronos.seek.reset(), this.flags.isSeeking = !1;
                } else this.chronos.buffer.start();
                try {
                  this.fireEventsStruct.buffer = [], i ? this.fireEventsStruct.buffer.push(i) : this.fireEventsStruct.buffer.push("undefinedEvent");
                } catch (t) {}
                this.flags.isBuffering = !0, this.flags.isVideoStateBuffering = s, this.emit(l.Event.BUFFER_BEGIN, {
                  params: t
                });
              }
            },
            fireBufferEnd: function fireBufferEnd(t, e) {
              if (this.flags.isJoined && this.flags.isBuffering) {
                try {
                  e ? this.fireEventsStruct.buffer.push(e) : this.fireEventsStruct.buffer.push("undefinedEvent");
                } catch (t) {}
                (t = t || {}).triggeredEvents = this.fireEventsStruct.buffer, this.cancelBuffer(), this.emit(l.Event.BUFFER_END, {
                  params: t
                });
                try {
                  this.chronos.pause.getDeltaTime(!1) > 0 && this.chronos.pause.resume();
                } catch (t) {}
              }
            },
            _discardFalseBuffers: function _discardFalseBuffers() {
              try {
                this.flags.isBuffering && this.flags.isVideoStateBuffering && this._getDeltaBufferTime() <= 100 && this.cancelBuffer();
              } catch (t) {}
            },
            cancelBuffer: function cancelBuffer(t) {
              this.flags.isJoined && this.flags.isBuffering && (this.flags.isBuffering = !1, this.flags.isVideoStateBuffering = !1, this.chronos.buffer.stop(), this.monitor && this.monitor.skipNextTick());
            },
            _getDeltaBufferTime: function _getDeltaBufferTime() {
              return this.chronos && this.chronos.buffer ? this.chronos.buffer.getDeltaTime(!1) : 0;
            },
            fireStop: function fireStop(t, e) {
              try {
                if ((this._isAds() || this._npawVideo._isStopReady()) && (this._isAds() && this.flags.isStarted || !this._isAds() && (this.flags.isStarted || this._npawVideo.isInitiated))) {
                  if (this.stopMonitor(), this.stopReadyStateMonitor(), this._isAds() && (t = t || {}, this.flags.isPaused)) {
                    var _e22 = this.chronos.pause.getDeltaTime();
                    t.adPauseDuration = _e22;
                  }
                  this.flags.reset(), this.chronos.total.stop(), this.chronos.join.reset(), this.chronos.pause.stop(), this.chronos.buffer.stop(), this.chronos.seek.stop(), e && ((t = t || {}).triggeredEvents = [e]), this.emit(l.Event.STOP, {
                    params: t
                  }), this.chronos.pause.reset(), this.chronos.buffer.reset(), this.chronos.seek.reset(), this.chronos.viewedMax.splice(0, this.chronos.viewedMax.length);
                }
              } catch (t) {
                n.warn(p, "Issue firing Stop event");
              }
            },
            firePlayerLog: function firePlayerLog(t, e) {
              if (this._npawVideo) {
                var i = {
                  logs: e,
                  logAction: t,
                  logType: "playerEvent"
                };
                this._npawVideo.firePlayerLog(i);
              }
            },
            setIsAds: function setIsAds(t) {
              this._isAdsAdapter = t;
            },
            _isAds: function _isAds() {
              return this._isAdsAdapter;
            },
            fireCasted: function fireCasted(t, e) {
              t || (t = {}), t.casted = !0, this.fireStop(t, e);
            },
            fireError: function fireError(t, e, i, s, n, a) {
              var o = r.buildErrorParams(t, e, i);
              o.code && delete o.code, n && (o = o || {}, o.triggeredEvents = [n]);
              var d = this._npawVideo ? this._npawVideo.options : {};
              void 0 !== o.errorCode && d["errors.ignore"] && d["errors.ignore"].indexOf(o.errorCode.toString()) > -1 || (((a = a || !1) || void 0 !== o.errorCode && d["errors.fatal"] && d["errors.fatal"].indexOf(o.errorCode.toString()) > -1) && this.flags.isJoined && (o = o || {}, o.errorType = "fatal"), this.emit(l.Event.ERROR, {
                params: o
              }));
            },
            fireFatalError: function fireFatalError(t, e, i, s, n) {
              this.fireError(t, e, i, s, n, !0);
            },
            isLegacyBufferBehaviourEnabled: function isLegacyBufferBehaviourEnabled() {
              return (this._npawVideo ? this._npawVideo.options : {}).enableLegacyBufferBehaviour || !1;
            }
          }, {
            Event: l.Event
          });
          r.assign(m.prototype, i(9393)), r.assign(m.prototype, i(594)), t.exports = m;
        },
        5200: function _(t, e, i) {
          var s = i(3948),
            n = i(7680),
            r = s.extend({
              constructor: function constructor() {
                this.reset();
              },
              reset: function reset() {
                this.join = new n(), this.seek = new n(), this.pause = new n(), this.buffer = new n(), this.total = new n(), this.viewedMax = [];
              }
            });
          t.exports = r;
        },
        7255: function _(t, e, i) {
          var s = i(3948).extend({
            constructor: function constructor() {
              this.reset();
            },
            reset: function reset() {
              this.isStarted = !1, this.isJoined = !1, this.isPaused = !1, this.isSeeking = !1, this.isBuffering = !1, this.isVideoStateBuffering = !1, this.isEnded = !1, this.isStopped = !1, this.lastQuartileSent = 0, this.isAdPaused = !1;
            }
          });
          t.exports = s;
        },
        3381: function _(t, e, i) {
          var s = i(3948),
            n = i(4954),
            r = i(7680),
            a = s.extend({
              constructor: function constructor(t, e, i) {
                this._adapter = t, this._seekEnabled = e & a.Type.SEEK, this._bufferEnabled = e & a.Type.BUFFER, i = i || 800, this._chrono = new r(), this._lastPlayhead = 0, i > 0 && (this._timer = new n(this.progress.bind(this), i));
              },
              start: function start() {
                this.stop(), this.canBeUsed() && this._timer.start();
              },
              stop: function stop() {
                this._lastPlayhead = 0, this._timer && this._timer.stop();
              },
              skipNextTick: function skipNextTick() {
                this._lastPlayhead = 0;
              },
              progress: function progress() {
                var t = this._chrono.stop();
                this._chrono.start();
                var e = t * a.kBUFFER_THRESHOLD_RATIO,
                  i = t * a.kSEEK_THRESHOLD_RATIO;
                this._adapter.getPlayrate && this._adapter.getPlayrate() && 1 !== this._adapter.getPlayrate() && (e *= this._adapter.getPlayrate(), i *= this._adapter.getPlayrate());
                var s = this._getPlayhead(),
                  n = 1e3 * Math.abs(this._lastPlayhead - s);
                n < e ? this._bufferEnabled && this._lastPlayhead > 0 && !this._adapter.flags.isPaused && !this._adapter.flags.isSeeking && this._adapter.fireBufferBegin(null, !1, "playheadMonitor") : n > i ? this._seekEnabled && this._lastPlayhead > 0 && this._adapter.fireSeekBegin(null, !1, "playheadMonitor") : (this._seekEnabled && this._adapter.fireSeekEnd(null, "playheadMonitor"), this._bufferEnabled && this._adapter.fireBufferEnd(null, "playheadMonitor")), this._lastPlayhead = s;
              },
              canBeUsed: function canBeUsed() {
                var t = this._adapter.getVideo(),
                  e = this._adapter.getPlugin();
                return !(!e || !e.getPlayheadMonitorEnabled() || !this._seekEnabled && !this._bufferEnabled || t && t.getIsLive() && e.options["content.isLive.noMonitor"]);
              },
              _getPlayhead: function _getPlayhead() {
                return this._adapter.getPlayhead();
              }
            }, {
              Type: {
                NONE: 0,
                BUFFER: 1,
                SEEK: 2
              },
              kBUFFER_THRESHOLD_RATIO: .5,
              kSEEK_THRESHOLD_RATIO: 2
            });
          t.exports = a;
        },
        8490: function _(t, e, i) {
          var s = i(3948);
          var _i24 = i(7276),
            n = _i24.default,
            _i25 = i(2784),
            r = _i25.AnalyticsTag;
          var a = s.extend({
            constructor: function constructor(t, e) {
              this._adapter = t, this._videoElement = t.getVideoObject(), this._startedStateCheck = !1, this._intervalCheckId = null, this._intervalMilliseconds = e || 300;
            },
            start: function start() {
              var t = this._adapter.plugin;
              t && t.getReadyStateMonitorEnabled() && this._videoElement && !this._startedStateCheck && (this._intervalCheckId = setInterval(this.checkStateProperty.bind(this), this._intervalMilliseconds), this._startedStateCheck = !0);
            },
            stop: function stop() {
              try {
                this._startedStateCheck && this._intervalCheckId && clearInterval(this._intervalCheckId), this._intervalCheckId = null, this._startedStateCheck = !1;
              } catch (t) {
                n.error(r, "Produced error stopping the network monitor");
              }
            },
            checkStateProperty: function checkStateProperty(t) {
              try {
                this._videoElement && this._adapter && this._videoElement.readyState && (this._videoElement.readyState > 3 && !this._adapter.flags.isSeeking ? this._adapter.flags.isBuffering ? this.fireBufferEnd({}, "stateMonitor") : this._adapter.flags.isJoined || this.fireJoin({}, "stateMonitor") : this._videoElement.readyState < 4 && !this._adapter.flags.isBuffering && this.fireBufferBegin({}, !1, "stateMonitor", !0));
              } catch (t) {}
            }
          });
          t.exports = a;
        },
        7680: function _(t, e, i) {
          var s = i(3948).extend({
            constructor: function constructor() {
              this.reset();
            },
            reset: function reset() {
              this.startTime = 0, this.stopTime = 0, this.pauseTime = 0, this.offset = 0;
            },
            getDeltaTime: function getDeltaTime(t) {
              var e = -1,
                i = new Date().getTime();
              if (this.startTime) {
                t && !this.stopTime && (this.stopTime = i);
                var s = this.pauseTime ? i - this.pauseTime : 0,
                  n = this.stopTime ? this.stopTime : i;
                e = this.offset - s + (n - this.startTime);
              }
              return e;
            },
            start: function start() {
              this.startTime = new Date().getTime(), this.stopTime = 0, this.offset = 0;
            },
            stop: function stop() {
              return this.pauseTime && this.resume(), this.stopTime = new Date().getTime(), this.startTime ? this.offset + (this.stopTime - this.startTime) : -1;
            },
            pause: function pause() {
              this.pauseTime = new Date().getTime();
            },
            resume: function resume() {
              this.offset -= new Date().getTime() - this.pauseTime, this.pauseTime = 0;
            },
            clone: function clone() {
              var t = new s();
              return t.startTime = this.startTime, t.stopTime = this.stopTime, t.offset = this.offset, t;
            }
          });
          t.exports = s;
        },
        3821: function _(t, e, i) {
          var s = i(3948);
          var _i26 = i(7276),
            n = _i26.default,
            r = _i26.LogLevel;
          var a = i(2507);
          var _i27 = i(2784),
            o = _i27.AnalyticsTag;
          var d = s.extend({
            constructor: function constructor(t, e, i, s, n) {
              this.videoKey = n, this.xhr = this.createXHR(), this.host = t || "", this.service = e || "", this.params = i || {}, this.options = a.assign({}, d.defaultOptions, s), this.retries = 0, this.sendPostRequest = !1, this.preparedPostRequest = !1, this.options.cache || this.params.timemark || this.setParam("timemark", new Date().getTime());
            },
            createXHR: function createXHR() {
              var t = {};
              try {
                t = XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
              } catch (t) {
                n.error(o, t);
              }
              return t;
            },
            getXHR: function getXHR() {
              return this.xhr;
            },
            getResponse: function getResponse() {
              return this.xhr.response;
            },
            getResponseText: function getResponseText() {
              return this.xhr.responseText;
            },
            getResponseHeaders: function getResponseHeaders() {
              return this.xhr.getAllResponseHeaders();
            },
            getUrl: function getUrl() {
              return this.host + this.service + this.getParamString();
            },
            getVideoKey: function getVideoKey() {
              return this.videoKey;
            },
            on: function on(t, e, i) {
              return this.xhr.addEventListener ? this.xhr.addEventListener(t, e.bind(this, this, i)) : t === d.Event.SUCCESS && (this.xhr.onreadystatechange = function () {
                4 === this.xhr.readyState && e.bind(this, this, i);
              }.bind(this)), this;
            },
            off: function off(t, e) {
              return this.xhr.removeEventListener(t, e), this;
            },
            getParamString: function getParamString() {
              try {
                var t = "?";
                for (var e in this.params) {
                  var i = this.params[e];
                  if (null !== i && "object" == typeof i) {
                    var s = JSON.stringify(i);
                    "{}" !== s && (t += encodeURIComponent(e) + "=" + encodeURIComponent(s) + "&");
                  } else null != i && "" !== i && (t += encodeURIComponent(e) + "=" + encodeURIComponent(i) + "&");
                }
                return t.slice(0, -1);
              } catch (t) {
                return n.error(o, t), "";
              }
            },
            getParam: function getParam(t) {
              return this.params[t];
            },
            setParam: function setParam(t, e) {
              return this.params[t] = e, this;
            },
            setBody: function setBody(t) {
              this.body = t;
            },
            setPostRequest: function setPostRequest(t) {
              this.sendPostRequest = t;
            },
            getParamsForPostMessages: function getParamsForPostMessages() {
              var t = {};
              try {
                var e = this.getParam("timemark"),
                  i = this.getParam("code"),
                  s = this.getParam("sessionRoot"),
                  r = this.getParam("sessionId");
                e && (t.timemark = e), i && (t.code = i), s && (t.sessionRoot = s), r && (t.sessionId = r);
              } catch (t) {
                n.error(o, t);
              }
              return t;
            },
            send: function send() {
              try {
                try {
                  this.sendPostRequest && !this.preparedPostRequest && (this.options.method = "POST", this.body = JSON.stringify(this.params), this.params = this.getParamsForPostMessages(), this.preparedPostRequest = !0);
                } catch (t) {}
                if (this.xhr.open(this.options.method, this.getUrl(), !0), this.options.requestHeaders) for (var t in this.options.requestHeaders) this.options.requestHeaders.hasOwnProperty(t) && this.xhr.setRequestHeader(t, this.options.requestHeaders[t]);
                for (var e in this.options.retryAfter > 0 && this.options.maxRetries > 0 && 0 === this.retries && this.on(d.Event.ERROR, function () {
                  if (this.retries >= this.options.maxRetries) n.error(o, 'Aborting failed request "' + this.service + '". Max retries reached.');else {
                    n.warn(o, 'YBRequest "' + this.service + '" failed. Retry ' + (this.retries + 1) + " of " + this.options.maxRetries + " in " + this.options.retryAfter + "ms.");
                    try {
                      setTimeout(function () {
                        this.retries += 1, this.send();
                      }.bind(this), this.options.retryAfter);
                    } catch (t) {
                      "undefined" != typeof atv ? atv.setTimeout(function () {
                        this.retries += 1, this.send();
                      }.bind(this), this.options.retryAfter) : n.error(o, t);
                    }
                  }
                }.bind(this)), n.logLevel <= r.VERBOSE && n.verbose(o, "XHR Req: " + this.getUrl()), d._globalListeners) d._globalListeners[e].forEach(function (t) {
                  this.on(e, t);
                }.bind(this));
                return this.xhr.send(this.body);
              } catch (t) {
                n.error(o, t);
              }
            }
          }, {
            Event: {
              SUCCESS: "load",
              LOAD: "load",
              ERROR: "error",
              ABORT: "abort"
            },
            defaultOptions: {
              method: "GET",
              requestHeaders: {},
              maxRetries: 3,
              retryAfter: 5e3,
              cache: !1
            },
            _globalListeners: {},
            onEvery: function onEvery(t, e) {
              d._globalListeners[t] = d._globalListeners[t] || [], d._globalListeners[t].push(e);
            },
            offEvery: function offEvery(t, e) {
              if (d._globalListeners[t]) {
                var i = d._globalListeners[t].indexOf(e);
                -1 !== i && d._globalListeners[t].splice(i, 1);
              }
            }
          });
          t.exports = d;
        },
        1151: function _(t, e, i) {
          var s = i(2503),
            n = i(3168),
            r = i(3908),
            a = i(8187),
            o = i(3831),
            d = i(4387),
            c = i(1657),
            u = i(3782);
          var _i28 = i(2784),
            l = _i28.AnalyticsTag,
            _i29 = i(7276),
            h = _i29.default;
          var p = s.extend({
            constructor: function constructor(t) {
              p.__super__.constructor.apply(this, arguments), this.plugin = t, this._realResource = void 0, this._transportFormat = void 0, this._initResource = void 0, this._cdnName = void 0, this._cdnNodeHost = void 0, this._cdnNodeTypeString = void 0, this._cdnNodeType = void 0, this._responses = {}, this._isBusy = !1, this.transformName = "Resource";
            },
            getResource: function getResource() {
              return this._realResource;
            },
            _getInitialCdnResource: function _getInitialCdnResource() {
              return this._realResource || this._initResource;
            },
            getTransportFormat: function getTransportFormat() {
              return this._transportFormat;
            },
            getCdnName: function getCdnName() {
              return this._cdnName;
            },
            getNodeHost: function getNodeHost() {
              return this._cdnNodeHost;
            },
            getNodeTypeString: function getNodeTypeString() {
              return this._cdnNodeTypeString;
            },
            getNodeType: function getNodeType() {
              return this._cdnNodeType;
            },
            init: function init(t) {
              t ? this._isBusy || (this._isBusy = !0, this._initResource = t, this._parseManifestEnabled = this.plugin.isParseManifest(), this._cdnEnabled = this.plugin.isParseCdnNode(), this._cdnList = this.plugin.getParseCdnNodeList().slice(), r.setBalancerHeaderName(this.plugin.getParseCdnNodeNameHeader(), this.plugin.getParseNodeHeader()), this._setTimeout(), this._parseManifestEnabled ? this._isFinalUrl(this._initResource) ? (this._realResource = this._initResource, this.done()) : this.parseManifest() : this._parseCDN()) : this.done();
            },
            _isFinalUrl: function _isFinalUrl(t) {
              var e = [".ts", ".mp4", ".m4s", ".cmfv"];
              t = t || "";
              for (var _i30 in e) {
                var _s14 = e[_i30];
                if (t.lastIndexOf(_s14) === t.length - _s14.length) return !0;
              }
              return !1;
            },
            _setTimeout: function _setTimeout() {
              var _this13 = this;
              var t = function t() {
                _this13._isBusy && (_this13.done(), h.warn(l, "ResourceTransform has exceded the maximum execution time (3s) and will be aborted."));
              };
              try {
                this._parseTimeout = setTimeout(t, 3e3);
              } catch (e) {
                "undefined" != typeof atv ? this._parseTimeout = atv.setTimeout(t, 3e3) : h.error(l, e);
              }
            },
            parseManifest: function parseManifest(t, e) {
              var i = this.plugin.options["parse.manifest.auth"],
                s = [new c(i), new o(i), new n(i)];
              this._parseManifest(s, t, e || this._initResource);
            },
            _parseManifest: function _parseManifest(t, e, i, s) {
              var _this14 = this;
              if (t.length > 0) {
                var _n11 = t[0];
                _n11.shouldExecute(e) ? (_n11.on(d.Event.DONE, function () {
                  _this14._parseManifest(t.slice(1, t.length), _n11.getLastManifest(), _n11.getResource(), _n11.getTransportFormat() || s);
                }), _n11.parse(i, e)) : this._parseManifest(t.slice(1, t.length), e, i, s);
              } else this._transportFormat = s, this._realResource = i, this._parseCDN();
            },
            _parseCDN: function _parseCDN() {
              var _this15 = this;
              if (this.plugin.isCdnSwitch()) this.switchDetector = new a(this.plugin), this.switchDetector.on(a.Events.DONE, function (t) {
                _this15._cdnName = t.data, _this15.done();
              }), this.switchDetector.on(a.Events.ERROR, function () {
                _this15.done();
              }), this.switchDetector.init();else if (this._cdnEnabled && this._cdnList.length > 0) {
                var _t25 = this._cdnList.shift(),
                  _e23 = r.create(_t25);
                _e23 ? (_e23.on(r.Event.DONE, function () {
                  _this15._responses = _e23.getResponses(), _this15._cdnName = _e23.getParsedCdnName(), _this15._cdnNodeHost = _e23.getParsedNodeHost(), _this15._cdnNodeTypeString = _e23.getParsedNodeTypeString(), _this15._cdnNodeType = _e23.getParsedNodeType(), _this15.getNodeHost() ? _this15.done() : _this15._parseCDN();
                }), _e23.parse(this._getInitialCdnResource(), this._responses)) : this._parseCDN();
              } else this.done();
            },
            parse: function parse(t) {
              if (t.service === u.Service.START) {
                var _e24 = this.plugin.requestBuilder.lastSent;
                _e24.parsedResource = t.params.parsedResource = this.getResource() || t.params.parsedResource, _e24.transportFormat = t.params.transportFormat = this.getTransportFormat() || t.params.transportFormat, this._cdnEnabled && (_e24.cdn = t.params.cdn = t.params.cdn || this.getCdnName(), _e24.nodeHost = t.params.nodeHost = this.getNodeHost() || t.params.nodeHost, _e24.nodeType = t.params.nodeType = this.getNodeType() || t.params.nodeType, _e24.nodeTypeString = t.params.nodeTypeString = this.getNodeTypeString() || t.params.nodeTypeString);
              }
            }
          });
          t.exports = p;
        },
        8187: function _(t, e, i) {
          var s = i(1593),
            n = i(3821);
          var _i31 = i(2784),
            r = _i31.AnalyticsTag,
            _i32 = i(7276),
            a = _i32.default;
          var o = s.extend({
            constructor: function constructor(t) {
              this.plugin = t, this.headerName = "x-cdn";
            },
            init: function init() {
              var t = null;
              this.plugin && (t = this.plugin.getAdapter() && this.plugin.getAdapter().getURLToParse() ? this.plugin.getAdapter().getURLToParse() : this.plugin.getResource()), this.plugin && this.plugin.getAdapter() && this.plugin.getAdapter().flags.isStarted && this._request(t);
            },
            done: function done(t) {
              this.emit(o.Events.DONE, t);
            },
            error: function error() {
              this.emit(o.Events.ERROR);
            },
            _successfulRequest: function _successfulRequest(t) {
              setTimeout(this.init.bind(this), 1e3 * parseInt(this.plugin.options["parse.cdnTTL"]));
              var e = t.getResponseHeaders().split("\n"),
                i = null;
              for (var s in e) {
                var n = e[s],
                  r = n.indexOf(this.headerName);
                r > -1 && (i = n.substring(r + this.headerName.length + 1, n.length - 1).replace(" ", ""));
              }
              this.done(i);
            },
            _failedRequest: function _failedRequest() {
              setTimeout(this.init.bind(this), 1e3 * parseInt(this.plugin.options["parse.cdnTTL"])), a.warn(r, "CDN switch detection request failed"), this.error();
            },
            _request: function _request(t) {
              var e = new n(t, null, null, {
                method: "HEAD",
                cache: !0
              });
              e.on(n.Event.SUCCESS, this._successfulRequest.bind(this)), e.on(n.Event.ERROR, this._failedRequest.bind(this)), e.send();
            }
          }, {
            Events: {
              DONE: "done",
              ERROR: "error"
            }
          });
          t.exports = o;
        },
        3908: function _(t, e, i) {
          var s = i(1593),
            n = i(2507);
          i(3821);
          var _i33 = i(2784),
            r = _i33.AnalyticsTag,
            _i34 = i(7276),
            a = _i34.default;
          var o = s.extend({
            constructor: function constructor(t) {
              this._options = n.assign({
                cdnName: null,
                parsers: [],
                requestMethod: "HEAD",
                requestHeaders: {},
                parseType: function parseType() {
                  return 0;
                }
              }, t), this._responses = {};
            },
            done: function done() {
              this.emit(o.Event.DONE);
            },
            addParser: function addParser(t) {
              return this._options.parsers.push(t), this;
            },
            setCdnName: function setCdnName(t) {
              return this._options.cdnName = t, this;
            },
            setRequestMethod: function setRequestMethod(t) {
              return this._options.requestMethod = t, this;
            },
            setRequestHeader: function setRequestHeader(t, e) {
              return this._options.requestHeaders[t] = e, this;
            },
            setParseType: function setParseType(t) {
              return this._options.parseType = t, this;
            },
            getParsedCdnName: function getParsedCdnName() {
              return this._cdnName;
            },
            getParsedNodeHost: function getParsedNodeHost() {
              return this._cdnNodeHost;
            },
            getParsedNodeTypeString: function getParsedNodeTypeString() {
              return this._cdnNodeTypeString;
            },
            getParsedNodeType: function getParsedNodeType() {
              return this._cdnNodeType;
            },
            getResponses: function getResponses() {
              return this._responses;
            },
            parse: function parse(t, e) {
              this._responses = e || {};
              var i = JSON.stringify(this._options.requestHeaders);
              this._responses[i] ? this._parseResponse(this._responses[i]) : this._requestResponse(t);
            },
            _requestResponse: function _requestResponse(t) {
              var _this16 = this;
              var e = JSON.stringify(this._options.requestHeaders),
                i = "{}" !== e;
              var s = new XMLHttpRequest();
              s.open(this._options.requestMethod, t);
              for (var _t26 in this._options.requestHeaders) Object.prototype.hasOwnProperty(this._options.requestHeaders, _t26) && s.setRequestHeader(_t26, this._options.requestHeaders[_t26]);
              s.onreadystatechange = function () {
                4 === s.readyState && (s.status >= 200 && s.status < 400 ? (_this16._responses[e] = s.getAllResponseHeaders(), _this16._parseResponse(_this16._responses[e])) : i ? (_this16._options.requestHeaders = {}, _this16._requestResponse(t)) : _this16.done());
              }, s.send();
            },
            _parseResponse: function _parseResponse(t) {
              this._options.parsers.forEach(function (e) {
                if ("string" == typeof e.headerName) this._parseHeaderResponse(t, e, e.headerName);else if (Array.isArray(e.headerName)) for (var i = 0, s = e.headerName.length; i < s; i++) {
                  var n = e.headerName[i];
                  "string" == typeof n && this._parseHeaderResponse(t, e, n);
                }
              }.bind(this)), this.done();
            },
            _parseHeaderResponse: function _parseHeaderResponse(t, e, i) {
              i && (i = i ? i.toLowerCase() : "", t.split("\n").forEach(function (t) {
                var s = t.indexOf(":");
                -1 !== s && t.slice(0, s).toLowerCase() === i && this._executeParser(e, t.slice(s + 1));
              }.bind(this)));
            },
            _executeParser: function _executeParser(t, e) {
              try {
                var i = t.regex.exec(e.trim());
                if (null !== i) switch (this._options.cdnName && (this._cdnName = this._options.cdnName), t.element) {
                  case o.ElementType.HOST:
                    this._cdnNodeHost = i[1];
                    break;
                  case o.ElementType.TYPE:
                    this._cdnNodeTypeString = i[1], this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
                    break;
                  case o.ElementType.HOST_AND_TYPE:
                    this._cdnNodeHost = i[1], this._cdnNodeTypeString = i[2], this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
                    break;
                  case o.ElementType.TYPE_AND_HOST:
                    this._cdnNodeTypeString = i[1], this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString), this._cdnNodeHost = i[2];
                    break;
                  case o.ElementType.NAME:
                    this._cdnName = i[1].toUpperCase();
                }
              } catch (t) {
                a.warn(r, "CDN parsing for " + this._options.cdnName + " could not parse header value " + e);
              }
            },
            shouldExecute: function shouldExecute() {
              return !0;
            }
          }, {
            Event: {
              DONE: "done"
            },
            ElementType: {
              HOST: "host",
              TYPE: "type",
              HOST_AND_TYPE: "host+type",
              TYPE_AND_HOST: "type+host",
              NAME: "name"
            },
            _cdnConfigs: {},
            setBalancerHeaderName: function setBalancerHeaderName(t, e) {
              o._cdnConfigs.Balancer.parsers[0].headerName = t, o._cdnConfigs.Balancer.parsers[1].headerName = e;
            },
            create: function create(t) {
              if (o._cdnConfigs[t]) return new o(o._cdnConfigs[t]);
              a.warn(r, "Tried to create an unexisting CdnParser named " + t);
            },
            add: function add(t, e) {
              o._cdnConfigs[t] = e;
            }
          });
          o.add("Level3", i(3713)), o.add("Cloudfront", i(7286)), o.add("Akamai", i(5298)), o.add("Highwinds", i(2047)), o.add("Fastly", i(563)), o.add("Telefonica", i(5040)), o.add("Amazon", i(2370)), o.add("Edgecast", i(7660)), o.add("Balancer", i(2580)), o.add("NosOtt", i(4335)), t.exports = o;
        },
        5298: function _(t) {
          t.exports = {
            cdnName: "AKAMAI",
            parsers: [{
              element: "type+host",
              headerName: "X-Cache",
              regex: /(.+)\sfrom.+AkamaiGHost\/(.+)\).+/
            }, {
              element: "host",
              headerName: "akamai-mon-iucid-del",
              regex: /(.*)/
            }, {
              element: "type",
              headerName: "akamai-cache-status",
              regex: /(.+)\sfrom\schild/
            }],
            requestHeaders: {
              Pragma: "akamai-x-cache-on"
            },
            parseType: function parseType(t) {
              var e = t.toLowerCase();
              return -1 !== e.indexOf("hit") ? 1 : -1 !== e.indexOf("miss") ? 2 : 0;
            }
          };
        },
        2370: function _(t) {
          t.exports = {
            cdnName: "AMAZON",
            parsers: [{
              element: "host",
              headerName: "x-amz-cf-pop",
              regex: /(.+)/
            }, {
              element: "type",
              headerName: "x-cache",
              regex: /(.+)\sfrom.+/
            }],
            parseType: function parseType(t) {
              return -1 !== t.toLowerCase().indexOf("hit") ? 1 : -1 !== t.toLowerCase().indexOf("miss") ? 2 : 0;
            }
          };
        },
        2580: function _(t) {
          t.exports = {
            parsers: [{
              element: "name",
              headerName: null,
              regex: /(.+)/
            }, {
              element: "host",
              headerName: null,
              regex: /(.+)/
            }]
          };
        },
        7286: function _(t) {
          t.exports = {
            cdnName: "CLOUDFRT",
            parsers: [{
              element: "host",
              headerName: "X-Amz-Cf-Id",
              regex: /(.+)/
            }, {
              element: "type",
              headerName: "X-Cache",
              regex: /(\S+)\s.+/
            }],
            parseType: function parseType(t) {
              switch (t) {
                case "Hit":
                  return 1;
                case "Miss":
                  return 2;
                default:
                  return 0;
              }
            }
          };
        },
        7660: function _(t) {
          t.exports = {
            cdnName: "EDGECAST",
            parsers: [{
              element: "host",
              headerName: "Server",
              regex: /\((.+)\/.+\)/
            }, {
              element: "type",
              headerName: "X-Cache",
              regex: /(.+)/
            }],
            parseType: function parseType(t) {
              return "HIT" === t ? 1 : 2;
            }
          };
        },
        563: function _(t) {
          t.exports = {
            cdnName: "FASTLY",
            parsers: [{
              element: "host",
              headerName: "X-Served-By",
              regex: /([^,\s]+)$/
            }, {
              element: "type",
              headerName: "X-Cache",
              regex: /([^,\s]+)$/
            }],
            parseType: function parseType(t) {
              switch (t) {
                case "HIT":
                  return 1;
                case "MISS":
                  return 2;
                default:
                  return 0;
              }
            }
          };
        },
        2047: function _(t) {
          t.exports = {
            cdnName: "HIGHNEGR",
            parsers: [{
              element: "host+type",
              headerName: "X-HW",
              regex: /.+,[0-9]+\.(.+)\.(.+)/
            }],
            parseType: function parseType(t) {
              switch (t) {
                case "c":
                case "x":
                  return 1;
                default:
                  return 2;
              }
            }
          };
        },
        3713: function _(t) {
          t.exports = {
            cdnName: "LEVEL3",
            parsers: [{
              element: "host+type",
              headerName: "X-WR-Diag",
              regex: /Host:(.+)\sType:(.+)/
            }],
            requestHeaders: {
              "X-WR-Diag": "host"
            },
            parseType: function parseType(t) {
              if (t) {
                if (0 === t.indexOf("TCP_HIT") || 0 === t.indexOf("TCP_MEM_HIT") || 0 === t.indexOf("TCP_IMS_HIT")) return 1;
                if (0 === t.indexOf("TCP_MISS")) return 2;
              }
              return 0;
            }
          };
        },
        4335: function _(t) {
          t.exports = {
            cdnName: "NOSOTT",
            parsers: [{
              element: "host",
              headerName: "X-NOS-Server",
              regex: /(.+)/
            }, {
              element: "type",
              headerName: "X-Cache",
              regex: /(.*)/
            }],
            parseType: function parseType(t) {
              switch (t) {
                case "Hit":
                  return 1;
                case "Miss":
                  return 2;
                default:
                  return 0;
              }
            }
          };
        },
        5040: function _(t) {
          t.exports = {
            cdnName: "TELEFO",
            parsers: [{
              element: "host+type",
              headerName: "x-tcdn",
              regex: /Host:(.+)\sType:(.+)/
            }],
            requestHeaders: {
              "x-tcdn": "host"
            },
            parseType: function parseType(t) {
              if (t) {
                if (-1 !== t.indexOf("p") || -1 !== t.indexOf("c")) return 1;
                if (-1 !== t.indexOf("i") || -1 !== t.indexOf("m")) return 2;
              }
              return 0;
            }
          };
        },
        3831: function _(t, e, i) {
          var s = i(3821),
            n = i(4387),
            r = i(7939);
          var _i35 = i(2784),
            a = _i35.AnalyticsTag,
            _i36 = i(7276),
            o = _i36.default;
          var d = n.extend({
            parse: function parse(t, e) {
              if (e) this.parseLocation(e, t);else {
                var i = new s(t, null, null, {
                  cache: !0,
                  requestHeaders: this._headers
                });
                i.on(s.Event.SUCCESS, function (e) {
                  this.parseLocation(e, t);
                }.bind(this)), i.on(s.Event.ERROR, function (t) {
                  this.done();
                }.bind(this)), i.send();
              }
            },
            parseLocation: function parseLocation(t, e) {
              this.iterations--;
              var i = new RegExp(/<Location>([\s\S]+)<\/Location>/);
              try {
                this._lastManifest = t;
                var s = t.getResponseText(),
                  n = i.exec(s);
                if (n && n[1]) var r = this._htmlDecode(n[1].replace("\n", ""));
                r && r !== e && this.iterations > 0 ? this.parse(r) : this.parseFinalResource(s, e);
              } catch (t) {
                o.warn(a, "Dash parse failed"), this.done();
              }
            },
            _htmlDecode: function _htmlDecode(t) {
              if ("undefined" != typeof document && "function" == typeof document.createElement) {
                var e = document.createElement("textarea");
                return e.innerHTML = t, e.childNodes && e.childNodes.length ? e.childNodes[0].nodeValue : t;
              }
              return t;
            },
            parseFinalResource: function parseFinalResource(t, e) {
              var i = new RegExp(/<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/),
                s = new RegExp(/<SegmentURL[\s\S]*media="([^"]+)/),
                n = new RegExp(/<SegmentTemplate[\s\S]*media="([^"]+)/),
                r = null;
              try {
                r = i.exec(t) || n.exec(t) || s.exec(t), this._getManifestMetadata(t), r && r[1] && this._isFullUrl(r[1]) ? r[1].indexOf('"') > 0 ? this._realResource = r[1].substr(0, r[1].indexOf('"')).replace("\n", "") : this._realResource = r[1].replace("\n", "") : this._realResource = e;
              } catch (t) {
                o.warn(a, "Dash manifest parse failed");
              }
              this.done();
            },
            _getManifestMetadata: function _getManifestMetadata(t) {
              try {
                var e = new RegExp(/<AdaptationSet[\s\S]*mimeType="video\/([^"]+)/).exec(t),
                  i = null;
                switch (e[1]) {
                  case "mp4":
                  case "m4s":
                    i = r.MP4;
                    break;
                  case "mp2t":
                    i = r.MPEG2;
                    break;
                  case "cmfv":
                    i = r.CMF;
                }
                this._transportFormat = i;
              } catch (t) {
                o.warn(a, "Couldnt find the transport format");
              }
            },
            _isFullUrl: function _isFullUrl(t) {
              return -1 !== t.indexOf("http");
            },
            shouldExecute: function shouldExecute(t) {
              var e = !0;
              return t && (e = -1 !== t.getResponseText().indexOf("<MPD")), e;
            }
          });
          t.exports = d;
        },
        3168: function _(t, e, i) {
          var s = i(3821),
            n = i(4387),
            r = i(7939);
          var _i37 = i(2784),
            a = _i37.AnalyticsTag,
            _i38 = i(7276),
            o = _i38.default;
          var d = n.extend({
            parse: function parse(t, e, i) {
              i = i || "";
              var n = null;
              try {
                n = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.m4a)((\?|;)\S*|\n|\r|$))/i.exec(t.replaceAll(",URI=", "\n").replaceAll('"', "").replaceAll(",", "\n"));
              } catch (t) {
                o.warn(a, "Parse HLS Regex failed", t), this.done();
              }
              if (null !== n) {
                var d = n[1].trim(),
                  c = "",
                  u = i.lastIndexOf("/");
                if (0 !== d.indexOf("http") && -1 !== u) {
                  if ("/" === d[0] && "/" !== d[1]) {
                    var l = i.indexOf("/") + 1;
                    l += i.substr(l, i.length).indexOf("/") + 1, l += i.substr(l, i.length).indexOf("/"), d = i.slice(0, l) + d;
                  } else d = i.slice(0, u) + "/" + d;
                  c = i.slice(0, u) + "/";
                }
                if (".m3u8" === n[3] || ".m3u" === n[3]) {
                  if (e) this._parseWithManifest(e, c, n);else {
                    var h = new s(d, null, null, {
                      cache: !0,
                      requestHeaders: this._headers
                    });
                    h.on(s.Event.SUCCESS, function (t) {
                      this._parseWithManifest(t, c, n);
                    }.bind(this)), h.on(s.Event.ERROR, function (t) {
                      this.done();
                    }.bind(this)), h.send();
                  }
                } else {
                  switch (n[3]) {
                    case ".mp4":
                    case ".m4s":
                    case ".m4a":
                      this._transportFormat = r.MP4;
                      break;
                    case ".ts":
                      this._transportFormat = r.MPEG2;
                      break;
                    case ".cmfv":
                      this._transportFormat = r.CMF;
                  }
                  this._realResource = d, this.done();
                }
              } else this.done();
            },
            _parseWithManifest: function _parseWithManifest(t, e, i) {
              this._lastManifest = t, this.parse(t.getResponseText(), null, e + i[2]);
            },
            shouldExecute: function shouldExecute(t) {
              var e = !0;
              return t && (e = -1 !== t.getResponseText().indexOf("#EXTM3U")), e;
            }
          });
          t.exports = d;
        },
        1657: function _(t, e, i) {
          var s = i(3821),
            n = i(4387).extend({
              parse: function parse(t, e) {
                if (e) this._parseWithManifest(e);else {
                  this._realResource = t;
                  var i = new s(t, null, null, {
                    cache: !0,
                    requestHeaders: this._headers
                  });
                  i.on(s.Event.SUCCESS, function (t) {
                    this._parseWithManifest(t);
                  }.bind(this)), i.on(s.Event.ERROR, function (t) {
                    this.done();
                  }.bind(this)), i.send();
                }
              },
              _parseWithManifest: function _parseWithManifest(t) {
                this._lastManifest = t;
                var e = t.getResponseHeaders(),
                  i = !1;
                t && t.xhr && t.xhr.responseURL && t.xhr.responseURL !== this._realResource ? (this._realResource = t.xhr.responseURL, this.parse(this._realResource), i = !0) : e.split("\n").forEach(function (t) {
                  t.startsWith("Location:") && (this._realResource = t.slice(10), this.parse(this._realResource), i = !0);
                }.bind(this)), i || this.done();
              }
            });
          t.exports = n;
        },
        4387: function _(t, e, i) {
          var s = i(1593).extend({
            constructor: function constructor(t) {
              this._realResource = void 0, this._lastManifest = void 0, this._transportFormat = void 0, this.iterations = 3, this._headers = t;
            },
            done: function done() {
              this.iterations = 3, this.emit(s.Event.DONE);
            },
            parse: function parse(t, e) {},
            getResource: function getResource() {
              return this._realResource;
            },
            getTransportFormat: function getTransportFormat() {
              return this._transportFormat;
            },
            getLastManifest: function getLastManifest() {
              return this._lastManifest;
            },
            shouldExecute: function shouldExecute(t) {
              return !0;
            }
          }, {
            Event: {
              DONE: "done"
            }
          });
          t.exports = s;
        },
        2503: function _(t, e, i) {
          var s = i(1593).extend({
            constructor: function constructor() {
              this._isBusy = !0, this._sendRequest = !0, this.transformName = "Transform";
            },
            parse: function parse(t) {},
            isBlocking: function isBlocking(t) {
              return this._isBusy;
            },
            done: function done() {
              this._isBusy = !1, this.emit(s.Event.DONE);
            },
            hasToSend: function hasToSend(t) {
              return this._sendRequest;
            },
            getState: function getState() {
              return this._sendRequest ? this._isBusy ? this.STATE_BLOCKED : this.STATE_NO_BLOCKED : this.STATE_OFFLINE;
            }
          }, {
            STATE_OFFLINE: 2,
            STATE_BLOCKED: 1,
            STATE_NO_BLOCKED: 0,
            Event: {
              DONE: "done"
            }
          });
          t.exports = s;
        },
        3782: function _(t, e, i) {
          var s = i(703),
            n = i(7086),
            r = {
              AdPosition: s,
              ManifestError: i(8932),
              RequestMethod: i(9637),
              Service: i(7062),
              WillSendEvent: i(3003),
              WillSendLog: i(825),
              AdInsertionType: i(1083),
              Adapter: n,
              Metadata: i(8424)
            };
          t.exports = r;
        },
        1083: function _(t) {
          t.exports = {
            ClientSide: "csai",
            ServerSide: "ssai"
          };
        },
        703: function _(t) {
          t.exports = {
            Preroll: "pre",
            Midroll: "mid",
            Postroll: "post"
          };
        },
        7086: function _(t, e, i) {
          var s = {
            Event: i(2477)
          };
          t.exports = s;
        },
        2477: function _(t) {
          t.exports = {
            INIT: "init",
            START: "start",
            JOIN: "join",
            JOIN_TIME: "joinTime",
            PAUSE: "pause",
            RESUME: "resume",
            SEEK_BEGIN: "seek-begin",
            SEEK_END: "seek-end",
            BUFFER_BEGIN: "buffer-begin",
            BUFFER_END: "buffer-end",
            ERROR: "error",
            STOP: "stop",
            CLICK: "click",
            MANIFEST: "manifest",
            PODSTART: "break-start",
            PODSTOP: "break-stop",
            QUARTILE: "quartile",
            VIDEO_EVENT: "video-event"
          };
        },
        8932: function _(t) {
          t.exports = {
            NO_RESPONSE: "NO_RESPONSE",
            EMPTY: "EMPTY_RESPONSE",
            WRONG: "WRONG_RESPONSE"
          };
        },
        8424: function _(t) {
          t.exports = {
            REQUIRED_METADATA_TIMEOUT: 1e4
          };
        },
        9637: function _(t) {
          t.exports = {
            GET: "GET",
            POST: "POST"
          };
        },
        7062: function _(t) {
          t.exports = {
            DATA: "/data",
            ADAPTERS: "/adapters",
            CONFIGURATION: "/configuration",
            APP_ANALYTICS_PLUGIN_LOGS: "/infinity/session/pluginLogs",
            VIDEO_PLUGIN_LOGS: "/infinity/video/pluginLogs",
            INIT: "/init",
            START: "/start",
            JOIN: "/joinTime",
            PAUSE: "/pause",
            RESUME: "/resume",
            SEEK: "/seek",
            BUFFER: "/bufferUnderrun",
            ERROR: "/error",
            STOP: "/stop",
            PING: "/ping",
            CDN: "/cdn",
            VIDEO_EVENT: "/infinity/video/event",
            AD_INIT: "/adInit",
            AD_START: "/adStart",
            AD_JOIN: "/adJoin",
            AD_PAUSE: "/adPause",
            AD_RESUME: "/adResume",
            AD_BUFFER: "/adBufferUnderrun",
            AD_STOP: "/adStop",
            AD_CLICK: "/adClick",
            AD_ERROR: "/adError",
            AD_MANIFEST: "/adManifest",
            AD_POD_START: "/adBreakStart",
            AD_POD_STOP: "/adBreakStop",
            AD_QUARTILE: "/adQuartile",
            EVENT: "/infinity/session/event",
            SESSION_START: "/infinity/session/start",
            SESSION_STOP: "/infinity/session/stop",
            NAV: "/infinity/session/nav",
            BEAT: "/infinity/session/beat",
            OFFLINE_EVENTS: "/offlineEvents"
          };
        },
        8472: function _(t) {
          t.exports = {
            HDS: "HDS",
            HLS: "HLS",
            MSS: "MSS",
            DASH: "DASH",
            RTMP: "RTMP",
            RTP: "RTP",
            RTSP: "RTSP",
            DVB: "DVB",
            DVBC: "DVB-C",
            DVBT: "DVB-T",
            DVBT2: "DVB-T2",
            MULTICAST: "MULTICAST"
          };
        },
        7939: function _(t) {
          t.exports = {
            MP4: "MP4",
            MPEG2: "TS",
            CMF: "CMF"
          };
        },
        3003: function _(t) {
          t.exports = {
            WILL_SEND_INIT: "will-send-init",
            WILL_SEND_START: "will-send-start",
            WILL_SEND_JOIN: "will-send-join",
            WILL_SEND_PAUSE: "will-send-pause",
            WILL_SEND_RESUME: "will-send-resume",
            WILL_SEND_SEEK: "will-send-seek",
            WILL_SEND_BUFFER: "will-send-buffer",
            WILL_SEND_ERROR: "will-send-error",
            WILL_SEND_FATAL_ERROR: "will-send-fatal-error",
            WILL_SEND_STOP: "will-send-stop",
            WILL_SEND_PING: "will-send-ping",
            WILL_SEND_VIDEO_EVENT: "will-send-video-event",
            WILL_SEND_AD_START: "will-send-ad-start",
            WILL_SEND_AD_JOIN: "will-send-ad-join",
            WILL_SEND_AD_PAUSE: "will-send-ad-pause",
            WILL_SEND_AD_RESUME: "will-send-ad-resume",
            WILL_SEND_AD_BUFFER: "will-send-ad-buffer",
            WILL_SEND_AD_STOP: "will-send-ad-stop",
            WILL_SEND_AD_CLICK: "will-send-ad-click",
            WILL_SEND_AD_ERROR: "will-send-ad-error",
            WILL_SEND_AD_MANIFEST: "will-send-ad-manifest",
            WILL_SEND_AD_POD_START: "will-send-ad-break-start",
            WILL_SEND_AD_POD_STOP: "will-send-ad-break-stop",
            WILL_SEND_AD_QUARTILE: "will-send-ad-quartile",
            WILL_SEND_SESSION_START: "will-send-session-start",
            WILL_SEND_SESSION_STOP: "will-send-session-stop",
            WILL_SEND_NAV: "will-send-nav",
            WILL_SEND_BEAT: "will-send-beat",
            WILL_SEND_EVENT: "will-send-event",
            WILL_SEND_OFFLINE_EVENTS: "will-send-offline-events"
          };
        },
        825: function _(t) {
          t.exports = {
            WILL_SEND_LOG_PLUGIN_INIT: "will-send-log-plugin-init",
            WILL_SEND_LOG_PLUGIN_SET_OPTIONS: "will-send-log-plugin-set-options",
            WILL_SEND_LOG_PLUGIN_RECEIVE_DATA: "will-send-log-plugin-receive-data",
            WILL_SEND_LOG_INFINITY_BEGIN: "will-send-log-infinity-begin",
            WILL_SEND_LOG_INFINITY_START: "will-send-log-infinity-start",
            WILL_SEND_LOG_INFINITY_EVENT: "will-send-log-infinity-event",
            WILL_SEND_LOG_INFINITY_NAV: "will-send-log-infinity-nav",
            WILL_SEND_LOG_INFINITY_NEW_SESSION: "will-send-log-infinity-new-session"
          };
        },
        9773: function _(t, e, i) {
          var s = i(3948).extend({
            constructor: function constructor(t) {
              this.plugin = t, this.isInBackground = !1, this.listenerReference = this._visibilityListener.bind(this), this._reset();
            },
            startDetection: function startDetection() {
              this.isBackgroundDetectorStarted || "undefined" == typeof document || (this.isBackgroundDetectorStarted = !0, document.addEventListener("visibilitychange", this.listenerReference));
            },
            stopDetection: function stopDetection() {
              this.isBackgroundDetectorStarted && "undefined" != typeof document && (document.removeEventListener("visibilitychange", this.listenerReference), this._reset());
            },
            _reset: function _reset() {
              this.isBackgroundDetectorStarted = !1;
            },
            _visibilityListener: function _visibilityListener(t) {
              if ("undefined" != typeof document) {
                var e = this._getSettings();
                "hidden" === document.visibilityState ? this._toBackground(e) : "visible" === document.visibilityState && this._toForeground(e);
              }
            },
            _toBackground: function _toBackground(t) {
              this.isInBackground = !0;
              try {
                if (this.plugin && this.plugin.videos) for (var e = 0; e < this.plugin.videos.getVideoKeys().length; e++) {
                  var i = this.plugin.videos.getVideoKeys()[e],
                    s = this.plugin.videos.getAdsAdapter(i);
                  s && s.stopChronoView();
                }
              } catch (t) {}
              try {
                if ("string" == typeof t) {
                  switch (t) {
                    case "stop":
                      this._fireStop();
                      break;
                    case "pause":
                      this._firePause();
                  }
                  if (this.plugin.appAnalytics.appAnalyticsStarted) {
                    this.lastBeatTime = new Date().getTime();
                    var n = this.plugin.appAnalytics._beat.chrono.startTime ? this.lastBeatTime - this.plugin.appAnalytics._beat.chrono.startTime : 0;
                    this.plugin.appAnalytics._sendBeat(n), this.plugin.appAnalytics._beat.stop();
                  }
                }
              } catch (t) {}
            },
            _toForeground: function _toForeground(t) {
              this.isInBackground = !1;
              try {
                if (this.plugin && this.plugin.videos) for (var e = 0; e < this.plugin.videos.getVideoKeys().length; e++) {
                  var i = this.plugin.videos.getVideoKeys()[e],
                    s = this.plugin.videos.getAdsAdapter(i);
                  s && s.startChronoView();
                }
              } catch (t) {}
              try {
                if ("string" == typeof t && t && this.plugin.appAnalytics.appAnalyticsStarted) {
                  var n = new Date().getTime();
                  n - this.lastBeatTime < this.plugin.appAnalytics.sessionExpire ? (this.plugin.appAnalytics._sendBeat(n - this.lastBeatTime), this.plugin.appAnalytics._beat.start()) : this.plugin.appAnalytics.newSession();
                }
              } catch (t) {}
            },
            _getSettings: function _getSettings() {
              return "string" == typeof this.plugin.options["background.settings"] && this.plugin.options["background.settings"] ? this.plugin.options["background.settings"] : this.plugin.deviceDetector.isSmartTV() ? this.plugin.options["background.settings.tv"] : this.plugin.deviceDetector.isDesktop() ? this.plugin.options["background.settings.desktop"] : this.plugin.deviceDetector.isAndroid() ? this.plugin.options["background.settings.android"] : this.plugin.deviceDetector.isIphone() ? this.plugin.options["background.settings.iOS"] : this.plugin.deviceDetector.isPlayStation() ? this.plugin.options["background.settings.playstation"] : void 0;
            },
            _firePause: function _firePause() {
              this._fireX("firePause");
            },
            _fireStop: function _fireStop() {
              this._fireX("fireStop");
            },
            _fireX: function _fireX(t) {
              try {
                if (this.plugin && this.plugin.videos) for (var e = 0; e < this.plugin.videos.getVideoKeys().length; e++) {
                  var i = this.plugin.videos.getVideoKeys()[e];
                  this.adsAdapter = this.plugin.videos.getAdsAdapter(i), this.adsAdapter && this.adsAdapter[t]({}, "backgroundDetector"), this.contentAdapter = this.plugin.videos.getAdapter(i), this.contentAdapter && this.contentAdapter[t]({}, "backgroundDetector");
                }
              } catch (t) {}
            },
            canBlockStartCalls: function canBlockStartCalls() {
              return this.isInBackground && !0 === this.plugin.options["background.enabled"] && this._getSettings();
            }
          });
          t.exports = s;
        },
        2635: function _(t, e, i) {
          var s = i(3948).extend({
            constructor: function constructor() {
              "undefined" != typeof navigator && navigator.userAgent && (this._isSmartTVDevice = navigator.userAgent.toLowerCase().match(/smarttv/) || navigator.userAgent.toLowerCase().match(/smart-tv/) || navigator.userAgent.toLowerCase().match(/appletv/) || navigator.userAgent.toLowerCase().match(/apple tv/), this._isPlaystationDevice = null !== navigator.userAgent.match(/PlayStation/), this._isIphoneDevice = null !== navigator.userAgent.match(/iPhone|iPad|iPod/i), this._isAndroidDevice = null !== navigator.userAgent.match(/Android/), this._isSmartphoneDevice = !this._isSmartTVDevice && !this._isPlaystationDevice && (this._isIphoneDevice || this._isAndroidDevice), this._isDesktopDevice = !this._isSmartphoneDevice && !this._isSmartTVDevice && !this._isPlaystationDevice);
            },
            isIphone: function isIphone() {
              return this._isIphoneDevice;
            },
            isAndroid: function isAndroid() {
              return this._isAndroidDevice;
            },
            isSmartphone: function isSmartphone() {
              return this._isSmartphoneDevice;
            },
            isDesktop: function isDesktop() {
              return this._isDesktopDevice;
            },
            isSmartTV: function isSmartTV() {
              return this._isSmartTVDevice;
            },
            isPlayStation: function isPlayStation() {
              return this._isPlaystationDevice;
            }
          });
          t.exports = s;
        },
        6424: function _(t, e, i) {
          var s = i(3948).extend({
            constructor: function constructor(t, e) {
              this.plugin = t, this.video = e, this.listenerReference = this._changeListener.bind(this), this.loadReference = this._loadListener.bind(this), this.isEnabled = !1, this.pageHeight = 0, this.maxHeight = 0, this.startDetection();
            },
            startDetection: function startDetection() {
              this.isEnabled || "undefined" == typeof window || "function" != typeof window.addEventListener || (window.addEventListener("scroll", this.listenerReference), window.addEventListener("resize", this.listenerReference), window.addEventListener("load", this.loadReference), this.isEnabled = !0);
            },
            stopDetection: function stopDetection() {
              this.isEnabled && "undefined" != typeof window && "function" == typeof window.removeEventListener && (window.removeEventListener("scroll", this.listenerReference), window.removeEventListener("resize", this.listenerReference), window.removeEventListener("load", this.loadReference), this.isEnabled = !1);
            },
            getScrollDepth: function getScrollDepth() {
              var t = null;
              return this.maxHeight && this.pageHeight && (t = Math.min(Math.trunc(this.maxHeight / this.pageHeight * 100), 100)), t;
            },
            _loadListener: function _loadListener() {
              if ("undefined" != typeof document) {
                var t = document.documentElement;
                t && (this.pageHeight = Math.round(t.scrollHeight, t.clientHeight, t.offsetHeight), this.maxHeight = window.innerHeight, this._updateCompletionRate());
              }
            },
            _changeListener: function _changeListener() {
              if (this.pageHeight) {
                var t = this.maxHeight;
                this.maxHeight = Math.max(this.maxHeight, window.pageYOffset + window.innerHeight), t !== this.maxHeight && this._updateCompletionRate();
              }
              var e = this.video.getAdsAdapter();
              e && e.flags.isStarted && (e.getIsVisible() ? e.startChronoView() : e.stopChronoView());
            },
            _updateCompletionRate: function _updateCompletionRate() {
              setTimeout(function () {
                this.plugin.storage.setSession("pageScrollDepth", this.getScrollDepth());
              }.bind(this), 3e3);
            }
          });
          t.exports = s;
        },
        245: function _(t, e, i) {
          var s = i(3948).extend({
            constructor: function constructor(t) {
              this.plugin = t;
            },
            getAllData: function getAllData() {
              var t = this.getNonRandomData();
              return t.timestamp = this.getTimestamp(), t;
            },
            getNonRandomData: function getNonRandomData() {
              var t = {};
              return t.userAgent = this.getUserAgent(), t.threads = this.getVirtualCores(), t.language = this.getLanguage(), t.langList = this.getAvailableLanguages(), t.resolution = this.getResolution(), t.colorDepth = this.getColorDepth(), t.deviceMemory = this.getMemory(), t.touchscreen = this.getTouchscreen(), t.localStorage = this.getLocalStorage(), t.sessionStorage = this.getSessionStorage(), t.cookiesAvailable = this.getCookiesAvailable(), t.flashAvailable = this.getHasFlash(), t.timeZone = this.getTimeZone(), t.plugins = this.getPluginList(), t;
            },
            getUserAgent: function getUserAgent() {
              return this._getNavigatorValue("userAgent");
            },
            getVirtualCores: function getVirtualCores() {
              return this._getNavigatorValue("hardwareConcurrency");
            },
            getLanguage: function getLanguage() {
              return this._getNavigatorValue("language");
            },
            getAvailableLanguages: function getAvailableLanguages() {
              return this._getNavigatorValue("languages");
            },
            getResolution: function getResolution() {
              var t = null;
              try {
                this._getNavigatorValue("screen") && (t = navigator.screen.width.toString() + navigator.screen.height.toString());
              } catch (t) {}
              return t;
            },
            getColorDepth: function getColorDepth() {
              var t = null;
              try {
                this._getNavigatorValue("screen") && (t = navigator.screen.colorDepth);
              } catch (t) {}
              return t;
            },
            getMemory: function getMemory() {
              return this._getNavigatorValue("deviceMemory");
            },
            getTouchscreen: function getTouchscreen() {
              return this._getNavigatorValue("maxTouchPoints") || !1;
            },
            getLocalStorage: function getLocalStorage() {
              var t = !1;
              try {
                t = "undefined" != typeof localStorage;
              } catch (t) {}
              return t;
            },
            getSessionStorage: function getSessionStorage() {
              var t = !1;
              try {
                t = "undefined" != typeof sessionStorage;
              } catch (t) {}
              return t;
            },
            getCookiesAvailable: function getCookiesAvailable() {
              return this._getNavigatorValue("cookieEnabled") || !1;
            },
            getHasFlash: function getHasFlash() {
              var t = !1;
              try {
                var e = this._getNavigatorValue("plugins");
                t = e && "object" == typeof e["Shockwave Flash"] || "undefined" != typeof window && window.ActiveXObject && !1 !== new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
              } catch (t) {}
              return t;
            },
            getPluginList: function getPluginList() {
              var t = null;
              try {
                var e = this._getNavigatorValue("plugins");
                if (e && 0 !== e.length) {
                  for (var i = "", s = 0; s < navigator.plugins.length; s++) i += navigator.plugins[s].description + " " + navigator.plugins[s].filename + " " + navigator.plugins[s].name + " ";
                  t = i;
                }
              } catch (t) {}
              return t;
            },
            getTimeZone: function getTimeZone() {
              var t = null;
              try {
                t = new Date().getTimezoneOffset().toString();
              } catch (t) {}
              return t;
            },
            getTimestamp: function getTimestamp() {
              return new Date().getTime();
            },
            _navigatorCheck: function _navigatorCheck() {
              return "undefined" != typeof navigator;
            },
            _getNavigatorValue: function _getNavigatorValue(t) {
              var e = null;
              try {
                this._navigatorCheck() && (e = navigator[t]);
              } catch (t) {}
              return e;
            }
          });
          t.exports = s;
        },
        5804: function _(t, e, i) {
          var s = i(245),
            n = i(3948),
            r = i(6777);
          var _i39 = i(9065),
            a = _i39.default;
          var o = n.extend({
            constructor: function constructor() {
              this.dataExtractor = new s(), this.key = this.getPreviousKey();
            },
            generateHashKey: function generateHashKey() {
              if (!this.key) {
                var t = this.dataExtractor.getAllData();
                this.key = this._hashFunction(t), a.getInstance().getCoreStorage().setLocal("npawDeviceUUID", this.key);
              }
            },
            getKey: function getKey() {
              return this.key || this.generateHashKey(), this.key;
            },
            _hashFunction: function _hashFunction(t) {
              var e = t;
              return "string" != typeof t && (e = JSON.stringify(t)), r(e);
            },
            _reset: function _reset() {
              this.key = void 0;
            },
            getPreviousKey: function getPreviousKey() {
              return a.getInstance().getCoreStorage().getLocal("npawDeviceUUID");
            }
          });
          t.exports = o;
        },
        6777: function _(t) {
          t.exports = function (t) {
            function e(t, e) {
              return t << e | t >>> 32 - e;
            }
            function i(t, e) {
              var i, s, n, r, a;
              return n = 2147483648 & t, r = 2147483648 & e, a = (1073741823 & t) + (1073741823 & e), (i = 1073741824 & t) & (s = 1073741824 & e) ? 2147483648 ^ a ^ n ^ r : i | s ? 1073741824 & a ? 3221225472 ^ a ^ n ^ r : 1073741824 ^ a ^ n ^ r : a ^ n ^ r;
            }
            function s(t, s, n, r, a, o, d) {
              return t = i(t, i(i(function (t, e, i) {
                return t & e | ~t & i;
              }(s, n, r), a), d)), i(e(t, o), s);
            }
            function n(t, s, n, r, a, o, d) {
              return t = i(t, i(i(function (t, e, i) {
                return t & i | e & ~i;
              }(s, n, r), a), d)), i(e(t, o), s);
            }
            function r(t, s, n, r, a, o, d) {
              return t = i(t, i(i(function (t, e, i) {
                return t ^ e ^ i;
              }(s, n, r), a), d)), i(e(t, o), s);
            }
            function a(t, s, n, r, a, o, d) {
              return t = i(t, i(i(function (t, e, i) {
                return e ^ (t | ~i);
              }(s, n, r), a), d)), i(e(t, o), s);
            }
            function o(t) {
              var e,
                i = "",
                s = "";
              for (e = 0; e <= 3; e++) i += (s = "0" + (t >>> 8 * e & 255).toString(16)).substr(s.length - 2, 2);
              return i;
            }
            var d,
              c,
              u,
              l,
              h,
              p,
              f,
              g,
              m,
              v = Array();
            for (v = function (t) {
              for (var e, i = t.length, s = i + 8, n = 16 * ((s - s % 64) / 64 + 1), r = Array(n - 1), a = 0, o = 0; o < i;) a = o % 4 * 8, r[e = (o - o % 4) / 4] = r[e] | t.charCodeAt(o) << a, o++;
              return a = o % 4 * 8, r[e = (o - o % 4) / 4] = r[e] | 128 << a, r[n - 2] = i << 3, r[n - 1] = i >>> 29, r;
            }(t = function (t) {
              t = t.replace(/rn/g, "n");
              for (var e = "", i = 0; i < t.length; i++) {
                var s = t.charCodeAt(i);
                s < 128 ? e += String.fromCharCode(s) : s > 127 && s < 2048 ? (e += String.fromCharCode(s >> 6 | 192), e += String.fromCharCode(63 & s | 128)) : (e += String.fromCharCode(s >> 12 | 224), e += String.fromCharCode(s >> 6 & 63 | 128), e += String.fromCharCode(63 & s | 128));
              }
              return e;
            }(t)), p = 1732584193, f = 4023233417, g = 2562383102, m = 271733878, d = 0; d < v.length; d += 16) c = p, u = f, l = g, h = m, p = s(p, f, g, m, v[d + 0], 7, 3614090360), m = s(m, p, f, g, v[d + 1], 12, 3905402710), g = s(g, m, p, f, v[d + 2], 17, 606105819), f = s(f, g, m, p, v[d + 3], 22, 3250441966), p = s(p, f, g, m, v[d + 4], 7, 4118548399), m = s(m, p, f, g, v[d + 5], 12, 1200080426), g = s(g, m, p, f, v[d + 6], 17, 2821735955), f = s(f, g, m, p, v[d + 7], 22, 4249261313), p = s(p, f, g, m, v[d + 8], 7, 1770035416), m = s(m, p, f, g, v[d + 9], 12, 2336552879), g = s(g, m, p, f, v[d + 10], 17, 4294925233), f = s(f, g, m, p, v[d + 11], 22, 2304563134), p = s(p, f, g, m, v[d + 12], 7, 1804603682), m = s(m, p, f, g, v[d + 13], 12, 4254626195), g = s(g, m, p, f, v[d + 14], 17, 2792965006), p = n(p, f = s(f, g, m, p, v[d + 15], 22, 1236535329), g, m, v[d + 1], 5, 4129170786), m = n(m, p, f, g, v[d + 6], 9, 3225465664), g = n(g, m, p, f, v[d + 11], 14, 643717713), f = n(f, g, m, p, v[d + 0], 20, 3921069994), p = n(p, f, g, m, v[d + 5], 5, 3593408605), m = n(m, p, f, g, v[d + 10], 9, 38016083), g = n(g, m, p, f, v[d + 15], 14, 3634488961), f = n(f, g, m, p, v[d + 4], 20, 3889429448), p = n(p, f, g, m, v[d + 9], 5, 568446438), m = n(m, p, f, g, v[d + 14], 9, 3275163606), g = n(g, m, p, f, v[d + 3], 14, 4107603335), f = n(f, g, m, p, v[d + 8], 20, 1163531501), p = n(p, f, g, m, v[d + 13], 5, 2850285829), m = n(m, p, f, g, v[d + 2], 9, 4243563512), g = n(g, m, p, f, v[d + 7], 14, 1735328473), p = r(p, f = n(f, g, m, p, v[d + 12], 20, 2368359562), g, m, v[d + 5], 4, 4294588738), m = r(m, p, f, g, v[d + 8], 11, 2272392833), g = r(g, m, p, f, v[d + 11], 16, 1839030562), f = r(f, g, m, p, v[d + 14], 23, 4259657740), p = r(p, f, g, m, v[d + 1], 4, 2763975236), m = r(m, p, f, g, v[d + 4], 11, 1272893353), g = r(g, m, p, f, v[d + 7], 16, 4139469664), f = r(f, g, m, p, v[d + 10], 23, 3200236656), p = r(p, f, g, m, v[d + 13], 4, 681279174), m = r(m, p, f, g, v[d + 0], 11, 3936430074), g = r(g, m, p, f, v[d + 3], 16, 3572445317), f = r(f, g, m, p, v[d + 6], 23, 76029189), p = r(p, f, g, m, v[d + 9], 4, 3654602809), m = r(m, p, f, g, v[d + 12], 11, 3873151461), g = r(g, m, p, f, v[d + 15], 16, 530742520), p = a(p, f = r(f, g, m, p, v[d + 2], 23, 3299628645), g, m, v[d + 0], 6, 4096336452), m = a(m, p, f, g, v[d + 7], 10, 1126891415), g = a(g, m, p, f, v[d + 14], 15, 2878612391), f = a(f, g, m, p, v[d + 5], 21, 4237533241), p = a(p, f, g, m, v[d + 12], 6, 1700485571), m = a(m, p, f, g, v[d + 3], 10, 2399980690), g = a(g, m, p, f, v[d + 10], 15, 4293915773), f = a(f, g, m, p, v[d + 1], 21, 2240044497), p = a(p, f, g, m, v[d + 8], 6, 1873313359), m = a(m, p, f, g, v[d + 15], 10, 4264355552), g = a(g, m, p, f, v[d + 6], 15, 2734768916), f = a(f, g, m, p, v[d + 13], 21, 1309151649), p = a(p, f, g, m, v[d + 4], 6, 4149444226), m = a(m, p, f, g, v[d + 11], 10, 3174756917), g = a(g, m, p, f, v[d + 2], 15, 718787259), f = a(f, g, m, p, v[d + 9], 21, 3951481745), p = i(p, c), f = i(f, u), g = i(g, l), m = i(m, h);
            return (o(p) + o(f) + o(g) + o(m)).toLowerCase();
          };
        },
        1593: function _(t, e, i) {
          var s = i(3948),
            n = i(2467),
            r = s.extend({
              on: function on(t, e) {
                if (this._listeners = this._listeners || {}, "function" == typeof e) return this._listeners[t] = this._listeners[t] || [], this._listeners[t].push(e), this;
              },
              off: function off(t, e) {
                if (this._listeners = this._listeners || {}, this._listeners[t]) {
                  var i = this._listeners[t].indexOf(e);
                  -1 !== i && this._listeners[t].splice(i, 1);
                }
                return this;
              },
              emit: function emit(t, e) {
                return this._listeners = this._listeners || {}, e = e || {}, n(this._listeners[t]) && this._listeners[t].forEach(this._eachCallback.bind(this, t, e)), n(this._listeners["*"]) && this._listeners["*"].forEach(this._eachCallback.bind(this, t, e)), this;
              },
              _eachCallback: function _eachCallback(t, e, i) {
                "function" == typeof i && i({
                  type: t,
                  data: e,
                  target: this
                });
              }
            });
          t.exports = r;
        },
        4173: function _(t) {
          t.exports = function (t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");
            for (var e = Object(t), i = 1; i < arguments.length; i++) {
              var s = arguments[i];
              if (null != s) for (var n in s) s.hasOwnProperty(n) && (e[n] = s[n]);
            }
            return e;
          };
        },
        9600: function _(t) {
          var e = function e() {};
          t.exports = function (t) {
            if (arguments.length > 1) throw Error("Second argument not supported");
            if (null === t) throw Error("Cannot set a null [[Prototype]]");
            if ("object" != typeof t) throw TypeError("Argument must be an object");
            return e.prototype = t, new e();
          };
        },
        2467: function _(t) {
          t.exports = function (t) {
            return "[object Array]" === Object.prototype.toString.call(t);
          };
        },
        2101: function _(t, e, i) {
          var s = i(3948),
            n = i(9474),
            r = s.extend({
              constructor: function constructor(t) {
                var _this17 = this;
                if (this.appAnalytics = t.appAnalytics, this.timeObject = void 0, this.playerSetup = void 0, this.myTimesObject = {}, this.perfObject = void 0, "undefined" != typeof window && "function" == typeof window.addEventListener && (window.addEventListener("load", this._windowLoaded.bind(this)), window.performance && window.performance.timing)) {
                  try {
                    "function" == typeof window.performance.getEntriesByType && (this.perfObject = window.performance);
                  } catch (t) {}
                  this.timeObject = window.performance.timing;
                }
                try {
                  if ("function" == typeof PerformanceObserver) {
                    var _t27 = new PerformanceObserver(function (t, e) {
                      var i = t.getEntries();
                      _this17.myTimesObject.largestContentfulPaint = i[i.length - 1].renderTime;
                    });
                    PerformanceObserver.supportedEntryTypes.indexOf("largest-contentful-paint") > -1 && _t27.observe({
                      entryTypes: ["largest-contentful-paint"]
                    });
                  }
                } catch (t) {}
              },
              _windowLoaded: function _windowLoaded() {
                this.myTimesObject.onLoad = new Date().getTime(), this._getEnoughFPS(), setTimeout(this._fireLoadTimesEvent.bind(this), 1e3);
              },
              _fireLoadTimesEvent: function _fireLoadTimesEvent() {
                this._getLastMetrics(), this.appAnalytics && this.appAnalytics.fireEvent("loadTimes", {}, this._getAllValues());
              },
              _getAllValues: function _getAllValues() {
                var t = {
                  PageLoadTime: this.getPageLoadTime(),
                  DNSTime: this.getDnsTime(),
                  TCPTime: this.getTcpTime(),
                  HandshakeTime: this.getHandshakeTime(),
                  DomReadyTime: this.getDomReadyTime(),
                  BackendTime: this.getBackendTime(),
                  FrontendTime: this.getFrontendTime(),
                  VisualReady: this.getTimeToVisuallyReady(),
                  TimeToInteractive: this.getTimeToInteractive(),
                  JsTime: this.getJSTime(),
                  CssTime: this.getCSSTime(),
                  ImageTime: this.getImageTime(),
                  FontTime: this.getFontTime(),
                  AvgReqLatency: this.getAvgReqLatency(),
                  MaxReqLatency: this.getMaxReqLatency(),
                  FirstPaint: this.getFirstPaint(),
                  FirstContentfulPaint: this.getFirstContentfulPaint(),
                  LargestContentfulPaint: this.getLargestContentfulPaint(),
                  SpeedIndex: this.getSpeedIndex()
                };
                for (var _e25 in t) null === t[_e25] || void 0 === t[_e25] || t[_e25] < 0 ? delete t[_e25] : t[_e25] = Math.round(t[_e25]);
                return t;
              },
              getPageLoadTime: function getPageLoadTime() {
                var t;
                return this.timeObject && (t = this.timeObject.loadEventEnd - this.timeObject.navigationStart), t;
              },
              getPlayerStartupTime: function getPlayerStartupTime() {
                var t;
                return this.timeObject && this.playerSetup && (t = this.playerSetup - this.timeObject.navigationStart), t;
              },
              getDnsTime: function getDnsTime() {
                var t;
                return this.timeObject && (t = this.timeObject.domainLookupEnd - this.timeObject.domainLookupStart), t;
              },
              getTcpTime: function getTcpTime() {
                var t;
                return this.timeObject && (t = this.timeObject.connectEnd - this.timeObject.connectStart), t;
              },
              getHandshakeTime: function getHandshakeTime() {
                var t;
                return this.timeObject && this.timeObject.secureConnectionStart && (t = this.timeObject.connectEnd - this.timeObject.secureConnectionStart), t;
              },
              getDomReadyTime: function getDomReadyTime() {
                var t;
                return this.timeObject && (t = this.timeObject.domComplete - this.timeObject.navigationStart), t;
              },
              getBackendTime: function getBackendTime() {
                var t;
                return this.timeObject && (t = this.timeObject.responseStart - this.timeObject.navigationStart), t;
              },
              getFrontendTime: function getFrontendTime() {
                var t;
                return this.timeObject && (t = this.myTimesObject.onLoad - this.timeObject.responseStart), t;
              },
              getTimeToVisuallyReady: function getTimeToVisuallyReady() {
                var t = this.myTimesObject.firstPaint || 0;
                return this.timeObject ? Math.max(t, this.timeObject.domContentLoadedEventEnd - this.timeObject.navigationStart || 0) : t || void 0;
              },
              getTimeToInteractive: function getTimeToInteractive() {
                var _this18 = this;
                if (this.myTimesObject.fps && this.getTimeToVisuallyReady()) return Math.max(this.myTimesObject.fps, this.getTimeToVisuallyReady());
                setTimeout(function () {
                  _this18.getTimeToInteractive();
                }, 500);
              },
              getJSTime: function getJSTime() {
                return this._getXTime("script");
              },
              getCSSTime: function getCSSTime() {
                return this._getXTime("css");
              },
              getImageTime: function getImageTime() {
                return this._getXTime("img");
              },
              getFontTime: function getFontTime() {
                return this._getXTime("css", [".woff", ".otf", ".ttf"]);
              },
              getAvgReqLatency: function getAvgReqLatency() {
                try {
                  if (this.perfObject && "function" == typeof this.perfObject.getEntriesByType) {
                    var _e26 = 0,
                      _i40 = 0;
                    var _s15 = this.perfObject.getEntriesByType("resource");
                    for (var t in _s15) _s15[t].requestStart && _s15[t].responseStart && (_i40 += _s15[t].responseStart - _s15[t].requestStart), _e26++;
                    return _i40 / _e26;
                  }
                } catch (t) {}
              },
              getFirstPaint: function getFirstPaint() {
                return this.myTimesObject ? this.myTimesObject.firstPaint : void 0;
              },
              getFirstContentfulPaint: function getFirstContentfulPaint() {
                return this.myTimesObject ? this.myTimesObject.firstContentfulPaint : void 0;
              },
              getLargestContentfulPaint: function getLargestContentfulPaint() {
                return this.myTimesObject ? this.myTimesObject.largestContentfulPaint : void 0;
              },
              getMaxReqLatency: function getMaxReqLatency() {
                try {
                  if (this.perfObject && "function" == typeof this.perfObject.getEntriesByType) {
                    var _t28 = this.perfObject.getEntriesByType("resource");
                    var _e27 = 0;
                    for (var _i41 in _t28) _t28[_i41].requestStart && _t28[_i41].responseStart && (_e27 = Math.max(_e27, _t28[_i41].responseStart - _t28[_i41].requestStart));
                    return _e27;
                  }
                } catch (t) {}
              },
              getSpeedIndex: function getSpeedIndex() {
                var t;
                if ("undefined" != typeof window && window.performance && "function" == typeof window.performance.getEntriesByType) try {
                  t = n();
                } catch (t) {}
                return t;
              },
              _getXTime: function _getXTime(t, e) {
                var i = 0;
                try {
                  if (this.perfObject && "function" == typeof this.perfObject.getEntriesByType) {
                    var _n12 = this.perfObject.getEntriesByType("resource");
                    for (var _r6 in _n12) if (_n12[_r6].initiatorType === t) if (e) {
                      var _t29 = !1;
                      for (var s in e) _n12[_r6].name.indexOf(e[s] > 0) && (_t29 = !0);
                      _t29 && (i += _n12[_r6].duration);
                    } else i += _n12[_r6].duration;
                  }
                } catch (t) {}
                return Math.round(i) || void 0;
              },
              _getLastMetrics: function _getLastMetrics() {
                var t, e;
                try {
                  if (this.perfObject && "function" == typeof this.perfObject.getEntriesByType) {
                    var _i42 = this.perfObject.getEntriesByType("paint");
                    for (var _s16 in _i42) "first-paint" === _i42[_s16].name ? t = _i42[_s16].startTime : "first-contentful-paint" === _i42[_s16].name && (e = _i42[_s16].startTime);
                  }
                } catch (t) {}
                !t && this.timeObject && (t = this.timeObject.msFirstPaint - this.timeObject.navigationStart), this.myTimesObject.firstPaint = t, this.myTimesObject.firstContentfulPaint = e, this.getTimeToInteractive();
              },
              _getEnoughFPS: function _getEnoughFPS() {
                var _this19 = this;
                if (!this.timeObject || "undefined" == typeof window) return !0;
                {
                  var _t30 = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function () {};
                  this.preFPS = new Date().getTime(), _t30(function () {
                    var t = new Date().getTime();
                    t < _this19.preFPS + 50 ? _this19.myTimesObject.fps = t - _this19.timeObject.navigationStart : setTimeout(function () {
                      return _this19._getEnoughFPS();
                    }, 50);
                  });
                }
              },
              setPlayerSetupTime: function setPlayerSetupTime() {
                this.playerSetup = this.playerSetup || new Date().getTime();
              }
            });
          t.exports = r;
        },
        2995: function _(t, e, i) {
          var s = i(3948).extend({
            getCdnTraffic: function getCdnTraffic() {
              var t;
              if ("undefined" != typeof CdnBalancerStats && CdnBalancerStats.cdn) t = CdnBalancerStats.cdn.totalDownloadedBytes;else if ("undefined" != typeof Streamroot) t = this._getStreamrootPeerObject("cdn", !1) || this._getStreamrootInstanceObject("cdnDownload");else if ("undefined" != typeof peer5 && peer5.getStats) t = peer5.getStats().totalHttpDownloaded;else if ("undefined" != typeof teltoo && teltoo.getStats) {
                var e = teltoo.getStats();
                t = e.totalReceivedBytes - e.p2pReceivedBytes;
              }
              return t;
            },
            getMultiCdnInfo: function getMultiCdnInfo() {
              var t;
              if ("undefined" != typeof CdnBalancerStats && CdnBalancerStats.cdn && CdnBalancerStats.cdn.cdns) {
                var _e28 = CdnBalancerStats.p2p;
                t = {
                  P2P: {
                    downloaded_bytes: _e28.downloadedBytes,
                    uploaded_bytes: _e28.uploadedBytes,
                    downloaded_chunks: _e28.downloadedSegments,
                    uploaded_chunks: _e28.uploadedSegments,
                    errors: _e28.failedRequests ? _e28.failedRequests.total : 0,
                    missed_downloaded_chunks: _e28.failedRequests ? _e28.failedRequests.absent : 0,
                    timeout_errors: _e28.failedRequests ? _e28.failedRequests.timeout : 0,
                    other_errors: _e28.failedRequests ? _e28.failedRequests.error : 0,
                    late_uploaded_chunks: _e28.discardedUploadedSegments,
                    late_uploaded_bytes: _e28.discardedUploadedBytes,
                    late_downloaded_bytes: _e28.discardedDownloadedBytes,
                    time: _e28.downloadMillis,
                    active_peers: _e28.activePeers,
                    peers: _e28.totalPeers
                  }
                }, CdnBalancerStats.cdn.cdns.forEach(function (e) {
                  t[e.name] = {
                    downloaded_bytes: e.bytes,
                    downloaded_chunks: e.chunks,
                    errors: e.failures,
                    time: e.downloadMillis
                  };
                });
              }
              return t;
            },
            getSegmentDuration: function getSegmentDuration() {
              if ("undefined" != typeof CdnBalancerStats && CdnBalancerStats.segmentDuration) return CdnBalancerStats.segmentDuration;
            },
            getBalancerResponseId: function getBalancerResponseId() {
              if ("undefined" != typeof CdnBalancerStats && CdnBalancerStats.cdn) return CdnBalancerStats.cdn.responseUUID;
            },
            getP2PTraffic: function getP2PTraffic() {
              var t;
              return "undefined" != typeof CdnBalancerStats && CdnBalancerStats.p2p ? t = CdnBalancerStats.p2p.downloadedBytes : "undefined" != typeof Streamroot ? t = this._getStreamrootPeerObject("p2p", !0) || this._getStreamrootInstanceObject("dnaDownload") : "undefined" != typeof peer5 && peer5.getStats ? t = peer5.getStats().totalP2PDownloaded : "undefined" != typeof teltoo && teltoo.getStats && (t = teltoo.getStats().p2pReceivedBytes), t;
            },
            getUploadTraffic: function getUploadTraffic() {
              var t;
              return "undefined" != typeof CdnBalancerStats && CdnBalancerStats.p2p ? t = CdnBalancerStats.p2p.uploadedBytes : "undefined" != typeof Streamroot ? t = this._getStreamrootPeerObject("upload", !0) || this._getStreamrootInstanceObject("dnaUpload") : "undefined" != typeof peer5 && peer5.getStats && (t = peer5.getStats().totalP2PUploaded), t;
            },
            getIsP2PEnabled: function getIsP2PEnabled() {
              var t = !1;
              if ("undefined" != typeof CdnBalancerStats && CdnBalancerStats.p2p) t = CdnBalancerStats.p2p.downloadEnabled;else if ("undefined" != typeof Streamroot) {
                if (Streamroot.p2pAvailable && Streamroot.peerAgents) for (var e in Streamroot.peerAgents) t = t || Streamroot.peerAgents[e].isP2PEnabled;else Streamroot.instances && Streamroot.instances.forEach(function (e) {
                  t = t || e.dnaDownloadEnabled || e.dnaUploadEnabled;
                });
              } else "undefined" != typeof peer5 && peer5.isEnabled ? t = peer5.isEnabled() : "undefined" != typeof teltoo && (t = !0);
              return t;
            },
            _getStreamrootPeerObject: function _getStreamrootPeerObject(t, e) {
              var i = "";
              if (Streamroot.p2pAvailable && Streamroot.peerAgents) for (var _s17 in Streamroot.peerAgents) {
                var n = Streamroot.peerAgents[_s17];
                !n.stats || e && !n.isP2PEnabled || (i += n.stats[t]);
              }
              return i.length > 0 ? i : void 0;
            },
            _getStreamrootInstanceObject: function _getStreamrootInstanceObject(t) {
              var e = "";
              return Streamroot.instances && Streamroot.instances.forEach(function (i) {
                i.stats && i.stats.currentContent && (e += i.stats.currentContent[t]);
              }), e.length > 0 ? e : void 0;
            }
          });
          t.exports = s;
        },
        9474: function _(t) {
          var e = function e(t) {
            var i,
              s,
              n = (t = t || window).document,
              r = function r(e) {
                var i = !1;
                if (e.getBoundingClientRect) {
                  var s = e.getBoundingClientRect();
                  (i = {
                    top: Math.max(s.top, 0),
                    left: Math.max(s.left, 0),
                    bottom: Math.min(s.bottom, t.innerHeight || n.documentElement.clientHeight),
                    right: Math.min(s.right, t.innerWidth || n.documentElement.clientWidth)
                  }).bottom <= i.top || i.right <= i.left ? i = !1 : i.area = (i.bottom - i.top) * (i.right - i.left);
                }
                return i;
              },
              a = function a(t, e) {
                if (e) {
                  var i = r(t);
                  i && o.push({
                    url: e,
                    area: i.area,
                    rect: i
                  });
                }
              },
              o = [],
              d = [];
            try {
              var c = t.performance.timing.navigationStart;
              !function () {
                for (var i = n.getElementsByTagName("*"), s = /url\(.*(http.*)\)/gi, d = 0; d < i.length; d++) {
                  var c = i[d],
                    u = t.getComputedStyle(c);
                  if ("IMG" === c.tagName && a(c, c.src), u["background-image"]) {
                    s.lastIndex = 0;
                    var l = s.exec(u["background-image"]);
                    l && l.length > 1 && a(c, l[1].replace('"', ""));
                  }
                  if ("IFRAME" === c.tagName) try {
                    var h = r(c);
                    if (h) {
                      var p = e(c.contentWindow);
                      p && o.push({
                        tm: p,
                        area: h.area,
                        rect: h
                      });
                    }
                  } catch (t) {}
                }
              }(), function () {
                for (var e = {}, i = t.performance.getEntriesByType("resource"), s = 0; s < i.length; s++) e[i[s].name] = i[s].responseEnd;
                for (var n = 0; n < o.length; n++) "tm" in o[n] || (o[n].tm = void 0 !== e[o[n].url] ? e[o[n].url] : 0);
              }(), function () {
                "msFirstPaint" in t.performance.timing && (i = t.performance.timing.msFirstPaint - c);
                for (var e = t.performance.getEntriesByType("paint"), s = 0; s < e.length; s++) "first-paint" === e[s].name && (i = e[s].startTime);
                if (void 0 === i || i < 0 || i > 12e4) {
                  i = t.performance.timing.responseStart - c;
                  for (var r = {}, a = n.getElementsByTagName("head")[0].children, o = 0; o < a.length; o++) {
                    var d = a[o];
                    "SCRIPT" === d.tagName && d.src && !d.async && (r[d.src] = !0), "LINK" === d.tagName && "stylesheet" === d.rel && d.href && (r[d.href] = !0);
                  }
                  for (var u = t.performance.getEntriesByType("resource"), l = !1, h = 0; h < u.length; h++) if (l || !r[u[h].name] || "script" !== u[h].initiatorType && "link" !== u[h].initiatorType) l = !0;else {
                    var p = u[h].responseEnd;
                    (void 0 === i || p > i) && (i = p);
                  }
                }
                i = Math.max(i, 0);
              }(), function () {
                for (var e = {
                    0: 0
                  }, s = 0, r = 0; r < o.length; r++) {
                  var a = i;
                  "tm" in o[r] && o[r].tm > i && (a = o[r].tm), void 0 === e[a] && (e[a] = 0), e[a] += o[r].area, s += o[r].area;
                }
                var c = Math.max(n.documentElement.clientWidth, t.innerWidth || 0) * Math.max(n.documentElement.clientHeight, t.innerHeight || 0);
                if (c > 0 && (c = .1 * Math.max(c - s, 0), void 0 === e[i] && (e[i] = 0), e[i] += c, s += c), s) {
                  for (var u in e) e.hasOwnProperty(u) && d.push({
                    tm: u,
                    area: e[u]
                  });
                  d.sort(function (t, e) {
                    return t.tm - e.tm;
                  });
                  for (var l = 0, h = 0; h < d.length; h++) l += d[h].area, d[h].progress = l / s;
                }
              }(), function () {
                if (d.length) {
                  s = 0;
                  for (var t = 0, e = 0, n = 0; n < d.length; n++) {
                    var r = d[n].tm - t;
                    r > 0 && e < 1 && (s += (1 - e) * r), t = d[n].tm, e = d[n].progress;
                  }
                } else s = i;
              }();
            } catch (t) {}
            return s;
          };
          t.exports = e;
        },
        6014: function _(t, e, i) {
          var s = n,
            n = {
              noConflict: function noConflict() {
                return n = s, this;
              }
            };
          n.VERSION = i(9835), n.polyfills = i(4607), n.polyfills(), n.Object = i(3948), n.Emitter = i(1593);
          var _i43 = i(7276),
            r = _i43.default;
          n.Log = r, n.Log.loadLevelFromUrl(), n.Util = i(2507), n.HybridNetwork = i(2995), n.Chrono = i(7680), n.Timer = i(4954), n.Constants = i(3782), n.Transform = i(2503), n.ResourceTransform = i(1151), n.CdnParser = i(3908), n.HlsParser = i(3168), n.DashParser = i(3831), n.LocationheaderParser = i(1657), n.Options = i(7061), n.Plugin = i(1527), n.Storage = i(470), n.RequestBuilder = i(2071), n.PlayheadMonitor = i(3381), n.Adapter = i(5292), n.adapters = {}, n.BackgroundDetector = i(9773), n.DeviceDetector = i(2635), n.UUIDGenerator = i(5804), n.registerAdapter = function (t, e) {
            this.adapters[t] = e;
          }.bind(n), n.unregisterAdapter = function (t) {
            this.adapters[t] = null;
          }.bind(n), t.exports = n;
        },
        3948: function _(t, e, i) {
          var s = i(4173),
            n = i(9600),
            r = function r() {};
          r.prototype = {
            constructor: function constructor() {}
          }, r.extend = function (t, e) {
            var i,
              r = this;
            return i = t && t.hasOwnProperty("constructor") ? t.constructor : function () {
              return r.apply(this, arguments);
            }, s(i, r, e), i.prototype = n(r.prototype), t && s(i.prototype, t), i.prototype.constructor = i, i.__super__ = r.prototype, i;
          }, t.exports = r;
        },
        3398: function _(t, e, i) {
          var s = i(3948);
          var _i44 = i(7276),
            n = _i44.default,
            _i45 = i(2784),
            r = _i45.AnalyticsTag;
          var a = s.extend({
            exists: function exists(t) {
              return a.Dictionary.hasOwnProperty(t);
            },
            getNewName: function getNewName(t) {
              var e = a.Dictionary[t];
              return n.warn(r, 'The option "' + t + '" is deprecated, use "' + e + '" instead'), e;
            }
          }, {
            Dictionary: {
              httpSecure: "app.https",
              username: "user.name",
              anonymousUser: "user.anonymousId",
              obfuscateIp: "user.obfuscateIp",
              userType: "user.type",
              "content.title2": "content.program",
              "background.settings.iphone": "background.settings.iOS",
              "parse.hls": "parse.manifest",
              "parse.dash": "parse.manifest",
              "parse.locationHeader": "parse.manifest",
              "extraparam.1": "content.customDimension.1",
              "extraparam.2": "content.customDimension.2",
              "extraparam.3": "content.customDimension.3",
              "extraparam.4": "content.customDimension.4",
              "extraparam.5": "content.customDimension.5",
              "extraparam.6": "content.customDimension.6",
              "extraparam.7": "content.customDimension.7",
              "extraparam.8": "content.customDimension.8",
              "extraparam.9": "content.customDimension.9",
              "extraparam.10": "content.customDimension.10",
              "extraparam.11": "content.customDimension.11",
              "extraparam.12": "content.customDimension.12",
              "extraparam.13": "content.customDimension.13",
              "extraparam.14": "content.customDimension.14",
              "extraparam.15": "content.customDimension.15",
              "extraparam.16": "content.customDimension.16",
              "extraparam.17": "content.customDimension.17",
              "extraparam.18": "content.customDimension.18",
              "extraparam.19": "content.customDimension.19",
              "extraparam.20": "content.customDimension.20",
              "ad.extraparam.1": "ad.customDimension.1",
              "ad.extraparam.2": "ad.customDimension.2",
              "ad.extraparam.3": "ad.customDimension.3",
              "ad.extraparam.4": "ad.customDimension.4",
              "ad.extraparam.5": "ad.customDimension.5",
              "ad.extraparam.6": "ad.customDimension.6",
              "ad.extraparam.7": "ad.customDimension.7",
              "ad.extraparam.8": "ad.customDimension.8",
              "ad.extraparam.9": "ad.customDimension.9",
              "ad.extraparam.10": "ad.customDimension.10"
            }
          });
          t.exports = a;
        },
        3455: function _(t, e, i) {
          var s = i(3948),
            n = i(470),
            r = s.extend({
              constructor: function constructor() {
                this.storage = new n("npawOffline", !0), this.actualView = null, this.viewList = [], this.givenIds = [], this._getOldViewList();
              },
              _newView: function _newView() {
                var t = this._getValidId();
                this.storage.setLocal(t, ""), this.viewList.push(t), this.storage.setLocal("views", this.viewList), this.actualView = t;
              },
              addEvent: function addEvent(t, e) {
                if ("/start" === t && this._newView(), "/init" === t) return null;
                if (!this.actualView) return null;
                var i = '{"request":"' + t.slice(1) + '",';
                for (var s in i += '"unixtime":' + Date.now() + ",", e) {
                  if (void 0 === e[s]) break;
                  i += '"' + s + '":', "code" === s ? i += '"CODE_PLACEHOLDER",' : "sessionId" === s ? i += '"SESSION_PLACEHOLDER",' : "sessionRoot" === s ? i += '"ROOT_PLACEHOLDER",' : "string" == typeof e[s] ? i += '"' + e[s] + '",' : "object" == typeof e[s] ? i += '"' + JSON.stringify(e[s]).replace(/"/g, '\\"') + '",' : i += e[s] + ",";
                }
                i = i.slice(0, -1), i += "}";
                var n = this.storage.getLocal(this.actualView);
                "" !== n && (n += ","), this.storage.setLocal(this.actualView, n + i);
              },
              getView: function getView() {
                if (this.viewList.length > this.givenIds.length) for (var t = 0;;) {
                  var e = this.viewList[t];
                  if (this.givenIds.indexOf(e) < 0) return this.givenIds.push(e), ["[" + this.storage.getLocal(e) + "]", e];
                  t++;
                }
                return [null, null];
              },
              removeView: function removeView(t) {
                this.storage.removeLocal(t);
                var e = this.viewList.indexOf(t);
                -1 !== e && this.viewList.splice(e, 1), -1 !== (e = this.givenIds.indexOf(t)) && this.givenIds.splice(e, 1), this.storage.setLocal("views", this.viewList.toString()), t === this.actualView && (this.actualView = null);
              },
              _getOldViewList: function _getOldViewList() {
                var t = "";
                this.storage.getLocal("views") ? t = this.storage.getLocal("views") : this.storage.setLocal("views", ""), "" === t ? this.viewList = [] : "function" == typeof t.split && (this.viewList = t.split(","));
              },
              _getValidId: function _getValidId() {
                var t = Math.floor(1e8 * Math.random()).toString();
                return this.viewList.indexOf(t) >= 0 ? this._getValidId() : t;
              },
              sent: function sent() {
                this.givenIds = [];
              }
            });
          t.exports = r;
        },
        7061: function _(t, e, i) {
          var s = i(3948),
            n = i(3398),
            _i46 = i(7276),
            r = _i46.default,
            a = i(7939),
            o = i(8472),
            d = i(9637),
            _i47 = i(2784),
            c = _i47.AnalyticsTag;
          var u = s.extend({
            constructor: function constructor(t) {
              this.enabled = !0, this.authToken = void 0, this.authType = "Bearer", this.preventZombieViews = !0, this.offline = !1, this.referer = void 0, this.referral = void 0, this.disableCookies = !0, this.forceCookies = !1, this.disableStorage = !1, this["user.email"] = void 0, this["user.type"] = void 0, this["user.name"] = void 0, this["user.obfuscateIp"] = !1, this["user.anonymousId"] = void 0, this["user.privacyProtocol"] = void 0, this["parse.manifest"] = !1, this["parse.manifest.auth"] = {}, this["parse.cdnNameHeader"] = ["x-cdn-forward"], this["parse.cdnNodeHeader"] = "", this["parse.cdnNode"] = !1, this["parse.cdnNode.list"] = ["Akamai", "Amazon", "Cloudfront", "Level3", "Fastly", "Highwinds", "Telefonica", "Edgecast", "NosOtt"], this["parse.fdsResponseHost"] = void 0, this["parse.cdnSwitchHeader"] = !1, this["parse.cdnTTL"] = 60, this["network.ip"] = void 0, this["network.isp"] = void 0, this["network.connectionType"] = void 0, this["device.id"] = void 0, this["device.code"] = void 0, this["device.model"] = void 0, this["device.brand"] = void 0, this["device.type"] = void 0, this["device.name"] = void 0, this["device.osName"] = void 0, this["device.osVersion"] = void 0, this["device.browserName"] = void 0, this["device.browserVersion"] = void 0, this["device.browserType"] = void 0, this["device.browserEngine"] = void 0, this["device.EDID"] = void 0, this["device.isAnonymous"] = !1, this["content.transactionCode"] = void 0, this["content.resource"] = void 0, this["content.isLive"] = void 0, this["content.isLive.noSeek"] = !1, this["content.isLive.noMonitor"] = !1, this["content.title"] = void 0, this["content.program"] = void 0, this["content.duration"] = void 0, this["content.fps"] = void 0, this["content.segmentDuration"] = void 0, this["content.bitrate"] = void 0, this["content.totalBytes"] = void 0, this["content.sendTotalBytes"] = !1, this["content.throughput"] = void 0, this["content.rendition"] = void 0, this["content.cdn"] = void 0, this["content.cdnNode"] = void 0, this["content.cdnType"] = void 0, this["content.metadata"] = {}, this["content.metrics"] = {}, this["content.streamingProtocol"] = void 0, this["content.transportFormat"] = void 0, this["content.package"] = void 0, this["content.saga"] = void 0, this["content.tvShow"] = void 0, this["content.season"] = void 0, this["content.episodeTitle"] = void 0, this["content.channel"] = void 0, this["content.id"] = void 0, this["content.imdbId"] = void 0, this["content.gracenoteId"] = void 0, this["content.type"] = void 0, this["content.genre"] = void 0, this["content.language"] = void 0, this["content.autodetect.language"] = !0, this["content.subtitles"] = void 0, this["content.autodetect.subtitles"] = !0, this["content.contractedResolution"] = void 0, this["content.cost"] = void 0, this["content.price"] = void 0, this["content.playbackType"] = void 0, this["content.drm"] = void 0, this["content.encoding.videoCodec"] = void 0, this["content.encoding.audioCodec"] = void 0, this["content.encoding.codecSettings"] = void 0, this["content.encoding.codecProfile"] = void 0, this["content.encoding.containerFormat"] = void 0, this["ad.metadata"] = {}, this["ad.campaign"] = void 0, this["ad.creativeId"] = void 0, this["ad.provider"] = void 0, this["ad.resource"] = void 0, this["ad.title"] = void 0, this["ad.duration"] = void 0, this["ad.expectedPattern"] = void 0, this["ad.givenAds"] = void 0, this["ad.breaksTime"] = void 0, this["ad.expectedBreaks"] = void 0, this["ad.givenBreaks"] = void 0, this["ad.ignore"] = !1, this["ad.blockerDetected"] = void 0, this["ad.postRollTimeout"] = 1e3, this["app.name"] = void 0, this["app.releaseVersion"] = void 0, this["app.https"] = !0, this["background.enabled"] = !0, this["background.settings"] = void 0, this["background.settings.android"] = "stop", this["background.settings.iOS"] = "stop", this["background.settings.desktop"] = void 0, this["background.settings.tv"] = "stop", this["background.settings.playstation"] = "stop", this["smartswitch.configCode"] = void 0, this["smartswitch.groupCode"] = void 0, this["smartswitch.contractCode"] = void 0, this["content.customDimensions"] = {}, this["content.customDimension.1"] = void 0, this["content.customDimension.2"] = void 0, this["content.customDimension.3"] = void 0, this["content.customDimension.4"] = void 0, this["content.customDimension.5"] = void 0, this["content.customDimension.6"] = void 0, this["content.customDimension.7"] = void 0, this["content.customDimension.8"] = void 0, this["content.customDimension.9"] = void 0, this["content.customDimension.10"] = void 0, this["content.customDimension.11"] = void 0, this["content.customDimension.12"] = void 0, this["content.customDimension.13"] = void 0, this["content.customDimension.14"] = void 0, this["content.customDimension.15"] = void 0, this["content.customDimension.16"] = void 0, this["content.customDimension.17"] = void 0, this["content.customDimension.18"] = void 0, this["content.customDimension.19"] = void 0, this["content.customDimension.20"] = void 0, this["ad.customDimension.1"] = void 0, this["ad.customDimension.2"] = void 0, this["ad.customDimension.3"] = void 0, this["ad.customDimension.4"] = void 0, this["ad.customDimension.5"] = void 0, this["ad.customDimension.6"] = void 0, this["ad.customDimension.7"] = void 0, this["ad.customDimension.8"] = void 0, this["ad.customDimension.9"] = void 0, this["ad.customDimension.10"] = void 0, this.forceInit = !1, this["session.metrics"] = {}, this["session.context"] = !1, this["errors.fatal"] = [], this["errors.nonFatal"] = [], this["errors.ignore"] = [], this["pause.ignoreSmallEvents"] = !0, this["check.playerExists"] = !0, this["check.appAnalytics.autoBegin"] = !1, this["check.appAnalytics.enabled"] = !0, this["debug.playerLogs.enabled"] = !1, this["debug.pluginLogs.enabled"] = !1, this["check.videoAnalytics.enabled"] = !0, this["lma.refresh.configuration.enabled"] = !1, this["lma.refresh.configuration.seconds"] = 300, this.linkedViewId = void 0, this.waitForMetadata = !1, this.pendingMetadata = [], this.method = d.GET, this["playhead.monitor"] = !0, this["readyState.monitor"] = !0, this["adapters.overwrite"] = !1, this["adapters.templates"] = {}, this["adapters.properties"] = {}, this.enableExtraMetricCollection = !1, this.renditionQueryInterval = 250, this.enableLegacyBufferBehaviour = !1, this.setOptions(t);
            },
            setOptions: function setOptions(t, e) {
              var i,
                s = !1;
              if (void 0 === e && (e = this, s = !0, i = new n()), void 0 !== t) for (var a in t) {
                var _n13 = void 0,
                  _o4 = !1;
                s && (this.hasOwnProperty(a) || (i.exists(a) ? (_n13 = i.getNewName(a), _o4 = !0) : "function" != typeof t[a] && r.warn(c, 'The option "' + a + '" does not exist, so it cannot be set'))), "object" != typeof e[a] || void 0 === e[a] || Array.isArray(e[a]) || "parse.cdnNode.list" !== a ? _o4 ? e[_n13] = t[a] : e[a] = t[a] : this.setOptions(t[a], e[a]);
              }
            },
            setExtraParams: function setExtraParams(t) {
              var _this20 = this;
              if ("object" == typeof t && t.length) {
                for (t.length >= 20 && (t = t.slice(0, 20)); t.length < 20;) t.push(void 0);
                t.forEach(function (t, e) {
                  _this20["content.customDimension." + (e + 1).toString()] = t;
                });
              }
            },
            setCustomDimensions: function setCustomDimensions() {
              u.prototype.setExtraParams.apply(this, arguments);
            },
            setAdExtraParams: function setAdExtraParams(t) {
              var _this21 = this;
              if ("object" == typeof t && t.length) {
                for (t.length >= 10 && (t = t.slice(0, 10)); t.length < 10;) t.push(void 0);
                t.forEach(function (t, e) {
                  _this21["ad.customDimension." + (e + 1).toString()] = t;
                });
              }
            },
            setAdCustomDimensions: function setAdCustomDimensions() {
              u.prototype.setAdExtraParams.apply(this, arguments);
            },
            setEnableLegacyBufferBehaviour: function setEnableLegacyBufferBehaviour() {
              u.prototype.setEnableLegacyBufferBehaviour.apply(this, arguments);
            }
          }, {
            StreamingProtocol: o,
            TransportFormat: a,
            RequestMethod: d
          });
          t.exports = u;
        },
        1527: function _(t, e, i) {
          var s = i(1593),
            n = i(3782),
            r = i(2507);
          var _i48 = i(7276),
            a = _i48.default;
          var o = i(5651);
          var _i49 = i(6075),
            d = _i49.default;
          var c = i(7061),
            u = i(470),
            l = (i(3455), i(2071)),
            h = i(1151),
            p = i(2101),
            f = i(9773),
            g = i(2635),
            m = i(5804);
          var _i50 = i(3555),
            v = _i50.default,
            _i51 = i(2784),
            y = _i51.Method,
            T = _i51.AnalyticsTag,
            _i52 = i(9065),
            S = _i52.default,
            _i53 = i(61),
            E = _i53.default,
            _i54 = i(1577),
            b = _i54.default;
          var A = s.extend({
            constructor: function constructor(t, e, s, n) {
              if (A.instance) return e && (a.notice(T, "Set Options for already existing instance"), A.instance.setOptions(e), A.instance.storage.updateStorageOptions(A.instance.options.disableCookies, A.instance.options.forceCookies, A.instance.options.disableStorage)), s && (a.notice(T, "Set Adapter for already existing instance"), A.instance.setAdapter(s)), a.warn(T, "Only a single plugin instance can be created on npaw context"), A.instance;
              this.options = new c(e), this.storage = new u(null, this.options.disableCookies, this.options.forceCookies, this.options.disableStorage), this.utils = i(2507), this.uuidGenerator = new m(), this.videos = new o(this), this.analyticsRequestHandler = new d(this), this.adapterTemplates = {}, this.appAnalytics = t, this.requestBuilder = new l(), this.resourceTransform = new h(this), this.lastEventTime = null, this.browserLoadTimes = new p(this), this.deviceDetector = new g(), this.backgroundDetector = new f(this), this.options["background.enabled"] && this.backgroundDetector.startDetection(), s && this.setAdapter(s), this._logInitPluginEvent(e), A.instance = this;
            },
            addOnWillSendRequestListener: function addOnWillSendRequestListener(t) {
              this.analyticsRequestHandler.onWillSendVideoRequestListeners.push(t);
            },
            removeOnWillSendRequestListener: function removeOnWillSendRequestListener(t) {
              this.analyticsRequestHandler.onWillSendVideoRequestListeners = this.analyticsRequestHandler.onWillSendVideoRequestListeners.filter(function (e) {
                return e !== t;
              });
            },
            destroy: function destroy() {
              this.videos.removeAllAdapters(), this.videos.videos = {};
            },
            _setAdapterTemplates: function _setAdapterTemplates(t) {
              this.adapterTemplates = t;
            },
            _receiveConfiguration: function _receiveConfiguration(t) {
              try {
                if (t.target.response.configurationOptions) {
                  var e = t.target.response.configurationOptions;
                  this.options.setOptions(e, this.options), this.videos.updateAllOptions(e);
                }
                this.isRefreshLMAConfigurationEnabled() && this.fastDataTransform && this.fastDataTransform._createConfigurationInterval();
              } catch (t) {}
            },
            _reset: function _reset(t) {
              this.videos.resetVideo(t);
            },
            setOptions: function setOptions(t) {
              if (this._logSetOptionsEvent(t), t) {
                "boolean" == typeof t["parse.manifest"] && t["parse.manifest"] && (t.waitForMetadata = !0, t.pendingMetadata || (t.pendingMetadata = []), t.pendingMetadata.push("parsedResource")), this.options.setOptions(t), this.storage.updateStorageOptions(this.options.disableCookies, this.options.forceCookies, this.options.disableStorage);
                var _iterator9 = _createForOfIteratorHelper(this.videos.getVideoKeys()),
                  _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _e29 = _step9.value;
                    this.setVideoOptions(t, _e29);
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
                "boolean" == typeof t["background.enabled"] && (t["background.enabled"] ? this.backgroundDetector.startDetection() : this.backgroundDetector.stopDetection());
              }
              S.getInstance().registerCommonVariable(E.Products.VIDEO_ANALYTICS, E.AnalyticsVariables.METHOD_OPTION, b.methodFromString(t.method));
            },
            setVideoOptions: function setVideoOptions(t, e) {
              e = e || "default", t && e && this.videos.existsVideo(e) && Object.keys(t).length > 0 && this.videos.getVideo(e).setVideoOptions(t);
            },
            disable: function disable() {
              this.setOptions({
                enabled: !1
              });
            },
            enable: function enable() {
              this.setOptions({
                enabled: !0
              });
            },
            getPingTime: function getPingTime() {
              return S.getInstance().getFastDataService().getPingTime();
            },
            _logInitPluginEvent: function _logInitPluginEvent(t) {
              var e = {
                logs: t,
                logAction: "initPlugin",
                logType: "pluginMethod"
              };
              this._sendPluginLogs(e, this.isMethodPostEnabled());
            },
            _logSetAdapterEvent: function _logSetAdapterEvent(t) {
              var e = {
                adapter: t,
                logAction: "setAdapter",
                logType: "pluginMethod"
              };
              this._sendPluginLogs(e, this.isMethodPostEnabled());
            },
            _logSetOptionsEvent: function _logSetOptionsEvent(t) {
              var e = {
                logs: t,
                logAction: "setOptions",
                logType: "pluginMethod"
              };
              this._sendPluginLogs(e, this.isMethodPostEnabled());
            },
            _logReceiveDataEvent: function _logReceiveDataEvent(t) {
              var e = "";
              t.data && t.data.target && t.data.target.response && t.data.target.response.msg && (e = JSON.parse(t.data.target.response.msg));
              var i = {
                logs: e,
                logAction: "receiveData",
                logType: "internalMethod"
              };
              this._sendPluginLogs(i, this.isMethodPostEnabled());
            },
            _sendPluginLogs: function _sendPluginLogs(t, e) {
              if (e = e || !1, this.isPluginLogsEnabled() && (t && t.logType && t.logAction && a.notice(T, "PluginLog " + t.logType + ": Action " + t.logAction), this.analyticsRequestHandler && null !== (t = this.requestBuilder.buildParams(t, n.Service.VIDEO_PLUGIN_LOGS, this)))) {
                var i = e ? y.POST : y.GET;
                var _s18 = new v(n.Service.VIDEO_PLUGIN_LOGS, t, "", i);
                this.analyticsRequestHandler.sendRequest(_s18);
              }
            }
          }, {
            Event: n.WillSendEvent
          });
          r.assign(A.prototype, i(9516)), r.assign(A.prototype, i(5901)), r.assign(A.prototype, i(1705)), r.assign(A.prototype, i(6083)), r.assign(A.prototype, i(6874)), A.instance = null, t.exports = A;
        },
        9516: function _(t, e, i) {
          var _i55 = i(7276),
            s = _i55.default;
          var n = i(5292),
            r = i(1516);
          var _i56 = i(6933),
            a = _i56.default,
            _i57 = i(2784),
            o = _i57.AnalyticsTag;
          var d = {
            registerAdapter: function registerAdapter(t, e, i, d) {
              if (!e) return void s.error(o, "Register Adapter needs an adapter to initialize");
              if (i = i || {}, d = d || "default", this.videos.existsVideo(d)) i = i || {}, this.videos.getVideo(d).mergeOptions(i), this.setAdapter(new n(d, this.videos.getVideo(d), this, this.adapterTemplates, t, e), d);else {
                var c = new r(d, this, this.options, null, null);
                this.getNextViewIndex(c), i = i || {}, c.setVideoOptions(i), this.videos.setVideo(c);
                var u = new n(d, c, this, this.adapterTemplates, t, e);
                this.setAdapter(u, d);
              }
              a.getInstance().registeredPlayer(!0);
              var l = i["content.resource"];
              !l && this.videos.existsAdapter(d) && (l = this.videos.getAdapter(d).getURLToParse(), l || (l = this.videos.getAdapter(d).getResource())), this.resourceTransform.init(l);
            },
            setAdapter: function setAdapter(t, e) {
              if (e = e || "default", this.browserLoadTimes && this.browserLoadTimes.setPlayerSetupTime(), t.isSetAdapter()) s.warn(o, "Adapters can only be added to a single plugin");else {
                var i = this.getAdapter(e);
                i && (t.flags = i.flags, t.chronos = i.chronos, t.fireEventsStruct = i.fireEventsStruct), this.removeAdapter(e), this.videos.setAdapter(t, e);
              }
            },
            getAdapter: function getAdapter(t) {
              return t = t || "default", this.videos.getAdapter(t);
            },
            removeAdapter: function removeAdapter(t) {
              t = t || "default", this.videos.existsVideo(t) && this.videos.removeAdapter(this.contentAdapterListeners, t);
            },
            getNextViewIndex: function getNextViewIndex(t) {
              t.nextView();
              var e = !0;
              for (; e;) {
                var _i58 = !1;
                var _iterator10 = _createForOfIteratorHelper(this.videos.getVideoKeys().filter(function (e) {
                    return e !== t.getVideoKey();
                  })),
                  _step10;
                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var _e30 = _step10.value;
                    if (t.getViewCode() === this.videos.getVideo(_e30).getViewCode()) {
                      _i58 = !0;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }
                _i58 && t.nextView(), e = _i58;
              }
            }
          };
          t.exports = d;
        },
        5901: function _(t, e, i) {
          var s = i(5292),
            n = i(1516);
          var _i59 = i(6933),
            r = _i59.default;
          var a = {
            registerAdsAdapter: function registerAdsAdapter(t, e, i, r) {
              if (e) {
                if (r = r || "default", this.videos.existsVideo(r)) this.videos.getVideo(r).mergeOptions(i), this.setAdsAdapter(new s(r, this.videos.getVideo(r), this, this.adapterTemplates, t, e), r);else {
                  var a = new n(r, this, this.options, null, null);
                  a.mergeOptions(i), this.videos.setVideo(a);
                  var o = new s(r, a, this, this.adapterTemplates, t, e);
                  this.setAdsAdapter(o, r);
                }
              } else Log.error(AnalyticsTag, "Register Ads Adapter needs an adapter to initialize");
            },
            updateAdsAdapter: function updateAdsAdapter(t, e) {
              e = e || "default", t && (videoObj = this.videos.getVideo(e), videoObj && videoObj.getAdapter() && (adsAdapter = videoObj.getAdapter().getAdapterClass(t), adsAdapter && videoObj.setAdsAdapter(adsAdapter, this, !0)));
            },
            getAdsAdapter: function getAdsAdapter(t) {
              return t = t || "default", this.videos.getVideo(t).getAdsAdapter();
            },
            setAdsAdapter: function setAdsAdapter(t, e) {
              e = e || "default", this.videos.getVideo(e).setAdsAdapter(t, this), r.getInstance().registeredAdsPlayer(!0);
            },
            removeAdsAdapter: function removeAdsAdapter(t) {
              t = t || "default", this.videos.existsVideo(t) && this.videos.getVideo(t).removeAdsAdapter();
            }
          };
          t.exports = a;
        },
        1705: function _(t, e, i) {
          var s = i(9835),
            n = i(2507),
            r = i(9637);
          var _i60 = i(9065),
            a = _i60.default,
            _i61 = i(61),
            o = _i61.default;
          var d = {
            getAccountCode: function getAccountCode() {
              return a.getInstance().getFastDataService().getAccountCode();
            },
            getUsername: function getUsername(t) {
              return this._getGenericOptionsValue("user.name", t);
            },
            getPluginVersion: function getPluginVersion() {
              return a.getPluginVersion();
            },
            getRequestNumber: function getRequestNumber() {
              return Math.random();
            },
            getUserType: function getUserType(t) {
              return this._getGenericOptionsValue("user.type", t);
            },
            getAnonymousUser: function getAnonymousUser(t) {
              return this._getGenericOptionsValue("user.anonymousId", t);
            },
            getReferer: function getReferer() {
              var t = this.options.referer || "";
              return !t && "undefined" != typeof window && window.location && (t = window.location.href), t;
            },
            getReferral: function getReferral() {
              var t = this.options.referral || "";
              return t || "undefined" == typeof document || (t = document.referrer), t;
            },
            getLanguage: function getLanguage() {
              var t;
              return "undefined" != typeof navigator && (t = navigator.language), t;
            },
            getScreenResolution: function getScreenResolution() {
              var t;
              try {
                if (window && window.screen) {
                  var _e31 = window.devicePixelRatio || 1;
                  t = window.screen.width * _e31 + "x" + window.screen.height * _e31;
                }
              } catch (t) {}
              return t;
            },
            getDeviceInfo: function getDeviceInfo(t) {
              var e = {};
              return this.getDeviceCode(t) && (e.deviceCode = this.getDeviceCode(t)), this.getModel(t) && (e.model = this.getModel(t)), this.getBrand(t) && (e.brand = this.getBrand(t)), this.getDeviceType(t) && (e.deviceType = this.getDeviceType(t)), this.getDeviceName(t) && (e.deviceName = this.getDeviceName(t)), this.getOsName(t) && (e.osName = this.getOsName(t)), this.getOsVersion(t) && (e.osVersion = this.getOsVersion(t)), this.getBrowserName(t) && (e.browserName = this.getBrowserName(t)), this.getBrowserVersion(t) && (e.browserVersion = this.getBrowserVersion(t)), this.getBrowserType(t) && (e.browserType = this.getBrowserType(t)), this.getBrowserEngine(t) && (e.browserEngine = this.getBrowserEngine(t)), e !== {} ? e : void 0;
            },
            getDeviceCode: function getDeviceCode(t) {
              return this._getGenericOptionsValue("device.code", t);
            },
            getModel: function getModel(t) {
              return this._getGenericOptionsValue("device.model", t);
            },
            getBrand: function getBrand(t) {
              return this._getGenericOptionsValue("device.brand", t);
            },
            getDeviceType: function getDeviceType(t) {
              return this._getGenericOptionsValue("device.type", t);
            },
            getDeviceName: function getDeviceName(t) {
              return this._getGenericOptionsValue("device.name", t);
            },
            getOsName: function getOsName(t) {
              return this._getGenericOptionsValue("device.osName", t);
            },
            getOsVersion: function getOsVersion(t) {
              return this._getGenericOptionsValue("device.osVersion", t);
            },
            getBrowserName: function getBrowserName(t) {
              return this._getGenericOptionsValue("device.browserName", t);
            },
            getBrowserVersion: function getBrowserVersion(t) {
              return this._getGenericOptionsValue("device.browserVersion", t);
            },
            getBrowserType: function getBrowserType(t) {
              return this._getGenericOptionsValue("device.browserType", t);
            },
            getBrowserEngine: function getBrowserEngine(t) {
              return this._getGenericOptionsValue("device.browserEngine", t);
            },
            getIsBlocked: function getIsBlocked(t) {
              return this._getGenericOptionsValue("ad.blockerDetected", t);
            },
            isMethodPostEnabled: function isMethodPostEnabled() {
              return this.options.method && this.options.method.toUpperCase() === r.POST;
            },
            getDeviceUUID: function getDeviceUUID(t) {
              var e;
              return !t["device.isAnonymous"] && t["device.id"] ? t["device.id"] : (this.options["device.isAnonymous"] || (e = this.options["device.id"] || this.uuidGenerator.getKey()), e);
            },
            getLibVersion: function getLibVersion() {
              return s;
            },
            getAppName: function getAppName(t) {
              return this._getGenericOptionsValue("app.name", t);
            },
            getAppReleaseVersion: function getAppReleaseVersion(t) {
              return this._getGenericOptionsValue("app.releaseVersion", t);
            },
            getIp: function getIp(t) {
              return this._getGenericOptionsValue("network.ip", t);
            },
            getIsp: function getIsp(t) {
              return this._getGenericOptionsValue("network.isp", t);
            },
            getConnectionType: function getConnectionType(t) {
              return this._getGenericOptionsValue("network.connectionType", t);
            },
            getEDID: function getEDID(t) {
              var e = this._getGenericOptionsValue("device.EDID", t);
              return e ? e.toString() : void 0;
            },
            getObfuscateIp: function getObfuscateIp(t) {
              return this._getGenericOptionsValue("user.obfuscateIp", t);
            },
            getPrivacyProtocol: function getPrivacyProtocol(t) {
              var e = this._getGenericOptionsValue("user.privacyProtocol", t);
              return "string" == typeof e && (e = e.toLowerCase()), "optin" === e || "optout" === e ? e : void 0;
            },
            getCustomDimensions: function getCustomDimensions(t) {
              var e = this._getGenericOptionsValue("content.customDimensions", t);
              return "object" == typeof e ? e : void 0;
            },
            getExtraparam1: function getExtraparam1(t) {
              return this._getGenericOptionsValue("content.customDimension.1", t);
            },
            getExtraparam2: function getExtraparam2(t) {
              return this._getGenericOptionsValue("content.customDimension.2", t);
            },
            getExtraparam3: function getExtraparam3(t) {
              return this._getGenericOptionsValue("content.customDimension.3", t);
            },
            getExtraparam4: function getExtraparam4(t) {
              return this._getGenericOptionsValue("content.customDimension.4", t);
            },
            getExtraparam5: function getExtraparam5(t) {
              return this._getGenericOptionsValue("content.customDimension.5", t);
            },
            getExtraparam6: function getExtraparam6(t) {
              return this._getGenericOptionsValue("content.customDimension.6", t);
            },
            getExtraparam7: function getExtraparam7(t) {
              return this._getGenericOptionsValue("content.customDimension.7", t);
            },
            getExtraparam8: function getExtraparam8(t) {
              return this._getGenericOptionsValue("content.customDimension.8", t);
            },
            getExtraparam9: function getExtraparam9(t) {
              return this._getGenericOptionsValue("content.customDimension.9", t);
            },
            getExtraparam10: function getExtraparam10(t) {
              return this._getGenericOptionsValue("content.customDimension.10", t);
            },
            getExtraparam11: function getExtraparam11(t) {
              return this._getGenericOptionsValue("content.customDimension.11", t);
            },
            getExtraparam12: function getExtraparam12(t) {
              return this._getGenericOptionsValue("content.customDimension.12", t);
            },
            getExtraparam13: function getExtraparam13(t) {
              return this._getGenericOptionsValue("content.customDimension.13", t);
            },
            getExtraparam14: function getExtraparam14(t) {
              return this._getGenericOptionsValue("content.customDimension.14", t);
            },
            getExtraparam15: function getExtraparam15(t) {
              return this._getGenericOptionsValue("content.customDimension.15", t);
            },
            getExtraparam16: function getExtraparam16(t) {
              return this._getGenericOptionsValue("content.customDimension.16", t);
            },
            getExtraparam17: function getExtraparam17(t) {
              return this._getGenericOptionsValue("content.customDimension.17", t);
            },
            getExtraparam18: function getExtraparam18(t) {
              return this._getGenericOptionsValue("content.customDimension.18", t);
            },
            getExtraparam19: function getExtraparam19(t) {
              return this._getGenericOptionsValue("content.customDimension.19", t);
            },
            getExtraparam20: function getExtraparam20(t) {
              return this._getGenericOptionsValue("content.customDimension.20", t);
            },
            isParseManifest: function isParseManifest(t) {
              return this._getGenericOptionsValue("parse.manifest", t);
            },
            isParseCdnNode: function isParseCdnNode(t) {
              return this._getGenericOptionsValue("parse.cdnNode", t);
            },
            isCdnSwitch: function isCdnSwitch(t) {
              return this._getGenericOptionsValue("parse.cdnSwitchHeader", t);
            },
            getParseCdnNodeList: function getParseCdnNodeList(t) {
              return this._getGenericOptionsValue("parse.cdnNode.list", t);
            },
            getParseCdnNodeNameHeader: function getParseCdnNodeNameHeader(t) {
              return this._getGenericOptionsValue("parse.cdnNameHeader", t);
            },
            getParseNodeHeader: function getParseNodeHeader(t) {
              return this._getGenericOptionsValue("parse.cdnNodeHeader", t);
            },
            canOverwriteAdapters: function canOverwriteAdapters(t) {
              return n.parseBoolean(this._getGenericOptionsValue("adapters.overwrite", t));
            },
            getAdaptersProperties: function getAdaptersProperties(t) {
              return this._getGenericOptionsValue("adapters.properties", t);
            },
            getNetworkConnectionType: function getNetworkConnectionType() {
              if (!this.options.enableExtraMetricCollection || !navigator || !navigator.connection) return;
              var t = navigator.connection.type;
              return ["wimax"].includes(t) ? void 0 : t;
            },
            getNetworkCellType: function getNetworkCellType() {
              if (this.options.enableExtraMetricCollection && navigator && navigator.connection) return this.getNetworkConnectionType() && "wifi" !== this.getNetworkConnectionType() ? navigator.connection.effectiveType : "none";
            },
            getNetworkSignalStrength: function getNetworkSignalStrength() {},
            getCpuUsed: function getCpuUsed() {},
            getMemoryUsed: function getMemoryUsed() {
              if (this.options.enableExtraMetricCollection && performance && performance.memory) return performance.memory.usedJSHeapSize / 1024 / 1024;
            },
            getCacheStorageUsed: function getCacheStorageUsed() {
              if (!this.options.enableExtraMetricCollection) return;
              var t = 0;
              if ("undefined" != typeof localStorage && localStorage) for (var _e32 in localStorage) localStorage.hasOwnProperty(_e32) && (t += 2 * (localStorage[_e32].length + _e32.length));
              if ("undefined" != typeof sessionStorage && sessionStorage) for (var _e33 in sessionStorage) sessionStorage.hasOwnProperty(_e33) && (t += 2 * (sessionStorage[_e33].length + _e33.length));
              return 0 != t ? t : void 0;
            },
            getTransferredTraffic: function getTransferredTraffic() {
              if (this.options.enableExtraMetricCollection) return a.getInstance().getCommonVariable(o.Products.BALANCER, o.BalancerVariables.BALANCER_TRAFFIC);
            },
            getImprovedBandwidth: function getImprovedBandwidth() {
              if (this.options.enableExtraMetricCollection) return a.getInstance().getCommonVariable(o.Products.BALANCER, o.BalancerVariables.BALANCER_BITRATE);
            },
            isAppAnalyticsAutoBegin: function isAppAnalyticsAutoBegin(t) {
              return n.parseBoolean(this._getGenericOptionsValue("check.appAnalytics.autoBegin", t));
            },
            isAppAnalyticsEnabled: function isAppAnalyticsEnabled(t) {
              return n.parseBoolean(this._getGenericOptionsValue("check.appAnalytics.enabled", t));
            },
            isVideoAnalyticsEnabled: function isVideoAnalyticsEnabled(t) {
              return n.parseBoolean(this._getGenericOptionsValue("check.videoAnalytics.enabled", t));
            },
            isRefreshLMAConfigurationEnabled: function isRefreshLMAConfigurationEnabled(t) {
              return n.parseBoolean(this._getGenericOptionsValue("lma.refresh.configuration.enabled", t));
            },
            isPluginLogsEnabled: function isPluginLogsEnabled(t) {
              return n.parseBoolean(this._getGenericOptionsValue("debug.pluginLogs.enabled", t));
            },
            isPlayerLogsEnabled: function isPlayerLogsEnabled(t) {
              return n.parseBoolean(this._getGenericOptionsValue("debug.playerLogs.enabled", t));
            },
            refreshLMAConfigurationSeconds: function refreshLMAConfigurationSeconds(t) {
              return this._getGenericOptionsValue("lma.refresh.configuration.seconds", t);
            },
            getPlayheadMonitorEnabled: function getPlayheadMonitorEnabled(t) {
              return this._getGenericOptionsValue("playhead.monitor", t);
            },
            getReadyStateMonitorEnabled: function getReadyStateMonitorEnabled(t) {
              return this._getGenericOptionsValue("readyState.monitor", t);
            },
            getPageName: function getPageName() {
              return this.options["content.title"];
            },
            _getGenericOptionsValue: function _getGenericOptionsValue(t, e) {
              return e && e[t] ? e[t] : this.options[t];
            }
          };
          t.exports = d;
        },
        6083: function _(t) {
          t.exports = {
            fireInit: function fireInit(t, e, i) {
              i = i || "default", this.videos.getVideo(i).fireInit(t, e);
            },
            fireError: function fireError(t, e, i, s, n, r) {
              r = r || "default", this.videos.getVideo(r).fireError(t, e, i, s, n);
            },
            fireFatalError: function fireFatalError(t, e, i, s, n, r) {
              r = r || "default", this.videos.getVideo(r).fireFatalError(t, e, i, s, n);
            },
            fireStop: function fireStop(t, e, i) {
              i = i || "default", this.videos.getVideo(i).fireStop(t, e);
            },
            fireOfflineEvents: function fireOfflineEvents(t, e) {
              e = e || "default", this.videos.getVideo(e).fireOfflineEvents(t);
            }
          };
        },
        6874: function _(t, e, i) {
          var s = i(2507);
          var _i62 = i(9065),
            n = _i62.default;
          var r = {
            getFastDataConfig: function getFastDataConfig() {
              return this.fastDataTransform.response.msg;
            },
            getHost: function getHost() {
              var t = n.getInstance().getOptions().getFastDataHost();
              return this.fastDataTransform && this.fastDataTransform.response && this.fastDataTransform.response.host && (t = this.fastDataTransform.response.host), s.addProtocol(s.stripProtocol(t), this.options["app.https"]);
            },
            getFastDataHost: function getFastDataHost() {
              return s.addProtocol(s.stripProtocol(n.getInstance().getOptions().getFastDataHost()), this.options["app.https"]);
            },
            getSession: function getSession() {
              var t = n.getInstance().getCoreStorage().getStorages("session");
              if ("undefined" === t && (t = void 0), !t) {
                var e = this.getStoredData();
                if (e) try {
                  t = JSON.parse(e).q.c;
                } catch (t) {}
              }
              return t;
            },
            getStorageHost: function getStorageHost() {
              var t = null;
              var e = this.getStoredData();
              if (e) try {
                t = JSON.parse(e).q.h;
              } catch (t) {}
              return t ? s.addProtocol(t, this.options["app.https"]) : t;
            },
            getStoredData: function getStoredData() {
              return n.getInstance().getCoreStorage().getStorages("data");
            },
            getDataTime: function getDataTime() {
              return n.getInstance().getCoreStorage().getStorages("dataTime");
            },
            setStoredData: function setStoredData(t) {
              this.storage.setStorages("data", t);
            },
            setSession: function setSession(t) {
              this.storage.setStorages("session", t);
            },
            setDataTime: function setDataTime(t) {
              this.storage.setStorages("dataTime", t);
            }
          };
          t.exports = r;
        },
        2071: function _(t, e, i) {
          var s = i(3948);
          var _i63 = i(7276),
            n = _i63.default,
            _i64 = i(2784),
            r = _i64.AnalyticsTag;
          var a = ["accountCode", "username", "anonymousUser", "rendition", "deviceInfo", "player", "title", "title2", "live", "segmentDuration", "mediaDuration", "mediaResource", "parsedResource", "transactionCode", "properties", "cdn", "profile", "bucket", "playerVersion", "param1", "param2", "param3", "param4", "param5", "param6", "param7", "param8", "param9", "param10", "param11", "param12", "param13", "param14", "param15", "param16", "param17", "param18", "param19", "param20", "dimensions", "playerStartupTime", "obfuscateIp", "privacyProtocol", "p2pEnabled", "pluginVersion", "pluginInfo", "isp", "connectionType", "ip", "referer", "userType", "streamingProtocol", "transportFormat", "householdId", "adsBlocked", "adsExpected", "deviceUUID", "smartswitchConfigCode", "smartswitchGroupCode", "smartswitchContractCode", "libVersion", "nodeHost", "nodeType", "appName", "appReleaseVersion", "package", "saga", "tvshow", "season", "titleEpisode", "channel", "imdbID", "gracenoteID", "contentType", "genre", "contentLanguage", "subtitles", "cost", "price", "playbackType", "email", "drm", "videoCodec", "audioCodec", "codecSettings", "codecProfile", "containerFormat", "contentId", "contractedResolution", "linkedViewId", "edid", "cdnBalancerResponseUUID", "accur_geo_location", "network_type", "network_cell_type", "network_signal_strengh", "cpu_used", "mem_used", "cache_used"],
            o = ["player", "playhead", "adTitle", "position", "adDuration", "adCampaign", "adCreativeId", "adProvider", "adResource", "adPlayerVersion", "adProperties", "adAdapterVersion", "adInsertionType", "extraparam1", "extraparam2", "extraparam3", "extraparam4", "extraparam5", "extraparam6", "extraparam7", "extraparam8", "extraparam9", "extraparam10", "fullscreen", "audio", "skippable", "adNumber", "adNumberInBreak", "breakNumber"],
            d = s.extend({
              constructor: function constructor() {
                this.lastSent = {};
              },
              fetchParams: function fetchParams(t, e, i, s, a) {
                t = t || {}, e = e || [];
                for (var _o5 = 0; _o5 < e.length; _o5++) {
                  var c = e[_o5];
                  if (t[c]) continue;
                  var u = d.getters[c];
                  var l = !1;
                  for (var _e34 in s) if (s[_e34] && s[_e34][u]) {
                    var _n14 = s[_e34][u](a);
                    void 0 === _n14 || i && this.lastSent[c] === _n14 || (t[c] = _n14, this.lastSent[c] = _n14), l = !0;
                    break;
                  }
                  l || n.warn(r, "Trying to call undefined getter " + c + ":" + u);
                }
                return t;
              },
              getGetters: function getGetters() {
                return d.getters;
              },
              getRequiredMetadataParams: function getRequiredMetadataParams() {
                return ["live", "rendition"];
              },
              buildBody: function buildBody(t, e) {
                return this.fetchParams(void 0, d.bodyParams[t], !1, e);
              },
              buildParams: function buildParams(t, e, i, s) {
                return t = t || {}, this.fetchParams(t, d.params[e], !1, i, s), this.fetchParams(t, d.differentParams[e], !0, i, s), t;
              },
              getChangedEntities: function getChangedEntities(t) {
                return this.fetchParams({}, d.differentParams.entities, !0, t);
              }
            }, {
              params: {
                "/data": ["system", "pluginVersion", "requestNumber", "username"],
                "/adapters": ["system", "pluginVersion", "requestNumber"],
                "/configuration": ["system", "pluginVersion", "requestNumber", "appName", "appReleaseVersion"],
                "/infinity/session/pluginLogs": ["logAction", "logType"],
                "/infinity/video/pluginLogs": ["logAction", "logType"],
                "/init": a,
                "/start": a,
                "/joinTime": ["joinDuration", "playhead", "bitrate"],
                "/pause": ["playhead", "accountCode", "pluginVersion"],
                "/resume": ["pauseDuration", "playhead", "accountCode", "pluginVersion"],
                "/seek": ["seekDuration", "playhead", "accountCode", "pluginVersion"],
                "/bufferUnderrun": ["bufferDuration", "playhead", "accountCode", "pluginVersion"],
                "/error": ["player", "playhead"].concat(a),
                "/stop": ["accur_geo_location", "bitrate", "totalBytes", "playhead", "pauseDuration", "metrics", "cdnDownloadedTraffic", "multiCdnInfo", "p2pDownloadedTraffic", "uploadTraffic", "profile", "bucket", "accountCode", "pluginVersion"],
                "/infinity/video/event": [],
                "/adInit": o,
                "/adStart": o,
                "/adJoin": ["playhead", "position", "adJoinDuration", "adPlayhead", "adNumber", "adNumberInBreak", "breakNumber"],
                "/adPause": ["playhead", "position", "adPlayhead", "adNumber", "adNumberInBreak", "breakNumber"],
                "/adResume": ["playhead", "position", "adPlayhead", "adPauseDuration", "adNumber", "adNumberInBreak", "breakNumber"],
                "/adBufferUnderrun": ["playhead", "position", "adPlayhead", "adBufferDuration", "adNumber", "adNumberInBreak", "breakNumber"],
                "/adStop": ["playhead", "position", "adPlayhead", "adTotalDuration", "adViewedDuration", "adViewability", "adNumber", "adNumberInBreak", "breakNumber"],
                "/adClick": ["playhead", "position", "adPlayhead", "adNumber", "adNumberInBreak", "breakNumber"],
                "/adError": ["adPlayhead"].concat(o),
                "/adManifest": ["givenBreaks", "expectedBreaks", "expectedPattern", "breaksTime"],
                "/adBreakStart": ["position", "givenAds", "expectedAds", "breakNumber", "adInsertionType"],
                "/adBreakStop": ["position", "breakNumber"],
                "/adQuartile": ["position", "adViewedDuration", "adViewability", "adNumber", "adNumberInBreak", "breakNumber"],
                "/ping": ["real_traffic", "improved_bandwidth_estimation", "network_type", "network_cell_type", "network_signal_strengh", "cpu_used", "mem_used", "cache_used", "accountCode", "pluginVersion", "droppedFrames", "playrate", "cdnDownloadedTraffic", "multiCdnInfo", "p2pDownloadedTraffic", "uploadTraffic", "latency", "packetLoss", "packetSent", "metrics", "totalBytes", "segmentDuration"],
                "/infinity/session/start": ["accountCode", "username", "userType", "anonymousUser", "route", "page", "referer", "referral", "screenResolution", "language", "deviceInfo", "adsBlocked", "deviceUUID", "libVersion", "appName", "appReleaseVersion", "isp", "connectionType", "ip", "obfuscateIp", "privacyProtocol", "dimensions", "param1", "param2", "param3", "param4", "param5", "param6", "param7", "param8", "param9", "param10", "param11", "param12", "param13", "param14", "param15", "param16", "param17", "param18", "param19", "param20", "edid"],
                "/infinity/session/stop": ["sessionMetrics"],
                "/infinity/session/nav": ["route", "page", "scrollDepth"],
                "/infinity/session/beat": ["sessionMetrics"],
                "/infinity/session/event": ["accountCode"],
                "/offlineEvents": {}
              },
              bodyParams: {
                "/offlineEvents": ["viewJson"]
              },
              differentParams: {
                entities: ["pluginInfo", "rendition", "title", "title2", "param1", "param2", "param3", "param4", "param5", "param6", "param7", "param8", "param9", "param10", "param11", "param12", "param13", "param14", "param15", "param16", "param17", "param18", "param19", "param20", "cdn", "nodeHost", "nodeType", "nodeTypeString", "subtitles", "contentLanguage", "contentId", "accur_geo_location"]
              },
              getters: {
                requestNumber: "getRequestNumber",
                playhead: "getPlayhead",
                playrate: "getPlayrate",
                fps: "getFramesPerSecond",
                segmentDuration: "getSegmentDuration",
                droppedFrames: "getDroppedFrames",
                mediaDuration: "getDuration",
                bitrate: "getBitrate",
                totalBytes: "getTotalBytes",
                throughput: "getThroughput",
                rendition: "getRendition",
                title: "getTitle",
                title2: "getTitle2",
                live: "getIsLive",
                mediaResource: "getResource",
                parsedResource: "getParsedResource",
                transactionCode: "getTransactionCode",
                properties: "getMetadata",
                playerVersion: "getPlayerVersion",
                player: "getPlayerName",
                cdn: "getCdn",
                profile: "getProfileName",
                bucket: "getBucketName",
                pluginVersion: "getPluginVersion",
                libVersion: "getLibVersion",
                userType: "getUserType",
                streamingProtocol: "getStreamingProtocol",
                transportFormat: "getTransportFormat",
                obfuscateIp: "getObfuscateIp",
                privacyProtocol: "getPrivacyProtocol",
                householdId: "getHouseholdId",
                latency: "getLatency",
                packetLoss: "getPacketLoss",
                packetSent: "getPacketSent",
                metrics: "getVideoMetrics",
                dimensions: "getCustomDimensions",
                accur_geo_location: "getAccurateGeoLocation",
                network_type: "getNetworkConnectionType",
                network_cell_type: "getNetworkCellType",
                network_signal_strengh: "getNetworkSignalStrength",
                cpu_used: "getCpuUsed",
                mem_used: "getMemoryUsed",
                cache_used: "getCacheStorageUsed",
                real_traffic: "getTransferredTraffic",
                improved_bandwidth_estimation: "getImprovedBandwidth",
                param1: "getExtraparam1",
                param2: "getExtraparam2",
                param3: "getExtraparam3",
                param4: "getExtraparam4",
                param5: "getExtraparam5",
                param6: "getExtraparam6",
                param7: "getExtraparam7",
                param8: "getExtraparam8",
                param9: "getExtraparam9",
                param10: "getExtraparam10",
                param11: "getExtraparam11",
                param12: "getExtraparam12",
                param13: "getExtraparam13",
                param14: "getExtraparam14",
                param15: "getExtraparam15",
                param16: "getExtraparam16",
                param17: "getExtraparam17",
                param18: "getExtraparam18",
                param19: "getExtraparam19",
                param20: "getExtraparam20",
                extraparam1: "getAdExtraparam1",
                extraparam2: "getAdExtraparam2",
                extraparam3: "getAdExtraparam3",
                extraparam4: "getAdExtraparam4",
                extraparam5: "getAdExtraparam5",
                extraparam6: "getAdExtraparam6",
                extraparam7: "getAdExtraparam7",
                extraparam8: "getAdExtraparam8",
                extraparam9: "getAdExtraparam9",
                extraparam10: "getAdExtraparam10",
                position: "getAdPosition",
                adNumber: "getAdNumber",
                adNumberInBreak: "getAdNumberInBreak",
                breakNumber: "getBreakNumber",
                adPlayhead: "getAdPlayhead",
                adDuration: "getAdDuration",
                adCampaign: "getAdCampaign",
                adCreativeId: "getAdCreativeId",
                adBitrate: "getAdBitrate",
                adTitle: "getAdTitle",
                adResource: "getAdResource",
                adPlayerVersion: "getAdPlayerVersion",
                adProperties: "getAdMetadata",
                adAdapterVersion: "getAdAdapterVersion",
                givenBreaks: "getGivenBreaks",
                expectedBreaks: "getExpectedBreaks",
                expectedPattern: "getExpectedPattern",
                breaksTime: "getBreaksTime",
                givenAds: "getGivenAds",
                expectedAds: "getExpectedAds",
                adsExpected: "getAdsExpected",
                adViewedDuration: "getAdViewedDuration",
                adViewability: "getAdViewability",
                fullscreen: "getIsFullscreen",
                audio: "getAudioEnabled",
                skippable: "getIsSkippable",
                adProvider: "getAdProvider",
                adInsertionType: "getAdInsertionType",
                pluginInfo: "getPluginInfo",
                isp: "getIsp",
                connectionType: "getConnectionType",
                ip: "getIp",
                deviceInfo: "getDeviceInfo",
                edid: "getEDID",
                system: "getAccountCode",
                accountCode: "getAccountCode",
                username: "getUsername",
                anonymousUser: "getAnonymousUser",
                joinDuration: "getJoinDuration",
                bufferDuration: "getBufferDuration",
                seekDuration: "getSeekDuration",
                pauseDuration: "getPauseDuration",
                adJoinDuration: "getAdJoinDuration",
                adBufferDuration: "getAdBufferDuration",
                adPauseDuration: "getAdPauseDuration",
                adTotalDuration: "getAdTotalDuration",
                referer: "getReferer",
                referral: "getReferral",
                language: "getLanguage",
                screenResolution: "getScreenResolution",
                nodeHost: "getNodeHost",
                nodeType: "getNodeType",
                nodeTypeString: "getNodeTypeString",
                route: "getReferer",
                page: "getPageName",
                playerStartupTime: "getPlayerStartupTime",
                pageLoadTime: "getPageLoadTime",
                cdnDownloadedTraffic: "getCdnTraffic",
                multiCdnInfo: "getMultiCdnInfo",
                p2pDownloadedTraffic: "getP2PTraffic",
                p2pEnabled: "getIsP2PEnabled",
                uploadTraffic: "getUploadTraffic",
                cdnBalancerResponseUUID: "getBalancerResponseId",
                viewJson: "getOfflineView",
                deviceUUID: "getDeviceUUID",
                sessionMetrics: "getSessionMetrics",
                scrollDepth: "getScrollDepth",
                adsBlocked: "getIsBlocked",
                linkedViewId: "getLinkedViewId",
                smartswitchConfigCode: "getSmartswitchConfigCode",
                smartswitchGroupCode: "getSmartswitchGroupCode",
                smartswitchContractCode: "getSmartswitchContractCode",
                appName: "getAppName",
                appReleaseVersion: "getAppReleaseVersion",
                package: "getPackage",
                saga: "getSaga",
                tvshow: "getTvShow",
                season: "getSeason",
                titleEpisode: "getEpisodeTitle",
                channel: "getChannel",
                drm: "getDRM",
                videoCodec: "getVideoCodec",
                audioCodec: "getAudioCodec",
                codecSettings: "getCodecSettings",
                codecProfile: "getCodecProfile",
                containerFormat: "getContainerFormat",
                contentId: "getID",
                imdbID: "getImdbId",
                gracenoteID: "getGracenoteID",
                contentType: "getType",
                genre: "getGenre",
                contentLanguage: "getVideoLanguage",
                subtitles: "getSubtitles",
                contractedResolution: "getContractedResolution",
                cost: "getCost",
                price: "getPrice",
                playbackType: "getPlaybackType",
                email: "getEmail"
              }
            });
          t.exports = d;
        },
        470: function _(t, e, i) {
          var s = i(3948);
          var _i65 = i(7276),
            n = _i65.default,
            _i66 = i(2784),
            r = _i66.AnalyticsTag;
          var a = s.extend({
            constructor: function constructor(t, e, i, s) {
              this.prefix = t || "npaw", this.disableCookies = e, this.forceCookies = i, this.disabled = s;
            },
            updateStorageOptions: function updateStorageOptions(t, e, i) {
              this.disableCookies = t, this.forceCookies = e, this.disabled = i;
            },
            isEnabled: function isEnabled() {
              if (this.disabled) return !1;
              var t = !0;
              if (!this.forceCookies) try {
                localStorage.setItem(this.prefix + ".test", "true"), localStorage.removeItem(this.prefix + ".test");
              } catch (e) {
                t = !1;
              }
              return t;
            },
            setLocal: function setLocal(t, e) {
              if (this.disabled) return null;
              var i = null;
              try {
                !this.forceCookies && ("undefined" != typeof localStorage && localStorage || this.disableCookies) ? "undefined" != typeof localStorage && localStorage && (i = localStorage.setItem(this.prefix + "." + t, e)) : i = this._setCookie(this.prefix + ".local." + t, e);
              } catch (t) {
                n.error(r, "Npaw App Analytics needs localStorage or cookies, not supported by your browser.");
              }
              return i;
            },
            getLocal: function getLocal(t) {
              return this.disabled ? null : this._localGetRemove("getItem", "_getCookie", t);
            },
            removeLocal: function removeLocal(t) {
              return this.disabled ? null : this._localGetRemove("removeItem", "_removeCookie", t);
            },
            _localGetRemove: function _localGetRemove(t, e, i) {
              var s = null;
              try {
                !this.forceCookies && ("undefined" != typeof localStorage && localStorage || this.disableCookies) ? "undefined" != typeof localStorage && localStorage && (s = localStorage[t](this.prefix + "." + i)) : s = this[e](this.prefix + ".local." + i);
              } catch (t) {
                n.error(r, "Npaw App Analytics needs localStorage or cookies, not supported by your browser.");
              }
              return s;
            },
            setSession: function setSession(t, e) {
              if (this.disabled) return null;
              var i = null;
              try {
                i = !this.forceCookies && ("undefined" != typeof sessionStorage && sessionStorage || this.disableCookies) ? sessionStorage.setItem(this.prefix + "." + t, e) : this._setCookie(this.prefix + ".session." + t, e);
              } catch (t) {
                n.error(r, "Npaw App Analytics needs sessionStorage or cookies, not supported by your browser.");
              }
              return i;
            },
            getSession: function getSession(t) {
              return this.disabled ? null : this._sessionGetRemove("getItem", "_getCookie", t);
            },
            removeSession: function removeSession(t) {
              return this.disabled ? null : this._sessionGetRemove("removeItem", "_removeCookie", t);
            },
            _sessionGetRemove: function _sessionGetRemove(t, e, i) {
              var s = null;
              try {
                s = !this.forceCookies && ("undefined" != typeof sessionStorage && sessionStorage || this.disableCookies) ? sessionStorage[t](this.prefix + "." + i) : this[e](this.prefix + ".session." + i);
              } catch (t) {
                n.error(r, "Npaw App Analytics needs sessionStorage or cookies, not supported by your browser.");
              }
              return s;
            },
            getStorages: function getStorages(t) {
              return this.disabled ? null : this.getSession(t) || this.getLocal(t);
            },
            setStorages: function setStorages(t, e) {
              if (this.disabled) return null;
              this.setSession(t, e), this.setLocal(t, e);
            },
            removeStorages: function removeStorages(t) {
              if (this.disabled) return null;
              this.removeSession(t), this.removeLocal(t);
            },
            _setCookie: function _setCookie(t, e) {
              if ("undefined" != typeof document) {
                var i = ";";
                "undefined" != typeof location && (i += "domain=" + location.host.split(".").reverse().splice(0, 2).reverse().join(".") + ";path=/;"), document.cookie = t + "=" + e + i;
              }
            },
            _getCookie: function _getCookie(t) {
              if ("undefined" != typeof document) for (var e = t + "=", i = decodeURIComponent(document.cookie).split(";"), s = 0; s < i.length; s++) {
                for (var n = i[s]; " " === n.charAt(0);) n = n.substring(1);
                if (0 === n.indexOf(e)) return n.substring(e.length, n.length);
              }
              return null;
            },
            _removeCookie: function _removeCookie(t) {
              this._setCookie(t, "");
            }
          });
          t.exports = a;
        },
        4607: function _(t) {
          t.exports = function () {
            Function.prototype.bind = Function.prototype.bind || function (t) {
              var e = Array.prototype.slice,
                i = this,
                s = e.call(arguments, 1);
              function n() {
                var n = i.prototype && this instanceof i;
                return i.apply(!n && t || this, s.concat(e.call(arguments)));
              }
              return n.prototype = i.prototype, n;
            }, Array.prototype.forEach = Array.prototype.forEach || function (t, e) {
              if ("function" != typeof t) throw new TypeError(t + " is not a function!");
              for (var i = this.length, s = 0; s < i; s++) t.call(e, this[s], s, this);
            }, Math.trunc = Math.trunc || function (t) {
              return isNaN(t) ? NaN : t > 0 ? Math.floor(t) : Math.ceil(t);
            };
          };
        },
        4954: function _(t, e, i) {
          var s = i(3948),
            n = i(7680),
            r = s.extend({
              constructor: function constructor(t, e) {
                this.callback = t, this.interval = e || 5e3, this.isRunning = !1, this._timer = null, this.chrono = new n();
              },
              start: function start() {
                this.isRunning || (this.isRunning = !0, this._setTick());
              },
              stop: function stop() {
                if (this.isRunning = !1, this._timer) try {
                  clearTimeout(this._timer), this._timer = null;
                } catch (t) {
                  "undefined" != typeof atv && (atv.clearTimeout(this._timer), this._timer = null);
                }
              },
              _setTick: function _setTick() {
                if (this.isRunning) {
                  this.chrono.start();
                  try {
                    this._timer = setTimeout(function () {
                      this.callback(this.chrono.stop()), this._setTick();
                    }.bind(this), this.interval);
                  } catch (t) {
                    "undefined" != typeof atv && (this._timer = atv.setTimeout(function () {
                      this.callback(this.chrono.stop()), this._setTick();
                    }.bind(this), this.interval));
                  }
                }
              }
            });
          t.exports = r;
        },
        2507: function _(t, e, i) {
          var _i67 = i(7276),
            s = _i67.default,
            n = _i67.LogLevel,
            _i68 = i(2784),
            r = _i68.AnalyticsTag;
          var a = {
            stripProtocol: function stripProtocol(t) {
              var e = t;
              try {
                e = t.replace(/^(.*?:\/\/|\/\/)/i, "");
              } catch (t) {
                s.warn(r, t);
              }
              return e;
            },
            parseBoolean: function parseBoolean(t) {
              return "string" == typeof t || t instanceof String ? "true" === t.toLowerCase() : !!t;
            },
            elementIsInPage: function elementIsInPage(t) {
              try {
                return t !== document.body && document.body.contains(t);
              } catch (t) {
                s.warn(r, t);
              }
              return !0;
            },
            addProtocol: function addProtocol(t, e) {
              var i = "http://localhost/";
              try {
                i = "http://" + t, e || "undefined" != typeof window && 0 === window.location.protocol.indexOf("https") ? i = "https://" + t : "undefined" != typeof window && 0 === window.location.protocol.indexOf("http") && (i = "//" + t);
              } catch (t) {
                s.warn(r, t);
              }
              return i;
            },
            parseNumber: function parseNumber(t, e) {
              return !isNaN(t) && t >= 0 && t !== 1 / 0 && t !== -1 / 0 && null != t ? t : e;
            },
            logAllEvents: function logAllEvents(t, e, i) {
              try {
                if (s.logLevel <= n.DEBUG) {
                  i = i || function (t) {
                    s.debug(r, "Event: " + t.type);
                  };
                  var a = ["canplay", "buffering", "waiting", "ended", "play", "playing", "pause", "resume", "error", "abort", "seek", "seeking", "seeked", "stalled", "dispose", "loadeddata", "loadstart"];
                  e && (null === e[0] ? (e.shift(), a = e) : a = a.concat(e));
                  for (var o = 0; o < a.length; o++) "function" == typeof t ? t.call(window, a[o], i) : t.on ? t.on(a[o], i) : t.addEventListener && t.addEventListener(a[o], i);
                }
              } catch (t) {
                s.error(r, t);
              }
            },
            buildRenditionString: function buildRenditionString(t, e, i) {
              1 === arguments.length && (i = t, t = null, e = null);
              var s = null;
              return t && e && (s = t + "x" + e), "number" == typeof i && !isNaN(i) && i >= 1 && (s ? s += "@" : s = "", s += i < 1e3 ? Math.round(i) + "bps" : i < 1e6 ? (i = Math.round(i / 1e3)) + "Kbps" : (i = Math.round(i / 1e4) / 100) + "Mbps"), s;
            },
            buildErrorParams: function buildErrorParams(t, e, i) {
              var s = {};
              return "object" == typeof t && null !== t ? s = t : (s.errorCode = t || "FAILURE", s.msg = e || s.errorCode, s.errorMetadata = i), s;
            },
            calculateAdViewability: function calculateAdViewability(t, e) {
              var i = !0;
              if ("undefined" != typeof window && t && "function" == typeof t.getBoundingClientRect) {
                var s = t.getBoundingClientRect();
                if (s.top >= window.innerHeight || s.bottom <= 0 || s.right <= 0 || s.left >= window.innerWidth) i = !1;else {
                  var n = Math.trunc(s.height * s.width),
                    r = s.top > 0 ? s.top : 0,
                    a = s.bottom > window.innerHeight ? window.innerHeight : s.bottom,
                    o = s.left > 0 ? s.left : 0;
                  i = ((s.right > window.innerWidth ? window.innerWidth : s.right) - o) * (a - r) * 100 > n * (e || 50);
                }
              }
              return i;
            },
            getMetricsFrom: function getMetricsFrom(t, e) {
              var i = t || e;
              for (var s in i) if ("object" != typeof i[s] || !i[s].value) {
                var n = {};
                n.value = i[s], i[s] = n;
              }
              return i;
            },
            assign: i(4173),
            isArray: i(2467)
          };
          t.exports = a;
        },
        9835: function _(t, e, i) {
          var s = "7.2.26" + (i(9907).env.NWF || "");
          t.exports = s;
        },
        1516: function _(t, e, i) {
          var s = i(1593),
            n = i(7680),
            r = i(7061);
          var _i69 = i(7276),
            a = _i69.default;
          var o = i(3782),
            d = i(2507);
          var _i70 = i(1577),
            c = _i70.default;
          var u = i(5292),
            l = i(2071),
            h = i(2995),
            p = i(6424);
          var _i71 = i(6933),
            f = _i71.default,
            _i72 = i(9065),
            g = _i72.default,
            _i73 = i(3555),
            m = _i73.default,
            _i74 = i(61),
            v = _i74.default,
            _i75 = i(2784),
            y = _i75.Method,
            T = _i75.AnalyticsTag;
          var S = s.extend({
            constructor: function constructor(t, e, i, s) {
              this._key = t, this._adapterClasses = {}, this.plugin = e, this.isInitiated = !1, this.isAdsManifestSent = !1, this.playedPostrolls = 0, this.isBreakStarted = !1, this.initChrono = new n(), this.options = new r(i), this._adNumber = 0, this._adNumberInBreak = 0, this.requestBuilder = new l(), this.hybridNetwork = new h(), this.resizeScrollDetector = new p(e, this), this._adapter = null, this._adsAdapter = null, s && this.setAdapter(s, e), this._pluginLogsQueue = [], this.lastEventTime = null, this.lastKnownLocation = void 0, this.isFetchingLocation = !1, this.sendingPings = !1, this._startPings();
            },
            mergeOptions: function mergeOptions(t) {
              t && this.options.setOptions(t, this.options);
            },
            setVideoOptions: function setVideoOptions(t) {
              t && this.options.setOptions(t);
            },
            getVideoKey: function getVideoKey() {
              return this._key;
            },
            getAdapterClasses: function getAdapterClasses() {
              return this._adapterClasses;
            },
            nextView: function nextView() {
              return this._viewIndex = new Date().getTime(), this._viewCode = g.getInstance().getFastDataSessionToken(), g.getInstance().registerCommonVariable(v.Products.VIDEO_ANALYTICS, v.AnalyticsVariables.VIEW_CODE, this._viewIndex), this.getViewCode();
            },
            getViewCode: function getViewCode() {
              var t = g.getInstance().getFastDataSessionToken();
              return 0 === t.length || this._viewCode && this._viewCode === t || (this._viewCode = t), this._viewCode + (this._viewIndex ? "_".concat(this._viewIndex) : "");
            },
            setAdapter: function setAdapter(t, e) {
              for (var i in this.plugin = e, this._adapter = t, this._adapter.setIsAds(!1), this._adapter._setAdapter = !0, this.contentAdapterListeners = {}, this.contentAdapterListeners[u.Event.START] = this._startListener.bind(this), this.contentAdapterListeners[u.Event.JOIN] = this._joinListener.bind(this), this.contentAdapterListeners[u.Event.PAUSE] = this._pauseListener.bind(this), this.contentAdapterListeners[u.Event.RESUME] = this._resumeListener.bind(this), this.contentAdapterListeners[u.Event.SEEK_BEGIN] = this._seekBufferBeginListener.bind(this), this.contentAdapterListeners[u.Event.SEEK_END] = this._seekEndListener.bind(this), this.contentAdapterListeners[u.Event.BUFFER_BEGIN] = this._seekBufferBeginListener.bind(this), this.contentAdapterListeners[u.Event.BUFFER_END] = this._bufferEndListener.bind(this), this.contentAdapterListeners[u.Event.ERROR] = this._errorListener.bind(this), this.contentAdapterListeners[u.Event.STOP] = this._stopListener.bind(this), this.contentAdapterListeners[u.Event.VIDEO_EVENT] = this._videoEventListener.bind(this), this.contentAdapterListeners) this._adapter.on(i, this.contentAdapterListeners[i]);
              this.options.enableExtraMetricCollection && this.shouldStartRenditionTimer();
            },
            getAdapter: function getAdapter() {
              return this._adapter;
            },
            removeAdapter: function removeAdapter() {
              try {
                if (this._adapter) {
                  if (this._adapter.dispose(), this.contentAdapterListeners) {
                    for (var t in this.contentAdapterListeners) this._adapter.off(t, this.contentAdapterListeners[t]);
                    delete this.contentAdapterListeners;
                  }
                  this._adapter = null;
                }
              } catch (t) {
                a.error(T, "Is not possible to remove adapter for video: " + this._key);
              }
            },
            getAdsAdapter: function getAdsAdapter() {
              return this._adsAdapter;
            },
            fetchLocation: function fetchLocation() {
              var _this22 = this;
              if (this.isFetchingLocation = !0, navigator && navigator.geolocation) {
                var _t31 = {
                  enableHighAccuracy: !0,
                  timeout: 1e4
                };
                this.lastKnownLocation = void 0, navigator.geolocation.getCurrentPosition(function (t) {
                  _this22.lastKnownLocation = {
                    latitude: t.coords.latitude,
                    longitude: t.coords.longitude
                  }, _this22.isFetchingLocation = !1;
                }, function (t) {
                  _this22.isFetchingLocation = !1;
                }, _t31);
              } else this.lastKnownLocation = void 0, this.isFetchingLocation = !1;
            },
            shouldStartRenditionTimer: function shouldStartRenditionTimer() {
              var _this23 = this;
              if (!this._adapter.getAdapterClass("detectQualityChange") && !this.renditionInterval) {
                var _t32 = this.options.renditionQueryInterval < 100 ? 100 : this.options.renditionQueryInterval;
                this.renditionInterval = setInterval(function () {
                  var t = _this23._adapter.getRendition();
                  t && _this23.triggerUpdateRendition(t);
                }, _t32 || 250);
              }
            },
            triggerUpdateRendition: function triggerUpdateRendition(t) {
              this.lastObservedRendition ? this.lastObservedRendition != t && (this.lastObservedRendition = t) : this.lastObservedRendition = t;
            },
            fireInit: function fireInit(t, e) {
              this.isInitiated || (!this.getAdapter() || this.getAdapter() && !this.getAdapter().flags.isStarted) && (this._viewIndex || this.plugin.getNextViewIndex(this), this._startPings(), this.initChrono.start(), this.isInitiated = !0, t = t || {}, e && (t.triggeredEvents = [e]), this._send(o.WillSendEvent.WILL_SEND_INIT, o.Service.INIT, t), this._adSavedError(), this._adSavedManifest(), a.notice(T, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + o.Service.INIT + ", title/res: " + (t.title || t.mediaResource) + (t.triggeredEvents ? ", eventsTriggered: " + t.triggeredEvents : "")));
            },
            fireError: function fireError(t, e, i, s, n, r) {
              this.fireInit();
              var c = d.buildErrorParams(t, e, i);
              c.code && delete c.code, n && (c.triggeredEvents = [n]);
              try {
                (r = r || !1) && this._adapter && this._adapter.flags && this._adapter.flags.isJoined && ((c = c || {}).errorType = "fatal");
              } catch (t) {}
              this._send(o.WillSendEvent.WILL_SEND_ERROR, o.Service.ERROR, c), this._adSavedError(), this._adSavedManifest(), a.notice(T, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + o.Service.ERROR + ", errorType: " + c.errorType + ", errorCode: " + c.errorCode + (c.triggeredEvents ? ", eventsTriggered: " + c.triggeredEvents : "")), "fatal" === c.errorType && this.fireStop();
            },
            fireFatalError: function fireFatalError(t, e, i, s, n) {
              this.fireError(t, e, i, s, n, !0);
            },
            fireStop: function fireStop(t, e) {
              if (this.isInitiated || this.isStarted) {
                this._adapter && (this._adapter.flags.isStopped = !0, this._adapter.monitor && this._adapter.monitor.stop()), this._adsAdapter && this.isBreakStarted && (this._adsAdapter.fireStop(), this._adsAdapter.fireAdBreakStop()), t = t || {}, e && (t.triggeredEvents = [e]), f.getInstance().setTriedSendingNQSStats(!0), this._send(o.WillSendEvent.WILL_SEND_STOP, o.Service.STOP, t, void 0, void 0, function () {
                  f.getInstance().addNQSRequest(o.Service.STOP);
                });
                var i = this._adapter ? this._adapter.chronos : null;
                i && (i.total.stop(), i.join.reset(), i.pause.reset(), i.buffer.reset(), i.seek.reset()), this.lastKnownLocation = void 0, this.observedRenditions = [], this.renditionInterval && (clearInterval(this.renditionInterval), this.renditionInterval = void 0), a.notice(T, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + o.Service.STOP + " at " + t.playhead + "s" + (t.triggeredEvents ? ", eventsTriggered: " + t.triggeredEvents : "")), this._reset();
              }
            },
            fireOfflineEvents: function fireOfflineEvents(t) {
              this.options && !this.options.offline ? this.isInitiated || this._adapter && this._adapter.flags.isStarted || this._adsAdapter && this._adsAdapter.flags.isStarted ? a.error(T, "Adapters have to be stopped") : (this._offlineParams = t, g.getInstance().getFastDataService().getAccountCode() && g.getInstance().getFastDataSessionToken() ? this._generateAndSendOffline() : this.offlineReference = this._generateAndSendOffline.bind(this)) : a.error(T, "To send offline events, offline option must be disabled");
            },
            _generateAndSendOffline: function _generateAndSendOffline() {
              if (this.options.disableStorage) return null;
              var t = this._offlineParams;
              for (;;) {
                var e = this.requestBuilder.buildBody(o.Service.OFFLINE_EVENTS, [this, this.plugin]).viewJson;
                if (null === e[0]) break;
                var i = this.plugin.getNextViewIndex(this),
                  s = e[0].replace(/CODE_PLACEHOLDER/g, i.toString()).replace(/,"sessionId":"SESSION_PLACEHOLDER"/g, "").replace(/,"sessionRoot":"ROOT_PLACEHOLDER"/g, "");
                this._send(o.WillSendEvent.WILL_SEND_OFFLINE_EVENTS, o.Service.OFFLINE_EVENTS, t, s, "POST", function (t, e) {
                  this.plugin.offlineStorage.removeView(e.offlineId);
                }.bind(this), {
                  offlineId: e[1]
                });
              }
              this.plugin.offlineStorage.sent(), this._offlineParams = null;
            },
            _reset: function _reset() {
              try {
                this._stopPings(), this._adapter && this._adapter.flags.reset(), this._viewIndex = void 0, this.isInitiated = !1, this.isStarted = !1, this.startDelayed = !1, this.isAdsManifestSent = !1, this.initChrono.reset(), this._totalPrerollsTime = 0, this.requestBuilder.lastSent.breakNumber = 0, this.requestBuilder.lastSent.adNumber = 0, this._savedAdManifest = null, this._savedAdError = null, this.playedPostrolls = 0, this.isBreakStarted = !1, this._adNumber = 0, this._adNumberInBreak = 0;
              } catch (t) {}
            },
            _send: function _send(t, e, i, s, n, r, a) {
              var d = c.methodFromString(n),
                u = new Date().getTime();
              this.options.preventZombieViews && this.lastEventTime && u > this.lastEventTime + 6e5 && this.plugin.getNextViewIndex(this), this.lastEventTime = e === o.Service.STOP ? null : u;
              var l = new m(e, i, this.getVideoKey(), d, void 0, r);
              this.plugin.resourceTransform.parse(l), i = this.requestBuilder.buildParams(i, e, [this, this.plugin], this.options), !0 === this.getIsLive() && (i.mediaDuration = this.options["content.duration"], i.playhead = void 0), l.setParams(i), s && l.setBody(s), l.setMethod(d), this.plugin.isMethodPostEnabled() && l.setMethod(y.POST);
              var h = {
                params: l.getParams(),
                plugin: this,
                adapter: this.getAdapter(),
                adsAdapter: this.getAdsAdapter()
              };
              this.emit(t, h), this.plugin.analyticsRequestHandler && (null !== i || void 0 !== n) && this.options.enabled && (this.plugin.lastServiceSent = e, this.plugin.analyticsRequestHandler.sendRequest(l));
            },
            firePlayerLog: function firePlayerLog(t) {
              try {
                if (this.plugin.isPlayerLogsEnabled()) if (this._adapter && !this._adapter.isStarted()) t.timemark = new Date().getTime(), this._pluginLogsQueue.push(t);else {
                  for (; this._pluginLogsQueue.length > 0;) {
                    var e = this._pluginLogsQueue.shift();
                    this._sendPlayerLog(e);
                  }
                  this._sendPlayerLog(t);
                }
              } catch (t) {}
            },
            _sendPlayerLog: function _sendPlayerLog(t) {
              try {
                t && t.logType && t.logAction && a.notice(T, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") PlayerLog " + t.logType + ": Action " + t.logAction), this.plugin._comm && t && null !== (t = this.requestBuilder.buildParams(t, o.Service.VIDEO_PLUGIN_LOGS, this, this.options)) && this._send(null, o.Service.VIDEO_PLUGIN_LOGS, t);
              } catch (t) {}
            }
          });
          d.assign(S.prototype, i(8037)), d.assign(S.prototype, i(5710)), d.assign(S.prototype, i(7355)), d.assign(S.prototype, i(5031)), t.exports = S;
        },
        8037: function _(t, e, i) {
          var s = i(3782),
            n = i(2507),
            r = i(5292);
          var _i76 = i(2784),
            a = _i76.AnalyticsTag,
            _i77 = i(7276),
            o = _i77.default,
            _i78 = i(6933),
            d = _i78.default;
          var c = {
            getAdsAdapter: function getAdsAdapter() {
              return this._adsAdapter;
            },
            setAdsAdapter: function setAdsAdapter(t, e, i) {
              if (i = i || !1, t.isSetAdapter()) o.warn(a, "Adapters can only be added to a single plugin");else try {
                for (var s in this.removeAdsAdapter(), this.plugin = e, this._adsAdapter = t, this._adsAdapter.setIsAds(!0), this.adsAdapterListeners = {}, this.adsAdapterListeners[r.Event.START] = this._adStartListener.bind(this), this.adsAdapterListeners[r.Event.JOIN] = this._adJoinListener.bind(this), this.adsAdapterListeners[r.Event.PAUSE] = this._adPauseListener.bind(this), this.adsAdapterListeners[r.Event.RESUME] = this._adResumeListener.bind(this), this.adsAdapterListeners[r.Event.BUFFER_BEGIN] = this._adBufferBeginListener.bind(this), this.adsAdapterListeners[r.Event.BUFFER_END] = this._adBufferEndListener.bind(this), this.adsAdapterListeners[r.Event.STOP] = this._adStopListener.bind(this), this.adsAdapterListeners[r.Event.ERROR] = this._adErrorListener.bind(this), this.adsAdapterListeners[r.Event.CLICK] = this._adClickListener.bind(this), this.adsAdapterListeners[r.Event.MANIFEST] = this._adManifestListener.bind(this), this.adsAdapterListeners[r.Event.PODSTART] = this._adBreakStartListener.bind(this), this.adsAdapterListeners[r.Event.PODSTOP] = this._adBreakStopListener.bind(this), this.adsAdapterListeners[r.Event.QUARTILE] = this._adQuartileListener.bind(this), this.adsAdapterListeners) this._adsAdapter.on(s, this.adsAdapterListeners[s]);
                i && (o.notice(a, "Registering listeners for registered AdsAdapter"), this._adsAdapter.registerListeners());
              } catch (t) {
                o.warn(a, "Problem during setAdsAdapter process");
              }
            },
            removeAdsAdapter: function removeAdsAdapter() {
              if (this._adsAdapter) {
                if (this._adsAdapter.dispose(), this.adsAdapterListeners) {
                  for (var t in this.adsAdapterListeners) this._adsAdapter.off(t, this.adsAdapterListeners[t]);
                  delete this.adsAdapterListeners;
                }
                this.resizeScrollDetector.stopDetection(), this._adsAdapter = void 0;
              }
            },
            _adStartListener: function _adStartListener(t) {
              this._adapter ? (this._adapter.fireBufferEnd(null, "adStartListener"), this._adapter.fireSeekEnd(null, "adStartListener"), this.isInitiated || this._adapter.flags.isStarted || this._adapter.fireStart(), this._adapter.flags.isPaused && this._adapter.chronos.pause.reset()) : this.fireInit(), this._adsAdapter && (this._adsAdapter.chronos.viewedMax = []);
              var e = t.data.params || {};
              e.adNumber = this.getNewAdNumber(), (this.getAdResource() || this.getAdTitle()) && "number" == typeof this.getAdDuration() ? (this.adStartSent = !0, this._adsAdapter.fireManifest(), this._adsAdapter.fireAdBreakStart(), e.adNumberInBreak = this.getNewAdNumberInBreak(), d.getInstance().addNQSAdEvent(r.Event.START, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_START, s.Service.AD_START, e)) : (this.adInitSent = !0, e.adNumberInBreak = this.getNewAdNumberInBreak(), d.getInstance().addNQSAdEvent(r.Event.INIT, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_INIT, s.Service.AD_INIT, e));
            },
            _adJoinListener: function _adJoinListener(t) {
              var e = {};
              n.assign(e, t.data.params || {}), this.adInitSent && !this.adStartSent && (this._adsAdapter.fireManifest(), this._adsAdapter.fireAdBreakStart(), d.getInstance().addNQSAdEvent(r.Event.START, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_START, s.Service.AD_START, e)), this._adsAdapter.startChronoView(), this.adConnected && (this._adsAdapter.chronos.join.startTime = this.adConnectedTime, this._adsAdapter.chronos.total.startTime = this.adConnectedTime, this.adConnectedTime = 0, this.adConnected = !1), e = t.data.params || {}, d.getInstance().addNQSAdEvent(r.Event.JOIN, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_JOIN, s.Service.AD_JOIN, e), this.adInitSent = !1, this.adStartSent = !1;
            },
            _adPauseListener: function _adPauseListener(t) {
              var e = t.data.params || {};
              this._adsAdapter.stopChronoView(), d.getInstance().addNQSAdEvent(r.Event.PAUSE, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_PAUSE, s.Service.AD_PAUSE, e);
            },
            _adResumeListener: function _adResumeListener(t) {
              var e = t.data.params || {};
              this._adsAdapter.startChronoView(), d.getInstance().addNQSAdEvent(r.Event.RESUME, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_RESUME, s.Service.AD_RESUME, e);
            },
            _adBufferBeginListener: function _adBufferBeginListener(t) {
              o.notice(a, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") Ad Buffer Begin"), this._adsAdapter.stopChronoView(), this._adsAdapter && this._adsAdapter.flags.isPaused && this._adsAdapter.chronos.pause.reset();
            },
            _adBufferEndListener: function _adBufferEndListener(t) {
              var e = t.data.params || {};
              this._adsAdapter.startChronoView(), d.getInstance().addNQSAdEvent(r.Event.BUFFER_END, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_BUFFER, s.Service.AD_BUFFER, e);
            },
            _adStopListener: function _adStopListener(t) {
              var e = t.data.params || {};
              if (this._adsAdapter.stopChronoView(), this._adsAdapter.flags.reset(), this._totalPrerollsTime = (this._totalPrerollsTime || 0) + this._adsAdapter.chronos.total.getDeltaTime(), e.position = this.requestBuilder.lastSent.position, d.getInstance().addNQSAdEvent(r.Event.STOP, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_STOP, s.Service.AD_STOP, e), this.requestBuilder.lastSent.position === s.AdPosition.Postroll) {
                var _t33 = this.options["ad.expectedPattern"];
                this.playedPostrolls++, (this.requestBuilder.lastSent.givenAds && this.requestBuilder.lastSent.givenAds <= this.playedPostrolls || !this.requestBuilder.lastSent.givenAds && _t33 && _t33.post && _t33.post[0] && _t33.post[0] <= this.playedPostrolls) && this._adapter.fireStop({}, "_adStopListener");
              }
              this.adConnected = !0, this.adConnectedTime = new Date().getTime();
            },
            _adErrorListener: function _adErrorListener(t) {
              var e = t.data.params || {};
              !this._adapter || this._adapter.flags.isStarted || this.isInitiated ? this._blockAdError(t.data.params) || (this._adsAdapter && (this._adsAdapter.fireManifest(), this._adsAdapter.fireAdBreakStart()), this._adsAdapter && this._adsAdapter.flags.isStarted || (e.adNumber = this.getNewAdNumber(), e.adNumberInBreak = this.getNewAdNumberInBreak()), this.isBreakStarted || (e.breakNumber = this.getNewBreakNumber()), d.getInstance().addNQSAdEvent(r.Event.ERROR, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_ERROR, s.Service.AD_ERROR, e)) : this._savedAdError = t;
            },
            _adSavedError: function _adSavedError() {
              this._savedAdError && (this._adErrorListener(this._savedAdError), this._savedAdError = null);
            },
            _adSavedManifest: function _adSavedManifest() {
              this._savedAdManifest && (this._adManifestListener(this._savedAdManifest), this._savedAdManifest = null);
            },
            _blockAdError: function _blockAdError(t) {
              var e = Date.now();
              return this._lastAdErrorParams && this._lastAdErrorParams.errorCode === t.errorCode && this._lastAdErrorParams.msg === t.msg && this._lastAdErrorParams.adCreativeId === this.getAdCreativeId() && this._lastAdErrorTime + 5e3 > e ? (this._lastAdErrorTime = e, !0) : (this._lastAdErrorTime = e, this._lastAdErrorParams = t, !1);
            },
            _adClickListener: function _adClickListener(t) {
              var e = t.data.params || {};
              this._adsAdapter.stopChronoView(), d.getInstance().addNQSAdEvent(r.Event.CLICK, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_CLICK, s.Service.AD_CLICK, e);
            },
            _adManifestListener: function _adManifestListener(t) {
              if (!this.isAdsManifestSent) {
                if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated) return void (this._savedAdManifest = t);
                var _e35 = t.data.params || {};
                this.isAdsManifestSent = !0, d.getInstance().addNQSAdEvent(r.Event.MANIFEST, _e35), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_MANIFEST, s.Service.AD_MANIFEST, _e35);
              }
            },
            _adBreakStartListener: function _adBreakStartListener(t) {
              if (!this.isBreakStarted) {
                this.isBreakStarted = !0, this._adapter && this._adapter.firePause();
                var _e36 = t.data.params || {};
                _e36.breakNumber = this.getNewBreakNumber(), d.getInstance().addNQSAdEvent(r.Event.PODSTART, _e36), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_POD_START, s.Service.AD_POD_START, _e36), this.adConnected = !1;
              }
            },
            _adBreakStopListener: function _adBreakStopListener(t) {
              if (this.isBreakStarted) {
                this.isBreakStarted = !1;
                var _e37 = t.data.params || {};
                _e37.position = this.requestBuilder.lastSent.position, d.getInstance().addNQSAdEvent(r.Event.PODSTOP, _e37), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_POD_STOP, s.Service.AD_POD_STOP, _e37), this.adConnected = !1, this._adapter && this._adapter.fireResume();
              }
            },
            _adQuartileListener: function _adQuartileListener(t) {
              var e = t.data.params || {};
              e.quartile && (d.getInstance().addNQSAdEvent(r.Event.QUARTILE, e), this._sendAdEventIfAllowed(s.WillSendEvent.WILL_SEND_AD_QUARTILE, s.Service.AD_QUARTILE, e));
            },
            _sendAdEventIfAllowed: function _sendAdEventIfAllowed(t, e, i) {
              this.options["ad.ignore"] || (d.getInstance().setTriedSendingNQSAdStats(!0), this._send(t, e, i, void 0, void 0, function () {
                d.getInstance().addNQSAdRequest(e);
              })), o.notice(a, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + e);
            }
          };
          t.exports = c;
        },
        5710: function _(t, e, i) {
          var _i79 = i(6933),
            s = _i79.default;
          var n = i(3782);
          var r = i(2477),
            _i80 = i(7276),
            a = _i80.default;
          var o = i(2507),
            d = i(5292);
          var _i81 = i(2784),
            c = _i81.AnalyticsTag,
            _i82 = i(61),
            u = _i82.default,
            _i83 = i(9065),
            l = _i83.default;
          var h = {
            _startListener: function _startListener(t) {
              !this.plugin.options.enableExtraMetricCollection || this.lastKnownLocation || this.isFetchingLocation || this.fetchLocation(), this.isInitiated ? 0 !== this.initChrono.startTime && (this._adapter.chronos.join.startTime = this.initChrono.startTime) : (this._viewIndex || this.plugin.getNextViewIndex(this), this._startPings());
              var e = t.data.params || {};
              s.getInstance().addNQSEvent(d.Event.START, e);
              var i = this.getResource() && "boolean" == typeof this.getIsLive() && (this.getIsLive() || "number" == typeof this.getDuration() && this.getDuration() > 0) && this.getTitle(),
                r = l.getInstance().getCommonVariable(u.Products.BALANCER, u.BalancerVariables.DECISION_FINISHED);
              void 0 === r && (r = !0), (i = !this.options.forceInit && i && this._isExtraMetadataReady() && r && this._isRequiredMetadataReady()) && !this.isInitiated ? (s.getInstance().setTriedSendingNQSStats(!0), this._send(n.WillSendEvent.WILL_SEND_START, n.Service.START, e, void 0, void 0, function () {
                s.getInstance().addNQSRequest(n.Service.START);
              }), this._adSavedError(), this._adSavedManifest(), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.START + ", title/res: " + (e.title || e.mediaResource) + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : "")), this.isStarted = !0) : this.isInitiated || (this.isInitiated = !0, this._adapter.chronos.join.start(), s.getInstance().setTriedSendingNQSStats(!0), this._send(n.WillSendEvent.WILL_SEND_INIT, n.Service.INIT, e, void 0, void 0, function () {
                s.getInstance().addNQSRequest(n.Service.INIT);
              }), this._adSavedError(), this._adSavedManifest(), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.INIT + ", title/res: " + (e.title || e.mediaResource) + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : ""))), this.options.enableExtraMetricCollection && this.shouldStartRenditionTimer();
            },
            _retryStart: function _retryStart(t) {
              var e = l.getInstance().getCommonVariable(u.Products.BALANCER, u.BalancerVariables.DECISION_FINISHED);
              void 0 === e && (e = !0), this._isExtraMetadataReady() && e && this._isRequiredMetadataReady() && (this._send(n.WillSendEvent.WILL_SEND_START, n.Service.START, {}), this.startDelayed = !1);
            },
            _joinListener: function _joinListener(t) {
              var e = {};
              if (o.assign(e, t.data.params || {}), this._adsAdapter && this._adsAdapter.flags.isStarted) this._adapter.monitor && this._adapter.monitor.stop(), this._adapter.flags.isJoined = !1, this._adapter.chronos.join.stopTime = 0;else {
                if (s.getInstance().addNQSEvent(d.Event.JOIN, e), this._adapter && (this._adapter.chronos.join.startTime = Math.min(this._adapter.chronos.join.startTime + (this._totalPrerollsTime || 0), new Date().getTime()), this._totalPrerollsTime = 0), this.isInitiated && !this.isStarted) {
                  var i = l.getInstance().getCommonVariable(u.Products.BALANCER, u.BalancerVariables.DECISION_FINISHED);
                  void 0 === i && (i = !0), this._isExtraMetadataReady() && i && this._isRequiredMetadataReady() ? (s.getInstance().setTriedSendingNQSStats(!0), this._send(n.WillSendEvent.WILL_SEND_START, n.Service.START, e, void 0, void 0, function () {
                    s.getInstance().addNQSRequest(n.Service.START);
                  })) : this.startDelayed = !0, this._adSavedError(), this._adSavedManifest(), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.START + ", title/res: " + (e.title || e.mediaResource) + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : "")), this.isStarted = !0;
                }
                e = t.data.params || {}, s.getInstance().addNQSEvent(r.JOIN_TIME, e), this._adsAdapter && this.isBreakStarted && this._adsAdapter.fireAdBreakStop(), s.getInstance().setTriedSendingNQSStats(!0), this._send(n.WillSendEvent.WILL_SEND_JOIN, n.Service.JOIN, e, void 0, void 0, function () {
                  s.getInstance().addNQSRequest(n.Service.JOIN);
                }), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.JOIN + ", duration: " + e.joinDuration + "ms" + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : ""));
              }
            },
            _pauseListener: function _pauseListener(t) {
              this._adapter && (this._adapter.flags.isBuffering || this._adapter.flags.isSeeking || this._adsAdapter && this._adsAdapter.flags.isStarted) && this._adapter.chronos.pause.reset();
              var e = t.data.params || {};
              s.getInstance().addNQSEvent(d.Event.PAUSE, e), this._send(n.WillSendEvent.WILL_SEND_PAUSE, n.Service.PAUSE, e), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.PAUSE + " at " + e.playhead + "s" + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : ""));
            },
            _resumeListener: function _resumeListener(t) {
              this._adsAdapter && this.isBreakStarted && !this._adsAdapter.flags.isStarted && this._adsAdapter.fireAdBreakStop();
              var e = t.data.params || {};
              s.getInstance().addNQSEvent(d.Event.RESUME, e), this._send(n.WillSendEvent.WILL_SEND_RESUME, n.Service.RESUME, e), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.RESUME + ", duration: " + e.pauseDuration + "ms" + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : "")), this._adapter.chronos.pause.reset();
            },
            _seekBufferBeginListener: function _seekBufferBeginListener(t) {
              this._adapter && this._adapter.flags.isPaused && this._adapter.chronos.pause.pause(), t.type && t.type.includes("buffer") ? (s.getInstance().addNQSEvent(d.Event.BUFFER_BEGIN, {}), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + t.type + ", eventsTriggered: " + this._adapter.fireEventsStruct.buffer)) : (s.getInstance().addNQSEvent(d.Event.SEEK_BEGIN, {}), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + t.type + ", eventsTriggered: " + this._adapter.fireEventsStruct.seek));
            },
            _seekEndListener: function _seekEndListener(t) {
              var e = t.data.params || {};
              s.getInstance().addNQSEvent(d.Event.SEEK_END, e), this._send(n.WillSendEvent.WILL_SEND_SEEK, n.Service.SEEK, e), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.SEEK + " to " + e.playhead + " in " + e.seekDuration + "ms" + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : ""));
            },
            _bufferEndListener: function _bufferEndListener(t) {
              var e = t.data.params || {};
              s.getInstance().addNQSEvent(d.Event.BUFFER_END, e), this._send(n.WillSendEvent.WILL_SEND_BUFFER, n.Service.BUFFER, e), a.notice(c, "[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") " + n.Service.BUFFER + " to " + e.playhead + " in " + e.bufferDuration + "ms" + (e.triggeredEvents ? ", eventsTriggered: " + e.triggeredEvents : ""));
            },
            _errorListener: function _errorListener(t) {
              this._blockError(t.data.params) || (s.getInstance().addNQSEvent(d.Event.ERROR, t.data.params), this.fireError(t.data.params || {}), this._adSavedError(), this._adSavedManifest());
            },
            _blockError: function _blockError(t) {
              var e = Date.now();
              return this._lastErrorParams && this._lastErrorParams.errorCode === t.errorCode && this._lastErrorParams.msg === t.msg && this._lastErrorTime + 5e3 > e ? (this._lastErrorTime = e, !0) : (this._lastErrorTime = e, this._lastErrorParams = t, !1);
            },
            _stopListener: function _stopListener(t) {
              s.getInstance().addNQSEvent(d.Event.STOP, t.data.params), this.fireStop(t.data.params || {});
            },
            _isStopReady: function _isStopReady(t) {
              var e = !1;
              if (!this.requestBuilder.lastSent.live && this._adsAdapter && this._adapter && (!this._adapter.getPlayhead() || this._adapter.getPlayhead() >= this.requestBuilder.lastSent.mediaDuration - 1)) {
                var _t34 = 0;
                var _i84 = this.options["ad.expectedPattern"];
                if (_i84 && _i84.post && _i84.post[0]) _t34 = _i84.post[0];else if (this.requestBuilder.lastSent.breaksTime) {
                  if (this.requestBuilder.lastSent.position === n.AdPosition.Postroll && (_t34 = this.requestBuilder.lastSent.givenAds), !_t34 && this.requestBuilder.lastSent.breaksTime) {
                    var _e38 = this.requestBuilder.lastSent.breaksTime;
                    _e38.length > 0 && this.requestBuilder.lastSent.mediaDuration && Math.round(_e38[_e38.length - 1]) + 1 >= this.requestBuilder.lastSent.mediaDuration && (_t34 = 1);
                  }
                } else e = !0;
                _t34 <= this.playedPostrolls && (e = !0);
              } else e = !0;
              return e;
            },
            _videoEventListener: function _videoEventListener(t) {
              s.getInstance().addNQSEvent(d.Event.VIDEO_EVENT, t.data.params), this._send(n.WillSendEvent.WILL_SEND_VIDEO_EVENT, n.Service.VIDEO_EVENT, t.data.params);
            },
            _isExtraMetadataReady: function _isExtraMetadataReady(t) {
              if (!this.options.waitForMetadata || this.options.pendingMetadata.length < 1) return !0;
              try {
                var _t35 = this.requestBuilder.getGetters();
                return this.options.pendingMetadata.map(function (e) {
                  if (_t35.hasOwnProperty(e)) {
                    if (this[_t35[e]]) return !!this[_t35[e]]();
                    if (this.plugin[_t35[e]]) return !!this.plugin[_t35[e]]();
                  }
                }.bind(this)).indexOf(!1) < 0;
              } catch (t) {
                a.warn("[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") Error processing isExtraMetadataReady method.");
              }
              return !0;
            },
            _isRequiredMetadataReady: function _isRequiredMetadataReady() {
              if (new Date().getTime() - this._adapter.chronos.join.startTime < n.Metadata.REQUIRED_METADATA_TIMEOUT) {
                try {
                  var _t36 = this.requestBuilder.getGetters();
                  return this.requestBuilder.getRequiredMetadataParams().every(function (e) {
                    if (_t36.hasOwnProperty(e)) if ("function" == typeof this[_t36[e]]) {
                      var _i85 = this[_t36[e]]();
                      if (null != _i85 && !Number.isNaN(_i85)) return !0;
                    } else if (this.plugin && "function" == typeof this.plugin[_t36[e]]) {
                      var _i86 = this.plugin[_t36[e]]();
                      if (null != _i86 && !Number.isNaN(_i86)) return !0;
                    }
                    return !1;
                  }.bind(this));
                } catch (t) {
                  a.warn("[" + this.getViewCode() + "] (Video Space " + this.getVideoKey() + ") Error processing _isRequiredMetadataReady method.");
                }
                return !1;
              }
              return !0;
            }
          };
          t.exports = h;
        },
        7355: function _(t, e, i) {
          var s = i(2507),
            _i87 = i(7276),
            n = _i87.default,
            r = i(9835),
            a = i(8472),
            o = i(7939),
            d = i(3782),
            _i88 = i(9065),
            c = _i88.default,
            _i89 = i(2784),
            u = _i89.AnalyticsTag,
            _i90 = i(61),
            l = _i90.default;
          var h = {
            getPlayhead: function getPlayhead() {
              var t = this._safeGetterAdapter("getPlayhead");
              return s.parseNumber(t, 0);
            },
            getPlayrate: function getPlayrate() {
              var t = 0;
              if (this._adapter && this._adapter.flags && !this._adapter.flags.isPaused) try {
                t = this._adapter.getPlayrate();
              } catch (t) {
                n.warn(u, "An error occured while calling getPlayrate", t);
              }
              return t;
            },
            getFramesPerSecond: function getFramesPerSecond() {
              return this._safeGetterAdapter("getFramesPerSecond", "content.fps");
            },
            getSegmentDuration: function getSegmentDuration() {
              return this.hybridNetwork.getSegmentDuration() || this._safeGetterAdapter("getSegmentDuration", "content.segmentDuration");
            },
            getDroppedFrames: function getDroppedFrames() {
              var t = this._safeGetterAdapter("getDroppedFrames");
              return t || (t = this.getWebkitDroppedFrames()), s.parseNumber(t, 0);
            },
            getWebkitDroppedFrames: function getWebkitDroppedFrames() {
              if (this._adapter && this._adapter.tag && this._adapter.tag.webkitDroppedFrameCount) return this._adapter.tag.webkitDroppedFrameCount;
            },
            getDuration: function getDuration() {
              var t = this._safeGetterAdapter("getDuration", "content.duration") || void 0;
              return s.parseNumber(Math.round(t), void 0);
            },
            getBitrate: function getBitrate() {
              var t = this._safeGetterAdapter("getBitrate", "content.bitrate");
              return t && -1 !== t || (t = this.getWebkitBitrate()), s.parseNumber(t, -1);
            },
            getTotalBytes: function getTotalBytes() {
              return this.options["content.sendTotalBytes"] ? this._safeGetterAdapter("getTotalBytes", "content.totalBytes") : void 0;
            },
            getWebkitBitrate: function getWebkitBitrate() {
              try {
                if (this._adapter && this._adapter.tag && this._adapter.tag.webkitVideoDecodedByteCount) {
                  var _e39 = this._adapter.tag.webkitVideoDecodedByteCount;
                  if (this._lastWebkitBitrate) {
                    var t = this._adapter.tag.webkitVideoDecodedByteCount - this._lastWebkitBitrate;
                    _e39 = Math.round(t / this.plugin.fastDataTransform.response.pingTime * 8);
                  }
                  return this._lastWebkitBitrate = this._adapter.tag.webkitVideoDecodedByteCount, 0 !== _e39 ? _e39 : -1;
                }
              } catch (t) {}
              return -1;
            },
            getThroughput: function getThroughput() {
              var t = this._safeGetterAdapter("getThroughput", "content.throughput");
              return s.parseNumber(t, -1);
            },
            getRendition: function getRendition() {
              return this._safeGetterAdapter("getRendition", "content.rendition");
            },
            getTitle: function getTitle() {
              return this._safeGetterAdapter("getTitle", "content.title");
            },
            getTitle2: function getTitle2() {
              return this._safeGetterAdapter("getTitle2", "content.program");
            },
            getIsLive: function getIsLive() {
              var t = this.options["content.isLive"];
              return t || !1 === t || (t = this._safeGetterAdapter("getIsLive") || !1), t;
            },
            getResource: function getResource() {
              return this._safeGetterAdapter("getResource", "content.resource");
            },
            getParsedResource: function getParsedResource() {
              var t = this.plugin.resourceTransform.getResource();
              return t = t || this._safeGetterAdapter("getURLToParse"), t === this.getResource() ? void 0 : t;
            },
            getTransactionCode: function getTransactionCode() {
              return this.options["content.transactionCode"];
            },
            getMetadata: function getMetadata() {
              return this.options["content.metadata"];
            },
            getPlayerVersion: function getPlayerVersion() {
              return this._safeGetterAdapter("getPlayerVersion") || "";
            },
            getPlayerName: function getPlayerName() {
              return this._safeGetterAdapter("getPlayerName") || "";
            },
            getCdn: function getCdn() {
              var t = null;
              return t = c.getInstance().getCommonVariable(l.Products.BALANCER, l.BalancerVariables.AS_ENABLED) ? "ACTVSWIT" : this.plugin.resourceTransform.getCdnName(), t || this.options["content.cdn"];
            },
            getProfileName: function getProfileName() {
              return c.getInstance().getCommonVariable(l.Products.BALANCER, l.BalancerVariables.PROFILE_NAME);
            },
            getBucketName: function getBucketName() {
              return c.getInstance().getCommonVariable(l.Products.BALANCER, l.BalancerVariables.BUCKET);
            },
            getPluginVersion: function getPluginVersion() {
              return c.getPluginVersion();
            },
            getAdapterVersion: function getAdapterVersion() {
              return this._safeGetterAdapter("getVersion");
            },
            getCdnTraffic: function getCdnTraffic() {
              return this._safeGetterAdapter("getCdnTraffic") || this.hybridNetwork.getCdnTraffic();
            },
            getMultiCdnInfo: function getMultiCdnInfo() {
              return this.hybridNetwork.getMultiCdnInfo();
            },
            getBalancerResponseId: function getBalancerResponseId() {
              return this.hybridNetwork.getBalancerResponseId();
            },
            getP2PTraffic: function getP2PTraffic() {
              return this._safeGetterAdapter("getP2PTraffic") || this.hybridNetwork.getP2PTraffic();
            },
            getUploadTraffic: function getUploadTraffic() {
              return this._safeGetterAdapter("getUploadTraffic") || this.hybridNetwork.getUploadTraffic();
            },
            getIsP2PEnabled: function getIsP2PEnabled() {
              return this._safeGetterAdapter("getIsP2PEnabled") || this.hybridNetwork.getIsP2PEnabled();
            },
            getStreamingProtocol: function getStreamingProtocol() {
              var t = this.options["content.streamingProtocol"];
              if (t) for (var e in a) if (a[e] === t) return t;
            },
            getTransportFormat: function getTransportFormat() {
              var t = this.options["content.transportFormat"];
              if (!t && this.options["parse.manifest"] && (t = this.plugin.resourceTransform.getTransportFormat()), t) for (var _e40 in o) if (o[_e40] === t) return t;
            },
            getHouseholdId: function getHouseholdId() {
              return this._safeGetterAdapter("getHouseholdId");
            },
            getLatency: function getLatency() {
              return this.getIsLive() ? this._safeGetterAdapter("getLatency") : void 0;
            },
            getPacketLoss: function getPacketLoss() {
              return this._safeGetterAdapter("getPacketLoss");
            },
            getPacketSent: function getPacketSent() {
              return this._safeGetterAdapter("getPacketSent");
            },
            getVideoMetrics: function getVideoMetrics() {
              return s.getMetricsFrom(this._adapter ? this._adapter.getMetrics() : void 0, this.options["content.metrics"]);
            },
            getPlayerStartupTime: function getPlayerStartupTime() {
              return this.plugin.browserLoadTimes.getPlayerStartupTime();
            },
            getJoinDuration: function getJoinDuration() {
              return this._adapter ? this._adapter.chronos.join.getDeltaTime(!1) : -1;
            },
            getBufferDuration: function getBufferDuration() {
              return this._adapter ? this._adapter.chronos.buffer.getDeltaTime(!1) : -1;
            },
            getSeekDuration: function getSeekDuration() {
              return this._adapter ? this._adapter.chronos.seek.getDeltaTime(!1) : -1;
            },
            getPauseDuration: function getPauseDuration() {
              return this._adapter ? this._adapter.chronos.pause.getDeltaTime(!1) : 0;
            },
            getPackage: function getPackage() {
              return this.options["content.package"];
            },
            getSaga: function getSaga() {
              return this.options["content.saga"];
            },
            getTvShow: function getTvShow() {
              return this.options["content.tvShow"];
            },
            getSeason: function getSeason() {
              return this.options["content.season"];
            },
            getEpisodeTitle: function getEpisodeTitle() {
              return this.options["content.episodeTitle"];
            },
            getChannel: function getChannel() {
              return this.options["content.channel"];
            },
            getID: function getID() {
              return this.options["content.id"];
            },
            getImdbId: function getImdbId() {
              return this.options["content.imdbId"];
            },
            getGracenoteID: function getGracenoteID() {
              return this.options["content.gracenoteId"];
            },
            getType: function getType() {
              return this.options["content.type"];
            },
            getGenre: function getGenre() {
              return this.options["content.genre"];
            },
            getVideoLanguage: function getVideoLanguage() {
              return this.options["content.language"];
            },
            getSubtitles: function getSubtitles() {
              return this.options["content.subtitles"];
            },
            getContractedResolution: function getContractedResolution() {
              return this.options["content.contractedResolution"];
            },
            getCost: function getCost() {
              return this.options["content.cost"];
            },
            getPrice: function getPrice() {
              return this.options["content.price"];
            },
            getPlaybackType: function getPlaybackType() {
              var t = this.options["content.playbackType"];
              if (!t) {
                var _e41 = this.options["content.isLive"];
                "boolean" != typeof _e41 && (_e41 = this._safeGetterAdapter("getIsLive")), "boolean" == typeof _e41 && (t = _e41 ? "Live" : "VoD");
              }
              return t;
            },
            getDRM: function getDRM() {
              return this.options["content.drm"];
            },
            getVideoCodec: function getVideoCodec() {
              return this._safeGetterAdapter("getVideoCodec", "content.encoding.videoCodec");
            },
            getAudioCodec: function getAudioCodec() {
              return this._safeGetterAdapter("getAudioCodec", "content.encoding.audioCodec");
            },
            getCodecSettings: function getCodecSettings() {
              return this.options["content.encoding.codecSettings"];
            },
            getCodecProfile: function getCodecProfile() {
              return this.options["content.encoding.codecProfile"];
            },
            getContainerFormat: function getContainerFormat() {
              return this.options["content.encoding.containerFormat"];
            },
            getLinkedViewId: function getLinkedViewId() {
              return this.options.linkedViewId;
            },
            _safeGetterAdapter: function _safeGetterAdapter(t, e) {
              var i;
              if (e && this.options[e]) i = this.options[e];else try {
                this._adapter && "function" == typeof this._adapter[t] && (i = this._adapter[t]());
              } catch (e) {
                n.warn(u, "An error occured while calling " + t, e);
              }
              return i || void 0;
            },
            getCustomDimensions: function getCustomDimensions() {
              var t = this.options["content.customDimensions"];
              return "object" == typeof t ? t : void 0;
            },
            getAdExtraparam1: function getAdExtraparam1() {
              return this.options["ad.customDimension.1"];
            },
            getAdExtraparam2: function getAdExtraparam2() {
              return this.options["ad.customDimension.2"];
            },
            getAdExtraparam3: function getAdExtraparam3() {
              return this.options["ad.customDimension.3"];
            },
            getAdExtraparam4: function getAdExtraparam4() {
              return this.options["ad.customDimension.4"];
            },
            getAdExtraparam5: function getAdExtraparam5() {
              return this.options["ad.customDimension.5"];
            },
            getAdExtraparam6: function getAdExtraparam6() {
              return this.options["ad.customDimension.6"];
            },
            getAdExtraparam7: function getAdExtraparam7() {
              return this.options["ad.customDimension.7"];
            },
            getAdExtraparam8: function getAdExtraparam8() {
              return this.options["ad.customDimension.8"];
            },
            getAdExtraparam9: function getAdExtraparam9() {
              return this.options["ad.customDimension.9"];
            },
            getAdExtraparam10: function getAdExtraparam10() {
              return this.options["ad.customDimension.10"];
            },
            getPluginInfo: function getPluginInfo() {
              return JSON.stringify({
                lib: r,
                adapter: this.getAdapterVersion(),
                adAdapter: this.getAdAdapterVersion()
              });
            },
            getAccountCode: function getAccountCode() {
              return c.getInstance().getFastDataService().getAccountCode();
            },
            getUsername: function getUsername() {
              return this.options["user.name"];
            },
            getEmail: function getEmail() {
              return this.options["user.email"];
            },
            getNodeHost: function getNodeHost() {
              return this.options["content.cdnNode"] || this.plugin.resourceTransform.getNodeHost();
            },
            getNodeType: function getNodeType() {
              return this.options["content.cdnType"] || this.plugin.resourceTransform.getNodeType();
            },
            getNodeTypeString: function getNodeTypeString() {
              return this.plugin.resourceTransform.getNodeTypeString();
            },
            getRequestNumber: function getRequestNumber() {
              return Math.random();
            },
            getOfflineView: function getOfflineView() {
              var t;
              return this.plugin.offlineStorage && (t = this.plugin.offlineStorage.getView()), t;
            },
            getSmartswitchConfigCode: function getSmartswitchConfigCode() {
              return this.options["smartswitch.configCode"];
            },
            getSmartswitchGroupCode: function getSmartswitchGroupCode() {
              return this.options["smartswitch.groupCode"];
            },
            getSmartswitchContractCode: function getSmartswitchContractCode() {
              return this.options["smartswitch.contractCode"];
            },
            controlPlayerExists: function controlPlayerExists() {
              return this.options["check.playerExists"];
            },
            ignorePauseSmallEvents: function ignorePauseSmallEvents() {
              return this.options["pause.ignoreSmallEvents"];
            },
            getAdPlayerVersion: function getAdPlayerVersion() {
              return this._safeGetterAdsAdapter("getPlayerVersion") || "";
            },
            getAdPosition: function getAdPosition() {
              var t = d.AdPosition.Preroll;
              if (this._adsAdapter) try {
                var e = this._adsAdapter.getPosition();
                d.AdPosition.Preroll !== e && d.AdPosition.Midroll !== e && d.AdPosition.Postroll !== e || (t = e);
              } catch (t) {
                n.warn(u, "An error occured while calling getAdPosition", t);
              }
              return !t && this._adapter && (t = this._adapter.flags.isJoined ? d.AdPosition.Midroll : d.AdPosition.Preroll), t;
            },
            getAdNumber: function getAdNumber() {
              return this.requestBuilder.lastSent.adNumber || 0;
            },
            getAdNumberInBreak: function getAdNumberInBreak() {
              return this.requestBuilder.lastSent.adNumberInBreak || 0;
            },
            getBreakNumber: function getBreakNumber() {
              return this.requestBuilder.lastSent.breakNumber || 0;
            },
            getAdPlayhead: function getAdPlayhead() {
              var t = this._safeGetterAdsAdapter("getPlayhead");
              return s.parseNumber(t, 0);
            },
            getAdDuration: function getAdDuration() {
              var t = this._safeGetterAdsAdapter("getDuration", "ad.duration");
              return s.parseNumber(t, 0);
            },
            getAdBitrate: function getAdBitrate() {
              var t = this._safeGetterAdsAdapter("getBitrate");
              return t && -1 !== t || (t = this.getWebkitAdBitrate()), s.parseNumber(t, -1);
            },
            getWebkitAdBitrate: function getWebkitAdBitrate() {
              try {
                if (this._adsAdapter && this._adsAdapter.tag && this._adsAdapter.tag.webkitVideoDecodedByteCount) {
                  var _t37 = this._adsAdapter.tag.webkitVideoDecodedByteCount;
                  if (this._lastWebkitAdBitrate) {
                    var _e42 = this._adsAdapter.tag.webkitVideoDecodedByteCount - this._lastWebkitAdBitrate;
                    _t37 = Math.round(_e42 / this.plugin.fastDataTransform.response.pingTime * 8);
                  }
                  return this._lastWebkitAdBitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount, 0 !== _t37 ? _t37 : -1;
                }
              } catch (t) {}
              return -1;
            },
            getAdTitle: function getAdTitle() {
              return this._safeGetterAdsAdapter("getTitle", "ad.title");
            },
            getAdResource: function getAdResource() {
              return this._safeGetterAdsAdapter("getResource", "ad.resource");
            },
            getAdCampaign: function getAdCampaign() {
              return this._safeGetterAdsAdapter("getCampaign", "ad.campaign");
            },
            getAdCreativeId: function getAdCreativeId() {
              return this._safeGetterAdsAdapter("getCreativeId", "ad.creativeId");
            },
            getAdProvider: function getAdProvider() {
              return this._safeGetterAdsAdapter("getProvider", "ad.provider");
            },
            getAdAdapterVersion: function getAdAdapterVersion() {
              return this._safeGetterAdsAdapter("getVersion");
            },
            getAdMetadata: function getAdMetadata() {
              return this.options["ad.metadata"];
            },
            getAdInsertionType: function getAdInsertionType() {
              return this._safeGetterAdsAdapter("getAdInsertionType");
            },
            getGivenBreaks: function getGivenBreaks() {
              return this._safeGetterAdsAdapter("getGivenBreaks", "ad.givenBreaks");
            },
            getExpectedBreaks: function getExpectedBreaks() {
              var t;
              var e = this.options["ad.expectedBreaks"],
                i = this.options["ad.expectedPattern"];
              if (e) t = e;else if (i) t = 0, t = i.pre ? i.pre.length : 0, t += i.mid ? i.mid.length : 0, t += i.post ? i.post.length : 0;else if (this._adsAdapter) try {
                t = this._adsAdapter.getExpectedBreaks();
              } catch (t) {
                n.warn(u, "An error occured while calling expectedBreaks", t);
              }
              return t;
            },
            getExpectedPattern: function getExpectedPattern() {
              return this._safeGetterAdsAdapter("getExpectedPattern", "ad.expectedPattern");
            },
            getBreaksTime: function getBreaksTime() {
              return this._safeGetterAdsAdapter("getBreaksTime", "ad.breaksTime");
            },
            getGivenAds: function getGivenAds() {
              return this._safeGetterAdsAdapter("getGivenAds", "ad.givenAds");
            },
            getExpectedAds: function getExpectedAds() {
              var t;
              try {
                if (this._adsAdapter) {
                  var _e43 = this.options["ad.expectedPattern"];
                  if (_e43 && this.getAdPosition()) {
                    var _i91 = [];
                    if (_e43.pre && (_i91 = _i91.concat(_e43.pre)), _e43.mid && (_i91 = _i91.concat(_e43.mid)), _e43.post && (_i91 = _i91.concat(_e43.post)), _i91.length > 0) {
                      var _e44 = this.requestBuilder.lastSent.breakNumber;
                      _e44 > _i91.length && (_e44 = _i91.length), t = _i91[_e44 - 1];
                    }
                  } else t = this._adsAdapter.getExpectedAds();
                }
              } catch (t) {
                n.warn(u, "An error occured while calling expectedAds", t);
              }
              return t;
            },
            getAdsExpected: function getAdsExpected() {
              var t;
              try {
                t = this.getExpectedPattern() || this.getGivenAds() || !1;
              } catch (t) {
                n.warn(u, "An error occured while calling givenAds or expectedPattern", t);
              }
              return t;
            },
            getAdJoinDuration: function getAdJoinDuration() {
              return this._adsAdapter ? this._adsAdapter.chronos.join.getDeltaTime(!1) : -1;
            },
            getAdBufferDuration: function getAdBufferDuration() {
              return this._adsAdapter ? this._adsAdapter.chronos.buffer.getDeltaTime(!1) : -1;
            },
            getAdPauseDuration: function getAdPauseDuration() {
              return this._adsAdapter ? this._adsAdapter.chronos.pause.getDeltaTime(!1) : 0;
            },
            getAdTotalDuration: function getAdTotalDuration() {
              return this._adsAdapter ? this._adsAdapter.chronos.total.getDeltaTime(!1) : -1;
            },
            getAdViewedDuration: function getAdViewedDuration() {
              return this._getTimeMaxOrAcum(!0);
            },
            getAdViewability: function getAdViewability() {
              return this._getTimeMaxOrAcum();
            },
            _getTimeMaxOrAcum: function _getTimeMaxOrAcum(t) {
              var e = 0;
              return this._adsAdapter && this._adsAdapter.chronos.viewedMax.forEach(function (i) {
                t ? e += i.getDeltaTime(!1) : e = Math.max(i.getDeltaTime(!1), e);
              }), e;
            },
            getAudioEnabled: function getAudioEnabled() {
              return this._safeGetterAdsAdapter("getAudioEnabled");
            },
            getIsSkippable: function getIsSkippable() {
              return this._safeGetterAdsAdapter("getIsSkippable");
            },
            getIsFullscreen: function getIsFullscreen() {
              return this._safeGetterAdsAdapter("getIsFullscreen");
            },
            _safeGetterAdsAdapter: function _safeGetterAdsAdapter(t, e) {
              var i;
              if (e && this.options[e]) i = this.options[e];else try {
                this._adsAdapter && "function" == typeof this._adsAdapter[t] && (i = this._adsAdapter[t]());
              } catch (e) {
                n.warn(u, "An error occured while calling " + t, e);
              }
              return i;
            },
            getNewAdNumber: function getNewAdNumber() {
              var t = this.requestBuilder.lastSent.adNumber;
              return t && this.requestBuilder.lastSent.position === this.getAdPosition() ? t += 1 : t = 1, this.requestBuilder.lastSent.adNumber = t, t;
            },
            getNewAdNumberInBreak: function getNewAdNumberInBreak() {
              return this._adNumberInBreak++, this.requestBuilder.lastSent.adNumberInBreak = this._adNumberInBreak, this._adNumberInBreak;
            },
            getNewBreakNumber: function getNewBreakNumber() {
              var t = 1;
              return this._adNumberInBreak = 0, this.requestBuilder.lastSent.breakNumber && (t = this.requestBuilder.lastSent.breakNumber + 1), t && this.requestBuilder.lastSent.position !== this.getAdPosition() && (t = 1), this.requestBuilder.lastSent.breakNumber = t, t;
            },
            getAccurateGeoLocation: function getAccurateGeoLocation() {
              return this.lastKnownLocation;
            }
          };
          t.exports = h;
        },
        5031: function _(t, e, i) {
          var _i92 = i(7276),
            s = _i92.default;
          var n = i(3782);
          var _i93 = i(6933),
            r = _i93.default,
            _i94 = i(9065),
            a = _i94.default,
            _i95 = i(3555),
            o = _i95.default,
            _i96 = i(2784),
            d = _i96.AnalyticsTag,
            c = _i96.Method,
            _i97 = i(1577),
            u = _i97.default,
            _i98 = i(61),
            l = _i98.default;
          var h = {
            _startPings: function _startPings() {
              if (!this.sendingPings) {
                var t = this.plugin.isMethodPostEnabled() ? c.POST : c.GET;
                var _e45 = 1e3 * a.getInstance().getFastDataService().getPingTime();
                a.getInstance().pushPeriodicDataFromCallback(this.plugin.options.offline ? l.Consumer.PERSISTENT : l.Consumer.NQS, this.getVideoKey(), n.Service.PING, _e45, t, this._sendPing.bind(this), this._onPingSuccess.bind(this)), this.sendingPings = !0;
              }
            },
            _onPingSuccess: function _onPingSuccess() {
              r.getInstance().addNQSRequest(n.Service.PING), this.lastEventTime = new Date().getTime();
            },
            _stopPings: function _stopPings() {
              a.getInstance().unregisterPeriodicPush(this.getVideoKey()), this.sendingPings = !1;
            },
            _sendPing: function _sendPing() {
              if (!this.plugin.analyticsRequestHandler.shouldSendStats()) return;
              var t = new Date().getTime(),
                e = this.timeSinceLastPing ? t - this.timeSinceLastPing : 5e3;
              this.timeSinceLastPing = t;
              var i = {
                diffTime: e,
                entities: this.requestBuilder.getChangedEntities([this, this.plugin])
              };
              if (this._adapter && (i = this._adapter.flags.isPaused ? this.requestBuilder.fetchParams(i, ["pauseDuration"], !1, [this, this.plugin], this.options) : this.requestBuilder.fetchParams(i, ["bitrate", "throughput", "fps"], !1, [this, this.plugin], this.options), this._adapter.flags.isJoined && (i = this.requestBuilder.fetchParams(i, ["playhead"], !1, [this, this.plugin], this.options)), this._adapter.flags.isBuffering && (i = this.requestBuilder.fetchParams(i, ["bufferDuration"], !1, [this, this.plugin], this.options)), this._adapter.flags.isSeeking && (i = this.requestBuilder.fetchParams(i, ["seekDuration"], !1, [this, this.plugin], this.options))), this._adsAdapter && !this.options["ad.ignore"] && (this._adsAdapter.flags.isStarted && (i = this.requestBuilder.fetchParams(i, ["adPlayhead", "adViewedDuration", "adViewability"], !1, [this, this.plugin], this.options), i = this._adsAdapter.flags.isPaused ? this.requestBuilder.fetchParams(i, ["adPauseDuration"], !1, [this, this.plugin], this.options) : this.requestBuilder.fetchParams(i, ["adBitrate"], !1, [this, this.plugin], this.options)), this._adsAdapter.flags.isBuffering && (i = this.requestBuilder.fetchParams(i, ["adBufferDuration"], !1, [this, this.plugin], this.options))), i = this.requestBuilder.buildParams(i, n.Service.PING, [this, this.plugin], this.options), this.controlPlayerExists() && this._adapter && !this._adapter.checkExistsPlayer()) return s.debug(d, "Detected player no exists, and fire stop event"), void this._adapter.fireStop();
              r.getInstance().setTriedSendingNQSStats(!0);
              var a = this.plugin.isMethodPostEnabled() ? c.POST : c.GET;
              var u = new o(n.Service.PING, i, this.getVideoKey(), a);
              var l = u.getVideoKey(),
                h = u.getService();
              var p = this.plugin.analyticsRequestHandler.onWillSendVideoRequestListeners;
              var _iterator11 = _createForOfIteratorHelper(p),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var _t38 = _step11.value;
                  _t38(h, l, i);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              return this.plugin.analyticsRequestHandler.prepareParams(u), s.verbose(d, n.Service.PING), this.startDelayed && this._retryStart(), u.getParams();
            }
          };
          t.exports = h;
        },
        5651: function _(t, e, i) {
          var s = i(1593);
          var _i99 = i(7276),
            n = _i99.default,
            _i100 = i(2784),
            r = _i100.AnalyticsTag;
          var a = s.extend({
            constructor: function constructor(t) {
              this.plugin = t, this.videos = {};
            },
            existsVideo: function existsVideo(t) {
              return t = t || "default", !!this.videos[t];
            },
            getVideo: function getVideo(t) {
              if (t = t || "default", this.videos[t]) return this.videos[t];
            },
            setVideo: function setVideo(t) {
              this.videos[this._parseVideoKey(t.getVideoKey())] = t;
            },
            getVideoKeys: function getVideoKeys() {
              return Object.keys(this.videos);
            },
            existsAdapter: function existsAdapter(t) {
              return t = t || "default", !(!this.videos[t] || !this.videos[t]._adapter);
            },
            getAdapter: function getAdapter(t) {
              if (t = t || "default", this.videos[t]) return this.videos[t].getAdapter();
            },
            setAdapter: function setAdapter(t, e) {
              e = e || "default", this.videos[e] && this.videos[e].setAdapter(t, this.plugin);
            },
            getAdsAdapter: function getAdsAdapter(t) {
              if (t = t || "default", this.videos[t]) return this.videos[t].getAdsAdapter();
            },
            removeAdapter: function removeAdapter(t, e) {
              e = e || "default";
              try {
                this.videos[e] && this.videos[e].removeAdapter();
              } catch (t) {
                n.error(r, "Is not possible to remove adapter for video: " + e);
              }
            },
            removeAllAdapters: function removeAllAdapters() {
              for (var _i101 = 0, _Object$keys3 = Object.keys(this.videos); _i101 < _Object$keys3.length; _i101++) {
                var _t39 = _Object$keys3[_i101];
                this.videos[_t39].removeAdapter(), this.videos[_t39].removeAdsAdapter();
              }
            },
            sendRequest: function sendRequest(t, e, i, s, a, o, d, c) {
              t = t || "default", this.videos[t] ? this.videos._send(this._key, e, i, s, a, o, d, c) : n.error(r, "Can't send request for not existent video object");
            },
            updateAllOptions: function updateAllOptions(t) {
              for (var _e46 in this.videos) for (var _i102 in t) this.videos[_e46].options[_i102] = t[_i102];
              t["adapters.templates"] && (this.plugin._setAdapterTemplates(t["adapters.templates"]), this.updateAdapterTemplates(t["adapters.templates"]));
            },
            updatePingInterval: function updatePingInterval(t) {
              for (var e in this.videos) this.videos[e]._ping.interval = t;
            },
            updateAdapterTemplates: function updateAdapterTemplates(t) {
              if (t && this.videos) for (var e in this.videos) this.videos[e]._adapter && this.videos[e]._adapter.updateAdapterTemplates(t);
            },
            resetVideo: function resetVideo(t) {
              t = t || "default", this.video[t] && this.video[t]._reset();
            },
            _parseVideoKey: function _parseVideoKey(t) {
              return t || "default";
            }
          });
          t.exports = a;
        }
      },
      e = {};
    function i(s) {
      var n = e[s];
      if (void 0 !== n) return n.exports;
      var r = e[s] = {
        exports: {}
      };
      return t[s].call(r.exports, r, r.exports, i), r.exports;
    }
    i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, {
        a: e
      }), e;
    }, i.d = function (t, e) {
      for (var s in e) i.o(e, s) && !i.o(t, s) && Object.defineProperty(t, s, {
        enumerable: !0,
        get: e[s]
      });
    }, i.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var s = {};
    return function () {
      "use strict";

      i.d(s, {
        default: function _default() {
          return $i;
        }
      });
      var t = {};
      i.r(t), i.d(t, {
        VERSION: function VERSION() {
          return Le;
        },
        addSidxSegmentsToPlaylist: function addSidxSegmentsToPlaylist() {
          return Kt;
        },
        generateSidxKey: function generateSidxKey() {
          return ee;
        },
        inheritAttributes: function inheritAttributes() {
          return De;
        },
        parse: function parse() {
          return Ce;
        },
        parseUTCTiming: function parseUTCTiming() {
          return Oe;
        },
        stringToMpdXml: function stringToMpdXml() {
          return Re;
        },
        toM3u8: function toM3u8() {
          return ue;
        },
        toPlaylists: function toPlaylists() {
          return ye;
        }
      });
      var e = i(9065),
        n = i(7276),
        r = i(2784),
        a = i(5438);
      var o = d;
      function d(t, e) {
        var i = u();
        return (d = function d(t, e) {
          return i[t -= 137];
        })(t, e);
      }
      !function (t, e) {
        var i = d,
          s = t();
        for (;;) try {
          if (784217 == -parseInt(i(146)) / 1 * (-parseInt(i(178)) / 2) + parseInt(i(165)) / 3 + parseInt(i(137)) / 4 + parseInt(i(150)) / 5 * (-parseInt(i(158)) / 6) + -parseInt(i(153)) / 7 * (-parseInt(i(167)) / 8) + -parseInt(i(184)) / 9 * (-parseInt(i(157)) / 10) + -parseInt(i(185)) / 11 * (parseInt(i(152)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(u);
      var c = /*#__PURE__*/function (_o6, _o7, _o8, _o9, _o10, _o11, _o12, _o13, _o14) {
        function c() {
          _classCallCheck(this, c);
        }
        _createClass(c, null, [{
          key: _o6,
          value: function value(t) {
            var e = o,
              i = new URL(t),
              s = i[e(142)] + i[e(169)],
              n = s[e(140)]("/") + 1;
            return {
              route: s[e(170)](0, n),
              fileName: s[e(170)](n)
            };
          }
        }, {
          key: _o7,
          value: function value(t) {
            var e = o;
            return {
              path: new URL(t)[e(169)]
            };
          }
        }, {
          key: _o8,
          value: function value(t) {
            return new Promise(function (e) {
              return setTimeout(e, t);
            });
          }
        }, {
          key: "findPathMach",
          value: function findPathMach(t, e, i) {
            var s = o;
            var n = i.url;
            t = t.split("?")[0];
            var r = new URL(t),
              a = new URL(e);
            r[s(168)] != a[s(168)] && (r[s(168)] = a[s(168)], t = r.toString());
            var d = e;
            if (null != e && "" != e) for (; !t[s(181)](d) && d[s(181)]("/");) {
              d[s(145)]("/") && (d = d[s(154)](0, d[s(183)] - 1));
              var _t40 = d[s(154)](d[s(140)]("/"), d[s(183)]);
              if ((n[s(145)](_t40) || n[s(145)](_t40 + "/")) && (n[s(145)]("/") && (n = n[s(154)](0, n[s(183)] - 1)), n = n.substr(0, n[s(140)]("/") + 1)), d = d[s(154)](0, d[s(140)]("/") + 1), d == s(175) || d == s(177)) return "";
            }
            return t[s(180)](d, n);
          }
        }, {
          key: _o9,
          value: function value(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var i = o;
            var s = [t.indexOf("?")];
            return e && s[i(144)](t[i(171)](";")), s = s[i(155)](function (t) {
              return -1 != t;
            }), t.slice(0, Math.min.apply(Math, _toConsumableArray(s)));
          }
        }, {
          key: _o10,
          value: function value(t) {
            var e = o;
            var i = !1;
            return a.Y4[e(172)](function (s) {
              i = i || t[e(145)](s);
            }), i;
          }
        }, {
          key: _o11,
          value: function value(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var i = o;
            var s = !1;
            var n = e ? c[i(160)](t, e) : t;
            return a.w2[i(172)](function (t) {
              s = s || n[i(145)](t);
            }), s;
          }
        }, {
          key: _o12,
          value: function value(t) {
            var e = o;
            return String[e(174)][e(149)](null, new Uint8Array(t));
          }
        }, {
          key: _o13,
          value: function value(t) {
            var e = o;
            var i = "";
            var s = t[e(183)] - 1;
            return s > 0 && (i = t[Math[e(147)](Math[e(179)]() * s)]), i;
          }
        }, {
          key: _o14,
          value: function value(t) {
            var e = o;
            return "?" + Object[e(173)](t)[e(138)](function (e) {
              return "" === t[e] ? "" : e + "=" + encodeURIComponent(t[e]);
            })[e(151)]("&");
          }
        }, {
          key: "ifByteArrayToString",
          value: function ifByteArrayToString(t) {
            var e = o;
            if (typeof t != e(143)) {
              var _s19 = new Uint8Array(t);
              var _n15 = "";
              for (var i = 0; i < _s19[e(183)]; i++) _n15 += String[e(174)](_s19[i]);
              return _n15;
            }
            return t;
          }
        }, {
          key: "isValidUrl",
          value: function isValidUrl(t) {
            try {
              return new URL(t), !0;
            } catch (t) {
              return !1;
            }
          }
        }, {
          key: "isHeaderMatch",
          value: function isHeaderMatch(t, e) {
            var i = o;
            var s = !1;
            return "list" === e[i(141)] ? s = e[i(148)][i(138)](function (t) {
              return t;
            })[i(181)](t) : e[i(141)] === i(182) && (s = new RegExp(e[i(148)])[i(156)](t)), s;
          }
        }]);
        return c;
      }(o(162), o(164), o(166), o(160), o(163), o(176), o(139), o(161), o(159));
      function u() {
        var t = ["origin", "string", "push", "endsWith", "1YHesUX", "round", "pattern", "apply", "10505TdHvMH", "join", "96684FuVOHw", "7fwAZFm", "substr", "filter", "test", "10bdcwHR", "2166JvHRfZ", "formatParameters", "sliceByFirstSpecial", "returnRandom", "getRouteAndFilename", "isMedia", "getPath", "1528758HjSOeg", "delay", "5507528rjFLqq", "host", "pathname", "slice", "indexOf", "forEach", "keys", "fromCharCode", "https://", "isManifest", "http://", "1747038zFtipd", "random", "replace", "includes", "regex", "length", "3623589LSZRKX", "1353dwAMCr", "238088vouNpt", "map", "bufferToString", "lastIndexOf", "type"];
        return (u = function u() {
          return t;
        })();
      }
      function l(t, e) {
        var i = p();
        return (l = function l(t, e) {
          return i[t -= 418];
        })(t, e);
      }
      var h = l;
      function p() {
        var t = ["setEstimator", "verbose", "2857195mbAwAQ", "2507716tUHzdT", "_cdnBalancer", "arraybuffer", "string", "readyState", "method", "_totalDownloadTime", "pathname", "url", "network", "2003622dPMCSG", "useTheoplayer", "addRequestInterceptor", "responseType", "1472130rQJGMR", "659534AdjJqZ", "stream", "setRequestHeader", "statusText", "endsWith", "3564162TMJNRD", "6YREAha", "1129912EeNaEz", "removeRequestInterceptor", "unload", "onreadystatechange", "headers", ".m3u8", "2lSRELo", "now", "respondWith", "status", "response", "_interceptor", "byteLength", "type", "load", "ifByteArrayToString", "isNaN", "length", "_player", "body"];
        return (p = function p() {
          return t;
        })();
      }
      !function (t, e) {
        var i = l,
          s = t();
        for (;;) try {
          if (439685 == -parseInt(i(426)) / 1 + -parseInt(i(439)) / 2 * (-parseInt(i(421)) / 3) + -parseInt(i(456)) / 4 + parseInt(i(455)) / 5 * (parseInt(i(432)) / 6) + parseInt(i(431)) / 7 + parseInt(i(433)) / 8 + -parseInt(i(425)) / 9) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(p);
      var f = /*#__PURE__*/function (_h, _h2) {
        function f(t, e) {
          _classCallCheck(this, f);
          var i = l;
          this._totalDownloadedBytes = 0, this[i(462)] = 0, this[i(451)] = t, this._cdnBalancer = e;
        }
        _createClass(f, [{
          key: _h,
          value: function value() {
            var t = h;
            this[t(451)] && this._cdnBalancer && (this._totalDownloadedBytes = 0, this._totalDownloadTime = 0, this[t(457)][t(422)](), this[t(423)]());
          }
        }, {
          key: _h2,
          value: function value() {
            var t = h;
            this[t(451)][t(420)][t(434)](this._interceptor);
          }
        }, {
          key: "addRequestInterceptor",
          value: function addRequestInterceptor() {
            var _this24 = this;
            var t = h;
            this[t(444)] = function (t) {
              t.waitUntil(function (e) {
                var i = l,
                  s = new XMLHttpRequest();
                var a = 0,
                  o = 0,
                  d = 0;
                t[i(424)] === i(427) ? s[i(424)] = i(458) : s[i(424)] = t[i(424)], s[i(436)] = function (u) {
                  var l = i;
                  if (1 === s[l(460)] && "manifest" !== t.type && (a = Date.now()), 2 === s[l(460)] && "manifest" !== t[l(446)] && (o = Date.now(), d = o - a), 4 === s[l(460)]) {
                    var _i103 = {
                      status: s[l(442)],
                      statusText: s[l(429)],
                      body: void 0
                    };
                    if (s[l(442)] >= 200 && s.status < 400) {
                      var _e47 = new URL(t[l(419)])[l(418)];
                      if (_e47[l(430)](l(438)) || _e47[l(430)](".mpd") ? _i103[l(452)] = c[l(448)](s[l(443)]) : _i103.body = s[l(443)], "manifest" !== t[l(446)] && d > 0) {
                        var _t41 = Date[l(440)]() - o;
                        _this24[l(462)] += _t41, _this24._totalDownloadedBytes += s[l(443)][l(445)];
                        var _e48 = _this24._totalDownloadedBytes / (_this24._totalDownloadTime / 1e3);
                        Number[l(449)](_e48) && (_e48 = (typeof s.response === l(459) ? s[l(443)][l(450)] : s[l(443)][l(445)]) / (d / 1e3)), _this24[l(451)][l(420)][l(453)]({
                          bandwidth: 8 * _e48,
                          roundTripTime: d / 1e3,
                          createMeasurer: function createMeasurer() {}
                        });
                      }
                      t[l(441)](_i103);
                    } else t[l(441)](_i103);
                    n.default[l(454)](r.BalancerTag, "Theoplayer interceptor - Completed request for -> " + s.responseURL), e();
                  }
                }, n.default[i(454)](r.BalancerTag, "Theoplayer interceptor - Intercepting request to -> " + t.url), s.open(t[i(461)], t.url);
                for (var _e49 in t[i(437)]) s[i(428)](_e49, t.headers[_e49]);
                s.send(t[i(452)]);
              });
            }, this._player.network[t(423)](this[t(444)]);
          }
        }]);
        return f;
      }(h(447), h(435));
      var g = m;
      function m(t, e) {
        var i = v();
        return (m = function m(t, e) {
          return i[t -= 297];
        })(t, e);
      }
      function v() {
        var t = ["2232ShDVLM", "1813301VmCuLa", "126395zmArHo", "loadedInterceptors", "298892RWmIPi", "9819gVoXFZ", "456HwaBZZ", "load", "removeInterceptors", "161333JSryQZ", "1439830wJsrCl", "6MPVUQz", "loadInterceptor", "_cdnBalancer", "44WGXnSa", "247078jValya", "6rNSpNb"];
        return (v = function v() {
          return t;
        })();
      }
      !function (t, e) {
        var i = m,
          s = t();
        for (;;) try {
          if (247419 == -parseInt(i(304)) / 1 + -parseInt(i(310)) / 2 * (parseInt(i(311)) / 3) + -parseInt(i(309)) / 4 * (parseInt(i(297)) / 5) + parseInt(i(306)) / 6 * (-parseInt(i(313)) / 7) + -parseInt(i(312)) / 8 * (-parseInt(i(300)) / 9) + -parseInt(i(305)) / 10 + -parseInt(i(299)) / 11 * (-parseInt(i(301)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(v);
      var y = /*#__PURE__*/function (_g, _g2) {
        function y(t) {
          _classCallCheck(this, y);
          var e = m;
          this[e(298)] = [], this[e(308)] = t;
        }
        _createClass(y, [{
          key: _g,
          value: function value(t, e) {
            var i = g;
            var s;
            "theoplayer" === t.toLowerCase() && (s = new f(e, this[i(308)])), s && (s[i(302)](), this[i(298)].push(s));
          }
        }, {
          key: _g2,
          value: function value() {
            var _iterator12 = _createForOfIteratorHelper(this.loadedInterceptors),
              _step12;
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _t42 = _step12.value;
                null == _t42 || _t42.unload();
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
          }
        }]);
        return y;
      }(g(307), g(303));
      !function (t, e) {
        for (var i = S, s = t();;) try {
          if (354832 == -parseInt(i(439)) / 1 + -parseInt(i(436)) / 2 * (parseInt(i(440)) / 3) + parseInt(i(429)) / 4 * (-parseInt(i(437)) / 5) + -parseInt(i(431)) / 6 + -parseInt(i(425)) / 7 * (parseInt(i(421)) / 8) + parseInt(i(423)) / 9 + parseInt(i(434)) / 10) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(E);
      var T = /*#__PURE__*/_createClass(function T(t) {
        _classCallCheck(this, T);
        var e,
          i,
          s,
          n,
          r,
          a,
          o,
          d = S;
        this[d(433)] = !1, this[d(424)] = 0, this.reportTime = 5, this[d(426)] = !1, this[d(420)] = [], this.domainWhitelistRegex = [], this[d(419)] = !1, this[d(427)] = !1, this[d(430)] = !1, this[d(428)] = null == t ? void 0 : t[d(428)], this.bucketName = null == t ? void 0 : t[d(435)], this.isLive = (null == t ? void 0 : t[d(433)]) || !1, this[d(432)] = null == t ? void 0 : t[d(432)], this.resource = null == t ? void 0 : t[d(416)], this[d(424)] = null !== (e = null == t ? void 0 : t[d(424)]) && void 0 !== e ? e : 0, this[d(415)] = null !== (i = null == t ? void 0 : t[d(415)]) && void 0 !== i ? i : 0, this[d(418)] = null == t ? void 0 : t[d(418)], this[d(422)] = null == t ? void 0 : t[d(422)], this[d(438)] = null == t ? void 0 : t[d(438)], this.domainWhitelist = null !== (s = null == t ? void 0 : t.domainWhitelist) && void 0 !== s ? s : [], this[d(417)] = null !== (n = null == t ? void 0 : t[d(417)]) && void 0 !== n ? n : [], this[d(419)] = null !== (r = null == t ? void 0 : t[d(419)]) && void 0 !== r && r, this[d(427)] = null !== (a = null == t ? void 0 : t[d(427)]) && void 0 !== a && a, this.allowSpecialDelimitersInUrl = null !== (o = null == t ? void 0 : t[d(430)]) && void 0 !== o && o;
      });
      function S(t, e) {
        var i = E();
        return (S = function S(t, e) {
          return i[t -= 415];
        })(t, e);
      }
      function E() {
        var t = ["profileName", "92fYUrUG", "allowSpecialDelimitersInUrl", "2177322BGaLmH", "videoId", "isLive", "7406510zMgaei", "bucketName", "1200qdYqGL", "1595bPsgFE", "timeBetweenHeads", "139660bmqQvb", "711qypPHi", "reportTime", "resource", "domainWhitelistRegex", "debug", "probeOnlyOnBanned", "domainWhitelist", "8AsiZTW", "isDev", "3254328rjkCyY", "updateTime", "667289neXdJU", "forceDecisionCall", "noProbing"];
        return (E = function E() {
          return t;
        })();
      }
      function b(t, e) {
        var i = w();
        return (b = function b(t, e) {
          return i[t -= 377];
        })(t, e);
      }
      var A = b;
      function w() {
        var t = ["14gJfEMe", "splice", "data", "_listeners", "90443rMdEjy", "3rxNyDg", "653570sXuIKv", "455814PpEOkV", "off", "push", "12JPWvid", "10GTdzGj", "emit", "1568024uEAedD", "115074voUlHM", "forEach", "753269sWKRhA", "83756nkwXsZ"];
        return (w = function w() {
          return t;
        })();
      }
      !function (t, e) {
        var i = b,
          s = t();
        for (;;) try {
          if (207716 == -parseInt(i(392)) / 1 + parseInt(i(377)) / 2 + parseInt(i(393)) / 3 * (parseInt(i(387)) / 4) + parseInt(i(394)) / 5 * (-parseInt(i(380)) / 6) + parseInt(i(388)) / 7 * (parseInt(i(383)) / 8) + -parseInt(i(384)) / 9 * (parseInt(i(381)) / 10) + -parseInt(i(386)) / 11) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(w);
      var _ = /*#__PURE__*/function (_A, _A2) {
        function _() {
          _classCallCheck(this, _);
          this[b(391)] = {};
        }
        _createClass(_, [{
          key: "on",
          value: function on(t, e) {
            var i = b;
            return !this[i(391)][t] && (this[i(391)][t] = []), this._listeners[t][i(379)](e), this;
          }
        }, {
          key: _A,
          value: function value(t, e) {
            var i = A;
            if (this[i(391)][t]) if (e) {
              var _s20 = this._listeners[t].indexOf(e);
              -1 !== _s20 && this[i(391)][t][i(389)](_s20, 1);
            } else this[i(391)][t] = [];
            return this;
          }
        }, {
          key: _A2,
          value: function value(t) {
            var _this25 = this;
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var i = arguments.length > 2 ? arguments[2] : undefined;
            var s = A;
            return [t, "*"][s(385)](function (n) {
              var r = s;
              _this25._listeners[n] && _this25._listeners[n][r(385)](function (s) {
                var n = i || r(390);
                s(_defineProperty({
                  type: t
                }, n, e));
              });
            }), this;
          }
        }]);
        return _;
      }(A(378), A(382));
      var I = i(1048).hp;
      var N = R;
      function P() {
        var t = ["totalErrors", "ping", "64236zCoyEV", "timeout", "activeP2PSendProcesses", "debug", "peerSegmentLoaded", "_cancelRequest", "getByteArrayFromIdentifier", "80SOOuBN", "OPERATION ID -> ", "parse", "_loader", "trim", "clear", "getTotalSendTime", "destroy", "version", "P2P Pong to ", "_version", "455KAvsQx", "1647536EKHdKR", "sendSegment", "min", "error", "errorDetail", "_totalSendSegments", "peerSegmentProgress", "get", "splice", "getIceAnswer", "timeouts", "peerSegmentUploadRequest", "This peer may timeout in ", "cancel", "time", "timeGap", "getVersion", "byteLength", "Could not send message to peer (maybe it was destroyed)", "pong", "_startTimeout", "command", "_getLastSecondsTraffic", "sendNewSegmentAvailable", "_onData", "_totalSendBytes", "_decoder", "_segmentMap", "24870wgpMcH", "totalDataInterval", "downloadingProcessActive", "_peer", "_onClose", "_onError", "_lastSent", "createdAt", "storageSize", "from", "stringify", "verbose", "Timeout ", "c=IN IP4", "2493025fQervf", "_lastBandwith", "_lastLatencyP2P", "getDownloadBandwidth", "message", "_send", "connect", "_ip", "send", "identifier", "peerFailedSegmentAbsent", "realBodySize", "then", "_downloaded", "getLastDownloadsTraffic", "consecutiveHaveSegment", "foreSegmentsInfo", "apply", "_identifierShort", "_totalDownloaded", "splits", "p2p not wrong -> ", "503520ALejlh", "getIp", "getLastLatencyP2P", "pop", "_lastResponses", "map", "sdp", "_destroyed", "floor", "_answer", "size", "buffer", "getTotalSendBytes", "getLastUploadsTraffic", "addPeerResponse", "sendNoSegment", "_endDownload", " download end ", "delete", "P2P Upload canceled.", "137982OkOpNC", "P2P Ping to ", "_lastLatencySegment", "maxMessageSize", "_segmendDataMessages", "testLatencyResult", "isBehind", "CREATEPEERCONNECTING?", "length", "getLastResponses", "_totalDownloadedBytes", "newSegmentAvailable", "Download ended ", "getIdentifierFromByteArray", "_totalDownloadTime", "getLastSegmentDataMessagesTime", "Absent", "decode", "_cancel", "_onConnect", "getDownloadedBytes", "1323351bYxuzV", "startTime", "addPeerLatency", " not an active download id", "request", "_activeDownloads", "_lastSegmendDataMessagesTime", "concat", "set", "testBandwidthResult", "getStorage", "_totalSendTime", "_operationId", "peerCloseListener", "sendMap", "12MBKUXl", "sctp-failure", "data", "isAhead", "value", "__awaiter", "testBandwidthDone", "forEach", "push", "bind", "slice", "getDownloadedChunks", "P2P onConnect to ", "now"];
        return (P = function P() {
          return t;
        })();
      }
      !function (t, e) {
        var i = R,
          s = t();
        for (;;) try {
          if (263740 == parseInt(i(467)) / 1 + -parseInt(i(415)) / 2 * (-parseInt(i(451)) / 3) + parseInt(i(395)) / 4 + parseInt(i(528)) / 5 + -parseInt(i(514)) / 6 * (-parseInt(i(485)) / 7) + parseInt(i(486)) / 8 + -parseInt(i(436)) / 9 * (parseInt(i(474)) / 10)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(P);
      var D = function D(t, e, i, s) {
        return new (i || (i = Promise))(function (n, r) {
          function a(t) {
            try {
              d(s.next(t));
            } catch (t) {
              r(t);
            }
          }
          function o(t) {
            try {
              d(s.throw(t));
            } catch (t) {
              r(t);
            }
          }
          function d(t) {
            var e = R;
            var s;
            t.done ? n(t[e(455)]) : (s = t[e(455)], s instanceof i ? s : new i(function (t) {
              t(s);
            }))[e(540)](a, o);
          }
          d((s = s[R(390)](t, e || [])).next());
        });
      };
      function R(t, e) {
        var i = P();
        return (R = function R(t, e) {
          return i[t -= 389];
        })(t, e);
      }
      var L = /*#__PURE__*/function (_ref, _N, _N2, _N3, _N4, _N5, _N6, _N7, _N8, _N9, _N10, _N11, _N12, _N13, _N14, _N15, _N16, _N17, _N18, _N19, _N20, _N21, _N22, _N23, _N24, _N25, _N26, _N27) {
        _inherits(L, _ref);
        var _super2 = _createSuper(L);
        function L(t, e, i) {
          var _this26;
          _classCallCheck(this, L);
          var s = N;
          _this26 = _super2.call(this), _this26._segmentMap = [], _this26._activeDownloads = new Map(), _this26[s(399)] = [], _this26[s(520)] = [], _this26[s(512)] = new TextDecoder(), _this26[s(391)] = Math.round(65536 * Math.random()) - 32768, _this26[s(541)] = [], _this26[s(392)] = 0, _this26._totalDownloadedBytes = 0, _this26[s(429)] = 0, _this26.consecutiveHaveSegment = 0, _this26[s(496)] = 0, _this26[s(516)] = !1, _this26[s(484)] = 0, _this26[s(511)] = 0, _this26[s(447)] = 0, _this26[s(491)] = 0, _this26[s(530)] = 0, _this26._lastLatencySegment = 0, _this26[s(529)] = 0, _this26[s(535)] = void 0, _this26[s(419)] = 0, _this26[s(442)] = 0, _this26._destroyed = !1, _this26[s(389)] = !1, _this26.isAhead = !1, _this26.isBehind = !1, _this26[s(501)] = 0, _this26[s(448)] = 0, _this26[s(465)] = 0, _this26[s(433)] = new Map(), _this26.testLatencyDone = !1, _this26[s(457)] = !1, _this26[s(420)] = 0, _this26[s(445)] = 0, _this26[s(404)] = i, _this26.id = e.id, _this26[s(517)] = e, _this26._loader = t, e.on(a.Lg[s(534)], _this26[s(434)][s(460)](_assertThisInitialized(_this26))), e.on(a.Lg.close, _this26[s(518)][s(460)](_assertThisInitialized(_this26))), e.on(a.Lg[s(489)], _this26._onError[s(460)](_assertThisInitialized(_this26))), e.on(a.Lg[s(453)], _this26[s(510)][s(460)](_assertThisInitialized(_this26)));
          return _this26;
        }
        _createClass(L, [{
          key: _N,
          value: function value() {
            return this[N(404)];
          }
        }, {
          key: _N2,
          value: function value() {
            return this[N(511)];
          }
        }, {
          key: _N3,
          value: function value() {
            return this[N(447)];
          }
        }, {
          key: "getTotalSendSegments",
          value: function getTotalSendSegments() {
            return this[N(491)];
          }
        }, {
          key: _N4,
          value: function value() {
            return this._totalDownloadedBytes;
          }
        }, {
          key: _N5,
          value: function value() {
            return this[N(392)];
          }
        }, {
          key: _N6,
          value: function value() {
            var t = N;
            return 0 == this._totalDownloadTime ? 0 : this[t(425)] * (this._totalDownloadTime / 1e3);
          }
        }, {
          key: _N7,
          value: function value() {
            return this[N(530)];
          }
        }, {
          key: "getLastLatencySegment",
          value: function getLastLatencySegment() {
            return this._lastLatencySegment;
          }
        }, {
          key: "getLastBandwith",
          value: function getLastBandwith() {
            return this[N(529)];
          }
        }, {
          key: _N8,
          value: function value() {
            var t = N;
            var e;
            if (null != this[t(535)]) return this[t(535)];
            var i = null === (e = this[t(404)]) || void 0 === e ? void 0 : e[t(401)];
            if (null != i) try {
              var _e50 = i.split(t(527))[1];
              _e50 = _e50[t(478)]();
              var _s22 = _e50.split(" ")[0];
              _s22 = _e50.split("a=")[0], _s22 = _s22.trim(), this[t(535)] = _s22;
            } catch (t) {}
          }
        }, {
          key: _N9,
          value: function value() {
            return this[N(399)];
          }
        }, {
          key: _N10,
          value: function value() {
            return this[N(484)];
          }
        }, {
          key: "isDownloading",
          value: function isDownloading() {
            var t = N;
            return this._activeDownloads[t(405)] > 0;
          }
        }, {
          key: "getSegmentDataMessages",
          value: function getSegmentDataMessages() {
            return this._segmendDataMessages;
          }
        }, {
          key: _N11,
          value: function value() {
            return this[N(442)];
          }
        }, {
          key: _N12,
          value: function value() {
            var t = N;
            this[t(517)][t(481)](), this[t(518)](), this[t(402)] = !0;
          }
        }, {
          key: "_onConnect",
          value: function _onConnect() {
            var t = N;
            n.default[t(525)](r.BalancerTag, t(422) + this.id), this[t(402)] || (n.default[t(470)](r.BalancerTag, t(463) + this.id), this[t(477)].peerConnect(this));
          }
        }, {
          key: _N13,
          value: function value(t) {
            var e = N;
            var i, s;
            n.default[e(470)](r.BalancerTag, "P2P onError to " + this.id + " " + (null === (i = null == t ? void 0 : t.error) || void 0 === i ? void 0 : i[e(490)])), (null === (s = null == t ? void 0 : t.error) || void 0 === s ? void 0 : s[e(490)]) === e(452) && this[e(518)](), this.consecutiveHaveSegment = 0, this[e(465)]++;
          }
        }, {
          key: "_onClose",
          value: function _onClose() {
            var t = N;
            this._peer[t(481)](), this._activeDownloads[t(479)](), this._endDownload("Close callback", 0), this[t(477)][t(449)](this);
          }
        }, {
          key: _N14,
          value: function value(t, e) {
            var i = N;
            "Absent" === t && (n.default[i(470)](r.BalancerTag, "Probable algorithm failed"), this[i(543)] = 0);
            var s = this[i(441)].get(e);
            s && n.default[i(470)](r.BalancerTag, "Closing p2p download " + s.id), this[i(441)][i(413)](e);
          }
        }, {
          key: "_onData",
          value: function _onData(t) {
            var e = N;
            if (this[e(402)]) return;
            var i = t[e(461)](0, 4),
              s = t[e(461)](4, t[e(503)]),
              o = i[0],
              d = this[e(428)](t[e(461)](1, 3)),
              c = i[3];
            if (this[e(484)] < c && (this[e(484)] = c), o == a.b3[e(532)]) {
              var _t43 = JSON[e(476)](this[e(512)][e(432)](s));
              if (_t43[a.CE[e(507)]]) switch (_t43[a.CE[e(507)]]) {
                case a.mH[e(440)]:
                  this[e(477)][e(497)](this, _t43[a.CE.id], _t43[a.CE[e(537)]]);
                  break;
                case a.mH.map:
                  this[e(513)] = _t43[a.CE[e(400)]], this[e(419)]++, this._lastSegmendDataMessagesTime = Date[e(464)]();
                  break;
                case a.mH.newSegmentAvailable:
                  var _i104 = _t43[a.CE.id],
                    _s23 = (_t43[a.CE[e(405)]], _t43[a.CE[e(522)]]);
                  this[e(530)] = Date[e(464)]() - _t43[a.CE.dateTime], this[e(417)] = Date.now() - _t43[a.CE[e(521)]], this._loader[e(438)](this._lastLatencyP2P);
                  var _o15 = 0,
                    _c = this[e(477)][e(446)]().getSegment(_i104);
                  _c && (_o15 = _c[e(437)] - _t43[a.CE[e(521)]]), _o15 >= 0 ? (this[e(454)] = !0, this[e(421)] = !1) : (this.isAhead = !1, this[e(421)] = !0), this._segmentMap.unshift(_i104), this[e(513)].length > _s23 && this._segmentMap[e(398)]();
                  break;
                case a.mH.ping:
                  var _u = _t43[a.CE[e(537)]],
                    _l = _t43[a.CE.time];
                  this[e(505)](_u, _l);
                  break;
                case a.mH.pong:
                  var _h3 = Date.now() - _t43[a.CE.time];
                  this[e(477)][e(438)](_h3);
                  break;
                case a.mH[e(499)]:
                  this[e(433)][e(444)](_t43[a.CE[e(537)]], _t43[a.CE[e(537)]]);
                  break;
                case a.mH.absent:
                  {
                    var _i105 = _t43[a.CE[e(537)]] || 0,
                      _s24 = this[e(441)].get(_i105);
                    _s24 && _s24.id === _t43[a.CE.id] && (this[e(477)][e(538)](this, _s24.id), this[e(411)](e(431), d));
                  }
                  break;
                case a.mH[e(453)]:
                  {
                    var _i106 = this[e(441)][e(493)](_t43[a.CE[e(537)]]);
                    if (_i106 && (_i106.size = _t43[a.CE[e(405)]], 0 == _i106.startTime && (_i106[e(437)] = Date[e(464)]()), this._totalDownloaded >= 3 && this[e(531)]() > 0)) {
                      var _t44 = 1e3 * _i106[e(405)] / this.getDownloadBandwidth();
                      _t44 > 1.15 * a.LI[e(468)] && n.default[e(525)](r.BalancerTag, e(498) + _t44 + "ms");
                    }
                  }
              }
            } else if (o == a.b3[e(453)]) {
              var _t45 = this[e(441)].get(d);
              if (_t45 && _t45.id) {
                0 == _t45.startTime && (_t45[e(437)] = Date[e(464)]()), _t45[e(453)][e(459)](s);
                var _i107 = 0;
                _t45[e(453)][e(458)](function (t) {
                  _i107 += t[e(503)];
                });
                var _a5 = Date[e(464)]() - (_t45.startTime || Date.now());
                if (_i107 > _t45[e(405)] && n.default[e(470)](r.BalancerTag, "SOMETHING IS WRONG, Total p2p file size is bigger than expected size. " + _i107 + " " + _t45.size), _i107 == _t45.size) {
                  var _s25 = 0;
                  var _o16 = new Uint8Array(_i107);
                  var _iterator13 = _createForOfIteratorHelper(_t45[e(453)]),
                    _step13;
                  try {
                    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                      var _i108 = _step13.value;
                      _o16[e(444)](new Uint8Array(_i108), _s25), _s25 += _i108[e(503)];
                    }
                  } catch (err) {
                    _iterator13.e(err);
                  } finally {
                    _iterator13.f();
                  }
                  this[e(425)] = this[e(425)] + _o16.byteLength, this[e(392)]++, this._totalDownloadTime = this[e(429)] + _a5;
                  var _c2 = {
                    time: Date[e(464)](),
                    size: _o16[e(503)]
                  };
                  this._lastResponses[e(459)](_c2), this[e(477)][e(409)](_c2);
                  var _u2 = (Date[e(464)]() - _t45.startTime) / 1e3,
                    _l2 = _t45[e(405)] / _u2;
                  this._lastBandwith = _l2, this[e(541)][e(459)](_t45.id), this[e(477)][e(471)](this, _t45.id, _a5, _o16[e(406)]), n.default[e(470)](r.BalancerTag, e(394) + _t45.id + e(412) + _t45[e(405)]), this._endDownload(e(427) + _t45.id + " " + _t45[e(405)] + " | " + _i107, d);
                } else {
                  var _s26 = 0;
                  var _n16 = new Uint8Array(_i107);
                  var _iterator14 = _createForOfIteratorHelper(_t45[e(453)]),
                    _step14;
                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var _i109 = _step14.value;
                      _n16[e(444)](new Uint8Array(_i109), _s26), _s26 += _i109[e(503)];
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }
                  0 != _t45[e(405)] && this._loader[e(492)](this, _t45.id, _a5, _n16, _t45[e(405)]);
                }
              } else n.default[e(470)](r.BalancerTag, "P2P: " + this.id + e(439));
            }
          }
        }, {
          key: _N15,
          value: function value(t) {
            var e = N;
            if (this[e(402)]) return;
            this[e(484)] >= 2 && (this._operationId++, 0 == this[e(448)] && this._operationId++);
            var i = this[e(448)];
            n.default[e(470)](r.BalancerTag, e(475) + i), this[e(506)](t, i), this[e(533)](_defineProperty(_defineProperty(_defineProperty({}, a.CE[e(507)], a.mH[e(440)]), a.CE.id, t), a.CE[e(537)], i), a.b3.message);
          }
        }, {
          key: _N16,
          value: function value(t) {
            var e = N;
            n.default.debug(r.BalancerTag, e(416) + this.id), this[e(533)](_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, a.CE[e(507)], a.mH[e(466)]), a.CE[e(500)], Date[e(464)]()), a.CE.id, t), a.CE[e(537)], this.id), a.b3[e(532)]);
          }
        }, {
          key: "pong",
          value: function pong(t, e) {
            var i = N;
            n.default[i(470)](r.BalancerTag, i(483) + this.id), this[i(533)](_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, a.CE[i(507)], a.mH.pong), a.CE[i(500)], e), a.CE.id, t), a.CE.identifier, this.id), a.b3.message);
          }
        }, {
          key: _N17,
          value: function value(t, e) {
            var i = N;
            this[i(533)](_defineProperty(_defineProperty(_defineProperty({}, a.CE[i(507)], a.mH[i(499)]), a.CE.id, t), a.CE.identifier, e), a.b3[i(532)]);
          }
        }, {
          key: _N18,
          value: function value(t) {
            return D(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var e;
              return _regeneratorRuntime.wrap(function _callee$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    e = R;
                    this[e(402)] || this[e(533)](_defineProperty(_defineProperty({}, a.CE.command, a.mH.map), a.CE[e(400)], t), a.b3[e(532)]);
                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }, _callee, this);
            }));
          }
        }, {
          key: _N19,
          value: function value(t, e, i) {
            var s;
            return D(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var o, _d6, _c3, _u3, _l3, _h4, _p, _t46;
              return _regeneratorRuntime.wrap(function _callee2$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    o = R;
                    if (this[o(402)]) {
                      _context6.next = 28;
                      break;
                    }
                    if (!(e[o(453)] && this[o(433)] && null == this[o(433)][o(493)](i))) {
                      _context6.next = 26;
                      break;
                    }
                    this._send(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, a.CE[o(507)], a.mH[o(453)]), a.CE.id, t), a.CE[o(405)], e.realBodySize), a.CE[o(537)], i), a.CE[o(393)], Math[o(403)](e.data[o(503)] / a.LI[o(418)]) + 1), a.b3[o(532)]);
                    _d6 = e[o(539)], _c3 = 0, _u3 = this.getByteArrayFromIdentifier(i), _l3 = I[o(523)]([a.b3[o(453)], _u3[0], _u3[1], 0]), _h4 = _d6;
                    e[o(469)]++;
                    _p = Date[o(464)]();
                    _context6.prev = 7;
                  case 8:
                    if (!(_h4 > 0 && !this[o(433)][o(493)](i))) {
                      _context6.next = 18;
                      break;
                    }
                    _t46 = Math[o(488)](_h4, a.LI[o(418)]);
                  case 10:
                    if (!(e && e.data && e.data[o(503)] && _t46 + _c3 > e[o(453)][o(503)] && !this[o(433)][o(493)](i))) {
                      _context6.next = 15;
                      break;
                    }
                    _context6.next = 13;
                    return new Promise(function (t) {
                      return setTimeout(t, 2);
                    });
                  case 13:
                    _context6.next = 10;
                    break;
                  case 15:
                    this._peer[o(536)](I[o(443)]([_l3, I[o(523)](e[o(453)], (null === (s = e[o(453)]) || void 0 === s ? void 0 : s[o(503)]) - _h4, _t46)])), _c3 += _t46, _h4 -= _t46;
                  case 16:
                    _context6.next = 8;
                    break;
                  case 18:
                    _context6.next = 23;
                    break;
                  case 20:
                    _context6.prev = 20;
                    _context6.t0 = _context6["catch"](7);
                    n.default[o(470)](r.BalancerTag, o(504));
                  case 23:
                    this._totalSendBytes = this[o(511)] + _c3, this[o(447)] = Date.now() - _p, this[o(491)]++, e[o(469)]--, this[o(433)][o(493)](i) ? this[o(477)].peerCanceledSegmentUpload(e[o(453)].byteLength - _h4) : (this[o(520)][o(459)]({
                      time: Date[o(464)](),
                      size: e[o(453)].byteLength
                    }), this[o(477)].peerSegmentUpload(e[o(453)][o(503)]));
                    _context6.next = 27;
                    break;
                  case 26:
                    n.default[o(470)](r.BalancerTag, o(414));
                  case 27:
                    null != this[o(433)][o(493)](i) && (n.default[o(470)](r.BalancerTag, "Canceling operation -> 0 "), this._cancel[o(413)](i));
                  case 28:
                  case "end":
                    return _context6.stop();
                }
              }, _callee2, this, [[7, 20]]);
            }));
          }
        }, {
          key: _N20,
          value: function value(t) {
            var e = [0, 0];
            return e[0] = t >> 8 & 255, e[1] = 255 & t, e;
          }
        }, {
          key: _N21,
          value: function value(t) {
            return (255 & t[0]) << 8 | 255 & t[1];
          }
        }, {
          key: _N22,
          value: function value(t, e) {
            var i = N;
            this._send(_defineProperty(_defineProperty(_defineProperty({}, a.CE[i(507)], a.mH.absent), a.CE.id, t), a.CE[i(537)], e), a.b3[i(532)]);
          }
        }, {
          key: _N23,
          value: function value(t, e, i, s) {
            return D(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var n;
              return _regeneratorRuntime.wrap(function _callee3$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    n = R;
                    this[n(402)] || this[n(533)](_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, a.CE.command, a.mH[n(426)]), a.CE.id, t), a.CE[n(405)], e), a.CE[n(522)], i), a.CE.dateTime, Date.now()), a.CE.createdAt, s), a.b3[n(532)]);
                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }, _callee3, this);
            }));
          }
        }, {
          key: "_send",
          value: function _send(t, e) {
            var i = N;
            try {
              this[i(517)][i(536)](I[i(443)]([I[i(523)]([e, 0, 0, a.jQ[i(482)]]), I[i(523)](JSON[i(524)](t))]));
            } catch (t) {
              n.default.debug(r.BalancerTag, "Could not send message to peer (maybe it was destroyed)");
            }
          }
        }, {
          key: "getSegmentMap",
          value: function getSegmentMap() {
            return this[N(513)];
          }
        }, {
          key: _N24,
          value: function value(t, e) {
            var _this27 = this;
            var i = N;
            n.default[i(470)](r.BalancerTag, "PTT-> TIMEOUT CREATION " + e), this[i(441)][i(444)](e, {
              id: t,
              data: [],
              startTime: 0,
              size: 0
            }), setTimeout(function () {
              var s = i;
              var n;
              var r = _this27._downloaded.indexOf(t);
              if (r < 0) {
                _this27[s(472)](t, e);
                var _i110 = 0;
                _i110 = (null === (n = _this27[s(441)][s(493)](e)) || void 0 === n ? void 0 : n[s(405)]) || 0, _this27._loader.peerFailedSegmentTimeout(_this27, t, _i110), _this27._endDownload(s(526) + t + " " + a.LI.timeout, e);
              } else _this27._downloaded[s(494)](r, 1);
            }, a.LI.timeout);
          }
        }, {
          key: "getOldestRequestTS",
          value: function getOldestRequestTS() {
            var t;
            return (null === (t = this[N(399)][0]) || void 0 === t ? void 0 : t.time) || 0;
          }
        }, {
          key: _N26,
          value: function value() {
            var t = N;
            return L._getLastSecondsTraffic(this[t(399)]);
          }
        }, {
          key: _N27,
          value: function value() {
            return L[N(508)](this._lastSent);
          }
        }], [{
          key: _N25,
          value: function value(t) {
            var e = N;
            var i = 0;
            var s = Date.now();
            for (var _n17 = 0; _n17 < t[e(423)];) t[_n17][e(500)] + a.Ji[e(515)] < s ? t[e(494)](_n17, 1) : (i += t[_n17][e(405)], ++_n17);
            return i;
          }
        }]);
        return L;
      }(_, N(495), N(407), N(480), N(435), N(462), N(531), N(397), N(396), N(424), N(502), N(430), N(481), N(519), N(411), N(440), N(466), N(472), N(450), N(487), N(473), N(428), N(410), N(509), N(506), N(508), N(542), N(408));
      var C = B;
      function O() {
        var t = ["copyArray", "push", "96918OeQNRZ", "peek", "166065NYBvCj", "18030fBbJce", "489548jcOOqF", "removeFirst", "array", "size", "3052QNGQOt", "13281521wnzfaW", "72HOeYwy", "isEmpty", "9eCQXTN", "6218830AiyOSq", "assign", "length", "3nDiyzR", "1147880lvENYz", "splice"];
        return (O = function O() {
          return t;
        })();
      }
      function B(t, e) {
        var i = O();
        return (B = function B(t, e) {
          return i[t -= 403];
        })(t, e);
      }
      !function (t, e) {
        var i = B,
          s = t();
        for (;;) try {
          if (685349 == -parseInt(i(411)) / 1 * (-parseInt(i(420)) / 2) + -parseInt(i(416)) / 3 + parseInt(i(405)) / 4 * (-parseInt(i(418)) / 5) + parseInt(i(419)) / 6 * (parseInt(i(403)) / 7) + -parseInt(i(412)) / 8 + -parseInt(i(407)) / 9 * (-parseInt(i(408)) / 10) + -parseInt(i(404)) / 11) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(O);
      var x = /*#__PURE__*/function (_C2, _C3, _C4, _C5) {
        function x(t) {
          _classCallCheck(this, x);
          var e = B;
          this[e(422)] = [], this[e(423)] = t;
        }
        _createClass(x, [{
          key: "add",
          value: function add(t) {
            var e = B;
            for (this.array[e(415)](t); this.array[e(410)] > this[e(423)];) this[e(421)]();
          }
        }, {
          key: _C2,
          value: function value() {
            var t = C;
            if (!this[t(406)]()) return this[t(422)].shift();
          }
        }, {
          key: _C3,
          value: function value() {
            if (!this[C(406)]()) return this.array[0];
          }
        }, {
          key: _C4,
          value: function value() {
            var t = C;
            return 0 === this[t(422)][t(410)];
          }
        }, {
          key: _C5,
          value: function value() {
            var t = C;
            return Object[t(409)]([], this[t(422)]);
          }
        }, {
          key: "lastn",
          value: function lastn(t) {
            var e = C,
              i = Object[e(409)]([], this[e(422)]);
            return i[e(410)] <= t ? i : i[e(413)](i[e(410)] - t);
          }
        }]);
        return x;
      }(C(421), C(417), C(406), C(414));
      var M = i(6933);
      var k = U;
      function U(t, e) {
        var i = V();
        return (U = function U(t, e) {
          return i[t -= 177];
        })(t, e);
      }
      function V() {
        var t = ["bandwidth", "lastUpdatedState", "25449yzbcJo", "usedOnce", "setChecked", "isHeaderMatch", "test", "72nAhRrV", "getOldestRequestTS", "setBandwidth", "maxThroughput", "numberOfCdnCacheMisses", "lowestSegmentBandwidth", "minResponseTime", "resetOnPing", "verbose", "length", "max", "host", "MAX_SAFE_INTEGER", "isRangeCompatible", "incrementSwitchesDueToErrors", "original", "toLowerCase", "_checked", "4ihHgXT", "downloadedBytes", "376330BzXrFy", "1754480mOrTrp", "hugeChunks", "copyArray", "_incrementCacheCount", "bannedCount", "maxResponseBytes", "downloadMillis", "minNetworkLatency", "switchesDueToQuality", "time", "bannedTime", "getCdnCacheMisses", "lastPreferedVideoChunkDownloadTime", "incrementSwitchesDueToConnectivity", "2856JYIuaw", "statusCode", "bannedRefTicToc", "min", "downloadedBytesVideo", "now", "lastn", "minThroughput", "getLastResponse", " segment of ", "Downloaded a ", "_updateCacheCounts", "numberOfCdnCacheHits", "isCodavel", "highestRenditionBandwidth", "incrementSwitchesDueToQuality", "9170LvEgdi", "downloadTimeMs", "switches", "entries", "path", "getAvgRecentWBandwidth", "banned", "header", "highestSegmentBandwidth", "totalFail", "maxResponseTime", "active", "size", "browserCacheHits", "updateStatusCodeCounters", "video", "MB/s size-> ", "http4xxResponses", "push", "highestPingTime", "type", "downloadedChunksVideo", "cache", "resetBandwidth", "headers", "getAvgWBandwidth", "unbannedTime", "sumVideoTime", "getCdnCacheHits", "route", "minResponseBytes", "name", "maxNetworkLatency", "lastPingTime", "_lastResponses", "pushLastPreferedVideoBandwidth", "isChecked", "bandwidthForScoring", "Unknown", "url", "sumResponseTime", "downloadedSegments", "provider", "clone", "1220883WdntGA", "kb in ", "getInstance", "sumResponseBytes", "6327574FwyGdI", "retries", "sumNetworkLatency", "failed", "samplesResponseTime", "includes", "STREBOOS", "lastPreferedVideoChunkSize", "sumVideoBytes", "undefined", "samplesThroughput", "addResponse", "downloadMillisVideo", "STREBOPX", "compressedBytes", "http1xxResponses", "toFixed", "wBandwidth", "_lastsPreferedVideoBandwidth", "downloadedBytesForScoring", "shift", "getAvgResponseTime", "isAudio", "addResp", "samplesResponseBytes", "switchesDueToConnectivity", "723080PXRVtT", "wBandwidthForScoring", "_accumBw", "sumThroughput", "http2xxResponses", "downloadTimeForScoring", "updateCdnInfo", "initialBw", "numberOfCdnCacheUnknowns", "fromEntries", "_parser", "189cmmGiN", "firstHugeChunkSize", "updateAvailability", "incrementSwitches", "lastMeasurementWeight", "http5xxResponses", "score", "getBandwidthInBits", "downloadedChunks", "Audio", "getAvgBandwidth", "uncompressedBytes", "_processCdnCache", "regex", "http3xxResponses", "indexOf", "getVideoBandwidth", "trunc", "CODAVEL", "_updateCacheCount", "add", "samplesNetworkLatency", "getBandwidth", "cdnName", "pattern", "rendition", "switchesDueToErrors", "getWeightedBandwidth"];
        return (V = function V() {
          return t;
        })();
      }
      !function (t, e) {
        var i = U,
          s = t();
        for (;;) try {
          if (541983 == -parseInt(i(302)) / 1 * (-parseInt(i(307)) / 2) + parseInt(i(231)) / 3 * (-parseInt(i(325)) / 4) + parseInt(i(328)) / 5 + -parseInt(i(342)) / 6 * (parseInt(i(187)) / 7) + parseInt(i(261)) / 8 + -parseInt(i(272)) / 9 * (-parseInt(i(327)) / 10) + -parseInt(i(235)) / 11) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(V);
      var q = /*#__PURE__*/function (_k, _k2, _k3, _k4, _k5, _k6, _k7, _k8, _k9, _k10, _k11, _k12, _k13, _k14, _k15, _k16, _k17, _k18, _k19, _k20, _k21, _k22, _k23, _k24, _k25, _k26, _k27, _k28) {
        function q(t, e, i, s, n, r, a, o) {
          _classCallCheck(this, q);
          var d = U;
          this[d(332)] = 0, this.unBannedCount = 0, this[d(280)] = 0, this[d(326)] = 0, this[d(254)] = 0, this[d(266)] = 0, this[d(329)] = 0, this[d(273)] = 0, this[d(224)] = new x(20), this[d(262)] = new x(20), this.failures = 0, this[d(236)] = 0, this[d(196)] = 0, this[d(200)] = 0, this[d(183)] = 0, this[d(311)] = 0, this.numberOfCdnCacheUnknowns = 0, this.downloadMillis = 0, this[d(303)] = !1, this[d(346)] = 0, this[d(247)] = 0, this.downloadedChunksVideo = 0, this[d(213)] = 0, this[d(338)] = 0, this[d(344)] = Date.now(), this[d(301)] = 0, this.maxBandwidth = 1e12, this.lastPreferedVideoBandwidth = 0, this[d(253)] = [], this[d(185)] = 0, this[d(242)] = 0, this[d(340)] = 0, this[d(220)] = 0, this[d(263)] = q.initialBw, this[d(300)] = new x(20), this[d(252)] = new x(20), this[d(221)] = [], this[d(195)] = 0, this[d(312)] = Number[d(319)], this[d(206)] = 0, this.lowestPingTime = Number[d(319)], this.avgPingTime = 0, this[d(320)] = !0, this[d(324)] = !1, this[d(228)] = new Array(), this.provider = t, this.internal_provider = [d(290), "STREBOOS", d(248)].includes(t) ? e : t, this[d(218)] = e, this[d(318)] = i, this[d(191)] = s, this[d(226)] = n, this[d(278)] = r, this[d(322)] = a, this[d(198)] = !0, this[d(193)] = !1, this._parser = o;
        }
        _createClass(q, [{
          key: _k,
          value: function value(t) {
            var e = k;
            this[e(253)][e(205)](t), this[e(253)][e(316)] > 5 && this._lastsPreferedVideoBandwidth[e(255)]();
          }
        }, {
          key: "getAvgLastVideoBandwidth",
          value: function getAvgLastVideoBandwidth() {
            var t = k;
            var e = 0,
              i = 0;
            for (i = 0; i < this[t(253)][t(316)]; i++) e += this._lastsPreferedVideoBandwidth[i];
            return e / i;
          }
        }, {
          key: _k2,
          value: function value() {
            var t = k;
            return 0 === this[t(221)].length ? {
              time: Date[t(347)](),
              size: 0
            } : this[t(221)][this._lastResponses[t(316)] - 1];
          }
        }, {
          key: "setLastResponses",
          value: function setLastResponses(t) {
            this[k(221)] = t;
          }
        }, {
          key: _k3,
          value: function value(t) {
            var e = k;
            this[e(221)][e(205)](t);
          }
        }, {
          key: _k4,
          value: function value() {
            var t = k;
            return 0 == this[t(280)] ? 0 : this.downloadMillis / this[t(280)];
          }
        }, {
          key: _k5,
          value: function value() {
            return this.numberOfCdnCacheHits;
          }
        }, {
          key: _k6,
          value: function value() {
            return this[k(311)];
          }
        }, {
          key: "_processCdnCache",
          value: function _processCdnCache(t) {
            var e = k;
            if (!this[e(271)] || !t.headers) return;
            var i = Object[e(270)](Object[e(190)](t[e(211)]).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                  t = _ref3[0],
                  e = _ref3[1];
                return [t.toLowerCase(), e];
              })),
              _this$e$e = this[e(271)][e(209)],
              s = _this$e$e.hit,
              n = _this$e$e.miss;
            s && n ? this[e(182)](s, n, i) : this[e(291)](s || n, i, !!s);
          }
        }, {
          key: _k7,
          value: function value(t, e, i) {
            var s = k;
            var n, r;
            var a = null !== (n = null == t ? void 0 : t[s(194)][s(323)]()) && void 0 !== n ? n : "",
              o = null !== (r = null == e ? void 0 : e.header[s(323)]()) && void 0 !== r ? r : "",
              d = a in i && c[s(305)](i[a], t),
              u = o in i && c.isHeaderMatch(i[o], e);
            d ? this[s(183)]++ : u ? this.numberOfCdnCacheMisses++ : this[s(269)]++;
          }
        }, {
          key: "_updateCacheCount",
          value: function _updateCacheCount(t, e, i) {
            var s = k;
            var n;
            var r = null !== (n = null == t ? void 0 : t[s(194)][s(323)]()) && void 0 !== n ? n : "";
            if (r in e) {
              var _n18 = e[r];
              var _a6 = !1;
              "list" === t[s(207)] ? _a6 = t.pattern[s(240)](_n18) : t[s(207)] === s(285) && (_a6 = new RegExp(t[s(296)])[s(306)](_n18)), _a6 ? this[s(331)](i) : this[s(331)](!i);
            } else this._incrementCacheCount(!i);
          }
        }, {
          key: "_incrementCacheCount",
          value: function _incrementCacheCount(t) {
            var e = k;
            t ? this[e(183)]++ : this[e(311)]++;
          }
        }, {
          key: _k8,
          value: function value(t) {
            var _this28 = this;
            var e = k;
            var i, s;
            var o = t[e(216)],
              d = t[e(300)] || 0,
              c = t[e(199)] || 0,
              u = t[e(188)] || 0,
              l = t[e(238)];
            if (this[e(201)](t[e(343)]), l) return this.retries++, this[e(196)]++, void M.default[e(233)]()[e(267)](this.name, this[e(280)], this[e(326)], this[e(196)]);
            this[e(280)]++, this.downloadedBytes += c, typeof this.sumResponseBytes === e(244) ? this[e(234)] = c : this[e(234)] += c, typeof this.minResponseBytes === e(244) ? this[e(217)] = c : this[e(217)] = Math[e(345)](this.minResponseBytes, c), typeof this.maxResponseBytes === e(244) ? this[e(333)] = c : this.maxResponseBytes = Math[e(317)](this.maxResponseBytes, c), typeof this[e(259)] === e(244) ? this[e(259)] = 1 : this.samplesResponseBytes += 1, null != t[e(249)] && null != t[e(283)] && (void 0 === this.compressedBytes ? this.compressedBytes = t[e(249)] : this.compressedBytes += t[e(249)], typeof this.uncompressedBytes === e(244) ? this.uncompressedBytes = t[e(283)] : this.uncompressedBytes += t[e(283)]), this[e(284)](t), M.default[e(233)]().updateCdnInfo(this.name, this[e(280)], this.downloadedBytes, this[e(196)]), null != t[e(297)] && t[e(297)].isAudio && 0 == this[e(329)] && (this[e(303)] = !1), (null == t[e(297)] || !t[e(297)][e(257)]) && (this[e(254)] += c, this[e(266)] += u, this[e(303)] = !0, this[e(329)]++, 0 == this[e(273)] && (this[e(273)] = c)), a.Y4.forEach(function (i) {
              var s = e;
              if (o[s(287)](i) >= 0) {
                var _e51 = !0;
                d > 0 ? (c > 1e3 * a._C.minRequestSizeForBwEstimateKB && (_e51 = !1, _this28[s(263)] = _this28._accumBw !== q[s(268)] ? Math[s(289)](_this28[s(263)] * (1 - a.Zq[s(276)]) + d * a.Zq[s(276)]) : d), _this28[s(300)][s(292)](d), _this28[s(252)][s(292)]({
                  bw: d * c,
                  ct: c
                }), (null == t[s(297)] || !t[s(297)][s(257)]) && (_this28[s(224)].add(d), _this28[s(262)][s(292)]({
                  bw: d * c,
                  ct: c
                }), _this28[s(247)] += u, _this28[s(346)] += c, _this28[s(208)]++, typeof _this28[s(264)] === s(244) ? _this28[s(264)] = d : _this28[s(264)] += d, typeof _this28.minThroughput === s(244) ? _this28[s(178)] = d : _this28[s(178)] = Math[s(345)](_this28[s(178)], d), typeof _this28[s(310)] === s(244) ? _this28[s(310)] = d : _this28[s(310)] = Math[s(317)](_this28[s(310)], d), void 0 === _this28.samplesThroughput ? _this28.samplesThroughput = 1 : _this28.samplesThroughput += 1, typeof _this28[s(243)] === s(244) ? _this28[s(243)] = c : _this28[s(243)] += c, typeof _this28[s(214)] === s(244) ? _this28[s(214)] = u : _this28[s(214)] += u)) : _this28.browserCacheHits++, 0 == _this28[s(263)] && !_e51 && (_this28.usedOnce = !1);
              }
            }), 0 == this[e(326)] && (this.usedOnce = !1), d > this[e(195)] && (this[e(195)] = d), d < this[e(312)] && (this[e(312)] = d), this[e(334)] += u, void 0 === this[e(227)] ? this[e(227)] = u : this[e(227)] += u, typeof this[e(313)] === e(244) ? this[e(313)] = u : this[e(313)] = Math.min(this[e(313)], u), typeof this.maxResponseTime === e(244) ? this[e(197)] = u : this[e(197)] = Math[e(317)](this[e(197)], u), typeof this.samplesResponseTime === e(244) ? this.samplesResponseTime = 1 : this[e(239)] += 1, this._lastResponses.push({
              time: Date[e(347)](),
              size: c
            }), (null == t.rendition || !(null === (i = t.rendition) || void 0 === i ? void 0 : i.isAudio)) && (this[e(242)] = c, this[e(340)] = u), null != t.rendition && this[e(185)] < t[e(297)][e(300)] && (this[e(185)] = t[e(297)][e(300)]), (null == t.rendition || !(null === (s = t[e(297)]) || void 0 === s ? void 0 : s.isAudio)) && (this.lastPreferedVideoBandwidth = t[e(300)], this[e(222)](t[e(300)]));
            var h = e(225);
            t[e(297)] && (h = t[e(297)][e(257)] ? e(281) : e(202));
            var p = 0;
            t[e(297)] && (p = t[e(297)].targetDuration), n.default[e(315)](r.BalancerTag, e(181) + h + e(180) + p + "s from " + t[e(295)] + " at " + Number(d / 1e6)[e(251)](2) + e(203) + Number(c / 1024)[e(251)](2) + e(232) + u);
          }
        }, {
          key: "calculateEffectiveBandwidth",
          value: function calculateEffectiveBandwidth(t, e) {
            var i = k,
              s = this[i(340)],
              n = this[i(242)];
            var r = this[i(220)],
              a = s - r;
            if (a <= 0 && (r = s, a = s), n <= 0) return 0;
            var o = t / 8 * e,
              d = o * a / n + 2 * r;
            return 0 == d ? 0 : 8 * o / (d / 1e3);
          }
        }, {
          key: _k9,
          value: function value() {
            var t = k;
            return (this[t(254)] || 0) / ((this[t(266)] || 1) / 1e3) * 8;
          }
        }, {
          key: _k10,
          value: function value() {
            return this[k(263)];
          }
        }, {
          key: _k11,
          value: function value(t) {
            this[k(263)] = t;
          }
        }, {
          key: _k12,
          value: function value() {
            return 8 * this[k(263)];
          }
        }, {
          key: _k13,
          value: function value() {
            var t = k;
            var e = 0,
              i = 0;
            var _iterator15 = _createForOfIteratorHelper(this[t(300)][t(330)]()),
              _step15;
            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _s27 = _step15.value;
                e += _s27, i++;
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
            return i > 0 ? e / i : 0;
          }
        }, {
          key: "getAvgRecentBandwidth",
          value: function getAvgRecentBandwidth() {
            var t = k;
            var e = 0,
              i = 0;
            var _iterator16 = _createForOfIteratorHelper(this[t(300)][t(177)](4)),
              _step16;
            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _s28 = _step16.value;
                e += _s28, i++;
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
            return i > 0 ? e / i : 0;
          }
        }, {
          key: _k14,
          value: function value() {
            var t = k;
            var e = 0,
              i = 0;
            var _iterator17 = _createForOfIteratorHelper(this[t(262)].copyArray()),
              _step17;
            try {
              for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                var _s29 = _step17.value;
                e += _s29.bw, i += _s29.ct;
              }
            } catch (err) {
              _iterator17.e(err);
            } finally {
              _iterator17.f();
            }
            return i > 0 ? e / i : 0;
          }
        }, {
          key: _k15,
          value: function value() {
            var t = k;
            var e = 0,
              i = 0;
            var _iterator18 = _createForOfIteratorHelper(this.wBandwidthForScoring[t(177)](4)),
              _step18;
            try {
              for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                var _s30 = _step18.value;
                e += _s30.bw, i += _s30.ct;
              }
            } catch (err) {
              _iterator18.e(err);
            } finally {
              _iterator18.f();
            }
            return i > 0 ? e / i : 0;
          }
        }, {
          key: _k16,
          value: function value() {
            var t = k;
            return .45 * this[t(212)]() + .55 * this[t(192)]();
          }
        }, {
          key: _k17,
          value: function value() {
            var t = k;
            this._accumBw = q[t(268)];
          }
        }, {
          key: _k18,
          value: function value() {
            var t = k;
            var e;
            return (null === (e = this[t(221)][0]) || void 0 === e ? void 0 : e[t(337)]) || 0;
          }
        }, {
          key: _k19,
          value: function value() {
            var _this29 = this;
            var t = k,
              e = new q(this.provider, this[t(218)], this[t(318)], this[t(191)], this.url, this.score, this[t(322)], this._parser);
            return Object.keys(this).forEach(function (t) {
              var i = t,
                s = {};
              s[i] = _this29[i], Object.assign(e, s);
            }), e;
          }
        }, {
          key: "addProbe",
          value: function addProbe(t) {
            var e = k;
            typeof this.sumNetworkLatency === e(244) ? this[e(237)] = t : this[e(237)] += t, typeof this[e(335)] === e(244) ? this.minNetworkLatency = t : this.minNetworkLatency = Math[e(345)](this[e(335)], t), void 0 === this[e(219)] ? this[e(219)] = t : this[e(219)] = Math[e(317)](this.maxNetworkLatency, t), typeof this.samplesNetworkLatency === e(244) ? this[e(293)] = 1 : this[e(293)] += 1;
          }
        }, {
          key: "updateStatusCodeCounters",
          value: function updateStatusCodeCounters(t) {
            var e = k;
            null != t && (t >= 100 && t <= 199 ? this[e(250)] = (this[e(250)] || 0) + 1 : t >= 200 && t <= 299 ? this[e(265)] = (this[e(265)] || 0) + 1 : t >= 300 && t <= 399 ? this[e(286)] = (this[e(286)] || 0) + 1 : t >= 400 && t <= 499 ? this[e(204)] = (this[e(204)] || 0) + 1 : t >= 500 && t <= 599 && (this[e(277)] = (this[e(277)] || 0) + 1));
          }
        }, {
          key: _k20,
          value: function value() {
            var t = k,
              e = Date[t(347)]();
            this[t(193)] ? (this[t(338)] += e - this[t(344)], this[t(344)] = e) : (this[t(213)] += e - this[t(344)], this[t(344)] = e);
          }
        }, {
          key: _k21,
          value: function value() {
            var t = k;
            typeof this[t(189)] === t(244) ? this[t(189)] = 1 : this[t(189)] += 1;
          }
        }, {
          key: _k22,
          value: function value() {
            var t = k;
            typeof this[t(336)] === t(244) ? this[t(336)] = 1 : this.switchesDueToQuality += 1;
          }
        }, {
          key: _k23,
          value: function value() {
            var t = k;
            void 0 === this[t(260)] ? this[t(260)] = 1 : this.switchesDueToConnectivity += 1;
          }
        }, {
          key: _k24,
          value: function value() {
            var t = k;
            typeof this[t(298)] === t(244) ? this[t(298)] = 1 : this[t(298)] += 1;
          }
        }, {
          key: _k25,
          value: function value() {
            var t = k;
            this[t(234)] = void 0, this[t(217)] = void 0, this[t(333)] = void 0, this[t(259)] = void 0, this.sumResponseTime = void 0, this.minResponseTime = void 0, this[t(197)] = void 0, this[t(239)] = void 0, this[t(237)] = void 0, this[t(335)] = void 0, this.maxNetworkLatency = void 0, this[t(293)] = void 0, this[t(264)] = void 0, this.minThroughput = void 0, this[t(310)] = void 0, this[t(245)] = void 0, this[t(243)] = void 0, this.sumVideoTime = void 0, this.unbannedTime = 0, this[t(338)] = 0, this[t(344)] = Date[t(347)]();
          }
        }, {
          key: _k26,
          value: function value() {
            var t = k;
            return [t(290), t(241), t(248)][t(240)](this[t(229)]);
          }
        }, {
          key: _k27,
          value: function value() {
            this[k(324)] = !0;
          }
        }, {
          key: _k28,
          value: function value() {
            return this[k(324)];
          }
        }]);
        return q;
      }(k(222), k(179), k(246), k(256), k(215), k(339), k(182), k(258), k(288), k(294), k(309), k(279), k(282), k(212), k(192), k(299), k(210), k(308), k(230), k(274), k(275), k(186), k(341), k(321), k(314), k(184), k(304), k(223));
      function F(t, e) {
        var i = H();
        return (F = function F(t, e) {
          return i[t -= 458];
        })(t, e);
      }
      q[k(268)] = 9e12;
      var X = F;
      function H() {
        var t = ["_minPing", "pingsCounter", "354IUpVKn", "52WJFWQo", "max", "242NoImjZ", "25227fQCXXC", "pingsTime", "38390iUDJkC", "1554371pECBWx", "2308jiVFbj", "averagePing", "getAvgPingTime", "34544SIptWx", "lastMeasurementWeight", "trunc", "85515egASdj", "432276xsEdsf", "getMinPingTime", "_maxPing", "688owDamn"];
        return (H = function H() {
          return t;
        })();
      }
      !function (t, e) {
        for (var i = F, s = t();;) try {
          if (126732 == parseInt(i(472)) / 1 + parseInt(i(469)) / 2 * (-parseInt(i(461)) / 3) + parseInt(i(462)) / 4 * (-parseInt(i(475)) / 5) + parseInt(i(476)) / 6 + parseInt(i(468)) / 7 + parseInt(i(458)) / 8 * (parseInt(i(465)) / 9) + parseInt(i(467)) / 10 * (-parseInt(i(464)) / 11)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(H);
      var G = /*#__PURE__*/function (_X, _X2) {
        function G() {
          _classCallCheck(this, G);
          var t = F;
          this[t(460)] = 0, this.pingsTime = 0, this.averagePing = 0, this[t(478)] = 0, this[t(459)] = Number.MAX_SAFE_INTEGER;
        }
        _createClass(G, [{
          key: "add",
          value: function add(t) {
            var e = F;
            this[e(478)] = Math[e(463)](this[e(478)], t), this[e(459)] = Math.min(this[e(459)], t), this.pingsTime += t, this[e(460)]++, this[e(470)] = 0 === this[e(470)] ? t : Math[e(474)](this[e(470)] * (1 - a.Zq[e(473)]) + t * a.Zq[e(473)]);
          }
        }, {
          key: _X,
          value: function value() {
            return this[X(470)];
          }
        }, {
          key: "getMaxPingTime",
          value: function getMaxPingTime() {
            return this[X(478)];
          }
        }, {
          key: _X2,
          value: function value() {
            return this[X(459)];
          }
        }, {
          key: "getSimpleAveragePingTime",
          value: function getSimpleAveragePingTime() {
            var t = X;
            return this[t(466)] / this[t(460)];
          }
        }]);
        return G;
      }(X(471), X(477));
      var j = Y;
      !function (t, e) {
        var i = Y,
          s = t();
        for (;;) try {
          if (453386 == parseInt(i(513)) / 1 + -parseInt(i(505)) / 2 + parseInt(i(510)) / 3 + parseInt(i(522)) / 4 + parseInt(i(514)) / 5 * (parseInt(i(508)) / 6) + parseInt(i(502)) / 7 * (parseInt(i(499)) / 8) + -parseInt(i(518)) / 9 * (parseInt(i(500)) / 10)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(W);
      function W() {
        var t = ["877935SrCXqP", "4765NJmaPi", "next", "getPeersWithContent", "__awaiter", "1034919OiwUZh", "p2pLoader", "isEnabled", "apply", "1915588OHQmVu", "_isMonitoring", "_instance", "timeBetweenBurstsMilliseconds", "getPeers", "monitor", "_pingBroadcastTimeInSeconds", "then", "lastDownloadedSegment", "_lastPingBroadcast", "ping", "3571944sUSMNk", "170vhcEYg", "now", "7JHBtDW", "newDownloadedSegment", "length", "758590xztowG", "bandwidth", "throw", "1410kshZGs", "value", "2280744IBJdnC", "pingTime", "testPeer"];
        return (W = function W() {
          return t;
        })();
      }
      function Y(t, e) {
        var i = W();
        return (Y = function Y(t, e) {
          return i[t -= 494];
        })(t, e);
      }
      var z = /*#__PURE__*/function (_j, _j2, _j3) {
        function z(t) {
          _classCallCheck(this, z);
          var e = j;
          this[e(506)] = new Map(), this[e(511)] = new Map(), this[e(523)] = !1, this[e(494)] = 60, this[e(497)] = Date[e(501)](), this.p2pLoader = t;
        }
        _createClass(z, [{
          key: _j,
          value: function value(t) {
            this[j(496)] = t;
          }
        }, {
          key: _j2,
          value: function value() {
            return t = this, e = void 0, s = /*#__PURE__*/_regeneratorRuntime.mark(function s() {
              var t, _iterator19, _step19, _e52, _e53;
              return _regeneratorRuntime.wrap(function s$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    t = Y;
                    if (this._isMonitoring) {
                      _context8.next = 19;
                      break;
                    }
                    this._isMonitoring = !0;
                  case 3:
                    if (!(Date[t(501)]() - this[t(497)] > 1e3 * this[t(494)])) {
                      _context8.next = 8;
                      break;
                    }
                    _iterator19 = _createForOfIteratorHelper(this[t(519)][t(526)]().values());
                    try {
                      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                        _e52 = _step19.value;
                        this[t(512)](_e52);
                      }
                    } catch (err) {
                      _iterator19.e(err);
                    } finally {
                      _iterator19.f();
                    }
                    _context8.next = 15;
                    break;
                  case 8:
                    if (this[t(496)]) {
                      _context8.next = 13;
                      break;
                    }
                    _context8.next = 11;
                    return new Promise(function (t) {
                      return setTimeout(t, 1e3);
                    });
                  case 11:
                    _context8.next = 8;
                    break;
                  case 13:
                    _e53 = this[t(519)][t(516)](this[t(496)]);
                    _e53[t(504)] > 0 && this[t(512)](_e53[0]);
                  case 15:
                    _context8.next = 17;
                    return new Promise(function (e) {
                      return setTimeout(e, a.wc[t(525)]);
                    });
                  case 17:
                    _context8.next = 3;
                    break;
                  case 19:
                  case "end":
                    return _context8.stop();
                }
              }, s, this);
            }), new ((i = void 0) || (i = Promise))(function (n, r) {
              var a = Y;
              function o(t) {
                var e = Y;
                try {
                  c(s[e(515)](t));
                } catch (t) {
                  r(t);
                }
              }
              function d(t) {
                var e = Y;
                try {
                  c(s[e(507)](t));
                } catch (t) {
                  r(t);
                }
              }
              function c(t) {
                var e = Y;
                var s;
                t.done ? n(t[e(509)]) : (s = t.value, s instanceof i ? s : new i(function (t) {
                  t(s);
                }))[e(495)](o, d);
              }
              c((s = s[a(521)](t, e || []))[a(515)]());
            });
            var t, e, i, s;
          }
        }, {
          key: _j3,
          value: function value(t) {
            var e = j;
            this[e(519)][e(520)]() && t[e(498)](t.id);
          }
        }], [{
          key: "getInstance",
          value: function getInstance(t) {
            return null != t && (this[j(524)] = new z(t)), this._instance;
          }
        }]);
        return z;
      }(j(503), j(527), j(512));
      var K = Q;
      function Q(t, e) {
        var i = J();
        return (Q = function Q(t, e) {
          return i[t -= 462];
        })(t, e);
      }
      function J() {
        var t = ["getAvgPingTime", "byteLength", "_uploadRequests", "getPeersAhead", "_isEnabled", "_activeDownloadIds", "P2P dependency does not exist. Disabling P2P!", "_sumVideoBytes", "_peersAvailable", "getOldestRequestTS", "_errorListener", "_samplesThroughput", "_offerInterval", "_sumThroughput", "map", "getMissingPeers", "consumeOnly", "min", "peerSegmentProgress", "_maxPeersParallelUsed", "maxConnectedPeers", "_activeDownloads", "getMaxSize", "P2P Error: ", "_peersParallelUsed", "peerConnect", "_accountCode", "addResponse", "verbose", "monitor", "realBodySize", "sendMap", "tracker", "has", "_maxNetworkLatency", "pathname", "concat", "_sumResponseTime", " last msg -> ", "getLastSegmentCreatedAt", "BANNING Peer -> ", "_minThroughput", " SM Size-> ", "_p2pManager", "_samplesResponseTime", "get", "_errorRequests", "timeouts", "data", "WebRtcEvents", "reduce", "yes", "updatePeerMetrics", "avgPingTime", "time", "sendJoin", "getUploadedChunks", "_chunkDownloadCount", "_warningListener", "destroy", "noContentObtained", "_timeoutRequests", "_options", "_maxBandwidth", "isMaxPeers", "_segmentsRequested", "notice", "resetOnPing", "P2PSMAP new segment to all peers: ", "isAhead", "getUploadRequestsFailed", "_sendMapToPeer", "_storage", "initialBw", "12kDsUFR", "getSegment", "setLastResponses", "_activePeerSet", "size", "getId", "announcedP2P", "P2P MAP send map to peer  ", "P2P", "storeSegment", "_updatePeersMetricsRefCounter", "request", "getSegmentDataMessages", "resource", "P2P Requesting segment ", "_sumResponseBytes", "peerSegmentUpload", "getBannedPeers", "_failedRequests", "_sumVideoTime", "10oOnQDy", "peerCanceledSegmentUpload", "_maxConcurrent", "push", "max", "_maxThroughput", "getLastLatencyP2P", "P2P ADDPEERCANDIDATE - received message from ", "_sumNetworkLatency", "indexOf", "_minBandwidth", "getCdnObject", "onConnected", "1704072CLysDt", "getDownloadBandwidth", "rendition", "_peerConnectionTime", "_peerDiscoveryTime", "_sendMapToAllPeersV0", "_minResponseBytes", " pos: ", "bind", "now", "enabled", "addPeerResponse", "getPeersNothing", "forEach", "CREATEPEERCONNECTING", "_minNetworkLatency", "P2P Warning ", "trunc", "start", "_minPeersParallelUsed", "route", "disable", "getLastDownloadsTraffic", "rejoin", "peerRequestsPerAnnounce", "_maxPeersAvailable", "p2pId", "set", "Constants", "peerFailedSegmentTimeout", "35461sVfJoT", "sendSegment", "onOffer", "_downloadMillis", "add", "_bannedPeers", "consecutiveHaveSegment", "8574423qFxtbC", "length", "maxConcurrency", "_chunkUploadCount", " delay ", " available from peer ", "getStorage", "getUploadedBytes", "_downloadedChunksVideo", "_samplesResponseBytes", "getLastBandwith", "maxParallelP2PDownloads", "getVersion", "getSegmentMap", "_minResponseTime", "_accumBw", "P2PRS Requesting segment ", "_timeoutDiscardedBytes", "P2P New peer candidate ", "P2PManager", "_candidates", "isAudio", "P2P peer already exist. ", " peers: ", "_chunkUploadDiscardedCount", "19836uWvBnm", "upload", "getUploadRequests", "Active downloads vs max concurrencui P2PMO -> ", "981134czYtyU", "_downloadedBytesVideo", "1075660WuBFdx", "_downloadMillisVideo", "_peersUsed", "isEnabled", "_byteUploadDiscardedCount", "8bgbRXQ", "peerSegmentLoaded", "createMap", "_peers", "_performReset", "setBandwidth", "peerSegmentUploadRequest", "debug", "_segmentAbsentRequests", "delete", "isBehind", " not available ", "lastMeasurementWeight", "peer", "slice", "P2P Unable to request to more peers max concurrency (", "getMaxPeers", "trackerAnnounce", "values", "triedP2P", "Problem peer doen't exists?", "_maxResponseTime", "getPeersWithContent", "_maxResponseBytes", "_byteUploadCount", "58NhkClh", "_sendNewSegmentToAllPeersV1", "_maxConnectedPeers", "getLastResponses", "_monitoringStarted", "_byteDownloadCount", "undefined", "_minPeersAvailable", "splice", "setSettings", "_uplodadedPeers", "getTotalSendTime", "_samplesNetworkLatency", "getMinPingTime", "startMonitoring", "from", "_uploadRequestsFailed", "p2p", "_cdnObject", "3857480wlrZfl", "Problem max concurrency ", "getPeers", ") already reached", "sendNewSegmentAvailable", "Already have max peers", "_cdnPingTimeBean", "videoId", "endTime", "P2PSMAP Send map all v0 size: ", "_availablePeersMap", "P2P support disabled.", "_downloadedPeers", "_packageFound", "P2P support enabled ", "_destroyed", " | ", "https://localhost", "sort", "getMaxPingTime"];
        return (J = function J() {
          return t;
        })();
      }
      !function (t, e) {
        var i = Q,
          s = t();
        for (;;) try {
          if (567774 == -parseInt(i(479)) / 1 * (-parseInt(i(547)) / 2) + -parseInt(i(693)) / 3 + -parseInt(i(566)) / 4 + parseInt(i(517)) / 5 * (parseInt(i(660)) / 6) + parseInt(i(515)) / 7 * (-parseInt(i(522)) / 8) + parseInt(i(511)) / 9 * (parseInt(i(680)) / 10) + parseInt(i(486)) / 11) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(J);
      var $ = /*#__PURE__*/function (_K, _K2, _K3, _K4, _K5, _K6, _K7, _K8, _K9, _K10, _K11, _K12, _K13, _K14, _K15, _K16, _K17, _K18, _K19, _K20, _K21, _K22, _K23, _K24, _K25, _K26, _K27, _K28, _K29, _K30, _K31, _K32, _K33, _K34, _K35, _K36, _K37, _K38, _K39, _K40, _K41) {
        function $(t, e, i) {
          _classCallCheck(this, $);
          var s = Q;
          this[s(512)] = a.LI[s(512)], this._isEnabled = !1, this[s(579)] = !1, this[s(682)] = a.LI[s(488)], this[s(549)] = a.LI[s(606)], this[s(525)] = new Map(), this._bannedPeers = new Map(), this._candidates = new Map(), this[s(607)] = 0, this._segmentsRequested = new Map(), this._activeDownloadIds = [], this[s(551)] = !1, this._performReset = !1, this[s(578)] = new Map(), this[s(557)] = new Map(), this[s(649)] = 0, this[s(690)] = Number.MAX_SAFE_INTEGER, this._timeoutDiscardedBytes = 0, this[s(678)] = 0, this[s(647)] = 0, this[s(530)] = 0, this[s(632)] = 0, this[s(482)] = 0, this[s(552)] = 0, this[s(643)] = 0, this._totalPeerSet = new Set(), this[s(663)] = new Set(), this[s(576)] = new Map(), this[s(670)] = 0, this[s(598)] = 45e3, this[s(501)] = q[s(659)], this._downloadMillisVideo = 0, this._downloadedBytesVideo = 0, this[s(494)] = 0, this[s(521)] = 0, this._chunkUploadDiscardedCount = 0, this[s(489)] = 0, this[s(546)] = 0, this[s(588)] = 0, this[s(563)] = 0, this._destroyed = !1, this[s(612)] = t, this[s(648)] = e, this._storage = i, this[s(565)] = new q(s(668), s(668), "", "", "", 1, !1), this[s(565)].setBandwidth(this[s(501)]), this._cdnObject[s(662)](this[s(550)]()), this._cdnPingTimeBean = new G(), window.P2PManager ? this._packageFound = !0 : n.default[s(652)](r.BalancerTag, s(592));
        }
        _createClass($, [{
          key: _K,
          value: function value() {
            return this[K(579)] && this._isEnabled;
          }
        }, {
          key: "enable",
          value: function enable() {
            this._isEnabled = !0;
          }
        }, {
          key: _K2,
          value: function value() {
            this._isEnabled = !1;
          }
        }, {
          key: _K3,
          value: function value() {
            return this[K(658)];
          }
        }, {
          key: "getUploadedUniqPeers",
          value: function getUploadedUniqPeers() {
            var t = K;
            return this[t(557)][t(664)];
          }
        }, {
          key: _K4,
          value: function value() {
            var t = K;
            var e = 0;
            var _iterator20 = _createForOfIteratorHelper(this[t(525)][t(540)]()),
              _step20;
            try {
              for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                var _i111 = _step20.value;
                _i111.isAhead && e++;
              }
            } catch (err) {
              _iterator20.e(err);
            } finally {
              _iterator20.f();
            }
            return e;
          }
        }, {
          key: "getPeersBehind",
          value: function getPeersBehind() {
            var t = K;
            var e = 0;
            var _iterator21 = _createForOfIteratorHelper(this[t(525)].values()),
              _step21;
            try {
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                var _i112 = _step21.value;
                _i112[t(532)] && e++;
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
            return e;
          }
        }, {
          key: _K5,
          value: function value() {
            var t = K;
            var e = 0;
            var _iterator22 = _createForOfIteratorHelper(this._peers[t(540)]()),
              _step22;
            try {
              for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                var _i113 = _step22.value;
                _i113[t(655)] || _i113[t(532)] || e++;
              }
            } catch (err) {
              _iterator22.e(err);
            } finally {
              _iterator22.f();
            }
            return e;
          }
        }, {
          key: _K6,
          value: function value() {
            var t = K;
            var e;
            return null === (e = this[t(629)]) || void 0 === e ? void 0 : e[t(665)]();
          }
        }, {
          key: _K7,
          value: function value() {
            return this[K(565)];
          }
        }, {
          key: "resetP2PConnection",
          value: function resetP2PConnection() {
            this[K(526)] = !0;
          }
        }, {
          key: _K8,
          value: function value() {
            var t = K;
            var e, i;
            if (this[t(579)] && this[t(590)]) {
              var _s31 = new URL(null !== (e = this._options[t(673)]) && void 0 !== e ? e : t(583)),
                _n19 = this[t(612)] + (this[t(648)][t(573)] || _s31[t(621)]);
              null === (i = this[t(629)]) || void 0 === i || i[t(472)](_n19);
            }
          }
        }, {
          key: _K9,
          value: function value(t) {
            var e = K;
            var i;
            if (this[e(579)] && !this[e(590)]) if (t[e(564)] && t[e(564)][e(703)]) {
              this[e(590)] = !0, this[e(512)] = !t.p2p[e(602)] || a.LI.upload, this[e(682)] = t[e(564)][e(497)] || a.LI[e(488)], this._maxConnectedPeers = t[e(564)][e(606)] || a.LI[e(606)];
              var _s32 = new URL(null !== (i = this[e(648)][e(673)]) && void 0 !== i ? i : e(583)),
                _o17 = this._accountCode + (this[e(648)][e(573)] || _s32[e(621)]);
              this[e(629)] = new window[e(505)](this, _o17, {
                tracker: t[e(564)][e(539)] || a.LI[e(618)],
                accountCode: this[e(612)],
                announcePeers: t[e(564)][e(473)]
              }), this[e(629)].on(window.P2PManager[e(477)][e(635)].Error, $[e(596)][e(701)](this)).on(window[e(505)][e(477)][e(635)].Warning, $[e(644)].bind(this))[e(467)](), n.default[e(529)](r.BalancerTag, e(580) + this.getId());
            } else n.default[e(529)](r.BalancerTag, e(577)), this[e(590)] = !1;
          }
        }, {
          key: _K10,
          value: function value() {
            var t = K;
            this[t(551)] || (this[t(551)] = !0, z.getInstance()[t(615)]());
          }
        }, {
          key: _K11,
          value: function value() {
            var t = K;
            return this[t(525)].size > this[t(549)] && (n.default[t(614)](r.BalancerTag, "Max peers reached -> " + this[t(525)][t(664)]), !0);
          }
        }, {
          key: _K12,
          value: function value() {
            var t = K;
            return this[t(549)] - this[t(525)][t(664)];
          }
        }, {
          key: _K13,
          value: function value() {
            return this._maxConnectedPeers;
          }
        }, {
          key: "getBannedPeers",
          value: function getBannedPeers() {
            return this[K(484)];
          }
        }, {
          key: _K14,
          value: function value() {
            return this[K(588)];
          }
        }, {
          key: _K15,
          value: function value() {
            return this[K(563)];
          }
        }, {
          key: _K16,
          value: function value(t) {
            var e = K;
            return this[e(658)][e(661)](t[e(475)]);
          }
        }, {
          key: _K17,
          value: function value(t) {
            var e = K;
            if (this._destroyed || 0 == this[e(525)][e(664)]) return [];
            var i = [];
            var _iterator23 = _createForOfIteratorHelper(this[e(525)].values()),
              _step23;
            try {
              for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                var _s33 = _step23.value;
                if (0 == _s33[e(499)]()[e(487)]) {
                  var _t50 = Date.now() - _s33.getLastSegmentDataMessagesTime();
                  (_t50 > 3e4 && _s33[e(672)]() < 2 || _t50 > 12e4) && (this[e(484)][e(476)](_s33.id, !0), _s33[e(645)](), this.peerCloseListener(_s33), n.default[e(614)](r.BalancerTag, e(626) + _s33.id + e(628) + _s33[e(499)]()[e(487)] + e(624) + _t50 / 1e3 + "s messages: " + _s33[e(672)]()));
                } else (!_s33.isDownloading() || _s33[e(498)]() >= 2) && _s33[e(499)]().length > 0 && _s33[e(499)]()[e(689)](t[e(475)]) >= 0 && i[e(683)](_s33);
              }
            } catch (err) {
              _iterator23.e(err);
            } finally {
              _iterator23.f();
            }
            if (0 == i[e(487)]) return [];
            var s = [];
            for (var _i115 = 0, _i114 = i; _i115 < _i114.length; _i115++) {
              var _t47 = _i114[_i115];
              _t47[e(686)]() > 0 && _t47[e(686)]() < 5 && s[e(683)](_t47);
            }
            if (0 == s[e(487)]) {
              var _iterator24 = _createForOfIteratorHelper(i),
                _step24;
              try {
                for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                  var _t48 = _step24.value;
                  _t48.getLastLatencyP2P() > 0 && _t48[e(686)]() < 7 && s[e(683)](_t48);
                }
              } catch (err) {
                _iterator24.e(err);
              } finally {
                _iterator24.f();
              }
            }
            if (0 == s[e(487)]) {
              var _t49 = [];
              var _iterator25 = _createForOfIteratorHelper(i),
                _step25;
              try {
                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  var _n20 = _step25.value;
                  0 == _n20.getLastBandwith() && 0 == _n20[e(633)] && s[e(683)](_n20), _n20[e(496)]() > 0 && _t49[e(683)](_n20);
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
              _t49 = _t49[e(584)](function (t, e) {
                return e.getLastBandwith() - t.getLastBandwith();
              }), s = _t49[e(487)] < 4 ? s[e(622)](_t49) : s[e(622)](_t49[e(536)](0, 3));
            }
            return 0 == s[e(487)] && (s = i), s;
          }
        }, {
          key: "request",
          value: function request(t, e) {
            var i = K;
            var s, a, o;
            if (!this[i(579)]) return !1;
            if (n.default[i(614)](r.BalancerTag, i(514) + this._activeDownloads + " " + this[i(682)]), this[i(607)] > this[i(682)] && n.default[i(614)](r.BalancerTag, i(567) + this[i(607)]), !(this._activeDownloads <= this._maxConcurrent)) return n.default.debug(r.BalancerTag, i(537) + this[i(682)] + i(569)), !1;
            {
              n.default[i(614)](r.BalancerTag, "P2P Requesting new segment " + t[i(475)] + i(582) + (null === (s = t[i(695)]) || void 0 === s ? void 0 : s[i(507)]) + i(509) + this[i(525)][i(664)]);
              var _e54 = this.getPeersWithContent(t);
              if (_e54[i(487)] > 0) {
                var _s34 = Array.from(_e54).sort(function (t, e) {
                  return .5 - Math.random();
                })[0];
                return this[i(651)][i(476)](t[i(475)], t), this._activeDownloads++, t[i(541)] = !0, _s34[i(671)](t[i(475)]), t[i(535)] = _s34, _s34[i(485)]++, n.default[i(614)](r.BalancerTag, i(502) + t[i(475)] + "  audio -> " + (null === (a = t[i(695)]) || void 0 === a || a[i(507)], i(637), "no") + i(491) + _s34.id + " size -> " + _s34[i(499)]().length + i(700) + _s34[i(499)]().indexOf(t[i(475)]) + " peer-timeouts: " + _s34.timeouts), !0;
              }
            }
            return n.default[i(614)](r.BalancerTag, i(674) + t[i(475)] + "  audio -> " + (null === (o = t.rendition) || void 0 === o ? void 0 : o[i(507)]) + i(533)), !1;
          }
        }, {
          key: _K18,
          value: function value(t) {
            var e = K;
            this[e(565)][e(613)](t);
          }
        }, {
          key: _K19,
          value: function value() {
            var t = K;
            return Array[t(562)](this[t(525)][t(540)]())[t(600)](function (e) {
              return e[t(550)]();
            })[t(636)](function (t, e) {
              return [].concat(_toConsumableArray(t), _toConsumableArray(e));
            }, [])[t(584)](function (e, i) {
              return i[t(640)] - e[t(640)];
            });
          }
        }, {
          key: "addPeerLatency",
          value: function addPeerLatency(t) {
            var e = K;
            this[e(572)][e(483)](t), this[e(565)][e(639)] = this._cdnPingTimeBean[e(586)](), typeof this[e(688)] === e(553) ? this._sumNetworkLatency = t : this._sumNetworkLatency += t, typeof this[e(464)] === e(553) ? this[e(464)] = t : this[e(464)] = Math[e(603)](this[e(464)], t), void 0 === this[e(620)] ? this._maxNetworkLatency = t : this[e(620)] = Math[e(684)](this[e(620)], t), void 0 === this[e(559)] ? this[e(559)] = 1 : this._samplesNetworkLatency += 1;
          }
        }, {
          key: _K22,
          value: function value(t) {
            var e = K;
            if (this[e(512)]) {
              var _i116 = this[e(658)][e(669)](t);
              !t.announcedP2P && _i116 && (t[e(666)] = !0, this._sendNewSegmentToAllPeersV1(t), this._sendMapToAllPeersV0());
              var _s35 = this[e(591)].indexOf(t[e(475)]);
              _s35 >= 0 && this._activeDownloadIds.splice(_s35);
            } else if (!t[e(666)]) {
              t[e(666)] = !0;
              var _i117 = this[e(658)][e(524)]();
              this._peers.forEach(function (t) {
                t[e(617)](_i117);
              });
            }
          }
        }, {
          key: _K23,
          value: function value() {
            var t = K;
            if (this[t(581)]) return;
            var e = this._storage[t(524)](),
              i = Date[t(702)]() - this._storage[t(625)]();
            n.default[t(614)](r.BalancerTag, t(575) + e[t(487)] + " / " + this._peers[t(664)] + t(490) + i), e[t(487)] > 0 && this[t(525)][t(462)](function (i) {
              var s = t;
              0 == i.getVersion() && i[s(617)](e);
            });
          }
        }, {
          key: _K24,
          value: function value(t) {
            var _this30 = this;
            var e = K;
            if (this[e(581)]) return;
            var i = this._storage[e(524)]();
            n.default[e(614)](r.BalancerTag, e(654) + i[e(487)]), i[e(487)] > 0 && this[e(525)][e(462)](function (i) {
              var s = e;
              i[s(498)]() > 0 && i[s(570)](t[s(475)], t[s(664)], _this30[s(658)][s(608)](), t.createdAt);
            });
          }
        }, {
          key: _K25,
          value: function value(t) {
            var e = K;
            if (this._destroyed) return;
            var i = this[e(658)][e(524)]();
            n.default[e(614)](r.BalancerTag, e(667) + i[e(487)] + " " + t);
            var s = !1;
            this[e(525)].forEach(function (n) {
              var r = e;
              n.id == t && (n[r(617)](i), s = !0);
            }), !s && n.default[e(614)](r.BalancerTag, e(542));
          }
        }, {
          key: "addPeerCandidate",
          value: function addPeerCandidate(t, e) {
            var i = K;
            var s;
            if (!this._destroyed) if (this[i(576)].set(t.id, Date[i(702)]()), null == this[i(484)][i(631)](t.id)) {
              if (n.default.verbose(r.BalancerTag, i(687) + t.id + " "), this.isMaxPeers()) n.default[i(529)](r.BalancerTag, i(571));else {
                if (!this[i(525)][i(619)](t.id)) {
                  !this[i(506)].has(t.id) && this[i(506)][i(476)](t.id, []);
                  var _a7 = new L(this, t, e);
                  null === (s = this[i(506)][i(631)](t.id)) || void 0 === s || s[i(683)](_a7), n.default[i(614)](r.BalancerTag, i(504) + _a7.id);
                }
                this.updatePeerMetrics();
              }
            } else n.default[i(529)](r.BalancerTag, "Already banned peer -> " + t.id);
          }
        }, {
          key: _K26,
          value: function value(t) {
            var e = K;
            var i;
            n.default[e(614)](r.BalancerTag, e(463)), this[e(581)] || (this[e(576)][e(476)](t.id, Date[e(702)]()), this[e(677)]().get(t.id) || (this.isMaxPeers() ? n.default[e(529)](r.BalancerTag, e(571)) : (this[e(525)][e(619)](t.id) ? (n.default.debug(r.BalancerTag, e(508) + t.id), t.destroy()) : (n.default[e(529)](r.BalancerTag, "P2P adding the candidate. " + t.id), this[e(525)].set(t.id, t), this[e(663)][e(483)](t.id), this._totalPeerSet.add(t.id), null === (i = this[e(506)][e(631)](t.id)) || void 0 === i || i[e(462)](function (i) {
              t != i && i[e(645)]();
            }), this._candidates[e(531)](t.id), this[e(657)](t.id)), this[e(638)]())));
          }
        }, {
          key: "peerCloseListener",
          value: function peerCloseListener(t) {
            var e = K,
              i = t;
            this[e(525)].delete(i.id), this[e(663)][e(531)](i.id);
            var s = this[e(506)].get(i.id);
            if (s) {
              var _t51 = s[e(689)](i);
              _t51 > -1 && (s[e(555)](_t51, 1), !s.length && this[e(506)].delete(i.id));
            }
            this[e(638)]();
          }
        }, {
          key: _K27,
          value: function value(t, e, i) {
            var s = K;
            this[s(588)]++;
            var a = this[s(557)][s(631)](t.id);
            if (null == a && (a = 0), this._uplodadedPeers[s(476)](t.id, a), this[s(581)]) return;
            var o = this[s(658)][s(661)](e);
            var d = !1;
            o && o.data[s(587)] > 1 ? (t[s(480)](e, o, i), d = !0) : (t.sendNoSegment(e, i), this[s(657)](t.id), this[s(563)]++), n.default.verbose(r.BalancerTag, "P2PUR Peer requested segment -> " + d + s(582) + e + " " + (null == o ? void 0 : o.size) + " " + (null == o ? void 0 : o[s(634)][s(587)]) + " | " + t.id + " " + i + " " + (null == o ? void 0 : o.origRes));
          }
        }, {
          key: _K28,
          value: function value(t, e, i, s) {
            var _this31 = this;
            var n = K;
            var r;
            this[n(607)]--, this[n(643)]++, this._downloadMillis += i, this._byteDownloadCount += s.byteLength, typeof this[n(675)] === n(553) ? this[n(675)] = s[n(587)] : this[n(675)] += s[n(587)], typeof this[n(699)] === n(553) ? this._minResponseBytes = s[n(587)] : this._minResponseBytes = Math[n(603)](this[n(699)], s[n(587)]), typeof this[n(545)] === n(553) ? this._maxResponseBytes = s[n(587)] : this[n(545)] = Math[n(684)](this[n(545)], s[n(587)]), typeof this[n(495)] === n(553) ? this[n(495)] = 1 : this[n(495)] += 1, null === (r = this[n(651)][n(631)](e)) || void 0 === r || r.setContent(s);
            var o = Math[n(466)](s.byteLength / (i / 1e3));
            this._accumBw = this[n(501)] !== q[n(659)] ? Math[n(466)](this[n(501)] * (1 - a.Zq[n(534)]) + o * a.Zq[n(534)]) : o, this[n(565)][n(527)](this[n(501)]), typeof this._sumThroughput === n(553) ? this[n(599)] = o : this[n(599)] += o, typeof this[n(627)] === n(553) ? this[n(627)] = o : this._minThroughput = Math.min(this[n(627)], o), typeof this._maxThroughput === n(553) ? this._maxThroughput = o : this[n(685)] = Math[n(684)](this[n(685)], o), void 0 === this[n(597)] ? this[n(597)] = 1 : this[n(597)] += 1, typeof this[n(593)] === n(553) ? this[n(593)] = s[n(587)] : this._sumVideoBytes += s[n(587)], void 0 === this[n(679)] ? this[n(679)] = i : this._sumVideoTime += i, typeof this._sumResponseTime === n(553) ? this[n(623)] = i : this[n(623)] += i, typeof this[n(500)] === n(553) ? this._minResponseTime = i : this[n(500)] = Math[n(603)](this[n(500)], i), typeof this[n(543)] === n(553) ? this[n(543)] = i : this[n(543)] = Math[n(684)](this._maxResponseTime, i), typeof this[n(630)] === n(553) ? this[n(630)] = 1 : this[n(630)] += 1;
            var d = this[n(651)][n(631)](e);
            if (d) {
              var _t52 = d[n(469)];
              a.Y4[n(462)](function (e) {
                var r = n;
                _t52[r(689)](e) >= 0 && (null == d[r(695)] || !d[r(695)][r(507)]) && (_this31[r(518)] += i, _this31[r(516)] += s.byteLength, _this31[r(494)]++);
              }), d.endTime = Date.now(), d[n(616)] = s[n(587)], this[n(669)](d), this[n(651)][n(531)](e);
            }
          }
        }, {
          key: _K29,
          value: function value(t, e, i, s, n) {
            var r = K;
            if (0 == n) return;
            var a = this._segmentsRequested[r(631)](e);
            if (a && (a[r(574)] = Date[r(702)]()), a && !this[r(658)][r(661)](a.id) && (n > 0 && (a[r(616)] = n), this[r(669)](a)), a && (a[r(634)] = s), a && a.id) {
              var _t53 = this._storage[r(661)](a.id);
              _t53 && (_t53[r(634)] = s);
            }
          }
        }, {
          key: _K30,
          value: function value(t, e, i) {
            var s = K;
            var n;
            this[s(503)] += i || 0, this._timeoutRequests++, this._activeDownloads--, this[s(678)]++, null === (n = this._segmentsRequested[s(631)](e)) || void 0 === n || n[s(646)](), this[s(651)][s(531)](e);
          }
        }, {
          key: "peerFailedSegmentAbsent",
          value: function peerFailedSegmentAbsent(t, e) {
            var i = K;
            var s;
            this[i(530)]++, this._activeDownloads--, this[i(678)]++, null === (s = this[i(651)][i(631)](e)) || void 0 === s || s[i(646)](), this._segmentsRequested[i(531)](e);
          }
        }, {
          key: _K31,
          value: function value(t) {
            var e = K;
            this._byteUploadCount += t, this[e(489)]++;
          }
        }, {
          key: _K32,
          value: function value() {
            return this[K(546)];
          }
        }, {
          key: _K33,
          value: function value() {
            return this[K(489)];
          }
        }, {
          key: _K34,
          value: function value(t) {
            var e = K;
            this[e(521)] += t, this[e(510)]++;
          }
        }, {
          key: _K35,
          value: function value() {
            var t = K;
            if (this._p2pManager) try {
              this[t(629)][t(645)](), delete this._p2pManager;
            } catch (t) {}
            var _iterator26 = _createForOfIteratorHelper(this[t(506)]),
              _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var _step26$value = _slicedToArray(_step26.value, 2),
                  _e55 = _step26$value[1];
                _e55[t(462)](function (e) {
                  e[t(645)]();
                });
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
            var _iterator27 = _createForOfIteratorHelper(this[t(525)]),
              _step27;
            try {
              for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                var _step27$value = _slicedToArray(_step27.value, 2),
                  _e56 = _step27$value[1];
                _e56.destroy();
              }
            } catch (err) {
              _iterator27.e(err);
            } finally {
              _iterator27.f();
            }
            try {
              this._destroyed = !0, this[t(658)][t(645)]();
            } catch (t) {}
          }
        }, {
          key: _K36,
          value: function value() {
            var t = K;
            var e = Date[t(702)]();
            return this._peers.forEach(function (i) {
              var s = t,
                n = i.getOldestRequestTS();
              n && (e = Math[s(603)](e, n));
            }), e;
          }
        }, {
          key: _K37,
          value: function value() {
            return this[K(525)];
          }
        }, {
          key: "getStats",
          value: function getStats() {
            var _this32 = this;
            var t = K;
            var e = 0,
              i = 0,
              s = 0,
              n = 0,
              r = 0;
            return this._peers.forEach(function (t) {
              var a = Q;
              t[a(694)]() > 0 && (e += t[a(694)](), _this32._maxBandwidth = Math[a(466)](Math[a(684)](_this32[a(649)], t.getDownloadBandwidth())), _this32[a(690)] = Math[a(466)](Math[a(603)](_this32[a(690)], t[a(694)]())), i++), s += t[a(471)](), n += t.getLastUploadsTraffic(), r += t[a(558)]();
            }), e /= i || 1, e = Math.trunc(e), {
              downloadEnabled: !0,
              uploadEnabled: this.upload,
              uploadedBytes: this[t(546)],
              uploadedTime: r,
              uploadedChunks: this[t(489)],
              discardedUploadedChunks: this[t(510)],
              discardedUploadedBytes: this[t(521)],
              downloadedSegments: this[t(643)],
              downloadedBytes: this[t(552)],
              discardedDownloadedBytes: this[t(503)],
              failedRequests: {
                total: this._failedRequests,
                absent: this[t(530)],
                timeout: this._timeoutRequests,
                error: this[t(632)]
              },
              activePeers: this[t(525)][t(664)],
              totalPeers: this[t(525)][t(664)],
              downloadMillis: this[t(482)],
              maxBandwidth: this[t(649)],
              minBandwidth: this[t(690)],
              downloadAvgBw: e,
              lastSecondsDownloadTraffic: s,
              lastSecondsUploadTraffic: n,
              downloadMillisVideo: this[t(518)],
              downloadBytesVideo: this[t(516)],
              downloadChunksVideo: this[t(494)],
              avgPingTime: this[t(572)][t(586)](),
              minPingTime: this[t(572)][t(560)](),
              maxPingTime: this[t(572)][t(585)](),
              sumResponseBytes: this[t(675)],
              minResponseBytes: this[t(699)],
              maxResponseBytes: this[t(545)],
              samplesResponseBytes: this[t(495)],
              sumResponseTime: this[t(623)],
              minResponseTime: this[t(500)],
              maxResponseTime: this[t(543)],
              samplesResponseTime: this[t(630)],
              sumNetworkLatency: this[t(688)],
              minNetworkLatency: this[t(464)],
              maxNetworkLatency: this._maxNetworkLatency,
              samplesNetworkLatency: this._samplesNetworkLatency,
              sumThroughput: this[t(599)],
              minThroughput: this[t(627)],
              maxThroughput: this[t(685)],
              samplesThroughput: this._samplesThroughput,
              sumVideoBytes: this._sumVideoBytes,
              sumVideoTime: this[t(679)],
              peersAvailable: this._peersAvailable,
              maxPeersAvailable: this[t(474)],
              minPeersAvailable: this[t(554)],
              peersUsed: this._peersUsed,
              peersParallelUsed: this[t(610)],
              maxPeersParallelUsed: this[t(605)],
              minPeersParallelUsed: this[t(468)],
              peerDiscoveryTime: this[t(697)],
              peerConnectionTime: this[t(696)]
            };
          }
        }, {
          key: _K38,
          value: function value() {
            var t = K;
            this[t(675)] = void 0, this[t(699)] = void 0, this[t(545)] = void 0, this[t(495)] = void 0, this[t(623)] = void 0, this[t(500)] = void 0, this[t(543)] = void 0, this[t(630)] = void 0, this._sumNetworkLatency = void 0, this[t(464)] = void 0, this._maxNetworkLatency = void 0, this[t(559)] = void 0, this._sumThroughput = void 0, this[t(627)] = void 0, this[t(685)] = void 0, this[t(597)] = void 0, this[t(593)] = void 0, this._sumVideoTime = void 0, this[t(696)] = void 0, this._peerDiscoveryTime = void 0, this._updatePeersMetricsRefCounter = 0;
          }
        }, {
          key: _K39,
          value: function value(t, e) {
            var i = K;
            this[i(598)] = e, this._availablePeersMap[i(476)](t, Date[i(702)]());
          }
        }, {
          key: _K40,
          value: function value() {
            var _this33 = this;
            var t = K,
              e = Date[t(702)]() - this[t(598)] + 15e3;
            this[t(576)][t(462)](function (i, s) {
              var n = t;
              i < e && _this33._availablePeersMap[n(531)](s);
            }), this._updatePeersMetricsRefCounter++, this[t(519)] = this._peers[t(664)], this[t(610)] = this[t(663)].size, this[t(594)] = this[t(576)][t(664)], 1 == this[t(670)] ? (this[t(468)] = this[t(663)][t(664)], this[t(605)] = this[t(663)][t(664)], this[t(554)] = this._availablePeersMap[t(664)], this[t(474)] = this[t(576)][t(664)]) : ((null == this._minPeersParallelUsed || this._minPeersParallelUsed > this[t(663)].size) && (this[t(468)] = this[t(663)].size), (null == this._maxPeersParallelUsed || this[t(605)] < this[t(663)][t(664)]) && (this[t(605)] = this[t(663)].size), (null == this[t(554)] || this[t(554)] > this._availablePeersMap[t(664)]) && (this._minPeersAvailable = this[t(576)][t(664)]), (null == this[t(474)] || this._maxPeersAvailable < this[t(576)][t(664)]) && (this[t(474)] = this._availablePeersMap[t(664)]));
          }
        }, {
          key: _K41,
          value: function value(t) {
            this[K(696)] = t;
          }
        }, {
          key: "onDiscovery",
          value: function onDiscovery(t) {
            this[K(697)] = t;
          }
        }], [{
          key: _K20,
          value: function value(t) {
            var e = K;
            n.default.error(r.BalancerTag, e(609), t);
          }
        }, {
          key: _K21,
          value: function value(t) {
            var e = K;
            n.default.warn(r.BalancerTag, e(465), t);
          }
        }]);
        return $;
      }(K(520), K(470), K(492), K(589), K(705), K(665), K(691), K(641), K(556), K(561), K(650), K(601), K(538), K(513), K(656), K(661), K(544), K(704), K(550), K(596), K(644), K(669), K(698), K(548), K(657), K(611), K(528), K(523), K(604), K(478), K(676), K(493), K(642), K(681), K(645), K(595), K(568), K(653), K(481), K(638), K(692));
      var Z = et;
      function tt() {
        var t = ["forEach", "Performing probe to ", "debug", "1340fupfJg", "usedSelectorAPIResponse", " because not used yet", " Mbps", "sort", "values", "2601CbQwwI", "_options", "from", "getInstance", "wasActiveSwitchingDecisionPerformed", "currentCDN", "downloadedChunks", "225010BPgzCG", "_p2pLoader", "setChecked", " highest segment bandwidth -> ", "get", "_cdnList", "time", "_getCdnToProbe", " for ", "now", "banned", "minimumDurationSinceLastUsedForTrialMilliseconds", "filter", "_cdnPriority", "241575nnNxNz", "_getNotUsedCdn", "getBandwidthInBits", " reference bandwidth ", "Original", "isChecked", "102VaXkBJ", "length", "some", "getBandwidth", "9832185idWIIT", "536xmGqnN", "size", "1414176pdNrGn", "getPeersWithContent", "noProbing", "_activeSwitching", "_bestScoredCdn", "usedOnce", "setSwitchedCdns", "latency", "qualityPriority", "getLastResponse", "Fastest CDN is -> ", "35161gsuyKz", "name", "getCDN", "_highetsSegmentBandwidth", "clear", "755017iDvPCn", "cdnPriority", "234bWgSbd", "Current bandwidth for ", "useP2P", "verbose", "last bandwidth", "P2P", "_bandwidthThreshold", "set", "toFixed", "avgPingTime", "push", "active", "CDN Candidates -> ", "_qualityPriority", "Selected ", " is: ", "delete"];
        return (tt = function tt() {
          return t;
        })();
      }
      function et(t, e) {
        var i = tt();
        return (et = function et(t, e) {
          return i[t -= 366];
        })(t, e);
      }
      !function (t, e) {
        var i = et,
          s = t();
        for (;;) try {
          if (510713 == -parseInt(i(367)) / 1 + parseInt(i(429)) / 2 + -parseInt(i(395)) / 3 * (parseInt(i(389)) / 4) + parseInt(i(416)) / 5 * (parseInt(i(422)) / 6) + parseInt(i(440)) / 7 * (parseInt(i(427)) / 8) + -parseInt(i(369)) / 9 * (-parseInt(i(402)) / 10) + -parseInt(i(426)) / 11) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(tt);
      var it = /*#__PURE__*/function (_Z, _Z2, _Z3, _Z4, _Z5) {
        function it(t, e, i, s, n, r) {
          _classCallCheck(this, it);
          var a = et;
          this._cdnList = t, this._activeSwitching = s, this._bandwidthThreshold = e, this[a(443)] = i, this[a(403)] = n, this[a(396)] = r;
        }
        _createClass(it, [{
          key: _Z,
          value: function value(t, e) {
            var i = Z;
            var s = i(420);
            var o = new Map();
            var d = 0,
              c = !0;
            if (this[i(407)][i(386)](function (t, e) {
              d += t[i(401)], !t.banned && t.active && (o.set(e, t), c = !1);
            }), c && (o[i(366)](), this[i(407)][i(386)](function (t, e) {
              var s = i;
              t[s(380)] && (t[s(412)] = !1, o[s(376)](e, t));
            })), (0 === this[i(403)][i(430)](t)[i(423)] || !t[i(371)]) && o[i(385)](i(374)), n.default[i(372)](r.BalancerTag, i(381) + o[i(428)] + " of " + this[i(407)][i(428)] + " Active switching method -> " + this[i(432)]), o[i(385)](i(420)), 0 == o[i(428)]) return s = i(420), !this[i(432)] && d > 0 && (s = e[i(400)]), e[i(400)] = s, 0 === s[i(423)] ? i(420) : s;
            if (o[i(428)] > 0) if (M.default[i(398)]()[i(390)](!0), M.default.getInstance()[i(399)](void 0 !== this[i(432)]), this._activeSwitching) {
              var _n21 = e[i(400)];
              switch (this[i(432)]) {
                case a.m[i(437)]:
                  s = this[i(382)](t, o, e);
                  break;
                case a.m.cdnPriority:
                  s = this[i(415)](t, o, e);
                  break;
                default:
                  var _n22;
                  _n22 = this._bestScoredCdn(t, o), s = null === _n22 ? "" : _n22[i(441)];
              }
              "" !== _n21 && s !== i(420) && _n21 !== s && M.default[i(398)]()[i(435)](!0);
            } else {
              var _n23;
              _n23 = this[i(433)](t, o), null === _n23 || _n23[i(421)]() ? s = 0 === d ? "" : e.currentCDN : (s = _n23[i(441)], e[i(400)] = s, _n23[i(404)]());
            }
            return s && "" != s.trim() ? s : i(420);
          }
        }, {
          key: _Z2,
          value: function value(t, e, i) {
            var _this34 = this;
            var s = Z,
              o = this[s(396)][s(431)] ? new Map(this[s(407)]) : e;
            0 === this[s(403)][s(430)](t)[s(423)] && o[s(385)](s(374));
            var d = this[s(409)](o, a.m[s(437)], i.currentCDN);
            if (d) return n.default[s(388)](r.BalancerTag, s(387) + d[s(441)]), i[s(400)] = d[s(441)], d[s(441)];
            var c = this[s(417)](t);
            if (c) return n.default[s(388)](r.BalancerTag, s(383) + c + s(391)), c;
            var u = "",
              l = 0;
            return e[s(386)](function (t) {
              var e = s,
                i = t.getVideoBandwidth();
              n.default[e(372)](r.BalancerTag, t.name + e(419) + i / 1e6 + " | estimated bandwidth " + t.getBandwidth() + e(405) + _this34[e(443)] / 1e6), l < t[e(425)]() && (l = t[e(425)](), u = t[e(441)]);
            }), n.default[s(388)](r.BalancerTag, s(439) + u), i.currentCDN = u, u;
          }
        }, {
          key: _Z3,
          value: function value(t, e, i) {
            var _this35 = this;
            var s = Z;
            var o, d;
            var c = this[s(396)][s(431)] ? new Map(this._cdnList) : e;
            0 === this[s(403)][s(430)](t)[s(423)] && c[s(385)](s(374));
            var u = this._getCdnToProbe(c, a.m[s(368)], i[s(400)]);
            if (u) return n.default.debug(r.BalancerTag, s(387) + u[s(441)]), i[s(400)] = u.name, u[s(441)];
            var l = Array[s(397)](e[s(394)]())[s(414)](function (t) {
              return t.getBandwidthInBits() / 1e3 > _this35[s(375)] && !t[s(412)];
            });
            if (!l[s(424)](function (t) {
              return t[s(441)] === i[s(400)];
            })) {
              var _t54 = e[s(406)](i[s(400)]);
              _t54 && (_t54.lastUpdatedState = 3);
            }
            var h = null !== (d = null === (o = l[0]) || void 0 === o ? void 0 : o.name) && void 0 !== d ? d : "";
            if ("" === h) {
              var _t55 = Array[s(397)](e[s(394)]());
              _t55.sort(function (t, e) {
                return e[s(425)]() - t[s(425)]();
              }), h = _t55[0][s(441)];
            }
            return i[s(400)] = h, h;
          }
        }, {
          key: "_bestScoredCdn",
          value: function _bestScoredCdn(t, e) {
            var i = Z;
            var s;
            return null !== (s = Array[i(397)](e[i(394)]())[0]) && void 0 !== s ? s : null;
          }
        }, {
          key: _Z4,
          value: function value(t) {
            var e = Z,
              i = [];
            var _iterator28 = _createForOfIteratorHelper(this[e(407)]),
              _step28;
            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var _step28$value = _slicedToArray(_step28.value, 2),
                  _t57 = _step28$value[0],
                  _s36 = _step28$value[1];
                _s36[e(380)] && !_s36[e(412)] && !_s36.usedOnce && i[e(379)](_s36[e(441)]);
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }
            if (0 === this._p2pLoader[e(430)](t).length || !t.useP2P) {
              var _t56 = i.indexOf(e(374));
              _t56 > -1 && i.splice(_t56, 1);
            }
            if (0 == i.length) return;
            var s = i[Math.floor(Math.random() * i.length)],
              n = this[e(407)][e(406)](s);
            return null != n && (n[e(434)] = !0), s;
          }
        }, {
          key: _Z5,
          value: function value(t, e, i) {
            var _this36 = this;
            var s = Z;
            var o = Array[s(397)](t[s(394)]())[s(414)](function (t) {
              return t.name !== i;
            });
            if (e === a.m.cdnPriority) {
              o = [];
              var _iterator29 = _createForOfIteratorHelper(t),
                _step29;
              try {
                for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                  var _step29$value = _slicedToArray(_step29.value, 2),
                    _e57 = _step29$value[0],
                    _n24 = _step29$value[1];
                  if (_e57 === i) break;
                  o[s(379)](_n24);
                }
              } catch (err) {
                _iterator29.e(err);
              } finally {
                _iterator29.f();
              }
            }
            o[s(393)](function (t, e) {
              return t[s(438)]()[s(408)] - e[s(438)]()[s(408)];
            });
            var d = t.get(i);
            if (!d) return;
            var c = d.avgPingTime,
              u = d.getBandwidthInBits(),
              l = e === a.m[s(368)] ? 1e3 * this[s(375)] : d[s(418)](),
              h = o[s(414)](function (t) {
                var e = s;
                if (Date[e(411)]() - t[e(438)]()[e(408)] >= a.Zq[e(413)]) return !0;
                var o = !0 === _this36[e(396)][e(431)],
                  d = o ? t[e(418)]() : c * u / t[e(378)];
                return n.default.debug(r.BalancerTag, "Estimated bandwidth based on " + e(o ? 373 : 436) + e(410) + t.name + e(384) + (d / 1e6).toFixed(2) + e(392)), n.default[e(388)](r.BalancerTag, e(370) + i + ": " + (u / 1e6)[e(377)](2) + " Mbps"), (d - l) / l >= -a.Zq.maximumRelativeDeltaForTrial;
              });
            return 0 === h[s(423)] ? void 0 : h[s(393)](function (t, e) {
              return t[s(438)]()[s(408)] - e[s(438)]()[s(408)];
            })[0];
          }
        }]);
        return it;
      }(Z(442), Z(382), Z(415), Z(417), Z(409));
      var st = at;
      function nt() {
        var t = ["updateCdnList", "70GwKxZR", "newDownloadedSegment", "done", "getMinPingTime", "onerror", "11495225ybggAP", "getMaxPingTime", "1LehdvR", "monitoring", "712URhgYY", "verbose", "bytes=0-0", "HEAD", "loader", "timeBetweenCallsMilliseconds", "banned", "pingsTime", "value", "BANNING CDN DUE TO TIMEOUT ", "lastPingTime", "bannedTime", "CDNLoader", "isRangeCompatible", "now", "6134661NWSPsM", "probeOnlyOnBanned", "UNABLE TO GENERATE URL FOR PROBING CHECK ", "status", "timeout", "&rnpaw=", "set", "9854248RNQhzT", "send", "readyState", "_instance", "testCdn", "unBannedCount", "monitor", "PINGTIME No available resources to test ", "ontimeout", "stopMonitor", "2180vOHSnU", "values", "isCodavel", "setNoProbing", "onCodavelSucessfullResponse", "setLoader", "failures", "646560maYgOe", "throw", "P2P", "setRequestHeader", "setHeadOnBannedOnly", "bannedCount", "BANNING CDN ", "4803792GeRuLI", "_performHeadCheck", "_isMonitoring", "avgPingTime", "_performCheck", "timeBetweenBurstsMilliseconds", "lastDownloadedSegment", "addParametersToUrl", "floor", "_performGetCheck", "add", "highestPingTime", "_afterCheck", "onCodavelFailedResponse", "callTimeoutMilliseconds", "noProbing", "GET", "apply", "_cdns", "addProbe", "name", "bannedRefTicToc", "3424132WGgozR", "next", "shouldMonitor", "unbannedTime", "getAvgPingTime", "provider", "lastUpdatedState", "get", "getInstance", "includes"];
        return (nt = function nt() {
          return t;
        })();
      }
      !function (t, e) {
        var i = at,
          s = t();
        for (;;) try {
          if (862311 == -parseInt(i(351)) / 1 * (parseInt(i(333)) / 2) + -parseInt(i(311)) / 3 + -parseInt(i(353)) / 4 * (parseInt(i(297)) / 5) + -parseInt(i(304)) / 6 + -parseInt(i(349)) / 7 + parseInt(i(375)) / 8 + -parseInt(i(368)) / 9 * (-parseInt(i(344)) / 10)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(nt);
      var rt = function rt(t, e, i, s) {
        return new (i || (i = Promise))(function (n, r) {
          var a = at;
          function o(t) {
            var e = at;
            try {
              c(s[e(334)](t));
            } catch (t) {
              r(t);
            }
          }
          function d(t) {
            var e = at;
            try {
              c(s[e(305)](t));
            } catch (t) {
              r(t);
            }
          }
          function c(t) {
            var e = at;
            var s;
            t[e(346)] ? n(t[e(361)]) : (s = t[e(361)], s instanceof i ? s : new i(function (t) {
              t(s);
            })).then(o, d);
          }
          c((s = s[a(328)](t, e || []))[a(334)]());
        });
      };
      function at(t, e) {
        var i = nt();
        return (at = function at(t, e) {
          return i[t -= 292];
        })(t, e);
      }
      var ot = /*#__PURE__*/function (_st, _st2, _st3, _st4, _st5, _st6, _st7, _st8, _st9, _st10, _st11, _st12) {
        function ot() {
          _classCallCheck(this, ot);
          var t = at;
          this[t(360)] = new Map(), this[t(352)] = new Map(), this._isMonitoring = !1, this[t(329)] = new Map(), this[t(335)] = !0, this[t(369)] = !1, this[t(326)] = !1;
        }
        _createClass(ot, [{
          key: _st,
          value: function value(t) {
            var e = st;
            this.loader = t, this[e(335)] = !0;
          }
        }, {
          key: _st2,
          value: function value(t) {
            this[st(329)] = t;
          }
        }, {
          key: _st3,
          value: function value(t) {
            this.lastDownloadedSegment = t;
          }
        }, {
          key: _st4,
          value: function value() {
            this.shouldMonitor = !1;
          }
        }, {
          key: _st5,
          value: function value() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            this.probeOnlyOnBanned = t;
          }
        }, {
          key: _st6,
          value: function value() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            this[st(326)] = t;
          }
        }, {
          key: _st7,
          value: function value(t) {
            return rt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var e, i, _iterator30, _step30, _s37, _iterator31, _step31, _t58;
              return _regeneratorRuntime.wrap(function _callee4$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    e = at;
                    this[e(329)] = t;
                    i = new Map();
                    _iterator30 = _createForOfIteratorHelper(t.values());
                    try {
                      for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                        _s37 = _step30.value;
                        i[e(374)](_s37[e(331)], new G()), this[e(360)] = i;
                      }
                    } catch (err) {
                      _iterator30.e(err);
                    } finally {
                      _iterator30.f();
                    }
                    if (this[e(313)]) {
                      _context9.next = 39;
                      break;
                    }
                    this[e(313)] = !0;
                  case 7:
                    if (!this[e(335)]) {
                      _context9.next = 39;
                      break;
                    }
                  case 8:
                    if (this[e(317)]) {
                      _context9.next = 13;
                      break;
                    }
                    _context9.next = 11;
                    return new Promise(function (t) {
                      return setTimeout(t, 1e3);
                    });
                  case 11:
                    _context9.next = 8;
                    break;
                  case 13:
                    if (this[e(326)]) {
                      _context9.next = 35;
                      break;
                    }
                    _iterator31 = _createForOfIteratorHelper(this[e(329)][e(298)]());
                    _context9.prev = 15;
                    _iterator31.s();
                  case 17:
                    if ((_step31 = _iterator31.n()).done) {
                      _context9.next = 27;
                      break;
                    }
                    _t58 = _step31.value;
                    _context9.t0 = this.lastDownloadedSegment && _t58[e(331)] !== e(306);
                    if (!_context9.t0) {
                      _context9.next = 25;
                      break;
                    }
                    _context9.next = 23;
                    return this[e(379)](_t58, this[e(317)]);
                  case 23:
                    _context9.next = 25;
                    return new Promise(function (t) {
                      return setTimeout(t, a.wc[e(358)]);
                    });
                  case 25:
                    _context9.next = 17;
                    break;
                  case 27:
                    _context9.next = 32;
                    break;
                  case 29:
                    _context9.prev = 29;
                    _context9.t1 = _context9["catch"](15);
                    _iterator31.e(_context9.t1);
                  case 32:
                    _context9.prev = 32;
                    _iterator31.f();
                    return _context9.finish(32);
                  case 35:
                    _context9.next = 37;
                    return new Promise(function (t) {
                      return setTimeout(t, a.wc[e(316)]);
                    });
                  case 37:
                    _context9.next = 7;
                    break;
                  case 39:
                  case "end":
                    return _context9.stop();
                }
              }, _callee4, this, [[15, 29, 32, 35]]);
            }));
          }
        }, {
          key: _st8,
          value: function value(t, e) {
            var i = st;
            var s, n, r;
            var a = Date[i(367)]() - t;
            ot[i(341)]().monitoring.set(e[i(331)], a);
            var o = ot[i(341)]().pingsTime[i(340)](e.name);
            null == o || o[i(321)](a), e[i(363)] = a, e[i(314)] = null !== (s = null == o ? void 0 : o[i(337)]()) && void 0 !== s ? s : e[i(314)], e[i(322)] = null !== (n = null == o ? void 0 : o[i(350)]()) && void 0 !== n ? n : e[i(322)], e.lowestPingTime = null !== (r = null == o ? void 0 : o[i(347)]()) && void 0 !== r ? r : e.lowestPingTime, e[i(330)](a);
          }
        }, {
          key: _st9,
          value: function value(t, e) {
            return rt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var i, _s38, _e58, _a8;
              return _regeneratorRuntime.wrap(function _callee5$(_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    i = at;
                    if (!(this.loader && this[i(357)].getIsEnabled && t.active && "ORIGINAL" != t[i(338)] && (!this.probeOnlyOnBanned || t[i(359)]))) {
                      _context10.next = 20;
                      break;
                    }
                    if (!e) {
                      _context10.next = 19;
                      break;
                    }
                    _s38 = this.loader.CDNLoader.updateUrl(e, t[i(331)]);
                    if (!(_s38 = e[i(318)](_s38), _s38)) {
                      _context10.next = 16;
                      break;
                    }
                    _e58 = Math[i(319)](1e9 * Math.random());
                    _s38 = _s38[i(342)]("?") ? _s38 + i(373) + _e58 : _s38 + "?rnpaw=" + _e58;
                    _a8 = 0;
                    _context10.t0 = t.isRangeCompatible;
                    if (!_context10.t0) {
                      _context10.next = 13;
                      break;
                    }
                    _context10.next = 12;
                    return this._performGetCheck(t, _s38);
                  case 12:
                    _a8 = _context10.sent;
                  case 13:
                    (!t[i(366)] || 1 === _a8) && (t[i(366)] = !1, n.default.verbose(r.BalancerTag, "Probing with range failed failed. Falling back to HEAD request on the next probe"));
                    _context10.next = 17;
                    break;
                  case 16:
                    n.default[i(354)](r.BalancerTag, i(370) + t[i(331)] + " // " + e.url);
                  case 17:
                    _context10.next = 20;
                    break;
                  case 19:
                    n.default[i(354)](r.BalancerTag, i(294) + t[i(331)]);
                  case 20:
                  case "end":
                    return _context10.stop();
                }
              }, _callee5, this);
            }));
          }
        }, {
          key: _st10,
          value: function value(t, e) {
            return rt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var i;
              return _regeneratorRuntime.wrap(function _callee6$(_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    i = at;
                    _context11.next = 3;
                    return this[i(315)](i(327), t, e);
                  case 3:
                    return _context11.abrupt("return", _context11.sent);
                  case 4:
                  case "end":
                    return _context11.stop();
                }
              }, _callee6, this);
            }));
          }
        }, {
          key: _st11,
          value: function value(t, e) {
            return rt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var i;
              return _regeneratorRuntime.wrap(function _callee7$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    i = at;
                    _context12.next = 3;
                    return this[i(315)](i(356), t, e);
                  case 3:
                    return _context12.abrupt("return", _context12.sent);
                  case 4:
                  case "end":
                    return _context12.stop();
                }
              }, _callee7, this);
            }));
          }
        }, {
          key: _st12,
          value: function value(t, e, i) {
            return rt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
              var s, o, d, c;
              return _regeneratorRuntime.wrap(function _callee8$(_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    s = at, o = new XMLHttpRequest(), d = Date[s(367)](), c = this;
                    return _context13.abrupt("return", new Promise(function (u, l) {
                      var h = s;
                      o.onload = function () {
                        var s = at;
                        if (4 === o[s(377)]) {
                          var _a9 = 0;
                          if ("GET" === t && 206 !== o[s(371)] && o.status >= 200 && o.status < 400) _a9 = 1;else if (o[s(371)] >= 200 && o[s(371)] < 300) {
                            if (e.banned) {
                              var _t59 = Date[s(367)]();
                              e.bannedTime += _t59 - e[s(332)], e.bannedRefTicToc = _t59, e[s(359)] = !1, e[s(292)]++;
                            }
                            e[s(303)] = 0, n.default[s(354)](r.BalancerTag, "HEALTHY CDN " + i + " " + o[s(371)]), e[s(339)] = 0, e[s(299)]() && null != c.loader && c[s(357)][s(365)][s(301)]();
                          } else if (o[s(371)] >= 400) {
                            if (n.default[s(354)](r.BalancerTag, s(310) + i + " " + o[s(371)]), !e.banned) {
                              var _t60 = Date[s(367)]();
                              e[s(336)] += _t60 - e.bannedRefTicToc, e[s(332)] = _t60, e[s(359)] = !0, e.bannedCount++;
                            }
                            e.lastUpdatedState = 1, e[s(299)]() && null != c[s(357)] && c[s(357)][s(365)][s(324)](1);
                          }
                          0 === _a9 && c._afterCheck(d, e), u(_a9);
                        }
                      }, o[h(348)] = function () {
                        var t = h;
                        if (n.default[t(354)](r.BalancerTag, t(310) + i + " " + o[t(371)]), e[t(359)]) {
                          var _i118 = Date[t(367)]();
                          e[t(364)] += _i118 - e[t(332)], e.bannedRefTicToc = _i118;
                        } else {
                          var _i119 = Date[t(367)]();
                          e[t(336)] += _i119 - e.bannedRefTicToc, e[t(332)] = _i119, e.banned = !0, e[t(309)]++;
                        }
                        e[t(339)] = 2, e[t(299)]() && null != c[t(357)] && c.loader[t(365)][t(324)](2), u(0);
                      }, o[h(295)] = function () {
                        var t = h;
                        if (n.default[t(354)](r.BalancerTag, t(362) + i + " " + o[t(371)]), e[t(359)]) {
                          var _i120 = Date[t(367)]();
                          e[t(364)] += _i120 - e[t(332)], e.bannedRefTicToc = _i120;
                        } else {
                          var _i121 = Date.now();
                          e[t(336)] += _i121 - e[t(332)], e[t(332)] = _i121, e.banned = !0, e[t(309)]++;
                        }
                        e[t(339)] = 2, e[t(299)]() && null != c[t(357)] && c[t(357)].CDNLoader[t(324)](2), u(0);
                      }, o.open(t, i), t === h(327) && o[h(307)]("Range", h(355)), o[h(372)] = a.wc[h(325)], o[h(376)]();
                    }));
                  case 2:
                  case "end":
                    return _context13.stop();
                }
              }, _callee8, this);
            }));
          }
        }], [{
          key: "getInstance",
          value: function getInstance(t) {
            var e = at;
            return !this[e(378)] && (this._instance = new ot()), null != t && this[e(378)].setLoader(t), this[e(378)];
          }
        }]);
        return ot;
      }(st(302), st(343), st(345), st(296), st(308), st(300), st(293), st(323), st(379), st(320), st(312), st(315));
      var dt = /*#__PURE__*/function () {
        function dt(t, e) {
          _classCallCheck(this, dt);
          this.columns = ["CDN", "Provider", "# of requests", "% of failed req.", "Traffic served (MB)"], this.requestsPerformed = 0, this.trafficServedInBytes = 0, this.failedRequests = 0, this.name = t, this.provider = e;
        }
        _createClass(dt, [{
          key: "setRequestsPerformed",
          value: function setRequestsPerformed(t) {
            this.requestsPerformed = t;
          }
        }, {
          key: "setTrafficServerInBytes",
          value: function setTrafficServerInBytes(t) {
            this.trafficServedInBytes = t;
          }
        }, {
          key: "setFailedRequests",
          value: function setFailedRequests(t) {
            this.failedRequests = t;
          }
        }, {
          key: "getFailedRequestsPercentage",
          value: function getFailedRequestsPercentage() {
            var t = this.requestsPerformed + this.failedRequests;
            return 0 !== t ? this.failedRequests / t * 100 : 0;
          }
        }, {
          key: "generateRow",
          value: function generateRow() {
            var t = 0 !== this.requestsPerformed ? this.failedRequests / this.requestsPerformed * 100 : 0;
            t = 0 === this.requestsPerformed && this.failedRequests > 0 ? 100 : t;
            var e = "";
            return t > 70 ? e = "red" : t > 30 && (e = "yellow"), {
              row: "%c" + [this.name, this.provider, this.requestsPerformed + this.failedRequests, t.toFixed(0), (this.trafficServedInBytes / 1048576).toFixed(2)].map(function (t) {
                return t.toString().padEnd(18);
              }).join(""),
              color: e
            };
          }
        }]);
        return dt;
      }();
      var ct = i(61);
      var ut = ht;
      !function (t, e) {
        var i = ht,
          s = t();
        for (;;) try {
          if (937099 == -parseInt(i(576)) / 1 * (parseInt(i(437)) / 2) + -parseInt(i(585)) / 3 * (-parseInt(i(582)) / 4) + parseInt(i(547)) / 5 * (parseInt(i(415)) / 6) + parseInt(i(589)) / 7 + parseInt(i(454)) / 8 * (parseInt(i(587)) / 9) + parseInt(i(513)) / 10 + parseInt(i(470)) / 11 * (-parseInt(i(481)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(lt);
      function lt() {
        var t = ["Original", "getRouteAndFilename", "STREBOPX", "changeStatusCDN", "getBucket", "24uajGMb", "isNotOnWhitelist", "progressDownloadedBytes", "_cdnLastInstantBandwith", "_cdnList", "_totalDownloadedBytes", "minApiCallResponseTime", "_activeSwitching", "min", "discarded", "downloadedBytes", "lastPreferedVideoBandwidth", "getFastDataService", "codavelSwitches", "default", "_cdnInstantBandwith", "11NFUUfX", "isLive", "parser", "FAILED -> ", "updateUrl", "instantBandwidth", "timeBetweenBurstsMilliseconds", "getSegmentDuration", "debug", "updateCDNStatsOnSuccess", "test", "34982628vrDofo", "Quality priority", "origRes", "&advanceproxy=true", "qualityPriority", "verbose", "updateCDNStatsOnFailure", "get", "getIsLive", "BALANCER", "next", "_noProbing", "route", "fileName", "apiCallResponses", "banned", "changeCDN", "New url -> ", "decisionReloadIntervalPerManifestMilliseconds", "size", "domainWhitelistRegex", "priorityCdn", "getSecure", "unbannedTime", "providers", "score", "codavelUnbanCount", "profileName", "setResourceInfo", "maximumRelativeDeltaForTrial", "currentRenditionPos", " / ", "487470pIJopy", "renditionCount", "?orresource=", "currentRenditionBandwidth", "codavelUnbanTime", "avgApiCallResponseTime", "setMaxBandwidth", "https", "cleanCdnList", "domainWhitelist", "announcedCdns", "bannedRefTicToc", "monitoringStarted", "concat", "codavelBanRefTicToc", "includes", "setNoProbing", "apply", "forEach", "Update url -> ", "failures", "gotEmptyResponse", "codavelSwitchesDueToConnectivity", "downloadMillis", "resetOnPing", "isEnabled", "Updated", "BalancerVariables", "_highestChunkBandwidth", "maxBandwidth", "values", "trunc", "Disabled", "_activeRequests", "6115khvJde", "activeSwitching", "noProbing", "failed", "_probeOnBanned", "isNotOnCdnList", "&orresource= ", "finalUrl", "retries", "_failedRequests", "incrementSwitchesDueToConnectivity", "getMaxBandwidth", "probeOnlyOnBanned", "VERBOSE", "setLogLevel", "getCommonVariable", " because its host is not one of the currently active CDN hosts: [", "active", "isCodavel", "emit", "delete", "http://", "map", "getStats", "bandwidthThreshold", "name", "lastUpdatedState", "set", "codavelBanTime", "1NkWxZf", "_firstRequestTime", "totalFail", "lastUsedCdn", "then", "codavelBanCount", "1144UQgWqv", "p2pAvailable", "_cdnPeakBandwidth", "6861wtYDSX", "usedOnce", "3956193PZKAWi", "_highestRenditionBandwidth", "9433298lKikgA", "P2P", "bannedTime", "DECISION_FINISHED", "getForceDecision", "path", "cdnName", "max", "join", "lastCodavelRequestStatus", "codavelSwitchesDueToQuality", "delay", "setHeadOnBannedOnly", "processedApiCall", "addCdn", "], nor one of the whitelisted domains [", "value", "onCodavelSwitched", "_probingInfo", "isMasterPlaylist", "cdnBalanceMethod", "_secure", "duration", "updateProgressStats", "incrementSwitchesDueToQuality", "__awaiter", "_p2pLoader", "clear", "STREBOOS", "url", "downloadedChunks", "activeSwitchingPriority", "filter", "addResp", "pathName", "segmentDuration", "hugeChunks", "setActiveSwitchingEnabled", "resource", "minimumDurationSinceLastUsedForTrialMilliseconds", "getActiveRequests", "codavelAllBanned", "startsWith", "isValidUrl", "removeActiveSegment", "minRequestSizeForBwEstimateKB", "initializated", "codavelProvidersState", "lastMeasurementWeight", "_activeCdnRequests", "callTimeoutMilliseconds", "monitor", "_bandwidthThreshold", "updateAvailability", "getAccountCode", "onCodavelFailedResponse", "updateSettings", "getCdnList", "updateCodavelBanTimes", " -> banned ", "apiCallErrors", "https://", "warn", "_options", "CDN priority", "6612GjLvQH", "_chunkCount", "length", "Products", "_resource", "from", "incrementSwitches", "push", "provider", "cdnPriority", "incrementSwitchesDueToErrors", "getRecommendedManifest", "decisionCallWaitTime", "LAST_USED_CDN", "downloadTimeForScoring", "getInstance", "rendition", "throw", "indexOf", "isManifest", "now", "Error updating url -> ", "1729204KRvdri", "codavelSwitchesDueToErrors", "bucketName", "maxApiCallResponseTime", "Invalid regex expression ", "host", "Bypassed ", "timeBetweenCallsMilliseconds", "onFailedApiResponse", "onSucessfullApiResponse", "_lastChunksLapse", "_method"];
        return (lt = function lt() {
          return t;
        })();
      }
      function ht(t, e) {
        var i = lt();
        return (ht = function ht(t, e) {
          return i[t -= 394];
        })(t, e);
      }
      var pt = /*#__PURE__*/function (_ref4, _ut, _ut2, _ut3, _ut4, _ut5, _ut6, _ut7, _ut8, _ut9, _ut10, _ut11, _ut12, _ut13, _ut14, _ut15, _ut16, _ut17, _ut18, _ut19, _ut20, _ut21, _ut22, _ut23, _ut24, _ut25, _ut26, _ut27) {
        _inherits(pt, _ref4);
        var _super3 = _createSuper(pt);
        function pt(t, e, i) {
          var _this37;
          _classCallCheck(this, pt);
          var s = ut;
          _this37 = _super3.call(this), _this37._bandwidthThreshold = a.Ow[s(468)], _this37._cdnList = new Map(), _this37[s(399)] = new Map(), _this37[s(546)] = new Map(), _this37._failedRequests = 0, _this37._chunkCount = 0, _this37[s(607)] = {
            currentCDN: ""
          }, _this37[s(541)] = 0, _this37[s(588)] = 0, _this37[s(457)] = new Map(), _this37._cdnInstantBandwith = new Map(), _this37._cdnPeakBandwidth = new Map(), _this37._retries = new Map(), _this37[s(459)] = 0, _this37[s(577)] = 0, _this37._lastChunkTime = 0, _this37[s(447)] = 0, _this37[s(516)] = 0, _this37[s(511)] = 0, _this37[s(514)] = 0, _this37[s(396)] = !1, _this37[s(525)] = !1, _this37[s(630)] = !1, _this37.codavelBanCount = 0, _this37[s(507)] = 0, _this37[s(575)] = 0, _this37[s(517)] = 0, _this37[s(467)] = 0, _this37[s(535)] = 0, _this37[s(438)] = 0, _this37[s(599)] = 0, _this37[s(527)] = Date[s(435)](), _this37[s(598)] = 0, _this37[s(397)] = new Map(), _this37[s(602)] = !1, _this37[s(518)] = void 0, _this37[s(460)] = void 0, _this37.maxApiCallResponseTime = void 0, _this37[s(410)] = void 0, _this37[s(495)] = void 0, _this37[s(583)] = !1, _this37.bolinaAvailable = !1, _this37[s(620)] = "", _this37[s(502)] = "", _this37[s(523)] = 0, _this37[s(624)] = void 0, _this37._options = t, _this37[s(419)] = e, _this37[s(615)] = i;
          return _this37;
        }
        _createClass(pt, [{
          key: _ut,
          value: function value() {
            var t = ut;
            return null != this[t(610)] && this[t(610)];
          }
        }, {
          key: _ut2,
          value: function value() {
            return this[ut(546)];
          }
        }, {
          key: _ut3,
          value: function value() {
            var t = ut;
            this[t(396)] = !1, this._cdnList[t(616)]();
          }
        }, {
          key: "setSettings",
          value: function setSettings(t, e) {
            var _this38 = this;
            var i = ut;
            var s, o, d, u, l, h, p, f, g, m, v, y, T, S, E, b;
            if (this[i(396)]) return this[i(406)](t, e);
            this[i(458)] = new Map();
            try {
              !0 === (null == t ? void 0 : t[i(478)]) && n.default[i(561)](n.LogLevel.VERBOSE);
              var _r7 = c[i(632)](null !== (s = this._options[i(627)]) && void 0 !== s ? s : "") ? c.getRouteAndFilename(this._options.resource) : {
                route: "",
                fileName: ""
              };
              this[i(610)] = (null !== (d = null === (o = this[i(413)][i(627)]) || void 0 === o ? void 0 : o[i(433)]("https://")) && void 0 !== d ? d : -1) > -1 || void 0, this._resource[i(494)] = _r7.fileName, this[i(419)][i(493)] = _r7.route, this._responseUUID = t.UUID, this[i(448)] = t[i(609)], this[i(461)] = t[i(548)], this[i(402)] = null !== (u = t[i(571)]) && void 0 !== u ? u : a.Ow[i(468)], this[i(551)] = t.probeOnlyOnBanned, this[i(492)] = t[i(549)];
              var _A3 = void 0 !== t[i(548)];
              ot[i(430)]()[i(529)](null !== (l = this._noProbing) && void 0 !== l ? l : this[i(413)].noProbing), this[i(461)] === a.m[i(424)] ? ot.getInstance().setHeadOnBannedOnly(null !== (h = this[i(551)]) && void 0 !== h ? h : this[i(413)][i(559)]) : ot.getInstance()[i(601)](!1), M.default[i(430)]()[i(626)](_A3), a.Zq[i(398)] = null !== (p = t.lastMeasurementWeight) && void 0 !== p ? p : a.Zq.lastMeasurementWeight, a.Zq[i(510)] = null !== (f = t[i(510)]) && void 0 !== f ? f : a.Zq[i(510)], a.Zq[i(628)] = null !== (g = t[i(628)]) && void 0 !== g ? g : a.Zq[i(628)], a.wc[i(400)] = null !== (m = t[i(400)]) && void 0 !== m ? m : a.wc[i(400)], a.wc.timeBetweenBurstsMilliseconds = null !== (v = t[i(476)]) && void 0 !== v ? v : a.wc[i(476)], a.wc[i(444)] = null !== (y = t[i(444)]) && void 0 !== y ? y : a.wc.timeBetweenCallsMilliseconds, a.df[i(427)] = null !== (T = t.decisionCallWaitTime) && void 0 !== T ? T : a.df[i(427)], a.df[i(499)] = null !== (S = t.decisionReloadIntervalPerManifestMilliseconds) && void 0 !== S ? S : a.df[i(499)], a._C.minRequestSizeForBwEstimateKB = null !== (E = t[i(395)]) && void 0 !== E ? E : a._C[i(395)];
              var _w = 0,
                _2 = !1,
                _I = [];
              _I = _A3 ? (null === (b = t[i(505)]) || void 0 === b ? void 0 : b[i(526)](t[i(463)] || [])) || [] : t[i(505)] || [], M.default[i(430)]()[i(521)](), this._p2pLoader[i(538)]() && (this[i(399)][i(590)] = 0, this[i(458)][i(574)](i(590), this[i(615)].getCdnObject())), this[i(583)] = this[i(615)].isEnabled(), this[i(461)] == i(485) ? this[i(620)] = i(482) : this[i(461)] == i(424) ? this[i(620)] = i(414) : this[i(620)] = "Disabled", _I[i(531)](function (t) {
                _w += t[i(506)] || 0;
              });
              var _N28 = !1;
              _I.forEach(function (s) {
                var n = i,
                  r = s[n(506)] || 0,
                  a = c[n(632)](s[n(618)]) ? c[n(450)](s[n(618)]).route : "";
                _2 = _2 || a === e;
                var o = new q(s[n(423)], s[n(572)], s[n(442)], s[n(594)], a, r, a === e, t[n(472)]);
                o[n(442)] = s[n(442)], M.default.getInstance()[n(603)](s[n(572)], new dt(s[n(572)], s.provider)), _this38[n(458)][n(574)](s[n(572)], o), _this38[n(397)] = new Map(Array[n(420)](_this38[n(458)].values())[n(621)](function (t) {
                  return t[n(565)]();
                })[n(569)](function (t) {
                  return [t[n(572)], t[n(496)]];
                })), _this38[n(408)](), _this38[n(399)][s[n(572)]] = 0, !_N28 && (_this38[n(502)] = s.name, _N28 = !0);
              });
            } catch (t) {
              n.default[i(412)](r.BalancerTag, t);
            }
            this[i(523)] = this[i(458)].size - (this[i(615)][i(538)]() ? 1 : 0), this.initializated = !0;
          }
        }, {
          key: _ut4,
          value: function value(t, e) {
            var _this39 = this;
            var i = ut;
            var s, r, o;
            !0 === (null == t ? void 0 : t[i(478)]) && n.default[i(561)](n.LogLevel[i(560)]), this._method = t[i(609)], this[i(461)] = t[i(548)], this[i(551)] = t[i(559)], this[i(492)] = t[i(549)], this.p2pAvailable = this[i(615)][i(538)](), "qualityPriority" == this._activeSwitching ? this.activeSwitchingPriority = i(482) : this[i(461)] == i(424) ? this[i(620)] = "CDN priority" : this[i(620)] = i(545), ot[i(430)]()[i(529)](null !== (s = this._noProbing) && void 0 !== s ? s : this[i(413)].noProbing), this[i(461)] === a.m.cdnPriority ? ot.getInstance()[i(601)](null !== (r = this[i(551)]) && void 0 !== r ? r : this._options.probeOnlyOnBanned) : ot[i(430)]()[i(601)](!1);
            var d = !1;
            var u = (null === (o = t[i(505)]) || void 0 === o ? void 0 : o[i(526)](t[i(463)] || [])) || [],
              l = new Map();
            var h = !1;
            u[i(531)](function (s) {
              var n = i,
                r = _this39._cdnList[n(488)](s.name);
              if (r) {
                r[n(564)] = !0, r.host != s[n(442)] && (r[n(442)] = s[n(442)]), r.path != s.path && (r.path = s[n(594)]);
                var _t61 = c[n(450)](s.url)[n(493)];
                r.url != _t61 && (r[n(618)] = _t61), l[n(574)](s[n(572)], r);
              } else {
                var _i122 = s[n(506)] || 0,
                  _r8 = c.getRouteAndFilename(s.url)[n(493)];
                d = d || _r8 === e;
                var _a10 = new q(s[n(423)], s[n(572)], s[n(442)], s[n(594)], _r8, _i122, _r8 === e, t.parser);
                _this39[n(458)][n(574)](s.name, _a10), l.set(s[n(572)], _a10), _this39[n(399)][s[n(572)]] = 0;
              }
              !h && (_this39[n(502)] = s.name, h = !0);
            }), this[i(523)] = this[i(458)][i(500)] - (this[i(615)].isEnabled() ? 1 : 0), this[i(458)] = l;
            var p = u[i(569)](function (t) {
              return t[i(572)];
            });
            this._cdnList[i(531)](function (t) {
              var e = i;
              p.includes(t.name) || "ORIGINAL" == t[e(423)] || t[e(423)] == e(590) || (t[e(564)] = !1);
            }), this.codavelProvidersState = new Map(Array[i(420)](this[i(458)].values())[i(621)](function (t) {
              return t.isCodavel();
            })[i(569)](function (t) {
              return [t[i(572)], t[i(496)]];
            })), this.updateCodavelBanTimes();
          }
        }, {
          key: "startMonitoring",
          value: function startMonitoring() {
            var t = ut;
            this[t(461)] && (this.monitoringStarted ? ot.getInstance().updateCdnList(this[t(458)]) : (this[t(525)] = !0, ot[t(430)]()[t(401)](this[t(458)])));
          }
        }, {
          key: _ut5,
          value: function value(t, e) {
            var i = ut;
            if (this[i(399)][t] < 1) return;
            this[i(612)]();
            var s = this[i(458)].get(t);
            if (this[i(399)][t]--, 0 == e[i(555)] && this[i(556)]++, null != s && s[i(555)]--, s && !s.banned) {
              if (s[i(496)]) {
                var _t62 = Date[i(435)]();
                s[i(591)] += _t62 - s[i(524)], s.bannedRefTicToc = _t62;
              } else {
                var _t63 = Date.now();
                s[i(504)] += _t63 - s[i(524)], s.bannedRefTicToc = _t63, s[i(496)] = !0, s.bannedCount++;
              }
              s.banned = !0, s.bannedCount++;
            }
            s && n.default[i(486)](r.BalancerTag, i(473) + s[i(572)] + i(409) + s[i(496)]), s && (e.failed = !0, s[i(622)](e), s[i(533)]++, s[i(578)]++, s[i(586)] = !0), this.codavelProvidersState = new Map(Array[i(420)](this._cdnList.values())[i(621)](function (t) {
              return t.isCodavel();
            })[i(569)](function (t) {
              return [t[i(572)], t[i(496)]];
            })), this[i(408)]();
          }
        }, {
          key: _ut6,
          value: function value(t) {
            var e = ut;
            this[e(546)].delete(t.id), this[e(399)][t[e(595)]]--, this[e(416)]++;
          }
        }, {
          key: _ut7,
          value: function value(t) {
            var e = ut;
            var i;
            if (t[e(608)] && (this[e(624)] = t[e(624)]), this.updateProgressStats(), null != t[e(456)]) {
              if (this[e(459)] = this[e(459)] + t[e(500)], 0 != t.duration) {
                var _i123 = 8 * t.size / t[e(611)];
                this[e(541)] < _i123 && (this[e(541)] = _i123);
              }
              null === (i = this[e(458)].get((null == t ? void 0 : t[e(595)]) || "")) || void 0 === i || i[e(622)](t);
            }
            this[e(397)] = new Map(Array.from(this._cdnList[e(543)]())[e(621)](function (t) {
              return t[e(565)]();
            })[e(569)](function (t) {
              return [t.name, t[e(496)]];
            })), this[e(408)]();
          }
        }, {
          key: _ut8,
          value: function value() {
            return this[ut(458)];
          }
        }, {
          key: _ut9,
          value: function value() {
            var _this40 = this;
            var t = ut,
              e = new Map(),
              i = new Map();
            this[t(546)][t(531)](function (i) {
              var s = t,
                n = i[s(475)],
                r = i[s(595)];
              var a = e[s(488)](r);
              null == a && (a = 0), a += n, e[s(574)](r, a);
            }), this[t(469)] = e, e[t(531)](function (e, i) {
              var s = t,
                n = _this40._cdnPeakBandwidth[s(488)](i);
              null == n ? _this40[s(584)][s(574)](i, e) : n < e && _this40._cdnPeakBandwidth[s(574)](i, e);
            }), e[t(531)](function (e, i) {
              0 != e && _this40[t(457)].set(i, e);
            });
            var s = 0;
            i.forEach(function (t, e) {
              s += t;
            });
          }
        }, {
          key: _ut10,
          value: function value(t, i) {
            var s = ut;
            var a, o, d, c, u, l, h, p;
            n.default[s(478)](r.BalancerTag, s(532) + t[s(618)]);
            var f = this.isNotOnCdnList(t.url),
              g = this[s(455)](t[s(618)]);
            if (t[s(434)] && !t[s(550)] || f && g) {
              if (f && g) {
                var _e59 = Array[s(420)](this[s(458)].values())[s(569)](function (t) {
                    return '"' + t[s(442)] + '"';
                  }),
                  _i124 = (null !== (a = this[s(413)][s(522)]) && void 0 !== a ? a : [])[s(526)](null !== (o = this[s(413)][s(501)]) && void 0 !== o ? o : [])[s(569)](function (t) {
                    return '"' + t + '"';
                  });
                n.default[s(478)](r.BalancerTag, s(443) + t[s(618)] + s(563) + _e59[s(597)](",") + s(604) + _i124[s(597)](",") + "]");
              }
              return;
            }
            if (i) {
              var _n25 = this[s(458)][s(488)](i);
              if (_n25) {
                var _i125 = (t[s(618)].startsWith(s(520)) ? s(411) : "http://") + _n25[s(442)];
                return _n25[s(423)] === s(617) || "STREBOPX" === _n25.provider ? _i125 += "/" + e.default[s(430)]().getFastDataService()[s(404)]() + "/" + (null !== (d = this[s(413)][s(508)]) && void 0 !== d ? d : s(468)) + "/" + (null !== (c = this[s(413)].bucketName) && void 0 !== c ? c : s(468)) : _i125 += _n25[s(594)], _i125 += t[s(623)], (_n25[s(423)] === s(617) || _n25[s(423)] === s(451)) && (_i125 += _i125.includes("?") ? s(553) + t[s(483)] : "?orresource=" + t[s(483)]), _n25.provider === s(451) && (_i125 += s(484)), _i125;
              }
            }
            var m = new Map();
            m = new Map(this[s(458)]);
            var v = "",
              y = "";
            var T = (null === (u = t[s(431)]) || void 0 === u ? void 0 : u.bandwidth) || 0;
            for (this[s(588)] < T && (this._highestRenditionBandwidth = T); (!v || "" == v) && (y = new it(m, this[s(402)], this._highestRenditionBandwidth, this._activeSwitching, this[s(615)], this[s(413)]).getCDN(t, this[s(607)]), e.default[s(430)]().registerCommonVariable(ct.default.Products.BALANCER, ct.default[s(540)][s(428)], y === s(449) ? "Origin" : y), y !== s(590));) {
              var _i126 = this._cdnList.get(y);
              try {
                if (_i126 && y != s(449)) {
                  if (v = (t[s(618)][s(631)]("https") ? "https://" : s(568)) + _i126.host, _i126[s(423)] === s(617) || _i126.provider === s(451)) {
                    var _t64 = e.default[s(430)]()[s(466)]()[s(404)]();
                    v += "/" + _t64 + "/" + (null !== (l = this._options[s(508)]) && void 0 !== l ? l : s(468)) + "/" + (null !== (h = this[s(413)][s(439)]) && void 0 !== h ? h : s(468));
                  } else v += _i126[s(594)];
                  v += t.pathName, (_i126[s(423)] === s(617) || _i126[s(423)] === s(451)) && (v += v[s(528)]("?") ? s(553) + t[s(483)] : s(515) + t[s(483)]), _i126[s(423)] === s(451) && (v += s(484)), "" == v && n.default[s(478)](r.BalancerTag, s(436) + t[s(618)] + " / " + (null === (p = this[s(419)]) || void 0 === p ? void 0 : p[s(493)]) + s(512) + _i126.name);
                } else "Original" == y && (v = t[s(618)]);
              } catch (t) {}
              m[s(567)](y);
            }
            if (y === s(590)) v = s(590);else {
              this[s(399)][y]++;
              var _e60 = this[s(458)].get(y);
              if (t[s(554)] = v, _e60 && t[s(497)](v, _e60[s(572)], _e60[s(423)]), n.default[s(486)](r.BalancerTag, s(498) + v + " | " + t[s(595)]), this[s(579)] != y && this[s(579)] !== s(449) && void 0 !== this[s(579)]) {
                var _t65 = this._cdnList[s(488)](this[s(579)]),
                  _e61 = this[s(458)][s(488)](y);
                null != _t65 && (_t65[s(565)]() && null != _e61 && !_e61[s(565)]() && (3 == _t65.lastUpdatedState && this[s(405)](3), this[s(606)]()), _t65[s(421)](), 2 == _t65[s(573)] ? _t65[s(557)]() : 1 == _t65.lastUpdatedState ? _t65[s(425)]() : 3 == _t65[s(573)] && _t65[s(613)]());
              }
              this[s(579)] = y;
            }
            return v;
          }
        }, {
          key: _ut11,
          value: function value(t) {
            var e = ut,
              i = c[e(632)](null != t ? t : "") ? c[e(450)](t) : {
                route: "",
                fileName: ""
              };
            this[e(419)][e(494)] = i[e(494)], this[e(419)][e(493)] = i.route;
          }
        }, {
          key: _ut12,
          value: function value() {
            return t = this, i = void 0, n = /*#__PURE__*/_regeneratorRuntime.mark(function n() {
              var t, i, s;
              return _regeneratorRuntime.wrap(function n$(_context14) {
                while (1) switch (_context14.prev = _context14.next) {
                  case 0:
                    t = ht;
                    i = 0;
                  case 2:
                    if (!(!e.default[t(430)]()[t(562)](ct.default[t(418)][t(490)], ct.default.BalancerVariables[t(592)]) && i++ < 5)) {
                      _context14.next = 7;
                      break;
                    }
                    _context14.next = 5;
                    return c[t(600)](300);
                  case 5:
                    _context14.next = 2;
                    break;
                  case 7:
                    if (!(5 === i)) {
                      _context14.next = 9;
                      break;
                    }
                    return _context14.abrupt("return", this[t(419)][t(493)] + this[t(419)][t(494)]);
                  case 9:
                    s = Array[t(420)](this[t(458)][t(543)]())[t(621)](function (e) {
                      return e[t(572)] !== t(590);
                    });
                    return _context14.abrupt("return", s[t(417)] > 0 ? s[0][t(618)] + this[t(419)].fileName : this[t(419)][t(493)] + this[t(419)][t(494)]);
                  case 11:
                  case "end":
                    return _context14.stop();
                }
              }, n, this);
            }), new ((s = void 0) || (s = Promise))(function (e, r) {
              function a(t) {
                var e = ht;
                try {
                  d(n[e(491)](t));
                } catch (t) {
                  r(t);
                }
              }
              function o(t) {
                var e = ht;
                try {
                  d(n[e(432)](t));
                } catch (t) {
                  r(t);
                }
              }
              function d(t) {
                var i = ht;
                var n;
                t.done ? e(t[i(605)]) : (n = t[i(605)], n instanceof s ? n : new s(function (t) {
                  t(n);
                }))[i(580)](a, o);
              }
              d((n = n[ht(530)](t, i || [])).next());
            });
            var t, i, s, n;
          }
        }, {
          key: _ut13,
          value: function value() {
            var _this41 = this;
            var t = ut,
              e = [];
            var i = 0,
              s = 0,
              n = 0,
              r = 0,
              a = 0,
              o = 0,
              d = 0,
              c = 0;
            return this._cdnList[t(531)](function (u) {
              var l = t;
              if (u[l(572)] === l(590)) return;
              u[l(403)]();
              var h = (u[l(464)] || 0) / ((u.downloadMillis || 1) / 1e3) * 8;
              var p = (u.downloadedBytesForScoring || 0) / ((u[l(429)] || 1) / 1e3) * 8;
              null == h && (h = 0);
              var f = _this41._totalDownloadedBytes / ((Date.now() - _this41[l(577)]) / 1e3) * 8,
                g = _this41[l(584)][l(488)](u[l(572)]) || 0,
                m = _this41[l(469)].get(u[l(572)]) || 0,
                v = _this41[l(457)][l(488)](u[l(572)]) || 0;
              e[l(422)]({
                downloadedBytes: u.downloadedBytes,
                downloadedChunks: u[l(619)],
                bandwidth: Math[l(544)](h),
                instantBandwidth: Math[l(544)](m),
                lastInstantBandwidth: Math[l(544)](v),
                peakBandwidth: Math[l(544)](g),
                failures: u[l(533)],
                totalFailures: u[l(578)],
                retries: u[l(555)],
                downloadTime: u[l(536)],
                provider: u[l(423)],
                profileName: u[l(572)],
                isActive: u[l(564)],
                ptb: f,
                usedOnce: u[l(586)],
                hugeChunks: u[l(625)],
                firstHugeChunkSize: u.firstHugeChunkSize,
                lastChunksLapse: _this41[l(447)],
                maxBandwidth: u.maxBandwidth,
                banned: u[l(496)],
                lastBandwidth: u[l(465)],
                scoringBandwidth: p
              }), i += u[l(464)], s += h, n += g, r += m, a += u[l(619)], o += u.downloadMillis, d += u[l(533)], c += u.retries;
            }), {
              responseUUID: this._responseUUID,
              totalDownloadedBytes: i,
              totalDownloadedChunks: a,
              totalDownloadedTime: o,
              totalFailures: d,
              totalRetries: c,
              activeSwitching: this[t(461)] || "",
              mode: this[t(448)] || "",
              totalBandwidth: Math[t(544)](s),
              totalInstantBandwidth: Math[t(544)](r),
              totalPeakBandwidth: Math.trunc(n),
              cdns: e,
              currentRenditionBandwidth: this[t(516)],
              currentRenditionPos: this.currentRenditionPos,
              renditionCount: this[t(514)]
            };
          }
        }, {
          key: _ut14,
          value: function value(t, e) {
            var i = ut;
            var s = !1,
              n = 0;
            return !e && this._cdnList[i(531)](function (t) {
              t[i(564)] && n++;
            }), this[i(458)].forEach(function (r) {
              var a = i;
              r[a(572)] === t && (e && (r[a(564)] = !0, s = !0), !e && n > 1 && (r[a(564)] = !1, s = !0));
            }), s;
          }
        }, {
          key: _ut15,
          value: function value(t, e) {
            var i = ut,
              s = this[i(458)].get(t);
            return null != s && (s[i(542)] = e, this[i(566)](a.yl[i(539)], {
              loader: this
            }), !0);
          }
        }, {
          key: _ut16,
          value: function value(t) {
            var e = ut,
              i = this[e(458)][e(488)](t);
            return null != i ? i[e(542)] : 0;
          }
        }, {
          key: _ut17,
          value: function value() {
            var t = ut,
              e = Date[t(435)]();
            if (0 === this[t(397)][t(500)]) return void (this.codavelBanRefTicToc = e);
            var i = Array[t(420)](this[t(397)][t(543)]()).every(function (t) {
              return t;
            });
            i !== this[t(630)] ? i ? (this[t(517)] += e - this[t(527)], this[t(527)] = e, this[t(581)]++) : (this[t(575)] += e - this[t(527)], this[t(527)] = e, this[t(507)]++) : i ? (this[t(575)] += e - this[t(527)], this.codavelBanRefTicToc = e) : (this.codavelUnbanTime += e - this.codavelBanRefTicToc, this[t(527)] = e), this[t(630)] = i;
          }
        }, {
          key: _ut18,
          value: function value() {
            var t = ut;
            this[t(575)] = 0, this[t(517)] = 0, this[t(527)] = Date[t(435)](), this[t(602)] = !1, this.avgApiCallResponseTime = void 0, this[t(460)] = void 0, this[t(440)] = void 0, this[t(410)] = void 0, this[t(495)] = void 0;
          }
        }, {
          key: _ut19,
          value: function value() {
            var t = ut;
            this[t(467)]++, 2 == this[t(598)] ? this[t(535)]++ : 1 == this.lastCodavelRequestStatus ? this[t(438)]++ : 3 == this[t(598)] && this.codavelSwitchesDueToQuality++;
          }
        }, {
          key: "onCodavelSucessfullResponse",
          value: function onCodavelSucessfullResponse() {
            this.lastCodavelRequestStatus = 0;
          }
        }, {
          key: "onCodavelFailedResponse",
          value: function onCodavelFailedResponse(t) {
            this[ut(598)] = t;
          }
        }, {
          key: _ut20,
          value: function value() {
            var t = ut;
            null == this[t(410)] ? this[t(410)] = 1 : this[t(410)] += 1, this.processedApiCall = !0;
          }
        }, {
          key: _ut21,
          value: function value(t) {
            var e = ut;
            null == this[e(495)] ? this[e(495)] = 1 : this[e(495)] += 1, null == this[e(460)] ? this.minApiCallResponseTime = t : this.minApiCallResponseTime = Math[e(462)](this[e(460)], t), null == this[e(518)] ? this[e(518)] = t : this[e(518)] = this.avgApiCallResponseTime + (t - this.avgApiCallResponseTime) / this[e(495)], null == this.maxApiCallResponseTime ? this[e(440)] = t : this[e(440)] = Math[e(596)](this[e(440)], t), this.processedApiCall = !0;
          }
        }, {
          key: _ut22,
          value: function value() {
            var t = ut;
            return this[t(413)][t(439)];
          }
        }, {
          key: _ut23,
          value: function value() {
            var t = ut;
            return this[t(413)][t(471)];
          }
        }, {
          key: _ut24,
          value: function value() {
            return this._options.forceDecisionCall;
          }
        }, {
          key: _ut25,
          value: function value() {
            return this[ut(624)];
          }
        }, {
          key: _ut26,
          value: function value(t) {
            var e = ut;
            var i = !1;
            var s = new URL(t);
            var _iterator32 = _createForOfIteratorHelper(this[e(458)][e(543)]()),
              _step32;
            try {
              for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                var _t66 = _step32.value;
                if (_t66.host === s[e(442)]) {
                  i = !0;
                  break;
                }
              }
            } catch (err) {
              _iterator32.e(err);
            } finally {
              _iterator32.f();
            }
            return !i;
          }
        }, {
          key: _ut27,
          value: function value(t) {
            var e = ut;
            var i, s;
            var a = !1;
            var o = new URL(t);
            var _iterator33 = _createForOfIteratorHelper(null !== (i = this[e(413)][e(501)]) && void 0 !== i ? i : []),
              _step33;
            try {
              for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                var _t67 = _step33.value;
                try {
                  if (new RegExp(_t67)[e(480)](o[e(442)])) {
                    a = !0;
                    break;
                  }
                } catch (i) {
                  n.default[e(478)](r.BalancerTag, e(441) + _t67);
                }
              }
            } catch (err) {
              _iterator33.e(err);
            } finally {
              _iterator33.f();
            }
            var _iterator34 = _createForOfIteratorHelper(null !== (s = this[e(413)][e(522)]) && void 0 !== s ? s : []),
              _step34;
            try {
              for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                var _t68 = _step34.value;
                if (a) break;
                if (_t68 === o[e(442)]) {
                  a = !0;
                  break;
                }
              }
            } catch (err) {
              _iterator34.e(err);
            } finally {
              _iterator34.f();
            }
            return !a;
          }
        }]);
        return pt;
      }(_, ut(503), ut(629), ut(534), ut(406), ut(487), ut(394), ut(479), ut(407), ut(612), ut(474), ut(509), ut(426), ut(570), ut(452), ut(519), ut(558), ut(408), ut(537), ut(606), ut(445), ut(446), ut(453), ut(489), ut(593), ut(477), ut(552), ut(455));
      var ft = mt;
      function gt() {
        var t = ["hasSegment", "clear", "min", "has", "2442069NvxQHa", "_reduceMemSize", "31431aukCxJ", "endTime", "54608TRaNOb", "738dCiGJj", "expiration", "destroy", "P2P: Segment not ready yet for segment map", "undefined", "12kFibav", "850196tJiJGb", "p2p", "storeSegment", "getLastSegmentId", "_lastSegmentId", "startTime", "readyForP2P", "p2pId", "15RzdeQo", "_localMem", "getSegment", "get", "cachedSegmentExpiration", "getMaxSize", "_loader", "debug", "push", "getSize", "_expTime", "now", "327096iizLnd", "5613510HJltjO", "count", "forEach", "delete", "size", "_removeOldSegments", "_maxSize", "1133577VXTkwf", "safeMaxCount", "cachedSegmentsCount"];
        return (gt = function gt() {
          return t;
        })();
      }
      function mt(t, e) {
        var i = gt();
        return (mt = function mt(t, e) {
          return i[t -= 306];
        })(t, e);
      }
      !function (t, e) {
        var i = mt,
          s = t();
        for (;;) try {
          if (333800 == parseInt(i(326)) / 1 * (parseInt(i(334)) / 2) + parseInt(i(317)) / 3 + parseInt(i(335)) / 4 * (-parseInt(i(343)) / 5) + parseInt(i(309)) / 6 + parseInt(i(324)) / 7 + -parseInt(i(328)) / 8 * (parseInt(i(329)) / 9) + parseInt(i(310)) / 10) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(gt);
      var vt = /*#__PURE__*/function (_ft, _ft2, _ft3, _ft4, _ft5, _ft6, _ft7, _ft8, _ft9) {
        function vt(t) {
          var _this42 = this;
          _classCallCheck(this, vt);
          var e = mt;
          this[e(344)] = new Map(), this[e(316)] = a.dR.count, this[e(307)] = a.dR[e(330)], this._lastSegmentId = "", this[e(349)] = t, setInterval(function () {
            _this42[e(315)]();
          }, 1e3);
        }
        _createClass(vt, [{
          key: "setSettings",
          value: function setSettings(t) {
            var e = mt,
              i = t[e(336)];
            i && (this._expTime = i[e(347)] || a.dR[e(330)], this[e(316)] = Math[e(322)](i[e(319)] || a.dR[e(311)], a.dR[e(318)]));
          }
        }, {
          key: _ft,
          value: function value() {
            return this[ft(316)];
          }
        }, {
          key: _ft2,
          value: function value(t) {
            var e = ft;
            return this[e(344)][e(346)](t);
          }
        }, {
          key: _ft3,
          value: function value(t) {
            var e = ft;
            return this._localMem[e(323)](t);
          }
        }, {
          key: _ft4,
          value: function value(t) {
            var e = ft;
            return !this[e(320)](t[e(342)]) && typeof t.data !== e(333) && (this[e(339)] = t[e(342)], this[e(344)].set(t[e(342)], t), this[e(325)](), !0);
          }
        }, {
          key: _ft5,
          value: function value() {
            var _this43 = this;
            var t = ft,
              e = Date.now() - this[t(307)];
            this[t(344)][t(312)](function (i, s) {
              var n = t;
              i[n(340)] < e && _this43[n(344)][n(313)](s);
            });
          }
        }, {
          key: _ft6,
          value: function value() {
            var t = ft;
            var e, i;
            this[t(344)][t(314)] - this[t(316)] > 0 && (i = Date[t(308)](), e = "", this[t(344)][t(312)](function (s, n) {
              var r = t;
              s[r(327)] < i && (e = n, i = s[r(327)]);
            }), this._localMem.delete(e), this[t(325)]());
          }
        }, {
          key: "createMap",
          value: function createMap() {
            var t = ft,
              e = [];
            var _iterator35 = _createForOfIteratorHelper(this[t(344)]),
              _step35;
            try {
              for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                var _step35$value = _slicedToArray(_step35.value, 2),
                  _i127 = _step35$value[1];
                _i127[t(341)] ? e[t(351)](_i127[t(342)]) : n.default[t(350)](r.BalancerTag, t(332));
              }
            } catch (err) {
              _iterator35.e(err);
            } finally {
              _iterator35.f();
            }
            return e;
          }
        }, {
          key: _ft7,
          value: function value() {
            var t = ft;
            this[t(344)][t(321)]();
          }
        }, {
          key: _ft8,
          value: function value() {
            var t = ft;
            return this[t(344)][t(314)];
          }
        }, {
          key: _ft9,
          value: function value() {
            return this._lastSegmentId;
          }
        }, {
          key: "getLastSegmentCreatedAt",
          value: function getLastSegmentCreatedAt() {
            var t = ft;
            var e;
            return (null === (e = this._localMem[t(346)](this[t(339)])) || void 0 === e ? void 0 : e.createdAt) || 0;
          }
        }]);
        return vt;
      }(ft(348), ft(345), ft(320), ft(337), ft(315), ft(325), ft(331), ft(306), ft(338));
      var yt = i(8641),
        Tt = i.n(yt);
      function St() {
        var t = ["246UGRlJh", "pos", "5426dPtDQh", "25KzkkPQ", "50448iDdSUt", "5653683NYpdmn", "558vUgXjq", "3LxMdqh", "uri", "275979rCYwXV", "94140cBRzTo", "4285408pbrEel", "5633460FfYtCm"];
        return (St = function St() {
          return t;
        })();
      }
      function Et(t, e) {
        var i = St();
        return (Et = function Et(t, e) {
          return i[t -= 127];
        })(t, e);
      }
      !function (t, e) {
        for (var i = Et, s = t();;) try {
          if (629450 == -parseInt(i(128)) / 1 * (-parseInt(i(139)) / 2) + parseInt(i(133)) / 3 * (-parseInt(i(137)) / 4) + parseInt(i(129)) / 5 * (parseInt(i(136)) / 6) + parseInt(i(131)) / 7 + -parseInt(i(130)) / 8 * (parseInt(i(132)) / 9) + parseInt(i(138)) / 10 + -parseInt(i(135)) / 11) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(St);
      var bt = /*#__PURE__*/_createClass(function bt() {
        _classCallCheck(this, bt);
        var t = Et;
        this[t(134)] = "", this[t(127)] = 0;
      });
      var At = _t;
      function wt() {
        var t = ["uri", "bandwidth", "pos", "367870XqEfcv", "50104FQkvdf", "180264fSELIh", "9228wFIbqF", "1148AJROUj", "set", "4521KjOdYq", "63KiPznD", "2608736BgZxxL", "1100pvXQle", "57002RbrBFc", "125nnzTzq", "targetDuration", "26nhmfVB", "getSegments", "12bIGtgI", "bandwidthPosition", "isAudio", "size", "getSegmentsSize", "segments"];
        return (wt = function wt() {
          return t;
        })();
      }
      function _t(t, e) {
        var i = wt();
        return (_t = function _t(t, e) {
          return i[t -= 245];
        })(t, e);
      }
      !function (t, e) {
        var i = _t,
          s = t();
        for (;;) try {
          if (286418 == -parseInt(i(247)) / 1 + -parseInt(i(260)) / 2 * (parseInt(i(253)) / 3) + parseInt(i(248)) / 4 * (parseInt(i(258)) / 5) + parseInt(i(250)) / 6 * (-parseInt(i(251)) / 7) + parseInt(i(249)) / 8 * (-parseInt(i(254)) / 9) + parseInt(i(256)) / 10 * (parseInt(i(257)) / 11) + -parseInt(i(262)) / 12 * (-parseInt(i(255)) / 13)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(wt);
      var It = /*#__PURE__*/function (_At, _At2) {
        function It() {
          _classCallCheck(this, It);
          var t = _t;
          this[t(268)] = "", this[t(245)] = 0, this[t(264)] = !1, this[t(263)] = -1, this[t(259)] = 0, this[t(267)] = new Map(), this.isMaxRendition = !1;
        }
        _createClass(It, [{
          key: "addSegment",
          value: function addSegment(t, e, i) {
            var s = _t;
            var n = new bt();
            n[s(268)] = e, n[s(246)] = i, this[s(267)][s(252)](t, n);
          }
        }, {
          key: "getSegment",
          value: function getSegment(t) {
            return this[_t(267)].get(t);
          }
        }, {
          key: _At,
          value: function value() {
            var t = At;
            return this[t(267)][t(265)];
          }
        }, {
          key: _At2,
          value: function value() {
            return this[At(267)];
          }
        }]);
        return It;
      }(At(266), At(261));
      var Nt = Dt;
      function Pt() {
        var t = ["bandwidth", "endsWith", "audio", "addSegment", "getRenditions", "2169IQvvUK", "20374670ZnJPji", "6293483SfbNHZ", "231jiPaGo", "25006BYYVuC", "variants", "addRendition", "forEach", "41460nSDoim", "360TpJXip", "targetDuration", "725674DRvPpl", "uri", "4548246mORMoA", "26520gEAeTF", "segments", "parse", "isMasterPlaylist"];
        return (Pt = function Pt() {
          return t;
        })();
      }
      function Dt(t, e) {
        var i = Pt();
        return (Dt = function Dt(t, e) {
          return i[t -= 317];
        })(t, e);
      }
      !function (t, e) {
        var i = Dt,
          s = t();
        for (;;) try {
          if (542725 == -parseInt(i(330)) / 1 + -parseInt(i(323)) / 2 * (parseInt(i(322)) / 3) + -parseInt(i(327)) / 4 * (parseInt(i(328)) / 5) + -parseInt(i(332)) / 6 + parseInt(i(321)) / 7 + -parseInt(i(333)) / 8 * (-parseInt(i(319)) / 9) + parseInt(i(320)) / 10) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(Pt);
      var Rt = /*#__PURE__*/function (_Nt) {
        function Rt() {
          _classCallCheck(this, Rt);
        }
        _createClass(Rt, null, [{
          key: _Nt,
          value: function value(t, e, i) {
            var s = Nt,
              n = Tt()[s(335)](e);
            if (n[s(336)]) null != n[s(324)] && n[s(324)].forEach(function (t) {
              var e = s,
                n = new It();
              n[e(337)] = t[e(337)], n.uri = t[e(331)], i[e(325)](t[e(331)], n), null != t[e(339)] && t[e(339)].forEach(function (t) {
                var s = e,
                  n = new It();
                n[s(331)] = t[s(331)], n.isAudio = !0, i.addRendition(t.uri, n);
              });
            });else {
              var _e62 = !1;
              i[s(318)]().forEach(function (r, a) {
                var o = s;
                t[o(338)](a) && (null != n[o(334)] && n.segments[o(326)](function (t) {
                  var e = o;
                  i[e(317)](a, t[e(331)], t[e(331)]);
                }), null != n[o(329)] && (r[o(329)] = n[o(329)]), _e62 = !0);
              });
            }
            return n;
          }
        }]);
        return Rt;
      }(Nt(335));
      var Lt = i(9731),
        Ct = i.n(Lt),
        Ot = i(2553),
        Bt = i.n(Ot);
      var xt = function xt(t, e) {
        if (/^[a-z]+:/i.test(e)) return e;
        /^data:/.test(t) && (t = Bt().location && Bt().location.href || "");
        var i = "function" == typeof Bt().URL,
          s = /^\/\//.test(t),
          n = !Bt().location && !/\/\//i.test(t);
        if (i ? t = new (Bt().URL)(t, Bt().location || "http://example.com") : /\/\//i.test(t) || (t = Ct().buildAbsoluteURL(Bt().location && Bt().location.href || "", t)), i) {
          var r = new URL(e, t);
          return n ? r.href.slice(18) : s ? r.href.slice(r.protocol.length) : r.href;
        }
        return Ct().buildAbsoluteURL(t, e);
      };
      var Mt = i(1048).hp;
      var kt = i(7937),
        Ut = function Ut(t) {
          return !!t && "object" == typeof t;
        },
        Vt = function t() {
          for (var e = arguments.length, i = new Array(e), s = 0; s < e; s++) i[s] = arguments[s];
          return i.reduce(function (e, i) {
            return "object" != typeof i || Object.keys(i).forEach(function (s) {
              Array.isArray(e[s]) && Array.isArray(i[s]) ? e[s] = e[s].concat(i[s]) : Ut(e[s]) && Ut(i[s]) ? e[s] = t(e[s], i[s]) : e[s] = i[s];
            }), e;
          }, {});
        },
        qt = function qt(t) {
          return Object.keys(t).map(function (e) {
            return t[e];
          });
        },
        Ft = function Ft(t) {
          return t.reduce(function (t, e) {
            return t.concat(e);
          }, []);
        },
        Xt = function Xt(t) {
          if (!t.length) return [];
          for (var e = [], i = 0; i < t.length; i++) e.push(t[i]);
          return e;
        },
        Ht = function Ht(t, e) {
          for (var i = 0; i < t.length; i++) if (e(t[i])) return i;
          return -1;
        },
        Gt = function Gt(t) {
          var e = t.baseUrl,
            i = void 0 === e ? "" : e,
            s = t.source,
            n = void 0 === s ? "" : s,
            r = t.range,
            a = void 0 === r ? "" : r,
            o = t.indexRange,
            d = void 0 === o ? "" : o,
            c = {
              uri: n,
              resolvedUri: xt(i || "", n)
            };
          if (a || d) {
            var u,
              l = (a || d).split("-"),
              h = Bt().BigInt ? Bt().BigInt(l[0]) : parseInt(l[0], 10),
              p = Bt().BigInt ? Bt().BigInt(l[1]) : parseInt(l[1], 10);
            h < Number.MAX_SAFE_INTEGER && "bigint" == typeof h && (h = Number(h)), p < Number.MAX_SAFE_INTEGER && "bigint" == typeof p && (p = Number(p)), "bigint" == typeof (u = "bigint" == typeof p || "bigint" == typeof h ? Bt().BigInt(p) - Bt().BigInt(h) + Bt().BigInt(1) : p - h + 1) && u < Number.MAX_SAFE_INTEGER && (u = Number(u)), c.byterange = {
              length: u,
              offset: h
            };
          }
          return c;
        },
        jt = function jt(t) {
          return t && "number" != typeof t && (t = parseInt(t, 10)), isNaN(t) ? null : t;
        },
        Wt = {
          static: function _static(t) {
            var e = t.duration,
              i = t.timescale,
              s = void 0 === i ? 1 : i,
              n = t.sourceDuration,
              r = t.periodDuration,
              a = jt(t.endNumber),
              o = e / s;
            return "number" == typeof a ? {
              start: 0,
              end: a
            } : "number" == typeof r ? {
              start: 0,
              end: r / o
            } : {
              start: 0,
              end: n / o
            };
          },
          dynamic: function dynamic(t) {
            var e = t.NOW,
              i = t.clientOffset,
              s = t.availabilityStartTime,
              n = t.timescale,
              r = void 0 === n ? 1 : n,
              a = t.duration,
              o = t.periodStart,
              d = void 0 === o ? 0 : o,
              c = t.minimumUpdatePeriod,
              u = void 0 === c ? 0 : c,
              l = t.timeShiftBufferDepth,
              h = void 0 === l ? 1 / 0 : l,
              p = jt(t.endNumber),
              f = (e + i) / 1e3,
              g = s + d,
              m = f + u - g,
              v = Math.ceil(m * r / a),
              y = Math.floor((f - g - h) * r / a),
              T = Math.floor((f - g) * r / a);
            return {
              start: Math.max(0, y),
              end: "number" == typeof p ? p : Math.min(v, T)
            };
          }
        },
        Yt = function Yt(t) {
          var e = t.type,
            i = t.duration,
            s = t.timescale,
            n = void 0 === s ? 1 : s,
            r = t.periodDuration,
            a = t.sourceDuration,
            o = Wt[e](t),
            d = function (t, e) {
              for (var i = [], s = t; s < e; s++) i.push(s);
              return i;
            }(o.start, o.end).map(function (t) {
              return function (e) {
                var i = t.duration,
                  s = t.timescale,
                  n = void 0 === s ? 1 : s,
                  r = t.periodStart,
                  a = t.startNumber;
                return {
                  number: (void 0 === a ? 1 : a) + e,
                  duration: i / n,
                  timeline: r,
                  time: e * i
                };
              };
            }(t));
          if ("static" === e) {
            var c = d.length - 1,
              u = "number" == typeof r ? r : a;
            d[c].duration = u - i / n * c;
          }
          return d;
        },
        zt = function zt(t) {
          var e = t.baseUrl,
            i = t.initialization,
            s = void 0 === i ? {} : i,
            n = t.sourceDuration,
            r = t.indexRange,
            a = void 0 === r ? "" : r,
            o = t.periodStart,
            d = t.presentationTime,
            c = t.number,
            u = void 0 === c ? 0 : c,
            l = t.duration;
          if (!e) throw new Error("NO_BASE_URL");
          var h = Gt({
              baseUrl: e,
              source: s.sourceURL,
              range: s.range
            }),
            p = Gt({
              baseUrl: e,
              source: e,
              indexRange: a
            });
          if (p.map = h, l) {
            var f = Yt(t);
            f.length && (p.duration = f[0].duration, p.timeline = f[0].timeline);
          } else n && (p.duration = n, p.timeline = o);
          return p.presentationTime = d || o, p.number = u, [p];
        },
        Kt = function Kt(t, e, i) {
          var s,
            n = t.sidx.map ? t.sidx.map : null,
            r = t.sidx.duration,
            a = t.timeline || 0,
            o = t.sidx.byterange,
            d = o.offset + o.length,
            c = e.timescale,
            u = e.references.filter(function (t) {
              return 1 !== t.referenceType;
            }),
            l = [],
            h = t.endList ? "static" : "dynamic",
            p = t.sidx.timeline,
            f = p,
            g = t.mediaSequence || 0;
          s = "bigint" == typeof e.firstOffset ? Bt().BigInt(d) + e.firstOffset : d + e.firstOffset;
          for (var m = 0; m < u.length; m++) {
            var v,
              y = e.references[m],
              T = y.referencedSize,
              S = y.subsegmentDuration;
            v = "bigint" == typeof s ? s + Bt().BigInt(T) - Bt().BigInt(1) : s + T - 1;
            var E = zt({
              baseUrl: i,
              timescale: c,
              timeline: a,
              periodStart: p,
              presentationTime: f,
              number: g,
              duration: S,
              sourceDuration: r,
              indexRange: s + "-" + v,
              type: h
            })[0];
            n && (E.map = n), l.push(E), s += "bigint" == typeof s ? Bt().BigInt(T) : T, f += S / c, g++;
          }
          return t.segments = l, t;
        },
        Qt = ["AUDIO", "SUBTITLES"],
        Jt = 1 / 60,
        $t = function $t(t) {
          return (e = t, i = function i(t) {
            return t.timeline;
          }, qt(e.reduce(function (t, e) {
            return e.forEach(function (e) {
              t[i(e)] = e;
            }), t;
          }, {}))).sort(function (t, e) {
            return t.timeline > e.timeline ? 1 : -1;
          });
          var e, i;
        },
        Zt = function Zt(t) {
          var e,
            i,
            s = [];
          return e = t, i = function i(t, e, _i128, n) {
            s = s.concat(t.playlists || []);
          }, Qt.forEach(function (t) {
            for (var s in e.mediaGroups[t]) for (var n in e.mediaGroups[t][s]) {
              var r = e.mediaGroups[t][s][n];
              i(r);
            }
          }), s;
        },
        te = function te(t) {
          var e = t.playlist,
            i = t.mediaSequence;
          e.mediaSequence = i, e.segments.forEach(function (t, i) {
            t.number = e.mediaSequence + i;
          });
        },
        ee = function ee(t) {
          return t && t.uri + "-" + (i = "bigint" == typeof (e = t.byterange).offset || "bigint" == typeof e.length ? Bt().BigInt(e.offset) + Bt().BigInt(e.length) - Bt().BigInt(1) : e.offset + e.length - 1, e.offset + "-" + i);
          var e, i;
        },
        ie = function ie(t) {
          return qt(t.reduce(function (t, e) {
            var i,
              s = e.attributes.id + (e.attributes.lang || "");
            t[s] ? (e.segments && (e.segments[0] && (e.segments[0].discontinuity = !0), (i = t[s].segments).push.apply(i, e.segments)), e.attributes.contentProtection && (t[s].attributes.contentProtection = e.attributes.contentProtection)) : (t[s] = e, t[s].attributes.timelineStarts = []);
            return t[s].attributes.timelineStarts.push({
              start: e.attributes.periodStart,
              timeline: e.attributes.periodStart
            }), t;
          }, {})).map(function (t) {
            var e;
            return t.discontinuityStarts = (e = t.segments || [], e.reduce(function (t, e, i) {
              return e.discontinuity && t.push(i), t;
            }, [])), t;
          });
        },
        se = function se(t, e) {
          var i = ee(t.sidx),
            s = i && e[i] && e[i].sidx;
          return s && Kt(t, s, t.sidx.resolvedUri), t;
        },
        ne = function ne(t, e) {
          if (void 0 === e && (e = {}), !Object.keys(e).length) return t;
          for (var i in t) t[i] = se(t[i], e);
          return t;
        },
        re = function re(t) {
          var e,
            i = t.attributes,
            s = t.segments,
            n = t.sidx,
            r = t.discontinuityStarts,
            a = {
              attributes: (e = {
                NAME: i.id,
                AUDIO: "audio",
                SUBTITLES: "subs",
                RESOLUTION: {
                  width: i.width,
                  height: i.height
                },
                CODECS: i.codecs,
                BANDWIDTH: i.bandwidth
              }, e["PROGRAM-ID"] = 1, e),
              uri: "",
              endList: "static" === i.type,
              timeline: i.periodStart,
              resolvedUri: "",
              targetDuration: i.duration,
              discontinuityStarts: r,
              timelineStarts: i.timelineStarts,
              segments: s
            };
          return i.contentProtection && (a.contentProtection = i.contentProtection), n && (a.sidx = n), a;
        },
        ae = function ae(t) {
          var e = t.attributes;
          return "video/mp4" === e.mimeType || "video/webm" === e.mimeType || "video" === e.contentType;
        },
        oe = function oe(t) {
          var e = t.attributes;
          return "audio/mp4" === e.mimeType || "audio/webm" === e.mimeType || "audio" === e.contentType;
        },
        de = function de(t) {
          var e = t.attributes;
          return "text/vtt" === e.mimeType || "text" === e.contentType;
        },
        ce = function ce(t) {
          return t ? Object.keys(t).reduce(function (e, i) {
            var s = t[i];
            return e.concat(s.playlists);
          }, []) : [];
        },
        ue = function ue(t) {
          var e,
            i = t.dashPlaylists,
            s = t.locations,
            n = t.sidxMapping,
            r = void 0 === n ? {} : n,
            a = t.previousManifest;
          if (!i.length) return {};
          var o = i[0].attributes,
            d = o.sourceDuration,
            c = o.type,
            u = o.suggestedPresentationDelay,
            l = o.minimumUpdatePeriod,
            h = ie(i.filter(ae)).map(re),
            p = ie(i.filter(oe)),
            f = ie(i.filter(de)),
            g = i.map(function (t) {
              return t.attributes.captionServices;
            }).filter(Boolean),
            m = {
              allowCache: !0,
              discontinuityStarts: [],
              segments: [],
              endList: !0,
              mediaGroups: (e = {
                AUDIO: {},
                VIDEO: {}
              }, e["CLOSED-CAPTIONS"] = {}, e.SUBTITLES = {}, e),
              uri: "",
              duration: d,
              playlists: ne(h, r)
            };
          l >= 0 && (m.minimumUpdatePeriod = 1e3 * l), s && (m.locations = s), "dynamic" === c && (m.suggestedPresentationDelay = u);
          var v,
            y,
            T,
            S,
            E,
            b,
            A,
            w = 0 === m.playlists.length,
            _ = p.length ? function (t, e, i) {
              var s;
              void 0 === e && (e = {}), void 0 === i && (i = !1);
              var n = t.reduce(function (t, n) {
                var r = n.attributes.role && n.attributes.role.value || "",
                  a = n.attributes.lang || "",
                  o = n.attributes.label || "main";
                if (a && !n.attributes.label) {
                  var d = r ? " (" + r + ")" : "";
                  o = "" + n.attributes.lang + d;
                }
                t[o] || (t[o] = {
                  language: a,
                  autoselect: !0,
                  default: "main" === r,
                  playlists: [],
                  uri: ""
                });
                var c = se(function (t, e) {
                  var i,
                    s = t.attributes,
                    n = t.segments,
                    r = t.sidx,
                    a = t.mediaSequence,
                    o = t.discontinuitySequence,
                    d = t.discontinuityStarts,
                    c = {
                      attributes: (i = {
                        NAME: s.id,
                        BANDWIDTH: s.bandwidth,
                        CODECS: s.codecs
                      }, i["PROGRAM-ID"] = 1, i),
                      uri: "",
                      endList: "static" === s.type,
                      timeline: s.periodStart,
                      resolvedUri: "",
                      targetDuration: s.duration,
                      discontinuitySequence: o,
                      discontinuityStarts: d,
                      timelineStarts: s.timelineStarts,
                      mediaSequence: a,
                      segments: n
                    };
                  return s.contentProtection && (c.contentProtection = s.contentProtection), r && (c.sidx = r), e && (c.attributes.AUDIO = "audio", c.attributes.SUBTITLES = "subs"), c;
                }(n, i), e);
                return t[o].playlists.push(c), void 0 === s && "main" === r && ((s = n).default = !0), t;
              }, {});
              return s || (n[Object.keys(n)[0]].default = !0), n;
            }(p, r, w) : null,
            I = f.length ? function (t, e) {
              return void 0 === e && (e = {}), t.reduce(function (t, i) {
                var s = i.attributes.lang || "text";
                return t[s] || (t[s] = {
                  language: s,
                  default: !1,
                  autoselect: !1,
                  playlists: [],
                  uri: ""
                }), t[s].playlists.push(se(function (t) {
                  var e,
                    i = t.attributes,
                    s = t.segments,
                    n = t.mediaSequence,
                    r = t.discontinuityStarts,
                    a = t.discontinuitySequence;
                  void 0 === s && (s = [{
                    uri: i.baseUrl,
                    timeline: i.periodStart,
                    resolvedUri: i.baseUrl || "",
                    duration: i.sourceDuration,
                    number: 0
                  }], i.duration = i.sourceDuration);
                  var o = ((e = {
                    NAME: i.id,
                    BANDWIDTH: i.bandwidth
                  })["PROGRAM-ID"] = 1, e);
                  return i.codecs && (o.CODECS = i.codecs), {
                    attributes: o,
                    uri: "",
                    endList: "static" === i.type,
                    timeline: i.periodStart,
                    resolvedUri: i.baseUrl || "",
                    targetDuration: i.duration,
                    timelineStarts: i.timelineStarts,
                    discontinuityStarts: r,
                    discontinuitySequence: a,
                    mediaSequence: n,
                    segments: s
                  };
                }(i), e)), t;
              }, {});
            }(f, r) : null,
            N = h.concat(ce(_), ce(I)),
            P = N.map(function (t) {
              return t.timelineStarts;
            });
          return m.timelineStarts = $t(P), v = N, y = m.timelineStarts, v.forEach(function (t) {
            t.mediaSequence = 0, t.discontinuitySequence = Ht(y, function (e) {
              return e.timeline === t.timeline;
            }), t.segments && t.segments.forEach(function (t, e) {
              t.number = e;
            });
          }), _ && (m.mediaGroups.AUDIO.audio = _), I && (m.mediaGroups.SUBTITLES.subs = I), g.length && (m.mediaGroups["CLOSED-CAPTIONS"].cc = g.reduce(function (t, e) {
            return e ? (e.forEach(function (e) {
              var i = e.channel,
                s = e.language;
              t[s] = {
                autoselect: !1,
                default: !1,
                instreamId: i,
                language: s
              }, e.hasOwnProperty("aspectRatio") && (t[s].aspectRatio = e.aspectRatio), e.hasOwnProperty("easyReader") && (t[s].easyReader = e.easyReader), e.hasOwnProperty("3D") && (t[s]["3D"] = e["3D"]);
            }), t) : t;
          }, {})), a ? (S = (T = {
            oldManifest: a,
            newManifest: m
          }).oldManifest, E = T.newManifest, b = S.playlists.concat(Zt(S)), A = E.playlists.concat(Zt(E)), E.timelineStarts = $t([S.timelineStarts, E.timelineStarts]), function (t) {
            var e = t.oldPlaylists,
              i = t.timelineStarts;
            t.newPlaylists.forEach(function (t) {
              t.discontinuitySequence = Ht(i, function (e) {
                return e.timeline === t.timeline;
              });
              var s = function (t, e) {
                for (var i = 0; i < t.length; i++) if (t[i].attributes.NAME === e) return t[i];
                return null;
              }(e, t.attributes.NAME);
              if (s && !t.sidx) {
                var n = t.segments[0],
                  r = Ht(s.segments, function (t) {
                    return Math.abs(t.presentationTime - n.presentationTime) < Jt;
                  });
                if (-1 === r) return te({
                  playlist: t,
                  mediaSequence: s.mediaSequence + s.segments.length
                }), t.segments[0].discontinuity = !0, t.discontinuityStarts.unshift(0), void ((!s.segments.length && t.timeline > s.timeline || s.segments.length && t.timeline > s.segments[s.segments.length - 1].timeline) && t.discontinuitySequence--);
                s.segments[r].discontinuity && !n.discontinuity && (n.discontinuity = !0, t.discontinuityStarts.unshift(0), t.discontinuitySequence--), te({
                  playlist: t,
                  mediaSequence: s.segments[r].number
                });
              }
            });
          }({
            oldPlaylists: b,
            newPlaylists: A,
            timelineStarts: E.timelineStarts
          }), E) : m;
        },
        le = function le(t, e, i) {
          var s = t.NOW,
            n = t.clientOffset,
            r = t.availabilityStartTime,
            a = t.timescale,
            o = void 0 === a ? 1 : a,
            d = t.periodStart,
            c = void 0 === d ? 0 : d,
            u = t.minimumUpdatePeriod,
            l = (s + n) / 1e3 + (void 0 === u ? 0 : u) - (r + c);
          return Math.ceil((l * o - e) / i);
        },
        he = function he(t, e) {
          for (var i = t.type, s = t.minimumUpdatePeriod, n = void 0 === s ? 0 : s, r = t.media, a = void 0 === r ? "" : r, o = t.sourceDuration, d = t.timescale, c = void 0 === d ? 1 : d, u = t.startNumber, l = void 0 === u ? 1 : u, h = t.periodStart, p = [], f = -1, g = 0; g < e.length; g++) {
            var m = e[g],
              v = m.d,
              y = m.r || 0,
              T = m.t || 0;
            f < 0 && (f = T), T && T > f && (f = T);
            var S = void 0;
            if (y < 0) {
              var E = g + 1;
              S = E === e.length ? "dynamic" === i && n > 0 && a.indexOf("$Number$") > 0 ? le(t, f, v) : (o * c - f) / v : (e[E].t - f) / v;
            } else S = y + 1;
            for (var b = l + p.length + S, A = l + p.length; A < b;) p.push({
              number: A,
              duration: v / c,
              time: f,
              timeline: h
            }), f += v, A++;
          }
          return p;
        },
        pe = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g,
        fe = function fe(t, e) {
          return t.replace(pe, function (t) {
            return function (e, i, s, n) {
              if ("$$" === e) return "$";
              if (void 0 === t[i]) return e;
              var r = "" + t[i];
              return "RepresentationID" === i ? r : (n = s ? parseInt(n, 10) : 1, r.length >= n ? r : "" + new Array(n - r.length + 1).join("0") + r);
            };
          }(e));
        },
        ge = function ge(t, e) {
          var i = {
              RepresentationID: t.id,
              Bandwidth: t.bandwidth || 0
            },
            s = t.initialization,
            n = void 0 === s ? {
              sourceURL: "",
              range: ""
            } : s,
            r = Gt({
              baseUrl: t.baseUrl,
              source: fe(n.sourceURL, i),
              range: n.range
            }),
            a = function (t, e) {
              return t.duration || e ? t.duration ? Yt(t) : he(t, e) : [{
                number: t.startNumber || 1,
                duration: t.sourceDuration,
                time: 0,
                timeline: t.periodStart
              }];
            }(t, e);
          return a.map(function (e) {
            i.Number = e.number, i.Time = e.time;
            var s = fe(t.media || "", i),
              n = t.timescale || 1,
              a = t.presentationTimeOffset || 0,
              o = t.periodStart + (e.time - a) / n;
            return {
              uri: s,
              timeline: e.timeline,
              duration: e.duration,
              resolvedUri: xt(t.baseUrl || "", s),
              map: r,
              number: e.number,
              presentationTime: o
            };
          });
        },
        me = function me(t, e) {
          var i = t.duration,
            s = t.segmentUrls,
            n = void 0 === s ? [] : s,
            r = t.periodStart;
          if (!i && !e || i && e) throw new Error("SEGMENT_TIME_UNSPECIFIED");
          var a,
            o = n.map(function (e) {
              return function (t, e) {
                var i = t.baseUrl,
                  s = t.initialization,
                  n = void 0 === s ? {} : s,
                  r = Gt({
                    baseUrl: i,
                    source: n.sourceURL,
                    range: n.range
                  }),
                  a = Gt({
                    baseUrl: i,
                    source: e.media,
                    range: e.mediaRange
                  });
                return a.map = r, a;
              }(t, e);
            });
          return i && (a = Yt(t)), e && (a = he(t, e)), a.map(function (e, i) {
            if (o[i]) {
              var s = o[i],
                n = t.timescale || 1,
                a = t.presentationTimeOffset || 0;
              return s.timeline = e.timeline, s.duration = e.duration, s.number = e.number, s.presentationTime = r + (e.time - a) / n, s;
            }
          }).filter(function (t) {
            return t;
          });
        },
        ve = function ve(t) {
          var e,
            i,
            s = t.attributes,
            n = t.segmentInfo;
          n.template ? (i = ge, e = Vt(s, n.template)) : n.base ? (i = zt, e = Vt(s, n.base)) : n.list && (i = me, e = Vt(s, n.list));
          var r = {
            attributes: s
          };
          if (!i) return r;
          var a = i(e, n.segmentTimeline);
          if (e.duration) {
            var o = e,
              d = o.duration,
              c = o.timescale,
              u = void 0 === c ? 1 : c;
            e.duration = d / u;
          } else a.length ? e.duration = a.reduce(function (t, e) {
            return Math.max(t, Math.ceil(e.duration));
          }, 0) : e.duration = 0;
          return r.attributes = e, r.segments = a, n.base && e.indexRange && (r.sidx = a[0], r.segments = []), r;
        },
        ye = function ye(t) {
          return t.map(ve);
        },
        Te = function Te(t, e) {
          return Xt(t.childNodes).filter(function (t) {
            return t.tagName === e;
          });
        },
        Se = function Se(t) {
          return t.textContent.trim();
        },
        Ee = function Ee(t) {
          var e = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(t);
          if (!e) return 0;
          var i = e.slice(1),
            s = i[0],
            n = i[1],
            r = i[2],
            a = i[3],
            o = i[4],
            d = i[5];
          return 31536e3 * parseFloat(s || 0) + 2592e3 * parseFloat(n || 0) + 86400 * parseFloat(r || 0) + 3600 * parseFloat(a || 0) + 60 * parseFloat(o || 0) + parseFloat(d || 0);
        },
        be = {
          mediaPresentationDuration: function mediaPresentationDuration(t) {
            return Ee(t);
          },
          availabilityStartTime: function availabilityStartTime(t) {
            return /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(e = t) && (e += "Z"), Date.parse(e) / 1e3;
            var e;
          },
          minimumUpdatePeriod: function minimumUpdatePeriod(t) {
            return Ee(t);
          },
          suggestedPresentationDelay: function suggestedPresentationDelay(t) {
            return Ee(t);
          },
          type: function type(t) {
            return t;
          },
          timeShiftBufferDepth: function timeShiftBufferDepth(t) {
            return Ee(t);
          },
          start: function start(t) {
            return Ee(t);
          },
          width: function width(t) {
            return parseInt(t, 10);
          },
          height: function height(t) {
            return parseInt(t, 10);
          },
          bandwidth: function bandwidth(t) {
            return parseInt(t, 10);
          },
          startNumber: function startNumber(t) {
            return parseInt(t, 10);
          },
          timescale: function timescale(t) {
            return parseInt(t, 10);
          },
          presentationTimeOffset: function presentationTimeOffset(t) {
            return parseInt(t, 10);
          },
          duration: function duration(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? Ee(t) : e;
          },
          d: function d(t) {
            return parseInt(t, 10);
          },
          t: function t(_t69) {
            return parseInt(_t69, 10);
          },
          r: function r(t) {
            return parseInt(t, 10);
          },
          DEFAULT: function DEFAULT(t) {
            return t;
          }
        },
        Ae = function Ae(t) {
          return t && t.attributes ? Xt(t.attributes).reduce(function (t, e) {
            var i = be[e.name] || be.DEFAULT;
            return t[e.name] = i(e.value), t;
          }, {}) : {};
        },
        we = {
          "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
          "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
          "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
          "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
        },
        _e = function _e(t, e) {
          return e.length ? Ft(t.map(function (t) {
            return e.map(function (e) {
              return xt(t, Se(e));
            });
          })) : t;
        },
        Ie = function Ie(t) {
          var e = Te(t, "SegmentTemplate")[0],
            i = Te(t, "SegmentList")[0],
            s = i && Te(i, "SegmentURL").map(function (t) {
              return Vt({
                tag: "SegmentURL"
              }, Ae(t));
            }),
            n = Te(t, "SegmentBase")[0],
            r = i || e,
            a = r && Te(r, "SegmentTimeline")[0],
            o = i || n || e,
            d = o && Te(o, "Initialization")[0],
            c = e && Ae(e);
          c && d ? c.initialization = d && Ae(d) : c && c.initialization && (c.initialization = {
            sourceURL: c.initialization
          });
          var u = {
            template: c,
            segmentTimeline: a && Te(a, "S").map(function (t) {
              return Ae(t);
            }),
            list: i && Vt(Ae(i), {
              segmentUrls: s,
              initialization: Ae(d)
            }),
            base: n && Vt(Ae(n), {
              initialization: Ae(d)
            })
          };
          return Object.keys(u).forEach(function (t) {
            u[t] || delete u[t];
          }), u;
        },
        Ne = function Ne(t, e, i) {
          return function (s) {
            var n,
              r = Ae(s),
              a = _e(e, Te(s, "BaseURL")),
              o = Te(s, "Role")[0],
              d = {
                role: Ae(o)
              },
              c = Vt(t, r, d),
              u = Te(s, "Accessibility")[0],
              l = "urn:scte:dash:cc:cea-608:2015" === (n = Ae(u)).schemeIdUri ? ("string" != typeof n.value ? [] : n.value.split(";")).map(function (t) {
                var e, i;
                if (i = t, /^CC\d=/.test(t)) {
                  var s = t.split("=");
                  e = s[0], i = s[1];
                } else /^CC\d$/.test(t) && (e = t);
                return {
                  channel: e,
                  language: i
                };
              }) : "urn:scte:dash:cc:cea-708:2015" === n.schemeIdUri ? ("string" != typeof n.value ? [] : n.value.split(";")).map(function (t) {
                var e = {
                  channel: void 0,
                  language: void 0,
                  aspectRatio: 1,
                  easyReader: 0,
                  "3D": 0
                };
                if (/=/.test(t)) {
                  var i = t.split("="),
                    s = i[0],
                    n = i[1],
                    r = void 0 === n ? "" : n;
                  e.channel = s, e.language = t, r.split(",").forEach(function (t) {
                    var i = t.split(":"),
                      s = i[0],
                      n = i[1];
                    "lang" === s ? e.language = n : "er" === s ? e.easyReader = Number(n) : "war" === s ? e.aspectRatio = Number(n) : "3D" === s && (e["3D"] = Number(n));
                  });
                } else e.language = t;
                return e.channel && (e.channel = "SERVICE" + e.channel), e;
              }) : void 0;
            l && (c = Vt(c, {
              captionServices: l
            }));
            var h = Te(s, "Label")[0];
            if (h && h.childNodes.length) {
              var p = h.childNodes[0].nodeValue.trim();
              c = Vt(c, {
                label: p
              });
            }
            var f = Te(s, "ContentProtection").reduce(function (t, e) {
              var i = Ae(e);
              i.schemeIdUri && (i.schemeIdUri = i.schemeIdUri.toLowerCase());
              var s = we[i.schemeIdUri];
              if (s) {
                t[s] = {
                  attributes: i
                };
                var n = Te(e, "cenc:pssh")[0];
                if (n) {
                  var r = Se(n);
                  t[s].pssh = r && function (t) {
                    for (var e, i = (e = t, Bt().atob ? Bt().atob(e) : Mt.from(e, "base64").toString("binary")), s = new Uint8Array(i.length), n = 0; n < i.length; n++) s[n] = i.charCodeAt(n);
                    return s;
                  }(r);
                }
              }
              return t;
            }, {});
            Object.keys(f).length && (c = Vt(c, {
              contentProtection: f
            }));
            var g = Ie(s),
              m = Te(s, "Representation"),
              v = Vt(i, g);
            return Ft(m.map(function (t, e, i) {
              return function (s) {
                var n = Te(s, "BaseURL"),
                  r = _e(e, n),
                  a = Vt(t, Ae(s)),
                  o = Ie(s);
                return r.map(function (t) {
                  return {
                    segmentInfo: Vt(i, o),
                    attributes: Vt(a, {
                      baseUrl: t
                    })
                  };
                });
              };
            }(c, a, v)));
          };
        },
        Pe = function Pe(t, e) {
          return function (i, s) {
            var n = _e(e, Te(i.node, "BaseURL")),
              r = Vt(t, {
                periodStart: i.attributes.start
              });
            "number" == typeof i.attributes.duration && (r.periodDuration = i.attributes.duration);
            var a = Te(i.node, "AdaptationSet"),
              o = Ie(i.node);
            return Ft(a.map(Ne(r, n, o)));
          };
        },
        De = function De(t, e) {
          void 0 === e && (e = {});
          var i = e,
            s = i.manifestUri,
            n = void 0 === s ? "" : s,
            r = i.NOW,
            a = void 0 === r ? Date.now() : r,
            o = i.clientOffset,
            d = void 0 === o ? 0 : o,
            c = Te(t, "Period");
          if (!c.length) throw new Error("INVALID_NUMBER_OF_PERIOD");
          var u = Te(t, "Location"),
            l = Ae(t),
            h = _e([n], Te(t, "BaseURL"));
          l.type = l.type || "static", l.sourceDuration = l.mediaPresentationDuration || 0, l.NOW = a, l.clientOffset = d, u.length && (l.locations = u.map(Se));
          var p = [];
          return c.forEach(function (t, e) {
            var i = Ae(t),
              s = p[e - 1];
            i.start = function (t) {
              var e = t.attributes,
                i = t.priorPeriodAttributes,
                s = t.mpdType;
              return "number" == typeof e.start ? e.start : i && "number" == typeof i.start && "number" == typeof i.duration ? i.start + i.duration : i || "static" !== s ? null : 0;
            }({
              attributes: i,
              priorPeriodAttributes: s ? s.attributes : null,
              mpdType: l.type
            }), p.push({
              node: t,
              attributes: i
            });
          }), {
            locations: l.locations,
            representationInfo: Ft(p.map(Pe(l, h)))
          };
        },
        Re = function Re(t) {
          if ("" === t) throw new Error("DASH_EMPTY_MANIFEST");
          var e,
            i,
            s = new kt.DOMParser();
          try {
            i = (e = s.parseFromString(t, "application/xml")) && "MPD" === e.documentElement.tagName ? e.documentElement : null;
          } catch (t) {}
          if (!i || i && i.getElementsByTagName("parsererror").length > 0) throw new Error("DASH_INVALID_XML");
          return i;
        },
        Le = "0.21.1",
        Ce = function Ce(t, e) {
          void 0 === e && (e = {});
          var i = De(Re(t), e),
            s = ye(i.representationInfo);
          return ue({
            dashPlaylists: s,
            locations: i.locations,
            sidxMapping: e.sidxMapping,
            previousManifest: e.previousManifest
          });
        },
        Oe = function Oe(t) {
          return function (t) {
            var e = Te(t, "UTCTiming")[0];
            if (!e) return null;
            var i = Ae(e);
            switch (i.schemeIdUri) {
              case "urn:mpeg:dash:utc:http-head:2014":
              case "urn:mpeg:dash:utc:http-head:2012":
                i.method = "HEAD";
                break;
              case "urn:mpeg:dash:utc:http-xsdate:2014":
              case "urn:mpeg:dash:utc:http-iso:2014":
              case "urn:mpeg:dash:utc:http-xsdate:2012":
              case "urn:mpeg:dash:utc:http-iso:2012":
                i.method = "GET";
                break;
              case "urn:mpeg:dash:utc:direct:2014":
              case "urn:mpeg:dash:utc:direct:2012":
                i.method = "DIRECT", i.value = Date.parse(i.value);
                break;
              default:
                throw new Error("UNSUPPORTED_UTC_TIMING_SCHEME");
            }
            return i;
          }(Re(t));
        };
      var Be = Me;
      function xe() {
        var t = ["parse", "60pRtILa", "81390lwnecl", "8pQHpCn", "debug", "3148gWQjBl", "addRendition", "527605siGWth", "segments", "replace", "1904319CpAAlU", "uri", "1756469IsyblT", "targetDuration", "attributes", "624UIQvns", "15fLsNKl", "4517680rDuGcO", "resolvedUri", "Error parsing MPD manifest: ", "../", "12BSGDwP", "bandwidth", "addSegment", "47733LNjayc"];
        return (xe = function xe() {
          return t;
        })();
      }
      function Me(t, e) {
        var i = xe();
        return (Me = function Me(t, e) {
          return i[t -= 334];
        })(t, e);
      }
      !function (t, e) {
        var i = Me,
          s = t();
        for (;;) try {
          if (433351 == parseInt(i(339)) / 1 + parseInt(i(337)) / 2 * (parseInt(i(348)) / 3) + parseInt(i(353)) / 4 * (parseInt(i(334)) / 5) + parseInt(i(347)) / 6 * (-parseInt(i(356)) / 7) + -parseInt(i(335)) / 8 * (-parseInt(i(342)) / 9) + -parseInt(i(349)) / 10 + -parseInt(i(344)) / 11 * (-parseInt(i(358)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(xe);
      var ke = /*#__PURE__*/function (_Be) {
        function ke() {
          _classCallCheck(this, ke);
        }
        _createClass(ke, null, [{
          key: _Be,
          value: function value(e, i, s, a) {
            var o = Be,
              d = i;
            try {
              var _i129 = t[o(357)](d, {
                url: e
              }).playlists;
              var _iterator36 = _createForOfIteratorHelper(_i129),
                _step36;
              try {
                for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                  var c = _step36.value;
                  var _t70 = new It();
                  _t70[o(354)] = c[o(346)].BANDWIDTH, _t70.uri = c[o(350)], _t70[o(345)] = c[o(345)];
                  var _e63 = _t70[o(343)];
                  var _iterator37 = _createForOfIteratorHelper(((!_t70[o(343)] || "" == _t70[o(343)]) && (_e63 = c[o(346)]), s[o(338)](_e63, _t70), c[o(340)])),
                    _step37;
                  try {
                    for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                      var u = _step37.value;
                      var _t71 = u[o(343)];
                      for (; _t71.startsWith(o(352));) _t71 = _t71[o(341)]("../", "");
                      s[o(355)](_e63, u.resolvedUri, _t71);
                    }
                  } catch (err) {
                    _iterator37.e(err);
                  } finally {
                    _iterator37.f();
                  }
                }
              } catch (err) {
                _iterator36.e(err);
              } finally {
                _iterator36.f();
              }
            } catch (t) {
              n.default[o(336)](r.BalancerTag, o(351), t);
            }
          }
        }]);
        return ke;
      }(Be(357));
      var Ue = qe;
      function Ve() {
        var t = ["Done ", "parse", "pathName", "finalUrl", "hash", "Problem slicing the array", "Util", "5692168ObdChb", "9EoUfBc", "7840441NjpQnP", "pathname", "host", "now", "announcedP2P", "forceHttp", "duration", "arrayBuffer", "cdnProvider", "retries", ".m3u8", "Update P2P ID ", "lastEstimatedTime", "changeCDN", " renditions -> ", "getPerfLoadTime", "onSuccess", "cdnName", "startTime", "byteLength", "search", "BYTLELENGHT ", "trunc", "size", "downloadTimeMs", "createdAt", "820kuPcMq", "getNewUrl", "params", "readyForP2P", "triedCdns", "304148erhqFZ", "includes", " Total time -> ", "random", "headers", "1281004COarhz", "total", "p2pId", "resource", "getRenditions", "P2PManager", " downloaded by p2p -> ", "endsWith", "_resource", "ifByteArrayToString", "failed", "9312ZYxoCS", "Parsed DASH manifest -> ", "segmentDuration", "origRes", "4106865vgyZau", "slice", "verbose", "debug", ".mpd", "initialEstimatedTime", "progressDownloadedBytes", "isMedia", "emit", "getEntriesByType", "download", "length", "round", "setContent", "instantBandwidth", "failedOriginalCount", "uncompressedBytes", "triedP2P", "5053790gLBOFJ", "2GqQVoS", "Range", "endTime", "sliceByFirstSpecial", "targetDuration", "isManifest", "High risk of buffer. ", "realBodySize", "route", "push", "bandwidth", "onProgress", "progressDownloadedBytesLastUpdate", "timeout", "data", "isMasterPlaylist", "compressedBytes", "url", "floor", "Parsed HLS manifest -> ", "loaded"];
        return (Ve = function Ve() {
          return t;
        })();
      }
      function qe(t, e) {
        var i = Ve();
        return (qe = function qe(t, e) {
          return i[t -= 456];
        })(t, e);
      }
      !function (t, e) {
        var i = qe,
          s = t();
        for (;;) try {
          if (836177 == parseInt(i(522)) / 1 + -parseInt(i(461)) / 2 * (parseInt(i(542)) / 3) + parseInt(i(527)) / 4 + -parseInt(i(517)) / 5 * (-parseInt(i(538)) / 6) + parseInt(i(491)) / 7 + -parseInt(i(489)) / 8 * (-parseInt(i(490)) / 9) + -parseInt(i(460)) / 10) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(Ve);
      var Fe = /*#__PURE__*/function (_ref5, _Ue, _Ue2, _Ue3, _Ue4, _Ue5) {
        _inherits(Fe, _ref5);
        var _super4 = _createSuper(Fe);
        function Fe(t, e, i) {
          var _this44;
          var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;
          var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
          var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
          _classCallCheck(this, Fe);
          var o = qe;
          var d;
          _this44 = _super4.call(this), _this44[o(484)] = "", _this44[o(475)] = new ArrayBuffer(1), _this44[o(514)] = 0, _this44[o(471)] = 0, _this44[o(509)] = 0, _this44[o(463)] = 0, _this44[o(515)] = 0, _this44.failed = !1, _this44[o(474)] = !1, _this44[o(548)] = 0, _this44[o(473)] = 0, _this44[o(456)] = 0, _this44.duration = 0, _this44[o(547)] = 0, _this44[o(503)] = 0, _this44[o(466)] = !1, _this44[o(476)] = !1, _this44[o(549)] = !1, _this44[o(552)] = !0, _this44[o(468)] = 0, _this44[o(520)] = !0, _this44[o(495)] = !1, _this44.activeP2PSendProcesses = 0, _this44.retryBecauseNewHeaders = 0, _this44[o(496)] = !1, _this44.peer = void 0, _this44[o(516)] = Date[o(494)](), _this44[o(457)] = 0, _this44[o(540)] = void 0;
          var c = new URL(e);
          _this44[o(478)] = e, _this44.finalUrl = e, _this44[o(541)] = e, _this44[o(493)] = c.host, _this44[o(469)] = c[o(492)], _this44[o(519)] = c[o(511)], _this44.headers = s, _this44[o(500)] = n, _this44.useP2P = r, _this44.triedP2P = !1, _this44[o(508)] = "", _this44.cdnProvider = "", _this44[o(498)] = a, _this44[o(521)] = [], _this44[o(535)] = i, _this44[o(484)] = t, _this44.id = Math[o(479)](100 * Math[o(525)]()) + "-" + Date.now();
          var u = (null === (d = _this44[o(526)]) || void 0 === d ? void 0 : d[o(462)]) || "";
          _this44[o(529)] = window[o(532)] ? window[o(532)][o(488)][o(486)](_this44.pathName + u) : "" + _this44[o(484)] + u;
          return _this44;
        }
        _createClass(Fe, [{
          key: "updateP2PId",
          value: function updateP2PId() {
            var t = qe;
            var e;
            if (!window[t(532)]) return;
            var i = (null === (e = this.headers) || void 0 === e ? void 0 : e[t(462)]) || "";
            n.default[t(545)](r.BalancerTag, t(502) + this.pathName + i), this[t(529)] = window[t(532)].Util[t(486)](this[t(484)] + i);
          }
        }, {
          key: _Ue,
          value: function value() {
            var t = Ue;
            var e = !1;
            this[t(466)] ? this[t(466)] && this[t(537)] && (e = !0) : e = !0;
            var i = e ? this[t(485)] : this[t(478)];
            return this.params && (i = i[t(523)]("?") ? i + "&" + this[t(519)] : i + "?" + this[t(519)]), i;
          }
        }, {
          key: "addParametersToUrl",
          value: function addParametersToUrl(t) {
            var e = Ue;
            var i = t;
            return this.params && i && (i = i.includes("?") ? i + "&" + this[e(519)] : i + "?" + this[e(519)]), i;
          }
        }, {
          key: _Ue2,
          value: function value(t, e, i) {
            var s = Ue;
            if ("ORIGINAL" != i) {
              var _i130 = new URL(t);
              this.host = _i130[s(493)], this.route = _i130[s(492)], this[s(521)][s(470)](e);
            }
            this.cdnName = e, this[s(499)] = i;
          }
        }, {
          key: _Ue3,
          value: function value(t) {
            var e = Ue;
            this[e(475)] = t, this[e(514)] = t[e(510)], this[e(550)](a.yL.Success, {
              segment: this,
              data: t
            });
          }
        }, {
          key: "noContentObtained",
          value: function noContentObtained() {
            this[Ue(550)](a.yL.Fail, {
              segment: this
            });
          }
        }, {
          key: "getPerfLoadTime",
          value: function getPerfLoadTime(t) {
            var e = Ue;
            var i;
            if ("undefined" != typeof performance && "function" == typeof performance.getEntriesByType) {
              var _s39 = performance[e(551)](e(530));
              if (_s39 && _s39[e(553)] > 0) {
                var _iterator38 = _createForOfIteratorHelper(_s39),
                  _step38;
                try {
                  for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                    var _n26 = _step38.value;
                    var _s40 = _n26.toJSON();
                    if (null === (i = null == _s40 ? void 0 : _s40.name) || void 0 === i ? void 0 : i[e(523)](t)) return Math[e(554)](null == _s40 ? void 0 : _s40.duration);
                  }
                } catch (err) {
                  _iterator38.e(err);
                } finally {
                  _iterator38.f();
                }
              }
            }
            return -1;
          }
        }, {
          key: _Ue4,
          value: function value(t, e) {
            var i = Ue;
            e[i(528)] > 0 && (this.realBodySize = e.total), 0 == this[i(473)] && (this[i(473)] = this.startTime);
            var s = Date[i(494)](),
              a = s - this[i(473)];
            if (this[i(463)] = Date[i(494)](), a < 150) return;
            0 != a && (this.instantBandwidth = (e.loaded - this[i(548)]) / ((s - this.progressDownloadedBytesLastUpdate) / 1e3) * 8, this[i(473)] = s, e.loaded && (this.progressDownloadedBytes = e.loaded));
            var o = (s - this[i(509)]) / (e[i(481)] / e[i(528)]);
            this[i(547)] = 0 == this[i(547)] ? o : this.initialEstimatedTime, this[i(503)] = o, this[i(497)] > 0 && 0 != o && 1e3 * this[i(497)] < o && n.default[i(545)](r.BalancerTag, i(467) + this.origRes), n.default[i(544)](r.BalancerTag, i(482) + this[i(541)] + i(524) + (Date[i(494)]() - this[i(509)]));
          }
        }, {
          key: _Ue5,
          value: function value(t, e) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            var s = Ue;
            if (this[s(463)] = Date[s(494)](), null == t || 0 == t.length) return !1;
            this[s(515)] = this[s(463)] - this[s(509)], this[s(506)](this.route);
            var a = i ? c[s(464)](this[s(478)]) : this[s(478)],
              o = new URL(a)[s(492)];
            if (o[s(534)](s(501))) {
              t = c.ifByteArrayToString(t);
              var _e64 = Rt.parse(this[s(478)], t, this[s(535)]);
              this[s(476)] = _e64[s(476)], n.default[s(545)](r.BalancerTag, s(480) + this[s(478)] + s(505) + this[s(535)].getRenditions().size), null != _e64[s(465)] && (this[s(540)] = 1e3 * _e64.targetDuration);
            }
            if (o.endsWith(s(546))) {
              t = c[s(536)](t);
              var _e65 = {
                duration: void 0
              };
              ke[s(483)](this.url, t, this[s(535)], _e65), this[s(476)] = !0, n.default.debug(r.BalancerTag, s(539) + this.url + " renditions -> " + this[s(535)][s(531)]()[s(514)]), null != _e65[s(497)] && (this.segmentDuration = 1e3 * _e65.duration);
            }
            if (n.default[s(544)](r.BalancerTag, s(512) + t[s(510)] + s(533) + this[s(459)]), 0 != t[s(510)]) try {
              this[s(475)] = t[s(543)](0, t[s(510)]), this[s(514)] = this[s(515)] > 5 ? this.data[s(510)] : 0, this.cachedSize = this[s(515)] > 5 ? 0 : this[s(475)][s(510)], this[s(471)] = Math[s(513)](this[s(515)] > 5 ? this.data.byteLength / (this[s(515)] / 1e3) : 0), this[s(475)][s(510)] > 0 && (this[s(468)] = this[s(475)][s(510)]), this[s(456)] = 0, this[s(548)] = this.size;
              var _i131 = parseInt(e, 10);
              !isNaN(_i131) && _i131 > 0 && (this[s(477)] = _i131, this[s(458)] = this[s(475)][s(510)] || t[s(510)] || this.realBodySize);
            } catch (t) {
              n.default[s(545)](r.BalancerTag, s(487));
            } else this.data.byteLength != this[s(468)] && (this[s(475)] = new ArrayBuffer(1));
            return this.progressDownloadedBytesLastUpdate = this[s(463)], !0;
          }
        }]);
        return Fe;
      }(_, Ue(518), Ue(504), Ue(555), Ue(472), Ue(507));
      var Xe = He;
      function He(t, e) {
        var i = Ge();
        return (He = function He(t, e) {
          return i[t -= 427];
        })(t, e);
      }
      function Ge() {
        var t = ["10Lbohau", "uri", "pos", "getSize", "bandwidth", "186380PtDYNS", "forEach", "addSegment", "bandwidths", "clean", "8xEZBva", "409608emZFMf", "delete", "lastCleanPos", "889zlgKMp", "sort", "getBandwidthsPos", "getSegments", "cleaning", "isMaxRendition", "renditions", "push", "5KhcPLu", "endsWith", "length", "isAudio", "updateAvailableBandwidths", "fileName", "set", "48123ttgJwT", "37044ScHJNu", "6654FvEpop", "values", "2004996thdzWz", "55036HUfpGj", "bandwidthPosition", "getRendition", "22uSomkf"];
        return (Ge = function Ge() {
          return t;
        })();
      }
      !function (t, e) {
        var i = He,
          s = t();
        for (;;) try {
          if (102062 == parseInt(i(435)) / 1 + -parseInt(i(440)) / 2 * (-parseInt(i(460)) / 3) + parseInt(i(464)) / 4 * (parseInt(i(452)) / 5) + -parseInt(i(461)) / 6 * (-parseInt(i(444)) / 7) + parseInt(i(441)) / 8 + parseInt(i(459)) / 9 * (-parseInt(i(430)) / 10) + parseInt(i(429)) / 11 * (-parseInt(i(463)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(Ge);
      var je = /*#__PURE__*/function (_Xe, _Xe2, _Xe3, _Xe4, _Xe5, _Xe6) {
        function je() {
          _classCallCheck(this, je);
          var t = He;
          this.masterUri = "", this[t(450)] = new Map(), this.route = "", this[t(457)] = "", this.bandwidths = [], this.pos = 0, this[t(443)] = 0, this[t(448)] = !1;
        }
        _createClass(je, [{
          key: _Xe,
          value: function value() {
            var t = Xe;
            this[t(448)] || this.pos - this.lastCleanPos > 1e5 && (this.cleaning = !0, this[t(442)](this[t(443)], this[t(443)] + 5e3), this.lastCleanPos = this[t(443)] + 5e3, this[t(448)] = !1);
          }
        }, {
          key: "addSegment",
          value: function addSegment(t, e, i) {
            var s = Xe;
            var n;
            this.pos++, null === (n = this.renditions.get(t)) || void 0 === n || n[s(437)](e, i, this.pos);
          }
        }, {
          key: _Xe2,
          value: function value() {
            var t = Xe;
            var e = 0;
            var _iterator39 = _createForOfIteratorHelper(this[t(450)][t(462)]()),
              _step39;
            try {
              for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                var _i132 = _step39.value;
                e += _i132.getSegmentsSize();
              }
            } catch (err) {
              _iterator39.e(err);
            } finally {
              _iterator39.f();
            }
            return e;
          }
        }, {
          key: _Xe3,
          value: function value(t, e) {
            var i = Xe;
            var _iterator40 = _createForOfIteratorHelper(this.renditions[i(462)]()),
              _step40;
            try {
              for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                var _s41 = _step40.value;
                var _iterator41 = _createForOfIteratorHelper(_s41.getSegments()),
                  _step41;
                try {
                  for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                    var _step41$value = _slicedToArray(_step41.value, 2),
                      _n27 = _step41$value[0],
                      _r9 = _step41$value[1];
                    _r9[i(432)] >= t && _r9.pos <= e && _s41[i(447)]()[i(442)](_n27);
                  }
                } catch (err) {
                  _iterator41.e(err);
                } finally {
                  _iterator41.f();
                }
              }
            } catch (err) {
              _iterator40.e(err);
            } finally {
              _iterator40.f();
            }
          }
        }, {
          key: "addRendition",
          value: function addRendition(t, e) {
            var i = Xe;
            this.renditions[i(458)](t, e), this[i(456)]();
          }
        }, {
          key: "getRenditions",
          value: function getRenditions() {
            return this[Xe(450)];
          }
        }, {
          key: "getVideoRenditions",
          value: function getVideoRenditions() {
            var t = Xe;
            var e = new Map();
            return this[t(450)].forEach(function (i, s) {
              var n = t;
              i[n(455)] || e[n(458)](s, i);
            }), e;
          }
        }, {
          key: _Xe4,
          value: function value(t) {
            var e = Xe;
            var i;
            return this[e(450)][e(436)](function (s) {
              var n = e;
              s[n(447)]().forEach(function (e) {
                var r = n;
                t[r(453)](e[r(431)]) && (i = s);
              });
            }), i;
          }
        }, {
          key: _Xe5,
          value: function value() {
            var _this45 = this;
            var t = Xe;
            var e = new Array();
            this[t(450)].forEach(function (i) {
              var s = t;
              i[s(455)] || e[s(451)](Number(i[s(434)]));
            }), e[t(445)](function (t, e) {
              return t - e;
            }), this[t(438)] = e, this[t(450)][t(436)](function (e) {
              var i = t;
              !e[i(455)] && (e[i(427)] = _this45[i(446)](e[i(434)]), e[i(427)] + 1 == _this45[i(438)][i(454)] && (e[i(449)] = !0));
            });
          }
        }, {
          key: _Xe6,
          value: function value(t) {
            var e = Xe;
            var i = 0,
              s = -1;
            return this[e(438)][e(436)](function (e) {
              t == e && (s = i), i++;
            }), s;
          }
        }]);
        return je;
      }(Xe(439), Xe(433), Xe(442), Xe(428), Xe(456), Xe(446));
      var We = Ye;
      !function (t, e) {
        var i = Ye,
          s = t();
        for (;;) try {
          if (632016 == parseInt(i(478)) / 1 * (parseInt(i(419)) / 2) + parseInt(i(449)) / 3 + parseInt(i(415)) / 4 * (-parseInt(i(509)) / 5) + -parseInt(i(498)) / 6 * (-parseInt(i(477)) / 7) + -parseInt(i(456)) / 8 * (-parseInt(i(494)) / 9) + parseInt(i(459)) / 10 * (parseInt(i(416)) / 11) + -parseInt(i(413)) / 12) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(ze);
      function Ye(t, e) {
        var i = ze();
        return (Ye = function Ye(t, e) {
          return i[t -= 412];
        })(t, e);
      }
      function ze() {
        var t = ["setReportTimeout", "5276045VKcwXB", "options", "debug", "status", "4901268nrPCbv", "https://", "4LyHWlv", "1142933wKjYeY", "verbose", "getReportTimeout", "4936RTJTGY", " for /decision requests", "deleteOldestFromManifestMap", "setAdsAnalyticsEnabled", "throw", "diagnosticTool", "performHashmapCleanup", "Creating setTimeout for decision request with resource ", "open", "adsAnalyticsEnabled", "forEach", "CDNLoader", "qualityPriority", "balancerEnabled", "onload", "createUpdateTimer", "BUCKET", "clearReportTimeout", "GET", "timeout", "devHost", "Performing decision request with URL ", "isValidUrl", "Storing ", "pathname", "DECISION_FINISHED", "loadBalancerData", "PROFILE_NAME", "origin", "set", "3274773ieCxfW", "shouldPerformDecision", "_manifestMap", "_loader", "formatParameters", "getIsEnabled", "apply", "3526888aUkfwW", "LAST_USED_CDN", "getInstance", "20CYuPSH", " in manifest hashmap", "code", "setSettings", "__awaiter", "videoAnalyticsEnabled", "has", "activeSwitching", "size", "messages", "Origin", "setActiveSwitchingOnLegacy", "get", "cdnPriority", "Products", "onSucessfullApiResponse", "true", "done", "377209arDAAA", "13NJozwi", "decisionReloadIntervalPerManifestMilliseconds", "delete", "getRouteAndFilename", "unregisterCommonVariable", "defaultReportTimeout", "now", "registerCommonVariable", " from manifest hashmap since older than ", "BALANCER", "isUsingLegacy", "decision", "readyState", "slice", "startMonitoring", "lastIndexOf", "9hyTXAs", "setBalancerEnabled", "parse", "Error parsing Balancer API response: ", "36PfXjZi", "P2PLoader", "Using ", "Removing ", "Empty response received from Balancer API", "response", "BalancerVariables", "wasSelectorCommunicationSuccessful", "onFailedApiResponse", "includes"];
        return (ze = function ze() {
          return t;
        })();
      }
      var Ke = /*#__PURE__*/function (_We, _We2) {
        function Ke(t) {
          _classCallCheck(this, Ke);
          var e = We;
          this[e(451)] = new Map(), this[e(452)] = t;
        }
        _createClass(Ke, [{
          key: _We,
          value: function value(t, i, s, o, d, u, l, h, p) {
            return f = this, g = void 0, v = /*#__PURE__*/_regeneratorRuntime.mark(function v() {
              var f, g, m, v, y, T, S, E;
              return _regeneratorRuntime.wrap(function v$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    f = Ye;
                    if (this._loader[f(454)]()) {
                      _context15.next = 3;
                      break;
                    }
                    return _context15.abrupt("return", void e.default[f(458)]().registerCommonVariable(ct.default[f(473)][f(487)], ct.default[f(504)][f(444)], !0));
                  case 3:
                    if (this[f(450)](i)) {
                      _context15.next = 5;
                      break;
                    }
                    return _context15.abrupt("return", (n.default[f(511)](r.BalancerTag, "Not performing decision since time between requests has not passed yet."), void this.createUpdateTimer(t, i, s, o, null != d && d, null != u && u, l, h, p)));
                  case 5:
                    g = Date[f(484)](), m = c[f(441)](i) ? this[f(481)](i) : {
                      route: "",
                      fileName: ""
                    };
                    n.default.verbose(r.BalancerTag, "Using development environment -> " + u);
                    v = u ? a.df[f(439)] : a.df.host;
                    v = p || v, n.default.debug(r.BalancerTag, f(500) + v + f(420));
                    y = new XMLHttpRequest();
                    T = v + "/" + t + "/" + (l ? l + "/" : "") + f(489);
                    T = T.replace("//", "/"), T = f(414) + T;
                    S = {
                      resource: "" + m.route + m.fileName,
                      live: "" + s,
                      extended: f(475),
                      npawPluginInfo: f(475),
                      originCode: null != h ? h : "",
                      v: e.default.getPluginVersion().split("-js")[0]
                    }, E = this;
                    _context15.next = 15;
                    return new Promise(function (t, s) {
                      var o = f;
                      y[o(433)] = function () {
                        var s = o;
                        var d, c, u, p, f, v, T, S, b, A, w;
                        if (4 === y[s(490)]) {
                          if (y.status > 0 && (10 === E[s(451)][s(467)] && !E[s(451)][s(465)](i) && E[s(421)](), E[s(425)](), E._manifestMap[s(448)](i, Date[s(484)]()), n.default[s(417)](r.BalancerTag, s(442) + i + s(460))), y.status >= 200 && y[s(412)] <= 300) {
                            var _t72 = Date[s(484)]() - g;
                            E[s(452)][s(430)][s(474)](_t72);
                            try {
                              if (y.response) {
                                E[s(510)] = JSON[s(496)](y[s(503)]), e.default[s(458)]()[s(485)](ct.default[s(473)][s(487)], ct.default[s(504)][s(446)], l), e.default[s(458)]()[s(485)](ct.default.Products[s(487)], ct.default[s(504)].BUCKET, h);
                                var _t73 = [a.m[s(472)], a.m[s(431)]][s(507)](E[s(510)][s(466)]);
                                e.default.getInstance()[s(488)]() ? e.default[s(458)]()[s(470)](_t73) : e.default[s(458)]()[s(485)](ct.default[s(473)][s(487)], ct.default[s(504)].AS_ENABLED, _t73), M.default.getInstance().wasSelectorCommunicationSuccessful(!0), M.default[s(458)]()[s(495)](null === (c = null === (d = E[s(510)]) || void 0 === d ? void 0 : d.diagnosticTool) || void 0 === c ? void 0 : c[s(432)]), M.default[s(458)]().setVideoAnalyticsEnabled(null === (p = null === (u = E.options) || void 0 === u ? void 0 : u[s(424)]) || void 0 === p ? void 0 : p[s(464)]), M.default[s(458)]()[s(422)](null === (v = null === (f = E.options) || void 0 === f ? void 0 : f.diagnosticTool) || void 0 === v ? void 0 : v[s(428)]), M.default[s(458)]()[s(508)](null === (S = null === (T = E[s(510)]) || void 0 === T ? void 0 : T.diagnosticTool) || void 0 === S ? void 0 : S[s(438)]), E[s(452)].storage[s(462)](E[s(510)]), E._loader[s(499)] && (E[s(452)].P2PLoader.setSettings(E.options), E[s(452)][s(499)][s(492)]()), E[s(452)][s(430)][s(462)](E[s(510)], m.route), E[s(452)][s(430)][s(492)]();
                              } else n.default.debug(r.BalancerTag, s(502)), E[s(452)].P2PLoader.disable(), E[s(452)].CDNLoader.gotEmptyResponse(), M.default[s(458)]()[s(505)](!1, "Empty response received"), e.default[s(458)]()[s(485)](ct.default[s(473)][s(487)], ct.default[s(504)][s(457)], s(469));
                            } catch (t) {
                              n.default[s(511)](r.BalancerTag, s(497), t);
                            }
                          } else {
                            var _t74 = JSON.parse(y[s(503)]);
                            M.default.getInstance()[s(505)](!1, _t74[s(468)][0][s(461)]), e.default[s(458)]()[s(485)](ct.default.Products[s(487)], ct.default[s(504)][s(457)], s(469)), n.default[s(511)](r.BalancerTag, "API call failed with status code " + y[s(412)]), E[s(452)][s(430)][s(506)]();
                          }
                          e.default[s(458)]()[s(485)](ct.default.Products[s(487)], ct.default[s(504)][s(444)], !0);
                          var _t75 = M.default.getInstance()[s(418)]();
                          _t75 != M.default[s(483)] && (null !== (w = null === (A = null === (b = E[s(510)]) || void 0 === b ? void 0 : b[s(424)]) || void 0 === A ? void 0 : A[s(438)]) && void 0 !== w ? w : _t75) != _t75 && (M.default[s(458)]()[s(436)](), M.default.getInstance().start());
                        }
                        t();
                      }, y.onerror = function () {
                        var e = o;
                        E[e(452)][e(430)][e(506)](), n.default[e(511)](r.BalancerTag, "API call failed due to a network error."), t();
                      }, y[o(427)](o(437), T + c[o(453)](S)), e.default.getInstance()[o(485)](ct.default[o(473)][o(487)], ct.default[o(504)][o(444)], !1), e.default[o(458)]()[o(482)](ct.default[o(473)].BALANCER, ct.default[o(504)][o(446)]), e.default.getInstance()[o(482)](ct.default[o(473)][o(487)], ct.default.BalancerVariables[o(435)]), e.default[o(458)]()[o(482)](ct.default[o(473)].BALANCER, ct.default[o(504)].AS_ENABLED), n.default[o(417)](r.BalancerTag, o(440) + T + c[o(453)](S) + " + (host: " + v + ")"), y.send();
                    });
                  case 15:
                    this[f(434)](t, i, s, o, null != d && d, null != u && u, l, h, p);
                  case 16:
                  case "end":
                    return _context15.stop();
                }
              }, v, this);
            }), new ((m = void 0) || (m = Promise))(function (t, e) {
              function i(t) {
                try {
                  n(v.next(t));
                } catch (t) {
                  e(t);
                }
              }
              function s(t) {
                var i = Ye;
                try {
                  n(v[i(423)](t));
                } catch (t) {
                  e(t);
                }
              }
              function n(e) {
                var n;
                e[Ye(476)] ? t(e.value) : (n = e.value, n instanceof m ? n : new m(function (t) {
                  t(n);
                })).then(i, s);
              }
              n((v = v[Ye(455)](f, g || [])).next());
            });
            var f, g, m, v;
          }
        }, {
          key: "createUpdateTimer",
          value: function createUpdateTimer(t, e, i, s, a, o, d, c, u) {
            var _this46 = this;
            var l = We;
            s > 0 && (n.default[l(417)](r.BalancerTag, l(426) + e), setTimeout(function () {
              _this46[l(445)](t, e, i, s, a, o, d, c, u);
            }, 1e3 * s));
          }
        }, {
          key: "getRouteAndFilename",
          value: function getRouteAndFilename(t) {
            var e = We,
              i = new URL(t),
              s = i[e(447)] + i[e(443)],
              n = s[e(493)]("/") + 1;
            return {
              route: s[e(491)](0, n),
              fileName: s.slice(n)
            };
          }
        }, {
          key: "shouldPerformDecision",
          value: function shouldPerformDecision(t) {
            var e = We;
            var i;
            if (!this[e(451)].has(t)) return !0;
            {
              var _s42 = null !== (i = this[e(451)][e(471)](t)) && void 0 !== i ? i : Date[e(484)]();
              if (Date.now() - _s42 > a.df[e(479)]) return !0;
            }
            return !1;
          }
        }, {
          key: "performHashmapCleanup",
          value: function performHashmapCleanup() {
            var _this47 = this;
            var t = We;
            this[t(451)][t(429)](function (e, i) {
              var s = t;
              Date[s(484)]() - e > a.df[s(479)] && (n.default.verbose(r.BalancerTag, s(501) + i + s(486) + a.df[s(479)] + "ms"), _this47[s(451)].delete(i));
            });
          }
        }, {
          key: _We2,
          value: function value() {
            var t = We;
            var e,
              i = 1 / 0;
            this[t(451)][t(429)](function (t, s) {
              t < i && (i = t, e = s);
            }), void 0 !== e && this[t(451)][t(480)](e);
          }
        }]);
        return Ke;
      }(We(445), We(421));
      var Qe = Je;
      function Je(t, e) {
        var i = Ze();
        return (Je = function Je(t, e) {
          return i[t -= 494];
        })(t, e);
      }
      !function (t, e) {
        var i = Je,
          s = t();
        for (;;) try {
          if (599914 == parseInt(i(504)) / 1 * (parseInt(i(519)) / 2) + parseInt(i(515)) / 3 * (-parseInt(i(497)) / 4) + parseInt(i(509)) / 5 * (parseInt(i(518)) / 6) + parseInt(i(514)) / 7 + parseInt(i(500)) / 8 * (-parseInt(i(517)) / 9) + -parseInt(i(513)) / 10 * (parseInt(i(506)) / 11) + -parseInt(i(521)) / 12) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(Ze);
      var $e = /*#__PURE__*/function (_Qe) {
        function $e() {
          _classCallCheck(this, $e);
        }
        _createClass($e, [{
          key: _Qe,
          value: function value(t, e) {
            return i = this, s = void 0, r = /*#__PURE__*/_regeneratorRuntime.mark(function r() {
              var i, s, _s43, _n28;
              return _regeneratorRuntime.wrap(function r$(_context16) {
                while (1) switch (_context16.prev = _context16.next) {
                  case 0:
                    i = Je;
                    s = e[i(501)] / (e[i(494)] / 1e3) * 8;
                    if (!(0 != t && s > t)) {
                      _context16.next = 13;
                      break;
                    }
                    _s43 = 1e3 * e.size * 8 / t, _n28 = (Date[i(496)](), e[i(510)], _s43 - e[i(494)]);
                    _context16.t0 = _n28 > 0;
                    if (!_context16.t0) {
                      _context16.next = 8;
                      break;
                    }
                    _context16.next = 8;
                    return c[i(520)](_n28);
                  case 8:
                    e.endTime = Date[i(496)]();
                    e[i(494)] = e[i(512)] - e[i(510)];
                    e[i(498)] = e[i(501)] / (e.downloadTimeMs / 1e3);
                    e[i(516)] = 0;
                    e[i(495)] = e[i(512)];
                  case 13:
                  case "end":
                    return _context16.stop();
                }
              }, r);
            }), new ((n = void 0) || (n = Promise))(function (t, e) {
              var a = Je;
              function o(t) {
                var i = Je;
                try {
                  c(r[i(502)](t));
                } catch (t) {
                  e(t);
                }
              }
              function d(t) {
                var i = Je;
                try {
                  c(r[i(511)](t));
                } catch (t) {
                  e(t);
                }
              }
              function c(e) {
                var i = Je;
                var s;
                e[i(507)] ? t(e[i(508)]) : (s = e[i(508)], s instanceof n ? s : new n(function (t) {
                  t(s);
                }))[i(503)](o, d);
              }
              c((r = r.apply(i, s || []))[a(502)]());
            });
            var i, s, n, r;
          }
        }]);
        return $e;
      }(Qe(505));
      function Ze() {
        var t = ["9cGvTec", "906yomSxq", "2YVtZvX", "delay", "8712036LohnQG", "downloadTimeMs", "progressDownloadedBytesLastUpdate", "now", "4qqxOJe", "bandwidth", "__awaiter", "609904lkwQsq", "size", "next", "then", "401665ndDxnR", "limit", "41173fMMIlw", "done", "value", "27265vtYUAZ", "startTime", "throw", "endTime", "2060feutPp", "7178493AXzYDX", "232062jhtCYE", "instantBandwidth"];
        return (Ze = function Ze() {
          return t;
        })();
      }
      function ti() {
        var t = ["downloaded_bytes", "internal_unbanned_time", "min_response_time", "max_network_latency", "switches_due_quality", "network_latency", "min_network_latency", "http_1XX", "6985uAdRhF", "switches_due_connectivity", "video_downloaded_chunks", "avg_ping_time", "time", "9eYZadq", "video_downloaded_bytes", "15144FPjnPE", "max_ping_time", "banned_time", "errors", "network_latency_samples", "35sVUTjb", "throughput", "369175uwZRyR", "567324HCECbO", "downloaded_chunks", "compressed_video_bytes", "414696JjJCqz", "video_time", "internal_banned_time", "min_response_bytes", "switches", "internal_banned", "unbanned_time", "response_time_samples", "max_response_bytes", "http_3XX", "min_bandwidth", "unbanned", "2379440FezBbK", "resource", "3LOarvw", "2725262drgmTU", "uncompressed_video_bytes", "internal_switches_due_errors", "internal_is_banned", "http_4XX", "banned", "response_bytes", "12vrXPgl", "is_banned", "426816rNiziq", "min_ping_time"];
        return (ti = function ti() {
          return t;
        })();
      }
      function ei(t, e) {
        var i = ti();
        return (ei = function ei(t, e) {
          return i[t -= 224];
        })(t, e);
      }
      !function (t, e) {
        for (var i = ei, s = t();;) try {
          if (849611 == parseInt(i(270)) / 1 + parseInt(i(261)) / 2 * (-parseInt(i(260)) / 3) + -parseInt(i(268)) / 4 * (-parseInt(i(242)) / 5) + -parseInt(i(243)) / 6 * (-parseInt(i(240)) / 7) + parseInt(i(246)) / 8 * (parseInt(i(233)) / 9) + parseInt(i(258)) / 10 + parseInt(i(228)) / 11 * (parseInt(i(235)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(ti);
      var ii = /*#__PURE__*/_createClass(function ii(t, e, i, s, n, r, a, o, d, c, u, l, h, p, f, g, m, v, y, T, S, E, b, A, w, _, I, N, P, D, R, L, C, O, B, x, M, k, U, V, q, F, X, H, G, j, W, Y, z, K, Q, J, $, Z, tt, et, it, st, nt, rt) {
        _classCallCheck(this, ii);
        var at = ei;
        this.provider = t, this.internal_provider = e, this.is_p2p = i, this[at(272)] = n, this[at(244)] = r, this[at(267)] = T, this[at(249)] = S, this[at(254)] = E, this.response_bytes_samples = b, this.response_time = A, this[at(274)] = w, this.max_response_time = _, this[at(253)] = I, this[at(225)] = N, this[at(226)] = P, this[at(275)] = D, this[at(239)] = R, this[at(241)] = L, this.min_throughput = C, this.max_throughput = O, this.throughput_samples = B, this[at(238)] = a, this[at(227)] = x, this.http_2XX = M, this[at(255)] = k, this[at(265)] = U, this.http_5XX = V, this[at(252)] = q, this[at(237)] = F, this[at(245)] = H, this[at(262)] = X, this[at(250)] = G, this[at(229)] = j, this.switches_due_errors = W, this[at(224)] = Y, this[at(232)] = o, this.max_bandwidth = d, this[at(256)] = c, this[at(266)] = K, this[at(257)] = Q, this[at(231)] = u, this[at(271)] = l, this[at(236)] = h, this[at(269)] = z, this.is_active = s, this[at(259)] = p, this.response_time = A, this.cache_hit_chunks = f, this.cache_miss_chunks = g, this[at(234)] = m, this[at(230)] = v, this[at(247)] = y, this[at(264)] = J, this[at(251)] = $, this.internal_unbanned = Z, this.internal_switches = tt, this.internal_switches_due_quality = et, this.internal_switches_due_connectivity = it, this[at(263)] = st, this[at(248)] = nt, this[at(273)] = rt;
      });
      function si(t, e) {
        var i = ri();
        return (si = function si(t, e) {
          return i[t -= 167];
        })(t, e);
      }
      !function (t, e) {
        for (var i = si, s = t();;) try {
          if (785065 == -parseInt(i(202)) / 1 * (parseInt(i(178)) / 2) + parseInt(i(203)) / 3 + parseInt(i(171)) / 4 + -parseInt(i(213)) / 5 * (parseInt(i(184)) / 6) + -parseInt(i(167)) / 7 * (-parseInt(i(200)) / 8) + -parseInt(i(186)) / 9 + -parseInt(i(198)) / 10 * (-parseInt(i(176)) / 11)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(ri);
      var ni = /*#__PURE__*/_createClass(function ni(t, e, i, s, n, r, a, o, d, c, u, l, h, p, f, g, m, v, y, T, S, E, b, A, w, _, I, N, P, D, R, L, C, O, B, x, M, k, U, V, q, F, X, H, G, j, W, Y, z, K, Q, J) {
        _classCallCheck(this, ni);
        var $ = si;
        this[$(168)] = t, this[$(201)] = e, this[$(207)] = i, this[$(204)] = s, this[$(205)] = n, this[$(179)] = r, this.time = a, this.max_bandwidth = o, this[$(181)] = d, this[$(210)] = c, this[$(180)] = u, this[$(191)] = l, this[$(175)] = h, this[$(172)] = p, this.video_downloaded_chunks = f, this.video_time = g, this.uploaded_bytes = m, this[$(170)] = v, this[$(187)] = y, this[$(215)] = T, this.late_uploaded_bytes = S, this[$(169)] = E, this[$(199)] = b, this[$(177)] = A, this[$(174)] = w, this[$(196)] = _, this.peers = I, this[$(208)] = N, this[$(189)] = P, this[$(211)] = D, this[$(195)] = R, this.response_time = L, this.min_response_time = C, this[$(194)] = O, this[$(216)] = B, this[$(193)] = x, this[$(182)] = M, this[$(192)] = k, this[$(197)] = U, this[$(185)] = V, this[$(209)] = q, this[$(188)] = F, this[$(183)] = X, this.peers_available = H, this.max_peers_available = G, this[$(206)] = j, this[$(214)] = W, this[$(173)] = Y, this.max_peers_parallel_used = z, this.min_peers_parallel_used = K, this[$(190)] = Q, this[$(212)] = J;
      });
      function ri() {
        var t = ["network_latency", "max_response_time", "response_bytes_samples", "active_peers", "network_latency_samples", "480PzTSMY", "missed_downloaded_chunks", "1864XdlJKI", "internal_provider", "478508WvHsLb", "4432512YQKpYV", "downloaded_bytes", "downloaded_chunks", "min_peers_available", "is_p2p", "response_bytes", "min_throughput", "avg_ping_time", "max_response_bytes", "peer_connection_time", "465aOTnty", "peers_used", "late_uploaded_chunks", "response_time_samples", "13979wbinLp", "provider", "late_downloaded_bytes", "uploaded_chunks", "5498096dHIaOB", "video_downloaded_bytes", "peers_parallel_used", "other_errors", "resource", "29073NaWtGM", "timeout_errors", "2jlINlq", "errors", "min_ping_time", "min_bandwidth", "min_network_latency", "throughput_samples", "49398SVKZMm", "throughput", "12734559hQuUcI", "upload_time", "max_throughput", "min_response_bytes", "peer_discovery_time", "max_ping_time", "max_network_latency"];
        return (ri = function ri() {
          return t;
        })();
      }
      function ai() {
        var t = ["p2pAvailable", "14244lSSgPY", "1753798EYEXXV", "videoId", "isLive", "apiCallsAvgResponseTime", "apiCallErrors", "10rlyxfJ", "apiCallsMinResponseTime", "152hnGqgG", "bucket", "818982Hagxxx", "186yflbzq", "announcedCdns", "10843155pBtbqg", "apiCallResponses", "bolinaAvailable", "chunkDuration", "apiCallsMaxResponseTime", "12331DShept", "activeSwitchingPriority", "463533bOwyFA", "654ocTSYM", "priorityCdn", "70055PUpNeL", "17648ZUAPfM"];
        return (ai = function ai() {
          return t;
        })();
      }
      function oi(t, e) {
        var i = ai();
        return (oi = function oi(t, e) {
          return i[t -= 414];
        })(t, e);
      }
      !function (t, e) {
        for (var i = oi, s = t();;) try {
          if (662771 == -parseInt(i(432)) / 1 + parseInt(i(423)) / 2 + -parseInt(i(417)) / 3 * (parseInt(i(420)) / 4) + -parseInt(i(419)) / 5 * (-parseInt(i(433)) / 6) + -parseInt(i(416)) / 7 * (-parseInt(i(430)) / 8) + -parseInt(i(435)) / 9 * (-parseInt(i(428)) / 10) + -parseInt(i(414)) / 11 * (parseInt(i(422)) / 12)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(ai);
      var di = /*#__PURE__*/_createClass(function di(t, e, i, s, n, r, a, o, d, c, u, l, h, p, f, g) {
        _classCallCheck(this, di);
        var m = oi;
        this[m(427)] = t, this[m(436)] = e, this[m(429)] = i, this[m(426)] = s, this[m(439)] = n, this[m(431)] = r, this[m(425)] = a, this[m(424)] = o, this.forceDecision = d, this.requestPlatform = c, this[m(421)] = u, this[m(437)] = l, this[m(415)] = h, this[m(418)] = p, this[m(438)] = f, this[m(434)] = g;
      });
      var ci = li;
      !function (t, e) {
        var i = li,
          s = t();
        for (;;) try {
          if (832091 == -parseInt(i(535)) / 1 * (-parseInt(i(455)) / 2) + parseInt(i(352)) / 3 + -parseInt(i(392)) / 4 + parseInt(i(547)) / 5 + parseInt(i(384)) / 6 + parseInt(i(385)) / 7 + -parseInt(i(544)) / 8) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(ui);
      function ui() {
        var t = ["lastReportedCodavelBanTime", "http_5XX", "absent", "lastReportedCodavelBanCount", "compressedBytes", "CODAVEL", "timeoutErrors", "codavelUnbanTime", "downloadedSegments", "samplesNetworkLatency", "lateDownloadedBytes", "apiCallsAvgResponseTime", "maxResponseBytes", "takeMin", "lowestSegmentBandwidth", "samplesThroughput", "minPeersAvailable", "isLive", "codavelSwitchesDueToQuality", "http_1XX", "hasValuesChanged", "avgPingTime", "resetOnPing", "__awaiter", "uncompressedBytes", "lastReportedCodavelUnbanTime", "downloadedBytesVideo", "wasStartSent", "missedDownloadedChunks", "http5xxResponses", "loader", "videoTime", "errors", "minResponseBytes", "totalFail", "updateAvailability", "lowestPingTime", "updateCodavelBanTimes", "http_4XX", "P2P", "takeIf", "getFastDataService", "updateData", "cacheMiss", "-js", "lastReportedCodavelSwitchesDueToConnectivity", "failedRequests", "minPingTime", "unBannedCount", "BLACK_HOLE", "processedApiCall", "discardedUploadedChunks", "size", "requestPlatform", "totalPeers", "switchesDueToErrors", "uploadedBytes", "lastCdnStats", "stopped", "4BWQNDB", "getCommonVariable", "getPingTime", "peersAvailable", "GET", "http_2XX", "getCdnCacheHits", "report", "downloadChunksVideo", "maxPeersParallelUsed", "minApiCallResponseTime", "active", "bannedCount", "discardedUploadedBytes", "Products", "switchesDueToQuality", "profileName", "BALANCER_TRAFFIC", "P2PLoader", "isEnabled", "lastReportedCodavelSwitches", "announcedCdns", "sumResponseTime", "trunc", "getBucket", "token", "peersUsed", "apiCallResponses", "BalancerPing: ", "highestSegmentBandwidth", "lastReportedCodavelUnbanCount", "updatePeerMetrics", "getCdnCacheMisses", "name", "takeMax", "sumResponseBytes", "codavelSwitches", "maxResponseTime", "getViewCode", "get", "codavelSwitchesDueToErrors", "codavelBanTime", "CDN", "MAX_SAFE_INTEGER", "getPluginVersion", "switchesDueToConnectivity", "reportRequest", "BalancerVariables", "getSegmentDuration", "lateUploadedBytes", "started", "getForceDecision", "Plugin", "bucket", "isUsingLegacy", "accountCode", "split", "chunkDuration", "value", "http1xxResponses", "startsWith", "bolinaAvailable", "sumVideoBytes", "keys", "totalFailures", "maxPingTime", "codavelUnbanCount", "maxPeersAvailable", "uploadedChunks", "stringify", "pushPeriodicDataFromCallback", "VIDEO_ANALYTICS", "codavelBanCount", "forEach", "downloadMillis", "then", "getInstance", "lastReportedCodavelSwitchesDueToErrors", "getReportInterval", "unbannedCount", "1939odJyWH", "banned", "sumNetworkLatency", "minThroughput", "samplesResponseBytes", "cacheHit", "peersParallelUsed", "lastP2pStats", "switches", "7060944PeJuTv", "set", "BALANCER_BITRATE", "488605gNCfbr", "lastReportedCodavelSwitchesDueToQuality", "minResponseTime", "uploadedTime", "otherErrors", "BALANCER", "videoId", "METHOD_OPTION", "downloadMillisVideo", "bannedTime", "maxBandwidth", "codavelAllBanned", "http_3XX", "error", "minNetworkLatency", "lateUploadedChunks", "done", "unbannedTime", "uuid", "getIsLive", "registerCommonVariable", "timeout", "offline", "discardedDownloadedBytes", "activeSwitchingPriority", "3125046rgwwNW", "sumThroughput", "maxThroughput", "getStats", "undefined", "verbose", "total", "getFastDataSessionToken", "resource", "samplesResponseTime", "sumVideoTime", "codavelSwitchesDueToConnectivity", "provider", "minPeersParallelUsed", "_instance", "setTriedSendingBalancerStats", "NQS", "avgApiCallResponseTime", "http4xxResponses", "downloadedChunks", "peerDiscoveryTime", "isCodavel", "millis", "maxNetworkLatency", "getTime", "downloadBytesVideo", "http3xxResponses", "apiCallErrors", "host", "downloadedBytes", "downloadedChunksVideo", "some", "8696622fOUyer", "4387460dwBoEl", "clone", "minBandwidth", "apply", "CDNLoader", "p2pAvailable", "peerConnectionTime", "6019156fseNvH", "priorityCdn", "activePeers", "Consumer"];
        return (ui = function ui() {
          return t;
        })();
      }
      function li(t, e) {
        var i = ui();
        return (li = function li(t, e) {
          return i[t -= 330];
        })(t, e);
      }
      var hi = /*#__PURE__*/function (_ci, _ci2, _ci3, _ci4, _ci5) {
        function hi(t) {
          _classCallCheck(this, hi);
          var e = ci;
          this[e(505)] = !1, this[e(454)] = !1, this[e(453)] = new Map(), this[e(542)] = new Map(), this[e(380)] = "", this.token = "", this[e(510)] = "", this.profileName = "", this[e(360)] = "", this.lastReportedCodavelBanTime = void 0, this[e(421)] = void 0, this[e(399)] = void 0, this[e(485)] = void 0, this[e(475)] = void 0, this[e(548)] = void 0, this[e(532)] = void 0, this[e(441)] = void 0, this[e(426)] = t;
        }
        _createClass(hi, [{
          key: _ci2,
          value: function value(t, i, s, n, o) {
            var d, c, u, l, h;
            return c = this, u = void 0, h = /*#__PURE__*/_regeneratorRuntime.mark(function h() {
              var c, _t76;
              return _regeneratorRuntime.wrap(function h$(_context17) {
                while (1) switch (_context17.prev = _context17.next) {
                  case 0:
                    c = li;
                    if (this[c(380)] = t, this[c(480)] = i, this[c(510)] = s, this.profileName = null != n ? n : "", this[c(360)] = o, !(e.default[c(531)]()[c(509)]() && this.token[c(515)](c(356)) || this.started)) {
                      _t76 = a.xC[c(497)];
                      e.default[c(531)]()[c(525)](e.default[c(531)]().getOptions()[c(349)] ? ct.default.Consumer[c(445)] : ct.default[c(395)][c(368)], _t76, _t76, 1e3 * this[c(426)][c(533)](), null !== (d = e.default.getInstance()[c(456)](ct.default[c(469)][c(526)], ct.default.AnalyticsVariables[c(334)])) && void 0 !== d ? d : r.Method[c(459)], function () {
                        var t = c;
                        if (e.default[t(531)]()[t(423)]()) return M.default[t(531)]()[t(367)](!0), hi[t(531)]()[t(462)]();
                      }, function () {
                        var e = c;
                        M.default[e(531)]().addNQSRequest(_t76);
                      }), this.started = !0;
                    }
                  case 2:
                  case "end":
                    return _context17.stop();
                }
              }, h, this);
            }), new ((l = void 0) || (l = Promise))(function (t, e) {
              function i(t) {
                try {
                  n(h.next(t));
                } catch (t) {
                  e(t);
                }
              }
              function s(t) {
                try {
                  n(h.throw(t));
                } catch (t) {
                  e(t);
                }
              }
              function n(e) {
                var n = li;
                var r;
                e[n(343)] ? t(e[n(513)]) : (r = e[n(513)], r instanceof l ? r : new l(function (t) {
                  t(r);
                }))[n(530)](i, s);
              }
              n((h = h[li(388)](c, u || [])).next());
            });
          }
        }, {
          key: "report",
          value: function report() {
            var _this48 = this;
            var t = ci;
            try {
              if (!this[t(454)]) {
                var _i133 = new Map(),
                  _s44 = new Map(this[t(426)][t(389)].getCdnList());
                var _a11 = 0,
                  _o18 = 0;
                this[t(426)][t(389)][t(433)](), this[t(426)][t(473)][t(486)]();
                var _d7 = !1;
                if (_s44[t(528)](function (e) {
                  var s = t;
                  e[s(431)]();
                  var n = e[s(386)](),
                    r = _this48.lastCdnStats[s(494)](e[s(488)]);
                  _a11 += n.sumVideoBytes || 0, _o18 += n[s(362)] || 0;
                  var c = {
                    downloadedBytesVideo: n[s(422)],
                    downloadedChunksVideo: n[s(382)],
                    videoTime: n[s(335)],
                    downloadedBytes: n[s(381)],
                    downloadedChunks: n[s(371)],
                    sumResponseBytes: n[s(490)],
                    minResponseBytes: n[s(429)],
                    maxResponseBytes: n.maxResponseBytes,
                    samplesResponseBytes: n[s(539)],
                    sumResponseTime: n.sumResponseTime,
                    minResponseTime: n[s(549)],
                    maxResponseTime: n[s(492)],
                    samplesResponseTime: n.samplesResponseTime,
                    sumNetworkLatency: n[s(537)],
                    minNetworkLatency: n[s(341)],
                    maxNetworkLatency: n[s(375)],
                    samplesNetworkLatency: n[s(405)],
                    sumThroughput: n.sumThroughput,
                    minThroughput: n[s(538)],
                    maxThroughput: n[s(354)],
                    samplesThroughput: n[s(411)],
                    totalFailures: n.totalFail,
                    http_1XX: n.http1xxResponses,
                    http_2XX: n.http2xxResponses,
                    http_3XX: n[s(378)],
                    http_4XX: n[s(370)],
                    http_5XX: n[s(425)],
                    unbannedTime: n[s(344)],
                    bannedTime: n[s(336)],
                    compressedBytes: n.compressedBytes,
                    uncompressedBytes: n[s(420)],
                    switches: n[s(543)],
                    switchesDueToConnectivity: n[s(500)],
                    switchesDueToErrors: n[s(451)],
                    switchesDueToQuality: n.switchesDueToQuality,
                    millis: n.downloadMillis,
                    bannedCount: n[s(467)],
                    unbannedCount: n.unBannedCount,
                    avgPingTime: n[s(417)],
                    minPingTime: n.lowestPingTime === Number[s(498)] ? 0 : n.lowestPingTime,
                    maxPingTime: n.highestPingTime,
                    cacheHit: n.getCdnCacheHits(),
                    cacheMiss: n[s(487)](),
                    minBandwidth: n.lowestSegmentBandwidth === Number[s(498)] ? 0 : n[s(410)],
                    maxBandwidth: n[s(484)]
                  };
                  r && (c[s(422)] -= r.downloadedBytesVideo, c[s(382)] -= r[s(382)], c.videoTime -= r[s(335)], c[s(381)] -= r[s(381)], c[s(371)] -= r[s(371)], c[s(519)] -= r[s(430)], null != c[s(415)] && null != r[s(514)] && (c[s(415)] -= r[s(514)]), null != c[s(460)] && null != r.http2xxResponses && (c[s(460)] -= r.http2xxResponses), null != c[s(339)] && null != r[s(378)] && (c[s(339)] -= r.http3xxResponses), null != c[s(434)] && null != r[s(370)] && (c.http_4XX -= r[s(370)]), null != c[s(397)] && null != r.http5xxResponses && (c[s(397)] -= r[s(425)]), null != c[s(400)] && null != r[s(400)] && (c[s(400)] -= r.compressedBytes), null != c[s(420)] && null != r[s(420)] && (c[s(420)] -= r[s(420)]), null != c[s(543)] && null != r[s(543)] && (c.switches -= r[s(543)]), null != c[s(500)] && null != r[s(500)] && (c[s(500)] -= r[s(500)]), null != c[s(451)] && null != r[s(451)] && (c[s(451)] -= r[s(451)]), null != c[s(470)] && null != r[s(470)] && (c[s(470)] -= r[s(470)]), c[s(374)] -= r[s(529)], c[s(467)] -= r[s(467)], c[s(534)] -= r[s(444)], c[s(417)] -= r[s(417)], c.minPingTime = 0 == c[s(443)] ? c[s(443)] : c.minPingTime - r[s(432)], c[s(520)] = 0 == c[s(520)] ? c[s(520)] : c[s(520)] - r.highestPingTime, c.cacheHit -= r[s(461)](), c[s(439)] -= r[s(487)](), c[s(387)] = 0 == c.minBandwidth ? c[s(387)] : c.minBandwidth - r[s(410)], c[s(337)] = 0 == c.maxBandwidth ? c[s(337)] : c[s(337)] - r[s(484)]);
                  var u = e[s(373)]() ? s(401) : e[s(364)];
                  if (e[s(373)]()) {
                    if (_d7) {
                      var _t77 = new ii(u, e.internal_provider, !1, e[s(466)], _this48.takeIf(c[s(381)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(371)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(519)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(374)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.maxBandwidth, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(387)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(417)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(443)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(520)], function (t) {
                        return 0 != t;
                      }), _this48.resource, _this48[s(436)](c[s(540)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(439)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(422)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(382)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(427)], function (t) {
                        return 0 != t;
                      }), c.sumResponseBytes, _this48[s(409)](c[s(429)]), _this48[s(489)](c[s(408)]), c.samplesResponseBytes, c.sumResponseTime, _this48[s(409)](c.minResponseTime), _this48[s(489)](c.maxResponseTime), c[s(361)], c.sumNetworkLatency, _this48.takeMin(c[s(341)]), _this48.takeMax(c.maxNetworkLatency), c.samplesNetworkLatency, c[s(353)], _this48[s(409)](c[s(538)]), _this48[s(489)](c[s(354)]), c[s(411)], _this48[s(436)](c.http_1XX, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.http_2XX, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.http_3XX, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(434)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(397)], function (t) {
                        return 0 != t;
                      }), void 0, void 0, _this48[s(436)](c[s(420)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(400)], function (t) {
                        return 0 != t;
                      }), void 0, void 0, void 0, void 0, void 0, void 0, void 0, e[s(536)], _this48[s(436)](c.bannedCount, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(534)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(543)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(500)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.switchesDueToErrors, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.switchesDueToQuality, function (t) {
                        return 0 != t;
                      }), c[s(336)], c[s(344)]);
                      _i133[s(545)](e[s(488)], _t77), _this48[s(453)][s(545)](e[s(488)], n);
                    } else {
                      var _t78 = 0;
                      null != _this48.loader[s(389)][s(527)] && (_t78 = null != _this48[s(399)] ? _this48[s(426)].CDNLoader[s(527)] - _this48[s(399)] : _this48[s(426)][s(389)].codavelBanCount);
                      var _r10 = 0;
                      null != _this48[s(426)].CDNLoader[s(521)] && (_r10 = null != _this48[s(485)] ? _this48[s(426)][s(389)].codavelUnbanCount - _this48[s(485)] : _this48[s(426)][s(389)][s(521)]);
                      var _a12 = 0;
                      null != _this48[s(426)].CDNLoader[s(496)] && (_a12 = null != _this48[s(396)] ? _this48.loader[s(389)][s(496)] - _this48[s(396)] : _this48[s(426)][s(389)][s(496)]);
                      var _o19 = 0;
                      null != _this48[s(426)][s(389)][s(403)] && (_o19 = null != _this48.lastReportedCodavelUnbanTime ? _this48.loader[s(389)][s(403)] - _this48.lastReportedCodavelUnbanTime : _this48[s(426)][s(389)][s(403)]);
                      var _l4 = 0;
                      null != _this48.loader[s(389)][s(491)] && (_l4 = null != _this48[s(475)] ? _this48[s(426)][s(389)][s(491)] - _this48.lastReportedCodavelSwitches : _this48.loader[s(389)][s(491)]);
                      var _h5 = 0;
                      null != _this48[s(426)][s(389)].codavelSwitchesDueToQuality && (_h5 = null != _this48[s(548)] ? _this48[s(426)][s(389)][s(414)] - _this48[s(548)] : _this48[s(426)][s(389)][s(414)]);
                      var _p2 = 0;
                      null != _this48[s(426)][s(389)][s(363)] && (_p2 = null != _this48[s(441)] ? _this48[s(426)][s(389)].codavelSwitchesDueToConnectivity - _this48[s(441)] : _this48[s(426)][s(389)][s(363)]);
                      var _f = 0;
                      null != _this48[s(426)][s(389)][s(495)] && (_f = null != _this48[s(532)] ? _this48[s(426)][s(389)][s(495)] - _this48[s(532)] : _this48[s(426)][s(389)].codavelSwitchesDueToErrors);
                      var _g3 = new ii(u, e.internal_provider, !1, e.active, _this48[s(436)](c[s(381)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.downloadedChunks, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.totalFailures, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(374)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.maxBandwidth, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(387)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(417)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.minPingTime, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(520)], function (t) {
                        return 0 != t;
                      }), _this48[s(360)], _this48.takeIf(c[s(540)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.cacheMiss, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(422)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(382)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.videoTime, function (t) {
                        return 0 != t;
                      }), c[s(490)], _this48.takeMin(c[s(429)]), _this48[s(489)](c.maxResponseBytes), c[s(539)], c[s(477)], _this48[s(409)](c[s(549)]), _this48[s(489)](c[s(492)]), c.samplesResponseTime, c.sumNetworkLatency, _this48[s(409)](c.minNetworkLatency), _this48.takeMax(c[s(375)]), c[s(405)], c[s(353)], _this48[s(409)](c[s(538)]), _this48.takeMax(c[s(354)]), c[s(411)], _this48[s(436)](c[s(415)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(460)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.http_3XX, function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(434)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(397)], function (t) {
                        return 0 != t;
                      }), _o19, _a12, _this48.takeIf(c[s(420)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c.compressedBytes, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](_l4, function (t) {
                        return 0 != t;
                      }), _this48.takeIf(_p2, function (t) {
                        return 0 != t;
                      }), _this48.takeIf(_f, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](_h5, function (t) {
                        return 0 != t;
                      }), _this48[s(426)].CDNLoader[s(338)], _this48.takeIf(_t78, function (t) {
                        return 0 != t;
                      }), _this48.takeIf(_r10, function (t) {
                        return 0 != t;
                      }), e[s(536)], _this48[s(436)](c[s(467)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(534)], function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c.switches, function (t) {
                        return 0 != t;
                      }), _this48[s(436)](c[s(500)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(451)], function (t) {
                        return 0 != t;
                      }), _this48.takeIf(c[s(470)], function (t) {
                        return 0 != t;
                      }), c[s(336)], c[s(344)]);
                      _i133[s(545)](e[s(488)], _g3), _this48.lastCdnStats[s(545)](e[s(488)], n), _d7 = !0;
                    }
                  } else {
                    var _t79 = new ii(u, e.internal_provider, !1, e[s(466)], _this48[s(436)](c[s(381)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(371)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c.totalFailures, function (t) {
                      return 0 != t;
                    }), _this48.takeIf(c[s(374)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(337)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(387)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(417)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(443)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(520)], function (t) {
                      return 0 != t;
                    }), _this48[s(360)], _this48[s(436)](c[s(540)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(439)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c.downloadedBytesVideo, function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(382)], function (t) {
                      return 0 != t;
                    }), _this48.takeIf(c[s(427)], function (t) {
                      return 0 != t;
                    }), c[s(490)], _this48[s(409)](c.minResponseBytes), _this48[s(489)](c.maxResponseBytes), c[s(539)], c.sumResponseTime, _this48[s(409)](c[s(549)]), _this48[s(489)](c[s(492)]), c[s(361)], c[s(537)], _this48.takeMin(c.minNetworkLatency), _this48[s(489)](c[s(375)]), c[s(405)], c[s(353)], _this48.takeMin(c[s(538)]), _this48.takeMax(c.maxThroughput), c[s(411)], _this48[s(436)](c[s(415)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(460)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c.http_3XX, function (t) {
                      return 0 != t;
                    }), _this48.takeIf(c[s(434)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(397)], function (t) {
                      return 0 != t;
                    }), c.unbannedTime, c[s(336)], _this48[s(436)](c.uncompressedBytes, function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c.compressedBytes, function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c.switches, function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(500)], function (t) {
                      return 0 != t;
                    }), _this48[s(436)](c[s(451)], function (t) {
                      return 0 != t;
                    }), _this48.takeIf(c[s(470)], function (t) {
                      return 0 != t;
                    }), e.banned, _this48.takeIf(c[s(467)], function (t) {
                      return 0 != t;
                    }), _this48.takeIf(c[s(534)], function (t) {
                      return 0 != t;
                    }));
                    _i133[s(545)](e.name, _t79), _this48[s(453)][s(545)](e[s(488)], n);
                  }
                }), this.loader[t(473)][t(474)]()) {
                  var _e66 = this[t(426)][t(473)][t(355)](),
                    _s45 = this[t(542)][t(494)]("P2P");
                  _a11 += _e66[t(517)] || 0, _o18 += _e66[t(362)] || 0;
                  var _n29 = {
                    downloadedBytes: _e66[t(381)],
                    downloadedChunks: _e66[t(404)],
                    errors: _e66.failedRequests[t(358)],
                    millis: _e66[t(529)],
                    maxBandwidth: _e66[t(337)],
                    minBandwidth: _e66[t(387)] === Number[t(498)] ? 0 : _e66[t(387)],
                    avgPingTime: _e66[t(417)],
                    minPingTime: _e66[t(443)] === Number[t(498)] ? 0 : _e66[t(443)],
                    maxPingTime: _e66[t(520)],
                    downloadMillisVideo: _e66[t(335)],
                    downloadBytesVideo: _e66[t(377)],
                    downloadChunksVideo: _e66[t(463)],
                    uploadedBytes: _e66.uploadedBytes,
                    uploadedChunks: _e66[t(523)],
                    uploadedTime: _e66[t(330)],
                    lateUploadedChunks: _e66[t(447)],
                    lateUploadedBytes: _e66[t(468)],
                    lateDownloadedBytes: _e66[t(350)],
                    missedDownloadedChunks: _e66[t(442)][t(398)],
                    timeoutErrors: _e66[t(442)][t(348)],
                    otherErrors: _e66.failedRequests.error,
                    activePeers: _e66[t(394)],
                    totalPeers: _e66[t(450)],
                    sumResponseBytes: _e66[t(490)],
                    minResponseBytes: _e66[t(429)],
                    maxResponseBytes: _e66.maxResponseBytes,
                    samplesResponseBytes: _e66[t(539)],
                    sumResponseTime: _e66[t(477)],
                    minResponseTime: _e66[t(549)],
                    maxResponseTime: _e66[t(492)],
                    samplesResponseTime: _e66[t(361)],
                    sumNetworkLatency: _e66.sumNetworkLatency,
                    minNetworkLatency: _e66[t(341)],
                    maxNetworkLatency: _e66[t(375)],
                    samplesNetworkLatency: _e66[t(405)],
                    sumThroughput: _e66[t(353)],
                    minThroughput: _e66[t(538)],
                    maxThroughput: _e66[t(354)],
                    samplesThroughput: _e66[t(411)],
                    peersAvailable: _e66.peersAvailable,
                    minPeersAvailable: _e66.minPeersAvailable,
                    maxPeersAvailable: _e66.maxPeersAvailable,
                    peersUsed: _e66.peersUsed,
                    peersParallelUsed: _e66[t(541)],
                    minPeersParallelUsed: _e66[t(365)],
                    maxPeersParallelUsed: _e66[t(464)],
                    peerDiscoveryTime: _e66.peerDiscoveryTime,
                    peerConnectionTime: _e66[t(391)]
                  };
                  _s45 && (_n29[t(381)] -= _s45[t(381)], _n29[t(371)] -= _s45[t(404)], _n29[t(428)] -= _s45.failedRequests.total, _n29.millis -= _s45[t(529)], _n29[t(337)] = 0 == _n29[t(337)] ? _n29[t(337)] : _n29[t(337)] - _s45[t(337)], _n29[t(387)] = 0 == _n29.minBandwidth ? _n29.minBandwidth : _n29[t(387)] - _s45[t(387)], _n29.avgPingTime -= _s45[t(417)], _n29[t(443)] = 0 == _n29[t(443)] ? _n29[t(443)] : _n29.minPingTime - _s45[t(443)], _n29[t(520)] = 0 == _n29[t(520)] ? _n29[t(520)] : _n29[t(520)] - _s45[t(520)], _n29.minPingTime -= _s45[t(443)], _n29[t(520)] -= _s45.maxPingTime, _n29[t(335)] -= _s45.downloadMillisVideo, _n29[t(377)] -= _s45.downloadBytesVideo, _n29[t(463)] -= _s45[t(463)], _n29[t(452)] -= _s45[t(452)], _n29[t(523)] -= _s45[t(523)], _n29[t(330)] -= _s45[t(330)], _n29[t(342)] -= _s45[t(447)], _n29.lateUploadedBytes -= _s45[t(468)], _n29[t(406)] -= _s45[t(350)], _n29[t(424)] -= _s45[t(442)][t(398)], _n29[t(402)] -= _s45[t(442)].timeout, _n29[t(331)] -= _s45.failedRequests[t(340)], _n29.activePeers -= _s45[t(394)], _n29[t(450)] -= _s45[t(450)], null != _n29[t(458)] && null != _s45[t(458)] && (_n29.peersAvailable -= _s45.peersAvailable), null != _n29[t(481)] && null != _s45[t(481)] && (_n29[t(481)] -= _s45[t(481)]), null != _n29[t(541)] && null != _s45.peersParallelUsed && (_n29.peersParallelUsed -= _s45[t(541)]), null != _n29.peerDiscoveryTime && null != _s45[t(372)] && (_n29[t(372)] -= _s45[t(372)]), null != _n29[t(391)] && null != _s45[t(391)] && (_n29[t(391)] -= _s45[t(391)]));
                  var _r11 = new ni("P2P", t(435), !0, this[t(436)](_n29[t(381)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(371)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(428)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(374)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(337)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(387)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(417)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29.minPingTime, function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29.maxPingTime, function (t) {
                    return 0 != t;
                  }), this[t(360)], this[t(436)](_n29[t(377)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(463)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(335)], function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29.uploadedBytes, function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29.uploadedChunks, function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(330)], function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29[t(342)], function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29[t(504)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(406)], function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29[t(424)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(402)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29.otherErrors, function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(394)], function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(450)], function (t) {
                    return 0 != t;
                  }), _n29.sumResponseBytes, _n29[t(429)], _n29[t(408)], _n29.samplesResponseBytes, _n29[t(477)], _n29[t(549)], _n29[t(492)], _n29[t(361)], _n29[t(537)], _n29[t(341)], _n29[t(375)], _n29[t(405)], _n29.sumThroughput, _n29[t(538)], _n29.maxThroughput, _n29[t(411)], this.takeIf(_n29.peersAvailable, function (t) {
                    return 0 != t;
                  }), this[t(489)](_n29[t(522)]), this[t(409)](_n29[t(412)]), this[t(436)](_n29.peersUsed, function (t) {
                    return 0 != t;
                  }), this[t(436)](_n29[t(541)], function (t) {
                    return 0 != t;
                  }), this[t(489)](_n29[t(464)]), this[t(409)](_n29[t(365)]), this[t(436)](_n29[t(372)], function (t) {
                    return 0 != t;
                  }), this.takeIf(_n29[t(391)], function (t) {
                    return 0 != t;
                  }));
                  _i133[t(545)](t(435), _r11), this.lastP2pStats.set(t(435), _e66);
                }
                var _c4 = {};
                _i133.forEach(function (t, e) {
                  _c4[e] = t;
                });
                var _u4 = _o18 > 0 ? 8 * _a11 * 1e3 / _o18 : 0;
                var _l5;
                if (e.default[t(531)]()[t(347)](ct.default[t(469)][t(332)], ct.default[t(502)][t(472)], _a11), e.default[t(531)]()[t(347)](ct.default.Products.BALANCER, ct.default[t(502)][t(546)], _u4), this[t(426)][t(389)][t(446)] && (_l5 = new di(this.loader[t(389)][t(379)], this[t(426)][t(389)][t(482)], void 0 !== this[t(426)][t(389)][t(465)] ? Math.trunc(this[t(426)].CDNLoader[t(465)]) : void 0, void 0 !== this[t(426)][t(389)][t(369)] ? Math[t(478)](this[t(426)][t(389)].avgApiCallResponseTime) : void 0, void 0 !== this.loader.CDNLoader.maxApiCallResponseTime ? Math[t(478)](this[t(426)][t(389)].maxApiCallResponseTime) : void 0, this[t(426)][t(389)][t(479)](), this.loader[t(389)][t(346)](), this.token, this[t(426)].CDNLoader[t(506)](), t(507), this[t(426)][t(389)][t(390)], this[t(426)][t(389)][t(516)], this.loader.CDNLoader[t(351)], this[t(426)][t(389)].priorityCdn, this[t(426)][t(389)][t(503)](), this[t(426)][t(389)][t(476)])), _s44[t(528)](function (t) {
                  t.resetOnPing();
                }), this[t(426)][t(473)][t(474)]() && this[t(426)].P2PLoader[t(418)](), this.loader[t(389)][t(418)](), n.default[t(357)](r.BalancerTag, t(483) + JSON[t(524)](_c4)), _i133[t(448)] > 0) return this[t(501)](this[t(480)], this[t(510)], this[t(471)], this[t(360)], JSON[t(524)](_c4), _l5);
              }
            } catch (t) {}
          }
        }, {
          key: _ci3,
          value: function value(t) {
            var e = ci;
            return Object[e(518)](t)[e(383)](function (e) {
              return 0 != t[e];
            });
          }
        }, {
          key: "takeIf",
          value: function takeIf(t, e) {
            return void 0 !== t && e(t) ? t : void 0;
          }
        }, {
          key: _ci4,
          value: function value(t) {
            return void 0 !== t ? t : Number.MAX_SAFE_INTEGER;
          }
        }, {
          key: "takeMax",
          value: function takeMax(t) {
            return void 0 !== t ? t : Number.MIN_SAFE_INTEGER;
          }
        }, {
          key: _ci5,
          value: function value(t, i, s, n, r, a) {
            var o = ci;
            if ("" == r || "{}" == r) return;
            var d = {};
            return d = null != a ? {
              timemark: new Date().getTime(),
              code: e.default[o(531)]().isUsingLegacy() ? e.default.getInstance()[o(493)]() : t,
              sessionRoot: e.default.getInstance()[o(359)](),
              v: e.default[o(499)]()[o(511)](o(440))[0],
              pluginVersion: e.default[o(499)](),
              pingTime: e.default[o(531)]()[o(437)]()[o(457)](),
              token: t,
              accountCode: i,
              profileName: s,
              data: r,
              api_errors: a[o(379)],
              api_responses: a[o(482)],
              api_min_response_time: a.apiCallsMinResponseTime,
              api_avg_response_time: a[o(407)],
              api_max_response_time: a[o(407)],
              bucket: a[o(508)],
              is_live: a[o(413)],
              video_id: a[o(333)],
              force_decision: a.forceDecision,
              request_platform: a[o(449)],
              p2p_available: a[o(390)],
              bolina_available: a[o(516)],
              active_switching_priority: a.activeSwitchingPriority,
              priority_cdn: a[o(393)],
              chunk_duration: a[o(512)],
              announced_cdns: a[o(476)]
            } : {
              timemark: new Date()[o(376)](),
              code: e.default[o(531)]()[o(509)]() ? e.default.getInstance()[o(493)]() : t,
              sessionRoot: e.default[o(531)]().getFastDataSessionToken(),
              v: e.default[o(499)]().split(o(440))[0],
              pingTime: e.default[o(531)]().getFastDataService()[o(457)](),
              token: t,
              accountCode: i,
              profileName: s,
              data: r
            }, d;
          }
        }], [{
          key: _ci,
          value: function value(t) {
            var e = ci;
            return null == this[e(366)] && null != t ? this._instance = new hi(t) : null != t && null != this[e(366)] && (null == t ? void 0 : t[e(345)]) != this._instance[e(426)].uuid && (this[e(366)][e(462)](), this[e(366)] = new hi(t)), this[e(366)];
          }
        }]);
        return hi;
      }(ci(531), ci(438), ci(416), ci(409), ci(501));
      var pi = {
        randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
      };
      var fi;
      var gi = new Uint8Array(16);
      function mi() {
        if (!fi && (fi = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !fi)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        return fi(gi);
      }
      var vi = [];
      for (var _t80 = 0; _t80 < 256; ++_t80) vi.push((_t80 + 256).toString(16).slice(1));
      var yi = function yi(t, e, i) {
          if (pi.randomUUID && !e && !t) return pi.randomUUID();
          var s = (t = t || {}).random || (t.rng || mi)();
          if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, e) {
            i = i || 0;
            for (var _t81 = 0; _t81 < 16; ++_t81) e[i + _t81] = s[_t81];
            return e;
          }
          return function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return vi[t[e + 0]] + vi[t[e + 1]] + vi[t[e + 2]] + vi[t[e + 3]] + "-" + vi[t[e + 4]] + vi[t[e + 5]] + "-" + vi[t[e + 6]] + vi[t[e + 7]] + "-" + vi[t[e + 8]] + vi[t[e + 9]] + "-" + vi[t[e + 10]] + vi[t[e + 11]] + vi[t[e + 12]] + vi[t[e + 13]] + vi[t[e + 14]] + vi[t[e + 15]];
          }(s);
        },
        Ti = Si;
      !function (t, e) {
        var i = Si,
          s = t();
        for (;;) try {
          if (599839 == parseInt(i(455)) / 1 + parseInt(i(483)) / 2 * (parseInt(i(570)) / 3) + -parseInt(i(529)) / 4 * (-parseInt(i(485)) / 5) + parseInt(i(564)) / 6 * (parseInt(i(506)) / 7) + parseInt(i(531)) / 8 + parseInt(i(534)) / 9 + parseInt(i(449)) / 10 * (-parseInt(i(537)) / 11)) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(Ei);
      function Si(t, e) {
        var i = Ei();
        return (Si = function Si(t, e) {
          return i[t -= 449];
        })(t, e);
      }
      function Ei() {
        var t = ["3496131qJYPnb", "getIsEnabled", "cdns", "10615jsfKgk", "href", "toString", "download", "debug", "updateUrl", "done", "status", "onProcessSegmentFail", "_accountCode", "segmentsMap", "headers", "bandwidthPosition", "timeout", "retries", "then", "warn", "reportTime", "rendition", "getMaxBandwidth", "totalBandwidth", "storeSegment", "loadBalancerData", "AnalyticsVariables", "abort", "options", "startTime", "126NeYpDb", "Fail", "bucketName", "getFastDataSessionToken", "requestReadTimeout", "loadEM", "3aaehIz", "getResponseHeader", "set", "_resource", "delete", "getSegment", "getInstance", "changeStatusCDN", "resource", "setMaxBandwith", "P2P PATH FOR ID ", "throw", "Segment request failed, no more retries ", "34940YGxfys", "pathname", "Products", "_balancerBusinessObject", "value", "updateCDNStatsOnSuccess", "1066280BHvzpC", "isAudio", "Content-Length", "removeActiveSegment", "P2P", "total", "readyState", "url", "enable", " -> ", "useP2P", "failed", "isDev", "error", "limit", "Success", "realBodySize", "setActive", "statsReportBusinessObject", "storage", "updateData", "cdnName", "Detected rendition -> ", "__awaiter", "getVideoRenditions", "totalDownloadedBytes", "profileName", "updateCDNStatsOnFailure", "965688riBtwL", "isEnabled", "607125OSsYhP", "isManifest", "targetDuration", " for ", "off", "onAbort", "downloadMillis", "allowSpecialDelimitersInUrl", "uuid", "errorEM", "size", "downloadedSegments", "duration", "next", "updateProgressStats", "loadEndEM", "P2PLoader", "enableCDN", "byteLength", "enableCDN will be deprecated use setActive instead.", "_segments", "81347HqtCnM", "timeBetweenHeads", "trunc", "getRendition", "loadCDNBalancerData", "updateTime", "downloadedBytes", "response", "timeBetweenBurstsMilliseconds", "_options", "isMedia", "currentRenditionPos", "data", "onProcessSegmentSuccess", "getStats", "loadStartEM", "getReportInterval", "CDNLoader", "Request was canceled due a timeout -> ", " isAudio ", "onProgress", "isLive", "statusCode", "20ZqwpUP", "now", "9462400CRRqzn", "renditionCount", "newDownloadedSegment"];
        return (Ei = function Ei() {
          return t;
        })();
      }
      var bi = /*#__PURE__*/function (_Ti, _Ti2, _Ti3, _Ti4, _Ti5, _Ti6, _Ti7, _Ti8, _Ti9, _Ti10, _Ti11, _Ti12, _Ti13, _Ti14) {
        function bi(t, e) {
          _classCallCheck(this, bi);
          var i = Ti;
          this[i(505)] = new Map(), this[i(547)] = new Map(), this[i(484)] = !0, this._accountCode = t, this[i(515)] = e, this[i(573)] = new je(), this[i(474)] = new vt(this), this._options[i(507)] && this[i(515)][i(507)] >= 1e3 && (a.wc[i(514)] = this._options[i(507)]), this.P2PLoader = new $(this[i(546)], e, this.storage), this[i(523)] = new pt(e, this[i(573)], this.P2PLoader), this.statsReportBusinessObject = hi[i(576)](this), ot[i(576)](this), z.getInstance(this.P2PLoader), this[i(493)] = yi();
          var s = new Ke(this);
          this[i(452)] = s, e.forceDecisionCall && this[i(510)](!0);
        }
        _createClass(bi, [{
          key: _Ti,
          value: function value() {
            var t = Ti;
            return !this[t(515)][t(554)] || this[t(515)][t(554)] < 1 ? 5 : this[t(515)].reportTime;
          }
        }, {
          key: "loadCDNBalancerData",
          value: function loadCDNBalancerData(t) {
            var e = Ti;
            var i, s, n, r, a, o, d, c;
            null != t && t && this._balancerBusinessObject.loadBalancerData(this._accountCode, "/", null !== (i = this[e(515)].isLive) && void 0 !== i && i, null !== (s = this[e(515)][e(511)]) && void 0 !== s ? s : 0, null !== (n = this._options.debug) && void 0 !== n && n, null !== (r = this[e(515)][e(467)]) && void 0 !== r && r, this._options[e(481)], this[e(515)][e(566)], this[e(515)].host), this[e(515)][e(578)] && "" != this._options[e(578)] && this[e(452)][e(559)](this[e(546)], this._options[e(578)], null !== (a = this._options[e(527)]) && void 0 !== a && a, null !== (o = this[e(515)][e(511)]) && void 0 !== o ? o : 0, null !== (d = this[e(515)][e(541)]) && void 0 !== d && d, null !== (c = this._options[e(467)]) && void 0 !== c && c, this[e(515)][e(481)], this[e(515)][e(566)], this._options.host);
          }
        }, {
          key: "processSegment",
          value: function processSegment(t, i, s, o) {
            var _this49 = this;
            var d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : a._C[Ti(551)];
            var u = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
            var l = arguments.length > 6 ? arguments[6] : undefined;
            var h = Ti,
              p = c[h(516)](t[h(450)]),
              f = !p && c[h(486)](t[h(450)], this[h(515)].allowSpecialDelimitersInUrl),
              g = this[h(501)][h(484)]() && p;
            n.default.verbose(r.BalancerTag, h(580) + t.pathname);
            var m = new Fe(t[h(450)], t[h(538)], this[h(573)], o, d, g, u);
            if (m[h(540)] = i, m[h(548)] = o, this[h(505)][h(572)](m.id, m), !f) {
              var _e67 = this[h(573)][h(509)](t[h(450)]);
              null != _e67 && (n.default.verbose(r.BalancerTag, h(477) + _e67.bandwidth + " " + (null == _e67 ? void 0 : _e67[h(549)]) + h(525) + _e67[h(456)] + h(488) + t), m[h(497)] = _e67[h(487)], m[h(555)] = _e67, !_e67[h(456)] && (this.CDNLoader.currentRenditionBandwidth = _e67.bandwidth, this[h(523)][h(517)] = _e67[h(549)] + 1, this[h(523)][h(532)] = this._resource[h(479)]()[h(495)]));
            }
            this._resource && this[h(573)].clean();
            var v = e.default[h(576)]().getCommonVariable(ct.default[h(451)].VIDEO_ANALYTICS, ct.default[h(560)].VIEW_CODE);
            var y = e.default[h(576)]()[h(567)]() + (v ? "_" + v : "");
            return !y && (y = this[h(493)]), this[h(473)][h(475)]("d1.npaw.com", y, this[h(546)], this[h(515)].profileName, t[h(539)]()), m[h(486)] = f, m.isMedia = p, i && (m.on(a.yL[h(470)], function (t) {
              return e = _this49, i = void 0, r = /*#__PURE__*/_regeneratorRuntime.mark(function r() {
                return _regeneratorRuntime.wrap(function r$(_context18) {
                  while (1) switch (_context18.prev = _context18.next) {
                    case 0:
                      this.onProcessSegmentSuccess(m), s[0](m);
                    case 1:
                    case "end":
                      return _context18.stop();
                  }
                }, r, this);
              }), new ((n = void 0) || (n = Promise))(function (t, s) {
                var a = Si;
                function o(t) {
                  var e = Si;
                  try {
                    c(r[e(498)](t));
                  } catch (t) {
                    s(t);
                  }
                }
                function d(t) {
                  var e = Si;
                  try {
                    c(r[e(581)](t));
                  } catch (t) {
                    s(t);
                  }
                }
                function c(e) {
                  var i = Si;
                  var s;
                  e[i(543)] ? t(e[i(453)]) : (s = e[i(453)], s instanceof n ? s : new n(function (t) {
                    t(s);
                  }))[i(552)](o, d);
                }
                c((r = r.apply(e, i || []))[a(498)]());
              });
              var e, i, n, r;
            }), m.on(a.yL[h(565)], function (t) {
              var e = h;
              _this49[e(545)](m, !0), 0 == m[e(551)] && s.length > 1 && s[1](), n.default[e(468)](r.BalancerTag, e(582) + m.route);
            })), this[h(523)].updateUrl(m) !== h(459) ? this[h(523)].getActiveRequests()[h(572)](m.id, m) : (m.cdnName = h(459), m.cdnProvider = "P2P", this.P2PLoader.request(m, void 0)), m[h(563)] = Date[h(530)](), m;
          }
        }, {
          key: _Ti2,
          value: function value(t, e) {
            var i = Ti,
              s = t[i(476)];
            t[i(466)] = !0, this[i(523)][i(482)](s, t), t.triedP2P && 1 == t[i(465)] && (t[i(465)] = !1, this.CDNLoader[i(542)](t));
          }
        }, {
          key: _Ti3,
          value: function value(t) {
            var e = Ti;
            ot[e(576)]().newDownloadedSegment(t), z[e(576)]()[e(533)](t), t[e(489)](a.yL[e(470)]), t.off(a.yL[e(565)]);
            var i = this.CDNLoader[e(556)](t[e(476)]);
            i > 0 && new $e()[e(469)](i, t), this.CDNLoader[e(454)](t), this.CDNLoader[e(458)](t), this[e(501)][e(484)]() && t[e(516)] && !this[e(501)][e(575)](t) && this[e(501)].storeSegment(t), this[e(505)][e(574)](t.id);
          }
        }, {
          key: _Ti4,
          value: function value(t, e) {
            var i = Ti;
            return n.default[i(553)](r.BalancerTag, i(504)), this.setActive(t, e);
          }
        }, {
          key: _Ti5,
          value: function value(t, e) {
            var i = Ti;
            return "P2P" === t ? (e ? this[i(501)].enable() : this[i(501)].disable(), !0) : this.CDNLoader[i(577)](t, e);
          }
        }, {
          key: _Ti6,
          value: function value(t, e) {
            return t !== Ti(459) && (this.CDNLoader.setMaxBandwidth(t, e) || !1);
          }
        }, {
          key: _Ti7,
          value: function value(t, e) {
            var i = Ti;
            e && !e.failed && e.timeout && (n.default.debug(r.BalancerTag, i(524) + e[i(462)]), this[i(545)](e, !1));
          }
        }, {
          key: _Ti8,
          value: function value(t, e, i) {}
        }, {
          key: _Ti9,
          value: function value(t, e, i) {
            var s = Ti;
            null != e && i.total > 0 && this[s(501)][s(484)]() && e[s(516)] && !this.P2PLoader[s(575)](e) && t[s(513)] && t[s(513)][s(503)] && t[s(513)][s(503)] > 0 && (e[s(518)] = t.response, e[s(471)] = i[s(460)], this[s(501)].storeSegment(e));
          }
        }, {
          key: "progressEM",
          value: function progressEM(t, e, i) {
            var s = Ti;
            null != e && (this[s(501)][s(484)]() && e[s(516)] && !this.P2PLoader[s(575)](e) && t[s(513)] && t[s(513)].byteLength && t[s(513)].byteLength > 0 && (n.default[s(541)](r.BalancerTag, "the status is -> " + t[s(544)]), e[s(518)] = t[s(513)], i[s(460)] > 0 && (e[s(471)] = i.total), this[s(501)][s(558)](e)), e[s(526)](t, i), this.CDNLoader[s(499)]());
          }
        }, {
          key: "readyStateChangeEM",
          value: function readyStateChangeEM(t, e, i) {
            var _this50 = this;
            var s = Ti;
            switch (t[s(461)]) {
              case 2:
                e && !e[s(568)] && (e.requestReadTimeout = setTimeout(function () {
                  return _this50[s(550)](t, e);
                }, a._C.readTimeoutMilliseconds));
                break;
              case 4:
                if (null != e) {
                  if (clearTimeout(e[s(568)]), delete e[s(568)], e[s(528)] = t.status, t[s(544)] >= 200 && t[s(544)] < 400) {
                    var _n30 = e.onSuccess(t[s(513)], t[s(571)](s(457)) || "0", i[s(562)][s(492)]);
                    return e[s(486)] && i.setManifestResource(e[s(462)]), _n30 ? this.onProcessSegmentSuccess(e) : this.onProcessSegmentFail(e, !1), !0;
                  }
                  return n.default.debug(r.BalancerTag, "SEGMENT FAILED WITH STATUS " + t.status + s(464) + e.id), this[s(545)](e, !1), !1;
                }
            }
            return !0;
          }
        }, {
          key: _Ti10,
          value: function value(t, e) {
            var i = Ti;
            e[i(550)] = !0, t[i(561)]();
          }
        }, {
          key: _Ti11,
          value: function value(t, e, i) {}
        }, {
          key: _Ti12,
          value: function value(t, e, i) {}
        }, {
          key: "getStats",
          value: function getStats() {
            var t = Ti,
              e = this.CDNLoader[t(520)](),
              i = this[t(501)].getStats();
            var s = !1,
              n = 0;
            return i && this[t(501)] && this[t(523)][t(520)]()[t(480)] > 0 && (s = !0, n = 8 * i[t(512)] / (i[t(491)] / 1e3)), this[t(501)].isEnabled() && (e[t(536)].push({
              downloadedBytes: i[t(512)] || 0,
              downloadedChunks: i[t(496)] || 0,
              bandwidth: Math[t(508)](n || 0),
              instantBandwidth: Math.trunc(0),
              lastInstantBandwidth: Math[t(508)](0),
              peakBandwidth: Math[t(508)](0),
              failures: 0,
              totalFailures: 0,
              retries: 0,
              downloadTime: i[t(491)],
              provider: "P2P",
              profileName: t(459),
              isActive: this[t(501)][t(484)](),
              ptb: 0,
              usedOnce: s,
              hugeChunks: 0,
              firstHugeChunkSize: 0,
              lastChunksLapse: 0,
              maxBandwidth: 0,
              banned: !1,
              lastBandwidth: 0,
              scoringBandwidth: 0
            }), e[t(557)] = e.totalBandwidth + (i.downloadAvgBw || 0), e[t(480)] = e.totalDownloadedBytes + (i[t(512)] || 0)), e;
          }
        }, {
          key: _Ti13,
          value: function value() {
            this[Ti(484)] = !0;
          }
        }, {
          key: "disable",
          value: function disable() {
            this[Ti(484)] = !1;
          }
        }, {
          key: _Ti14,
          value: function value() {
            return this[Ti(484)];
          }
        }]);
        return bi;
      }(Ti(522), Ti(545), Ti(519), Ti(502), Ti(472), Ti(579), Ti(490), Ti(569), Ti(521), Ti(550), Ti(500), Ti(494), Ti(463), Ti(535));
      var Ai = _i;
      function wi() {
        var t = ["defaultChunkDownloadTimeout", "_accountCode", "CDNLoader", "P2P TIMEOUTERROR BY ME: ", "loadstart", "downloadedChunks", "rnpaw", "components", "sliceByFirstSpecial", "open", "decisionCallWaitTime", "status", "P2P READY FOR ", "GET", "responseURL", "destroy", "dispatchEvent", "loadStartEM", "getLoader", "simpleRequest", "interceptors", "byteLength", "allowSpecialDelimitersInUrl", "setInterceptedRequests", "throw", "Fetching segment via P2P for -> ", "Destroying CDN Balancer", "addInterceptor", "XHR-not-intercepted -> ", "url", " size -> ", " peer id -> ", "getIp", "P2P DISPATCH LOAD END", "29420CUZgQT", "isTheoplayer", "undefined", "split", "toFixed", "setRequestHeader", ".idx", "5294870Skbpsc", "abort", "92342lSnCdX", "next", "P2P Error on event ready state change", "ms timeout: ", "timeouts", ".mp4", ".m4s", "useP2P", "buffer", "connectTimeoutMilliseconds", "verbose", "resource", "getPeersNothing", "getActiveRequests", "search", "kb ", " downloaded through P2P. Size: ", "removeInterceptors", "isManifest", "Sending join to tracker due to new manifest", "segments-> (", "onAbort", "P2P", "loadend", ".lrc", "P2PLoader", "some", ".cap", "P2P DISPATCH READY STATE", "data", ".mpsub", "origRes", "onreadystatechange", "addEventListener", " peer version ", "isBitmovin", "P2P/SMB Traffic ", "segmentsMap", ".sbv", "__awaiter", "getStats", "updateP2PId", "toString", "setResourceInfo", "4810448ORxcoG", "pathname", "loadInterceptor", " PEER ID -> ", "size", "8876441ARqRhm", ".smi", ".dash", "apply", "join", "prototype", "29VCbljk", "provider", "headers", "6PbKhUf", "disable", " TIMEOUTS ", ".cea", "timeout", " byte length-> ", "getPeers", "send", "defineProperty", ".ttml", " UniqPeers: ", "reload", "realBodySize", "Error on request ", "downloadedBytes", "notice", ".dfxp", "statusText", "getVersion", "getUploadRequests", ".vtt", ".scc", "includes", "uploaded: (MB/#/%) ", "P2P Error on event load end", "load", "balancer", "now", "P2P Error on event load event", "responseType", "Fetching segment via CDN for -> ", "allResponseHeader", "loader", "progressEM", "readystatechange", "P2P Failure Update url on problems with p2p ", "params", "error", "P2P TIMEOUTERROR ", "useTheoplayer", "method", "lastDecisionTimestamp", ".sub", "stopMonitor", "getPeersAhead", "HTTP for -> ", "media", "cdns", "DONE", "Range", "startsWith", "retryBecauseNewHeaders", "getNewUrl", "readyState", "responseHeader", " TIME: ", "enable", "processSegment", "segment", "519SoAvvJ", "getBitmovinSendHttpRequest", "getSegment", "peer", "loadEndEM", "overrideMimeType", "getResponseHeader", "value", "request", "getAllResponseHeaders", "endsWith", "P2P DISPATCH LOAD ", ".ts", " segmnet p2p id -> ", "shift", "response", "ur: ", "p2pId", ".sami", "4383909vjYnYB", "debug", "loadCDNBalancerData", ".stl", ".m4f", " ip: ", "call", "options", "forceHttp", "setManifestResource", "isEnabled", " original -> ", "manifest", "isAsync", " peer id: ", "searchParams", "requestHeader", "set", "ifByteArrayToString", "resetP2PConnection", "5274790WGsqra", "openAndSend", "then", "length", "body", "getUploadedChunks", "getInstance", "arraybuffer"];
        return (wi = function wi() {
          return t;
        })();
      }
      !function (t, e) {
        var i = _i,
          s = t();
        for (;;) try {
          if (780375 == parseInt(i(303)) / 1 * (parseInt(i(248)) / 2) + parseInt(i(365)) / 3 * (parseInt(i(239)) / 4) + -parseInt(i(197)) / 5 * (-parseInt(i(306)) / 6) + -parseInt(i(297)) / 7 + -parseInt(i(292)) / 8 + -parseInt(i(384)) / 9 + -parseInt(i(246)) / 10) break;
          s.push(s.shift());
        } catch (t) {
          s.push(s.shift());
        }
      }(wi);
      function _i(t, e) {
        var i = wi();
        return (_i = function _i(t, e) {
          return i[t -= 190];
        })(t, e);
      }
      var Ii = /*#__PURE__*/function (_ref6, _Ai, _Ai2, _Ai3, _Ai4, _Ai5, _Ai6, _Ai7, _Ai8, _Ai9, _Ai10, _Ai11) {
        _inherits(Ii, _ref6);
        var _super5 = _createSuper(Ii);
        function Ii(t, e) {
          var _this51;
          _classCallCheck(this, Ii);
          var i = Ai;
          var s;
          if (_this51 = _super5.call(this), _this51[i(394)] = !0, _this51[i(205)] = 0, _this51[i(283)] = !1, _this51[i(240)] = !1, _this51[i(347)] = 0, _this51[i(206)] = t, _this51[i(391)] = new T(), _this51[i(338)] = new bi(_this51[i(206)], _this51.options), _this51[i(225)] = new y(_assertThisInitialized(_this51)), e && typeof (null === (s = e[i(212)]) || void 0 === s ? void 0 : s[i(332)]) !== i(241) && !e[i(212)].balancer) return _possibleConstructorReturn(_this51, (_this51[i(394)] = !1, _this51[i(338)][i(307)](), void _this51[i(338)][i(273)][i(307)]()));
          var o = _assertThisInitialized(_this51);
          _this51[i(360)] = XMLHttpRequest.prototype[i(371)], XMLHttpRequest[i(302)][i(371)] = function (t) {
            return o[i(360)].call(this, t);
          }, _this51[i(337)] = XMLHttpRequest.prototype.getAllResponseHeaders, XMLHttpRequest[i(302)][i(374)] = function () {
            var t = i;
            return o[t(337)][t(390)](this);
          }, _this51[i(247)] = XMLHttpRequest[i(302)][i(247)], XMLHttpRequest[i(302)][i(247)] = function () {
            var t = i,
              e = this[t(364)];
            o[t(223)]()[t(269)](this, e), o[t(247)][t(390)](this);
          }, _this51[i(370)] = XMLHttpRequest.prototype[i(370)], XMLHttpRequest.prototype[i(370)] = function (t) {
            var e = i;
            o[e(370)][e(390)](this, t);
          }, _this51[i(193)] = XMLHttpRequest[i(302)][i(244)], XMLHttpRequest[i(302)][i(244)] = function (t, e) {
            var _o$n;
            var n = i,
              r = this[n(364)];
            for (var _len6 = arguments.length, s = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
              s[_key6 - 2] = arguments[_key6];
            }
            r && (r[n(305)][t] = e, r[n(357)] = 0 == r[n(357)] ? 1 : r[n(357)]), (_o$n = o[n(193)])[n(390)].apply(_o$n, [this, t, e].concat(s));
          }, _this51[i(313)] = XMLHttpRequest[i(302)][i(313)], XMLHttpRequest.prototype[i(313)] = function (t) {
            for (var _len7 = arguments.length, e = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
              e[_key7 - 1] = arguments[_key7];
            }
            var i, s, d, c, u, l, h, p, f, g, m, v, y, T;
            return m = this, v = void 0, T = /*#__PURE__*/_regeneratorRuntime.mark(function T() {
              var _o$m, _o$m2;
              var m, v, _t82, _e68, _a13, _l6, _h6, _p3, _f2, _g4, _v, _i134, _y, _T, _S, _E, _b, _A4, _w2, _3, y, T, _t83, _e69, _i135, _s46, _t84, _i136, _s47, _a14;
              return _regeneratorRuntime.wrap(function T$(_context19) {
                while (1) switch (_context19.prev = _context19.next) {
                  case 0:
                    m = _i;
                    (!this[m(310)] || this[m(310)] > a._C[m(257)]) && this[m(190)] && (this[m(310)] = a._C[m(257)]);
                    v = this[m(364)];
                    if (!(!o.isEnabled || !v || v[m(266)])) {
                      _context19.next = 5;
                      break;
                    }
                    return _context19.abrupt("return", void (_o$m = o[m(313)])[m(390)].apply(_o$m, [this, t].concat(e)));
                  case 5:
                    if (!(1 == v.retryBecauseNewHeaders)) {
                      _context19.next = 7;
                      break;
                    }
                    return _context19.abrupt("return", (v[m(357)] = 2, v[m(289)](), void o[m(198)](this, v)));
                  case 7:
                    try {
                      _t82 = o[m(223)]()[m(288)]()[m(353)];
                      _e68 = 0, _a13 = 0, _l6 = 0, _h6 = 0, _p3 = 0, _f2 = 0, _g4 = (null === (i = o.getLoader()) || void 0 === i ? void 0 : i.P2PLoader.getUploadedBytes()) || 0;
                      _v = (null === (s = o[m(223)]()) || void 0 === s ? void 0 : s[m(273)][m(202)]()) || 0;
                      _g4 = _g4 / 1024 / 1024;
                      for (_i134 = 0; _i134 < _t82[m(200)]; _i134++) _t82[_i134][m(304)] === m(270) ? (_a13 += _t82[_i134].downloadedBytes, _h6 += _t82[_i134].downloadedChunks) : "STREBOOS" === _t82[_i134][m(304)] || "STREBOPX" === _t82[_i134].provider ? (_p3 += _t82[_i134].downloadedBytes, _f2 += _t82[_i134][m(210)]) : (_e68 += _t82[_i134][m(320)], _l6 += _t82[_i134][m(210)]);
                      _y = null === (d = o[m(223)]()) || void 0 === d ? void 0 : d.P2PLoader[m(325)](), _T = null === (c = o[m(223)]()) || void 0 === c ? void 0 : c.P2PLoader.getUploadRequestsFailed(), _S = null === (u = o.getLoader()) || void 0 === u ? void 0 : u[m(273)].getUploadedUniqPeers();
                      _E = 0, _b = 0, _A4 = 0;
                      try {
                        _E = _a13 / (_a13 + _e68 + _p3) * 100, _b = _p3 / (_a13 + _e68 + _p3) * 100, _A4 = _g4 / ((_a13 + _e68 + _p3) / 1024 / 1024) * 100;
                      } catch (t) {}
                      _w2 = o.getLoader()[m(273)][m(312)]()[m(296)] || 0, _3 = " (" + o[m(223)]()[m(273)].getPeersBehind() + "/" + o[m(223)]().P2PLoader[m(260)]() + "/" + o[m(223)]()[m(273)][m(350)]() + ") ";
                      n.default[m(258)](r.BalancerTag, m(284) + _E[m(243)](2) + "% " + _b.toFixed(2) + "%\nMB(CDN/SB/P2P) " + (_e68 / 1024 / 1024)[m(243)](2) + "/" + (_p3 / 1024 / 1024)[m(243)](2) + "/" + (_a13 / 1024 / 1024)[m(243)](2) + "\n" + m(268) + _l6 + "/" + _f2 + "/" + _h6 + ")\npeers: " + _w2 + _3 + "\n" + m(329) + _g4[m(243)](2) + "/" + _v + "/" + _A4.toFixed(2) + "\n" + m(381) + _y + "|" + _T + m(316) + _S);
                    } catch (t) {}
                    y = Date[m(333)]();
                    v[m(289)]();
                    T = o[m(338)][m(273)][m(367)](v);
                    if (!(v.cdnName !== m(270) || v[m(392)])) {
                      _context19.next = 15;
                      break;
                    }
                    n.default.verbose(r.BalancerTag, (v[m(392)] ? "FORCE" : "") + m(351) + v[m(279)]), o[m(223)]()[m(207)][m(261)]()[m(194)](v.id, v), n.default.notice(r.BalancerTag, m(336) + v[m(279)]), (_o$m2 = o[m(313)])[m(390)].apply(_o$m2, [this, t].concat(e));
                    _context19.next = 45;
                    break;
                  case 15:
                    _t83 = !1;
                    n.default[m(321)](r.BalancerTag, m(230) + v[m(279)]), v.forceHttp = !0, v[m(255)] = !1;
                    _e69 = null == T ? void 0 : T[m(277)], _i135 = T && (null == T ? void 0 : T[m(277)][m(226)]) > 0 && (null == _e69 ? void 0 : _e69[m(226)]) === (null == T ? void 0 : T[m(318)]) && (null == T ? void 0 : T[m(318)]) && (null == T ? void 0 : T.realBodySize) > 0, _s46 = 0;
                  case 18:
                    if (_i135) {
                      _context19.next = 28;
                      break;
                    }
                    _context19.next = 21;
                    return new Promise(function (t) {
                      return setTimeout(t, 20);
                    });
                  case 21:
                    T = o.loader[m(273)][m(367)](v);
                    _e69 = null == T ? void 0 : T[m(277)];
                    _s46 = (null == _e69 ? void 0 : _e69[m(226)]) || 0;
                    _i135 = T && (null == T ? void 0 : T[m(318)]) > 0 && (null == T ? void 0 : T.data[m(226)]) > 0 && (null == _e69 ? void 0 : _e69[m(226)]) === (null == T ? void 0 : T[m(318)]) && null != (null == T ? void 0 : T[m(318)]);
                    Date.now() - y > a.LI[m(310)] ? (_i135 = !0, _e69 = void 0, _t83 = !0, n.default.verbose(r.BalancerTag, m(208) + o[m(338)][m(273)].getId() + m(361) + (Date[m(333)]() - y) + m(191) + v[m(368)].id + " peer version: " + v[m(368)][m(324)]() + m(389) + v.peer[m(237)]() + " " + _s46 / ((null == T ? void 0 : T.realBodySize) || 1) * 100 + "%")) : Date[m(333)]() - y > 2e3 && (null == T || null == T.data || _s46 < 20) && (_i135 = !0, _e69 = void 0, _t83 = !0, n.default.verbose(r.BalancerTag, "P2P TIMEOUTERROR BY NO DATA ME:" + o.loader[m(273)].getId() + " " + (Date[m(333)]() - y > 2e3) + m(191) + v[m(368)].id + " peer version: " + v.peer.getVersion() + m(389) + v[m(368)][m(237)]() + " last length -> " + _s46));
                  case 26:
                    _context19.next = 18;
                    break;
                  case 28:
                    if (!(_e69 && (_e69 = _e69.slice(0, _e69[m(226)])), _t83 && (v[m(368)] && (v[m(368)][m(252)] = v[m(368)].timeouts + 1), n.default[m(258)](r.BalancerTag, m(344) + v[m(279)] + " " + v.id + " " + (null === (l = null == T ? void 0 : T.data) || void 0 === l ? void 0 : l.byteLength) + " " + (null == T ? void 0 : T[m(318)]) + m(295) + (null === (h = v[m(368)]) || void 0 === h ? void 0 : h.id) + m(308) + v[m(368)][m(252)])), n.default[m(258)](r.BalancerTag, m(217) + v[m(279)] + " " + (null == _e69 ? void 0 : _e69.byteLength) + " " + (null == T ? void 0 : T[m(318)]) + m(236) + v.peer.id + m(378) + v[m(382)]), T = o[m(338)][m(273)][m(367)](v), _e69 && (null === (p = null == T ? void 0 : T[m(277)]) || void 0 === p ? void 0 : p.byteLength) == (null == T ? void 0 : T[m(318)]) && null != (null == T ? void 0 : T[m(318)]) && (null == T ? void 0 : T[m(318)]) > 0)) {
                      _context19.next = 44;
                      break;
                    }
                    n.default[m(321)](r.BalancerTag, v[m(279)] + m(264) + ((null === (f = null == T ? void 0 : T.data) || void 0 === f ? void 0 : f[m(226)]) / 1048576)[m(243)](2) + "MB"), _e69 instanceof Uint8Array && (_e69 = _e69[m(256)]);
                    _t84 = new CustomEvent(m(340)), _i136 = new CustomEvent(m(271)), _s47 = new CustomEvent(m(331)), _a14 = new CustomEvent("loadstart");
                    Object[m(314)](this, m(380), {
                      writable: !0
                    }), Object[m(314)](this, m(216), {
                      writable: !0
                    }), Object[m(314)](this, m(323), {
                      writable: !0
                    }), Object.defineProperty(this, m(359), {
                      writable: !0
                    }), Object[m(314)](this, m(226), {
                      writable: !0
                    }), Object.defineProperty(this, m(219), {
                      writable: !0
                    }), Object.defineProperty(this, m(335), {
                      writable: !0
                    }), this[m(226)] = _e69.byteLength, this[m(380)] = _e69, this.status = 200, this[m(323)] = "OK", this[m(359)] = XMLHttpRequest[m(354)], this[m(219)] = v[m(279)], this[m(335)] = m(204), n.default.verbose(r.BalancerTag, "P2P DISPATCH LOAD START");
                    try {
                      this[m(221)](_a14);
                    } catch (t) {
                      n.default[m(258)](r.BalancerTag, "P2P Error on event load start");
                    }
                    _context19.next = 35;
                    return new Promise(function (t) {
                      return setTimeout(t, 6);
                    });
                  case 35:
                    n.default[m(258)](r.BalancerTag, m(276));
                    try {
                      this[m(221)](_t84);
                    } catch (t) {
                      n.default[m(258)](r.BalancerTag, m(250));
                    }
                    n.default[m(258)](r.BalancerTag, m(376));
                    try {
                      this.dispatchEvent(_s47);
                    } catch (t) {
                      n.default[m(258)](r.BalancerTag, m(334));
                    }
                    n.default[m(258)](r.BalancerTag, m(238));
                    try {
                      this[m(221)](_i136);
                    } catch (t) {
                      n.default[m(258)](r.BalancerTag, m(330));
                    }
                    n.default[m(258)](r.BalancerTag, "P2P2 Download done -> " + (Date.now() - y) + "ms id:" + v[m(382)] + m(235) + _e69.byteLength / 1024 + m(263) + v[m(279)] + m(282) + v[m(368)][m(324)]() + m(389) + v.peer[m(237)]());
                    _context19.next = 45;
                    break;
                  case 44:
                    n.default[m(258)](r.BalancerTag, m(341) + (Date[m(333)]() - y) + m(251) + a.LI[m(310)] + m(311) + (null === (g = null == T ? void 0 : T.data) || void 0 === g ? void 0 : g[m(226)]) + " real size-> " + (null == T ? void 0 : T.realBodySize) + m(395) + v.origRes), v.forceHttp = !0, o[m(223)]().CDNLoader.getActiveRequests()[m(194)](v.id, v), o[m(223)]()[m(207)].updateUrl(v), o[m(198)](this, v);
                  case 45:
                  case "end":
                    return _context19.stop();
                }
              }, T, this);
            }), new ((y = void 0) || (y = Promise))(function (t, e) {
              var i = _i;
              function s(t) {
                var i = _i;
                try {
                  r(T[i(249)](t));
                } catch (t) {
                  e(t);
                }
              }
              function n(t) {
                var i = _i;
                try {
                  r(T[i(229)](t));
                } catch (t) {
                  e(t);
                }
              }
              function r(e) {
                var i = _i;
                var r;
                e.done ? t(e[i(372)]) : (r = e.value, r instanceof y ? r : new y(function (t) {
                  t(r);
                }))[i(199)](s, n);
              }
              r((T = T[i(300)](m, v || []))[i(249)]());
            });
          }, _this51[i(214)] = XMLHttpRequest[i(302)][i(214)], XMLHttpRequest[i(302)][i(214)] = function (t, e) {
            var _o$d,
              _this52 = this,
              _o$d2;
            var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
            var d = i;
            for (var _len8 = arguments.length, a = new Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
              a[_key8 - 3] = arguments[_key8];
            }
            if (this.isAsync = s, !o[d(394)]) return (_o$d = o[d(214)])[d(390)].apply(_o$d, [this, t, e, s].concat(a));
            var u = e;
            var l = u[d(242)]("?");
            if (u = c[d(213)](u, o[d(391)][d(227)]), null == this[d(364)] && Object[d(314)](this, d(364), {
              writable: !0
            }), e[d(328)]("&rnpaw=") || e[d(328)]("?rnpaw=")) {
              var _t85 = new URL(e),
                _i137 = _t85[d(192)];
              _i137.delete(d(211)), _t85[d(262)] = _i137[d(290)](), e = _t85[d(290)]();
            } else if (t === d(218) && (u.endsWith(d(299)) || u[d(375)](d(253)) || u[d(375)](d(377)) || u[d(375)](d(254)) || u[d(375)](d(388)) || u[d(375)](".mpd") || u[d(375)](".m3u8"))) {
              var _o$open;
              var _e70;
              l[d(200)] > 1 && (_e70 = l[1]);
              var _i138 = this[d(364)];
              null == _i138 && (_i138 = o.simpleRequest(l[0], _e70, {})), null == this[d(364)] && (this[d(364)] = _i138), this[d(281)](d(331), function (t) {
                var e = d;
                o[e(223)]()[e(222)](this, _i138, t);
              }), this[d(281)](d(209), function (t) {
                o[d(223)]().loadStartEM(this, _i138, t);
              });
              var _n31 = this[d(280)],
                _r12 = function _r12(t) {
                  var e = d;
                  null == _n31 || _n31[e(390)](_this52, t), o[e(223)]().readyStateChangeEM(_this52, _i138, o);
                };
              return o[d(283)] || o.isTheoplayer ? this[d(280)] = _r12 : this.addEventListener(d(340), _r12), this.addEventListener("progress", function (t) {
                var e = d;
                o[e(223)]()[e(339)](this, _i138, t);
              }), this.addEventListener(d(271), function (t) {
                var e = d;
                o[e(223)]()[e(369)](this, _i138, t);
              }), this[d(281)](d(343), function (t) {}), (_o$open = o.open)[d(390)].apply(_o$open, [this, t, _i138[d(358)](), s].concat(a));
            }
            return n.default.debug(r.BalancerTag, d(233) + e), (_o$d2 = o[d(214)])[d(390)].apply(_o$d2, [this, t, e, s].concat(a));
          };
          return _possibleConstructorReturn(_this51);
        }
        _createClass(Ii, [{
          key: _Ai,
          value: function value() {
            var t = Ai;
            n.default.debug(r.BalancerTag, t(231)), ot.getInstance()[t(349)](), this[t(338)][t(273)].destroy(), this[t(394)] && (XMLHttpRequest.prototype[t(371)] = this[t(360)], XMLHttpRequest.prototype[t(374)] = this[t(337)], XMLHttpRequest[t(302)][t(247)] = this[t(247)], XMLHttpRequest.prototype[t(370)] = this[t(370)], XMLHttpRequest[t(302)][t(244)] = this[t(193)], XMLHttpRequest[t(302)].send = this[t(313)], XMLHttpRequest.prototype[t(214)] = this.open), this[t(225)][t(265)]();
          }
        }, {
          key: "getAccountCode",
          value: function getAccountCode() {
            return this[Ai(206)];
          }
        }, {
          key: "setOptions",
          value: function setOptions(t) {
            var e = Ai;
            for (var _i139 in t) this[e(391)][_i139] = t[_i139];
            this[e(338)] = new bi(this[e(206)], this[e(391)]);
          }
        }, {
          key: "openAndSend",
          value: function openAndSend(t, e) {
            var i = Ai;
            var s;
            try {
              t[i(214)](i(218), e[i(358)]()), (null === (s = e[i(305)]) || void 0 === s ? void 0 : s.Range) && t[i(244)](i(355), e[i(305)][i(355)]), t[i(313)]();
            } catch (t) {
              n.default[i(385)](r.BalancerTag, i(319) + e[i(358)]());
            }
          }
        }, {
          key: _Ai2,
          value: function value(t, e, i, s, n, r, a) {
            var o = Ai;
            this[o(338)][o(363)](t, !0, i, s, n, r, a);
          }
        }, {
          key: _Ai3,
          value: function value(t) {
            var e = Ai,
              i = Date.now() - this[e(347)];
            t && (this[e(391)].resource !== t || i > a.df[e(215)]) && (this[e(391)].resource = t, this[e(338)] && this[e(338)][e(273)] && this.loader[e(273)][e(394)]() && (n.default[e(385)](r.BalancerTag, e(267)), this.loader[e(273)].sendJoin()), !this[e(338)] && (this[e(338)] = new bi(this[e(206)], this[e(391)])), this[e(338)][e(207)][e(291)](t), this[e(338)][e(386)](), this[e(347)] = Date[e(333)]());
          }
        }, {
          key: "getLoader",
          value: function getLoader() {
            return this[Ai(338)];
          }
        }, {
          key: _Ai4,
          value: function value(t, e) {
            var i = Ai;
            this[i(225)][i(294)](t, e);
          }
        }, {
          key: "getRecommendedManifest",
          value: function getRecommendedManifest() {
            return this[Ai(338)].CDNLoader.getRecommendedManifest();
          }
        }, {
          key: _Ai5,
          value: function value() {
            this[Ai(240)] = !0;
          }
        }, {
          key: _Ai6,
          value: function value() {
            var t = Ai;
            this[t(283)] = !0;
            var e = this;
            return function (i, s) {
              var n = t;
              return void 0 === i || !i[n(356)](n(352)) && !i[n(356)](n(396)) ? null : {
                getResponse: function getResponse() {
                  return new Promise(function (t) {
                    var i = _i,
                      n = new XMLHttpRequest();
                    n.responseType = i(204), n[i(280)] = function (r) {
                      var a = i;
                      if (4 === n.readyState) {
                        var _i140 = {
                          request: s,
                          url: s[a(234)],
                          headers: [],
                          status: n[a(216)],
                          statusText: n[a(323)],
                          body: void 0
                        };
                        if (n.status >= 200 && n[a(216)] < 400) {
                          new URL(s[a(234)])[a(293)];
                          var _r13 = [".m3u8", ".mpd"],
                            _o20 = [".srt", a(286), a(348), a(278), a(272), a(275), a(298), a(383), ".rt", a(326), a(315), a(322), a(327), a(387), ".asc", a(309), a(245)],
                            _d8 = c.sliceByFirstSpecial(s[a(234)], e[a(391)][a(227)]);
                          _r13[a(274)](function (t) {
                            return _d8[a(375)](t);
                          }) || _o20[a(274)](function (t) {
                            return _d8[a(375)](t);
                          }) ? _i140[a(201)] = c[a(195)](n[a(380)]) : _i140[a(201)] = n[a(380)];
                          var _u5 = n[a(374)]().trim().split(/[\r\n]+/).map(function (t) {
                            var e = a,
                              i = t[e(242)](": ");
                            return {
                              name: i[e(379)](),
                              value: i[e(301)](": ")
                            };
                          });
                          _i140[a(305)] = _u5, t(_i140);
                        } else t(_i140);
                      }
                    }, n.open(s[i(346)], s[i(234)]);
                    for (var _t86 in s[i(305)]) n[i(244)](_t86, s[i(305)][_t86]);
                    n.send(null == s ? void 0 : s[i(201)]);
                  });
                },
                cancel: function cancel() {},
                setProgressListener: function setProgressListener() {}
              };
            };
          }
        }, {
          key: _Ai7,
          value: function value() {
            var t = Ai;
            this.loader.P2PLoader[t(196)](), this[t(391)][t(259)] = void 0;
          }
        }, {
          key: _Ai8,
          value: function value(t, e, i) {
            var s = Ai;
            M.default[s(203)]()[s(228)](!0);
            var n = new URL(t),
              r = this[s(338)][s(363)](n, !1, [], i);
            r[s(342)] = e;
            var a = (null == i ? void 0 : i[s(355)]) || "";
            return this[s(338)][s(285)].set(r.getNewUrl() + a, n[s(290)]()), r;
          }
        }, {
          key: _Ai9,
          value: function value() {
            var t = Ai;
            this[t(394)] = !0, this[t(338)][t(362)](), this[t(338)][t(273)][t(362)]();
          }
        }, {
          key: _Ai10,
          value: function value() {
            var t = Ai;
            this[t(394)] = !1, this[t(338)][t(307)](), this.loader[t(273)][t(307)]();
          }
        }, {
          key: "getIsEnabled",
          value: function getIsEnabled() {
            return this[Ai(394)];
          }
        }, {
          key: _Ai11,
          value: function value(t) {
            var e = Ai;
            null != t && (this[e(391)] = new T(t)), this[e(338)][e(273)][e(220)](), this.loader = new bi(this._accountCode, this[e(391)]), this[e(394)] = !0;
          }
        }]);
        return Ii;
      }(_, Ai(220), Ai(373), Ai(393), Ai(232), Ai(345), Ai(366), Ai(196), Ai(224), Ai(362), Ai(307), Ai(317));
      var Ni = i(6014),
        Pi = i.n(Ni),
        Di = i(2507),
        Ri = i.n(Di),
        Li = i(4954),
        Ci = i.n(Li),
        Oi = i(3782),
        Bi = i.n(Oi),
        xi = i(7061),
        Mi = i.n(xi),
        ki = i(2071),
        Ui = i.n(ki);
      var Vi = /*#__PURE__*/function () {
        function Vi(t, e, i, s, n) {
          _classCallCheck(this, Vi);
          this.method = r.Method.GET, this.service = t, this.params = e || {}, this.body = i, this.onSuccessCallback = s, this.onFailCallback = n;
        }
        _createClass(Vi, [{
          key: "getService",
          value: function getService() {
            return this.service;
          }
        }, {
          key: "getMethod",
          value: function getMethod() {
            return this.method;
          }
        }, {
          key: "setMethod",
          value: function setMethod(t) {
            this.method = t;
          }
        }, {
          key: "getParams",
          value: function getParams() {
            return this.params;
          }
        }, {
          key: "getOnSuccess",
          value: function getOnSuccess() {
            return this.onSuccessCallback;
          }
        }, {
          key: "getOnFail",
          value: function getOnFail() {
            return this.onFailCallback;
          }
        }, {
          key: "getParam",
          value: function getParam(t) {
            return this.params[t];
          }
        }, {
          key: "setParam",
          value: function setParam(t, e) {
            return this.params[t] = e, this;
          }
        }, {
          key: "setParams",
          value: function setParams(t) {
            this.params = t;
          }
        }, {
          key: "getBody",
          value: function getBody() {
            return this.body;
          }
        }, {
          key: "setBody",
          value: function setBody(t) {
            this.body = t;
          }
        }, {
          key: "isPost",
          value: function isPost() {
            return this.method === r.Method.POST;
          }
        }]);
        return Vi;
      }();
      var qi = i(108);
      var Fi = /*#__PURE__*/function () {
        function Fi() {
          _classCallCheck(this, Fi);
          this.readyToSend = !1, this.servicesToWait = [qi.A.Service.SESSION_START], this.onWillSendAnalyticsRequestListeners = [], this._requests = [], this._waitingForToken = [];
        }
        _createClass(Fi, [{
          key: "destroy",
          value: function destroy() {
            this._requests = [], this._waitingForToken = [], this.readyToSend = !1;
          }
        }, {
          key: "shouldSendStats",
          value: function shouldSendStats() {
            return this.readyToSend;
          }
        }, {
          key: "sendRequest",
          value: function sendRequest(t) {
            var _this53 = this,
              _this$_requests2;
            if ("" === e.default.getInstance().getFastDataSessionToken()) return void this._waitingForToken.push(t);
            this._waitingForToken.forEach(function (t) {
              return _this53.prepareParams(t);
            }), (_this$_requests2 = this._requests).push.apply(_this$_requests2, _toConsumableArray(this._waitingForToken)), this._waitingForToken = [];
            var i = t.getParams(),
              s = t.getService();
            var n = this.onWillSendAnalyticsRequestListeners;
            var _iterator42 = _createForOfIteratorHelper(n),
              _step42;
            try {
              for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                var _t87 = _step42.value;
                _t87(s, i);
              }
            } catch (err) {
              _iterator42.e(err);
            } finally {
              _iterator42.f();
            }
            this.prepareParams(t), this._requests.push(t), this._processRequests();
          }
        }, {
          key: "prepareParams",
          value: function prepareParams(t) {
            var i = t.getService();
            t.setParam("sessionId", t.getParam("sessionId") || e.default.getInstance().getFastDataSessionToken()), i == qi.A.Service.SESSION_START && t.setParam("beatTime", t.getParam("beatTime") || e.default.getInstance().getFastDataService().getBeatTime());
          }
        }, {
          key: "buildRequest",
          value: function buildRequest(t, e, i, s, n, a) {
            i = i || r.Method.GET;
            var o = new Vi(t, e, s, n, a);
            return o.setMethod(i), o;
          }
        }, {
          key: "_processRequests",
          value: function _processRequests() {
            var _this$_requests3;
            var t = this._requests;
            this._requests = [];
            var i = [];
            for (; t.length;) {
              var _s48 = t.shift();
              if (-1 !== this.servicesToWait.indexOf(_s48.getService()) && (this.readyToSend = !0), this.readyToSend) for (e.default.getInstance().pushData(e.default.getInstance().getOptions().offline ? ct.default.Consumer.BLACK_HOLE : ct.default.Consumer.NQS, _s48.getService(), _s48.getMethod(), _s48.getParams(), _s48.getOnSuccess(), _s48.getOnFail()); i.length;) {
                var _t88 = i.shift();
                e.default.getInstance().pushData(e.default.getInstance().getOptions().offline ? ct.default.Consumer.BLACK_HOLE : ct.default.Consumer.NQS, _t88.getService(), _t88.getMethod(), _t88.getParams(), _t88.getOnSuccess(), _t88.getOnFail());
              } else i.push(_s48);
            }
            (_this$_requests3 = this._requests).push.apply(_this$_requests3, i);
          }
        }]);
        return Fi;
      }();
      var Xi = i(9637),
        Hi = i.n(Xi),
        Gi = i(1577),
        ji = i(9835),
        Wi = i.n(ji),
        Yi = i(5804),
        zi = i.n(Yi);
      var Ki = /*#__PURE__*/function () {
        function Ki(t) {
          _classCallCheck(this, Ki);
          this.options = t;
        }
        _createClass(Ki, [{
          key: "getUsername",
          value: function getUsername() {
            return this.options["user.name"];
          }
        }, {
          key: "getPluginVersion",
          value: function getPluginVersion() {
            return e.default.getPluginVersion();
          }
        }, {
          key: "getRequestNumber",
          value: function getRequestNumber() {
            return Math.random();
          }
        }, {
          key: "getUserType",
          value: function getUserType() {
            return this.options["user.type"];
          }
        }, {
          key: "getAnonymousUser",
          value: function getAnonymousUser() {
            return this.options["user.anonymousId"];
          }
        }, {
          key: "getReferer",
          value: function getReferer() {
            var t = this.options.referer || "";
            return !t && "undefined" != typeof window && window.location && (t = window.location.href), t;
          }
        }, {
          key: "getReferral",
          value: function getReferral() {
            var t = this.options.referral || "";
            return t || "undefined" == typeof document || (t = document.referrer), t;
          }
        }, {
          key: "getPageName",
          value: function getPageName() {
            var t = this.options.title || "";
            return t || "undefined" == typeof document || (t = document.title), t;
          }
        }, {
          key: "getLanguage",
          value: function getLanguage() {
            return "undefined" != typeof navigator ? navigator.language : void 0;
          }
        }, {
          key: "getScreenResolution",
          value: function getScreenResolution() {
            var t;
            try {
              if (window && window.screen) {
                var _e71 = window.devicePixelRatio || 1;
                t = window.screen.width * _e71 + "x" + window.screen.height * _e71;
              }
            } catch (t) {}
            return t;
          }
        }, {
          key: "getDeviceInfo",
          value: function getDeviceInfo() {
            var t = {};
            return this.getDeviceCode() && (t.deviceCode = this.getDeviceCode()), this.getModel() && (t.model = this.getModel()), this.getBrand() && (t.brand = this.getBrand()), this.getDeviceType() && (t.deviceType = this.getDeviceType()), this.getDeviceName() && (t.deviceName = this.getDeviceName()), this.getOsName() && (t.osName = this.getOsName()), this.getOsVersion() && (t.osVersion = this.getOsVersion()), this.getBrowserName() && (t.browserName = this.getBrowserName()), this.getBrowserVersion() && (t.browserVersion = this.getBrowserVersion()), this.getBrowserType() && (t.browserType = this.getBrowserType()), this.getBrowserEngine() && (t.browserEngine = this.getBrowserEngine()), 0 !== Object.keys(t).length ? t : void 0;
          }
        }, {
          key: "getDeviceCode",
          value: function getDeviceCode() {
            return this.options["device.code"];
          }
        }, {
          key: "getModel",
          value: function getModel() {
            return this.options["device.model"];
          }
        }, {
          key: "getBrand",
          value: function getBrand() {
            return this.options["device.brand"];
          }
        }, {
          key: "getDeviceType",
          value: function getDeviceType() {
            return this.options["device.type"];
          }
        }, {
          key: "getDeviceName",
          value: function getDeviceName() {
            return this.options["device.name"];
          }
        }, {
          key: "getOsName",
          value: function getOsName() {
            return this.options["device.osName"];
          }
        }, {
          key: "getOsVersion",
          value: function getOsVersion() {
            return this.options["device.osVersion"];
          }
        }, {
          key: "getBrowserName",
          value: function getBrowserName() {
            return this.options["device.browserName"];
          }
        }, {
          key: "getBrowserVersion",
          value: function getBrowserVersion() {
            return this.options["device.browserVersion"];
          }
        }, {
          key: "getBrowserType",
          value: function getBrowserType() {
            return this.options["device.browserType"];
          }
        }, {
          key: "getBrowserEngine",
          value: function getBrowserEngine() {
            return this.options["device.browserEngine"];
          }
        }, {
          key: "getIsBlocked",
          value: function getIsBlocked() {
            return this.options["ad.blockerDetected"];
          }
        }, {
          key: "isMethodPostEnabled",
          value: function isMethodPostEnabled() {
            return this.options.method && this.options.method.toUpperCase() === Hi().POST;
          }
        }, {
          key: "getDeviceUUID",
          value: function getDeviceUUID() {
            var t;
            return this.options["device.isAnonymous"] || (t = this.options["device.id"] || new (zi())().getKey()), t;
          }
        }, {
          key: "getLibVersion",
          value: function getLibVersion() {
            return Wi();
          }
        }, {
          key: "getAppName",
          value: function getAppName() {
            return this.options["app.name"];
          }
        }, {
          key: "getAppReleaseVersion",
          value: function getAppReleaseVersion() {
            return this.options["app.releaseVersion"];
          }
        }, {
          key: "getIp",
          value: function getIp() {
            return this.options["network.ip"];
          }
        }, {
          key: "getIsp",
          value: function getIsp() {
            return this.options["network.isp"];
          }
        }, {
          key: "getConnectionType",
          value: function getConnectionType() {
            return this.options["network.connectionType"];
          }
        }, {
          key: "getEDID",
          value: function getEDID() {
            var t = this.options["device.EDID"];
            return t ? t.toString() : void 0;
          }
        }, {
          key: "getObfuscateIp",
          value: function getObfuscateIp() {
            return this.options["user.obfuscateIp"];
          }
        }, {
          key: "getPrivacyProtocol",
          value: function getPrivacyProtocol() {
            var t = this.options["user.privacyProtocol"];
            return "string" == typeof t && (t = t.toLowerCase()), "optin" === t || "optout" === t ? t : void 0;
          }
        }, {
          key: "getCustomDimensions",
          value: function getCustomDimensions() {
            var t = this.options["content.customDimensions"];
            return "object" == typeof t ? t : void 0;
          }
        }, {
          key: "getExtraparam1",
          value: function getExtraparam1() {
            return this.options["content.customDimension.1"];
          }
        }, {
          key: "getExtraparam2",
          value: function getExtraparam2() {
            return this.options["content.customDimension.2"];
          }
        }, {
          key: "getExtraparam3",
          value: function getExtraparam3() {
            return this.options["content.customDimension.3"];
          }
        }, {
          key: "getExtraparam4",
          value: function getExtraparam4() {
            return this.options["content.customDimension.4"];
          }
        }, {
          key: "getExtraparam5",
          value: function getExtraparam5() {
            return this.options["content.customDimension.5"];
          }
        }, {
          key: "getExtraparam6",
          value: function getExtraparam6() {
            return this.options["content.customDimension.6"];
          }
        }, {
          key: "getExtraparam7",
          value: function getExtraparam7() {
            return this.options["content.customDimension.7"];
          }
        }, {
          key: "getExtraparam8",
          value: function getExtraparam8() {
            return this.options["content.customDimension.8"];
          }
        }, {
          key: "getExtraparam9",
          value: function getExtraparam9() {
            return this.options["content.customDimension.9"];
          }
        }, {
          key: "getExtraparam10",
          value: function getExtraparam10() {
            return this.options["content.customDimension.10"];
          }
        }, {
          key: "getExtraparam11",
          value: function getExtraparam11() {
            return this.options["content.customDimension.11"];
          }
        }, {
          key: "getExtraparam12",
          value: function getExtraparam12() {
            return this.options["content.customDimension.12"];
          }
        }, {
          key: "getExtraparam13",
          value: function getExtraparam13() {
            return this.options["content.customDimension.13"];
          }
        }, {
          key: "getExtraparam14",
          value: function getExtraparam14() {
            return this.options["content.customDimension.14"];
          }
        }, {
          key: "getExtraparam15",
          value: function getExtraparam15() {
            return this.options["content.customDimension.15"];
          }
        }, {
          key: "getExtraparam16",
          value: function getExtraparam16() {
            return this.options["content.customDimension.16"];
          }
        }, {
          key: "getExtraparam17",
          value: function getExtraparam17() {
            return this.options["content.customDimension.17"];
          }
        }, {
          key: "getExtraparam18",
          value: function getExtraparam18() {
            return this.options["content.customDimension.18"];
          }
        }, {
          key: "getExtraparam19",
          value: function getExtraparam19() {
            return this.options["content.customDimension.19"];
          }
        }, {
          key: "getExtraparam20",
          value: function getExtraparam20() {
            return this.options["content.customDimension.20"];
          }
        }, {
          key: "isParseManifest",
          value: function isParseManifest() {
            return this.options["parse.manifest"];
          }
        }, {
          key: "isParseCdnNode",
          value: function isParseCdnNode() {
            return this.options["parse.cdnNode"];
          }
        }, {
          key: "isCdnSwitch",
          value: function isCdnSwitch() {
            return this.options["parse.cdnSwitchHeader"];
          }
        }, {
          key: "getParseCdnNodeList",
          value: function getParseCdnNodeList() {
            return this.options["parse.cdnNode.list"];
          }
        }, {
          key: "getParseCdnNodeNameHeader",
          value: function getParseCdnNodeNameHeader() {
            return this.options["parse.cdnNameHeader"];
          }
        }, {
          key: "getParseNodeHeader",
          value: function getParseNodeHeader() {
            return this.options["parse.cdnNodeHeader"];
          }
        }, {
          key: "canOverwriteAdapters",
          value: function canOverwriteAdapters() {
            return Gi.default.parseBoolean(this.options["adapters.overwrite"]);
          }
        }, {
          key: "getAdaptersProperties",
          value: function getAdaptersProperties() {
            return this.options["adapters.properties"];
          }
        }, {
          key: "isAppAnalyticsAutoBegin",
          value: function isAppAnalyticsAutoBegin() {
            return Gi.default.parseBoolean(this.options["check.appAnalytics.autoBegin"]);
          }
        }, {
          key: "isAppAnalyticsEnabled",
          value: function isAppAnalyticsEnabled() {
            return Gi.default.parseBoolean(this.options["check.appAnalytics.enabled"]);
          }
        }, {
          key: "isVideoAnalyticsEnabled",
          value: function isVideoAnalyticsEnabled() {
            return Gi.default.parseBoolean(this.options["check.videoAnalytics.enabled"]);
          }
        }, {
          key: "isRefreshLMAConfigurationEnabled",
          value: function isRefreshLMAConfigurationEnabled() {
            return Gi.default.parseBoolean(this.options["lma.refresh.configuration.enabled"]);
          }
        }, {
          key: "isPluginLogsEnabled",
          value: function isPluginLogsEnabled() {
            return Gi.default.parseBoolean(this.options["debug.pluginLogs.enabled"]);
          }
        }, {
          key: "isPlayerLogsEnabled",
          value: function isPlayerLogsEnabled() {
            return Gi.default.parseBoolean(this.options["debug.playerLogs.enabled"]);
          }
        }, {
          key: "refreshLMAConfigurationSeconds",
          value: function refreshLMAConfigurationSeconds() {
            return this.options["lma.refresh.configuration.seconds"];
          }
        }, {
          key: "getPlayheadMonitorEnabled",
          value: function getPlayheadMonitorEnabled() {
            return this.options["playhead.monitor"];
          }
        }, {
          key: "getReadyStateMonitorEnabled",
          value: function getReadyStateMonitorEnabled() {
            return this.options["readyState.monitor"];
          }
        }]);
        return Ki;
      }();
      var Qi = /*#__PURE__*/function () {
        function Qi(t) {
          _classCallCheck(this, Qi);
          this.options = new (Mi())(), this.core = e.default.getInstance(), this.coreStorage = this.core.getCoreStorage(), this.analyticsRequestHandler = new Fi(), this.accountCode = t, this.requestBuilder = new (Ui())(), this._beat = new (Ci())(this._sendBeat.bind(this), 3e4), this.sessionExpire = this.coreStorage.getSessionExpire() || 18e4, this.appAnalyticsStarted = !1, this.appAnalyticsStopped = !1, this._lastNavigation = {
            page: "",
            route: ""
          }, this._registeredProperties = null;
        }
        _createClass(Qi, [{
          key: "destroy",
          value: function destroy() {
            this._beat.stop(), this.analyticsRequestHandler.destroy();
          }
        }, {
          key: "setOptions",
          value: function setOptions(t) {
            this.options = t;
          }
        }, {
          key: "getOptions",
          value: function getOptions() {
            return this.options;
          }
        }, {
          key: "begin",
          value: function begin() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.core.isUsingLegacy() || (this.appAnalyticsStarted || (this._logBeginEvent(t), this._registeredProperties = this.coreStorage.getAppAnalyticsRegisteredProperties()), this.fireSessionStart(t));
          }
        }, {
          key: "newSession",
          value: function newSession(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            this.core.isUsingLegacy() || (this._logFireNewSessionListener(null != t ? t : {}, e), (this.appAnalyticsStarted || this.appAnalyticsStopped) && this.endSession(), t && this.setOptions(t), this.begin(e));
          }
        }, {
          key: "endSession",
          value: function endSession() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.core.isUsingLegacy() || this.appAnalyticsStarted && this.fireSessionStop(t);
          }
        }, {
          key: "_setLastActive",
          value: function _setLastActive() {
            this._firstActive || (this._firstActive = this.getFirstActive()), this.coreStorage.setLastActive(new Date().getTime().toString());
          }
        }, {
          key: "getAccountCode",
          value: function getAccountCode() {
            return this.accountCode;
          }
        }, {
          key: "getFirstActive",
          value: function getFirstActive() {
            return this.coreStorage.getLastActive() || 0;
          }
        }, {
          key: "getIsDataExpired",
          value: function getIsDataExpired() {
            var t = new Date().getTime();
            return !this.coreStorage.isEnabled() || !this.coreStorage.getStoredData() || this.getFirstActive() < t - this.sessionExpire;
          }
        }, {
          key: "fireSessionStart",
          value: function fireSessionStart() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.core.isUsingLegacy() || (this._logFireSessionStartEvent(t), this.appAnalyticsStopped && (this.core.refreshSessionToken(), this.appAnalyticsStopped = !1), this.appAnalyticsStarted || (this.coreStorage.setAppAnalyticsStarted(!0), this.appAnalyticsStarted = !0, this._processSessionStart(this._getParamsJson(t, null, null, !0, !0)), this._setLastActive()));
          }
        }, {
          key: "fireSessionStop",
          value: function fireSessionStop() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.core.isUsingLegacy() || (this._logFireSessionStopEvent(t), this.appAnalyticsStarted && (this.appAnalyticsStopped = !0, this.appAnalyticsStarted = !1, this.coreStorage.removeAppAnalyticsStarted(), this._processSessionStop(t), this.coreStorage.removeStoredData(), this.coreStorage.removeSession(), this.coreStorage.removeLastActive(), this.core.refreshSessionToken()));
          }
        }, {
          key: "fireNav",
          value: function fireNav() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.core.isUsingLegacy() || (this._logFireNavListener(t), this.isActive() && (this.appAnalyticsStarted = !0, this._processNavigation(this._getParamsJson(t, null, null, !0))));
          }
        }, {
          key: "fireEvent",
          value: function fireEvent() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            if (!this.core.isUsingLegacy() && (this._logFireEventListener(t), this.appAnalyticsStarted)) {
              var _n32 = this._getParamsJson(e, i, t);
              Ri().assign(_n32.params, s || {}), this._processCustomEvent(_n32), this._setLastActive();
            }
          }
        }, {
          key: "register",
          value: function register() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            this._registeredProperties = {
              dimensions: t,
              values: e
            }, this.coreStorage.setAppAnalyticsRegisteredProperties(JSON.stringify(this._registeredProperties));
          }
        }, {
          key: "registerOnce",
          value: function registerOnce(t, e) {
            this._registeredProperties || this.register(t, e);
          }
        }, {
          key: "unregister",
          value: function unregister() {
            this._registeredProperties = null, this.coreStorage.removeAppAnalyticsRegisteredProperties();
          }
        }, {
          key: "_getParamsJson",
          value: function _getParamsJson(t, e, i, s, n) {
            var r = {};
            if (i && (r.name = i), r.dimensions = t || {}, r.values = e || {}, this._registeredProperties) {
              for (var _t89 in this._registeredProperties.dimensions) r.dimensions[_t89] = this._registeredProperties.dimensions[_t89];
              for (var _t90 in this._registeredProperties.values) r.values[_t90] = this._registeredProperties.values[_t90];
            }
            var a = {
              params: r
            };
            return s && (a.params.dimensions.page && (a.params.page = a.params.dimensions.page, delete a.params.dimensions.page), a.params.dimensions.route && (a.params.route = a.params.dimensions.route, delete a.params.dimensions.route), n || delete a.params.dimensions, delete a.params.values), a;
          }
        }, {
          key: "isActive",
          value: function isActive() {
            if (this.core.isUsingLegacy()) return !1;
            if (this.appAnalyticsStarted || this.coreStorage.getAppAnalyticsStarted()) return !0;
            var t = new Date().getTime();
            return this.coreStorage.getLastActive() + this.sessionExpire > t;
          }
        }, {
          key: "_sendAppAnalytics",
          value: function _sendAppAnalytics(t, e) {
            if (!this.core.isUsingLegacy() && null !== (e = this.requestBuilder.buildParams(e, t, [this, new Ki(this.options)])) && this.options.enabled) {
              var _i141 = new Vi(t, e);
              this.isMethodPostEnabled() && _i141.setMethod(r.Method.POST), this.analyticsRequestHandler.prepareParams(_i141), this.analyticsRequestHandler.sendRequest(_i141);
            }
          }
        }, {
          key: "addOnWillSendRequestListener",
          value: function addOnWillSendRequestListener(t) {
            var e;
            null === (e = this.analyticsRequestHandler) || void 0 === e || e.onWillSendAnalyticsRequestListeners.push(t);
          }
        }, {
          key: "removeOnWillSendRequestListener",
          value: function removeOnWillSendRequestListener(t) {
            var e;
            this.analyticsRequestHandler && (this.analyticsRequestHandler.onWillSendAnalyticsRequestListeners = null === (e = this.analyticsRequestHandler) || void 0 === e ? void 0 : e.onWillSendAnalyticsRequestListeners.filter(function (e) {
              return e !== t;
            }));
          }
        }, {
          key: "_processNavigation",
          value: function _processNavigation(t) {
            t = this._parseInternalParams(t), this._checkDifferentNavigation(t) ? (this._sendAppAnalytics(Bi().Service.NAV, t), this._beat.isRunning || this._beat.start(), n.default.notice(r.AppAnalyticsTag, "[" + this.core.getFastDataSessionToken() + "] " + Bi().Service.NAV + " " + t.route), this._lastNavigation.page = t.page, this._lastNavigation.route = t.route) : n.default.warn(r.AppAnalyticsTag, "Same navigation detected and ignored for Page and Route");
          }
        }, {
          key: "_processSessionStart",
          value: function _processSessionStart(t) {
            t = this._parseInternalParams(t), this._sendAppAnalytics(Bi().Service.SESSION_START, t), this._beat.isRunning || this._beat.start(), n.default.notice(r.AppAnalyticsTag, "[" + this.core.getFastDataSessionToken() + "] " + Bi().Service.SESSION_START + " " + t.route);
          }
        }, {
          key: "_processSessionStop",
          value: function _processSessionStop(t) {
            t = this._parseInternalParams(t), this._sendAppAnalytics(Bi().Service.SESSION_STOP, t), this._beat.isRunning && this._beat.stop(), n.default.notice(r.AppAnalyticsTag, "[" + this.core.getFastDataSessionToken() + "] " + Bi().Service.SESSION_STOP + " " + t.route);
          }
        }, {
          key: "_processCustomEvent",
          value: function _processCustomEvent(t) {
            t = this._parseInternalParams(t), this._sendAppAnalytics(Bi().Service.EVENT, t), n.default.notice(r.AppAnalyticsTag, "[" + this.core.getFastDataSessionToken() + "] " + Bi().Service.EVENT + " " + t.name);
          }
        }, {
          key: "_parseInternalParams",
          value: function _parseInternalParams(t) {
            return t && (t.params || t) || {};
          }
        }, {
          key: "_sendBeat",
          value: function _sendBeat(t) {
            var e = {
              diffTime: t
            };
            this._sendAppAnalytics(Bi().Service.BEAT, e), this && this._setLastActive(), n.default.verbose(r.AppAnalyticsTag, Bi().Service.BEAT);
          }
        }, {
          key: "_checkDifferentNavigation",
          value: function _checkDifferentNavigation(t) {
            t = t || {};
            var e = this._lastNavigation && t.route === this._lastNavigation.route,
              i = this._lastNavigation && t.page === this._lastNavigation.page;
            return !e || !i;
          }
        }, {
          key: "getSessionMetrics",
          value: function getSessionMetrics() {
            return Ri().getMetricsFrom(this.options["session.metrics"]);
          }
        }, {
          key: "isPlayerLogsEnabled",
          value: function isPlayerLogsEnabled() {
            return n.default.debug(r.AppAnalyticsTag, "isPlayerLogsEnabled: " + this.options["debug.playerLogs.enabled"]), Ri().parseBoolean(this.options["debug.playerLogs.enabled"]);
          }
        }, {
          key: "isPluginLogsEnabled",
          value: function isPluginLogsEnabled() {
            return n.default.debug(r.AppAnalyticsTag, "isPluginLogsEnabled: " + this.options["debug.pluginLogs.enabled"]), Ri().parseBoolean(this.options["debug.pluginLogs.enabled"]);
          }
        }, {
          key: "isMethodPostEnabled",
          value: function isMethodPostEnabled() {
            return this.options.method && this.options.method.toUpperCase() === Xi.POST;
          }
        }, {
          key: "_sendPluginLogs",
          value: function _sendPluginLogs(t, e, i) {
            if (!this.core.isUsingLegacy() && this.isPluginLogsEnabled()) {
              try {
                if (i && i.logType && i.logAction) {
                  var _t91 = this.core.getFastDataSessionToken();
                  n.default.notice(r.AppAnalyticsTag, _t91.length ? "[" + _t91 + "] " : i.logType + ": Action " + i.logAction);
                }
              } catch (t) {}
              if (i.timemark = new Date().getTime(), null !== (i = this.requestBuilder.buildParams(i, e)) && this.options.enabled) {
                var _t92 = new Vi(e, i);
                this.isMethodPostEnabled() && _t92.setMethod(r.Method.POST), this.analyticsRequestHandler.prepareParams(_t92), this.analyticsRequestHandler.sendRequest(_t92);
              }
            }
          }
        }, {
          key: "_logBeginEvent",
          value: function _logBeginEvent(t) {
            var e = {
              logs: {
                data: t
              },
              logAction: "beginSession",
              logType: "pluginMethod"
            };
            this._sendPluginLogs(Bi().WillSendLog.WILL_SEND_LOG_INFINITY_BEGIN, Bi().Service.APP_ANALYTICS_PLUGIN_LOGS, e);
          }
        }, {
          key: "_logFireSessionStartEvent",
          value: function _logFireSessionStartEvent(t) {
            var e = {
              logs: {
                data: t
              },
              logAction: "startSession",
              logType: "pluginMethod"
            };
            this._sendPluginLogs(Bi().WillSendLog.WILL_SEND_LOG_INFINITY_START, Bi().Service.APP_ANALYTICS_PLUGIN_LOGS, e);
          }
        }, {
          key: "_logFireSessionStopEvent",
          value: function _logFireSessionStopEvent(t) {
            var e = {
              logs: {
                data: t
              },
              logAction: "stopSession",
              logType: "pluginMethod"
            };
            this._sendPluginLogs(Bi().WillSendLog.WILL_SEND_LOG_INFINITY_START, Bi().Service.APP_ANALYTICS_PLUGIN_LOGS, e);
          }
        }, {
          key: "_logFireEventListener",
          value: function _logFireEventListener(t) {
            var e = {
              logs: {
                data: t
              },
              logAction: "eventSession",
              logType: "pluginMethod"
            };
            this._sendPluginLogs(Bi().WillSendLog.WILL_SEND_LOG_INFINITY_EVENT, Bi().Service.APP_ANALYTICS_PLUGIN_LOGS, e);
          }
        }, {
          key: "_logFireNavListener",
          value: function _logFireNavListener(t) {
            var e = {
              logs: {
                data: t
              },
              logAction: "nav",
              logType: "pluginMethod"
            };
            this._sendPluginLogs(Bi().WillSendLog.WILL_SEND_LOG_INFINITY_NAV, Bi().Service.APP_ANALYTICS_PLUGIN_LOGS, e);
          }
        }, {
          key: "_logFireNewSessionListener",
          value: function _logFireNewSessionListener(t, e) {
            var i = {
              logs: {
                data: t,
                params: e
              },
              logAction: "newSession",
              logType: "pluginMethod"
            };
            this._sendPluginLogs(Bi().WillSendLog.WILL_SEND_LOG_INFINITY_NAV, Bi().Service.APP_ANALYTICS_PLUGIN_LOGS, i);
          }
        }]);
        return Qi;
      }();
      var Ji = i(2602);
      i.g.LogLevel = n.LogLevel, i.g.NpawPluginOptions = Ji.A;
      var $i = /*#__PURE__*/function () {
        function $i(t, i) {
          _classCallCheck(this, $i);
          this.core = e.default.getInstance(t, i, !0), this.cdnBalancer = new Ii(t, i), this.appAnalytics = new Qi(t), this.videoAnalytics = new (Pi().Plugin)(this.appAnalytics), this.diagnostic = M.default.getInstance(!0), this.diagnostic.start(this);
        }
        _createClass($i, [{
          key: "destroy",
          value: function destroy() {
            var _this54 = this;
            this.cdnBalancer.destroy(), this.videoAnalytics.videos.getVideoKeys().forEach(function (t) {
              var e, i;
              null === (e = _this54.videoAnalytics.getAdapter(t)) || void 0 === e || e.fireStop(), null === (i = _this54.videoAnalytics.getAdsAdapter(t)) || void 0 === i || i.fireStop();
            }), this.videoAnalytics.destroy(), this.appAnalytics.destroy(), this.diagnostic.destroy(), this.core.destroy();
          }
        }, {
          key: "setLogLevel",
          value: function setLogLevel(t) {
            n.default.setLogLevel(t);
          }
        }, {
          key: "setBalancerOptions",
          value: function setBalancerOptions(t) {
            this.cdnBalancer.setOptions(t);
          }
        }, {
          key: "setManifestResource",
          value: function setManifestResource(t) {
            this.cdnBalancer.setManifestResource(t);
          }
        }, {
          key: "addInterceptor",
          value: function addInterceptor(t, e) {
            this.cdnBalancer.addInterceptor(t, e);
          }
        }, {
          key: "getBitmovinSendHttpRequest",
          value: function getBitmovinSendHttpRequest() {
            return this.cdnBalancer.getBitmovinSendHttpRequest();
          }
        }, {
          key: "getRecommendedManifest",
          value: function getRecommendedManifest() {
            return this.cdnBalancer.getRecommendedManifest();
          }
        }, {
          key: "isBalancerEnabled",
          value: function isBalancerEnabled() {
            return this.cdnBalancer.getIsEnabled();
          }
        }, {
          key: "registerAdapter",
          value: function registerAdapter(t, e, i, s, n) {
            this.core.isUsingLegacy() || this.registerAdapterInModule(!1, t, e, i, s, n);
          }
        }, {
          key: "registerAdapterFromClass",
          value: function registerAdapterFromClass(t, e, i, s, a) {
            void 0 !== e && "function" == typeof e ? this.registerAdapterFromClassInModule(!1, t, new e(), i, s, a) : n.default.error(r.AnalyticsTag, "Adapter is not valid");
          }
        }, {
          key: "registerAdapterFromString",
          value: function registerAdapterFromString(t, e, i, s, a) {
            void 0 !== e && "string" == typeof e ? (this.videoAnalytics.registerAdapter(t, e, i, s), null == a || a()) : n.default.error(r.AnalyticsTag, "The provided adapter is not from a valid type");
          }
        }, {
          key: "registerDefaultAdapter",
          value: function registerDefaultAdapter(t, e) {
            this.core.isUsingLegacy() || this.videoAnalytics.registerAdapter(void 0, "{}", e, t);
          }
        }, {
          key: "removeAdapter",
          value: function removeAdapter(t) {
            this.core.isUsingLegacy() || (t && this.videoAnalytics.videos.existsVideo(t) && this.getAdapter(t) && this.getAdapter(t).fireStop && this.getAdapter(t).fireStop(), this.videoAnalytics.removeAdapter(t));
          }
        }, {
          key: "getAdapter",
          value: function getAdapter(t) {
            return this.videoAnalytics.getAdapter(t);
          }
        }, {
          key: "getAdsAdapter",
          value: function getAdsAdapter(t) {
            return this.videoAnalytics.getAdsAdapter(t);
          }
        }, {
          key: "registerAdsAdapter",
          value: function registerAdsAdapter(t, e, i, s, n) {
            this.core.isUsingLegacy() || this.registerAdapterInModule(!0, t, e, i, s, n);
          }
        }, {
          key: "registerAdsAdapterFromClass",
          value: function registerAdsAdapterFromClass(t, e, i, s, a) {
            void 0 !== e && "function" == typeof e ? this.registerAdapterFromClassInModule(!0, t, new e(), i, s, a) : n.default.error(r.AnalyticsTag, "Adapter is not valid");
          }
        }, {
          key: "registerAdsAdapterFromString",
          value: function registerAdsAdapterFromString(t, e, i, s, a) {
            void 0 !== e && "string" == typeof e ? (this.videoAnalytics.registerAdsAdapter(t, e, i, s), null == a || a()) : n.default.error(r.AnalyticsTag, "The provided adapter is not from a valid type");
          }
        }, {
          key: "updateAdsAdapter",
          value: function updateAdsAdapter(t, e) {
            e = null != e ? e : "default", void 0 !== t && "" != t ? this.videoAnalytics.updateAdsAdapter(t, e) : n.default.debug(r.AnalyticsTag, "Invalid ads adapter name");
          }
        }, {
          key: "registerDefaultAdsAdapter",
          value: function registerDefaultAdsAdapter(t, e) {
            this.core.isUsingLegacy() || this.videoAnalytics.registerAdsAdapter(void 0, "{}", e, t);
          }
        }, {
          key: "removeAdsAdapter",
          value: function removeAdsAdapter(t) {
            this.core.isUsingLegacy() || this.videoAnalytics.removeAdsAdapter(t);
          }
        }, {
          key: "setAnalyticsOptions",
          value: function setAnalyticsOptions(t) {
            this.core.isUsingLegacy() || (this.videoAnalytics.setOptions(t), this.appAnalytics.setOptions(this.videoAnalytics.options), this.core.setOptions(this.videoAnalytics.options), this.diagnostic.setOptions(this.videoAnalytics.options));
          }
        }, {
          key: "setVideoOptions",
          value: function setVideoOptions(t, e) {
            t ? this.videoAnalytics.setVideoOptions(t, null != e ? e : "default") : n.default.debug(r.AnalyticsTag, "Provided options object is not valid");
          }
        }, {
          key: "fireOfflineEvents",
          value: function fireOfflineEvents() {
            this.core.isUsingLegacy() || (this.videoAnalytics.videos.getVideoKeys().length > 0 ? n.default.notice(r.AnalyticsTag, "Unable to send offline events because there's at least one adapter registered") : this.core.sendOfflineEvents());
          }
        }, {
          key: "registerAdapterFromClassInModule",
          value: function registerAdapterFromClassInModule(t, e, i, s, n, r) {
            t ? this.videoAnalytics.registerAdsAdapter(e, i, s, n) : this.videoAnalytics.registerAdapter(e, i, s, n), null == r || r();
          }
        }, {
          key: "registerAdapterInModule",
          value: function registerAdapterInModule(t, e, i, s, r, a) {
            var _this55 = this;
            if (0 === i.length && n.default.error("Adapter URL can't be empty!"), "undefined" != typeof fetch) fetch(i).then(function (t) {
              return t.json();
            }).then(function (i) {
              var n = JSON.stringify(i);
              t ? _this55.videoAnalytics.registerAdsAdapter(e, n, s, r) : _this55.videoAnalytics.registerAdapter(e, n, s, r), null == a || a();
            });else {
              var _n33 = new XMLHttpRequest();
              _n33.addEventListener("readystatechange", function () {
                if (4 === _n33.readyState && _n33.status >= 200 && _n33.status < 400) {
                  var _i142 = _n33.response;
                  t ? _this55.videoAnalytics.registerAdsAdapter(e, _i142, s, r) : _this55.videoAnalytics.registerAdapter(e, _i142, s, r), null == a || a();
                }
              }), _n33.open("GET", i), _n33.send();
            }
          }
        }]);
        return $i;
      }();
    }(), s.default;
  }();
});